import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"notifyOnNetworkStatusChange":true} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  NotificationTypeInput: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddPhoneToMessagingServiceInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type AddPhoneToMessagingServiceResponse = {
  __typename?: 'AddPhoneToMessagingServiceResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  _id: Scalars['MongoID']['output'];
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<AddressLocation>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: EnumAddressType;
};

export type AddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: EnumAddressType;
};

export type AddressInputForProfile = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInputForUser = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AddressLocation = {
  __typename?: 'AddressLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<EnumAddressLocationType>;
};

export type AddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

/** List of items with pagination. */
export type AddressPagination = {
  __typename?: 'AddressPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Address>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AdminUserAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserRelationshipInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumUserType;
  vendorId: Scalars['MongoID']['input'];
};

export type Animal = {
  __typename?: 'Animal';
  _id: Scalars['MongoID']['output'];
  allowedSectionSizes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableToBuyers?: Maybe<Scalars['Boolean']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  claimMode?: Maybe<EnumAnimalClaimMode>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: Maybe<Scalars['Date']['output']>;
  cutDateChangedAt?: Maybe<Scalars['Date']['output']>;
  dateFirstEnteredHangingWeight?: Maybe<Scalars['Date']['output']>;
  dateUpdatedHangingWeight?: Maybe<Scalars['Date']['output']>;
  descriptorChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grade?: Maybe<Scalars['String']['output']>;
  hangTimeDays?: Maybe<Scalars['Float']['output']>;
  hangingWeight?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideA?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideB?: Maybe<Scalars['Float']['output']>;
  inspectionLevel?: Maybe<EnumAnimalInspectionLevel>;
  invoice?: Maybe<ProcessorSchedulingAnimalHeadsInvoice>;
  invoice_line_item?: Maybe<Scalars['MongoID']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** True when no capacity remains (remainingCapacity ≤ 0). Counts occupied cutsheet buyer slots for ON-JOB animals, consistent with `remainingCapacity`. */
  isFull?: Maybe<Scalars['Boolean']['output']>;
  isHangingWeightPerSide?: Maybe<Scalars['Boolean']['output']>;
  isKillAndChill?: Maybe<Scalars['Boolean']['output']>;
  isOverThirtyMonths?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Scalars['MongoID']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: Maybe<Scalars['Date']['output']>;
  listedBy?: Maybe<EnumAnimalListedBy>;
  listingDeposits?: Maybe<AnimalListingDeposits>;
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  /** Which side owns this listing (and the section-deposit money): 'producer' | 'processor'. CHEAP display path — trusts the producer's stored Stripe onboarding status; makes NO live Stripe call, so it is safe to resolve on every row of a paginated list. The real publish write (`updateVendorFloatingAnimal`/`updateOwnedFloatingAnimal`) always live-verifies before stamping `listedBy`; this field may lag that live check by whatever the stored snapshot is behind. */
  listingRecipient?: Maybe<Scalars['String']['output']>;
  listingTotalPrice?: Maybe<Scalars['Float']['output']>;
  listingVeto?: Maybe<AnimalListingVeto>;
  liveWeight?: Maybe<Scalars['Float']['output']>;
  liveWeightHigh?: Maybe<Scalars['Float']['output']>;
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  producer: Scalars['MongoID']['output'];
  producerDescription?: Maybe<Scalars['String']['output']>;
  producerIdentifier?: Maybe<Scalars['String']['output']>;
  producerRef?: Maybe<User>;
  publicId: Scalars['String']['output'];
  questionnaire?: Maybe<Scalars['MongoID']['output']>;
  /** Remaining split capacity in quarter-units (0–4). Claimed/confirmed splits always consume capacity; for an ON-JOB animal, occupied cutsheet buyer slots (status:"open" with a buyer) also consume capacity — mirroring every other on-job capacity read (countOccupiedSlots:true). Floating animals do not count occupied slots. */
  remainingCapacity?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  sizeTier?: Maybe<EnumAnimalSizeTier>;
  species: Scalars['String']['output'];
  /** Whole-animal layout ('whole' | 'half' | 'quarters' | 'half_and_two_quarters'), derived from the animal's splits. */
  splitType?: Maybe<Scalars['String']['output']>;
  splits?: Maybe<Array<Maybe<Split>>>;
  status?: Maybe<Scalars['String']['output']>;
  statusChanges?: Maybe<Array<Maybe<AnimalStatusChanges>>>;
  thirdPartyFee?: Maybe<Scalars['Float']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  trackingSort?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Scalars['MongoID']['output']>;
  vendorRef?: Maybe<Vendor>;
};

export type AnimalConfigurationInput = {
  averageHangingWeight: Scalars['Float']['input'];
  expectedThroughput: Scalars['Float']['input'];
  maxCapacity: Scalars['Float']['input'];
  processingCost: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
  species: Scalars['String']['input'];
};

export type AnimalForceUpdateStatusResponse = {
  __typename?: 'AnimalForceUpdateStatusResponse';
  newStatus?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type AnimalHeadInput = {
  cutsheetInformation?: InputMaybe<Array<InputMaybe<CutsheetInformationInput>>>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type AnimalHeadUpdatesInput = {
  _delete?: InputMaybe<Scalars['Boolean']['input']>;
  _id?: InputMaybe<Scalars['String']['input']>;
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type AnimalListingDeposits = {
  __typename?: 'AnimalListingDeposits';
  half?: Maybe<Scalars['Float']['output']>;
  quarter?: Maybe<Scalars['Float']['output']>;
  whole?: Maybe<Scalars['Float']['output']>;
};

export type AnimalListingVeto = {
  __typename?: 'AnimalListingVeto';
  jobId?: Maybe<Scalars['MongoID']['output']>;
  vetoedAt?: Maybe<Scalars['Date']['output']>;
  vetoedBy?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type AnimalPagination = {
  __typename?: 'AnimalPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Animal>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AnimalSettlementReport = {
  __typename?: 'AnimalSettlementReport';
  animalId: Scalars['MongoID']['output'];
  errorCount: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  results: Array<AnimalSettlementSplitResult>;
  settledCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type AnimalSettlementSplitResult = {
  __typename?: 'AnimalSettlementSplitResult';
  invoiceId?: Maybe<Scalars['MongoID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  skipReason?: Maybe<Scalars['String']['output']>;
  splitId: Scalars['MongoID']['output'];
  splitPart?: Maybe<Scalars['String']['output']>;
};

export type AnimalStatusChange = {
  __typename?: 'AnimalStatusChange';
  changedByName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  newStatus?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
};

export type AnimalStatusChanges = {
  __typename?: 'AnimalStatusChanges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  changedBy?: Maybe<Scalars['MongoID']['output']>;
  changedByName?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  newStatus: Scalars['String']['output'];
  previousStatus?: Maybe<Scalars['String']['output']>;
};

export type AnimalStatusUpdatePayload = {
  __typename?: 'AnimalStatusUpdatePayload';
  jobId: Scalars['MongoID']['output'];
  jobStatus?: Maybe<Scalars['String']['output']>;
  skippedCount: Scalars['Int']['output'];
  skippedLabels: Array<Scalars['String']['output']>;
  updatedCount: Scalars['Int']['output'];
};

export type AuditLogActorResult = {
  __typename?: 'AuditLogActorResult';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
};

export type AuditLogChangeResult = {
  __typename?: 'AuditLogChangeResult';
  from?: Maybe<Scalars['JSON']['output']>;
  path: Scalars['String']['output'];
  to?: Maybe<Scalars['JSON']['output']>;
};

export type AuditLogResult = {
  __typename?: 'AuditLogResult';
  _id: Scalars['MongoID']['output'];
  actor?: Maybe<AuditLogActorResult>;
  actorId?: Maybe<Scalars['MongoID']['output']>;
  changes?: Maybe<Array<Maybe<AuditLogChangeResult>>>;
  createdAt: Scalars['Date']['output'];
  documentId: Scalars['MongoID']['output'];
  documentType: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AuditLogTargetInput = {
  documentId: Scalars['MongoID']['input'];
  documentType: Scalars['String']['input'];
};

export type AuditLogsResponse = {
  __typename?: 'AuditLogsResponse';
  logs?: Maybe<Array<Maybe<AuditLogResult>>>;
  total: Scalars['Int']['output'];
};

export type AuthCheckUserPayload = {
  __typename?: 'AuthCheckUserPayload';
  authMethod?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  otpSent?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  requiresPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  resetCodeSent?: Maybe<Scalars['Boolean']['output']>;
  resetDestination?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
};

export type AuthConfirmForgotPasswordPayload = {
  __typename?: 'AuthConfirmForgotPasswordPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuthForgotPasswordPayload = {
  __typename?: 'AuthForgotPasswordPayload';
  destination?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AuthLoginOAuthPayload = {
  __typename?: 'AuthLoginOAuthPayload';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthLoginPasswordPayload = {
  __typename?: 'AuthLoginPasswordPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type AuthRefreshTokenPayload = {
  __typename?: 'AuthRefreshTokenPayload';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  idToken: Scalars['String']['output'];
};

export type AuthRegisterAndSignInPayload = {
  __typename?: 'AuthRegisterAndSignInPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type AuthRegisterPayload = {
  __typename?: 'AuthRegisterPayload';
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type AuthSendOtpPayload = {
  __typename?: 'AuthSendOTPPayload';
  message: Scalars['String']['output'];
  session?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuthVerifyOtpPayload = {
  __typename?: 'AuthVerifyOTPPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  requiresProfileCompletion?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableColumn = {
  __typename?: 'AvailableColumn';
  aliases: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  validationRules?: Maybe<Scalars['String']['output']>;
};

export type AvailablePhoneNumber = {
  __typename?: 'AvailablePhoneNumber';
  capabilities?: Maybe<AvailablePhoneNumberCapabilities>;
  friendlyName: Scalars['String']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type AvailablePhoneNumberCapabilities = {
  __typename?: 'AvailablePhoneNumberCapabilities';
  mms: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
  voice: Scalars['Boolean']['output'];
};

export type BlockedByInput = {
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};

export type BookingDepositPaymentIntentResponse = {
  __typename?: 'BookingDepositPaymentIntentResponse';
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  connectedAccountId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type BookingFollowUp = {
  __typename?: 'BookingFollowUp';
  date: Scalars['String']['output'];
  dayCapacity: Scalars['Int']['output'];
  daySpotsRemaining: Scalars['Int']['output'];
  daySpotsUsed: Scalars['Int']['output'];
  nextOpenDate?: Maybe<Scalars['String']['output']>;
};

export type BuildCutsheetCatalogPayload = {
  __typename?: 'BuildCutsheetCatalogPayload';
  animalType: Scalars['String']['output'];
  capabilityId: Scalars['MongoID']['output'];
  catalogName: Scalars['String']['output'];
  cutsCount: Scalars['Int']['output'];
  extrasCount: Scalars['Int']['output'];
  primalsCount: Scalars['Int']['output'];
  specificationsCount: Scalars['Int']['output'];
  trimCount: Scalars['Int']['output'];
};

export type BulkCutsheetRequestInput = {
  cutsheetRequestId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};

export type BuyerActiveHold = {
  __typename?: 'BuyerActiveHold';
  _id: Scalars['MongoID']['output'];
  animal?: Maybe<BuyerActiveHoldAnimal>;
  city?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  holdExpiresAt?: Maybe<Scalars['Date']['output']>;
  placementHoldAt?: Maybe<Scalars['Date']['output']>;
  processorName?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  splitPart?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type BuyerActiveHoldAnimal = {
  __typename?: 'BuyerActiveHoldAnimal';
  _id: Scalars['MongoID']['output'];
  cutDate?: Maybe<Scalars['String']['output']>;
  killDate?: Maybe<Scalars['String']['output']>;
  reserveByDate?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type BuyerAnimalDetail = {
  __typename?: 'BuyerAnimalDetail';
  _id: Scalars['MongoID']['output'];
  actualHangingWeight?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  costBreakdown?: Maybe<Array<Maybe<BuyerAnimalDetailCostBreakdown>>>;
  cutDate?: Maybe<Scalars['String']['output']>;
  descriptorChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  estimatedPickupDate?: Maybe<Scalars['String']['output']>;
  finalAnimalPrice?: Maybe<Scalars['Float']['output']>;
  hangTimeDays?: Maybe<Scalars['Int']['output']>;
  hasPendingClaim?: Maybe<Scalars['Boolean']['output']>;
  iOwnThis?: Maybe<Scalars['Boolean']['output']>;
  isFull?: Maybe<Scalars['Boolean']['output']>;
  isMarketplaceListing?: Maybe<Scalars['Boolean']['output']>;
  isPendingAcceptance?: Maybe<Scalars['Boolean']['output']>;
  killDate?: Maybe<Scalars['String']['output']>;
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  listingUnavailable?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<BuyerAnimalDetailLocation>;
  myAssignedSplitId?: Maybe<Scalars['MongoID']['output']>;
  myClaimedSplitDepositStatus?: Maybe<Scalars['String']['output']>;
  myClaimedSplitId?: Maybe<Scalars['MongoID']['output']>;
  myClaimedSplitPart?: Maybe<Scalars['String']['output']>;
  myClaimedSplitStatus?: Maybe<Scalars['String']['output']>;
  myPickupLocationId?: Maybe<Scalars['MongoID']['output']>;
  pickupLocations?: Maybe<Array<Maybe<BuyerAnimalDetailPickupLocation>>>;
  processorName?: Maybe<Scalars['String']['output']>;
  producerDescription?: Maybe<Scalars['String']['output']>;
  producerId?: Maybe<Scalars['MongoID']['output']>;
  producerLogoUrl?: Maybe<Scalars['String']['output']>;
  producerName?: Maybe<Scalars['String']['output']>;
  producerSlug?: Maybe<Scalars['String']['output']>;
  remainingCapacity?: Maybe<Scalars['Int']['output']>;
  reserveByDate?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<BuyerAnimalDetailSection>>>;
  sellable?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  thirdPartyFee?: Maybe<Scalars['Float']['output']>;
  totalCapacity?: Maybe<Scalars['Int']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type BuyerAnimalDetailCostBreakdown = {
  __typename?: 'BuyerAnimalDetailCostBreakdown';
  deposit?: Maybe<Scalars['Float']['output']>;
  dressingYieldHigh?: Maybe<Scalars['Float']['output']>;
  dressingYieldLow?: Maybe<Scalars['Float']['output']>;
  hangingWeightHigh?: Maybe<Scalars['Float']['output']>;
  hangingWeightLow?: Maybe<Scalars['Float']['output']>;
  meatHigh?: Maybe<Scalars['Float']['output']>;
  meatLow?: Maybe<Scalars['Float']['output']>;
  processingHigh?: Maybe<Scalars['Float']['output']>;
  processingLow?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sizeTier?: Maybe<Scalars['String']['output']>;
  takeHomeMeatHigh?: Maybe<Scalars['Float']['output']>;
  takeHomeMeatLow?: Maybe<Scalars['Float']['output']>;
  weightRingHigh?: Maybe<Scalars['Float']['output']>;
  weightRingLow?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAnimalDetailLocation = {
  __typename?: 'BuyerAnimalDetailLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type BuyerAnimalDetailPickupLocation = {
  __typename?: 'BuyerAnimalDetailPickupLocation';
  _id: Scalars['MongoID']['output'];
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<BuyerAnimalDetailLocation>;
  name: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type BuyerAnimalDetailSection = {
  __typename?: 'BuyerAnimalDetailSection';
  available: Scalars['Boolean']['output'];
  deposit?: Maybe<Scalars['Float']['output']>;
  estimatedTotalHigh?: Maybe<Scalars['Float']['output']>;
  estimatedTotalLow?: Maybe<Scalars['Float']['output']>;
  size: Scalars['String']['output'];
};

export type BuyerAvailableAnimal = {
  __typename?: 'BuyerAvailableAnimal';
  _id: Scalars['MongoID']['output'];
  allowedSectionSizes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  claimMode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  cutDate?: Maybe<Scalars['String']['output']>;
  datesEstimated?: Maybe<Scalars['Boolean']['output']>;
  descriptorChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  hasPendingClaim?: Maybe<Scalars['Boolean']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  isFull?: Maybe<Scalars['Boolean']['output']>;
  isInHouse?: Maybe<Scalars['Boolean']['output']>;
  isPendingAcceptance?: Maybe<Scalars['Boolean']['output']>;
  killDate?: Maybe<Scalars['String']['output']>;
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  myClaimedSplitDepositStatus?: Maybe<Scalars['String']['output']>;
  myClaimedSplitId?: Maybe<Scalars['MongoID']['output']>;
  myClaimedSplitPart?: Maybe<Scalars['String']['output']>;
  myClaimedSplitStatus?: Maybe<Scalars['String']['output']>;
  pickupLat?: Maybe<Scalars['Float']['output']>;
  pickupLng?: Maybe<Scalars['Float']['output']>;
  processorBoxUrl?: Maybe<Scalars['String']['output']>;
  processorName?: Maybe<Scalars['String']['output']>;
  producerBannerUrl?: Maybe<Scalars['String']['output']>;
  producerBio?: Maybe<Scalars['String']['output']>;
  producerBoxUrl?: Maybe<Scalars['String']['output']>;
  producerId?: Maybe<Scalars['MongoID']['output']>;
  producerLat?: Maybe<Scalars['Float']['output']>;
  producerLng?: Maybe<Scalars['Float']['output']>;
  producerLogoUrl?: Maybe<Scalars['String']['output']>;
  producerName?: Maybe<Scalars['String']['output']>;
  producerSlug?: Maybe<Scalars['String']['output']>;
  remainingCapacity?: Maybe<Scalars['Int']['output']>;
  reserveByDate?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<BuyerAvailableAnimalSection>>>;
  slug?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  splitType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type BuyerAvailableAnimalSection = {
  __typename?: 'BuyerAvailableAnimalSection';
  available?: Maybe<Scalars['Boolean']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  estimatedTotalHigh?: Maybe<Scalars['Float']['output']>;
  estimatedTotalLow?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type BuyerBalanceCheckoutResponse = {
  __typename?: 'BuyerBalanceCheckoutResponse';
  balanceDue: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  processorName?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
};

export type BuyerCombinedSettlementSavedPaymentMethod = {
  __typename?: 'BuyerCombinedSettlementSavedPaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type BuyerCreateCombinedSettlementIntentResponse = {
  __typename?: 'BuyerCreateCombinedSettlementIntentResponse';
  amountDue: Scalars['Float']['output'];
  chargeableParties?: Maybe<Array<Scalars['String']['output']>>;
  clientSecret: Scalars['String']['output'];
  savedPaymentMethods?: Maybe<Array<Maybe<BuyerCombinedSettlementSavedPaymentMethod>>>;
};

export type BuyerDepositCheckoutResponse = {
  __typename?: 'BuyerDepositCheckoutResponse';
  clientSecret: Scalars['String']['output'];
  depositAmount: Scalars['Float']['output'];
  expiresAt: Scalars['Float']['output'];
  listingFee: Scalars['Float']['output'];
  processorName?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  species?: Maybe<Scalars['String']['output']>;
  splitPart: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type BuyerDepositIntentResponse = {
  __typename?: 'BuyerDepositIntentResponse';
  clientSecret: Scalars['String']['output'];
  depositAmount: Scalars['Float']['output'];
  expiresAt: Scalars['Float']['output'];
  listingFee: Scalars['Float']['output'];
  processorName?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  splitPart: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type BuyerOrder = {
  __typename?: 'BuyerOrder';
  _id: Scalars['MongoID']['output'];
  adjustments?: Maybe<Array<Maybe<BuyerOrderAdjustment>>>;
  animalId?: Maybe<Scalars['MongoID']['output']>;
  balanceDue?: Maybe<Scalars['Float']['output']>;
  balancePaidAt?: Maybe<Scalars['Date']['output']>;
  combinedSettlement?: Maybe<BuyerOrderCombinedSettlement>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositPaidAt?: Maybe<Scalars['Date']['output']>;
  depositRecipientParty?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<BuyerOrderEvent>>>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  invoicePaidAt?: Maybe<Scalars['Date']['output']>;
  invoicedAt?: Maybe<Scalars['Date']['output']>;
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  isProducerListed?: Maybe<Scalars['Boolean']['output']>;
  isRefunded?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['MongoID']['output']>;
  listingFee?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  processingStatus?: Maybe<Scalars['String']['output']>;
  processorName?: Maybe<Scalars['String']['output']>;
  producerLogoUrl?: Maybe<Scalars['String']['output']>;
  producerName?: Maybe<Scalars['String']['output']>;
  producerSlug?: Maybe<Scalars['String']['output']>;
  refundedAmount?: Maybe<Scalars['Float']['output']>;
  refundedAt?: Maybe<Scalars['Date']['output']>;
  saleBaseAmount?: Maybe<Scalars['Float']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  splitId?: Maybe<Scalars['MongoID']['output']>;
  splitPart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type BuyerOrderAdjustment = {
  __typename?: 'BuyerOrderAdjustment';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

export type BuyerOrderCombinedSettlement = {
  __typename?: 'BuyerOrderCombinedSettlement';
  active: Scalars['Boolean']['output'];
  amountDue: Scalars['Float']['output'];
  blockedReason?: Maybe<Scalars['String']['output']>;
  paid: Scalars['Boolean']['output'];
  processorAmount?: Maybe<Scalars['Float']['output']>;
  processorStatus?: Maybe<Scalars['String']['output']>;
  producerAmount?: Maybe<Scalars['Float']['output']>;
  producerStatus?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
};

export type BuyerOrderEvent = {
  __typename?: 'BuyerOrderEvent';
  amount?: Maybe<Scalars['Float']['output']>;
  at?: Maybe<Scalars['Date']['output']>;
  byRole?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BuyerPayInvoiceResponse = {
  __typename?: 'BuyerPayInvoiceResponse';
  amountDue?: Maybe<Scalars['Float']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  connectedAccountId: Scalars['String']['output'];
  savedPaymentMethods?: Maybe<Array<Maybe<BuyerSavedPaymentMethod>>>;
  status: Scalars['String']['output'];
};

export type BuyerPayOrderBalanceResponse = {
  __typename?: 'BuyerPayOrderBalanceResponse';
  balanceDue: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  processorName?: Maybe<Scalars['String']['output']>;
  savedPaymentMethods?: Maybe<Array<Maybe<BuyerSavedPaymentMethod>>>;
};

export type BuyerSavedPaymentMethod = {
  __typename?: 'BuyerSavedPaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type BuyerSplitForCutsheet = {
  __typename?: 'BuyerSplitForCutsheet';
  _id: Scalars['MongoID']['output'];
  animalId?: Maybe<Scalars['MongoID']['output']>;
  animalSpecies?: Maybe<Scalars['String']['output']>;
  cutsheetMode?: Maybe<Scalars['String']['output']>;
  cutsheetRequired?: Maybe<Scalars['Boolean']['output']>;
  depositStatus?: Maybe<Scalars['String']['output']>;
  hasCutsheet?: Maybe<Scalars['Boolean']['output']>;
  holdExpiresAt?: Maybe<Scalars['Date']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['MongoID']['output']>;
  placementHoldAt?: Maybe<Scalars['Date']['output']>;
  producerId?: Maybe<Scalars['MongoID']['output']>;
  questionnaireId?: Maybe<Scalars['MongoID']['output']>;
  splitPart?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type BuyerSyncBalanceCheckoutResponse = {
  __typename?: 'BuyerSyncBalanceCheckoutResponse';
  orderStatus?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type BuyerSyncCombinedSettlementResponse = {
  __typename?: 'BuyerSyncCombinedSettlementResponse';
  status: Scalars['String']['output'];
};

export type BuyerSyncDepositCheckoutResponse = {
  __typename?: 'BuyerSyncDepositCheckoutResponse';
  depositStatus?: Maybe<Scalars['String']['output']>;
  splitStatus?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type BuyerSyncDepositIntentResponse = {
  __typename?: 'BuyerSyncDepositIntentResponse';
  depositStatus?: Maybe<Scalars['String']['output']>;
  splitStatus?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type BuyerSyncOrderBalanceResponse = {
  __typename?: 'BuyerSyncOrderBalanceResponse';
  orderStatus?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type BuyerTransaction = {
  __typename?: 'BuyerTransaction';
  _id: Scalars['MongoID']['output'];
  animal?: Maybe<BuyerTransactionAnimal>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositPaidAt?: Maybe<Scalars['Date']['output']>;
  depositPaidOnline?: Maybe<Scalars['Boolean']['output']>;
  depositStatus?: Maybe<Scalars['String']['output']>;
  holdExpiresAt?: Maybe<Scalars['Date']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['MongoID']['output']>;
  jobPublicId?: Maybe<Scalars['String']['output']>;
  listingFee?: Maybe<Scalars['Float']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  purchasePaidAt?: Maybe<Scalars['Date']['output']>;
  purchasePaidOnline?: Maybe<Scalars['Boolean']['output']>;
  refund?: Maybe<BuyerTransactionRefund>;
  releasedWithoutRefundAt?: Maybe<Scalars['Date']['output']>;
  splitPart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<BuyerTransactionVendor>;
};

export type BuyerTransactionAnimal = {
  __typename?: 'BuyerTransactionAnimal';
  _id: Scalars['MongoID']['output'];
  cutDate?: Maybe<Scalars['String']['output']>;
  killDate?: Maybe<Scalars['String']['output']>;
  producerIdentifier?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
};

export type BuyerTransactionRefund = {
  __typename?: 'BuyerTransactionRefund';
  amount?: Maybe<Scalars['Float']['output']>;
  at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BuyerTransactionVendor = {
  __typename?: 'BuyerTransactionVendor';
  _id: Scalars['MongoID']['output'];
  address?: Maybe<BuyerTransactionVendorAddress>;
  pickup_days?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  shop_name?: Maybe<Scalars['String']['output']>;
};

export type BuyerTransactionVendorAddress = {
  __typename?: 'BuyerTransactionVendorAddress';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type CsvImportCancelJobPayload = {
  __typename?: 'CSVImportCancelJobPayload';
  cancelledAt: Scalars['Date']['output'];
  cancelledAtStage: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CsvImportDeleteRecordPayload = {
  __typename?: 'CSVImportDeleteRecordPayload';
  deletedRows: Array<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
};

export type CsvImportExecutePayload = {
  __typename?: 'CSVImportExecutePayload';
  jobId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CsvImportFailure = {
  __typename?: 'CSVImportFailure';
  error: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type CsvImportForceCancelPayload = {
  __typename?: 'CSVImportForceCancelPayload';
  cancelledAt: Scalars['Date']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type CsvImportJob = {
  __typename?: 'CSVImportJob';
  _id: Scalars['MongoID']['output'];
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledAtStage?: Maybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedRows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  failureCount: Scalars['Float']['output'];
  failures?: Maybe<Array<Maybe<CsvImportJobFailures>>>;
  failuresFilePath?: Maybe<Scalars['String']['output']>;
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  parsedData?: Maybe<Scalars['JSON']['output']>;
  processedCount: Scalars['Float']['output'];
  producerId?: Maybe<Scalars['MongoID']['output']>;
  rawFilePath?: Maybe<Scalars['String']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: EnumCsvImportJobStatus;
  successCount: Scalars['Float']['output'];
  successFilePath?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['MongoID']['output']>;
  totalRows: Scalars['Float']['output'];
  type: EnumCsvImportJobType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uploadedBy: Scalars['MongoID']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Float']['output'];
  validationErrors?: Maybe<Array<Maybe<CsvImportJobValidationErrors>>>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type CsvImportJobFailures = {
  __typename?: 'CSVImportJobFailures';
  data: Scalars['JSON']['output'];
  error: Scalars['String']['output'];
  row: Scalars['Float']['output'];
};

export type CsvImportJobFailuresInput = {
  data: Scalars['JSON']['input'];
  error: Scalars['String']['input'];
  row: Scalars['Float']['input'];
};

export type CsvImportJobItem = {
  __typename?: 'CSVImportJobItem';
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  failureCount?: Maybe<Scalars['Int']['output']>;
  invalidRows?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  processedCount?: Maybe<Scalars['Int']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  successCount?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  validRows?: Maybe<Scalars['Int']['output']>;
};

/** List of items with pagination. */
export type CsvImportJobPagination = {
  __typename?: 'CSVImportJobPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CsvImportJob>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CsvImportJobStatus = {
  __typename?: 'CSVImportJobStatus';
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedRows: Array<Scalars['Int']['output']>;
  failureCount: Scalars['Int']['output'];
  failures: Array<CsvImportFailure>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportJobValidationErrors = {
  __typename?: 'CSVImportJobValidationErrors';
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  row: Scalars['Float']['output'];
  warningMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row: Scalars['Float']['input'];
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CsvImportJobsPayload = {
  __typename?: 'CSVImportJobsPayload';
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<CsvImportJobItem>;
  total: Scalars['Int']['output'];
};

export type CsvImportRevalidatePayload = {
  __typename?: 'CSVImportRevalidatePayload';
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportSaveColumnMappingPayload = {
  __typename?: 'CSVImportSaveColumnMappingPayload';
  columns: Array<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  parsedData?: Maybe<Scalars['JSON']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportUpdateRowsPayload = {
  __typename?: 'CSVImportUpdateRowsPayload';
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportUploadPayload = {
  __typename?: 'CSVImportUploadPayload';
  availableColumns: Array<AvailableColumn>;
  detectedColumns: Array<Scalars['String']['output']>;
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  suggestedMapping?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvValidationError = {
  __typename?: 'CSVValidationError';
  errorMessages: Array<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  warningMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  date: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['MongoID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CalendarEventPagination = {
  __typename?: 'CalendarEventPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CalendarEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CalendarEventType = {
  __typename?: 'CalendarEventType';
  _id: Scalars['MongoID']['output'];
  color: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CalendarEventTypePagination = {
  __typename?: 'CalendarEventTypePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CalendarEventType>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CalendarTooltipDocumentSettingsInput = {
  fields?: InputMaybe<Array<InputMaybe<DocumentFieldEntryInput>>>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

/** List of items with pagination. */
export type CancellationReasonPagination = {
  __typename?: 'CancellationReasonPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CancellationReason>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CapacityCalculationAllSpeciesResult = {
  __typename?: 'CapacityCalculationAllSpeciesResult';
  bySpecies: Scalars['JSON']['output'];
  hasAvailableSpots: Scalars['Boolean']['output'];
  spotGroups: Scalars['JSON']['output'];
  totalSpots: Scalars['Int']['output'];
};

export type CapacityCalculationResult = {
  __typename?: 'CapacityCalculationResult';
  hasAvailableSpots: Scalars['Boolean']['output'];
  spotGroups: Scalars['JSON']['output'];
  totalSpots: Scalars['Int']['output'];
};

export type CarcassTagPreviewResponse = {
  __typename?: 'CarcassTagPreviewResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type CarcassTagsDocumentSettingsInput = {
  fields?: InputMaybe<Array<InputMaybe<DocumentFieldEntryInput>>>;
  title: EnumProcessorSettingsDocumentSettingsCarcassTagTitle;
};

export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  _id: Scalars['MongoID']['output'];
  animal?: Maybe<Scalars['MongoID']['output']>;
  animalSpecies?: Maybe<Scalars['String']['output']>;
  chatRoom?: Maybe<ChatRoom>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isNotification?: Maybe<Scalars['Boolean']['output']>;
  notificationPrompt?: Maybe<NotificationPromptState>;
  readAt?: Maybe<Scalars['Date']['output']>;
  sender?: Maybe<User>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ChatMessagePagination = {
  __typename?: 'ChatMessagePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChatMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  customer?: Maybe<Scalars['MongoID']['output']>;
  lastMessage?: Maybe<ChatMessage>;
  /** Whether the current user explicitly marked this room unread so they could come back to it. */
  markedUnread: Scalars['Boolean']['output'];
  messages: Array<ChatMessage>;
  participants: Array<User>;
  producer?: Maybe<User>;
  twilioConversationSid?: Maybe<Scalars['String']['output']>;
  /** Count of non-notification, unread messages in this room from the opposite side of the conversation. */
  unreadMessagesCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};


export type ChatRoomMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatRoomParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};

/** List of items with pagination. */
export type ChatRoomPagination = {
  __typename?: 'ChatRoomPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChatRoom>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChatRoomUnreadMarksInput = {
  markedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export enum ComparisonType {
  /** Compare to the same period in the previous cycle */
  PreviousPeriod = 'PREVIOUS_PERIOD',
  /** Compare to the same period in the previous year */
  PreviousYear = 'PREVIOUS_YEAR'
}

export type ComplexAnimalCapacity = SpeciesComplexAnimalCapacitySchema | SpeciesInspectionComplexAnimalCapacitySchema | WeightedAnimalComplexAnimalCapacitySchema;

export type CreateForSchedulingJobContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateForSchedulingJobLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
};

export type CreateForSchedulingJobSplitInput = {
  animalHeadId: Scalars['MongoID']['input'];
  splitId: Scalars['MongoID']['input'];
};

export type CreateInvoiceForSchedulingJobInput = {
  animalHeadIds: Array<Scalars['MongoID']['input']>;
  contact?: InputMaybe<CreateForSchedulingJobContactInput>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  isPayAtPickup: Scalars['Boolean']['input'];
  lineItems?: InputMaybe<Array<InputMaybe<CreateForSchedulingJobLineItemInput>>>;
  processorSchedulingId: Scalars['MongoID']['input'];
  sendPaymentLink: Scalars['Boolean']['input'];
  splits?: InputMaybe<Array<InputMaybe<CreateForSchedulingJobSplitInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyAddressInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: EnumAddressType;
};

export type CreateManyAddressPayload = {
  __typename?: 'CreateManyAddressPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Address>>;
};

export type CreateManyCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount: Scalars['Float']['input'];
  failures?: InputMaybe<Array<InputMaybe<CsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows: Scalars['Float']['input'];
  jobId: Scalars['String']['input'];
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount: Scalars['Float']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status: EnumCsvImportJobStatus;
  successCount: Scalars['Float']['input'];
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows: Scalars['Float']['input'];
  type: EnumCsvImportJobType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy: Scalars['MongoID']['input'];
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows: Scalars['Float']['input'];
  validationErrors?: InputMaybe<Array<InputMaybe<CsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyCsvImportJobPayload = {
  __typename?: 'CreateManyCSVImportJobPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CsvImportJob>>;
};

export type CreateManyCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type CreateManyCancellationReasonPayload = {
  __typename?: 'CreateManyCancellationReasonPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CancellationReason>>;
};

export type CreateManyCustomFieldDefinitionInput = {
  captureAt: EnumCustomFieldDefinitionCaptureAt;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType: EnumCustomFieldDefinitionFieldType;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  modelType: EnumCustomFieldDefinitionModelType;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCustomFieldDefinitionPayload = {
  __typename?: 'CreateManyCustomFieldDefinitionPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CustomFieldDefinition>>;
};

export type CreateManyCustomFieldValueInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition: Scalars['MongoID']['input'];
  recordId: Scalars['String']['input'];
  recordType: EnumCustomFieldValueRecordType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyCustomFieldValuePayload = {
  __typename?: 'CreateManyCustomFieldValuePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CustomFieldValue>>;
};

export type CreateManyCutsheetAssignmentRuleSetInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetAssignmentRuleSetPayload = {
  __typename?: 'CreateManyCutsheetAssignmentRuleSetPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetAssignmentRuleSet>>;
};

export type CreateManyCutsheetCapabilityGroupInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilityGroupPayload = {
  __typename?: 'CreateManyCutsheetCapabilityGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapabilityGroup>>;
};

export type CreateManyCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name: Scalars['String']['input'];
  printSettings?: InputMaybe<CutsheetCapabilityPrintSettingsInput>;
  species: EnumCutsheetCapabilitySpecies;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilityOptionInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType: EnumCutsheetCapabilityOptionOptionType;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Float']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecificationsInput>>>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilityOptionPayload = {
  __typename?: 'CreateManyCutsheetCapabilityOptionPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapabilityOption>>;
};

export type CreateManyCutsheetCapabilityPayload = {
  __typename?: 'CreateManyCutsheetCapabilityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapability>>;
};

export type CreateManyCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: EnumCutsheetCapabilitySpecificationInputType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilitySpecificationPayload = {
  __typename?: 'CreateManyCutsheetCapabilitySpecificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapabilitySpecification>>;
};

export type CreateManyCutsheetDescriptionLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyCutsheetDescriptionLibraryPayload = {
  __typename?: 'CreateManyCutsheetDescriptionLibraryPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetDescriptionLibrary>>;
};

export type CreateManyCutsheetImageLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyCutsheetImageLibraryPayload = {
  __typename?: 'CreateManyCutsheetImageLibraryPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetImageLibrary>>;
};

export type CreateManyCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts: Array<InputMaybe<Scalars['MongoID']['input']>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimInput>>>;
  type: EnumCutsheetType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyCutsheetPayload = {
  __typename?: 'CreateManyCutsheetPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Cutsheet>>;
};

export type CreateManyCutsheetQuestionnaireInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<CutsheetQuestionnaireProcessingFeeInput>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<CutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<CutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetQuestionnairePayload = {
  __typename?: 'CreateManyCutsheetQuestionnairePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetQuestionnaire>>;
};

export type CreateManyDataImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<DataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<DataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows: Scalars['Float']['input'];
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId: Scalars['String']['input'];
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<DataImportJobNotImportedInput>>>;
  notImportedCount: Scalars['Float']['input'];
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount: Scalars['Float']['input'];
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status: EnumDataImportJobStatus;
  successCount: Scalars['Float']['input'];
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId: Scalars['MongoID']['input'];
  totalRows: Scalars['Float']['input'];
  type: EnumDataImportJobType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy: Scalars['MongoID']['input'];
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows: Scalars['Float']['input'];
  validationErrors?: InputMaybe<Array<InputMaybe<DataImportJobValidationErrorsInput>>>;
  vendorId: Scalars['MongoID']['input'];
};

export type CreateManyDataImportJobPayload = {
  __typename?: 'CreateManyDataImportJobPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<DataImportJob>>;
};

export type CreateManyExportPresetInput = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<ExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<ExportPresetSortInput>>>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyExportPresetPayload = {
  __typename?: 'CreateManyExportPresetPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ExportPreset>>;
};

export type CreateManyExportSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<ExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyExportSettingPayload = {
  __typename?: 'CreateManyExportSettingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ExportSetting>>;
};

export type CreateManyFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<FinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyFinancialReportingConfigPayload = {
  __typename?: 'CreateManyFinancialReportingConfigPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<FinancialReportingConfig>>;
};

export type CreateManyIntegrationInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<IntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name: EnumIntegrationName;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type: EnumIntegrationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyIntegrationPayload = {
  __typename?: 'CreateManyIntegrationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Integration>>;
};

export type CreateManyInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due: Scalars['Float']['input'];
  amount_paid: Scalars['Float']['input'];
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  discounts?: InputMaybe<Array<InputMaybe<InvoiceDiscountsInput>>>;
  due_date: Scalars['Date']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<InvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status: EnumInvoiceStatus;
  status_changes?: InputMaybe<Array<InputMaybe<InvoiceStatus_ChangesInput>>>;
  type: EnumInvoiceType;
  user: Scalars['MongoID']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceLineItemExternal_LinksInput>;
  invoice: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<InputMaybe<InvoiceLineItemLinksInput>>>;
  quantity: Scalars['Float']['input'];
};

export type CreateManyInvoiceLineItemPayload = {
  __typename?: 'CreateManyInvoiceLineItemPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<InvoiceLineItem>>;
};

export type CreateManyInvoicePayload = {
  __typename?: 'CreateManyInvoicePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Invoice>>;
};

export type CreateManyLandingPageSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<LandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<LandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<LandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<LandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<LandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<LandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyLandingPageSettingsPayload = {
  __typename?: 'CreateManyLandingPageSettingsPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<LandingPageSettings>>;
};

export type CreateManyNoteInput = {
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<NoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumNoteType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyNotePayload = {
  __typename?: 'CreateManyNotePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Note>>;
};

export type CreateManyNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<NotificationErrorInput>;
  errorMessage?: InputMaybe<NotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyNotificationPayload = {
  __typename?: 'CreateManyNotificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Notification>>;
};

export type CreateManyNotificationSettingInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationSettingTimingsInput>>>;
  trigger: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyNotificationSettingPayload = {
  __typename?: 'CreateManyNotificationSettingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<NotificationSetting>>;
};

export type CreateManyPrimalCutBlockerInput = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<PrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyPrimalCutBlockerPayload = {
  __typename?: 'CreateManyPrimalCutBlockerPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCutBlocker>>;
};

export type CreateManyPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  primal: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalCutPayload = {
  __typename?: 'CreateManyPrimalCutPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCut>>;
};

export type CreateManyPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalCutTypePayload = {
  __typename?: 'CreateManyPrimalCutTypePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCutType>>;
};

export type CreateManyPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalGroupPayload = {
  __typename?: 'CreateManyPrimalGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalGroup>>;
};

export type CreateManyPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['MongoID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalPayload = {
  __typename?: 'CreateManyPrimalPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Primal>>;
};

export type CreateManyProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyProcessorCapabilityPayload = {
  __typename?: 'CreateManyProcessorCapabilityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorCapability>>;
};

export type CreateManyProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyProcessorCapabilitySpecificationPayload = {
  __typename?: 'CreateManyProcessorCapabilitySpecificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorCapabilitySpecification>>;
};

export type CreateManyProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType: Scalars['String']['input'];
  sentOn: Scalars['Date']['input'];
  sentTo: Scalars['String']['input'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorNotificationPayload = {
  __typename?: 'CreateManyProcessorNotificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorNotification>>;
};

export type CreateManyProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<ProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<ProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<ProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount: Scalars['Float']['input'];
  invoice?: InputMaybe<ProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<ProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusChanges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyProcessorSchedulingPayload = {
  __typename?: 'CreateManyProcessorSchedulingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorScheduling>>;
};

export type CreateManyProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['input'];
  isDeleted: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyProcessorSettingsCustomCapacityPayload = {
  __typename?: 'CreateManyProcessorSettingsCustomCapacityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorSettingsCustomCapacity>>;
};

export type CreateManyProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<ProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<ProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<ProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<ProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<ProcessorSettingsValidationErrorsInput>>>;
  vendor: Scalars['MongoID']['input'];
  workflowCapacity?: InputMaybe<ProcessorSettingsWorkflowCapacityInput>;
};

export type CreateManyProcessorSettingsPayload = {
  __typename?: 'CreateManyProcessorSettingsPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorSettings>>;
};

export type CreateManyStateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateManyStatePayload = {
  __typename?: 'CreateManyStatePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<State>>;
};

export type CreateManyTenantInput = {
  date_created: Scalars['Date']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyTenantPayload = {
  __typename?: 'CreateManyTenantPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Tenant>>;
};

export type CreateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<UserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant: Scalars['MongoID']['input'];
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyUserPayload = {
  __typename?: 'CreateManyUserPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<User>>;
};

export type CreateManyVendorInput = {
  address: AddressInput;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name: Scalars['String']['input'];
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory: Scalars['Boolean']['input'];
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['MongoID']['input'];
  twilioPhoneConfig?: InputMaybe<VendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManyVendorModuleInput = {
  active: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moduleType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyVendorModulePayload = {
  __typename?: 'CreateManyVendorModulePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<VendorModule>>;
};

export type CreateManyVendorPayload = {
  __typename?: 'CreateManyVendorPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Vendor>>;
};

export type CreateManyWaitlistInput = {
  animal: EnumWaitlistAnimal;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer: Scalars['MongoID']['input'];
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status: EnumWaitlistStatus;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyWaitlistPayload = {
  __typename?: 'CreateManyWaitlistPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Waitlist>>;
};

export type CreateOneAddressInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: EnumAddressType;
};

export type CreateOneAddressPayload = {
  __typename?: 'CreateOneAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount: Scalars['Float']['input'];
  failures?: InputMaybe<Array<InputMaybe<CsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows: Scalars['Float']['input'];
  jobId: Scalars['String']['input'];
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount: Scalars['Float']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status: EnumCsvImportJobStatus;
  successCount: Scalars['Float']['input'];
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows: Scalars['Float']['input'];
  type: EnumCsvImportJobType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy: Scalars['MongoID']['input'];
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows: Scalars['Float']['input'];
  validationErrors?: InputMaybe<Array<InputMaybe<CsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneCsvImportJobPayload = {
  __typename?: 'CreateOneCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CsvImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCalendarEventInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date: Scalars['Date']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCalendarEventPayload = {
  __typename?: 'CreateOneCalendarEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CalendarEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCalendarEventTypeInput = {
  color: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCalendarEventTypePayload = {
  __typename?: 'CreateOneCalendarEventTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CalendarEventType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type CreateOneCancellationReasonPayload = {
  __typename?: 'CreateOneCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customer?: InputMaybe<Scalars['MongoID']['input']>;
  directKey?: InputMaybe<Scalars['String']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  unreadMarks?: InputMaybe<Array<InputMaybe<ChatRoomUnreadMarksInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneChatRoomPayload = {
  __typename?: 'CreateOneChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCustomFieldDefinitionInput = {
  captureAt: EnumCustomFieldDefinitionCaptureAt;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType: EnumCustomFieldDefinitionFieldType;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  modelType: EnumCustomFieldDefinitionModelType;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCustomFieldDefinitionPayload = {
  __typename?: 'CreateOneCustomFieldDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CustomFieldDefinition>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCustomFieldValueInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition: Scalars['MongoID']['input'];
  recordId: Scalars['String']['input'];
  recordType: EnumCustomFieldValueRecordType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneCustomFieldValuePayload = {
  __typename?: 'CreateOneCustomFieldValuePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CustomFieldValue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetAssignmentRuleSetInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetAssignmentRuleSetPayload = {
  __typename?: 'CreateOneCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetAssignmentRuleSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilityGroupInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilityGroupPayload = {
  __typename?: 'CreateOneCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapabilityGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name: Scalars['String']['input'];
  printSettings?: InputMaybe<CutsheetCapabilityPrintSettingsInput>;
  species: EnumCutsheetCapabilitySpecies;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilityOptionInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType: EnumCutsheetCapabilityOptionOptionType;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Float']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecificationsInput>>>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilityOptionPayload = {
  __typename?: 'CreateOneCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapabilityOption>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilityPayload = {
  __typename?: 'CreateOneCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: EnumCutsheetCapabilitySpecificationInputType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilitySpecificationPayload = {
  __typename?: 'CreateOneCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetDescriptionLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneCutsheetDescriptionLibraryPayload = {
  __typename?: 'CreateOneCutsheetDescriptionLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetDescriptionLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetImageLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneCutsheetImageLibraryPayload = {
  __typename?: 'CreateOneCutsheetImageLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetImageLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts: Array<InputMaybe<Scalars['MongoID']['input']>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimInput>>>;
  type: EnumCutsheetType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneCutsheetPayload = {
  __typename?: 'CreateOneCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetQuestionnaireInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<CutsheetQuestionnaireProcessingFeeInput>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<CutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<CutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetQuestionnairePayload = {
  __typename?: 'CreateOneCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetQuestionnaire>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDataImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<DataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<DataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows: Scalars['Float']['input'];
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId: Scalars['String']['input'];
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<DataImportJobNotImportedInput>>>;
  notImportedCount: Scalars['Float']['input'];
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount: Scalars['Float']['input'];
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status: EnumDataImportJobStatus;
  successCount: Scalars['Float']['input'];
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId: Scalars['MongoID']['input'];
  totalRows: Scalars['Float']['input'];
  type: EnumDataImportJobType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy: Scalars['MongoID']['input'];
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows: Scalars['Float']['input'];
  validationErrors?: InputMaybe<Array<InputMaybe<DataImportJobValidationErrorsInput>>>;
  vendorId: Scalars['MongoID']['input'];
};

export type CreateOneDataImportJobPayload = {
  __typename?: 'CreateOneDataImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<DataImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneExportPresetInput = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<ExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<ExportPresetSortInput>>>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneExportPresetPayload = {
  __typename?: 'CreateOneExportPresetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ExportPreset>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneExportSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<ExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneExportSettingPayload = {
  __typename?: 'CreateOneExportSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ExportSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<FinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFinancialReportingConfigPayload = {
  __typename?: 'CreateOneFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<FinancialReportingConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneIntegrationInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<IntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name: EnumIntegrationName;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type: EnumIntegrationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneIntegrationPayload = {
  __typename?: 'CreateOneIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due: Scalars['Float']['input'];
  amount_paid: Scalars['Float']['input'];
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  discounts?: InputMaybe<Array<InputMaybe<InvoiceDiscountsInput>>>;
  due_date: Scalars['Date']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<InvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status: EnumInvoiceStatus;
  status_changes?: InputMaybe<Array<InputMaybe<InvoiceStatus_ChangesInput>>>;
  type: EnumInvoiceType;
  user: Scalars['MongoID']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceLineItemExternal_LinksInput>;
  invoice: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<InputMaybe<InvoiceLineItemLinksInput>>>;
  quantity: Scalars['Float']['input'];
};

export type CreateOneInvoiceLineItemPayload = {
  __typename?: 'CreateOneInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInvoicePayload = {
  __typename?: 'CreateOneInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneJobTagInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  icon: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumJobTagSpecies>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneJobTagPayload = {
  __typename?: 'CreateOneJobTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<JobTag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLandingPageSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<LandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<LandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<LandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<LandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<LandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<LandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLandingPageSettingsPayload = {
  __typename?: 'CreateOneLandingPageSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LandingPageSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNoteInput = {
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<NoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumNoteType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneNotePayload = {
  __typename?: 'CreateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<NotificationErrorInput>;
  errorMessage?: InputMaybe<NotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneNotificationPayload = {
  __typename?: 'CreateOneNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Notification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNotificationSettingInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationSettingTimingsInput>>>;
  trigger: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneNotificationSettingPayload = {
  __typename?: 'CreateOneNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutBlockerInput = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<PrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOnePrimalCutBlockerPayload = {
  __typename?: 'CreateOnePrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  primal: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalCutPayload = {
  __typename?: 'CreateOnePrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalCutTypePayload = {
  __typename?: 'CreateOnePrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalGroupPayload = {
  __typename?: 'CreateOnePrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['MongoID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalPayload = {
  __typename?: 'CreateOnePrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneProcessorCapabilityPayload = {
  __typename?: 'CreateOneProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProcessorCapabilitySpecificationPayload = {
  __typename?: 'CreateOneProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType: Scalars['String']['input'];
  sentOn: Scalars['Date']['input'];
  sentTo: Scalars['String']['input'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorNotificationPayload = {
  __typename?: 'CreateOneProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<ProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<ProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<ProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount: Scalars['Float']['input'];
  invoice?: InputMaybe<ProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<ProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusChanges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneProcessorSchedulingPayload = {
  __typename?: 'CreateOneProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['input'];
  isDeleted: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProcessorSettingsCustomCapacityPayload = {
  __typename?: 'CreateOneProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<ProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<ProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<ProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<ProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<ProcessorSettingsValidationErrorsInput>>>;
  vendor: Scalars['MongoID']['input'];
  workflowCapacity?: InputMaybe<ProcessorSettingsWorkflowCapacityInput>;
};

export type CreateOneProcessorSettingsPayload = {
  __typename?: 'CreateOneProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneStateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOneStatePayload = {
  __typename?: 'CreateOneStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTenantInput = {
  date_created: Scalars['Date']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTenantPayload = {
  __typename?: 'CreateOneTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<UserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant: Scalars['MongoID']['input'];
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneUserPayload = {
  __typename?: 'CreateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneVendorInput = {
  address: AddressInput;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name: Scalars['String']['input'];
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory: Scalars['Boolean']['input'];
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['MongoID']['input'];
  twilioPhoneConfig?: InputMaybe<VendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneVendorModuleInput = {
  active: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moduleType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneVendorModulePayload = {
  __typename?: 'CreateOneVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<VendorModule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneVendorPayload = {
  __typename?: 'CreateOneVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWaitlistInput = {
  animal: EnumWaitlistAnimal;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer: Scalars['MongoID']['input'];
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status: EnumWaitlistStatus;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneWaitlistPayload = {
  __typename?: 'CreateOneWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateProcessorScheduleResponse = {
  __typename?: 'CreateProcessorScheduleResponse';
  /** Capacity on the booked job's drop-off day (and the next open day), counted like the scheduling date picker, after this booking. */
  bookingFollowUp?: Maybe<BookingFollowUp>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scheduling: ProcessorScheduling;
};

export type CreateProcessorSchedulingInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadInput>>>;
  animalSpecies: Scalars['String']['input'];
  blockIndex?: InputMaybe<Scalars['Int']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  depositCollection?: InputMaybe<DepositCollectionInput>;
  depositPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  dropoffDate: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  headCount: Scalars['Int']['input'];
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  listing?: InputMaybe<ProcessorSchedulingListingInput>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays: Scalars['Int']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  requesterContactInformation?: InputMaybe<RequesterContactInformationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  vendor: Scalars['MongoID']['input'];
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateProcessorSettingsCustomCapacityInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityBlockInput>>>;
  date: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProcessorSettingsInvoicingInput = {
  defaultSplitRule?: InputMaybe<Scalars['String']['input']>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProcessorSettingsWithCustomCapacity = {
  __typename?: 'CreateProcessorSettingsWithCustomCapacity';
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  processorSettings?: Maybe<ProcessorSettings>;
};

export type CreateProcessorSettingsWithCustomCapacityInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsAnimalSettings>>>;
  autoCarcassNumberSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoCarcassNumberSettingsInput>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingInput>>>;
  capacityConfigurationType?: InputMaybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  customCapacities?: InputMaybe<Array<InputMaybe<CreateProcessorSettingsCustomCapacityInput>>>;
  documentSettings?: InputMaybe<DocumentSettingsInput>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsHangTimeInput>>>;
  invoicing?: InputMaybe<CreateProcessorSettingsInvoicingInput>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays: Scalars['Int']['input'];
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  timeTrackingConfig?: InputMaybe<TimeTrackingConfigInput>;
  vendor: Scalars['MongoID']['input'];
};

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  _id: Scalars['MongoID']['output'];
  captureAt: EnumCustomFieldDefinitionCaptureAt;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fieldKey?: Maybe<Scalars['String']['output']>;
  fieldSource?: Maybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType: EnumCustomFieldDefinitionFieldType;
  hint?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  modelType: EnumCustomFieldDefinitionModelType;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
  speciesFilter: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CustomFieldDefinitionPagination = {
  __typename?: 'CustomFieldDefinitionPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CustomFieldDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  definition: Scalars['MongoID']['output'];
  recordId: Scalars['String']['output'];
  recordType: EnumCustomFieldValueRecordType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value_boolean?: Maybe<Scalars['Boolean']['output']>;
  value_json?: Maybe<Scalars['JSON']['output']>;
  value_number?: Maybe<Scalars['Float']['output']>;
  value_text?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldValueBulkInput = {
  definitionId: Scalars['MongoID']['input'];
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldValueBulkSaveError = {
  __typename?: 'CustomFieldValueBulkSaveError';
  index: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CustomFieldValueBulkSaveResponse = {
  __typename?: 'CustomFieldValueBulkSaveResponse';
  errors?: Maybe<Array<CustomFieldValueBulkSaveError>>;
  savedCount: Scalars['Int']['output'];
};

export type CustomFieldValueClearInput = {
  definitionId: Scalars['MongoID']['input'];
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type CustomFieldValueClearResponse = {
  __typename?: 'CustomFieldValueClearResponse';
  deletedCount: Scalars['Int']['output'];
};

/** List of items with pagination. */
export type CustomFieldValuePagination = {
  __typename?: 'CustomFieldValuePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CustomFieldValue>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CustomerDeletePreview = {
  __typename?: 'CustomerDeletePreview';
  associatedRecordCount: Scalars['Int']['output'];
  blockedReason?: Maybe<Scalars['String']['output']>;
  canDelete: Scalars['Boolean']['output'];
  multiVendor: Scalars['Boolean']['output'];
};

export type CustomerDeleteResult = {
  __typename?: 'CustomerDeleteResult';
  loserSoftDeleted: Scalars['Boolean']['output'];
  operationId: Scalars['MongoID']['output'];
};

export type CustomerJobSummary = {
  __typename?: 'CustomerJobSummary';
  cancelledCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  firstJobDate?: Maybe<Scalars['Date']['output']>;
  inProgressCount: Scalars['Int']['output'];
  lastJobDate?: Maybe<Scalars['Date']['output']>;
  needsApprovalCount: Scalars['Int']['output'];
};

export type CustomerMergeCandidate = {
  __typename?: 'CustomerMergeCandidate';
  _id: Scalars['MongoID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  hasLogin: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  retireBlockedReason?: Maybe<Scalars['String']['output']>;
};

export type CustomerMergeFieldSelectionInput = {
  field: Scalars['String']['input'];
  sourceId: Scalars['MongoID']['input'];
};

export type CustomerMergePreview = {
  __typename?: 'CustomerMergePreview';
  affectedRecordCount: Scalars['Int']['output'];
  cap: Scalars['Int']['output'];
  crossType: Scalars['Boolean']['output'];
  exceedsCap: Scalars['Boolean']['output'];
  touchesQuickbooks: Scalars['Boolean']['output'];
};

export type CustomerMergeResult = {
  __typename?: 'CustomerMergeResult';
  affectedRecordCount: Scalars['Int']['output'];
  operationIds: Array<Scalars['MongoID']['output']>;
};

export type CustomerNotificationDefaults = {
  __typename?: 'CustomerNotificationDefaults';
  animal: Scalars['Boolean']['output'];
  job: Scalars['Boolean']['output'];
  split: Scalars['Boolean']['output'];
};

export type CustomerRebookingCadence = {
  __typename?: 'CustomerRebookingCadence';
  autoIntervalDays?: Maybe<Scalars['Float']['output']>;
  dueSoonWindowDays?: Maybe<Scalars['Float']['output']>;
  effectiveIntervalDays?: Maybe<Scalars['Float']['output']>;
  expectedNextBookingDate?: Maybe<Scalars['Date']['output']>;
  latestDropoffDate?: Maybe<Scalars['Date']['output']>;
  overrideIntervalDays?: Maybe<Scalars['Float']['output']>;
  rebookingIntervalSource?: Maybe<Scalars['String']['output']>;
  rebookingStatus?: Maybe<Scalars['String']['output']>;
};

export type CustomerSummaryDetails = {
  __typename?: 'CustomerSummaryDetails';
  customerCount?: Maybe<Scalars['Int']['output']>;
  jobSummary: CustomerJobSummary;
  linkedProducer?: Maybe<User>;
};

export type Cutsheet = {
  __typename?: 'Cutsheet';
  _id: Scalars['MongoID']['output'];
  activeSpecification?: Maybe<ProcessorCapabilitySpecification>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: Maybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  extras?: Maybe<Array<Maybe<CutsheetExtras>>>;
  groundMeatSize?: Maybe<Scalars['Float']['output']>;
  inspectionLevels?: Maybe<Array<Maybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Last date this cutsheet was used in a processor scheduling (for user cutsheets) */
  lastUsedDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['JSON']['output']>;
  parentCutsheet?: Maybe<Scalars['MongoID']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  primalCuts: Array<PrimalCut>;
  roastSize?: Maybe<Scalars['String']['output']>;
  selectedSpecifications?: Maybe<Scalars['JSON']['output']>;
  splitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  steakThickness?: Maybe<Scalars['Float']['output']>;
  steaksPerPack?: Maybe<Scalars['Float']['output']>;
  trim?: Maybe<Array<Maybe<CutsheetTrim>>>;
  type: EnumCutsheetType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['MongoID']['output']>;
  user?: Maybe<User>;
  vendor?: Maybe<Vendor>;
};


export type CutsheetPrimalCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};

export type CutsheetApplyCatalogChangesPayload = {
  __typename?: 'CutsheetApplyCatalogChangesPayload';
  actions: Array<CutsheetChatAction>;
  catalogChanged: Scalars['Boolean']['output'];
};

export type CutsheetApplyQuestionnaireChangesPayload = {
  __typename?: 'CutsheetApplyQuestionnaireChangesPayload';
  actions: Array<CutsheetChatAction>;
  changed: Scalars['Boolean']['output'];
  questions?: Maybe<Scalars['JSON']['output']>;
};

export type CutsheetAssignmentRuleInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId: Scalars['MongoID']['input'];
  sortOrder: Scalars['Int']['input'];
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CutsheetAssignmentRuleSet = {
  __typename?: 'CutsheetAssignmentRuleSet';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultQuestionnaireId?: Maybe<Scalars['MongoID']['output']>;
  rules?: Maybe<Array<Maybe<CutsheetAssignmentRuleSetRules>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetAssignmentRuleSetPagination = {
  __typename?: 'CutsheetAssignmentRuleSetPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetAssignmentRuleSet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetAssignmentRuleSetRules = {
  __typename?: 'CutsheetAssignmentRuleSetRules';
  buyer?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  inspectionLevel?: Maybe<Array<Maybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: Maybe<Scalars['String']['output']>;
  producer?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  questionnaireId: Scalars['MongoID']['output'];
  sortOrder: Scalars['Float']['output'];
  splitIndex?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  splitType?: Maybe<Array<Maybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type CutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId: Scalars['MongoID']['input'];
  sortOrder: Scalars['Float']['input'];
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type CutsheetCapability = {
  __typename?: 'CutsheetCapability';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  legacyInspectionLevelMap?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMap>>>;
  name: Scalars['String']['output'];
  printSettings?: Maybe<CutsheetCapabilityPrintSettings>;
  species: EnumCutsheetCapabilitySpecies;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type CutsheetCapabilityDuplicateResponse = {
  __typename?: 'CutsheetCapabilityDuplicateResponse';
  capability?: Maybe<CutsheetCapability>;
  summary?: Maybe<CutsheetCapabilityDuplicateSummary>;
};

export type CutsheetCapabilityDuplicateSummary = {
  __typename?: 'CutsheetCapabilityDuplicateSummary';
  assignmentRulesCopied: Scalars['Int']['output'];
  groupsCopied: Scalars['Int']['output'];
  optionsCopied: Scalars['Int']['output'];
  questionnairesCopied: Scalars['Int']['output'];
  specificationsCopied: Scalars['Int']['output'];
};

export type CutsheetCapabilityGroup = {
  __typename?: 'CutsheetCapabilityGroup';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetCapabilityGroupPagination = {
  __typename?: 'CutsheetCapabilityGroupPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapabilityGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCapabilityLegacyInspectionLevelMap = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap';
  cutMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapCutMappings>>>;
  extraMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapExtraMappings>>>;
  inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel;
  questionnaireId: Scalars['MongoID']['output'];
  specMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapSpecMappings>>>;
  trimMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapTrimMappings>>>;
};

export type CutsheetCapabilityLegacyInspectionLevelMapCutMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings';
  newOptionId: Scalars['MongoID']['output'];
  oldCutId: Scalars['MongoID']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldCutId: Scalars['MongoID']['input'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapExtraMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings';
  newOptionValue: Scalars['String']['output'];
  newSpecificationId: Scalars['MongoID']['output'];
  oldExtraName: Scalars['String']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue: Scalars['String']['input'];
  newSpecificationId: Scalars['MongoID']['input'];
  oldExtraName: Scalars['String']['input'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel;
  questionnaireId: Scalars['MongoID']['input'];
  specMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type CutsheetCapabilityLegacyInspectionLevelMapSpecMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings';
  newSpecificationId: Scalars['MongoID']['output'];
  oldSpecName: Scalars['String']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId: Scalars['MongoID']['input'];
  oldSpecName: Scalars['String']['input'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapTrimMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings';
  newOptionId: Scalars['MongoID']['output'];
  oldTrimName: Scalars['String']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldTrimName: Scalars['String']['input'];
};

export type CutsheetCapabilityMigrateLegacyResponse = {
  __typename?: 'CutsheetCapabilityMigrateLegacyResponse';
  capability?: Maybe<CutsheetCapability>;
  summary?: Maybe<CutsheetCapabilityMigrateLegacySummary>;
};

export type CutsheetCapabilityMigrateLegacySummary = {
  __typename?: 'CutsheetCapabilityMigrateLegacySummary';
  assignmentRulesAdded: Scalars['Int']['output'];
  cutsCreated: Scalars['Int']['output'];
  cutsReused: Scalars['Int']['output'];
  groupsCreated: Scalars['Int']['output'];
  groupsReused: Scalars['Int']['output'];
  inspectionLevelsMigrated: Array<Scalars['String']['output']>;
  questionnairesCreated: Scalars['Int']['output'];
  questionnairesReused: Scalars['Int']['output'];
  specificationsCreated: Scalars['Int']['output'];
  specificationsReused: Scalars['Int']['output'];
  trimsCreated: Scalars['Int']['output'];
  trimsReused: Scalars['Int']['output'];
};

export type CutsheetCapabilityOption = {
  __typename?: 'CutsheetCapabilityOption';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['MongoID']['output']>;
  hiddenUnlessSelected?: Maybe<Scalars['Boolean']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  minQty?: Maybe<Scalars['Float']['output']>;
  optionType: EnumCutsheetCapabilityOptionOptionType;
  partnerCodes?: Maybe<Array<Maybe<CutsheetCapabilityOptionPartnerCodes>>>;
  pricing?: Maybe<CutsheetCapabilityOptionPricing>;
  printedText?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Float']['output'];
  specifications?: Maybe<Array<Maybe<CutsheetCapabilityOptionSpecifications>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetCapabilityOptionPagination = {
  __typename?: 'CutsheetCapabilityOptionPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapabilityOption>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCapabilityOptionPartnerCodeInput = {
  adapter: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeRuleInput>>>;
};

export type CutsheetCapabilityOptionPartnerCodeRuleInput = {
  code: Scalars['String']['input'];
  conditions?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecConditionInput>>>;
};

export type CutsheetCapabilityOptionPartnerCodes = {
  __typename?: 'CutsheetCapabilityOptionPartnerCodes';
  adapter: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Maybe<CutsheetCapabilityOptionPartnerCodesRules>>>;
  speciesCode?: Maybe<Scalars['String']['output']>;
};

export type CutsheetCapabilityOptionPartnerCodesInput = {
  adapter: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetCapabilityOptionPartnerCodesRules = {
  __typename?: 'CutsheetCapabilityOptionPartnerCodesRules';
  code: Scalars['String']['output'];
  conditions?: Maybe<Array<Maybe<CutsheetCapabilityOptionPartnerCodesRulesConditions>>>;
  speciesCode?: Maybe<Scalars['String']['output']>;
};

export type CutsheetCapabilityOptionPartnerCodesRulesConditions = {
  __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions';
  specificationId: Scalars['MongoID']['output'];
  value: Scalars['String']['output'];
};

export type CutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId: Scalars['MongoID']['input'];
  value: Scalars['String']['input'];
};

export type CutsheetCapabilityOptionPartnerCodesRulesInput = {
  code: Scalars['String']['input'];
  conditions?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetCapabilityOptionPricing = {
  __typename?: 'CutsheetCapabilityOptionPricing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  model: EnumCutsheetCapabilityOptionPricingModel;
  price: Scalars['Float']['output'];
};

export type CutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: EnumCutsheetCapabilityOptionPricingModel;
  price: Scalars['Float']['input'];
};

export type CutsheetCapabilityOptionSpecConditionInput = {
  specificationId: Scalars['MongoID']['input'];
  value: Scalars['String']['input'];
};

export type CutsheetCapabilityOptionSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetCapabilityOptionSpecifications = {
  __typename?: 'CutsheetCapabilityOptionSpecifications';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: EnumCutsheetCapabilityOptionSpecificationsType;
  unit?: Maybe<Scalars['String']['output']>;
};

export type CutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: EnumCutsheetCapabilityOptionSpecificationsType;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type CutsheetCapabilityPagination = {
  __typename?: 'CutsheetCapabilityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapability>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCapabilityPrintSettings = {
  __typename?: 'CutsheetCapabilityPrintSettings';
  alwaysShowPrimalNotes?: Maybe<Scalars['Boolean']['output']>;
  baseFontSize?: Maybe<Scalars['Float']['output']>;
  checkboxStyle?: Maybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: Maybe<Scalars['String']['output']>;
  customContentTitle?: Maybe<Scalars['String']['output']>;
  hiddenGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hiddenItemIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hiddenSpecificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hideUnselectedCuts?: Maybe<Scalars['Boolean']['output']>;
  highlightCutsheetNotes?: Maybe<Scalars['Boolean']['output']>;
  highlightSectionNotes?: Maybe<Scalars['Boolean']['output']>;
  orientation?: Maybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: Maybe<Scalars['Float']['output']>;
  showAllSpecOptions?: Maybe<Scalars['Boolean']['output']>;
  showCustomContent?: Maybe<Scalars['Boolean']['output']>;
  showPrimalGroup?: Maybe<Scalars['Boolean']['output']>;
  specsLayoutPosition?: Maybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type CutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type CutsheetCapabilitySpecification = {
  __typename?: 'CutsheetCapabilitySpecification';
  _id: Scalars['MongoID']['output'];
  assignedToIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inputType: EnumCutsheetCapabilitySpecificationInputType;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  pricingAdjustments?: Maybe<Scalars['JSON']['output']>;
  printedText?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetCapabilitySpecificationPagination = {
  __typename?: 'CutsheetCapabilitySpecificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapabilitySpecification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCatalogChatMessageInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type CutsheetCatalogChatPayload = {
  __typename?: 'CutsheetCatalogChatPayload';
  actions: Array<CutsheetChatAction>;
  catalogChanged: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  proposedChanges: Array<CutsheetProposedChange>;
};

export type CutsheetChatAction = {
  __typename?: 'CutsheetChatAction';
  itemId?: Maybe<Scalars['String']['output']>;
  itemType: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CutsheetChoiceOptionInput = {
  cutIds: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type CutsheetCutPricingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetCutSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetDescriptionLibrary = {
  __typename?: 'CutsheetDescriptionLibrary';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type CutsheetDescriptionLibraryPagination = {
  __typename?: 'CutsheetDescriptionLibraryPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetDescriptionLibrary>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetDocumentSettingsInput = {
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type CutsheetExtraPricingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetExtraSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetExtras = {
  __typename?: 'CutsheetExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetExtrasTypeInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetHeaderDocumentSettingsInput = {
  fields?: InputMaybe<Array<InputMaybe<DocumentFieldEntryInput>>>;
  media?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetHeaderPreviewResponse = {
  __typename?: 'CutsheetHeaderPreviewResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type CutsheetImageLibrary = {
  __typename?: 'CutsheetImageLibrary';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type CutsheetImageLibraryPagination = {
  __typename?: 'CutsheetImageLibraryPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetImageLibrary>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetInformationInput = {
  contactInformation?: InputMaybe<RequesterContactInformationInput>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  splitPart: Scalars['String']['input'];
  type?: InputMaybe<EnumCutsheetType>;
};

export type CutsheetInformationPartialUpdateInput = {
  _id: Scalars['MongoID']['input'];
  clearContactUser?: InputMaybe<Scalars['Boolean']['input']>;
  contactUser?: InputMaybe<ProcessorSchedulingPartialUpdateRequestedByInput>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUpdateExistingUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CutsheetLegacyCutMappingInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldCutId: Scalars['MongoID']['input'];
};

export type CutsheetLegacyExtraMappingInput = {
  newOptionValue: Scalars['String']['input'];
  newSpecificationId: Scalars['MongoID']['input'];
  oldExtraName: Scalars['String']['input'];
};

export type CutsheetLegacyInspectionLevelEntryInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacyCutMappingInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacyExtraMappingInput>>>;
  inspectionLevel: Scalars['String']['input'];
  questionnaireId: Scalars['MongoID']['input'];
  specMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacySpecMappingInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacyTrimMappingInput>>>;
};

export type CutsheetLegacySpecMappingInput = {
  newSpecificationId: Scalars['MongoID']['input'];
  oldSpecName: Scalars['String']['input'];
};

export type CutsheetLegacyTrimMappingInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldTrimName: Scalars['String']['input'];
};

/** List of items with pagination. */
export type CutsheetPagination = {
  __typename?: 'CutsheetPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Cutsheet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetPartialUpdateInput = {
  _id: Scalars['MongoID']['input'];
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheetSource?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  yield?: InputMaybe<Array<InputMaybe<SplitYieldItemInput>>>;
};

export type CutsheetPricingOverrideEntryInput = {
  id: Scalars['String']['input'];
  pricing?: InputMaybe<CutsheetPricingOverrideInput>;
};

export type CutsheetPricingOverrideInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetProposedChange = {
  __typename?: 'CutsheetProposedChange';
  args?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  tool: Scalars['String']['output'];
};

export type CutsheetProposedChangeInput = {
  args?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  itemType: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  label: Scalars['String']['input'];
  tool: Scalars['String']['input'];
};

export type CutsheetQuestionInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<Scalars['String']['input']>>;
  availableExtraIds?: InputMaybe<Array<Scalars['String']['input']>>;
  availableTrimIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Int']['input']>;
  minSelections?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<InputMaybe<CutsheetChoiceOptionInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Int']['input'];
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CutsheetQuestionnaire = {
  __typename?: 'CutsheetQuestionnaire';
  _id: Scalars['MongoID']['output'];
  additionalCharges?: Maybe<Array<Maybe<CutsheetQuestionnaireAdditionalCharges>>>;
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultSelections?: Maybe<CutsheetQuestionnaireDefaultSelections>;
  description?: Maybe<Scalars['String']['output']>;
  killFee?: Maybe<CutsheetQuestionnaireProcessingFee>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  pricingOverrides?: Maybe<Scalars['JSON']['output']>;
  printSettings?: Maybe<CutsheetQuestionnairePrintSettings>;
  processingFee?: Maybe<CutsheetQuestionnaireProcessingFee>;
  questions?: Maybe<Array<Maybe<CutsheetQuestionnaireQuestions>>>;
  specOptionPricingOverrides?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useCustomPrintSettings?: Maybe<Scalars['Boolean']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export enum CutsheetQuestionnaireAdditionalChargeBasisInput {
  PerAnimal = 'per_animal',
  PerSplit = 'per_split'
}

export type CutsheetQuestionnaireAdditionalChargeInput = {
  amount: Scalars['Float']['input'];
  basis: CutsheetQuestionnaireAdditionalChargeBasisInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  priceType?: InputMaybe<CutsheetQuestionnaireFeePriceTypeInput>;
};

export type CutsheetQuestionnaireAdditionalCharges = {
  __typename?: 'CutsheetQuestionnaireAdditionalCharges';
  amount: Scalars['Float']['output'];
  basis: EnumCutsheetQuestionnaireAdditionalChargesBasis;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType;
};

export type CutsheetQuestionnaireAdditionalChargesInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireAdditionalChargesBasis;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType;
};

export type CutsheetQuestionnaireChatPayload = {
  __typename?: 'CutsheetQuestionnaireChatPayload';
  actions: Array<CutsheetChatAction>;
  changed: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  proposedChanges: Array<CutsheetProposedChange>;
  questions?: Maybe<Scalars['JSON']['output']>;
};

export type CutsheetQuestionnaireDefaultSelections = {
  __typename?: 'CutsheetQuestionnaireDefaultSelections';
  extraSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsExtraSelections>;
  primalNotes?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotes>>>;
  selectedCuts?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCuts>>>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
  trimNotes?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotes>>>;
  trimSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsTrimSelections>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelections = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelections';
  extras?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras';
  optionId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type CutsheetQuestionnaireDefaultSelectionsPrimalNotes = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes';
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type CutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCuts = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts';
  optionId: Scalars['String']['output'];
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId: Scalars['String']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications';
  specification: Scalars['String']['output'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['output'];
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelections = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections';
  trim?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim>>>;
  type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType;
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType;
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim';
  optionId: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type CutsheetQuestionnaireFeeInput = {
  amount: Scalars['Float']['input'];
  basis: CutsheetQuestionnaireAdditionalChargeBasisInput;
  priceType: CutsheetQuestionnaireFeePriceTypeInput;
};

export enum CutsheetQuestionnaireFeePriceTypeInput {
  Fixed = 'fixed',
  PerLbHanging = 'per_lb_hanging',
  PerLbLive = 'per_lb_live'
}

/** List of items with pagination. */
export type CutsheetQuestionnairePagination = {
  __typename?: 'CutsheetQuestionnairePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetQuestionnaire>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetQuestionnairePrintSettings = {
  __typename?: 'CutsheetQuestionnairePrintSettings';
  alwaysShowPrimalNotes?: Maybe<Scalars['Boolean']['output']>;
  baseFontSize?: Maybe<Scalars['Float']['output']>;
  checkboxStyle?: Maybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: Maybe<Scalars['String']['output']>;
  customContentTitle?: Maybe<Scalars['String']['output']>;
  hiddenGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hiddenItemIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hiddenSpecificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hideUnselectedCuts?: Maybe<Scalars['Boolean']['output']>;
  highlightCutsheetNotes?: Maybe<Scalars['Boolean']['output']>;
  highlightSectionNotes?: Maybe<Scalars['Boolean']['output']>;
  orientation?: Maybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: Maybe<Scalars['Float']['output']>;
  showAllSpecOptions?: Maybe<Scalars['Boolean']['output']>;
  showCustomContent?: Maybe<Scalars['Boolean']['output']>;
  showPrimalGroup?: Maybe<Scalars['Boolean']['output']>;
  specsLayoutPosition?: Maybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type CutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type CutsheetQuestionnairePrintSettingsOverrideInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<Scalars['String']['input']>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenSpecificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetQuestionnaireProcessingFee = {
  __typename?: 'CutsheetQuestionnaireProcessingFee';
  amount: Scalars['Float']['output'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type CutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type CutsheetQuestionnaireQuestions = {
  __typename?: 'CutsheetQuestionnaireQuestions';
  allowMultiple?: Maybe<Scalars['Boolean']['output']>;
  allowSubSelection?: Maybe<Scalars['Boolean']['output']>;
  availableCutIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableExtraIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableTrimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  maxSelections?: Maybe<Scalars['Float']['output']>;
  minSelections?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Maybe<CutsheetQuestionnaireQuestionsOptions>>>;
  requireExactTotal?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  specificationId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: EnumCutsheetQuestionnaireQuestionsType;
};

export type CutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireQuestionsType;
};

export type CutsheetQuestionnaireQuestionsOptions = {
  __typename?: 'CutsheetQuestionnaireQuestionsOptions';
  cutIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type CutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type CutsheetQuestionnaireResponse = {
  __typename?: 'CutsheetQuestionnaireResponse';
  _id: Scalars['MongoID']['output'];
  capabilitySet: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  extraSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsExtraSelections>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  primalNotes?: Maybe<Array<Maybe<CutsheetQuestionnaireResponsePrimalNotes>>>;
  questionnaire: Scalars['MongoID']['output'];
  /** The name of the questionnaire this response was submitted to. */
  questionnaireName?: Maybe<Scalars['String']['output']>;
  selectedCuts?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCuts>>>;
  sourceDocument?: Maybe<CutsheetQuestionnaireResponseSourceDocument>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
  timeToComplete?: Maybe<Scalars['Float']['output']>;
  trimSectionNotes?: Maybe<Scalars['String']['output']>;
  trimSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsTrimSelections>;
  type: EnumCutsheetQuestionnaireResponseType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['MongoID']['output']>;
  user?: Maybe<Scalars['MongoID']['output']>;
  /** The response user's first and last name, if any. */
  userFullName?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetQuestionnaireResponsePagination = {
  __typename?: 'CutsheetQuestionnaireResponsePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetQuestionnaireResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetQuestionnaireResponsePrimalNotes = {
  __typename?: 'CutsheetQuestionnaireResponsePrimalNotes';
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type CutsheetQuestionnaireResponseSourceDocument = {
  __typename?: 'CutsheetQuestionnaireResponseSourceDocument';
  annotations?: Maybe<Array<Maybe<CutsheetQuestionnaireResponseSourceDocumentAnnotations>>>;
  pages?: Maybe<Array<Maybe<CutsheetQuestionnaireResponseSourceDocumentPages>>>;
};

export type CutsheetQuestionnaireResponseSourceDocumentAnnotations = {
  __typename?: 'CutsheetQuestionnaireResponseSourceDocumentAnnotations';
  height: Scalars['Float']['output'];
  label?: Maybe<Scalars['String']['output']>;
  page: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CutsheetQuestionnaireResponseSourceDocumentPages = {
  __typename?: 'CutsheetQuestionnaireResponseSourceDocumentPages';
  height: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Float']['output'];
  /** Short-lived URL for this page image. */
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
};

export type CutsheetResponseCutOptionInput = {
  optionId: Scalars['String']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
};

export type CutsheetResponseExtraResponseInput = {
  extras?: InputMaybe<Array<InputMaybe<CutsheetResponseExtraSelectionInput>>>;
};

export type CutsheetResponseExtraSelectionInput = {
  optionId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
};

export type CutsheetResponseNoteEntryInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type CutsheetResponseSourceAnnotationInput = {
  height: Scalars['Float']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CutsheetResponseSourcePageInput = {
  height: Scalars['Int']['input'];
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type CutsheetResponseSpecificationSelectionInput = {
  specification: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CutsheetResponseTrimResponseInput = {
  trim?: InputMaybe<Array<InputMaybe<CutsheetResponseTrimSelectionInput>>>;
  type: Scalars['String']['input'];
};

export type CutsheetResponseTrimSelectionInput = {
  optionId: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
};

export type CutsheetSpecOptionPricingEntryInput = {
  options?: InputMaybe<Array<InputMaybe<CutsheetSpecOptionPricingOptionInput>>>;
  specId: Scalars['String']['input'];
};

export type CutsheetSpecOptionPricingOptionInput = {
  optionValue: Scalars['String']['input'];
  pricing?: InputMaybe<CutsheetPricingOverrideInput>;
};

export type CutsheetTrim = {
  __typename?: 'CutsheetTrim';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAllTrim?: Maybe<Scalars['Boolean']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  trimSelection: EnumCutsheetTrimTrimSelection;
};

export type CutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection: EnumCutsheetTrimTrimSelection;
};

export type CutsheetTrimPricingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetTrimSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetTrimTypeInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type DailyCapacity = {
  __typename?: 'DailyCapacity';
  capacitiesByType?: Maybe<Array<Maybe<DailyCapacityCapacitiesByType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DailyCapacityCapacitiesByType = {
  __typename?: 'DailyCapacityCapacitiesByType';
  /** Some Description */
  capacities?: Maybe<Array<Maybe<ComplexAnimalCapacity>>>;
  type: EnumDailyCapacityCapacitiesByTypeType;
};

export type DailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type: EnumDailyCapacityCapacitiesByTypeType;
};

export type DailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<DailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DataImportAnimalSetting = {
  __typename?: 'DataImportAnimalSetting';
  inspectionLevels: Array<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  species: Scalars['String']['output'];
  splitTypes: Array<Scalars['String']['output']>;
};

export type DataImportAnimalSettingsPayload = {
  __typename?: 'DataImportAnimalSettingsPayload';
  animalSettings: Array<DataImportAnimalSetting>;
  vendorId: Scalars['String']['output'];
};

export type DataImportAvailableColumn = {
  __typename?: 'DataImportAvailableColumn';
  aliases: Array<Scalars['String']['output']>;
  baseField: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  validationRules?: Maybe<Scalars['String']['output']>;
};

export type DataImportCsvValidationError = {
  __typename?: 'DataImportCSVValidationError';
  errorMessages: Array<Scalars['String']['output']>;
  excludedMessages?: Maybe<Array<Scalars['String']['output']>>;
  row: Scalars['Int']['output'];
  side?: Maybe<Scalars['String']['output']>;
  warningMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export type DataImportCancelJobPayload = {
  __typename?: 'DataImportCancelJobPayload';
  cancelledAt: Scalars['Date']['output'];
  cancelledAtStage: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DataImportClearMatchDecisionPayload = {
  __typename?: 'DataImportClearMatchDecisionPayload';
  clearedRowCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  side: Scalars['String']['output'];
};

export type DataImportDeleteRecordPayload = {
  __typename?: 'DataImportDeleteRecordPayload';
  deletedRows: Array<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
};

export type DataImportEnableAnimalSpeciesPayload = {
  __typename?: 'DataImportEnableAnimalSpeciesPayload';
  jobId: Scalars['String']['output'];
  malformedJobCount: Scalars['Int']['output'];
  species: Scalars['String']['output'];
};

export type DataImportExecutePayload = {
  __typename?: 'DataImportExecutePayload';
  jobId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DataImportFinalizeHygienePayload = {
  __typename?: 'DataImportFinalizeHygienePayload';
  jobId: Scalars['String']['output'];
  matchedSideCount: Scalars['Int']['output'];
  skippedSideCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type DataImportForceCancelPayload = {
  __typename?: 'DataImportForceCancelPayload';
  cancelledAt: Scalars['Date']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type DataImportJob = {
  __typename?: 'DataImportJob';
  _id: Scalars['MongoID']['output'];
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledAtStage?: Maybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerCount?: Maybe<Scalars['Float']['output']>;
  deletedRows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  detectedColumns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  excludedRowNumbers?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  excludedRows?: Maybe<Scalars['Float']['output']>;
  hygiene?: Maybe<DataImportJobHygiene>;
  hygieneReviewBaseline?: Maybe<Array<Maybe<DataImportJobHygieneReviewBaseline>>>;
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Float']['output'];
  jobCount?: Maybe<Scalars['Float']['output']>;
  jobId: Scalars['String']['output'];
  jobImportedCount?: Maybe<Scalars['Float']['output']>;
  jobNotImportedCount?: Maybe<Scalars['Float']['output']>;
  notImported?: Maybe<Array<Maybe<DataImportJobNotImported>>>;
  notImportedCount: Scalars['Float']['output'];
  notImportedFilePath?: Maybe<Scalars['String']['output']>;
  parsedData?: Maybe<Scalars['JSON']['output']>;
  processedCount: Scalars['Float']['output'];
  rawFilePath?: Maybe<Scalars['String']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  skippedWarningRowNumbers?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  status: EnumDataImportJobStatus;
  successCount: Scalars['Float']['output'];
  suggestedMapping?: Maybe<Scalars['JSON']['output']>;
  tenantId: Scalars['MongoID']['output'];
  totalRows: Scalars['Float']['output'];
  type: EnumDataImportJobType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uploadedBy: Scalars['MongoID']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Float']['output'];
  validationErrors?: Maybe<Array<Maybe<DataImportJobValidationErrors>>>;
  vendorId: Scalars['MongoID']['output'];
};

export type DataImportJobHygiene = {
  __typename?: 'DataImportJobHygiene';
  actions: Array<Maybe<DataImportJobHygieneActions>>;
  canonicalIdentities: Array<Maybe<DataImportJobHygieneCanonicalIdentities>>;
  clusterAssignments: Array<Maybe<DataImportJobHygieneClusterAssignments>>;
  crossClusterFlags: Array<Maybe<DataImportJobHygieneCrossClusterFlags>>;
  malformedJobs?: Maybe<Array<Maybe<DataImportJobHygieneMalformedJobs>>>;
  normalizationSummary?: Maybe<DataImportJobHygieneNormalizationSummary>;
};

export type DataImportJobHygieneActions = {
  __typename?: 'DataImportJobHygieneActions';
  actionId: Scalars['String']['output'];
  actor: Scalars['String']['output'];
  at: Scalars['String']['output'];
  detail: Scalars['JSON']['output'];
  kind: EnumDataImportJobHygieneActionsKind;
};

export type DataImportJobHygieneActionsInput = {
  actionId: Scalars['String']['input'];
  actor: Scalars['String']['input'];
  at: Scalars['String']['input'];
  detail: Scalars['JSON']['input'];
  kind: EnumDataImportJobHygieneActionsKind;
};

export type DataImportJobHygieneCanonicalIdentities = {
  __typename?: 'DataImportJobHygieneCanonicalIdentities';
  canonical: DataImportJobHygieneCanonicalIdentitiesCanonical;
  clusterId: Scalars['String']['output'];
  crossRoleAttachToProducerCluster?: Maybe<Scalars['String']['output']>;
  derivation: Scalars['String']['output'];
  humanReason: Scalars['String']['output'];
  role: EnumDataImportJobHygieneCanonicalIdentitiesRole;
  sourceRows: Array<Maybe<Scalars['Float']['output']>>;
  status: EnumDataImportJobHygieneCanonicalIdentitiesStatus;
};

export type DataImportJobHygieneCanonicalIdentitiesCanonical = {
  __typename?: 'DataImportJobHygieneCanonicalIdentitiesCanonical';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isJoint?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type DataImportJobHygieneCanonicalIdentitiesInput = {
  canonical: DataImportJobHygieneCanonicalIdentitiesCanonicalInput;
  clusterId: Scalars['String']['input'];
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation: Scalars['String']['input'];
  humanReason: Scalars['String']['input'];
  role: EnumDataImportJobHygieneCanonicalIdentitiesRole;
  sourceRows: Array<InputMaybe<Scalars['Float']['input']>>;
  status: EnumDataImportJobHygieneCanonicalIdentitiesStatus;
};

export type DataImportJobHygieneClusterAssignments = {
  __typename?: 'DataImportJobHygieneClusterAssignments';
  clusterId: Scalars['String']['output'];
  rowIndex: Scalars['Float']['output'];
  side: EnumDataImportJobHygieneClusterAssignmentsSide;
};

export type DataImportJobHygieneClusterAssignmentsInput = {
  clusterId: Scalars['String']['input'];
  rowIndex: Scalars['Float']['input'];
  side: EnumDataImportJobHygieneClusterAssignmentsSide;
};

export type DataImportJobHygieneCrossClusterFlags = {
  __typename?: 'DataImportJobHygieneCrossClusterFlags';
  clusterIds: Array<Maybe<Scalars['String']['output']>>;
  derivation: Scalars['String']['output'];
  flagId: Scalars['String']['output'];
  humanReason: Scalars['String']['output'];
  rowIndices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  sharedValue?: Maybe<DataImportJobHygieneCrossClusterFlagsSharedValue>;
  status: EnumDataImportJobHygieneCrossClusterFlagsStatus;
  type: EnumDataImportJobHygieneCrossClusterFlagsType;
};

export type DataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds: Array<InputMaybe<Scalars['String']['input']>>;
  derivation: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  humanReason: Scalars['String']['input'];
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<DataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status: EnumDataImportJobHygieneCrossClusterFlagsStatus;
  type: EnumDataImportJobHygieneCrossClusterFlagsType;
};

export type DataImportJobHygieneCrossClusterFlagsSharedValue = {
  __typename?: 'DataImportJobHygieneCrossClusterFlagsSharedValue';
  field: EnumDataImportJobHygieneCrossClusterFlagsSharedValueField;
  value: Scalars['String']['output'];
};

export type DataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field: EnumDataImportJobHygieneCrossClusterFlagsSharedValueField;
  value: Scalars['String']['input'];
};

export type DataImportJobHygieneInput = {
  actions: Array<InputMaybe<DataImportJobHygieneActionsInput>>;
  canonicalIdentities: Array<InputMaybe<DataImportJobHygieneCanonicalIdentitiesInput>>;
  clusterAssignments: Array<InputMaybe<DataImportJobHygieneClusterAssignmentsInput>>;
  crossClusterFlags: Array<InputMaybe<DataImportJobHygieneCrossClusterFlagsInput>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<DataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<DataImportJobHygieneNormalizationSummaryInput>;
};

export type DataImportJobHygieneMalformedJobs = {
  __typename?: 'DataImportJobHygieneMalformedJobs';
  reasons: Array<Maybe<Scalars['String']['output']>>;
  rowIndex: Scalars['Float']['output'];
};

export type DataImportJobHygieneMalformedJobsInput = {
  reasons: Array<InputMaybe<Scalars['String']['input']>>;
  rowIndex: Scalars['Float']['input'];
};

export type DataImportJobHygieneNormalizationSummary = {
  __typename?: 'DataImportJobHygieneNormalizationSummary';
  diacriticsStripped: Scalars['Float']['output'];
  emailsLowercased: Scalars['Float']['output'];
  phonesNormalized: Scalars['Float']['output'];
  whitespaceTrimmed: Scalars['Float']['output'];
};

export type DataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped: Scalars['Float']['input'];
  emailsLowercased: Scalars['Float']['input'];
  phonesNormalized: Scalars['Float']['input'];
  whitespaceTrimmed: Scalars['Float']['input'];
};

export type DataImportJobHygieneReviewBaseline = {
  __typename?: 'DataImportJobHygieneReviewBaseline';
  buyer?: Maybe<DataImportJobHygieneCanonicalIdentitiesCanonical>;
  producer?: Maybe<DataImportJobHygieneCanonicalIdentitiesCanonical>;
  rowIndex: Scalars['Float']['output'];
};

export type DataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<DataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<DataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex: Scalars['Float']['input'];
};

export type DataImportJobItem = {
  __typename?: 'DataImportJobItem';
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customerCount?: Maybe<Scalars['Int']['output']>;
  distinctIdentityCount?: Maybe<Scalars['Int']['output']>;
  importedIdentityCount?: Maybe<Scalars['Int']['output']>;
  invalidRows?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  notImportedCount?: Maybe<Scalars['Int']['output']>;
  notImportedIdentityCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  successCount?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  validRows?: Maybe<Scalars['Int']['output']>;
};

export type DataImportJobNotImported = {
  __typename?: 'DataImportJobNotImported';
  data: Scalars['JSON']['output'];
  error: Scalars['String']['output'];
  row: Scalars['Float']['output'];
};

export type DataImportJobNotImportedInput = {
  data: Scalars['JSON']['input'];
  error: Scalars['String']['input'];
  row: Scalars['Float']['input'];
};

/** List of items with pagination. */
export type DataImportJobPagination = {
  __typename?: 'DataImportJobPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<DataImportJob>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type DataImportJobStatus = {
  __typename?: 'DataImportJobStatus';
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedRows: Array<Scalars['Int']['output']>;
  excludedRows: Scalars['Int']['output'];
  importedIdentityCount?: Maybe<Scalars['Int']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobCount?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  jobImportedCount?: Maybe<Scalars['Int']['output']>;
  jobNotImportedCount?: Maybe<Scalars['Int']['output']>;
  notImported: Array<DataImportNotImportedRow>;
  notImportedCount: Scalars['Int']['output'];
  notImportedIdentityCount?: Maybe<Scalars['Int']['output']>;
  processedCount: Scalars['Int']['output'];
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<DataImportCsvValidationError>;
};

export type DataImportJobValidationErrors = {
  __typename?: 'DataImportJobValidationErrors';
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  excludedMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  row: Scalars['Float']['output'];
  side?: Maybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row: Scalars['Float']['input'];
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DataImportJobsPayload = {
  __typename?: 'DataImportJobsPayload';
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<DataImportJobItem>;
  total: Scalars['Int']['output'];
};

export type DataImportNotImportedRow = {
  __typename?: 'DataImportNotImportedRow';
  error: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type DataImportResolveJobDuplicatePayload = {
  __typename?: 'DataImportResolveJobDuplicatePayload';
  action: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type DataImportRevalidatePayload = {
  __typename?: 'DataImportRevalidatePayload';
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<DataImportCsvValidationError>;
};

export type DataImportRevertToHygienePayload = {
  __typename?: 'DataImportRevertToHygienePayload';
  jobId: Scalars['String']['output'];
  snapshottedRows: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type DataImportRunHygienePayload = {
  __typename?: 'DataImportRunHygienePayload';
  clusterCount: Scalars['Int']['output'];
  flagCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  malformedClusterCount: Scalars['Int']['output'];
  needsReviewClusterCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type DataImportSaveColumnMappingPayload = {
  __typename?: 'DataImportSaveColumnMappingPayload';
  columns: Array<Scalars['String']['output']>;
  hygiene?: Maybe<Scalars['JSON']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  parsedData?: Maybe<Scalars['JSON']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<DataImportCsvValidationError>;
};

export type DataImportSaveHygieneActionPayload = {
  __typename?: 'DataImportSaveHygieneActionPayload';
  actionCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  needsReviewClusterCount: Scalars['Int']['output'];
  openFlagCount: Scalars['Int']['output'];
  /**
   * set-all-inspection-levels only: compatible job rows that already carried
   * the chosen level, so the write was a no-op on them. Split out from
   * rowsUnchanged because the two buckets need different words: these rows
   * are correctly configured, and calling them skipped-for-species tells CS
   * their processor setup is broken when it isn't.
   */
  rowsAlreadySet?: Maybe<Scalars['Int']['output']>;
  /**
   * set-all-inspection-levels only: how many job rows this write actually
   * CHANGED, as observed server-side. The client cannot derive this — its
   * compatibility preview is computed from a cached animal-settings payload
   * that can be stale or can change between the query and the write — so
   * reporting the prediction back to CS would be asserting a number no write
   * produced.
   */
  rowsChanged?: Maybe<Scalars['Int']['output']>;
  /**
   * set-all-inspection-levels only: active job rows whose species has no such
   * level configured (or no resolvable species at all).
   */
  rowsIncompatible?: Maybe<Scalars['Int']['output']>;
  /**
   * set-all-inspection-levels only: active job rows the write left alone,
   * for whatever reason. The sum of rowsAlreadySet and rowsIncompatible.
   */
  rowsUnchanged?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type DataImportSaveMatchDecisionPayload = {
  __typename?: 'DataImportSaveMatchDecisionPayload';
  action: Scalars['String']['output'];
  fieldsToApply?: Maybe<Array<Scalars['String']['output']>>;
  jobId: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  side: Scalars['String']['output'];
  targetUserId?: Maybe<Scalars['String']['output']>;
};

export type DataImportSessionPayload = {
  __typename?: 'DataImportSessionPayload';
  availableColumns?: Maybe<Array<DataImportAvailableColumn>>;
  columns?: Maybe<Array<Scalars['String']['output']>>;
  customerCount?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  detectedColumns?: Maybe<Array<Scalars['String']['output']>>;
  hygiene?: Maybe<Scalars['JSON']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  stage: Scalars['String']['output'];
  suggestedMapping?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors?: Maybe<Array<DataImportCsvValidationError>>;
  vendorId: Scalars['String']['output'];
};

export type DataImportUpdateRowsPayload = {
  __typename?: 'DataImportUpdateRowsPayload';
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  parsedData: Scalars['JSON']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<DataImportCsvValidationError>;
};

export type DataImportUploadPayload = {
  __typename?: 'DataImportUploadPayload';
  availableColumns: Array<DataImportAvailableColumn>;
  detectedColumns: Array<Scalars['String']['output']>;
  detectedType: Scalars['String']['output'];
  excludedRows: Scalars['Int']['output'];
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  suggestedMapping?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Int']['output'];
  validationErrors: Array<DataImportCsvValidationError>;
};

export enum DateAnchorEnumUpsert {
  CompletedDate = 'completedDate',
  CutDate = 'cutDate',
  DropoffDate = 'dropoffDate',
  KillDate = 'killDate'
}

export type DeleteDuplicatePrimalsPayload = {
  __typename?: 'DeleteDuplicatePrimalsPayload';
  duplicatesDeleted: Scalars['Int']['output'];
  duplicatesFound: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type DepositCheckStripeResponse = {
  __typename?: 'DepositCheckStripeResponse';
  found: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  scheduling?: Maybe<ProcessorScheduling>;
};

export type DepositCollectionInput = {
  method: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export enum DepositManualMethod {
  Cash = 'cash',
  Check = 'check'
}

export type DepositPaymentIntentResponse = {
  __typename?: 'DepositPaymentIntentResponse';
  clientSecret: Scalars['String']['output'];
  connectedAccountId: Scalars['String']['output'];
};

export type DepositSetupIntentResponse = {
  __typename?: 'DepositSetupIntentResponse';
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
};

export type Document = {
  __typename?: 'Document';
  _id: Scalars['MongoID']['output'];
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentVersion: Scalars['Float']['output'];
  fileSize: Scalars['Float']['output'];
  filename: Scalars['String']['output'];
  generator?: Maybe<EnumDocumentGenerator>;
  hash?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  linkSummaries?: Maybe<Array<Maybe<DocumentLinkSummary>>>;
  links?: Maybe<Array<Maybe<DocumentLinks>>>;
  mimeType: Scalars['String']['output'];
  renderHash?: Maybe<Scalars['String']['output']>;
  source: EnumDocumentSource;
  sourceRef?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uploadedBy?: Maybe<User>;
  /** Short-lived presigned GET URL for viewing/downloading the current version. */
  url?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['MongoID']['output'];
  versions: Array<Maybe<DocumentVersions>>;
};

export type DocumentAssignableEntity = {
  __typename?: 'DocumentAssignableEntity';
  id: Scalars['MongoID']['output'];
  label: Scalars['String']['output'];
  sublabel?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type DocumentCategoryPagination = {
  __typename?: 'DocumentCategoryPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<DocumentCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type DocumentFieldEntryInput = {
  column?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  fieldKey: Scalars['String']['input'];
  fieldSource: DocumentFieldSource;
  label: Scalars['String']['input'];
};

export enum DocumentFieldSource {
  Custom = 'custom',
  Standard = 'standard'
}

export type DocumentFolderEntry = {
  __typename?: 'DocumentFolderEntry';
  facet: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sublabel?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type DocumentFolderResult = {
  __typename?: 'DocumentFolderResult';
  facet?: Maybe<Scalars['String']['output']>;
  files: DocumentPagination;
  folders: Array<DocumentFolderEntry>;
};

export type DocumentLinkInput = {
  entityId: Scalars['MongoID']['input'];
  entityType: EnumDocumentEntityType;
};

export type DocumentLinkSummary = {
  __typename?: 'DocumentLinkSummary';
  entityId?: Maybe<Scalars['MongoID']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sublabel?: Maybe<Scalars['String']['output']>;
};

export type DocumentLinks = {
  __typename?: 'DocumentLinks';
  entityId: Scalars['MongoID']['output'];
  entityType: EnumDocumentLinksEntityType;
};

/** List of items with pagination. */
export type DocumentPagination = {
  __typename?: 'DocumentPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Document>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type DocumentSettingsInput = {
  calendarTooltip?: InputMaybe<CalendarTooltipDocumentSettingsInput>;
  carcassTag?: InputMaybe<CarcassTagsDocumentSettingsInput>;
  cutsheet?: InputMaybe<CutsheetDocumentSettingsInput>;
  cutsheetHeader?: InputMaybe<CutsheetHeaderDocumentSettingsInput>;
  killSheet?: InputMaybe<KillSheetDocumentSettingsInput>;
};

export type DocumentVersions = {
  __typename?: 'DocumentVersions';
  createdAt: Scalars['Date']['output'];
  fileSize: Scalars['Float']['output'];
  filename: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  isGenerated: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  renderHash?: Maybe<Scalars['String']['output']>;
  uploadedBy?: Maybe<Scalars['MongoID']['output']>;
  version: Scalars['Float']['output'];
};

export type EmailPreviewResult = {
  __typename?: 'EmailPreviewResult';
  html: Scalars['String']['output'];
};

export enum EnumAddressLocationType {
  Point = 'Point'
}

export enum EnumAddressType {
  Commercial = 'commercial',
  Residential = 'residential',
  Unknown = 'unknown'
}

export enum EnumAnimalClaimMode {
  Direct = 'direct',
  Request = 'request'
}

export enum EnumAnimalInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumAnimalListedBy {
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumAnimalSizeTier {
  L = 'l',
  M = 'm',
  S = 's',
  Xl = 'xl',
  Xs = 'xs'
}

export enum EnumCsvImportJobCancelledAtStage {
  ColumnMapping = 'column_mapping',
  DataReview = 'data_review'
}

export enum EnumCsvImportJobStatus {
  AwaitingMapping = 'awaiting_mapping',
  AwaitingReview = 'awaiting_review',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing'
}

export enum EnumCsvImportJobType {
  Animals = 'animals',
  Customers = 'customers',
  Jobs = 'jobs'
}

export enum EnumCustomFieldDefinitionCaptureAt {
  Booking = 'booking',
  Cut = 'cut',
  Dropoff = 'dropoff',
  Slaughter = 'slaughter'
}

export enum EnumCustomFieldDefinitionFieldSource {
  Custom = 'custom',
  Standard = 'standard'
}

export enum EnumCustomFieldDefinitionFieldType {
  Date = 'date',
  HangingWeight = 'hanging_weight',
  MultiSelect = 'multi_select',
  Number = 'number',
  SingleSelect = 'single_select',
  Text = 'text',
  Toggle = 'toggle'
}

export enum EnumCustomFieldDefinitionModelType {
  Head = 'head',
  Job = 'job',
  Split = 'split'
}

export enum EnumCustomFieldValueRecordType {
  Head = 'head',
  Job = 'job',
  Split = 'split'
}

export enum EnumCutsheetAnimalSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumCutsheetAnimalType {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumCutsheetAssignmentRuleSetRulesInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetAssignmentRuleSetRulesSplitType {
  Half = 'half',
  HalfAndTwoQuarters = 'half_and_two_quarters',
  Quarters = 'quarters',
  Whole = 'whole'
}

export enum EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetCapabilityOptionOptionType {
  Cut = 'cut',
  Extra = 'extra',
  Trim = 'trim'
}

export enum EnumCutsheetCapabilityOptionPricingModel {
  FixedPrice = 'fixed_price',
  PerHangingWeight = 'per_hanging_weight',
  PerItem = 'per_item',
  PerPound = 'per_pound'
}

export enum EnumCutsheetCapabilityOptionSpecificationsType {
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum EnumCutsheetCapabilityPrintSettingsCheckboxStyle {
  Check = 'check',
  Cross = 'cross',
  Fill = 'fill'
}

export enum EnumCutsheetCapabilityPrintSettingsOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export enum EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum EnumCutsheetCapabilitySpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumCutsheetCapabilitySpecificationInputType {
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum EnumCutsheetExtrasType {
  FlatFee = 'flatFee',
  PricedPerPound = 'pricedPerPound'
}

export enum EnumCutsheetInspectionLevels {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetQuestionnaireAdditionalChargesBasis {
  PerAnimal = 'per_animal',
  PerSplit = 'per_split'
}

export enum EnumCutsheetQuestionnaireAdditionalChargesPriceType {
  Fixed = 'fixed',
  PerLbHanging = 'per_lb_hanging',
  PerLbLive = 'per_lb_live'
}

export enum EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType {
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType {
  Ranked = 'ranked',
  SelectionByPercentage = 'selection_by_percentage'
}

export enum EnumCutsheetQuestionnairePrintSettingsCheckboxStyle {
  Check = 'check',
  Cross = 'cross',
  Fill = 'fill'
}

export enum EnumCutsheetQuestionnairePrintSettingsOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export enum EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum EnumCutsheetQuestionnaireProcessingFeeBasis {
  PerAnimal = 'per_animal',
  PerSplit = 'per_split'
}

export enum EnumCutsheetQuestionnaireProcessingFeePriceType {
  Fixed = 'fixed',
  PerLbHanging = 'per_lb_hanging',
  PerLbLive = 'per_lb_live'
}

export enum EnumCutsheetQuestionnaireQuestionsType {
  ChoiceGroup = 'choice_group',
  ExtrasSelection = 'extras_selection',
  FreeSelection = 'free_selection',
  GlobalSpec = 'global_spec',
  InfoSlide = 'info_slide',
  TrimPercentage = 'trim_percentage',
  TrimRanking = 'trim_ranking'
}

export enum EnumCutsheetQuestionnaireResponseType {
  Orphan = 'orphan',
  User = 'user',
  Vendor = 'vendor'
}

export enum EnumCutsheetQuestionnaireStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published'
}

export enum EnumCutsheetTrimTrimSelection {
  AllowSelectionByPercentage = 'allowSelectionByPercentage',
  AllowSelectionByWeight = 'allowSelectionByWeight'
}

export enum EnumCutsheetType {
  Orphan = 'orphan',
  User = 'user',
  Vendor = 'vendor'
}

export enum EnumDailyCapacityCapacitiesByTypeType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export enum EnumDataImportJobCancelledAtStage {
  ColumnMapping = 'column_mapping',
  DataHygiene = 'data_hygiene',
  DataReview = 'data_review',
  ForceCancel = 'force_cancel'
}

export enum EnumDataImportJobHygieneActionsKind {
  AcceptMerge = 'accept_merge',
  AssignProducer = 'assign_producer',
  DismissFlag = 'dismiss_flag',
  EditCanonical = 'edit_canonical',
  EditJob = 'edit_job',
  KeepJobsOnRows = 'keep_jobs_on_rows',
  MarkCrossRoleSamePerson = 'mark_cross_role_same_person',
  MarkSamePerson = 'mark_same_person',
  MergeClusters = 'merge_clusters',
  MoveRowToAnother = 'move_row_to_another',
  ResolveFlag = 'resolve_flag',
  ResolveUniqueness = 'resolve_uniqueness',
  RestoreCluster = 'restore_cluster',
  RestoreJob = 'restore_job',
  SetAllInspectionLevels = 'set_all_inspection_levels',
  SkipCluster = 'skip_cluster',
  SkipJobsOnRows = 'skip_jobs_on_rows',
  SplitCluster = 'split_cluster',
  SplitJoint = 'split_joint',
  Undo = 'undo',
  UndoMerge = 'undo_merge'
}

export enum EnumDataImportJobHygieneCanonicalIdentitiesRole {
  Buyer = 'buyer',
  Producer = 'producer'
}

export enum EnumDataImportJobHygieneCanonicalIdentitiesStatus {
  Confirmed = 'confirmed',
  Malformed = 'malformed',
  NeedsReview = 'needsReview',
  Skipped = 'skipped'
}

export enum EnumDataImportJobHygieneClusterAssignmentsSide {
  Buyer = 'buyer',
  Producer = 'producer'
}

export enum EnumDataImportJobHygieneCrossClusterFlagsSharedValueField {
  Email = 'email',
  Phone = 'phone'
}

export enum EnumDataImportJobHygieneCrossClusterFlagsStatus {
  Dismissed = 'dismissed',
  Open = 'open',
  Resolved = 'resolved'
}

export enum EnumDataImportJobHygieneCrossClusterFlagsType {
  CrossRoleIdentity = 'cross_role_identity',
  FuzzyCluster = 'fuzzy_cluster',
  JobRowDuplicate = 'job_row_duplicate',
  JointIdentity = 'joint_identity',
  MidFileUpdate = 'mid_file_update',
  SelfReferential = 'self_referential',
  TaggedVariant = 'tagged_variant',
  UniquenessConflict = 'uniqueness_conflict'
}

export enum EnumDataImportJobStatus {
  AwaitingHygiene = 'awaiting_hygiene',
  AwaitingMapping = 'awaiting_mapping',
  AwaitingReview = 'awaiting_review',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing'
}

export enum EnumDataImportJobType {
  Customers = 'customers',
  Jobs = 'jobs'
}

export enum EnumDataImportJobValidationErrorsSide {
  Buyer = 'buyer',
  Producer = 'producer'
}

export enum EnumDocumentEntityType {
  Customer = 'customer',
  Job = 'job'
}

export enum EnumDocumentGenerator {
  CarcassTags = 'carcass_tags',
  Cutsheet = 'cutsheet',
  Invoice = 'invoice',
  PackingSlip = 'packing_slip'
}

export enum EnumDocumentLinksEntityType {
  Customer = 'customer',
  Job = 'job'
}

export enum EnumDocumentSearchSort {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

export enum EnumDocumentSource {
  Email = 'email',
  Generated = 'generated',
  Uploaded = 'uploaded'
}

export enum EnumExportPresetScheduleFrequency {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum EnumExportPresetScheduleLastRunStatus {
  Failed = 'failed',
  Ok = 'ok',
  Running = 'running'
}

export enum EnumExportPresetSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum EnumFinancialMetricsActualsSpeciesActualsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumFinancialReportingConfigAnimalConfigurationsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumFinancialReportingConfigDateAnchor {
  CompletedDate = 'completedDate',
  CutDate = 'cutDate',
  DropoffDate = 'dropoffDate',
  KillDate = 'killDate'
}

export enum EnumFinancialReportingConfigOverheadCostsFrequency {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}

export enum EnumIntegrationDeliveryAttemptOutcome {
  Delivered = 'delivered',
  Failed = 'failed',
  Retrying = 'retrying',
  Skipped = 'skipped'
}

export enum EnumIntegrationDeliveryStatus {
  Delivered = 'delivered',
  Failed = 'failed',
  Pending = 'pending',
  Retrying = 'retrying',
  Skipped = 'skipped',
  Superseded = 'superseded'
}

export enum EnumIntegrationDeliverySubjectType {
  Invoice = 'invoice',
  Job = 'job'
}

export enum EnumIntegrationInboundRecordKind {
  HangingWeight = 'hanging_weight',
  LiveWeight = 'live_weight',
  PackedWeight = 'packed_weight'
}

export enum EnumIntegrationInboundRecordStatus {
  Applied = 'applied',
  Dismissed = 'dismissed',
  Error = 'error',
  Matched = 'matched',
  Unmatched = 'unmatched'
}

export enum EnumIntegrationInboundWeightMode {
  Auto = 'auto',
  Review = 'review'
}

export enum EnumIntegrationName {
  Partner = 'partner',
  QuickbooksOnline = 'quickbooks_online',
  Sendgrid = 'sendgrid',
  Stripe = 'stripe'
}

export enum EnumIntegrationSubscribedEvents {
  InvoiceCreated = 'invoice_created',
  InvoicePaid = 'invoice_paid',
  InvoiceUpdated = 'invoice_updated',
  InvoiceVoided = 'invoice_voided',
  JobCreated = 'job_created',
  JobUpdated = 'job_updated'
}

export enum EnumIntegrationType {
  Api = 'api'
}

export enum EnumInvoiceDiscountsType {
  Coupon = 'coupon',
  FixedAmount = 'fixed_amount',
  Percentage = 'percentage'
}

export enum EnumInvoiceLineItemLinksEntityType {
  Cutsheet = 'Cutsheet',
  ProcessorSchedulingAnimalHead = 'ProcessorSchedulingAnimalHead'
}

export enum EnumInvoiceLinksEntityType {
  Cutsheet = 'Cutsheet',
  ProcessorScheduling = 'ProcessorScheduling',
  ProcessorSchedulingAnimalHead = 'ProcessorSchedulingAnimalHead',
  ProcessorSchedulingAnimalHeadSplit = 'ProcessorSchedulingAnimalHeadSplit'
}

export enum EnumInvoiceSettlement_Method {
  Cash = 'cash',
  Check = 'check',
  Manual = 'manual',
  Stripe = 'stripe'
}

export enum EnumInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceStatus_ChangesNew_Status {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceStatus_ChangesPrevious_Status {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceType {
  PartnersShipmentsMonthly = 'partners_shipments_monthly',
  ProcessingFees = 'processing_fees',
  ProcessorSchedulingDeposit = 'processor_scheduling_deposit',
  ProcessorSchedulingInvoice = 'processor_scheduling_invoice'
}

export enum EnumJobTagSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumLandingPageSettingsLocationType {
  Point = 'Point'
}

export enum EnumLandingPageSettingsPremierProducersBadge {
  FeaturedFarm = 'featured_farm',
  InHouse = 'in_house',
  PartnerFarm = 'partner_farm',
  Recommended = 'recommended'
}

export enum EnumLandingPageSettingsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumMarketplaceInterestSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumMarketplaceLeadLocationType {
  Point = 'Point'
}

export enum EnumMarketplaceLeadQuantity {
  Half = 'half',
  Quarter = 'quarter',
  Unsure = 'unsure',
  Whole = 'whole'
}

export enum EnumMarketplaceLeadSource {
  MarketplaceHome = 'marketplace_home',
  MarketplaceSearch = 'marketplace_search'
}

export enum EnumMarketplaceLeadSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Other = 'other',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumMarketplaceLeadTimeline {
  A_1_3Months = 'a_1_3_months',
  A_3_6Months = 'a_3_6_months',
  Exploring = 'exploring',
  Within_1Month = 'within_1_month'
}

export enum EnumMarketplaceRequestSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumMarketplaceRequestSplitType {
  Half = 'half',
  Quarter = 'quarter',
  Whole = 'whole'
}

export enum EnumNoteType {
  ProcessorScheduling = 'processor_scheduling',
  User = 'user'
}

export enum EnumNotificationChannel {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationNotificationType {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationSettingPreferredChannel {
  Both = 'both',
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationSettingTimingsRelation {
  After = 'after',
  At = 'at',
  Before = 'before'
}

export enum EnumNotificationStatusEmail {
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export enum EnumNotificationStatusSms {
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export enum EnumNotificationTemplateChannel {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationTemplateType {
  Custom = 'custom',
  System = 'system'
}

export enum EnumParentProductStock_Status {
  Instock = 'instock',
  Onbackorder = 'onbackorder',
  Outofstock = 'outofstock'
}

export enum EnumParentProductType {
  ProcessorDeposit = 'processor_deposit'
}

export enum EnumPickupLocationLocationType {
  Point = 'Point'
}

export enum EnumPrimalCutType {
  Chop = 'chop',
  Other = 'other',
  Rib = 'rib',
  Roast = 'roast',
  Steak = 'steak'
}

export enum EnumPrimalCutTypeAnimalSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumPrimalCutTypeLid {
  Chop = 'chop',
  Other = 'other',
  Rib = 'rib',
  Roast = 'roast',
  Steak = 'steak'
}

export enum EnumPrimalGroupAnimalSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumPrimalGroupInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorCapabilityAnimalSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorCapabilityExtrasType {
  FlatFee = 'flatFee',
  PricedPerPound = 'pricedPerPound'
}

export enum EnumProcessorCapabilityInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit {
  Inches = 'inches',
  None = 'none',
  Pounds = 'pounds'
}

export enum EnumProcessorCapabilityTrimSelection {
  AllowSelectionByPercentage = 'allowSelectionByPercentage',
  AllowSelectionByWeight = 'allowSelectionByWeight'
}

export enum EnumProcessorNotificationType {
  CutsheetConfirmation = 'cutsheetConfirmation',
  DepositPaidProcessor = 'depositPaidProcessor',
  MarketplaceRequestReceived = 'marketplaceRequestReceived',
  NewJob = 'newJob',
  PlacementExpired = 'placementExpired',
  QuickbooksReconnect = 'quickbooksReconnect',
  WaitlistJoin = 'waitlistJoin',
  WeeklyProcessorSummary = 'weeklyProcessorSummary'
}

export enum EnumProcessorSchedulingAnimalHeadsInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorSchedulingAnimalSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSchedulingAnimalType {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumProcessorSchedulingCustomerConfirmationHistoryStatus {
  Cleared = 'cleared',
  Confirmed = 'confirmed',
  Declined = 'declined'
}

export enum EnumProcessorSchedulingCustomerConfirmationHistoryVia {
  Chat = 'chat',
  Email = 'email',
  InApp = 'in_app',
  JobPage = 'job_page',
  Processor = 'processor',
  Reschedule = 'reschedule',
  Sms = 'sms'
}

export enum EnumProcessorSchedulingCustomerConfirmationStatus {
  Confirmed = 'confirmed',
  Declined = 'declined'
}

export enum EnumProcessorSchedulingCustomerConfirmationVia {
  Chat = 'chat',
  Email = 'email',
  InApp = 'in_app',
  JobPage = 'job_page',
  Processor = 'processor',
  Reschedule = 'reschedule',
  Sms = 'sms'
}

export enum EnumProcessorSchedulingDepositMethod {
  Card = 'card',
  CardOnFile = 'card_on_file',
  Cash = 'cash',
  Check = 'check',
  None = 'none',
  Notification = 'notification'
}

export enum EnumProcessorSchedulingDepositStatus {
  Failed = 'failed',
  Paid = 'paid',
  Pending = 'pending'
}

export enum EnumProcessorSchedulingInvoicesPricingType {
  CustomCutsheet = 'customCutsheet',
  KillAndChill = 'killAndChill',
  Killslot = 'killslot'
}

export enum EnumProcessorSchedulingSource {
  BulkUpload = 'bulk_upload',
  Farmshare = 'farmshare',
  Integration = 'integration',
  Processor = 'processor',
  Producer = 'producer',
  Recurring = 'recurring',
  Waitlist = 'waitlist'
}

export enum EnumProcessorSchedulingStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  MissedDropOff = 'Missed_Drop_Off',
  PendingDeposit = 'Pending_Deposit',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSchedulingStatusChangesNewStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  MissedDropOff = 'Missed_Drop_Off',
  PendingDeposit = 'Pending_Deposit',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSchedulingStatusChangesPreviousStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  MissedDropOff = 'Missed_Drop_Off',
  PendingDeposit = 'Pending_Deposit',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsAnimalSettingsInspectionLevels {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorSettingsAnimalSettingsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsAnimals {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumProcessorSettingsAutoSchedulingSettingsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsCapacityConfigurationType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export enum EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource {
  Custom = 'custom',
  Standard = 'standard'
}

export enum EnumProcessorSettingsDocumentSettingsCarcassTagTitle {
  EarTag = 'ear_tag',
  TrackingNumber = 'tracking_number'
}

export enum EnumProcessorSettingsDocumentSettingsCutsheetFormat {
  Bold = 'bold',
  Classic = 'classic'
}

export enum EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia {
  Logo = 'logo',
  Qr = 'qr'
}

export enum EnumProcessorSettingsHangTimeSettingsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsInvoicingDefaultSplitRule {
  Single = 'single',
  Split = 'split'
}

export enum EnumProcessorSettingsKillAndChillSettingsSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProductStock_Status {
  Instock = 'instock',
  Onbackorder = 'onbackorder',
  Outofstock = 'outofstock'
}

export enum EnumProductType {
  ProcessorDeposit = 'processor_deposit'
}

export enum EnumRecurringSeriesJobTemplateAnimalHeadsInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumRecurringSeriesJobTemplateAnimalSpecies {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumRecurringSeriesRuleByDayDay {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export enum EnumRecurringSeriesRuleFreq {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumSplitCutsheetChangesSource {
  Catalog = 'catalog',
  New = 'new'
}

export enum EnumSplitCutsheetSource {
  Catalog = 'catalog',
  New = 'new'
}

export enum EnumSplitKind {
  Game = 'game',
  Livestock = 'livestock'
}

export enum EnumSplitLastNudgeKind {
  Cutsheet = 'cutsheet',
  Deposit = 'deposit'
}

export enum EnumSplitPlacedBy {
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumSplitProgress {
  Collected = 'collected',
  Invoicing = 'invoicing',
  Ready = 'ready'
}

export enum EnumSplitStatus {
  Claimed = 'claimed',
  Confirmed = 'confirmed',
  Open = 'open',
  Requested = 'requested'
}

export enum EnumUserAuth_Method {
  GoogleSso = 'google_sso',
  Otp = 'otp',
  Password = 'password'
}

export enum EnumUserRelationshipsSource {
  BulkUpload = 'bulk_upload',
  GameDropoff = 'game_dropoff',
  Integration = 'integration',
  LandingPage = 'landing_page',
  Processor = 'processor'
}

export enum EnumUserRelationshipsType {
  Buyer = 'buyer',
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumUserRole {
  Admin = 'admin',
  Basic = 'basic',
  Vendor = 'vendor',
  VendorOwner = 'vendor_owner',
  VendorReadonly = 'vendor_readonly'
}

export enum EnumUserStatus {
  Complete = 'complete',
  MissingData = 'missing_data',
  PartiallyComplete = 'partially_complete'
}

export enum EnumUserType {
  Buyer = 'buyer',
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumVendorTwilioPhoneConfigPhoneNumberStatus {
  Active = 'active',
  CarrierProcessing = 'carrier_processing',
  Failed = 'failed',
  None = 'none',
  PendingLoa = 'pending_loa',
  PendingVerification = 'pending_verification',
  Provisioning = 'provisioning',
  Testing = 'testing'
}

export enum EnumVendorTwilioPhoneConfigPhoneNumberType {
  HostedLandline = 'hosted_landline',
  TwilioProvisioned = 'twilio_provisioned'
}

export enum EnumWaitlistAnimal {
  Alligator = 'alligator',
  Antelope = 'antelope',
  Bear = 'bear',
  Beef = 'beef',
  Bison = 'bison',
  Elk = 'elk',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Moose = 'moose',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumWaitlistInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumWaitlistStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type ExportColumnInput = {
  key: Scalars['String']['input'];
  /** Header to write instead of `key`. Defaults to `key`. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ExportFilterInput = {
  key: Scalars['String']['input'];
  /** One of eq, neq, contains, notContains, gt, gte, lt, lte, blank, notBlank. */
  operator: Scalars['String']['input'];
  /** What to compare to. Unused by `blank` and `notBlank`. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ExportPreset = {
  __typename?: 'ExportPreset';
  _id: Scalars['MongoID']['output'];
  anchorDate?: Maybe<Scalars['String']['output']>;
  animalSpecies?: Maybe<Scalars['String']['output']>;
  columns?: Maybe<Array<Maybe<ExportPresetColumns>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  customEnd?: Maybe<Scalars['String']['output']>;
  customStart?: Maybe<Scalars['String']['output']>;
  datePreset?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  filterMode?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<ExportPresetFilters>>>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  schedule?: Maybe<ExportPresetSchedule>;
  sort?: Maybe<Array<Maybe<ExportPresetSort>>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type ExportPresetColumns = {
  __typename?: 'ExportPresetColumns';
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type ExportPresetColumnsInput = {
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ExportPresetFilters = {
  __typename?: 'ExportPresetFilters';
  key: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ExportPresetFiltersInput = {
  key: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type ExportPresetPagination = {
  __typename?: 'ExportPresetPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ExportPreset>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ExportPresetSchedule = {
  __typename?: 'ExportPresetSchedule';
  dayOfMonth?: Maybe<Scalars['Float']['output']>;
  dayOfWeek?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  frequency?: Maybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: Maybe<Scalars['Float']['output']>;
  lastRunAt?: Maybe<Scalars['Date']['output']>;
  lastRunError?: Maybe<Scalars['String']['output']>;
  lastRunRowCount?: Maybe<Scalars['Float']['output']>;
  lastRunStatus?: Maybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: Maybe<Scalars['Date']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExportPresetSort = {
  __typename?: 'ExportPresetSort';
  direction?: Maybe<EnumExportPresetSortDirection>;
  key: Scalars['String']['output'];
};

export type ExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key: Scalars['String']['input'];
};

export type ExportSetting = {
  __typename?: 'ExportSetting';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  quickbooksDesktop?: Maybe<ExportSettingQuickbooksDesktop>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type ExportSettingPagination = {
  __typename?: 'ExportSettingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ExportSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ExportSettingQuickbooksDesktop = {
  __typename?: 'ExportSettingQuickbooksDesktop';
  adjustmentAccount?: Maybe<Scalars['String']['output']>;
  arAccount?: Maybe<Scalars['String']['output']>;
  defaultItem?: Maybe<Scalars['String']['output']>;
  depositAccount?: Maybe<Scalars['String']['output']>;
  discountAccount?: Maybe<Scalars['String']['output']>;
  incomeAccount?: Maybe<Scalars['String']['output']>;
};

export type ExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type ExportSortInput = {
  /** `asc` (default) or `desc`. */
  direction?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type FilterCountAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterCountAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterCountAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterCountCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterCountCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterCountCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterCountCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterCountCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterCountCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterCountCsvImportJobJobIdOperatorsInput>;
  producerId?: InputMaybe<FilterCountCsvImportJobProducerIdOperatorsInput>;
  status?: InputMaybe<FilterCountCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterCountCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterCountCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterCountCsvImportJobVendorIdOperatorsInput>;
};

export type FilterCountCsvImportJobProducerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterCountCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCalendarEventDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCalendarEventEventTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCalendarEventInput = {
  AND?: InputMaybe<Array<FilterCountCalendarEventInput>>;
  OR?: InputMaybe<Array<FilterCountCalendarEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCalendarEventOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCalendarEventOperatorsInput = {
  _id?: InputMaybe<FilterCountCalendarEvent_IdOperatorsInput>;
  date?: InputMaybe<FilterCountCalendarEventDateOperatorsInput>;
  eventType?: InputMaybe<FilterCountCalendarEventEventTypeOperatorsInput>;
  vendor?: InputMaybe<FilterCountCalendarEventVendorOperatorsInput>;
};

export type FilterCountCalendarEventTypeInput = {
  AND?: InputMaybe<Array<FilterCountCalendarEventTypeInput>>;
  OR?: InputMaybe<Array<FilterCountCalendarEventTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCalendarEventTypeOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCalendarEventTypeOperatorsInput = {
  _id?: InputMaybe<FilterCountCalendarEventType_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountCalendarEventTypeVendorOperatorsInput>;
};

export type FilterCountCalendarEventTypeVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCalendarEventType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCalendarEventVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCalendarEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterCountCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterCountCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterCountCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterCountCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterCountCancellationReasonIndexOperatorsInput>;
};

export type FilterCountCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCustomFieldDefinitionInput = {
  AND?: InputMaybe<Array<FilterCountCustomFieldDefinitionInput>>;
  OR?: InputMaybe<Array<FilterCountCustomFieldDefinitionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCustomFieldDefinitionOperatorsInput>;
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCustomFieldDefinitionOperatorsInput = {
  _id?: InputMaybe<FilterCountCustomFieldDefinition_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountCustomFieldDefinitionVendorOperatorsInput>;
};

export type FilterCountCustomFieldDefinitionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCustomFieldDefinition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCustomFieldValueDefinitionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCustomFieldValueInput = {
  AND?: InputMaybe<Array<FilterCountCustomFieldValueInput>>;
  OR?: InputMaybe<Array<FilterCountCustomFieldValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCustomFieldValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCustomFieldValueOperatorsInput = {
  _id?: InputMaybe<FilterCountCustomFieldValue_IdOperatorsInput>;
  definition?: InputMaybe<FilterCountCustomFieldValueDefinitionOperatorsInput>;
  recordId?: InputMaybe<FilterCountCustomFieldValueRecordIdOperatorsInput>;
};

export type FilterCountCustomFieldValueRecordIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountCustomFieldValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterCountCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterCountCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterCountCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterCountCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<FilterCountCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterCountCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterCountCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterCountCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterCountCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetDescriptionLibraryInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetDescriptionLibraryInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetDescriptionLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetDescriptionLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetDescriptionLibraryOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetDescriptionLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterCountCutsheetDescriptionLibraryTagsOperatorsInput>;
};

export type FilterCountCutsheetDescriptionLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountCutsheetDescriptionLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterCountCutsheetImageLibraryInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetImageLibraryInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetImageLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetImageLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetImageLibraryOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetImageLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterCountCutsheetImageLibraryTagsOperatorsInput>;
};

export type FilterCountCutsheetImageLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountCutsheetImageLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterCountCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheet_IdOperatorsInput>;
};

export type FilterCountCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type FilterCountCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterCountCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetQuestionnaireOperatorsInput>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<FilterCountCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterCountCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<FilterCountCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterCountCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterCountCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type FilterCountCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type FilterCountCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterCountCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireResponsePrimalNotesInput>>>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  sourceDocument?: InputMaybe<FilterCountCutsheetQuestionnaireResponseSourceDocumentInput>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  timeToComplete?: InputMaybe<Scalars['Float']['input']>;
  trimSectionNotes?: InputMaybe<Scalars['String']['input']>;
  trimSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterCountCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterCountCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterCountCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterCountCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterCountCutsheetQuestionnaireResponsePrimalNotesInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseSourceDocumentAnnotationsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseSourceDocumentInput = {
  annotations?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireResponseSourceDocumentAnnotationsInput>>>;
  pages?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireResponseSourceDocumentPagesInput>>>;
};

export type FilterCountCutsheetQuestionnaireResponseSourceDocumentPagesInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterCountCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterCountCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterCountDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountDataImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type FilterCountDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<FilterCountDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type FilterCountDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type FilterCountDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<FilterCountDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type FilterCountDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<FilterCountDataImportJobHygieneNormalizationSummaryInput>;
};

export type FilterCountDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<FilterCountDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<FilterCountDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountDataImportJobInput = {
  AND?: InputMaybe<Array<FilterCountDataImportJobInput>>;
  OR?: InputMaybe<Array<FilterCountDataImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDataImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<FilterCountDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterCountDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountDataImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDataImportJobOperatorsInput = {
  _id?: InputMaybe<FilterCountDataImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountDataImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterCountDataImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterCountDataImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterCountDataImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterCountDataImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterCountDataImportJobVendorIdOperatorsInput>;
};

export type FilterCountDataImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumDataImportJobStatus>;
  gte?: InputMaybe<EnumDataImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
  lt?: InputMaybe<EnumDataImportJobStatus>;
  lte?: InputMaybe<EnumDataImportJobStatus>;
  ne?: InputMaybe<EnumDataImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
};

export type FilterCountDataImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDataImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountDataImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDataImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDocumentCategoryInput = {
  AND?: InputMaybe<Array<FilterCountDocumentCategoryInput>>;
  OR?: InputMaybe<Array<FilterCountDocumentCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDocumentCategoryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDocumentCategoryOperatorsInput = {
  _id?: InputMaybe<FilterCountDocumentCategory_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountDocumentCategoryVendorOperatorsInput>;
};

export type FilterCountDocumentCategoryVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDocumentCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDocumentInput = {
  AND?: InputMaybe<Array<FilterCountDocumentInput>>;
  OR?: InputMaybe<Array<FilterCountDocumentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDocumentOperatorsInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currentVersion?: InputMaybe<Scalars['Float']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generator?: InputMaybe<EnumDocumentGenerator>;
  hash?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterCountDocumentLinksInput>>>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  renderHash?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EnumDocumentSource>;
  sourceRef?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  versions?: InputMaybe<Array<InputMaybe<FilterCountDocumentVersionsInput>>>;
};

export type FilterCountDocumentLinksInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  entityType?: InputMaybe<EnumDocumentLinksEntityType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDocumentOperatorsInput = {
  _id?: InputMaybe<FilterCountDocument_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountDocumentVendorOperatorsInput>;
};

export type FilterCountDocumentVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDocumentVersionsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  isGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  renderHash?: InputMaybe<Scalars['String']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountDocument_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountExportPresetInput = {
  AND?: InputMaybe<Array<FilterCountExportPresetInput>>;
  OR?: InputMaybe<Array<FilterCountExportPresetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountExportPresetOperatorsInput>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterCountExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<FilterCountExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<FilterCountExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<FilterCountExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountExportPresetOperatorsInput = {
  _id?: InputMaybe<FilterCountExportPreset_IdOperatorsInput>;
  schedule?: InputMaybe<FilterCountExportPresetScheduleOperatorsInput>;
  vendor?: InputMaybe<FilterCountExportPresetVendorOperatorsInput>;
};

export type FilterCountExportPresetScheduleEnabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountExportPresetScheduleOperatorsInput = {
  enabled?: InputMaybe<FilterCountExportPresetScheduleEnabledOperatorsInput>;
};

export type FilterCountExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountExportPresetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountExportPreset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountExportSettingInput = {
  AND?: InputMaybe<Array<FilterCountExportSettingInput>>;
  OR?: InputMaybe<Array<FilterCountExportSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountExportSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<FilterCountExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountExportSettingOperatorsInput = {
  _id?: InputMaybe<FilterCountExportSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountExportSettingVendorOperatorsInput>;
};

export type FilterCountExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountExportSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountExportSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFinancialMetricsActualsInput = {
  AND?: InputMaybe<Array<FilterCountFinancialMetricsActualsInput>>;
  OR?: InputMaybe<Array<FilterCountFinancialMetricsActualsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFinancialMetricsActualsOperatorsInput>;
  costOfGoodsSold?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  overhead?: InputMaybe<Scalars['Float']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  speciesActuals?: InputMaybe<Array<InputMaybe<FilterCountFinancialMetricsActualsSpeciesActualsInput>>>;
  totalHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFinancialMetricsActualsOperatorsInput = {
  _id?: InputMaybe<FilterCountFinancialMetricsActuals_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountFinancialMetricsActualsVendorOperatorsInput>;
};

export type FilterCountFinancialMetricsActualsSpeciesActualsInput = {
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialMetricsActualsSpeciesActualsSpecies>;
};

export type FilterCountFinancialMetricsActualsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFinancialMetricsActuals_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterCountFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterCountFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterCountFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterCountFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterCountFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterCountFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterCountFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterCountFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterCountFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterCountFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationDeliveryAttemptCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountIntegrationDeliveryAttemptDeliveryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationDeliveryAttemptExchangesInput = {
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
  responseBody?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Float']['input']>;
  truncated?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountIntegrationDeliveryAttemptInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationDeliveryAttemptInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationDeliveryAttemptInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationDeliveryAttemptOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['Date']['input']>;
  attempt?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  delivery?: InputMaybe<Scalars['MongoID']['input']>;
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exchanges?: InputMaybe<Array<InputMaybe<FilterCountIntegrationDeliveryAttemptExchangesInput>>>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  outcome?: InputMaybe<EnumIntegrationDeliveryAttemptOutcome>;
  statusCode?: InputMaybe<Scalars['Float']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationDeliveryAttemptOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegrationDeliveryAttempt_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountIntegrationDeliveryAttemptCreatedAtOperatorsInput>;
  delivery?: InputMaybe<FilterCountIntegrationDeliveryAttemptDeliveryOperatorsInput>;
};

export type FilterCountIntegrationDeliveryAttempt_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationDeliveryCauseInput = {
  changedPaths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountIntegrationDeliveryCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountIntegrationDeliveryEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountIntegrationDeliveryInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationDeliveryInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationDeliveryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationDeliveryOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  attempts?: InputMaybe<Scalars['Float']['input']>;
  cause?: InputMaybe<FilterCountIntegrationDeliveryCauseInput>;
  claimedUntil?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deliveredAt?: InputMaybe<Scalars['Date']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Date']['input']>;
  occurredAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumIntegrationDeliveryStatus>;
  subjectId?: InputMaybe<Scalars['MongoID']['input']>;
  subjectType?: InputMaybe<EnumIntegrationDeliverySubjectType>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountIntegrationDeliveryIntegrationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationDeliveryOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegrationDelivery_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountIntegrationDeliveryCreatedAtOperatorsInput>;
  eventId?: InputMaybe<FilterCountIntegrationDeliveryEventIdOperatorsInput>;
  integration?: InputMaybe<FilterCountIntegrationDeliveryIntegrationOperatorsInput>;
  vendor?: InputMaybe<FilterCountIntegrationDeliveryVendorOperatorsInput>;
};

export type FilterCountIntegrationDeliveryVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationDelivery_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type FilterCountIntegrationInboundOperatorsInput = {
  tokenHash?: InputMaybe<FilterCountIntegrationInboundTokenHashOperatorsInput>;
};

export type FilterCountIntegrationInboundRecordInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationInboundRecordInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationInboundRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationInboundRecordOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  appliedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalRef?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  kind?: InputMaybe<EnumIntegrationInboundRecordKind>;
  liveWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  match?: InputMaybe<FilterCountIntegrationInboundRecordMatchInput>;
  rawPayload?: InputMaybe<Scalars['JSON']['input']>;
  receivedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumIntegrationInboundRecordStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
  yieldLines?: InputMaybe<Array<InputMaybe<FilterCountIntegrationInboundRecordYieldLinesInput>>>;
};

export type FilterCountIntegrationInboundRecordIntegrationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationInboundRecordMatchInput = {
  animal?: InputMaybe<Scalars['MongoID']['input']>;
  animalHeadId?: InputMaybe<Scalars['String']['input']>;
  job?: InputMaybe<Scalars['MongoID']['input']>;
  matchedOn?: InputMaybe<Scalars['String']['input']>;
  matchedValue?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountIntegrationInboundRecordMatchJobOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationInboundRecordMatchOperatorsInput = {
  job?: InputMaybe<FilterCountIntegrationInboundRecordMatchJobOperatorsInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationInboundRecordOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegrationInboundRecord_IdOperatorsInput>;
  integration?: InputMaybe<FilterCountIntegrationInboundRecordIntegrationOperatorsInput>;
  match?: InputMaybe<FilterCountIntegrationInboundRecordMatchOperatorsInput>;
  vendor?: InputMaybe<FilterCountIntegrationInboundRecordVendorOperatorsInput>;
};

export type FilterCountIntegrationInboundRecordVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationInboundRecordYieldLinesInput = {
  itemCount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Float']['input']>;
  partnerLabel?: InputMaybe<Scalars['String']['input']>;
  partnerSku?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountIntegrationInboundRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationInboundTokenHashOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountIntegrationInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<FilterCountIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegration_IdOperatorsInput>;
  inbound?: InputMaybe<FilterCountIntegrationInboundOperatorsInput>;
  vendor?: InputMaybe<FilterCountIntegrationVendorOperatorsInput>;
};

export type FilterCountIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountInvoiceExternal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountInvoiceExternal_LinksOperatorsInput = {
  stripe?: InputMaybe<FilterCountInvoiceExternal_LinksStripeOperatorsInput>;
};

export type FilterCountInvoiceExternal_LinksStripeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterCountInvoiceInput = {
  AND?: InputMaybe<Array<FilterCountInvoiceInput>>;
  OR?: InputMaybe<Array<FilterCountInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterCountInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterCountInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterCountInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterCountInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterCountInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterCountInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterCountInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterCountInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountInvoiceLineItemInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterCountInvoiceLineItem_IdOperatorsInput>;
  invoice?: InputMaybe<FilterCountInvoiceLineItemInvoiceOperatorsInput>;
};

export type FilterCountInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountInvoiceLinksOperatorsInput = {
  parentEntityId?: InputMaybe<FilterCountInvoiceLinksParentEntityIdOperatorsInput>;
  subEntityId?: InputMaybe<FilterCountInvoiceLinksSubEntityIdOperatorsInput>;
};

export type FilterCountInvoiceLinksParentEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceLinksSubEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterCountInvoice_IdOperatorsInput>;
  external_id?: InputMaybe<FilterCountInvoiceExternal_IdOperatorsInput>;
  external_links?: InputMaybe<FilterCountInvoiceExternal_LinksOperatorsInput>;
  links?: InputMaybe<FilterCountInvoiceLinksOperatorsInput>;
  status?: InputMaybe<FilterCountInvoiceStatusOperatorsInput>;
  user?: InputMaybe<FilterCountInvoiceUserOperatorsInput>;
  vendor?: InputMaybe<FilterCountInvoiceVendorOperatorsInput>;
};

export type FilterCountInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterCountInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterCountInvoiceUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountJobTagInput = {
  AND?: InputMaybe<Array<FilterCountJobTagInput>>;
  OR?: InputMaybe<Array<FilterCountJobTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountJobTagOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumJobTagSpecies>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountJobTagOperatorsInput = {
  _id?: InputMaybe<FilterCountJobTag_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountJobTagVendorOperatorsInput>;
};

export type FilterCountJobTagVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountJobTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLandingPageSettingsInput = {
  AND?: InputMaybe<Array<FilterCountLandingPageSettingsInput>>;
  OR?: InputMaybe<Array<FilterCountLandingPageSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountLandingPageSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<FilterCountAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterCountLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FilterCountLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<FilterCountLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<FilterCountLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<FilterCountLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<FilterCountLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountLandingPageSettingsOperatorsInput = {
  _id?: InputMaybe<FilterCountLandingPageSettings_IdOperatorsInput>;
  slug?: InputMaybe<FilterCountLandingPageSettingsSlugOperatorsInput>;
  vendorId?: InputMaybe<FilterCountLandingPageSettingsVendorIdOperatorsInput>;
};

export type FilterCountLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLandingPageSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountLandingPageSettingsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountLandingPageSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNoteAnimalHeadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountNoteInput = {
  AND?: InputMaybe<Array<FilterCountNoteInput>>;
  OR?: InputMaybe<Array<FilterCountNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNoteOperatorsInput>;
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterCountNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNoteOperatorsInput = {
  _id?: InputMaybe<FilterCountNote_IdOperatorsInput>;
  animalHead?: InputMaybe<FilterCountNoteAnimalHeadOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountNoteUpdatedAtOperatorsInput>;
  user?: InputMaybe<FilterCountNoteUserOperatorsInput>;
};

export type FilterCountNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountNoteUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationErrorInput = {
  email?: InputMaybe<FilterCountNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterCountNotificationErrorMessageInput>;
};

export type FilterCountNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountNotificationInput = {
  AND?: InputMaybe<Array<FilterCountNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterCountNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterCountNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterCountNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterCountNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterCountNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterCountNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterCountNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterCountNotificationVendorIdOperatorsInput>;
};

export type FilterCountNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterCountNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterCountNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNotificationSettingOperatorsInput>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterCountNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterCountNotificationSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountNotificationSettingVendorOperatorsInput>;
};

export type FilterCountNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterCountNotificationSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterCountNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPickupLocationInput = {
  AND?: InputMaybe<Array<FilterCountPickupLocationInput>>;
  OR?: InputMaybe<Array<FilterCountPickupLocationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPickupLocationOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<FilterCountAddressInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<FilterCountPickupLocationLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountPickupLocationLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumPickupLocationLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPickupLocationOperatorsInput = {
  _id?: InputMaybe<FilterCountPickupLocation_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountPickupLocationVendorOperatorsInput>;
};

export type FilterCountPickupLocationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPickupLocation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterCountPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterCountPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterCountPrimalCutPrimalOperatorsInput>;
};

export type FilterCountPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterCountPrimalCutTypeNameOperatorsInput>;
};

export type FilterCountPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterCountPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterCountPrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterCountPrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterCountPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterCountPrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalInput = {
  AND?: InputMaybe<Array<FilterCountPrimalInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimal_IdOperatorsInput>;
};

export type FilterCountPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterCountProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterCountProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountProcessorCapabilityVendorOperatorsInput>;
};

export type FilterCountProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterCountProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterCountProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterCountProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterCountProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorNotification_IdOperatorsInput>;
};

export type FilterCountProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSchedulingCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type FilterCountProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type FilterCountProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterCountProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type FilterCountProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<FilterCountProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<FilterCountProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterCountProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterCountProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterCountProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterCountProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterCountProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorScheduling_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountProcessorSchedulingCreatedAtOperatorsInput>;
  dropoffDate?: InputMaybe<FilterCountProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterCountProcessorSchedulingJobIdOperatorsInput>;
  recurringSeries?: InputMaybe<FilterCountProcessorSchedulingRecurringSeriesOperatorsInput>;
  requestId?: InputMaybe<FilterCountProcessorSchedulingRequestIdOperatorsInput>;
  source?: InputMaybe<FilterCountProcessorSchedulingSourceOperatorsInput>;
  status?: InputMaybe<FilterCountProcessorSchedulingStatusOperatorsInput>;
  statusLastUpdated?: InputMaybe<FilterCountProcessorSchedulingStatusLastUpdatedOperatorsInput>;
  vendor?: InputMaybe<FilterCountProcessorSchedulingVendorOperatorsInput>;
};

export type FilterCountProcessorSchedulingRecurringSeriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSchedulingRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountProcessorSchedulingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingSource>;
  gte?: InputMaybe<EnumProcessorSchedulingSource>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
  lt?: InputMaybe<EnumProcessorSchedulingSource>;
  lte?: InputMaybe<EnumProcessorSchedulingSource>;
  ne?: InputMaybe<EnumProcessorSchedulingSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
};

export type FilterCountProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterCountProcessorSchedulingStatusLastUpdatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterCountProcessorSchedulingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterCountProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<FilterCountProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterCountProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterCountProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterCountProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterCountProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['input'];
};

export type FilterCountProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterCountProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type FilterCountProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterCountProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type FilterCountProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterCountProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type FilterCountProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<FilterCountProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<FilterCountProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterCountProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<FilterCountProcessorSettingsWorkflowCapacityInput>;
};

export type FilterCountProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type FilterCountProcessorSettingsKioskTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorSettings_IdOperatorsInput>;
  kioskToken?: InputMaybe<FilterCountProcessorSettingsKioskTokenOperatorsInput>;
  slug?: InputMaybe<FilterCountProcessorSettingsSlugOperatorsInput>;
  vendor?: InputMaybe<FilterCountProcessorSettingsVendorOperatorsInput>;
};

export type FilterCountProcessorSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountRecurringSeriesActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountRecurringSeriesInput = {
  AND?: InputMaybe<Array<FilterCountRecurringSeriesInput>>;
  OR?: InputMaybe<Array<FilterCountRecurringSeriesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountRecurringSeriesOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  exDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  horizonWeeks?: InputMaybe<Scalars['Float']['input']>;
  jobTemplate?: InputMaybe<FilterCountRecurringSeriesJobTemplateInput>;
  rule?: InputMaybe<FilterCountRecurringSeriesRuleInput>;
  targetUpcomingCount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput = {
  definition: Scalars['MongoID']['input'];
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationInput = {
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterCountRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountRecurringSeriesJobTemplateAnimalHeadsInput = {
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterCountRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterCountRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationInput>>>;
  hangTimeDays?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumRecurringSeriesJobTemplateAnimalHeadsInspectionLevel>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountRecurringSeriesJobTemplateInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<FilterCountRecurringSeriesJobTemplateAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumRecurringSeriesJobTemplateAnimalSpecies>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterCountRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountRecurringSeriesOperatorsInput = {
  _id?: InputMaybe<FilterCountRecurringSeries_IdOperatorsInput>;
  active?: InputMaybe<FilterCountRecurringSeriesActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountRecurringSeriesVendorOperatorsInput>;
};

export type FilterCountRecurringSeriesRuleByDayInput = {
  day?: InputMaybe<EnumRecurringSeriesRuleByDayDay>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountRecurringSeriesRuleInput = {
  anchor?: InputMaybe<Scalars['String']['input']>;
  byDay?: InputMaybe<Array<InputMaybe<FilterCountRecurringSeriesRuleByDayInput>>>;
  byMonth?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  byMonthDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  bySetPos?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  count?: InputMaybe<Scalars['Float']['input']>;
  freq?: InputMaybe<EnumRecurringSeriesRuleFreq>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountRecurringSeriesVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountRecurringSeries_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSplitActiveInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSplitAnimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSplitBuyerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSplitClaimRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountSplitCutsheetChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  enteredBy?: InputMaybe<Scalars['MongoID']['input']>;
  previousCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  previousQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumSplitCutsheetChangesSource>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountSplitInput = {
  AND?: InputMaybe<Array<FilterCountSplitInput>>;
  OR?: InputMaybe<Array<FilterCountSplitInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSplitOperatorsInput>;
  activeInvoice?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['MongoID']['input']>;
  buyer?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  claimRequestId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheetChanges?: InputMaybe<Array<InputMaybe<FilterCountSplitCutsheetChangesInput>>>;
  cutsheetConfirmationSentAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetSource?: InputMaybe<EnumSplitCutsheetSource>;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  depositReminderSentAt?: InputMaybe<Scalars['Date']['input']>;
  expiryNotifiedAt?: InputMaybe<Scalars['Date']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  holdExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumSplitKind>;
  lastNudgeKind?: InputMaybe<EnumSplitLastNudgeKind>;
  lastNudgedAt?: InputMaybe<Scalars['Date']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['MongoID']['input']>;
  paymentIntent?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  placedBy?: InputMaybe<EnumSplitPlacedBy>;
  placementHoldAt?: InputMaybe<Scalars['Date']['input']>;
  progress?: InputMaybe<EnumSplitProgress>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  reassignedFromOrder?: InputMaybe<Scalars['MongoID']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSplitStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  yield?: InputMaybe<Array<InputMaybe<FilterCountSplitYieldInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountSplitOperatorsInput = {
  _id?: InputMaybe<FilterCountSplit_IdOperatorsInput>;
  activeInvoice?: InputMaybe<FilterCountSplitActiveInvoiceOperatorsInput>;
  animal?: InputMaybe<FilterCountSplitAnimalOperatorsInput>;
  buyer?: InputMaybe<FilterCountSplitBuyerOperatorsInput>;
  claimRequestId?: InputMaybe<FilterCountSplitClaimRequestIdOperatorsInput>;
  questionnaireResponse?: InputMaybe<FilterCountSplitQuestionnaireResponseOperatorsInput>;
  status?: InputMaybe<FilterCountSplitStatusOperatorsInput>;
  vendor?: InputMaybe<FilterCountSplitVendorOperatorsInput>;
};

export type FilterCountSplitQuestionnaireResponseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSplitStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSplitStatus>;
  gte?: InputMaybe<EnumSplitStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSplitStatus>>>;
  lt?: InputMaybe<EnumSplitStatus>;
  lte?: InputMaybe<EnumSplitStatus>;
  ne?: InputMaybe<EnumSplitStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSplitStatus>>>;
};

export type FilterCountSplitVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSplitYieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityOptionId?: InputMaybe<Scalars['String']['input']>;
  itemCount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Float']['input']>;
  packageIdentifier?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountSplit_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountStateInput = {
  AND?: InputMaybe<Array<FilterCountStateInput>>;
  OR?: InputMaybe<Array<FilterCountStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStateOperatorsInput = {
  _id?: InputMaybe<FilterCountState_IdOperatorsInput>;
};

export type FilterCountState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountTenantInput = {
  AND?: InputMaybe<Array<FilterCountTenantInput>>;
  OR?: InputMaybe<Array<FilterCountTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountTenantOperatorsInput = {
  _id?: InputMaybe<FilterCountTenant_IdOperatorsInput>;
};

export type FilterCountTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterCountUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserInput = {
  AND?: InputMaybe<Array<FilterCountUserInput>>;
  OR?: InputMaybe<Array<FilterCountUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<FilterCountUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterCountUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterCountUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserOperatorsInput = {
  _id?: InputMaybe<FilterCountUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterCountUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterCountUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterCountUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterCountUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterCountUserRelationshipsOperatorsInput>;
  slug?: InputMaybe<FilterCountUserSlugOperatorsInput>;
};

export type FilterCountUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterCountUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterCountUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserSettingsInput = {
  calendar?: InputMaybe<FilterCountUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<FilterCountUserSettingsHangTimePreferencesInput>>>;
};

export type FilterCountUserSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountVendorInput = {
  AND?: InputMaybe<Array<FilterCountVendorInput>>;
  OR?: InputMaybe<Array<FilterCountVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVendorOperatorsInput>;
  address?: InputMaybe<FilterCountAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterCountVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountVendorModuleInput = {
  AND?: InputMaybe<Array<FilterCountVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterCountVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterCountVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountVendorModuleVendorOperatorsInput>;
};

export type FilterCountVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVendorOperatorsInput = {
  _id?: InputMaybe<FilterCountVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterCountVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterCountVendorTenantOperatorsInput>;
};

export type FilterCountVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterCountVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWaitlistInput = {
  AND?: InputMaybe<Array<FilterCountWaitlistInput>>;
  OR?: InputMaybe<Array<FilterCountWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterCountWaitlist_IdOperatorsInput>;
  producer?: InputMaybe<FilterCountWaitlistProducerOperatorsInput>;
  status?: InputMaybe<FilterCountWaitlistStatusOperatorsInput>;
  vendor?: InputMaybe<FilterCountWaitlistVendorOperatorsInput>;
};

export type FilterCountWaitlistProducerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWaitlistStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWaitlistStatus>;
  gte?: InputMaybe<EnumWaitlistStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
  lt?: InputMaybe<EnumWaitlistStatus>;
  lte?: InputMaybe<EnumWaitlistStatus>;
  ne?: InputMaybe<EnumWaitlistStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
};

export type FilterCountWaitlistVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterFindManyAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterFindManyAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterFindManyCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterFindManyCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterFindManyCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterFindManyCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindManyCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyCsvImportJobJobIdOperatorsInput>;
  producerId?: InputMaybe<FilterFindManyCsvImportJobProducerIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterFindManyCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterFindManyCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyCsvImportJobVendorIdOperatorsInput>;
};

export type FilterFindManyCsvImportJobProducerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterFindManyCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalendarEventDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCalendarEventEventTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalendarEventInput = {
  AND?: InputMaybe<Array<FilterFindManyCalendarEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyCalendarEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCalendarEventOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCalendarEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCalendarEvent_IdOperatorsInput>;
  date?: InputMaybe<FilterFindManyCalendarEventDateOperatorsInput>;
  eventType?: InputMaybe<FilterFindManyCalendarEventEventTypeOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCalendarEventVendorOperatorsInput>;
};

export type FilterFindManyCalendarEventTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyCalendarEventTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyCalendarEventTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCalendarEventTypeOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCalendarEventTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCalendarEventType_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCalendarEventTypeVendorOperatorsInput>;
};

export type FilterFindManyCalendarEventTypeVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalendarEventType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalendarEventVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalendarEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterFindManyCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterFindManyCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterFindManyCancellationReasonIndexOperatorsInput>;
};

export type FilterFindManyCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCustomFieldDefinitionInput = {
  AND?: InputMaybe<Array<FilterFindManyCustomFieldDefinitionInput>>;
  OR?: InputMaybe<Array<FilterFindManyCustomFieldDefinitionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCustomFieldDefinitionOperatorsInput>;
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCustomFieldDefinitionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCustomFieldDefinition_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCustomFieldDefinitionVendorOperatorsInput>;
};

export type FilterFindManyCustomFieldDefinitionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCustomFieldDefinition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCustomFieldValueDefinitionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCustomFieldValueInput = {
  AND?: InputMaybe<Array<FilterFindManyCustomFieldValueInput>>;
  OR?: InputMaybe<Array<FilterFindManyCustomFieldValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCustomFieldValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCustomFieldValueOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCustomFieldValue_IdOperatorsInput>;
  definition?: InputMaybe<FilterFindManyCustomFieldValueDefinitionOperatorsInput>;
  recordId?: InputMaybe<FilterFindManyCustomFieldValueRecordIdOperatorsInput>;
};

export type FilterFindManyCustomFieldValueRecordIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCustomFieldValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterFindManyCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterFindManyCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<FilterFindManyCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindManyCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterFindManyCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterFindManyCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterFindManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetDescriptionLibraryInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetDescriptionLibraryInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetDescriptionLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetDescriptionLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetDescriptionLibraryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetDescriptionLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterFindManyCutsheetDescriptionLibraryTagsOperatorsInput>;
};

export type FilterFindManyCutsheetDescriptionLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCutsheetDescriptionLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterFindManyCutsheetImageLibraryInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetImageLibraryInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetImageLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetImageLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetImageLibraryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetImageLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterFindManyCutsheetImageLibraryTagsOperatorsInput>;
};

export type FilterFindManyCutsheetImageLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCutsheetImageLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheet_IdOperatorsInput>;
};

export type FilterFindManyCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type FilterFindManyCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetQuestionnaireOperatorsInput>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<FilterFindManyCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterFindManyCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<FilterFindManyCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterFindManyCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterFindManyCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type FilterFindManyCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type FilterFindManyCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterFindManyCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireResponsePrimalNotesInput>>>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  sourceDocument?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseSourceDocumentInput>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  timeToComplete?: InputMaybe<Scalars['Float']['input']>;
  trimSectionNotes?: InputMaybe<Scalars['String']['input']>;
  trimSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterFindManyCutsheetQuestionnaireResponsePrimalNotesInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseSourceDocumentAnnotationsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseSourceDocumentInput = {
  annotations?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireResponseSourceDocumentAnnotationsInput>>>;
  pages?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireResponseSourceDocumentPagesInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseSourceDocumentPagesInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterFindManyCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterFindManyCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterFindManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDataImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type FilterFindManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<FilterFindManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type FilterFindManyDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type FilterFindManyDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<FilterFindManyDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type FilterFindManyDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<FilterFindManyDataImportJobHygieneNormalizationSummaryInput>;
};

export type FilterFindManyDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<FilterFindManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<FilterFindManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDataImportJobInput = {
  AND?: InputMaybe<Array<FilterFindManyDataImportJobInput>>;
  OR?: InputMaybe<Array<FilterFindManyDataImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDataImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<FilterFindManyDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindManyDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyDataImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDataImportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDataImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyDataImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyDataImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyDataImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterFindManyDataImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterFindManyDataImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyDataImportJobVendorIdOperatorsInput>;
};

export type FilterFindManyDataImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumDataImportJobStatus>;
  gte?: InputMaybe<EnumDataImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
  lt?: InputMaybe<EnumDataImportJobStatus>;
  lte?: InputMaybe<EnumDataImportJobStatus>;
  ne?: InputMaybe<EnumDataImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
};

export type FilterFindManyDataImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDataImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyDataImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDataImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDocumentCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyDocumentCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyDocumentCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDocumentCategoryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDocumentCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDocumentCategory_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyDocumentCategoryVendorOperatorsInput>;
};

export type FilterFindManyDocumentCategoryVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDocumentCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDocumentInput = {
  AND?: InputMaybe<Array<FilterFindManyDocumentInput>>;
  OR?: InputMaybe<Array<FilterFindManyDocumentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDocumentOperatorsInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currentVersion?: InputMaybe<Scalars['Float']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generator?: InputMaybe<EnumDocumentGenerator>;
  hash?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyDocumentLinksInput>>>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  renderHash?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EnumDocumentSource>;
  sourceRef?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  versions?: InputMaybe<Array<InputMaybe<FilterFindManyDocumentVersionsInput>>>;
};

export type FilterFindManyDocumentLinksInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  entityType?: InputMaybe<EnumDocumentLinksEntityType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDocumentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDocument_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyDocumentVendorOperatorsInput>;
};

export type FilterFindManyDocumentVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDocumentVersionsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  isGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  renderHash?: InputMaybe<Scalars['String']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDocument_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyExportPresetInput = {
  AND?: InputMaybe<Array<FilterFindManyExportPresetInput>>;
  OR?: InputMaybe<Array<FilterFindManyExportPresetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyExportPresetOperatorsInput>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<FilterFindManyExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<FilterFindManyExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<FilterFindManyExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyExportPresetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyExportPreset_IdOperatorsInput>;
  schedule?: InputMaybe<FilterFindManyExportPresetScheduleOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyExportPresetVendorOperatorsInput>;
};

export type FilterFindManyExportPresetScheduleEnabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyExportPresetScheduleOperatorsInput = {
  enabled?: InputMaybe<FilterFindManyExportPresetScheduleEnabledOperatorsInput>;
};

export type FilterFindManyExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyExportPresetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyExportPreset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyExportSettingInput = {
  AND?: InputMaybe<Array<FilterFindManyExportSettingInput>>;
  OR?: InputMaybe<Array<FilterFindManyExportSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyExportSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<FilterFindManyExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyExportSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyExportSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyExportSettingVendorOperatorsInput>;
};

export type FilterFindManyExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyExportSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyExportSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFinancialMetricsActualsInput = {
  AND?: InputMaybe<Array<FilterFindManyFinancialMetricsActualsInput>>;
  OR?: InputMaybe<Array<FilterFindManyFinancialMetricsActualsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFinancialMetricsActualsOperatorsInput>;
  costOfGoodsSold?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  overhead?: InputMaybe<Scalars['Float']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  speciesActuals?: InputMaybe<Array<InputMaybe<FilterFindManyFinancialMetricsActualsSpeciesActualsInput>>>;
  totalHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFinancialMetricsActualsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFinancialMetricsActuals_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyFinancialMetricsActualsVendorOperatorsInput>;
};

export type FilterFindManyFinancialMetricsActualsSpeciesActualsInput = {
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialMetricsActualsSpeciesActualsSpecies>;
};

export type FilterFindManyFinancialMetricsActualsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFinancialMetricsActuals_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterFindManyFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterFindManyFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterFindManyFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterFindManyFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterFindManyFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterFindManyFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationDeliveryAttemptCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIntegrationDeliveryAttemptDeliveryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationDeliveryAttemptExchangesInput = {
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
  responseBody?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Float']['input']>;
  truncated?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyIntegrationDeliveryAttemptInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationDeliveryAttemptInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationDeliveryAttemptInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationDeliveryAttemptOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['Date']['input']>;
  attempt?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  delivery?: InputMaybe<Scalars['MongoID']['input']>;
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exchanges?: InputMaybe<Array<InputMaybe<FilterFindManyIntegrationDeliveryAttemptExchangesInput>>>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  outcome?: InputMaybe<EnumIntegrationDeliveryAttemptOutcome>;
  statusCode?: InputMaybe<Scalars['Float']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationDeliveryAttemptOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationDeliveryAttempt_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIntegrationDeliveryAttemptCreatedAtOperatorsInput>;
  delivery?: InputMaybe<FilterFindManyIntegrationDeliveryAttemptDeliveryOperatorsInput>;
};

export type FilterFindManyIntegrationDeliveryAttempt_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationDeliveryCauseInput = {
  changedPaths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyIntegrationDeliveryCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIntegrationDeliveryEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIntegrationDeliveryInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationDeliveryInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationDeliveryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationDeliveryOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  attempts?: InputMaybe<Scalars['Float']['input']>;
  cause?: InputMaybe<FilterFindManyIntegrationDeliveryCauseInput>;
  claimedUntil?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deliveredAt?: InputMaybe<Scalars['Date']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Date']['input']>;
  occurredAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumIntegrationDeliveryStatus>;
  subjectId?: InputMaybe<Scalars['MongoID']['input']>;
  subjectType?: InputMaybe<EnumIntegrationDeliverySubjectType>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyIntegrationDeliveryIntegrationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationDeliveryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationDelivery_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIntegrationDeliveryCreatedAtOperatorsInput>;
  eventId?: InputMaybe<FilterFindManyIntegrationDeliveryEventIdOperatorsInput>;
  integration?: InputMaybe<FilterFindManyIntegrationDeliveryIntegrationOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyIntegrationDeliveryVendorOperatorsInput>;
};

export type FilterFindManyIntegrationDeliveryVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationDelivery_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type FilterFindManyIntegrationInboundOperatorsInput = {
  tokenHash?: InputMaybe<FilterFindManyIntegrationInboundTokenHashOperatorsInput>;
};

export type FilterFindManyIntegrationInboundRecordInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationInboundRecordInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationInboundRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationInboundRecordOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  appliedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalRef?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  kind?: InputMaybe<EnumIntegrationInboundRecordKind>;
  liveWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  match?: InputMaybe<FilterFindManyIntegrationInboundRecordMatchInput>;
  rawPayload?: InputMaybe<Scalars['JSON']['input']>;
  receivedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumIntegrationInboundRecordStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
  yieldLines?: InputMaybe<Array<InputMaybe<FilterFindManyIntegrationInboundRecordYieldLinesInput>>>;
};

export type FilterFindManyIntegrationInboundRecordIntegrationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationInboundRecordMatchInput = {
  animal?: InputMaybe<Scalars['MongoID']['input']>;
  animalHeadId?: InputMaybe<Scalars['String']['input']>;
  job?: InputMaybe<Scalars['MongoID']['input']>;
  matchedOn?: InputMaybe<Scalars['String']['input']>;
  matchedValue?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyIntegrationInboundRecordMatchJobOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationInboundRecordMatchOperatorsInput = {
  job?: InputMaybe<FilterFindManyIntegrationInboundRecordMatchJobOperatorsInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationInboundRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationInboundRecord_IdOperatorsInput>;
  integration?: InputMaybe<FilterFindManyIntegrationInboundRecordIntegrationOperatorsInput>;
  match?: InputMaybe<FilterFindManyIntegrationInboundRecordMatchOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyIntegrationInboundRecordVendorOperatorsInput>;
};

export type FilterFindManyIntegrationInboundRecordVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationInboundRecordYieldLinesInput = {
  itemCount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Float']['input']>;
  partnerLabel?: InputMaybe<Scalars['String']['input']>;
  partnerSku?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyIntegrationInboundRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationInboundTokenHashOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<FilterFindManyIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegration_IdOperatorsInput>;
  inbound?: InputMaybe<FilterFindManyIntegrationInboundOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyIntegrationVendorOperatorsInput>;
};

export type FilterFindManyIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInvoiceExternal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyInvoiceExternal_LinksOperatorsInput = {
  stripe?: InputMaybe<FilterFindManyInvoiceExternal_LinksStripeOperatorsInput>;
};

export type FilterFindManyInvoiceExternal_LinksStripeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterFindManyInvoiceInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInvoiceLineItemInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceLineItem_IdOperatorsInput>;
  invoice?: InputMaybe<FilterFindManyInvoiceLineItemInvoiceOperatorsInput>;
};

export type FilterFindManyInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyInvoiceLinksOperatorsInput = {
  parentEntityId?: InputMaybe<FilterFindManyInvoiceLinksParentEntityIdOperatorsInput>;
  subEntityId?: InputMaybe<FilterFindManyInvoiceLinksSubEntityIdOperatorsInput>;
};

export type FilterFindManyInvoiceLinksParentEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceLinksSubEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoice_IdOperatorsInput>;
  external_id?: InputMaybe<FilterFindManyInvoiceExternal_IdOperatorsInput>;
  external_links?: InputMaybe<FilterFindManyInvoiceExternal_LinksOperatorsInput>;
  links?: InputMaybe<FilterFindManyInvoiceLinksOperatorsInput>;
  status?: InputMaybe<FilterFindManyInvoiceStatusOperatorsInput>;
  user?: InputMaybe<FilterFindManyInvoiceUserOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyInvoiceVendorOperatorsInput>;
};

export type FilterFindManyInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterFindManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterFindManyInvoiceUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobTagInput = {
  AND?: InputMaybe<Array<FilterFindManyJobTagInput>>;
  OR?: InputMaybe<Array<FilterFindManyJobTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyJobTagOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumJobTagSpecies>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyJobTagOperatorsInput = {
  _id?: InputMaybe<FilterFindManyJobTag_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyJobTagVendorOperatorsInput>;
};

export type FilterFindManyJobTagVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLandingPageSettingsInput = {
  AND?: InputMaybe<Array<FilterFindManyLandingPageSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindManyLandingPageSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLandingPageSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterFindManyLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FilterFindManyLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<FilterFindManyLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<FilterFindManyLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<FilterFindManyLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<FilterFindManyLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLandingPageSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLandingPageSettings_IdOperatorsInput>;
  slug?: InputMaybe<FilterFindManyLandingPageSettingsSlugOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyLandingPageSettingsVendorIdOperatorsInput>;
};

export type FilterFindManyLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLandingPageSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyLandingPageSettingsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLandingPageSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNoteAnimalHeadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNoteInput = {
  AND?: InputMaybe<Array<FilterFindManyNoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNoteOperatorsInput>;
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindManyNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNote_IdOperatorsInput>;
  animalHead?: InputMaybe<FilterFindManyNoteAnimalHeadOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyNoteUpdatedAtOperatorsInput>;
  user?: InputMaybe<FilterFindManyNoteUserOperatorsInput>;
};

export type FilterFindManyNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyNoteUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationErrorInput = {
  email?: InputMaybe<FilterFindManyNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterFindManyNotificationErrorMessageInput>;
};

export type FilterFindManyNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterFindManyNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterFindManyNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterFindManyNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterFindManyNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindManyNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterFindManyNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyNotificationVendorIdOperatorsInput>;
};

export type FilterFindManyNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterFindManyNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterFindManyNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNotificationSettingOperatorsInput>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterFindManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNotificationSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyNotificationSettingVendorOperatorsInput>;
};

export type FilterFindManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterFindManyNotificationSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterFindManyNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPickupLocationInput = {
  AND?: InputMaybe<Array<FilterFindManyPickupLocationInput>>;
  OR?: InputMaybe<Array<FilterFindManyPickupLocationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPickupLocationOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<FilterFindManyPickupLocationLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPickupLocationLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumPickupLocationLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPickupLocationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPickupLocation_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyPickupLocationVendorOperatorsInput>;
};

export type FilterFindManyPickupLocationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPickupLocation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterFindManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterFindManyPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterFindManyPrimalCutPrimalOperatorsInput>;
};

export type FilterFindManyPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPrimalCutTypeNameOperatorsInput>;
};

export type FilterFindManyPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterFindManyPrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindManyPrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterFindManyPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyPrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimal_IdOperatorsInput>;
};

export type FilterFindManyPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterFindManyProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyProcessorCapabilityVendorOperatorsInput>;
};

export type FilterFindManyProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterFindManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterFindManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorNotification_IdOperatorsInput>;
};

export type FilterFindManyProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSchedulingCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type FilterFindManyProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type FilterFindManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterFindManyProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type FilterFindManyProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<FilterFindManyProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<FilterFindManyProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterFindManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterFindManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterFindManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterFindManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterFindManyProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorScheduling_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyProcessorSchedulingCreatedAtOperatorsInput>;
  dropoffDate?: InputMaybe<FilterFindManyProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyProcessorSchedulingJobIdOperatorsInput>;
  recurringSeries?: InputMaybe<FilterFindManyProcessorSchedulingRecurringSeriesOperatorsInput>;
  requestId?: InputMaybe<FilterFindManyProcessorSchedulingRequestIdOperatorsInput>;
  source?: InputMaybe<FilterFindManyProcessorSchedulingSourceOperatorsInput>;
  status?: InputMaybe<FilterFindManyProcessorSchedulingStatusOperatorsInput>;
  statusLastUpdated?: InputMaybe<FilterFindManyProcessorSchedulingStatusLastUpdatedOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyProcessorSchedulingVendorOperatorsInput>;
};

export type FilterFindManyProcessorSchedulingRecurringSeriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSchedulingRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyProcessorSchedulingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingSource>;
  gte?: InputMaybe<EnumProcessorSchedulingSource>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
  lt?: InputMaybe<EnumProcessorSchedulingSource>;
  lte?: InputMaybe<EnumProcessorSchedulingSource>;
  ne?: InputMaybe<EnumProcessorSchedulingSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
};

export type FilterFindManyProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterFindManyProcessorSchedulingStatusLastUpdatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterFindManyProcessorSchedulingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterFindManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterFindManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['input'];
};

export type FilterFindManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterFindManyProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type FilterFindManyProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<FilterFindManyProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<FilterFindManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterFindManyProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<FilterFindManyProcessorSettingsWorkflowCapacityInput>;
};

export type FilterFindManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type FilterFindManyProcessorSettingsKioskTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorSettings_IdOperatorsInput>;
  kioskToken?: InputMaybe<FilterFindManyProcessorSettingsKioskTokenOperatorsInput>;
  slug?: InputMaybe<FilterFindManyProcessorSettingsSlugOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyProcessorSettingsVendorOperatorsInput>;
};

export type FilterFindManyProcessorSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRecurringSeriesActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyRecurringSeriesInput = {
  AND?: InputMaybe<Array<FilterFindManyRecurringSeriesInput>>;
  OR?: InputMaybe<Array<FilterFindManyRecurringSeriesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRecurringSeriesOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  exDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  horizonWeeks?: InputMaybe<Scalars['Float']['input']>;
  jobTemplate?: InputMaybe<FilterFindManyRecurringSeriesJobTemplateInput>;
  rule?: InputMaybe<FilterFindManyRecurringSeriesRuleInput>;
  targetUpcomingCount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput = {
  definition: Scalars['MongoID']['input'];
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationInput = {
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterFindManyRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyRecurringSeriesJobTemplateAnimalHeadsInput = {
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterFindManyRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindManyRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationInput>>>;
  hangTimeDays?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumRecurringSeriesJobTemplateAnimalHeadsInspectionLevel>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyRecurringSeriesJobTemplateInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<FilterFindManyRecurringSeriesJobTemplateAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumRecurringSeriesJobTemplateAnimalSpecies>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterFindManyRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRecurringSeriesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRecurringSeries_IdOperatorsInput>;
  active?: InputMaybe<FilterFindManyRecurringSeriesActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyRecurringSeriesVendorOperatorsInput>;
};

export type FilterFindManyRecurringSeriesRuleByDayInput = {
  day?: InputMaybe<EnumRecurringSeriesRuleByDayDay>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRecurringSeriesRuleInput = {
  anchor?: InputMaybe<Scalars['String']['input']>;
  byDay?: InputMaybe<Array<InputMaybe<FilterFindManyRecurringSeriesRuleByDayInput>>>;
  byMonth?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  byMonthDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  bySetPos?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  count?: InputMaybe<Scalars['Float']['input']>;
  freq?: InputMaybe<EnumRecurringSeriesRuleFreq>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyRecurringSeriesVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRecurringSeries_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySplitActiveInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySplitAnimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySplitBuyerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySplitClaimRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySplitCutsheetChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  enteredBy?: InputMaybe<Scalars['MongoID']['input']>;
  previousCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  previousQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumSplitCutsheetChangesSource>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManySplitInput = {
  AND?: InputMaybe<Array<FilterFindManySplitInput>>;
  OR?: InputMaybe<Array<FilterFindManySplitInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySplitOperatorsInput>;
  activeInvoice?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['MongoID']['input']>;
  buyer?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  claimRequestId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheetChanges?: InputMaybe<Array<InputMaybe<FilterFindManySplitCutsheetChangesInput>>>;
  cutsheetConfirmationSentAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetSource?: InputMaybe<EnumSplitCutsheetSource>;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  depositReminderSentAt?: InputMaybe<Scalars['Date']['input']>;
  expiryNotifiedAt?: InputMaybe<Scalars['Date']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  holdExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumSplitKind>;
  lastNudgeKind?: InputMaybe<EnumSplitLastNudgeKind>;
  lastNudgedAt?: InputMaybe<Scalars['Date']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['MongoID']['input']>;
  paymentIntent?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  placedBy?: InputMaybe<EnumSplitPlacedBy>;
  placementHoldAt?: InputMaybe<Scalars['Date']['input']>;
  progress?: InputMaybe<EnumSplitProgress>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  reassignedFromOrder?: InputMaybe<Scalars['MongoID']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSplitStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  yield?: InputMaybe<Array<InputMaybe<FilterFindManySplitYieldInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySplitOperatorsInput = {
  _id?: InputMaybe<FilterFindManySplit_IdOperatorsInput>;
  activeInvoice?: InputMaybe<FilterFindManySplitActiveInvoiceOperatorsInput>;
  animal?: InputMaybe<FilterFindManySplitAnimalOperatorsInput>;
  buyer?: InputMaybe<FilterFindManySplitBuyerOperatorsInput>;
  claimRequestId?: InputMaybe<FilterFindManySplitClaimRequestIdOperatorsInput>;
  questionnaireResponse?: InputMaybe<FilterFindManySplitQuestionnaireResponseOperatorsInput>;
  status?: InputMaybe<FilterFindManySplitStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindManySplitVendorOperatorsInput>;
};

export type FilterFindManySplitQuestionnaireResponseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySplitStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSplitStatus>;
  gte?: InputMaybe<EnumSplitStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSplitStatus>>>;
  lt?: InputMaybe<EnumSplitStatus>;
  lte?: InputMaybe<EnumSplitStatus>;
  ne?: InputMaybe<EnumSplitStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSplitStatus>>>;
};

export type FilterFindManySplitVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySplitYieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityOptionId?: InputMaybe<Scalars['String']['input']>;
  itemCount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Float']['input']>;
  packageIdentifier?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManySplit_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStateInput = {
  AND?: InputMaybe<Array<FilterFindManyStateInput>>;
  OR?: InputMaybe<Array<FilterFindManyStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyState_IdOperatorsInput>;
};

export type FilterFindManyState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTenantInput = {
  AND?: InputMaybe<Array<FilterFindManyTenantInput>>;
  OR?: InputMaybe<Array<FilterFindManyTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTenant_IdOperatorsInput>;
};

export type FilterFindManyTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterFindManyUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<FilterFindManyUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterFindManyUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterFindManyUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterFindManyUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterFindManyUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterFindManyUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterFindManyUserRelationshipsOperatorsInput>;
  slug?: InputMaybe<FilterFindManyUserSlugOperatorsInput>;
};

export type FilterFindManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterFindManyUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterFindManyUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserSettingsInput = {
  calendar?: InputMaybe<FilterFindManyUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<FilterFindManyUserSettingsHangTimePreferencesInput>>>;
};

export type FilterFindManyUserSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorDate_CreatedOperatorsInput = {
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lte?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyVendorInput = {
  AND?: InputMaybe<Array<FilterFindManyVendorInput>>;
  OR?: InputMaybe<Array<FilterFindManyVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVendorOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterFindManyVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyVendorModuleInput = {
  AND?: InputMaybe<Array<FilterFindManyVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyVendorModuleVendorOperatorsInput>;
};

export type FilterFindManyVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVendorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterFindManyVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterFindManyVendorTenantOperatorsInput>;
};

export type FilterFindManyVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterFindManyVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWaitlistInput = {
  AND?: InputMaybe<Array<FilterFindManyWaitlistInput>>;
  OR?: InputMaybe<Array<FilterFindManyWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWaitlist_IdOperatorsInput>;
  producer?: InputMaybe<FilterFindManyWaitlistProducerOperatorsInput>;
  status?: InputMaybe<FilterFindManyWaitlistStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyWaitlistVendorOperatorsInput>;
};

export type FilterFindManyWaitlistProducerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWaitlistStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWaitlistStatus>;
  gte?: InputMaybe<EnumWaitlistStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
  lt?: InputMaybe<EnumWaitlistStatus>;
  lte?: InputMaybe<EnumWaitlistStatus>;
  ne?: InputMaybe<EnumWaitlistStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
};

export type FilterFindManyWaitlistVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterFindOneAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterFindOneAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterFindOneCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterFindOneCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterFindOneCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterFindOneCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindOneCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneCsvImportJobJobIdOperatorsInput>;
  producerId?: InputMaybe<FilterFindOneCsvImportJobProducerIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterFindOneCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterFindOneCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterFindOneCsvImportJobVendorIdOperatorsInput>;
};

export type FilterFindOneCsvImportJobProducerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterFindOneCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindOneCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCalendarEventDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCalendarEventEventTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCalendarEventInput = {
  AND?: InputMaybe<Array<FilterFindOneCalendarEventInput>>;
  OR?: InputMaybe<Array<FilterFindOneCalendarEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCalendarEventOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCalendarEventOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCalendarEvent_IdOperatorsInput>;
  date?: InputMaybe<FilterFindOneCalendarEventDateOperatorsInput>;
  eventType?: InputMaybe<FilterFindOneCalendarEventEventTypeOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCalendarEventVendorOperatorsInput>;
};

export type FilterFindOneCalendarEventTypeInput = {
  AND?: InputMaybe<Array<FilterFindOneCalendarEventTypeInput>>;
  OR?: InputMaybe<Array<FilterFindOneCalendarEventTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCalendarEventTypeOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCalendarEventTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCalendarEventType_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCalendarEventTypeVendorOperatorsInput>;
};

export type FilterFindOneCalendarEventTypeVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCalendarEventType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCalendarEventVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCalendarEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOneCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterFindOneCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterFindOneCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterFindOneCancellationReasonIndexOperatorsInput>;
};

export type FilterFindOneCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCustomFieldDefinitionInput = {
  AND?: InputMaybe<Array<FilterFindOneCustomFieldDefinitionInput>>;
  OR?: InputMaybe<Array<FilterFindOneCustomFieldDefinitionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCustomFieldDefinitionOperatorsInput>;
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCustomFieldDefinitionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCustomFieldDefinition_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCustomFieldDefinitionVendorOperatorsInput>;
};

export type FilterFindOneCustomFieldDefinitionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCustomFieldDefinition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCustomFieldValueDefinitionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCustomFieldValueInput = {
  AND?: InputMaybe<Array<FilterFindOneCustomFieldValueInput>>;
  OR?: InputMaybe<Array<FilterFindOneCustomFieldValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCustomFieldValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCustomFieldValueOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCustomFieldValue_IdOperatorsInput>;
  definition?: InputMaybe<FilterFindOneCustomFieldValueDefinitionOperatorsInput>;
  recordId?: InputMaybe<FilterFindOneCustomFieldValueRecordIdOperatorsInput>;
};

export type FilterFindOneCustomFieldValueRecordIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneCustomFieldValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterFindOneCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterFindOneCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<FilterFindOneCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindOneCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterFindOneCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterFindOneCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterFindOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetDescriptionLibraryInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetDescriptionLibraryInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetDescriptionLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetDescriptionLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetDescriptionLibraryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetDescriptionLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterFindOneCutsheetDescriptionLibraryTagsOperatorsInput>;
};

export type FilterFindOneCutsheetDescriptionLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneCutsheetDescriptionLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterFindOneCutsheetImageLibraryInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetImageLibraryInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetImageLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetImageLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetImageLibraryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetImageLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterFindOneCutsheetImageLibraryTagsOperatorsInput>;
};

export type FilterFindOneCutsheetImageLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneCutsheetImageLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheet_IdOperatorsInput>;
};

export type FilterFindOneCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type FilterFindOneCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetQuestionnaireOperatorsInput>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<FilterFindOneCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterFindOneCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<FilterFindOneCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterFindOneCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterFindOneCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type FilterFindOneCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type FilterFindOneCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterFindOneCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireResponsePrimalNotesInput>>>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  sourceDocument?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseSourceDocumentInput>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  timeToComplete?: InputMaybe<Scalars['Float']['input']>;
  trimSectionNotes?: InputMaybe<Scalars['String']['input']>;
  trimSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterFindOneCutsheetQuestionnaireResponsePrimalNotesInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseSourceDocumentAnnotationsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseSourceDocumentInput = {
  annotations?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireResponseSourceDocumentAnnotationsInput>>>;
  pages?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireResponseSourceDocumentPagesInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseSourceDocumentPagesInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterFindOneCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterFindOneCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterFindOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneDataImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type FilterFindOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<FilterFindOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type FilterFindOneDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type FilterFindOneDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<FilterFindOneDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type FilterFindOneDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<FilterFindOneDataImportJobHygieneNormalizationSummaryInput>;
};

export type FilterFindOneDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<FilterFindOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<FilterFindOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneDataImportJobInput = {
  AND?: InputMaybe<Array<FilterFindOneDataImportJobInput>>;
  OR?: InputMaybe<Array<FilterFindOneDataImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDataImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<FilterFindOneDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindOneDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneDataImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDataImportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDataImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneDataImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneDataImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneDataImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterFindOneDataImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterFindOneDataImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterFindOneDataImportJobVendorIdOperatorsInput>;
};

export type FilterFindOneDataImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumDataImportJobStatus>;
  gte?: InputMaybe<EnumDataImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
  lt?: InputMaybe<EnumDataImportJobStatus>;
  lte?: InputMaybe<EnumDataImportJobStatus>;
  ne?: InputMaybe<EnumDataImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
};

export type FilterFindOneDataImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDataImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindOneDataImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDataImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDocumentCategoryInput = {
  AND?: InputMaybe<Array<FilterFindOneDocumentCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindOneDocumentCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDocumentCategoryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDocumentCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDocumentCategory_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneDocumentCategoryVendorOperatorsInput>;
};

export type FilterFindOneDocumentCategoryVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDocumentCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDocumentInput = {
  AND?: InputMaybe<Array<FilterFindOneDocumentInput>>;
  OR?: InputMaybe<Array<FilterFindOneDocumentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDocumentOperatorsInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currentVersion?: InputMaybe<Scalars['Float']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generator?: InputMaybe<EnumDocumentGenerator>;
  hash?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneDocumentLinksInput>>>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  renderHash?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EnumDocumentSource>;
  sourceRef?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  versions?: InputMaybe<Array<InputMaybe<FilterFindOneDocumentVersionsInput>>>;
};

export type FilterFindOneDocumentLinksInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  entityType?: InputMaybe<EnumDocumentLinksEntityType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDocumentOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDocument_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneDocumentVendorOperatorsInput>;
};

export type FilterFindOneDocumentVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDocumentVersionsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  isGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  renderHash?: InputMaybe<Scalars['String']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneDocument_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneExportPresetInput = {
  AND?: InputMaybe<Array<FilterFindOneExportPresetInput>>;
  OR?: InputMaybe<Array<FilterFindOneExportPresetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneExportPresetOperatorsInput>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindOneExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<FilterFindOneExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<FilterFindOneExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<FilterFindOneExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneExportPresetOperatorsInput = {
  _id?: InputMaybe<FilterFindOneExportPreset_IdOperatorsInput>;
  schedule?: InputMaybe<FilterFindOneExportPresetScheduleOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneExportPresetVendorOperatorsInput>;
};

export type FilterFindOneExportPresetScheduleEnabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindOneExportPresetScheduleOperatorsInput = {
  enabled?: InputMaybe<FilterFindOneExportPresetScheduleEnabledOperatorsInput>;
};

export type FilterFindOneExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneExportPresetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneExportPreset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneExportSettingInput = {
  AND?: InputMaybe<Array<FilterFindOneExportSettingInput>>;
  OR?: InputMaybe<Array<FilterFindOneExportSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneExportSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<FilterFindOneExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneExportSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneExportSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneExportSettingVendorOperatorsInput>;
};

export type FilterFindOneExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneExportSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneExportSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFinancialMetricsActualsInput = {
  AND?: InputMaybe<Array<FilterFindOneFinancialMetricsActualsInput>>;
  OR?: InputMaybe<Array<FilterFindOneFinancialMetricsActualsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFinancialMetricsActualsOperatorsInput>;
  costOfGoodsSold?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  overhead?: InputMaybe<Scalars['Float']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  speciesActuals?: InputMaybe<Array<InputMaybe<FilterFindOneFinancialMetricsActualsSpeciesActualsInput>>>;
  totalHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFinancialMetricsActualsOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFinancialMetricsActuals_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneFinancialMetricsActualsVendorOperatorsInput>;
};

export type FilterFindOneFinancialMetricsActualsSpeciesActualsInput = {
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialMetricsActualsSpeciesActualsSpecies>;
};

export type FilterFindOneFinancialMetricsActualsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFinancialMetricsActuals_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterFindOneFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterFindOneFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterFindOneFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterFindOneFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterFindOneFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterFindOneFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterFindOneFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterFindOneFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationDeliveryAttemptCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneIntegrationDeliveryAttemptDeliveryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationDeliveryAttemptExchangesInput = {
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
  responseBody?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Float']['input']>;
  truncated?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneIntegrationDeliveryAttemptInput = {
  AND?: InputMaybe<Array<FilterFindOneIntegrationDeliveryAttemptInput>>;
  OR?: InputMaybe<Array<FilterFindOneIntegrationDeliveryAttemptInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIntegrationDeliveryAttemptOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['Date']['input']>;
  attempt?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  delivery?: InputMaybe<Scalars['MongoID']['input']>;
  durationMs?: InputMaybe<Scalars['Float']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exchanges?: InputMaybe<Array<InputMaybe<FilterFindOneIntegrationDeliveryAttemptExchangesInput>>>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  outcome?: InputMaybe<EnumIntegrationDeliveryAttemptOutcome>;
  statusCode?: InputMaybe<Scalars['Float']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIntegrationDeliveryAttemptOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIntegrationDeliveryAttempt_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneIntegrationDeliveryAttemptCreatedAtOperatorsInput>;
  delivery?: InputMaybe<FilterFindOneIntegrationDeliveryAttemptDeliveryOperatorsInput>;
};

export type FilterFindOneIntegrationDeliveryAttempt_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationDeliveryCauseInput = {
  changedPaths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneIntegrationDeliveryCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneIntegrationDeliveryEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneIntegrationDeliveryInput = {
  AND?: InputMaybe<Array<FilterFindOneIntegrationDeliveryInput>>;
  OR?: InputMaybe<Array<FilterFindOneIntegrationDeliveryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIntegrationDeliveryOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  attempts?: InputMaybe<Scalars['Float']['input']>;
  cause?: InputMaybe<FilterFindOneIntegrationDeliveryCauseInput>;
  claimedUntil?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deliveredAt?: InputMaybe<Scalars['Date']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Date']['input']>;
  occurredAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumIntegrationDeliveryStatus>;
  subjectId?: InputMaybe<Scalars['MongoID']['input']>;
  subjectType?: InputMaybe<EnumIntegrationDeliverySubjectType>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneIntegrationDeliveryIntegrationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIntegrationDeliveryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIntegrationDelivery_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneIntegrationDeliveryCreatedAtOperatorsInput>;
  eventId?: InputMaybe<FilterFindOneIntegrationDeliveryEventIdOperatorsInput>;
  integration?: InputMaybe<FilterFindOneIntegrationDeliveryIntegrationOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneIntegrationDeliveryVendorOperatorsInput>;
};

export type FilterFindOneIntegrationDeliveryVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationDelivery_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type FilterFindOneIntegrationInboundOperatorsInput = {
  tokenHash?: InputMaybe<FilterFindOneIntegrationInboundTokenHashOperatorsInput>;
};

export type FilterFindOneIntegrationInboundRecordInput = {
  AND?: InputMaybe<Array<FilterFindOneIntegrationInboundRecordInput>>;
  OR?: InputMaybe<Array<FilterFindOneIntegrationInboundRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIntegrationInboundRecordOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  appliedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalRef?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integration?: InputMaybe<Scalars['MongoID']['input']>;
  kind?: InputMaybe<EnumIntegrationInboundRecordKind>;
  liveWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  match?: InputMaybe<FilterFindOneIntegrationInboundRecordMatchInput>;
  rawPayload?: InputMaybe<Scalars['JSON']['input']>;
  receivedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumIntegrationInboundRecordStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
  yieldLines?: InputMaybe<Array<InputMaybe<FilterFindOneIntegrationInboundRecordYieldLinesInput>>>;
};

export type FilterFindOneIntegrationInboundRecordIntegrationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationInboundRecordMatchInput = {
  animal?: InputMaybe<Scalars['MongoID']['input']>;
  animalHeadId?: InputMaybe<Scalars['String']['input']>;
  job?: InputMaybe<Scalars['MongoID']['input']>;
  matchedOn?: InputMaybe<Scalars['String']['input']>;
  matchedValue?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneIntegrationInboundRecordMatchJobOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationInboundRecordMatchOperatorsInput = {
  job?: InputMaybe<FilterFindOneIntegrationInboundRecordMatchJobOperatorsInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIntegrationInboundRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIntegrationInboundRecord_IdOperatorsInput>;
  integration?: InputMaybe<FilterFindOneIntegrationInboundRecordIntegrationOperatorsInput>;
  match?: InputMaybe<FilterFindOneIntegrationInboundRecordMatchOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneIntegrationInboundRecordVendorOperatorsInput>;
};

export type FilterFindOneIntegrationInboundRecordVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationInboundRecordYieldLinesInput = {
  itemCount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Float']['input']>;
  partnerLabel?: InputMaybe<Scalars['String']['input']>;
  partnerSku?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneIntegrationInboundRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationInboundTokenHashOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindOneIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindOneIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIntegrationOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<FilterFindOneIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIntegration_IdOperatorsInput>;
  inbound?: InputMaybe<FilterFindOneIntegrationInboundOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneIntegrationVendorOperatorsInput>;
};

export type FilterFindOneIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneInvoiceExternal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneInvoiceExternal_LinksOperatorsInput = {
  stripe?: InputMaybe<FilterFindOneInvoiceExternal_LinksStripeOperatorsInput>;
};

export type FilterFindOneInvoiceExternal_LinksStripeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterFindOneInvoiceInput = {
  AND?: InputMaybe<Array<FilterFindOneInvoiceInput>>;
  OR?: InputMaybe<Array<FilterFindOneInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterFindOneInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterFindOneInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneInvoiceLineItemInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneInvoiceLineItem_IdOperatorsInput>;
  invoice?: InputMaybe<FilterFindOneInvoiceLineItemInvoiceOperatorsInput>;
};

export type FilterFindOneInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneInvoiceLinksOperatorsInput = {
  parentEntityId?: InputMaybe<FilterFindOneInvoiceLinksParentEntityIdOperatorsInput>;
  subEntityId?: InputMaybe<FilterFindOneInvoiceLinksSubEntityIdOperatorsInput>;
};

export type FilterFindOneInvoiceLinksParentEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceLinksSubEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneInvoice_IdOperatorsInput>;
  external_id?: InputMaybe<FilterFindOneInvoiceExternal_IdOperatorsInput>;
  external_links?: InputMaybe<FilterFindOneInvoiceExternal_LinksOperatorsInput>;
  links?: InputMaybe<FilterFindOneInvoiceLinksOperatorsInput>;
  status?: InputMaybe<FilterFindOneInvoiceStatusOperatorsInput>;
  user?: InputMaybe<FilterFindOneInvoiceUserOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneInvoiceVendorOperatorsInput>;
};

export type FilterFindOneInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterFindOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterFindOneInvoiceUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneJobTagInput = {
  AND?: InputMaybe<Array<FilterFindOneJobTagInput>>;
  OR?: InputMaybe<Array<FilterFindOneJobTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneJobTagOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumJobTagSpecies>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneJobTagOperatorsInput = {
  _id?: InputMaybe<FilterFindOneJobTag_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneJobTagVendorOperatorsInput>;
};

export type FilterFindOneJobTagVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneJobTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLandingPageSettingsInput = {
  AND?: InputMaybe<Array<FilterFindOneLandingPageSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindOneLandingPageSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneLandingPageSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<FilterFindOneAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterFindOneLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FilterFindOneLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<FilterFindOneLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<FilterFindOneLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<FilterFindOneLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<FilterFindOneLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneLandingPageSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindOneLandingPageSettings_IdOperatorsInput>;
  slug?: InputMaybe<FilterFindOneLandingPageSettingsSlugOperatorsInput>;
  vendorId?: InputMaybe<FilterFindOneLandingPageSettingsVendorIdOperatorsInput>;
};

export type FilterFindOneLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLandingPageSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneLandingPageSettingsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLandingPageSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNoteAnimalHeadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneNoteInput = {
  AND?: InputMaybe<Array<FilterFindOneNoteInput>>;
  OR?: InputMaybe<Array<FilterFindOneNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNoteOperatorsInput>;
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindOneNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNote_IdOperatorsInput>;
  animalHead?: InputMaybe<FilterFindOneNoteAnimalHeadOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneNoteUpdatedAtOperatorsInput>;
  user?: InputMaybe<FilterFindOneNoteUserOperatorsInput>;
};

export type FilterFindOneNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneNoteUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationErrorInput = {
  email?: InputMaybe<FilterFindOneNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterFindOneNotificationErrorMessageInput>;
};

export type FilterFindOneNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterFindOneNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterFindOneNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterFindOneNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterFindOneNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindOneNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterFindOneNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterFindOneNotificationVendorIdOperatorsInput>;
};

export type FilterFindOneNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterFindOneNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterFindOneNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNotificationSettingOperatorsInput>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterFindOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNotificationSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneNotificationSettingVendorOperatorsInput>;
};

export type FilterFindOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterFindOneNotificationSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterFindOneNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePickupLocationInput = {
  AND?: InputMaybe<Array<FilterFindOnePickupLocationInput>>;
  OR?: InputMaybe<Array<FilterFindOnePickupLocationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePickupLocationOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<FilterFindOneAddressInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<FilterFindOnePickupLocationLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOnePickupLocationLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumPickupLocationLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePickupLocationOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePickupLocation_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOnePickupLocationVendorOperatorsInput>;
};

export type FilterFindOnePickupLocationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePickupLocation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOnePrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterFindOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCutBlocker_IdOperatorsInput>;
};

export type FilterFindOnePrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterFindOnePrimalCutPrimalOperatorsInput>;
};

export type FilterFindOnePrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOnePrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOnePrimalCutTypeNameOperatorsInput>;
};

export type FilterFindOnePrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalGroupInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterFindOnePrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindOnePrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterFindOnePrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOnePrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimal_IdOperatorsInput>;
};

export type FilterFindOnePrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterFindOneProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneProcessorCapabilityVendorOperatorsInput>;
};

export type FilterFindOneProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterFindOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterFindOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorNotification_IdOperatorsInput>;
};

export type FilterFindOneProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSchedulingCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type FilterFindOneProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type FilterFindOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterFindOneProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type FilterFindOneProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<FilterFindOneProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<FilterFindOneProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterFindOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterFindOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterFindOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterFindOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterFindOneProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorScheduling_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneProcessorSchedulingCreatedAtOperatorsInput>;
  dropoffDate?: InputMaybe<FilterFindOneProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneProcessorSchedulingJobIdOperatorsInput>;
  recurringSeries?: InputMaybe<FilterFindOneProcessorSchedulingRecurringSeriesOperatorsInput>;
  requestId?: InputMaybe<FilterFindOneProcessorSchedulingRequestIdOperatorsInput>;
  source?: InputMaybe<FilterFindOneProcessorSchedulingSourceOperatorsInput>;
  status?: InputMaybe<FilterFindOneProcessorSchedulingStatusOperatorsInput>;
  statusLastUpdated?: InputMaybe<FilterFindOneProcessorSchedulingStatusLastUpdatedOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneProcessorSchedulingVendorOperatorsInput>;
};

export type FilterFindOneProcessorSchedulingRecurringSeriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSchedulingRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneProcessorSchedulingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingSource>;
  gte?: InputMaybe<EnumProcessorSchedulingSource>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
  lt?: InputMaybe<EnumProcessorSchedulingSource>;
  lte?: InputMaybe<EnumProcessorSchedulingSource>;
  ne?: InputMaybe<EnumProcessorSchedulingSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
};

export type FilterFindOneProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterFindOneProcessorSchedulingStatusLastUpdatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterFindOneProcessorSchedulingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterFindOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterFindOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['input'];
};

export type FilterFindOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterFindOneProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type FilterFindOneProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<FilterFindOneProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<FilterFindOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterFindOneProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<FilterFindOneProcessorSettingsWorkflowCapacityInput>;
};

export type FilterFindOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type FilterFindOneProcessorSettingsKioskTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorSettings_IdOperatorsInput>;
  kioskToken?: InputMaybe<FilterFindOneProcessorSettingsKioskTokenOperatorsInput>;
  slug?: InputMaybe<FilterFindOneProcessorSettingsSlugOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneProcessorSettingsVendorOperatorsInput>;
};

export type FilterFindOneProcessorSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneRecurringSeriesActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneRecurringSeriesInput = {
  AND?: InputMaybe<Array<FilterFindOneRecurringSeriesInput>>;
  OR?: InputMaybe<Array<FilterFindOneRecurringSeriesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneRecurringSeriesOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  exDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  horizonWeeks?: InputMaybe<Scalars['Float']['input']>;
  jobTemplate?: InputMaybe<FilterFindOneRecurringSeriesJobTemplateInput>;
  rule?: InputMaybe<FilterFindOneRecurringSeriesRuleInput>;
  targetUpcomingCount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput = {
  definition: Scalars['MongoID']['input'];
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationInput = {
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterFindOneRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneRecurringSeriesJobTemplateAnimalHeadsInput = {
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterFindOneRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindOneRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationInput>>>;
  hangTimeDays?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumRecurringSeriesJobTemplateAnimalHeadsInspectionLevel>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneRecurringSeriesJobTemplateInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<FilterFindOneRecurringSeriesJobTemplateAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumRecurringSeriesJobTemplateAnimalSpecies>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<FilterFindOneRecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValuesInput>>>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneRecurringSeriesOperatorsInput = {
  _id?: InputMaybe<FilterFindOneRecurringSeries_IdOperatorsInput>;
  active?: InputMaybe<FilterFindOneRecurringSeriesActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneRecurringSeriesVendorOperatorsInput>;
};

export type FilterFindOneRecurringSeriesRuleByDayInput = {
  day?: InputMaybe<EnumRecurringSeriesRuleByDayDay>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneRecurringSeriesRuleInput = {
  anchor?: InputMaybe<Scalars['String']['input']>;
  byDay?: InputMaybe<Array<InputMaybe<FilterFindOneRecurringSeriesRuleByDayInput>>>;
  byMonth?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  byMonthDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  bySetPos?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  count?: InputMaybe<Scalars['Float']['input']>;
  freq?: InputMaybe<EnumRecurringSeriesRuleFreq>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneRecurringSeriesVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneRecurringSeries_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSplitActiveInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSplitAnimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSplitBuyerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSplitClaimRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneSplitCutsheetChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  enteredBy?: InputMaybe<Scalars['MongoID']['input']>;
  previousCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  previousQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumSplitCutsheetChangesSource>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneSplitInput = {
  AND?: InputMaybe<Array<FilterFindOneSplitInput>>;
  OR?: InputMaybe<Array<FilterFindOneSplitInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSplitOperatorsInput>;
  activeInvoice?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['MongoID']['input']>;
  buyer?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  claimRequestId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheetChanges?: InputMaybe<Array<InputMaybe<FilterFindOneSplitCutsheetChangesInput>>>;
  cutsheetConfirmationSentAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetSource?: InputMaybe<EnumSplitCutsheetSource>;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  depositReminderSentAt?: InputMaybe<Scalars['Date']['input']>;
  expiryNotifiedAt?: InputMaybe<Scalars['Date']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  holdExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumSplitKind>;
  lastNudgeKind?: InputMaybe<EnumSplitLastNudgeKind>;
  lastNudgedAt?: InputMaybe<Scalars['Date']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['MongoID']['input']>;
  paymentIntent?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  placedBy?: InputMaybe<EnumSplitPlacedBy>;
  placementHoldAt?: InputMaybe<Scalars['Date']['input']>;
  progress?: InputMaybe<EnumSplitProgress>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  reassignedFromOrder?: InputMaybe<Scalars['MongoID']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSplitStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  yield?: InputMaybe<Array<InputMaybe<FilterFindOneSplitYieldInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSplitOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSplit_IdOperatorsInput>;
  activeInvoice?: InputMaybe<FilterFindOneSplitActiveInvoiceOperatorsInput>;
  animal?: InputMaybe<FilterFindOneSplitAnimalOperatorsInput>;
  buyer?: InputMaybe<FilterFindOneSplitBuyerOperatorsInput>;
  claimRequestId?: InputMaybe<FilterFindOneSplitClaimRequestIdOperatorsInput>;
  questionnaireResponse?: InputMaybe<FilterFindOneSplitQuestionnaireResponseOperatorsInput>;
  status?: InputMaybe<FilterFindOneSplitStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneSplitVendorOperatorsInput>;
};

export type FilterFindOneSplitQuestionnaireResponseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSplitStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSplitStatus>;
  gte?: InputMaybe<EnumSplitStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSplitStatus>>>;
  lt?: InputMaybe<EnumSplitStatus>;
  lte?: InputMaybe<EnumSplitStatus>;
  ne?: InputMaybe<EnumSplitStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSplitStatus>>>;
};

export type FilterFindOneSplitVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSplitYieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityOptionId?: InputMaybe<Scalars['String']['input']>;
  itemCount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Float']['input']>;
  packageIdentifier?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneSplit_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneStateInput = {
  AND?: InputMaybe<Array<FilterFindOneStateInput>>;
  OR?: InputMaybe<Array<FilterFindOneStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneStateOperatorsInput = {
  _id?: InputMaybe<FilterFindOneState_IdOperatorsInput>;
};

export type FilterFindOneState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTenantInput = {
  AND?: InputMaybe<Array<FilterFindOneTenantInput>>;
  OR?: InputMaybe<Array<FilterFindOneTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTenant_IdOperatorsInput>;
};

export type FilterFindOneTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterFindOneUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<FilterFindOneUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterFindOneUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterFindOneUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterFindOneUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterFindOneUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterFindOneUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterFindOneUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterFindOneUserRelationshipsOperatorsInput>;
  slug?: InputMaybe<FilterFindOneUserSlugOperatorsInput>;
};

export type FilterFindOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterFindOneUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterFindOneUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserSettingsInput = {
  calendar?: InputMaybe<FilterFindOneUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<FilterFindOneUserSettingsHangTimePreferencesInput>>>;
};

export type FilterFindOneUserSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneVendorInput = {
  AND?: InputMaybe<Array<FilterFindOneVendorInput>>;
  OR?: InputMaybe<Array<FilterFindOneVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVendorOperatorsInput>;
  address?: InputMaybe<FilterFindOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterFindOneVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneVendorModuleInput = {
  AND?: InputMaybe<Array<FilterFindOneVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterFindOneVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneVendorModuleVendorOperatorsInput>;
};

export type FilterFindOneVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVendorOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterFindOneVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterFindOneVendorTenantOperatorsInput>;
};

export type FilterFindOneVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterFindOneVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneWaitlistInput = {
  AND?: InputMaybe<Array<FilterFindOneWaitlistInput>>;
  OR?: InputMaybe<Array<FilterFindOneWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterFindOneWaitlist_IdOperatorsInput>;
  producer?: InputMaybe<FilterFindOneWaitlistProducerOperatorsInput>;
  status?: InputMaybe<FilterFindOneWaitlistStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneWaitlistVendorOperatorsInput>;
};

export type FilterFindOneWaitlistProducerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneWaitlistStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWaitlistStatus>;
  gte?: InputMaybe<EnumWaitlistStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
  lt?: InputMaybe<EnumWaitlistStatus>;
  lte?: InputMaybe<EnumWaitlistStatus>;
  ne?: InputMaybe<EnumWaitlistStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
};

export type FilterFindOneWaitlistVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterUpdateManyAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterUpdateManyAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterUpdateManyCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterUpdateManyCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateManyCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyCsvImportJobJobIdOperatorsInput>;
  producerId?: InputMaybe<FilterUpdateManyCsvImportJobProducerIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterUpdateManyCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterUpdateManyCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateManyCsvImportJobVendorIdOperatorsInput>;
};

export type FilterUpdateManyCsvImportJobProducerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterUpdateManyCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateManyCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateManyCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterUpdateManyCancellationReasonIndexOperatorsInput>;
};

export type FilterUpdateManyCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCustomFieldDefinitionInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCustomFieldDefinitionInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCustomFieldDefinitionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCustomFieldDefinitionOperatorsInput>;
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCustomFieldDefinitionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCustomFieldDefinition_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCustomFieldDefinitionVendorOperatorsInput>;
};

export type FilterUpdateManyCustomFieldDefinitionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCustomFieldDefinition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCustomFieldValueDefinitionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCustomFieldValueInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCustomFieldValueInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCustomFieldValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCustomFieldValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCustomFieldValueOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCustomFieldValue_IdOperatorsInput>;
  definition?: InputMaybe<FilterUpdateManyCustomFieldValueDefinitionOperatorsInput>;
  recordId?: InputMaybe<FilterUpdateManyCustomFieldValueRecordIdOperatorsInput>;
};

export type FilterUpdateManyCustomFieldValueRecordIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyCustomFieldValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterUpdateManyCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterUpdateManyCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetDescriptionLibraryInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetDescriptionLibraryInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetDescriptionLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetDescriptionLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetDescriptionLibraryOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetDescriptionLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterUpdateManyCutsheetDescriptionLibraryTagsOperatorsInput>;
};

export type FilterUpdateManyCutsheetDescriptionLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyCutsheetDescriptionLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterUpdateManyCutsheetImageLibraryInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetImageLibraryInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetImageLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetImageLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetImageLibraryOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetImageLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterUpdateManyCutsheetImageLibraryTagsOperatorsInput>;
};

export type FilterUpdateManyCutsheetImageLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyCutsheetImageLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheet_IdOperatorsInput>;
};

export type FilterUpdateManyCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type FilterUpdateManyCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireOperatorsInput>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterUpdateManyCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type FilterUpdateManyCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type FilterUpdateManyCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterUpdateManyCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterUpdateManyCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterUpdateManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyDataImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type FilterUpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<FilterUpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type FilterUpdateManyDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type FilterUpdateManyDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<FilterUpdateManyDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type FilterUpdateManyDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<FilterUpdateManyDataImportJobHygieneNormalizationSummaryInput>;
};

export type FilterUpdateManyDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<FilterUpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<FilterUpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyDataImportJobInput = {
  AND?: InputMaybe<Array<FilterUpdateManyDataImportJobInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyDataImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyDataImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<FilterUpdateManyDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateManyDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyDataImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyDataImportJobOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyDataImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyDataImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyDataImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyDataImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterUpdateManyDataImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterUpdateManyDataImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateManyDataImportJobVendorIdOperatorsInput>;
};

export type FilterUpdateManyDataImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumDataImportJobStatus>;
  gte?: InputMaybe<EnumDataImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
  lt?: InputMaybe<EnumDataImportJobStatus>;
  lte?: InputMaybe<EnumDataImportJobStatus>;
  ne?: InputMaybe<EnumDataImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
};

export type FilterUpdateManyDataImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyDataImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateManyDataImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyDataImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyExportPresetInput = {
  AND?: InputMaybe<Array<FilterUpdateManyExportPresetInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyExportPresetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyExportPresetOperatorsInput>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterUpdateManyExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<FilterUpdateManyExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<FilterUpdateManyExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<FilterUpdateManyExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyExportPresetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyExportPreset_IdOperatorsInput>;
  schedule?: InputMaybe<FilterUpdateManyExportPresetScheduleOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyExportPresetVendorOperatorsInput>;
};

export type FilterUpdateManyExportPresetScheduleEnabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterUpdateManyExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateManyExportPresetScheduleOperatorsInput = {
  enabled?: InputMaybe<FilterUpdateManyExportPresetScheduleEnabledOperatorsInput>;
};

export type FilterUpdateManyExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyExportPresetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyExportPreset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyExportSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyExportSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyExportSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyExportSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<FilterUpdateManyExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyExportSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyExportSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyExportSettingVendorOperatorsInput>;
};

export type FilterUpdateManyExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyExportSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyExportSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterUpdateManyFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterUpdateManyFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterUpdateManyFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterUpdateManyFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterUpdateManyFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterUpdateManyFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateManyFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterUpdateManyFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type FilterUpdateManyIntegrationInboundOperatorsInput = {
  tokenHash?: InputMaybe<FilterUpdateManyIntegrationInboundTokenHashOperatorsInput>;
};

export type FilterUpdateManyIntegrationInboundTokenHashOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyIntegrationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyIntegrationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyIntegrationOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<FilterUpdateManyIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyIntegration_IdOperatorsInput>;
  inbound?: InputMaybe<FilterUpdateManyIntegrationInboundOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyIntegrationVendorOperatorsInput>;
};

export type FilterUpdateManyIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyInvoiceExternal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyInvoiceExternal_LinksOperatorsInput = {
  stripe?: InputMaybe<FilterUpdateManyInvoiceExternal_LinksStripeOperatorsInput>;
};

export type FilterUpdateManyInvoiceExternal_LinksStripeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterUpdateManyInvoiceInput = {
  AND?: InputMaybe<Array<FilterUpdateManyInvoiceInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterUpdateManyInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyInvoiceLineItemInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyInvoiceLineItem_IdOperatorsInput>;
  invoice?: InputMaybe<FilterUpdateManyInvoiceLineItemInvoiceOperatorsInput>;
};

export type FilterUpdateManyInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyInvoiceLinksOperatorsInput = {
  parentEntityId?: InputMaybe<FilterUpdateManyInvoiceLinksParentEntityIdOperatorsInput>;
  subEntityId?: InputMaybe<FilterUpdateManyInvoiceLinksSubEntityIdOperatorsInput>;
};

export type FilterUpdateManyInvoiceLinksParentEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceLinksSubEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyInvoice_IdOperatorsInput>;
  external_id?: InputMaybe<FilterUpdateManyInvoiceExternal_IdOperatorsInput>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceExternal_LinksOperatorsInput>;
  links?: InputMaybe<FilterUpdateManyInvoiceLinksOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyInvoiceStatusOperatorsInput>;
  user?: InputMaybe<FilterUpdateManyInvoiceUserOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyInvoiceVendorOperatorsInput>;
};

export type FilterUpdateManyInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterUpdateManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterUpdateManyInvoiceUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyLandingPageSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateManyLandingPageSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyLandingPageSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyLandingPageSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<FilterUpdateManyAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterUpdateManyLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FilterUpdateManyLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<FilterUpdateManyLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<FilterUpdateManyLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<FilterUpdateManyLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<FilterUpdateManyLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyLandingPageSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyLandingPageSettings_IdOperatorsInput>;
  slug?: InputMaybe<FilterUpdateManyLandingPageSettingsSlugOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateManyLandingPageSettingsVendorIdOperatorsInput>;
};

export type FilterUpdateManyLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyLandingPageSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyLandingPageSettingsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyLandingPageSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNoteAnimalHeadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyNoteInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNoteInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNoteOperatorsInput>;
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterUpdateManyNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNote_IdOperatorsInput>;
  animalHead?: InputMaybe<FilterUpdateManyNoteAnimalHeadOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateManyNoteUpdatedAtOperatorsInput>;
  user?: InputMaybe<FilterUpdateManyNoteUserOperatorsInput>;
};

export type FilterUpdateManyNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyNoteUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationErrorInput = {
  email?: InputMaybe<FilterUpdateManyNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterUpdateManyNotificationErrorMessageInput>;
};

export type FilterUpdateManyNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterUpdateManyNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterUpdateManyNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterUpdateManyNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterUpdateManyNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateManyNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterUpdateManyNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateManyNotificationVendorIdOperatorsInput>;
};

export type FilterUpdateManyNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNotificationSettingOperatorsInput>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterUpdateManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNotificationSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyNotificationSettingVendorOperatorsInput>;
};

export type FilterUpdateManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterUpdateManyNotificationSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterUpdateManyNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterUpdateManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterUpdateManyPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterUpdateManyPrimalCutPrimalOperatorsInput>;
};

export type FilterUpdateManyPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateManyPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateManyPrimalCutTypeNameOperatorsInput>;
};

export type FilterUpdateManyPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterUpdateManyPrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateManyPrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterUpdateManyPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateManyPrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimal_IdOperatorsInput>;
};

export type FilterUpdateManyPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterUpdateManyProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyProcessorCapabilityVendorOperatorsInput>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorNotification_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type FilterUpdateManyProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type FilterUpdateManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterUpdateManyProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type FilterUpdateManyProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<FilterUpdateManyProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<FilterUpdateManyProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterUpdateManyProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorScheduling_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyProcessorSchedulingCreatedAtOperatorsInput>;
  dropoffDate?: InputMaybe<FilterUpdateManyProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyProcessorSchedulingJobIdOperatorsInput>;
  recurringSeries?: InputMaybe<FilterUpdateManyProcessorSchedulingRecurringSeriesOperatorsInput>;
  requestId?: InputMaybe<FilterUpdateManyProcessorSchedulingRequestIdOperatorsInput>;
  source?: InputMaybe<FilterUpdateManyProcessorSchedulingSourceOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyProcessorSchedulingStatusOperatorsInput>;
  statusLastUpdated?: InputMaybe<FilterUpdateManyProcessorSchedulingStatusLastUpdatedOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyProcessorSchedulingVendorOperatorsInput>;
};

export type FilterUpdateManyProcessorSchedulingRecurringSeriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyProcessorSchedulingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingSource>;
  gte?: InputMaybe<EnumProcessorSchedulingSource>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
  lt?: InputMaybe<EnumProcessorSchedulingSource>;
  lte?: InputMaybe<EnumProcessorSchedulingSource>;
  ne?: InputMaybe<EnumProcessorSchedulingSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
};

export type FilterUpdateManyProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterUpdateManyProcessorSchedulingStatusLastUpdatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterUpdateManyProcessorSchedulingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterUpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['input'];
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterUpdateManyProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type FilterUpdateManyProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<FilterUpdateManyProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<FilterUpdateManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterUpdateManyProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<FilterUpdateManyProcessorSettingsWorkflowCapacityInput>;
};

export type FilterUpdateManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type FilterUpdateManyProcessorSettingsKioskTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorSettings_IdOperatorsInput>;
  kioskToken?: InputMaybe<FilterUpdateManyProcessorSettingsKioskTokenOperatorsInput>;
  slug?: InputMaybe<FilterUpdateManyProcessorSettingsSlugOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyProcessorSettingsVendorOperatorsInput>;
};

export type FilterUpdateManyProcessorSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyStateInput = {
  AND?: InputMaybe<Array<FilterUpdateManyStateInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyStateOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyState_IdOperatorsInput>;
};

export type FilterUpdateManyState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyTenantInput = {
  AND?: InputMaybe<Array<FilterUpdateManyTenantInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyTenantOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyTenant_IdOperatorsInput>;
};

export type FilterUpdateManyTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterUpdateManyUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserInput = {
  AND?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<FilterUpdateManyUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterUpdateManyUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterUpdateManyUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateManyUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterUpdateManyUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterUpdateManyUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterUpdateManyUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterUpdateManyUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterUpdateManyUserRelationshipsOperatorsInput>;
  slug?: InputMaybe<FilterUpdateManyUserSlugOperatorsInput>;
};

export type FilterUpdateManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterUpdateManyUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterUpdateManyUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyUserSettingsInput = {
  calendar?: InputMaybe<FilterUpdateManyUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<FilterUpdateManyUserSettingsHangTimePreferencesInput>>>;
};

export type FilterUpdateManyUserSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyVendorInput = {
  AND?: InputMaybe<Array<FilterUpdateManyVendorInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyVendorOperatorsInput>;
  address?: InputMaybe<FilterUpdateManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterUpdateManyVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyVendorModuleInput = {
  AND?: InputMaybe<Array<FilterUpdateManyVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyVendorModuleVendorOperatorsInput>;
};

export type FilterUpdateManyVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyVendorOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterUpdateManyVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterUpdateManyVendorTenantOperatorsInput>;
};

export type FilterUpdateManyVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterUpdateManyVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyWaitlistInput = {
  AND?: InputMaybe<Array<FilterUpdateManyWaitlistInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyWaitlist_IdOperatorsInput>;
  producer?: InputMaybe<FilterUpdateManyWaitlistProducerOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyWaitlistStatusOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyWaitlistVendorOperatorsInput>;
};

export type FilterUpdateManyWaitlistProducerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyWaitlistStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWaitlistStatus>;
  gte?: InputMaybe<EnumWaitlistStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
  lt?: InputMaybe<EnumWaitlistStatus>;
  lte?: InputMaybe<EnumWaitlistStatus>;
  ne?: InputMaybe<EnumWaitlistStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
};

export type FilterUpdateManyWaitlistVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterUpdateOneAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterUpdateOneAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterUpdateOneCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterUpdateOneCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateOneCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneCsvImportJobJobIdOperatorsInput>;
  producerId?: InputMaybe<FilterUpdateOneCsvImportJobProducerIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterUpdateOneCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterUpdateOneCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateOneCsvImportJobVendorIdOperatorsInput>;
};

export type FilterUpdateOneCsvImportJobProducerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterUpdateOneCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateOneCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateOneCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterUpdateOneCancellationReasonIndexOperatorsInput>;
};

export type FilterUpdateOneCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCustomFieldDefinitionInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCustomFieldDefinitionInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCustomFieldDefinitionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCustomFieldDefinitionOperatorsInput>;
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCustomFieldDefinitionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCustomFieldDefinition_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCustomFieldDefinitionVendorOperatorsInput>;
};

export type FilterUpdateOneCustomFieldDefinitionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCustomFieldDefinition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCustomFieldValueDefinitionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCustomFieldValueInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCustomFieldValueInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCustomFieldValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCustomFieldValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCustomFieldValueOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCustomFieldValue_IdOperatorsInput>;
  definition?: InputMaybe<FilterUpdateOneCustomFieldValueDefinitionOperatorsInput>;
  recordId?: InputMaybe<FilterUpdateOneCustomFieldValueRecordIdOperatorsInput>;
};

export type FilterUpdateOneCustomFieldValueRecordIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneCustomFieldValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterUpdateOneCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterUpdateOneCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetDescriptionLibraryInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetDescriptionLibraryInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetDescriptionLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetDescriptionLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetDescriptionLibraryOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetDescriptionLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterUpdateOneCutsheetDescriptionLibraryTagsOperatorsInput>;
};

export type FilterUpdateOneCutsheetDescriptionLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneCutsheetDescriptionLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterUpdateOneCutsheetImageLibraryInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetImageLibraryInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetImageLibraryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetImageLibraryOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetImageLibraryOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetImageLibrary_IdOperatorsInput>;
  tags?: InputMaybe<FilterUpdateOneCutsheetImageLibraryTagsOperatorsInput>;
};

export type FilterUpdateOneCutsheetImageLibraryTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneCutsheetImageLibrary_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheet_IdOperatorsInput>;
};

export type FilterUpdateOneCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type FilterUpdateOneCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireOperatorsInput>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterUpdateOneCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type FilterUpdateOneCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type FilterUpdateOneCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterUpdateOneCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterUpdateOneCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterUpdateOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneDataImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type FilterUpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<FilterUpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type FilterUpdateOneDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type FilterUpdateOneDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<FilterUpdateOneDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type FilterUpdateOneDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<FilterUpdateOneDataImportJobHygieneNormalizationSummaryInput>;
};

export type FilterUpdateOneDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<FilterUpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<FilterUpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneDataImportJobInput = {
  AND?: InputMaybe<Array<FilterUpdateOneDataImportJobInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneDataImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneDataImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<FilterUpdateOneDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateOneDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneDataImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneDataImportJobOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneDataImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneDataImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneDataImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneDataImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterUpdateOneDataImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterUpdateOneDataImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateOneDataImportJobVendorIdOperatorsInput>;
};

export type FilterUpdateOneDataImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumDataImportJobStatus>;
  gte?: InputMaybe<EnumDataImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
  lt?: InputMaybe<EnumDataImportJobStatus>;
  lte?: InputMaybe<EnumDataImportJobStatus>;
  ne?: InputMaybe<EnumDataImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataImportJobStatus>>>;
};

export type FilterUpdateOneDataImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneDataImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateOneDataImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneDataImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneExportPresetInput = {
  AND?: InputMaybe<Array<FilterUpdateOneExportPresetInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneExportPresetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneExportPresetOperatorsInput>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterUpdateOneExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<FilterUpdateOneExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<FilterUpdateOneExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<FilterUpdateOneExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneExportPresetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneExportPreset_IdOperatorsInput>;
  schedule?: InputMaybe<FilterUpdateOneExportPresetScheduleOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneExportPresetVendorOperatorsInput>;
};

export type FilterUpdateOneExportPresetScheduleEnabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterUpdateOneExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateOneExportPresetScheduleOperatorsInput = {
  enabled?: InputMaybe<FilterUpdateOneExportPresetScheduleEnabledOperatorsInput>;
};

export type FilterUpdateOneExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneExportPresetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneExportPreset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneExportSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneExportSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneExportSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneExportSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<FilterUpdateOneExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneExportSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneExportSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneExportSettingVendorOperatorsInput>;
};

export type FilterUpdateOneExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneExportSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneExportSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterUpdateOneFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterUpdateOneFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterUpdateOneFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterUpdateOneFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterUpdateOneFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterUpdateOneFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateOneFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterUpdateOneFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type FilterUpdateOneIntegrationInboundOperatorsInput = {
  tokenHash?: InputMaybe<FilterUpdateOneIntegrationInboundTokenHashOperatorsInput>;
};

export type FilterUpdateOneIntegrationInboundTokenHashOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneIntegrationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneIntegrationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneIntegrationOperatorsInput>;
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<FilterUpdateOneIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneIntegration_IdOperatorsInput>;
  inbound?: InputMaybe<FilterUpdateOneIntegrationInboundOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneIntegrationVendorOperatorsInput>;
};

export type FilterUpdateOneIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneInvoiceExternal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneInvoiceExternal_LinksOperatorsInput = {
  stripe?: InputMaybe<FilterUpdateOneInvoiceExternal_LinksStripeOperatorsInput>;
};

export type FilterUpdateOneInvoiceExternal_LinksStripeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterUpdateOneInvoiceInput = {
  AND?: InputMaybe<Array<FilterUpdateOneInvoiceInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterUpdateOneInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneInvoiceLineItemInvoiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneInvoiceLineItem_IdOperatorsInput>;
  invoice?: InputMaybe<FilterUpdateOneInvoiceLineItemInvoiceOperatorsInput>;
};

export type FilterUpdateOneInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneInvoiceLinksOperatorsInput = {
  parentEntityId?: InputMaybe<FilterUpdateOneInvoiceLinksParentEntityIdOperatorsInput>;
  subEntityId?: InputMaybe<FilterUpdateOneInvoiceLinksSubEntityIdOperatorsInput>;
};

export type FilterUpdateOneInvoiceLinksParentEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceLinksSubEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneInvoice_IdOperatorsInput>;
  external_id?: InputMaybe<FilterUpdateOneInvoiceExternal_IdOperatorsInput>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceExternal_LinksOperatorsInput>;
  links?: InputMaybe<FilterUpdateOneInvoiceLinksOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneInvoiceStatusOperatorsInput>;
  user?: InputMaybe<FilterUpdateOneInvoiceUserOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneInvoiceVendorOperatorsInput>;
};

export type FilterUpdateOneInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterUpdateOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterUpdateOneInvoiceUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneLandingPageSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateOneLandingPageSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneLandingPageSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneLandingPageSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<FilterUpdateOneAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterUpdateOneLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FilterUpdateOneLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<FilterUpdateOneLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<FilterUpdateOneLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<FilterUpdateOneLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<FilterUpdateOneLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneLandingPageSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneLandingPageSettings_IdOperatorsInput>;
  slug?: InputMaybe<FilterUpdateOneLandingPageSettingsSlugOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateOneLandingPageSettingsVendorIdOperatorsInput>;
};

export type FilterUpdateOneLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneLandingPageSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneLandingPageSettingsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneLandingPageSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNoteAnimalHeadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneNoteInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNoteInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNoteOperatorsInput>;
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterUpdateOneNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNoteOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNote_IdOperatorsInput>;
  animalHead?: InputMaybe<FilterUpdateOneNoteAnimalHeadOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateOneNoteUpdatedAtOperatorsInput>;
  user?: InputMaybe<FilterUpdateOneNoteUserOperatorsInput>;
};

export type FilterUpdateOneNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneNoteUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationErrorInput = {
  email?: InputMaybe<FilterUpdateOneNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterUpdateOneNotificationErrorMessageInput>;
};

export type FilterUpdateOneNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterUpdateOneNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterUpdateOneNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterUpdateOneNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterUpdateOneNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateOneNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterUpdateOneNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateOneNotificationVendorIdOperatorsInput>;
};

export type FilterUpdateOneNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNotificationSettingOperatorsInput>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterUpdateOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNotificationSetting_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneNotificationSettingVendorOperatorsInput>;
};

export type FilterUpdateOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterUpdateOneNotificationSettingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterUpdateOneNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOnePrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterUpdateOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCutBlocker_IdOperatorsInput>;
};

export type FilterUpdateOnePrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterUpdateOnePrimalCutPrimalOperatorsInput>;
};

export type FilterUpdateOnePrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateOnePrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateOnePrimalCutTypeNameOperatorsInput>;
};

export type FilterUpdateOnePrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterUpdateOnePrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateOnePrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterUpdateOnePrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateOnePrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimal_IdOperatorsInput>;
};

export type FilterUpdateOnePrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterUpdateOneProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneProcessorCapabilityVendorOperatorsInput>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorNotification_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type FilterUpdateOneProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type FilterUpdateOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterUpdateOneProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type FilterUpdateOneProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<FilterUpdateOneProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<FilterUpdateOneProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterUpdateOneProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorScheduling_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneProcessorSchedulingCreatedAtOperatorsInput>;
  dropoffDate?: InputMaybe<FilterUpdateOneProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneProcessorSchedulingJobIdOperatorsInput>;
  recurringSeries?: InputMaybe<FilterUpdateOneProcessorSchedulingRecurringSeriesOperatorsInput>;
  requestId?: InputMaybe<FilterUpdateOneProcessorSchedulingRequestIdOperatorsInput>;
  source?: InputMaybe<FilterUpdateOneProcessorSchedulingSourceOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneProcessorSchedulingStatusOperatorsInput>;
  statusLastUpdated?: InputMaybe<FilterUpdateOneProcessorSchedulingStatusLastUpdatedOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneProcessorSchedulingVendorOperatorsInput>;
};

export type FilterUpdateOneProcessorSchedulingRecurringSeriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingRequestIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneProcessorSchedulingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingSource>;
  gte?: InputMaybe<EnumProcessorSchedulingSource>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
  lt?: InputMaybe<EnumProcessorSchedulingSource>;
  lte?: InputMaybe<EnumProcessorSchedulingSource>;
  ne?: InputMaybe<EnumProcessorSchedulingSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingSource>>>;
};

export type FilterUpdateOneProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterUpdateOneProcessorSchedulingStatusLastUpdatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterUpdateOneProcessorSchedulingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterUpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['input'];
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type FilterUpdateOneProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type FilterUpdateOneProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<FilterUpdateOneProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<FilterUpdateOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterUpdateOneProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<FilterUpdateOneProcessorSettingsWorkflowCapacityInput>;
};

export type FilterUpdateOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type FilterUpdateOneProcessorSettingsKioskTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorSettings_IdOperatorsInput>;
  kioskToken?: InputMaybe<FilterUpdateOneProcessorSettingsKioskTokenOperatorsInput>;
  slug?: InputMaybe<FilterUpdateOneProcessorSettingsSlugOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneProcessorSettingsVendorOperatorsInput>;
};

export type FilterUpdateOneProcessorSettingsSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneStateInput = {
  AND?: InputMaybe<Array<FilterUpdateOneStateInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneStateOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneState_IdOperatorsInput>;
};

export type FilterUpdateOneState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneTenantInput = {
  AND?: InputMaybe<Array<FilterUpdateOneTenantInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneTenantOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneTenant_IdOperatorsInput>;
};

export type FilterUpdateOneTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterUpdateOneUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserInput = {
  AND?: InputMaybe<Array<FilterUpdateOneUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<FilterUpdateOneUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterUpdateOneUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterUpdateOneUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateOneUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterUpdateOneUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterUpdateOneUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterUpdateOneUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterUpdateOneUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterUpdateOneUserRelationshipsOperatorsInput>;
  slug?: InputMaybe<FilterUpdateOneUserSlugOperatorsInput>;
};

export type FilterUpdateOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterUpdateOneUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterUpdateOneUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneUserSettingsInput = {
  calendar?: InputMaybe<FilterUpdateOneUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<FilterUpdateOneUserSettingsHangTimePreferencesInput>>>;
};

export type FilterUpdateOneUserSlugOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneVendorInput = {
  AND?: InputMaybe<Array<FilterUpdateOneVendorInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneVendorOperatorsInput>;
  address?: InputMaybe<FilterUpdateOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterUpdateOneVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneVendorModuleInput = {
  AND?: InputMaybe<Array<FilterUpdateOneVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneVendorModuleVendorOperatorsInput>;
};

export type FilterUpdateOneVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneVendorOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterUpdateOneVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterUpdateOneVendorTenantOperatorsInput>;
};

export type FilterUpdateOneVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterUpdateOneVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneWaitlistInput = {
  AND?: InputMaybe<Array<FilterUpdateOneWaitlistInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneWaitlist_IdOperatorsInput>;
  producer?: InputMaybe<FilterUpdateOneWaitlistProducerOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneWaitlistStatusOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneWaitlistVendorOperatorsInput>;
};

export type FilterUpdateOneWaitlistProducerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneWaitlistStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWaitlistStatus>;
  gte?: InputMaybe<EnumWaitlistStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
  lt?: InputMaybe<EnumWaitlistStatus>;
  lte?: InputMaybe<EnumWaitlistStatus>;
  ne?: InputMaybe<EnumWaitlistStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumWaitlistStatus>>>;
};

export type FilterUpdateOneWaitlistVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FinancialMetricsActuals = {
  __typename?: 'FinancialMetricsActuals';
  _id: Scalars['MongoID']['output'];
  costOfGoodsSold: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  overhead: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  speciesActuals?: Maybe<Array<Maybe<FinancialMetricsActualsSpeciesActuals>>>;
  totalHangingWeight: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type FinancialMetricsActualsPagination = {
  __typename?: 'FinancialMetricsActualsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<FinancialMetricsActuals>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type FinancialMetricsActualsSpeciesActuals = {
  __typename?: 'FinancialMetricsActualsSpeciesActuals';
  hangingWeight: Scalars['Float']['output'];
  headCount: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  species: EnumFinancialMetricsActualsSpeciesActualsSpecies;
};

export type FinancialMetricsActualsSpeciesInput = {
  hangingWeight: Scalars['Float']['input'];
  headCount: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
  species: Scalars['String']['input'];
};

export type FinancialMetricsActualsUpsertInput = {
  costOfGoodsSold: Scalars['Float']['input'];
  overhead: Scalars['Float']['input'];
  period: Scalars['String']['input'];
  speciesActuals?: InputMaybe<Array<InputMaybe<FinancialMetricsActualsSpeciesInput>>>;
  totalHangingWeight: Scalars['Float']['input'];
};

export type FinancialReportingConfig = {
  __typename?: 'FinancialReportingConfig';
  _id: Scalars['MongoID']['output'];
  animalConfigurations?: Maybe<Array<Maybe<FinancialReportingConfigAnimalConfigurations>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dateAnchor?: Maybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: Maybe<FinancialReportingConfigMonthlyModifiers>;
  overheadCosts?: Maybe<Array<Maybe<FinancialReportingConfigOverheadCosts>>>;
  timeConfiguration?: Maybe<FinancialReportingConfigTimeConfiguration>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type FinancialReportingConfigAnimalConfigurations = {
  __typename?: 'FinancialReportingConfigAnimalConfigurations';
  averageHangingWeight: Scalars['Float']['output'];
  expectedThroughput: Scalars['Float']['output'];
  maxCapacity: Scalars['Float']['output'];
  processingCost: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  species: EnumFinancialReportingConfigAnimalConfigurationsSpecies;
};

export type FinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight: Scalars['Float']['input'];
  expectedThroughput: Scalars['Float']['input'];
  maxCapacity: Scalars['Float']['input'];
  processingCost: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
  species: EnumFinancialReportingConfigAnimalConfigurationsSpecies;
};

export type FinancialReportingConfigMonthlyModifiers = {
  __typename?: 'FinancialReportingConfigMonthlyModifiers';
  april: Scalars['Float']['output'];
  august: Scalars['Float']['output'];
  december: Scalars['Float']['output'];
  february: Scalars['Float']['output'];
  january: Scalars['Float']['output'];
  july: Scalars['Float']['output'];
  june: Scalars['Float']['output'];
  march: Scalars['Float']['output'];
  may: Scalars['Float']['output'];
  november: Scalars['Float']['output'];
  october: Scalars['Float']['output'];
  september: Scalars['Float']['output'];
};

export type FinancialReportingConfigMonthlyModifiersInput = {
  april: Scalars['Float']['input'];
  august: Scalars['Float']['input'];
  december: Scalars['Float']['input'];
  february: Scalars['Float']['input'];
  january: Scalars['Float']['input'];
  july: Scalars['Float']['input'];
  june: Scalars['Float']['input'];
  march: Scalars['Float']['input'];
  may: Scalars['Float']['input'];
  november: Scalars['Float']['input'];
  october: Scalars['Float']['input'];
  september: Scalars['Float']['input'];
};

export type FinancialReportingConfigOverheadCosts = {
  __typename?: 'FinancialReportingConfigOverheadCosts';
  amount: Scalars['Float']['output'];
  frequency: EnumFinancialReportingConfigOverheadCostsFrequency;
  name: Scalars['String']['output'];
};

export type FinancialReportingConfigOverheadCostsInput = {
  amount: Scalars['Float']['input'];
  frequency: EnumFinancialReportingConfigOverheadCostsFrequency;
  name: Scalars['String']['input'];
};

/** List of items with pagination. */
export type FinancialReportingConfigPagination = {
  __typename?: 'FinancialReportingConfigPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<FinancialReportingConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type FinancialReportingConfigTimeConfiguration = {
  __typename?: 'FinancialReportingConfigTimeConfiguration';
  baseDigitalSavings: Scalars['Float']['output'];
  hourlyRate: Scalars['Float']['output'];
  timePerBooking: Scalars['Float']['output'];
  timePerCutsheet: Scalars['Float']['output'];
  timePerInvoicing: Scalars['Float']['output'];
  timePerNotification: Scalars['Float']['output'];
  timePerProducerBooking: Scalars['Float']['output'];
};

export type FinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerInvoicing: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
  timePerProducerBooking: Scalars['Float']['input'];
};

export type FinancialReportingConfigUpsertInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<AnimalConfigurationInput>>>;
  dateAnchor?: InputMaybe<DateAnchorEnumUpsert>;
  monthlyModifiers?: InputMaybe<MonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<OverheadCostInput>>>;
  timeConfiguration?: InputMaybe<TimeConfigurationInput>;
};

export type FixVendorPhoneConfigInput = {
  phoneNumber: Scalars['String']['input'];
  phoneNumberSid: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type FixVendorPhoneConfigResponse = {
  __typename?: 'FixVendorPhoneConfigResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GameDepositCollectionInput = {
  method: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type GameHunterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type GameJobAddAnimalsInput = {
  animalCount: Scalars['Int']['input'];
  job: Scalars['MongoID']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  shareCutSheet?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type GameJobAddAnimalsResponse = {
  __typename?: 'GameJobAddAnimalsResponse';
  addedCount: Scalars['Int']['output'];
  cutSheetOutcome: Scalars['String']['output'];
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  replayed: Scalars['Boolean']['output'];
  scheduling: ProcessorScheduling;
  sharedCutSheet: Scalars['Boolean']['output'];
};

export type GameJobCreateInput = {
  animalCount?: InputMaybe<Scalars['Int']['input']>;
  animalSpecies: Scalars['String']['input'];
  depositCollection?: InputMaybe<GameDepositCollectionInput>;
  expectedArrival?: InputMaybe<Scalars['String']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  hunter: GameHunterInput;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type GameJobCreateResponse = {
  __typename?: 'GameJobCreateResponse';
  hunterExisted: Scalars['Boolean']['output'];
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  replayed: Scalars['Boolean']['output'];
  scheduling: ProcessorScheduling;
};

export type GameKioskAddressCurrent = {
  __typename?: 'GameKioskAddressCurrent';
  kioskShortUrl: Scalars['String']['output'];
  kioskToken: Scalars['String']['output'];
  kioskUrl: Scalars['String']['output'];
};

export type GameKioskAddressSetupInput = {
  rotate?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type GameKioskAddressSetupResponse = {
  __typename?: 'GameKioskAddressSetupResponse';
  created: Scalars['Boolean']['output'];
  kioskShortUrl: Scalars['String']['output'];
  kioskToken: Scalars['String']['output'];
  kioskUrl: Scalars['String']['output'];
};

export type GameKioskCatalog = {
  __typename?: 'GameKioskCatalog';
  cuts?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  extras?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  primals?: Maybe<Array<Maybe<CutsheetCapabilityGroup>>>;
  specifications?: Maybe<Array<Maybe<CutsheetCapabilitySpecification>>>;
  trim?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
};

export type GameKioskCutsheet = {
  __typename?: 'GameKioskCutsheet';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

export type GameKioskCutsheetInput = {
  extraSelections?: InputMaybe<CutsheetResponseExtraResponseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primalNotes?: InputMaybe<Array<InputMaybe<CutsheetResponseNoteEntryInput>>>;
  questionnaireId: Scalars['MongoID']['input'];
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetResponseCutOptionInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
  timeToComplete?: InputMaybe<Scalars['Int']['input']>;
  trimSectionNotes?: InputMaybe<Scalars['String']['input']>;
  trimSelections?: InputMaybe<CutsheetResponseTrimResponseInput>;
};

export type GameKioskCutsheetResponse = {
  __typename?: 'GameKioskCutsheetResponse';
  catalog: GameKioskCatalog;
  questionnaire: CutsheetQuestionnaire;
};

export type GameKioskDropoffInput = {
  animalCount?: InputMaybe<Scalars['Int']['input']>;
  animalSpecies: Scalars['String']['input'];
  cutsheets: Array<InputMaybe<GameKioskCutsheetInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  hunterName: Scalars['String']['input'];
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type GameKioskDropoffResponse = {
  __typename?: 'GameKioskDropoffResponse';
  animalCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  processorName: Scalars['String']['output'];
  replayed: Scalars['Boolean']['output'];
};

export type GameKioskResponse = {
  __typename?: 'GameKioskResponse';
  processorName: Scalars['String']['output'];
  processorSettings: Scalars['MongoID']['output'];
  species?: Maybe<Array<Maybe<GameKioskSpecies>>>;
  vendor: Scalars['MongoID']['output'];
};

export type GameKioskSpecies = {
  __typename?: 'GameKioskSpecies';
  cutsheets?: Maybe<Array<Maybe<GameKioskCutsheet>>>;
  inspectionLevels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label: Scalars['String']['output'];
  schedulingDeposit: Scalars['Float']['output'];
  species: Scalars['String']['output'];
};

export type GenerateBillingStatementResponse = {
  __typename?: 'GenerateBillingStatementResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateBulkCarcassTagsResponse = {
  __typename?: 'GenerateBulkCarcassTagsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateBulkCutsheetsResponse = {
  __typename?: 'GenerateBulkCutsheetsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateCarcassTagsResponse = {
  __typename?: 'GenerateCarcassTagsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateCsvResponse = {
  __typename?: 'GenerateCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GenerateCutsheetQuestionnairePayload = {
  __typename?: 'GenerateCutsheetQuestionnairePayload';
  name: Scalars['String']['output'];
  questionCount: Scalars['Int']['output'];
  questionnaireId: Scalars['MongoID']['output'];
};

export type GenerateCutsheetResponse = {
  __typename?: 'GenerateCutsheetResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateHangingWeightCsvResponse = {
  __typename?: 'GenerateHangingWeightCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GenerateInvoicePdfResponse = {
  __typename?: 'GenerateInvoicePdfResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateKillSheetResponse = {
  __typename?: 'GenerateKillSheetResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GeneratePackingSlipResponse = {
  __typename?: 'GeneratePackingSlipResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateUploadUrlPayload = {
  __typename?: 'GenerateUploadUrlPayload';
  /** Public CDN URL the uploaded file will be accessible at (public uploads only) */
  cdnUrl: Scalars['String']['output'];
  /** Presigned S3 PUT URL — expires in expiresIn seconds */
  uploadUrl: Scalars['String']['output'];
};

export type GeocodeLocationResult = {
  __typename?: 'GeocodeLocationResult';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type HangTimePreferenceResponse = {
  __typename?: 'HangTimePreferenceResponse';
  success: Scalars['Boolean']['output'];
};

export type HerdAssignToJobPayload = {
  __typename?: 'HerdAssignToJobPayload';
  assignedCount: Scalars['Int']['output'];
  jobId: Scalars['MongoID']['output'];
};

export type HerdIntakeProducerInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
};

export type HerdSplitBuyerInput = {
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart: Scalars['String']['input'];
};

export type Holiday = {
  __typename?: 'Holiday';
  country: Scalars['String']['output'];
  date: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type HolidaysMeta = {
  __typename?: 'HolidaysMeta';
  count: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  end: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type HolidaysResponse = {
  __typename?: 'HolidaysResponse';
  holidays?: Maybe<Array<Maybe<Holiday>>>;
  meta?: Maybe<HolidaysMeta>;
};

/** The signed-in user's in-app notification feed and unseen badge count. */
export type InAppNotificationFeed = {
  __typename?: 'InAppNotificationFeed';
  items?: Maybe<Array<Maybe<InAppNotificationItem>>>;
  unseenCount: Scalars['Int']['output'];
};

export type InAppNotificationItem = {
  __typename?: 'InAppNotificationItem';
  _id: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  prompt?: Maybe<NotificationPromptState>;
  promptText?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  trigger?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InHouseProducer = {
  __typename?: 'InHouseProducer';
  canList?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['MongoID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  missingRequirements?: Maybe<Array<Scalars['String']['output']>>;
  picture_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type Integration = {
  __typename?: 'Integration';
  _id: Scalars['MongoID']['output'];
  adapter?: Maybe<Scalars['String']['output']>;
  autoPoll?: Maybe<Scalars['Boolean']['output']>;
  autoPush?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  inbound?: Maybe<IntegrationInbound>;
  /** Where this connection's partner posts data back. The same URL serves every connection to an adapter; the bearer token is what says which. */
  inboundUrl?: Maybe<Scalars['String']['output']>;
  instanceRef?: Maybe<Scalars['String']['output']>;
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  /** Masked form of the configured API key — enough to identify it, never enough to use it. */
  keyHint?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastDeliveryAt?: Maybe<Scalars['Date']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastErrorAt?: Maybe<Scalars['Date']['output']>;
  lastSynced?: Maybe<Scalars['Date']['output']>;
  name: EnumIntegrationName;
  subscribedEvents?: Maybe<Array<Maybe<EnumIntegrationSubscribedEvents>>>;
  type: EnumIntegrationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};

export type IntegrationAdapterConfigField = {
  __typename?: 'IntegrationAdapterConfigField';
  advanced?: Maybe<Scalars['Boolean']['output']>;
  help?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  keyLabel?: Maybe<Scalars['String']['output']>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  overrideToggleKey?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  valueLabel?: Maybe<Scalars['String']['output']>;
};

export type IntegrationAdapterCredentialField = {
  __typename?: 'IntegrationAdapterCredentialField';
  advanced?: Maybe<Scalars['Boolean']['output']>;
  help?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationAdapterInfo = {
  __typename?: 'IntegrationAdapterInfo';
  allowsMultiple: Scalars['Boolean']['output'];
  configFields: Array<IntegrationAdapterConfigField>;
  configurableEvents: Scalars['Boolean']['output'];
  credentialFields: Array<IntegrationAdapterCredentialField>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  subscribes: Array<Scalars['String']['output']>;
  supportsInbound: Scalars['Boolean']['output'];
  supportsPolling: Scalars['Boolean']['output'];
  supportsProducts: Scalars['Boolean']['output'];
};

export type IntegrationDelivery = {
  __typename?: 'IntegrationDelivery';
  _id: Scalars['MongoID']['output'];
  adapter: Scalars['String']['output'];
  attempts: Scalars['Float']['output'];
  cause?: Maybe<IntegrationDeliveryCause>;
  claimedUntil?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  eventId: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  integration: Scalars['MongoID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  manual?: Maybe<Scalars['Boolean']['output']>;
  nextAttemptAt?: Maybe<Scalars['Date']['output']>;
  occurredAt: Scalars['Date']['output'];
  status: EnumIntegrationDeliveryStatus;
  subjectId: Scalars['MongoID']['output'];
  subjectType: EnumIntegrationDeliverySubjectType;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type IntegrationDeliveryAttempt = {
  __typename?: 'IntegrationDeliveryAttempt';
  _id: Scalars['MongoID']['output'];
  adapter: Scalars['String']['output'];
  at: Scalars['Date']['output'];
  attempt: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  delivery: Scalars['MongoID']['output'];
  durationMs: Scalars['Float']['output'];
  error?: Maybe<Scalars['String']['output']>;
  exchanges?: Maybe<Array<Maybe<IntegrationDeliveryAttemptExchanges>>>;
  integration: Scalars['MongoID']['output'];
  outcome: EnumIntegrationDeliveryAttemptOutcome;
  statusCode?: Maybe<Scalars['Float']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type IntegrationDeliveryAttemptExchanges = {
  __typename?: 'IntegrationDeliveryAttemptExchanges';
  durationMs: Scalars['Float']['output'];
  error?: Maybe<Scalars['String']['output']>;
  method: Scalars['String']['output'];
  requestBody?: Maybe<Scalars['String']['output']>;
  requestHeaders?: Maybe<Scalars['JSON']['output']>;
  responseBody?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  truncated?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

/** List of items with pagination. */
export type IntegrationDeliveryAttemptPagination = {
  __typename?: 'IntegrationDeliveryAttemptPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<IntegrationDeliveryAttempt>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IntegrationDeliveryCause = {
  __typename?: 'IntegrationDeliveryCause';
  changedPaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  documentId?: Maybe<Scalars['MongoID']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type IntegrationDeliveryPagination = {
  __typename?: 'IntegrationDeliveryPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<IntegrationDelivery>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IntegrationInbound = {
  __typename?: 'IntegrationInbound';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  issuedAt?: Maybe<Scalars['Date']['output']>;
  lastPolledAt?: Maybe<Scalars['Date']['output']>;
  pollCursor?: Maybe<Scalars['String']['output']>;
  tokenHint?: Maybe<Scalars['String']['output']>;
  weightMode?: Maybe<EnumIntegrationInboundWeightMode>;
};

export type IntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type IntegrationInboundRecord = {
  __typename?: 'IntegrationInboundRecord';
  _id: Scalars['MongoID']['output'];
  adapter: Scalars['String']['output'];
  appliedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalRef?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  identifiers?: Maybe<Scalars['JSON']['output']>;
  integration: Scalars['MongoID']['output'];
  kind: EnumIntegrationInboundRecordKind;
  liveWeightLbs?: Maybe<Scalars['Float']['output']>;
  match?: Maybe<IntegrationInboundRecordMatch>;
  rawPayload?: Maybe<Scalars['JSON']['output']>;
  receivedAt: Scalars['Date']['output'];
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  resolvedBy?: Maybe<Scalars['MongoID']['output']>;
  status: EnumIntegrationInboundRecordStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
  weightLbs?: Maybe<Scalars['Float']['output']>;
  yieldLines?: Maybe<Array<Maybe<IntegrationInboundRecordYieldLines>>>;
};

export type IntegrationInboundRecordMatch = {
  __typename?: 'IntegrationInboundRecordMatch';
  animal?: Maybe<Scalars['MongoID']['output']>;
  animalHeadId?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Scalars['MongoID']['output']>;
  matchedOn?: Maybe<Scalars['String']['output']>;
  matchedValue?: Maybe<Scalars['String']['output']>;
  split?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type IntegrationInboundRecordPagination = {
  __typename?: 'IntegrationInboundRecordPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<IntegrationInboundRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IntegrationInboundRecordYieldLines = {
  __typename?: 'IntegrationInboundRecordYieldLines';
  itemCount?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  packageCount?: Maybe<Scalars['Float']['output']>;
  partnerLabel?: Maybe<Scalars['String']['output']>;
  partnerSku?: Maybe<Scalars['String']['output']>;
  weightLbs: Scalars['Float']['output'];
};

/** List of items with pagination. */
export type IntegrationPagination = {
  __typename?: 'IntegrationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Integration>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IntegrationPartnerProduct = {
  __typename?: 'IntegrationPartnerProduct';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IntegrationPartnerProducts = {
  __typename?: 'IntegrationPartnerProducts';
  error?: Maybe<Scalars['String']['output']>;
  products: Array<IntegrationPartnerProduct>;
  supported: Scalars['Boolean']['output'];
};

export type IntegrationPollNowResult = {
  __typename?: 'IntegrationPollNowResult';
  applied: Scalars['Int']['output'];
  duplicates: Scalars['Int']['output'];
  matched: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  received: Scalars['Int']['output'];
  unmatched: Scalars['Int']['output'];
};

export type IntegrationPreflightFinding = {
  __typename?: 'IntegrationPreflightFinding';
  area: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: Scalars['String']['output'];
};

export type IntegrationPreflightResult = {
  __typename?: 'IntegrationPreflightResult';
  findings: Array<IntegrationPreflightFinding>;
  mappedOptions: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type IntegrationRetryResult = {
  __typename?: 'IntegrationRetryResult';
  reason?: Maybe<Scalars['String']['output']>;
  requeued: Scalars['Int']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['MongoID']['output'];
  amount_discounted?: Maybe<Scalars['Float']['output']>;
  amount_due: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  amount_refunded?: Maybe<Scalars['Float']['output']>;
  billing_month?: Maybe<Scalars['Float']['output']>;
  billing_year?: Maybe<Scalars['Float']['output']>;
  date_created: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  discounts?: Maybe<Array<Maybe<InvoiceDiscounts>>>;
  due_date: Scalars['Date']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_links?: Maybe<InvoiceExternal_Links>;
  /** What this invoice now means for its job and the customer's balance with the vendor. Computed on read — select it on a mutation's result to see the state after that mutation. */
  followUp?: Maybe<InvoiceFollowUp>;
  line_items: Array<InvoiceLineItem>;
  links?: Maybe<Array<Maybe<InvoiceLinks>>>;
  linksWithEntities?: Maybe<Array<Maybe<InvoiceLinks>>>;
  number?: Maybe<Scalars['String']['output']>;
  settlement_method?: Maybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: Maybe<Scalars['Date']['output']>;
  settlement_recorded_by?: Maybe<Scalars['MongoID']['output']>;
  status: EnumInvoiceStatus;
  status_changes?: Maybe<Array<Maybe<InvoiceStatus_Changes>>>;
  type: EnumInvoiceType;
  user?: Maybe<User>;
  vendor?: Maybe<Vendor>;
};


export type InvoiceLine_ItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};

export type InvoiceDiscounts = {
  __typename?: 'InvoiceDiscounts';
  _id?: Maybe<Scalars['MongoID']['output']>;
  applied_amount: Scalars['Float']['output'];
  coupon_code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  type: EnumInvoiceDiscountsType;
  value: Scalars['Float']['output'];
};

export type InvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount: Scalars['Float']['input'];
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type: EnumInvoiceDiscountsType;
  value: Scalars['Float']['input'];
};

export type InvoiceExternal_Links = {
  __typename?: 'InvoiceExternal_links';
  _id?: Maybe<Scalars['MongoID']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  quickbooks?: Maybe<Scalars['JSON']['output']>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type InvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type InvoiceFollowUp = {
  __typename?: 'InvoiceFollowUp';
  customerOpenInvoiceCount: Scalars['Int']['output'];
  customerOutstandingBalance: Scalars['Float']['output'];
  jobId?: Maybe<Scalars['MongoID']['output']>;
  jobSettled: Scalars['Boolean']['output'];
  jobStatus?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_links?: Maybe<InvoiceLineItemExternal_Links>;
  invoice?: Maybe<Invoice>;
  links?: Maybe<Array<Maybe<InvoiceLineItemLinks>>>;
  quantity: Scalars['Float']['output'];
};

export type InvoiceLineItemExternal_Links = {
  __typename?: 'InvoiceLineItemExternal_links';
  _id?: Maybe<Scalars['MongoID']['output']>;
  quickbooks?: Maybe<Scalars['JSON']['output']>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type InvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type InvoiceLineItemLinks = {
  __typename?: 'InvoiceLineItemLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  entityType: EnumInvoiceLineItemLinksEntityType;
  parentEntityId: Scalars['MongoID']['output'];
  subEntityId?: Maybe<Scalars['MongoID']['output']>;
};

export type InvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  entityType: EnumInvoiceLineItemLinksEntityType;
  parentEntityId: Scalars['MongoID']['input'];
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type InvoiceLineItemPagination = {
  __typename?: 'InvoiceLineItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<InvoiceLineItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InvoiceLinks = {
  __typename?: 'InvoiceLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  /** The linked entity (ProcessorScheduling, AnimalHead, or Cutsheet) */
  entity?: Maybe<Scalars['JSON']['output']>;
  entityType: EnumInvoiceLinksEntityType;
  parentEntityId: Scalars['MongoID']['output'];
  subEntityId?: Maybe<Scalars['MongoID']['output']>;
};

export type InvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  entityType: EnumInvoiceLinksEntityType;
  parentEntityId: Scalars['MongoID']['input'];
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type InvoicePagination = {
  __typename?: 'InvoicePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Invoice>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InvoiceStatus_Changes = {
  __typename?: 'InvoiceStatus_changes';
  _id?: Maybe<Scalars['MongoID']['output']>;
  date: Scalars['Date']['output'];
  new_status: EnumInvoiceStatus_ChangesNew_Status;
  previous_status: EnumInvoiceStatus_ChangesPrevious_Status;
};

export type InvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date: Scalars['Date']['input'];
  new_status: EnumInvoiceStatus_ChangesNew_Status;
  previous_status: EnumInvoiceStatus_ChangesPrevious_Status;
};

export type InvoiceUpdateLineItemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type JobIntegrationPushResult = {
  __typename?: 'JobIntegrationPushResult';
  integrations: Array<Scalars['String']['output']>;
  queued: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type JobTag = {
  __typename?: 'JobTag';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  icon: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  species?: Maybe<Array<Maybe<EnumJobTagSpecies>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type JobTagPagination = {
  __typename?: 'JobTagPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<JobTag>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type KillSheetDocumentSettingsInput = {
  fields?: InputMaybe<Array<InputMaybe<DocumentFieldEntryInput>>>;
};

export type KillSheetPreviewResponse = {
  __typename?: 'KillSheetPreviewResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type LandingPageAddressInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPageContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPageDocumentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LandingPageFaqItemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type LandingPagePremierProducerInput = {
  badge?: InputMaybe<Scalars['String']['input']>;
  producerId: Scalars['MongoID']['input'];
};

export type LandingPagePricingRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPageSettings = {
  __typename?: 'LandingPageSettings';
  _id: Scalars['MongoID']['output'];
  about?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  boxImageUrl?: Maybe<Scalars['String']['output']>;
  buyerBio?: Maybe<Scalars['String']['output']>;
  buyerChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contact?: Maybe<LandingPageSettingsContact>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  documents?: Maybe<Array<Maybe<LandingPageSettingsDocuments>>>;
  faq?: Maybe<Array<Maybe<LandingPageSettingsFaq>>>;
  galleryImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<LandingPageSettingsLocation>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  premierProducers?: Maybe<Array<Maybe<LandingPageSettingsPremierProducers>>>;
  pricingRows?: Maybe<Array<Maybe<LandingPageSettingsPricingRows>>>;
  showAbout?: Maybe<Scalars['Boolean']['output']>;
  showAddress?: Maybe<Scalars['Boolean']['output']>;
  showCommunityListings?: Maybe<Scalars['Boolean']['output']>;
  showContact?: Maybe<Scalars['Boolean']['output']>;
  showDocuments?: Maybe<Scalars['Boolean']['output']>;
  showFaq?: Maybe<Scalars['Boolean']['output']>;
  showGallery?: Maybe<Scalars['Boolean']['output']>;
  showInDirectory?: Maybe<Scalars['Boolean']['output']>;
  showOnMap?: Maybe<Scalars['Boolean']['output']>;
  showPricing?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Array<Maybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagline?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type LandingPageSettingsContact = {
  __typename?: 'LandingPageSettingsContact';
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type LandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPageSettingsDocuments = {
  __typename?: 'LandingPageSettingsDocuments';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LandingPageSettingsFaq = {
  __typename?: 'LandingPageSettingsFaq';
  _id?: Maybe<Scalars['MongoID']['output']>;
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type LandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type LandingPageSettingsLocation = {
  __typename?: 'LandingPageSettingsLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<EnumLandingPageSettingsLocationType>;
};

export type LandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

/** List of items with pagination. */
export type LandingPageSettingsPagination = {
  __typename?: 'LandingPageSettingsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<LandingPageSettings>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LandingPageSettingsPremierProducers = {
  __typename?: 'LandingPageSettingsPremierProducers';
  badge: EnumLandingPageSettingsPremierProducersBadge;
  producerId: Scalars['MongoID']['output'];
};

export type LandingPageSettingsPremierProducersInput = {
  badge: EnumLandingPageSettingsPremierProducersBadge;
  producerId: Scalars['MongoID']['input'];
};

export type LandingPageSettingsPricingRows = {
  __typename?: 'LandingPageSettingsPricingRows';
  _id?: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type LandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPageUpsertInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<LandingPageAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<LandingPageContactInput>;
  documents?: InputMaybe<Array<InputMaybe<LandingPageDocumentInput>>>;
  faq?: InputMaybe<Array<InputMaybe<LandingPageFaqItemInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<LandingPagePremierProducerInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<LandingPagePricingRowInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<EnumProcessorSettingsAnimalSettingsSpecies>>;
  storefrontProducers?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type LegacyCapabilityData = {
  __typename?: 'LegacyCapabilityData';
  cuts: Array<Maybe<LegacyCut>>;
  extras: Array<Maybe<LegacyExtra>>;
  inspectionLevel: Scalars['String']['output'];
  specifications: Array<Maybe<LegacySpecification>>;
  trims: Array<Maybe<LegacyTrim>>;
};

export type LegacyCut = {
  __typename?: 'LegacyCut';
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
  primalName?: Maybe<Scalars['String']['output']>;
};

export type LegacyExtra = {
  __typename?: 'LegacyExtra';
  name: Scalars['String']['output'];
};

export type LegacySpecification = {
  __typename?: 'LegacySpecification';
  name: Scalars['String']['output'];
};

export type LegacyTrim = {
  __typename?: 'LegacyTrim';
  name: Scalars['String']['output'];
};

export type LinkableProducer = {
  __typename?: 'LinkableProducer';
  _id?: Maybe<Scalars['MongoID']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  isStaffAccount?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
};

export type ManualNotificationOption = {
  __typename?: 'ManualNotificationOption';
  eventType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notificationSettingId: Scalars['MongoID']['output'];
  recipients: Array<ManualNotificationRecipient>;
  sendEmail: Scalars['Boolean']['output'];
  sendSMS: Scalars['Boolean']['output'];
  trigger: Scalars['String']['output'];
};

export type ManualNotificationRecipient = {
  __typename?: 'ManualNotificationRecipient';
  defaultSelected: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  userId: Scalars['MongoID']['output'];
};

export type ManualNotificationRecipientInput = {
  mediums: Array<Scalars['String']['input']>;
  userId: Scalars['MongoID']['input'];
};

export type MarkAsPaidInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['MongoID']['input'];
};

export type MarketplaceInterest = {
  __typename?: 'MarketplaceInterest';
  _id: Scalars['MongoID']['output'];
  buyer: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastNotifiedAt?: Maybe<Scalars['Date']['output']>;
  producer?: Maybe<User>;
  species: EnumMarketplaceInterestSpecies;
  unsubscribeToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};

export type MarketplaceLead = {
  __typename?: 'MarketplaceLead';
  _id: Scalars['MongoID']['output'];
  buyer?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  location?: Maybe<MarketplaceLeadLocation>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  quantity: EnumMarketplaceLeadQuantity;
  source?: Maybe<EnumMarketplaceLeadSource>;
  species: EnumMarketplaceLeadSpecies;
  timeline: EnumMarketplaceLeadTimeline;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MarketplaceLeadExportCsvResponse = {
  __typename?: 'MarketplaceLeadExportCsvResponse';
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type MarketplaceLeadLocation = {
  __typename?: 'MarketplaceLeadLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<EnumMarketplaceLeadLocationType>;
};

export type MarketplaceLeadSearchResult = {
  __typename?: 'MarketplaceLeadSearchResult';
  records: Array<MarketplaceLead>;
  total: Scalars['Int']['output'];
};

export type MarketplaceRequest = {
  __typename?: 'MarketplaceRequest';
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  buyer: Scalars['MongoID']['output'];
  buyerContact?: Maybe<MarketplaceRequestBuyerContact>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  declinedAt?: Maybe<Scalars['Date']['output']>;
  /** Server-computed buyer deposit (dollars) for this request's {species, splitType}, from the vendor's ProcessorSettings. Null when the size is unpriced. */
  depositAmount?: Maybe<Scalars['Float']['output']>;
  desiredPickupDate?: Maybe<Scalars['String']['output']>;
  expiryNotifiedAt?: Maybe<Scalars['Date']['output']>;
  fulfilledAt?: Maybe<Scalars['Date']['output']>;
  fulfilledSplit?: Maybe<Scalars['MongoID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  species: EnumMarketplaceRequestSpecies;
  splitType: EnumMarketplaceRequestSplitType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};

export type MarketplaceRequestBuyerContact = {
  __typename?: 'MarketplaceRequestBuyerContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type MonthlyModifiersInput = {
  april: Scalars['Float']['input'];
  august: Scalars['Float']['input'];
  december: Scalars['Float']['input'];
  february: Scalars['Float']['input'];
  january: Scalars['Float']['input'];
  july: Scalars['Float']['input'];
  june: Scalars['Float']['input'];
  march: Scalars['Float']['input'];
  may: Scalars['Float']['input'];
  november: Scalars['Float']['input'];
  october: Scalars['Float']['input'];
  september: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  CutsheetCapabilityCreateMany?: Maybe<CreateManyCutsheetCapabilityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  CutsheetCapabilityCreateOne?: Maybe<CreateOneCutsheetCapabilityPayload>;
  /** Delete cutsheet capabilities */
  CutsheetCapabilityDelete: Scalars['Boolean']['output'];
  /** Copy catalog (groups, cuts/trims/extras, specifications) and optionally questionnaires/assignment rules from one capability set to another. Target must be empty. */
  CutsheetCapabilityDuplicate?: Maybe<CutsheetCapabilityDuplicateResponse>;
  /** Migrate legacy ProcessorCapability data into a cutsheet capability (groups, options, specs, questionnaires, rules) */
  CutsheetCapabilityMigrateLegacy?: Maybe<CutsheetCapabilityMigrateLegacyResponse>;
  /** Save PDF print/layout settings for a cutsheet capability */
  CutsheetCapabilityPrintSettingsUpdate?: Maybe<CutsheetCapability>;
  /** Set the full legacy mapping (questionnaires + item-level mappings) on a capability */
  CutsheetCapabilitySetLegacyMap?: Maybe<CutsheetCapability>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CutsheetCapabilityUpdateById?: Maybe<UpdateByIdCutsheetCapabilityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  CutsheetCapabilityUpdateMany?: Maybe<UpdateManyCutsheetCapabilityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CutsheetCapabilityUpdateOne?: Maybe<UpdateOneCutsheetCapabilityPayload>;
  /** Create or update cutsheet capabilities */
  CutsheetCapabilityUpsert?: Maybe<CutsheetCapability>;
  /** Add a processor phone number to the Twilio Messaging Service for Conversations */
  addPhoneToMessagingService?: Maybe<AddPhoneToMessagingServiceResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addressCreateMany?: Maybe<CreateManyAddressPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addressCreateOne?: Maybe<CreateOneAddressPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  addressUpdateById?: Maybe<UpdateByIdAddressPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  addressUpdateMany?: Maybe<UpdateManyAddressPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  addressUpdateOne?: Maybe<UpdateOneAddressPayload>;
  /** Admin only: clear a processor's veto stamp from an animal's listing, unblocking the producer's ability to re-list it. */
  adminClearListingVeto?: Maybe<Animal>;
  /** Admin only: force-settle an Order's invoice off-platform (no Stripe charge) — flip it to paid via the shared in-person settle recorder with byRole admin. Covers off-Stripe/off-platform balance collection. */
  adminForceSettleOrderBalance?: Maybe<OrderInvoiceResult>;
  /** Admin-only update of a user (contact, role, relationships). */
  adminUserUpdate?: Maybe<User>;
  /** Force update the status of a single animal, bypassing forward-only validation and all workflow side effects. Intended for administrative corrections (e.g. a head marked Harvested by mistake). Records a status history entry; does NOT re-derive the job's status. */
  animalForceUpdateStatus?: Maybe<AnimalForceUpdateStatusResponse>;
  /** Apply the approved subset of AI-proposed changes to a capability catalog */
  applyCutsheetCatalogChanges?: Maybe<CutsheetApplyCatalogChangesPayload>;
  /** Apply the approved subset of AI-proposed questionnaire changes to a draft */
  applyCutsheetQuestionnaireChanges?: Maybe<CutsheetApplyQuestionnaireChangesPayload>;
  authCheckUser?: Maybe<AuthCheckUserPayload>;
  authConfirmForgotPassword?: Maybe<AuthConfirmForgotPasswordPayload>;
  authForgotPassword?: Maybe<AuthForgotPasswordPayload>;
  authLoginOAuth?: Maybe<AuthLoginOAuthPayload>;
  authLoginPassword?: Maybe<AuthLoginPasswordPayload>;
  authRefreshToken?: Maybe<AuthRefreshTokenPayload>;
  authRegister?: Maybe<AuthRegisterPayload>;
  authRegisterAndSignIn?: Maybe<AuthRegisterAndSignInPayload>;
  authSendOTP?: Maybe<AuthSendOtpPayload>;
  authVerifyOTP?: Maybe<AuthVerifyOtpPayload>;
  /** Create a deposit PaymentIntent before a self-serve booking. */
  bookingDepositPaymentIntentCreate?: Maybe<BookingDepositPaymentIntentResponse>;
  /** Extract a cutsheet (PDF or image) into an existing capability catalog, without generating a questionnaire */
  buildCutsheetCatalog?: Maybe<BuildCutsheetCatalogPayload>;
  /** Add another section on an animal the signed-in buyer already owns a section on. Session-scoped: buyerId derives from the signed-in user. */
  buyerAddAnimalSection?: Maybe<Split>;
  /** Cancel the signed-in buyer's own open split request. Session-scoped and ownership-checked; sets active:false + cancelledAt without deleting the row. Rejects (without revealing why) a non-owned, non-existent, or already-inactive request id. */
  buyerCancelRequest?: Maybe<MarketplaceRequest>;
  /** Cancel the buyer's own pending (requested), claimed, or confirmed (deposit-paid) split. Session-scoped: buyerId derives from the signed-in user. Confirmed splits trigger a deposit refund before soft-delete. */
  buyerCancelSplit?: Maybe<Split>;
  /** Directly claim a section on a published direct-claim animal. Session-scoped: buyerId derives from the signed-in user. */
  buyerClaimSplit?: Maybe<Split>;
  /** Create an embedded Stripe Checkout session for the balance on the buyer's invoiced Order — a direct charge on the recipient's connected account (the producer's for a producer-listed sale) with NO platform fee — and return its client secret. Session-scoped + IDOR-checked against the Order's buyer. */
  buyerCreateBalanceCheckout?: Maybe<BuyerBalanceCheckoutResponse>;
  /** Open an in-app payment session for a producer-listed Order's combined settlement charge (producer sale + processor fee in ONE PaymentIntent on the Farmshare platform account) and return the client secret plus saved cards. Session-scoped + IDOR-checked against the Order's buyer. Creating the downstream Transfers happens later, on payment success. */
  buyerCreateCombinedSettlementIntent?: Maybe<BuyerCreateCombinedSettlementIntentResponse>;
  /** Create an embedded Stripe Checkout session for the deposit on a claimed marketplace split and return its client secret. Session-scoped: buyerId derives from the signed-in user. */
  buyerCreateDepositCheckout?: Maybe<BuyerDepositCheckoutResponse>;
  /** Create or reuse a Stripe PaymentIntent for the deposit on a claimed marketplace split and return its client secret. Service fee added on top. Session-scoped: buyerId derives from the signed-in user. */
  buyerCreateDepositIntent?: Maybe<BuyerDepositIntentResponse>;
  /** Tokenized, no-login unsubscribe for a single marketplace-interest subscription. Soft-deletes exactly the {vendor, species} row the token was issued for. Idempotent; always returns true and never reveals whether the token/subscription exists. */
  buyerInterestUnsubscribe: Scalars['Boolean']['output'];
  /** Open an in-app payment session for the session buyer's processing invoice and return the PaymentIntent client secret plus saved cards. */
  buyerPayInvoice?: Maybe<BuyerPayInvoiceResponse>;
  /** Open an in-app payment session for the balance on the buyer's stripe invoice (a separate balance PaymentIntent on the recipient's connected account — the producer's for a producer-listed sale, else the processor's) and return the client secret plus saved cards. Session-scoped + IDOR-checked against the Order's buyer. */
  buyerPayOrderBalance?: Maybe<BuyerPayOrderBalanceResponse>;
  /** Register a buyer's interest in a processor + species combination (mailing list opt-in). Session-scoped: buyerId derives from the signed-in user. Idempotent. */
  buyerRegisterInterest?: Maybe<MarketplaceInterest>;
  /** Register a buyer's interest in a producer + species combination ("Follow a Producer"). Session-scoped: buyerId derives from the signed-in user. Idempotent. */
  buyerRegisterProducerInterest?: Maybe<MarketplaceInterest>;
  /** Remove (soft-delete) a buyer's interest in a processor + species combination. Session-scoped: buyerId derives from the signed-in user. Idempotent. */
  buyerRemoveInterest?: Maybe<MarketplaceInterest>;
  /** Remove (soft-delete) a buyer's interest in a producer + species combination. Session-scoped: buyerId derives from the signed-in user. Idempotent. */
  buyerRemoveProducerInterest?: Maybe<MarketplaceInterest>;
  /** Submit a buyer split request (species + size) to a processor. Session-scoped: buyerId derives from the signed-in user. Reactivates a cancelled match; rejects an active duplicate. */
  buyerSubmitRequest?: Maybe<MarketplaceRequest>;
  /** Sync an Order balance payment on return from hosted Stripe Checkout. Retrieves the session and records the balance paid on the Order if settled. Idempotent. Session-scoped + IDOR-checked. */
  buyerSyncBalanceCheckout?: Maybe<BuyerSyncBalanceCheckoutResponse>;
  /** Sync a combined-settlement payment after the Payment Element confirms. Retrieves the Order's stamped combined PaymentIntent and, if succeeded, settles the producer/processor transfers (idempotent alongside the webhook). Session-scoped + IDOR-checked. */
  buyerSyncCombinedSettlement?: Maybe<BuyerSyncCombinedSettlementResponse>;
  /** Sync a marketplace deposit on return from hosted Stripe Checkout. Retrieves the session and confirms the split if paid. Idempotent. */
  buyerSyncDepositCheckout?: Maybe<BuyerSyncDepositCheckoutResponse>;
  /** Sync a marketplace deposit on return from the Payment Element. Retrieves the PaymentIntent and confirms the split if paid. Idempotent. */
  buyerSyncDepositIntent?: Maybe<BuyerSyncDepositIntentResponse>;
  /** Sync an Order balance payment on return from the Payment Element. Retrieves the balance PaymentIntent and records it paid on the Order if settled. Idempotent. Session-scoped + IDOR-checked. */
  buyerSyncOrderBalance?: Maybe<BuyerSyncOrderBalanceResponse>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  calendarEventCreateOne?: Maybe<CreateOneCalendarEventPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  calendarEventRemoveById?: Maybe<RemoveByIdCalendarEventPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  calendarEventTypeCreateOne?: Maybe<CreateOneCalendarEventTypePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  calendarEventTypeRemoveById?: Maybe<RemoveByIdCalendarEventTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  calendarEventTypeUpdateById?: Maybe<UpdateByIdCalendarEventTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  calendarEventUpdateById?: Maybe<UpdateByIdCalendarEventPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cancellationReasonCreateMany?: Maybe<CreateManyCancellationReasonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cancellationReasonCreateOne?: Maybe<CreateOneCancellationReasonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cancellationReasonUpdateById?: Maybe<UpdateByIdCancellationReasonPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cancellationReasonUpdateMany?: Maybe<UpdateManyCancellationReasonPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cancellationReasonUpdateOne?: Maybe<UpdateOneCancellationReasonPayload>;
  /** Generates a carcass tag PDF preview using demo data for the given vendor. */
  carcassTagPreview?: Maybe<CarcassTagPreviewResponse>;
  changePassword?: Maybe<ChangePasswordPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  chatRoomCreateOne?: Maybe<CreateOneChatRoomPayload>;
  /** Cancel a CSV import job before import execution starts (column_mapping or data_review stages only) */
  csvImportCancelJob?: Maybe<CsvImportCancelJobPayload>;
  /** Mark a record as deleted (will not be imported) */
  csvImportDeleteRecord?: Maybe<CsvImportDeleteRecordPayload>;
  /** Start importing validated CSV records */
  csvImportExecute?: Maybe<CsvImportExecutePayload>;
  /** Force cancel a stuck CSV import job (admin only). Use with caution as this may leave partial imports. */
  csvImportForceCancel?: Maybe<CsvImportForceCancelPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  csvImportJobCreateMany?: Maybe<CreateManyCsvImportJobPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  csvImportJobCreateOne?: Maybe<CreateOneCsvImportJobPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  csvImportJobUpdateById?: Maybe<UpdateByIdCsvImportJobPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  csvImportJobUpdateMany?: Maybe<UpdateManyCsvImportJobPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  csvImportJobUpdateOne?: Maybe<UpdateOneCsvImportJobPayload>;
  /** Re-validate edited CSV data for an import job */
  csvImportRevalidate?: Maybe<CsvImportRevalidatePayload>;
  /** Save column mapping for a CSV import job and re-validate data */
  csvImportSaveColumnMapping?: Maybe<CsvImportSaveColumnMappingPayload>;
  /** Update specific rows and re-validate CSV import data */
  csvImportUpdateRows?: Maybe<CsvImportUpdateRowsPayload>;
  /** Upload and validate a CSV file for bulk import */
  csvImportUpload?: Maybe<CsvImportUploadPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  customFieldDefinitionCreateMany?: Maybe<CreateManyCustomFieldDefinitionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  customFieldDefinitionCreateOne?: Maybe<CreateOneCustomFieldDefinitionPayload>;
  /** Soft delete a custom field definition. */
  customFieldDefinitionSoftDelete?: Maybe<CustomFieldDefinition>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  customFieldDefinitionUpdateById?: Maybe<UpdateByIdCustomFieldDefinitionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  customFieldDefinitionUpdateMany?: Maybe<UpdateManyCustomFieldDefinitionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  customFieldDefinitionUpdateOne?: Maybe<UpdateOneCustomFieldDefinitionPayload>;
  customFieldValueBulkSave?: Maybe<CustomFieldValueBulkSaveResponse>;
  customFieldValueClear?: Maybe<CustomFieldValueClearResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  customFieldValueCreateMany?: Maybe<CreateManyCustomFieldValuePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  customFieldValueCreateOne?: Maybe<CreateOneCustomFieldValuePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  customFieldValueUpdateById?: Maybe<UpdateByIdCustomFieldValuePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  customFieldValueUpdateMany?: Maybe<UpdateManyCustomFieldValuePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  customFieldValueUpdateOne?: Maybe<UpdateOneCustomFieldValuePayload>;
  /** Delete a customer with zero associated records for this vendor. A single-vendor customer is soft-deleted (login disabled); a multi-vendor customer is detached from this vendor only, keeping the account and login intact for the others. Records a CustomerMergeOperation of type 'delete'. Throws if the customer has associated records (merge instead). */
  customerDelete?: Maybe<CustomerDeleteResult>;
  /** Merge up to two losers into a master (single-vendor / Regime-1). Runs pairwise under the hood: one CustomerMergeOperation per loser. Identity fields are pulled onto the master per fieldSelections. */
  customerMerge?: Maybe<CustomerMergeResult>;
  customerNotificationPreferenceUpdate?: Maybe<Array<Maybe<NotificationPreference>>>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetAssignmentRuleSetCreateMany?: Maybe<CreateManyCutsheetAssignmentRuleSetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetAssignmentRuleSetCreateOne?: Maybe<CreateOneCutsheetAssignmentRuleSetPayload>;
  /** Delete the assignment rule set for a cutsheet capability */
  cutsheetAssignmentRuleSetDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetAssignmentRuleSetUpdateById?: Maybe<UpdateByIdCutsheetAssignmentRuleSetPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetAssignmentRuleSetUpdateMany?: Maybe<UpdateManyCutsheetAssignmentRuleSetPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetAssignmentRuleSetUpdateOne?: Maybe<UpdateOneCutsheetAssignmentRuleSetPayload>;
  /** Create or replace the ordered assignment rule set for a cutsheet capability */
  cutsheetAssignmentRuleSetUpsert?: Maybe<CutsheetAssignmentRuleSet>;
  /** Generates a blank cutsheet PDF from a vendor's CutsheetCapability, showing all available cuts/trim/extras with no selections. */
  cutsheetCapabilityGenerateBlankCutsheet?: Maybe<GenerateCutsheetResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCapabilityOptionCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCapabilityOptionCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a capability option */
  cutsheetCapabilityOptionDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCapabilityOptionUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetCapabilityOptionUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCapabilityOptionUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a capability option (cut, trim, or extra) */
  cutsheetCapabilityOptionUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Send a message to the AI catalog assistant for a capability and get its reply */
  cutsheetCatalogChat?: Maybe<CutsheetCatalogChatPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCreateMany?: Maybe<CreateManyCutsheetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCreateOne?: Maybe<CreateOneCutsheetPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCutCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCutCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a cutsheet cut */
  cutsheetCutDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCutUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetCutUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCutUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a cutsheet cut */
  cutsheetCutUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetDescriptionLibraryCreateMany?: Maybe<CreateManyCutsheetDescriptionLibraryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetDescriptionLibraryCreateOne?: Maybe<CreateOneCutsheetDescriptionLibraryPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  cutsheetDescriptionLibraryRemoveById?: Maybe<RemoveByIdCutsheetDescriptionLibraryPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetDescriptionLibraryUpdateById?: Maybe<UpdateByIdCutsheetDescriptionLibraryPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetDescriptionLibraryUpdateMany?: Maybe<UpdateManyCutsheetDescriptionLibraryPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetDescriptionLibraryUpdateOne?: Maybe<UpdateOneCutsheetDescriptionLibraryPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetExtraCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetExtraCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a cutsheet extra */
  cutsheetExtraDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetExtraUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetExtraUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetExtraUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a cutsheet extra */
  cutsheetExtraUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetGroupCreateMany?: Maybe<CreateManyCutsheetCapabilityGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetGroupCreateOne?: Maybe<CreateOneCutsheetCapabilityGroupPayload>;
  /** Delete a cutsheet primal */
  cutsheetGroupDelete: Scalars['Boolean']['output'];
  /** Bulk-update sortOrder for primals in one DB round-trip */
  cutsheetGroupReorder: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetGroupUpdateById?: Maybe<UpdateByIdCutsheetCapabilityGroupPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetGroupUpdateMany?: Maybe<UpdateManyCutsheetCapabilityGroupPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetGroupUpdateOne?: Maybe<UpdateOneCutsheetCapabilityGroupPayload>;
  /** Create or update a cutsheet primal */
  cutsheetGroupUpsert?: Maybe<CutsheetCapabilityGroup>;
  /** Generates a demo cutsheet PDF preview reflecting the vendor’s saved cutsheet header layout. */
  cutsheetHeaderPreview?: Maybe<CutsheetHeaderPreviewResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetImageLibraryCreateMany?: Maybe<CreateManyCutsheetImageLibraryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetImageLibraryCreateOne?: Maybe<CreateOneCutsheetImageLibraryPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  cutsheetImageLibraryRemoveById?: Maybe<RemoveByIdCutsheetImageLibraryPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetImageLibraryUpdateById?: Maybe<UpdateByIdCutsheetImageLibraryPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetImageLibraryUpdateMany?: Maybe<UpdateManyCutsheetImageLibraryPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetImageLibraryUpdateOne?: Maybe<UpdateOneCutsheetImageLibraryPayload>;
  /** Record that a legacy cutsheet has been converted to a new-format CutsheetQuestionnaireResponse. */
  cutsheetMarkConverted?: Maybe<Cutsheet>;
  /** Bulk-update sortOrder for capability options (cuts, trim, extras) */
  cutsheetOptionReorder: Scalars['Boolean']['output'];
  /** Send a message to the AI questionnaire assistant and get back an updated question flow to apply to the draft */
  cutsheetQuestionnaireChat?: Maybe<CutsheetQuestionnaireChatPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetQuestionnaireCreateMany?: Maybe<CreateManyCutsheetQuestionnairePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetQuestionnaireCreateOne?: Maybe<CreateOneCutsheetQuestionnairePayload>;
  /** Archive (soft-delete) a cutsheet questionnaire. Sets status to `archived` so responses referencing it remain intact. */
  cutsheetQuestionnaireDelete: Scalars['Boolean']['output'];
  /** Attach the uploaded paper cutsheet (as page images) to the response created from it */
  cutsheetQuestionnaireResponseAttachSource?: Maybe<CutsheetQuestionnaireResponse>;
  /** Generates a printable PDF for a standalone cutsheet questionnaire response (Cutsheet Library). */
  cutsheetQuestionnaireResponseGeneratePdf?: Maybe<GenerateCutsheetResponse>;
  /** Reassign a cutsheet questionnaire response to a customer */
  cutsheetQuestionnaireResponseReassign?: Maybe<CutsheetQuestionnaireResponse>;
  /** Restore a soft-deleted cutsheet questionnaire response */
  cutsheetQuestionnaireResponseRestore: Scalars['Boolean']['output'];
  /** Soft-delete a cutsheet questionnaire response */
  cutsheetQuestionnaireResponseSoftDelete: Scalars['Boolean']['output'];
  /** Create or update a customer cutsheet questionnaire response */
  cutsheetQuestionnaireResponseUpsert?: Maybe<CutsheetQuestionnaireResponse>;
  /** Un-archive a cutsheet questionnaire, back to `draft` or `published`. */
  cutsheetQuestionnaireRestore: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetQuestionnaireUpdateById?: Maybe<UpdateByIdCutsheetQuestionnairePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetQuestionnaireUpdateMany?: Maybe<UpdateManyCutsheetQuestionnairePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetQuestionnaireUpdateOne?: Maybe<UpdateOneCutsheetQuestionnairePayload>;
  /** Create or update cutsheet questionnaire */
  cutsheetQuestionnaireUpsert?: Maybe<CutsheetQuestionnaire>;
  /** Restore a soft-deleted cutsheet */
  cutsheetRestore?: Maybe<Cutsheet>;
  /** Soft delete of cutsheet */
  cutsheetSoftDelete?: Maybe<Cutsheet>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetSpecificationCreateMany?: Maybe<CreateManyCutsheetCapabilitySpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetSpecificationCreateOne?: Maybe<CreateOneCutsheetCapabilitySpecificationPayload>;
  /** Delete a cutsheet specification */
  cutsheetSpecificationDelete: Scalars['Boolean']['output'];
  /** Bulk-update sortOrder for specifications in one DB round-trip */
  cutsheetSpecificationReorder: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetSpecificationUpdateById?: Maybe<UpdateByIdCutsheetCapabilitySpecificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetSpecificationUpdateMany?: Maybe<UpdateManyCutsheetCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetSpecificationUpdateOne?: Maybe<UpdateOneCutsheetCapabilitySpecificationPayload>;
  /** Create or update a cutsheet specification */
  cutsheetSpecificationUpsert?: Maybe<CutsheetCapabilitySpecification>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetTrimCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetTrimCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a cutsheet trim */
  cutsheetTrimDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetTrimUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetTrimUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetTrimUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a cutsheet trim */
  cutsheetTrimUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetUpdateById?: Maybe<UpdateByIdCutsheetPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetUpdateMany?: Maybe<UpdateManyCutsheetPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetUpdateOne?: Maybe<UpdateOneCutsheetPayload>;
  /** Upsert cutsheet for an animal type. */
  cutsheetUpsert?: Maybe<Cutsheet>;
  /** Cancel a CSV import job before import execution starts (column_mapping, data_hygiene, or data_review stages only) */
  dataImportCancelJob?: Maybe<DataImportCancelJobPayload>;
  /** Clear CS's match decision for a side, returning the identity to its pre-decision bucket */
  dataImportClearMatchDecision?: Maybe<DataImportClearMatchDecisionPayload>;
  /** Mark a record as deleted (will not be imported) */
  dataImportDeleteRecord?: Maybe<DataImportDeleteRecordPayload>;
  /** Enable an animal species on the import job's vendor settings and re-validate every parsedData row so malformed-job flags refresh. */
  dataImportEnableAnimalSpecies?: Maybe<DataImportEnableAnimalSpeciesPayload>;
  /** Start importing validated CSV records */
  dataImportExecute?: Maybe<DataImportExecutePayload>;
  /** Finalize Hygiene: run the matcher against canonicals and transition to Data Review */
  dataImportFinalizeHygiene?: Maybe<DataImportFinalizeHygienePayload>;
  /** Force cancel a stuck CSV import job (admin only). Use with caution as this may leave partial imports. */
  dataImportForceCancel?: Maybe<DataImportForceCancelPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  dataImportJobCreateMany?: Maybe<CreateManyDataImportJobPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  dataImportJobCreateOne?: Maybe<CreateOneDataImportJobPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  dataImportJobUpdateById?: Maybe<UpdateByIdDataImportJobPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  dataImportJobUpdateMany?: Maybe<UpdateManyDataImportJobPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  dataImportJobUpdateOne?: Maybe<UpdateOneDataImportJobPayload>;
  /** Resolve a row's DB job-duplicate flag (keep / skip / clear) in Data Review */
  dataImportResolveJobDuplicate?: Maybe<DataImportResolveJobDuplicatePayload>;
  /** Re-validate edited CSV data for an import job */
  dataImportRevalidate?: Maybe<DataImportRevalidatePayload>;
  /** Revert from Data Review back to Hygiene, snapshotting canonicals for selective decision reset */
  dataImportRevertToHygiene?: Maybe<DataImportRevertToHygienePayload>;
  /** Run the Data Hygiene engine over a customer import jobs parsed rows and persist the cluster + flag state to the session document */
  dataImportRunHygiene?: Maybe<DataImportRunHygienePayload>;
  /** Save column mapping for a CSV import job and re-validate data */
  dataImportSaveColumnMapping?: Maybe<DataImportSaveColumnMappingPayload>;
  /** Apply a Hygiene action (edit-canonical, skip-cluster, resolve-flag, dismiss-flag, merge-clusters, split-cluster, move-row-to-another, undo) to a job */
  dataImportSaveHygieneAction?: Maybe<DataImportSaveHygieneActionPayload>;
  /** Record CS's decision about how to handle a match in the review step */
  dataImportSaveMatchDecision?: Maybe<DataImportSaveMatchDecisionPayload>;
  /** Update specific rows and re-validate CSV import data */
  dataImportUpdateRows?: Maybe<DataImportUpdateRowsPayload>;
  /** Upload and validate a CSV file for bulk import */
  dataImportUpload?: Maybe<DataImportUploadPayload>;
  deleteDuplicatePrimals?: Maybe<DeleteDuplicatePrimalsPayload>;
  /** Create a card PaymentIntent to pay an outstanding deposit. */
  depositPaymentIntentCreate?: Maybe<DepositPaymentIntentResponse>;
  /** Settle an outstanding deposit immediately after its PaymentIntent succeeds (backstopped by the Stripe webhook). */
  depositPaymentIntentSettle?: Maybe<ProcessorScheduling>;
  /** Create a SetupIntent to add a card on file for a customer. */
  depositSetupIntentCreate?: Maybe<DepositSetupIntentResponse>;
  /** Replace a document with a newer version (the previous version is retained). Vendor-scoped. No-ops if the content hash is unchanged. */
  documentAddVersion?: Maybe<Document>;
  /** Persist a new document category for the current vendor. No-ops (returns the existing row) if the name already exists as a global default or a vendor category. */
  documentCategoryUpsert?: Maybe<DocumentCategory>;
  /** Attach an already-uploaded document (via presigned URL) to zero or more customers/jobs as its first version. Vendor and uploader are stamped server-side. */
  documentCreate?: Maybe<Document>;
  /** Save a chat message attachment (image/PDF) as a managed document, copying it into the private documents store and linking it to zero or more customers/jobs. */
  documentCreateFromChatAttachment?: Maybe<Document>;
  /** Delete a document (its S3 object and metadata row). Enforces ownership by the current vendor. */
  documentDelete?: Maybe<Document>;
  /** Make a previous version current again by copying its content forward as a new version (history is preserved linearly). Vendor-scoped. */
  documentRestoreVersion?: Maybe<Document>;
  /** Replace the full set of records a document is linked to. Empty = unassigned. Vendor-scoped; each target is ownership-checked. */
  documentSetLinks?: Maybe<Document>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  exportPresetCreateMany?: Maybe<CreateManyExportPresetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  exportPresetCreateOne?: Maybe<CreateOneExportPresetPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  exportPresetUpdateById?: Maybe<UpdateByIdExportPresetPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  exportPresetUpdateMany?: Maybe<UpdateManyExportPresetPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  exportPresetUpdateOne?: Maybe<UpdateOneExportPresetPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  exportSettingCreateMany?: Maybe<CreateManyExportSettingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  exportSettingCreateOne?: Maybe<CreateOneExportSettingPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  exportSettingUpdateById?: Maybe<UpdateByIdExportSettingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  exportSettingUpdateMany?: Maybe<UpdateManyExportSettingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  exportSettingUpdateOne?: Maybe<UpdateOneExportSettingPayload>;
  /** Delete a historical actuals row. Enforces ownership by the current vendor. */
  financialMetricsActualsRemove?: Maybe<FinancialMetricsActuals>;
  /** Create or update a historical actuals row for the current vendor, keyed on (vendor, period). */
  financialMetricsActualsUpsert?: Maybe<FinancialMetricsActuals>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  financialReportingConfigCreateMany?: Maybe<CreateManyFinancialReportingConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  financialReportingConfigCreateOne?: Maybe<CreateOneFinancialReportingConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  financialReportingConfigUpdateById?: Maybe<UpdateByIdFinancialReportingConfigPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  financialReportingConfigUpdateMany?: Maybe<UpdateManyFinancialReportingConfigPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  financialReportingConfigUpdateOne?: Maybe<UpdateOneFinancialReportingConfigPayload>;
  /** Create or update financial reporting configuration for the current vendor. */
  financialReportingConfigUpsert?: Maybe<FinancialReportingConfig>;
  /** Fix vendor phone config that was not saved correctly during provisioning */
  fixVendorPhoneConfig?: Maybe<FixVendorPhoneConfigResponse>;
  /** Add animals to an existing wild-game drop-off. */
  gameJobAddAnimals?: Maybe<GameJobAddAnimalsResponse>;
  /** Create a wild-game job at drop-off, with no upstream scheduled animal. */
  gameJobCreate?: Maybe<GameJobCreateResponse>;
  /** Get or rotate the wild-game kiosk token for a processor. Minted on first ask. */
  gameKioskAddressSetup?: Maybe<GameKioskAddressSetupResponse>;
  /** Public: a hunter checks in their own drop-off, with a filled cut sheet, at a plant kiosk. */
  gameKioskDropoffCreate?: Maybe<GameKioskDropoffResponse>;
  /** Generates the printable wild-game kiosk QR sign for a processor to hang up. */
  gameKioskSignGenerate?: Maybe<GenerateCutsheetResponse>;
  /** Generate a questionnaire draft from an existing capability's saved catalog */
  generateCutsheetQuestionnaire?: Maybe<GenerateCutsheetQuestionnairePayload>;
  /** Generates a PDF for the specified invoice ID. */
  generateInvoicePdf?: Maybe<GenerateInvoicePdfResponse>;
  /** Generate a presigned S3 URL for direct browser uploads. Use the returned uploadUrl with an HTTP PUT request to upload the file. cdnUrl is the public URL the asset will be available at after upload (only meaningful for public uploads — private uploads must be served via a presigned GET URL). */
  generateUploadUrl?: Maybe<GenerateUploadUrlPayload>;
  inAppNotificationsMarkSeen: Scalars['Int']['output'];
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  integrationCreateMany?: Maybe<CreateManyIntegrationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  integrationCreateOne?: Maybe<CreateOneIntegrationPayload>;
  /** Re-queue a failed delivery, or every failed delivery for one integration. Payloads are rebuilt from live data, so a retry sends current state rather than replaying a stale snapshot. */
  integrationDeliveryRetry?: Maybe<IntegrationRetryResult>;
  /** Act on one inbound partner record: apply the weight, dismiss it, or re-run matching against the identifiers the partner sent. */
  integrationInboundRecordResolve?: Maybe<IntegrationInboundRecord>;
  /** Init integration. */
  integrationInit?: Maybe<Integration>;
  /** Collect a pull partner's results now, instead of waiting for the next scheduled poll. */
  integrationPollNow?: Maybe<IntegrationPollNowResult>;
  /** Check this processor's mapping against the partner's catalogue, before a push depends on it. */
  integrationPreflight?: Maybe<IntegrationPreflightResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  integrationUpdateById?: Maybe<UpdateByIdIntegrationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  integrationUpdateMany?: Maybe<UpdateManyIntegrationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  integrationUpdateOne?: Maybe<UpdateOneIntegrationPayload>;
  /** Create a single invoice for one contact on a processor scheduling job. Handles Stripe and QuickBooks creation based on vendor integrations and isPayAtPickup. */
  invoiceCreateForSchedulingJob?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  invoiceCreateMany?: Maybe<CreateManyInvoicePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  invoiceCreateOne?: Maybe<CreateOneInvoicePayload>;
  /** Finalize and send an invoice */
  invoiceFinalizeAndSend?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  invoiceLineItemCreateMany?: Maybe<CreateManyInvoiceLineItemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  invoiceLineItemCreateOne?: Maybe<CreateOneInvoiceLineItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceLineItemUpdateById?: Maybe<UpdateByIdInvoiceLineItemPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  invoiceLineItemUpdateMany?: Maybe<UpdateManyInvoiceLineItemPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceLineItemUpdateOne?: Maybe<UpdateOneInvoiceLineItemPayload>;
  /** Mark an invoice as paid */
  invoiceMarkAsPaid?: Maybe<Invoice>;
  /** Refund an invoice (full or partial) */
  invoiceRefund?: Maybe<Invoice>;
  /** Update an existing invoice */
  invoiceUpdate?: Maybe<Invoice>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceUpdateById?: Maybe<UpdateByIdInvoicePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  invoiceUpdateMany?: Maybe<UpdateManyInvoicePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceUpdateOne?: Maybe<UpdateOneInvoicePayload>;
  /** Void an invoice */
  invoiceVoid?: Maybe<Invoice>;
  /** Re-send a job to every connected partner integration now. Uses the normal delivery pipeline, so the result reflects what an automatic push would do. */
  jobIntegrationPush?: Maybe<JobIntegrationPushResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  jobTagCreateOne?: Maybe<CreateOneJobTagPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  jobTagRemoveById?: Maybe<RemoveByIdJobTagPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  jobTagUpdateById?: Maybe<UpdateByIdJobTagPayload>;
  /** Generates a kill sheet PDF preview using demo data for the given vendor. */
  killSheetPreview?: Maybe<KillSheetPreviewResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  landingPageCreateMany?: Maybe<CreateManyLandingPageSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  landingPageCreateOne?: Maybe<CreateOneLandingPageSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  landingPageOneCreateMany?: Maybe<CreateManyLandingPageSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  landingPageOneCreateOne?: Maybe<CreateOneLandingPageSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  landingPageOneUpdateById?: Maybe<UpdateByIdLandingPageSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  landingPageOneUpdateMany?: Maybe<UpdateManyLandingPageSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  landingPageOneUpdateOne?: Maybe<UpdateOneLandingPageSettingsPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  landingPageRemoveById?: Maybe<RemoveByIdLandingPageSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  landingPageUpdateById?: Maybe<UpdateByIdLandingPageSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  landingPageUpdateMany?: Maybe<UpdateManyLandingPageSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  landingPageUpdateOne?: Maybe<UpdateOneLandingPageSettingsPayload>;
  /** Create or update a landing page. Resolution order: by `_id` if provided, otherwise upsert by `vendorId`, otherwise create a new vendorless page. When the address changes, the resolver geocodes it and updates `location`. */
  landingPageUpsert?: Maybe<LandingPageSettings>;
  /** Marks all unread, non-notification messages from the other side of the chat as read, and clears the viewer's manual "mark as unread" flag. Pass markMessagesRead: false to retire the flag ALONE, leaving message read receipts untouched. */
  markChatRoomAsRead?: Maybe<ChatRoom>;
  /** Flags a chat room as unread for the current user only, so it keeps its badge until they open it again. */
  markChatRoomAsUnread?: Maybe<ChatRoom>;
  /** Admin-only: export marketplace leads as a base64-encoded CSV, using the same filters as marketplaceLeadSearch. */
  marketplaceLeadExportCsv?: Maybe<MarketplaceLeadExportCsvResponse>;
  /** Public: capture an unmatched-demand lead from the marketplace empty state. Geocodes the ZIP best-effort. Rate limited per IP and per email. */
  marketplaceLeadSubmit: Scalars['Boolean']['output'];
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  moduleCreateMany?: Maybe<CreateManyVendorModulePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  moduleCreateOne?: Maybe<CreateOneVendorModulePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleUpdateById?: Maybe<UpdateByIdVendorModulePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  moduleUpdateMany?: Maybe<UpdateManyVendorModulePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleUpdateOne?: Maybe<UpdateOneVendorModulePayload>;
  /** Producer: add one section + buyer to one of the signed-in producer's own producer-listed on-job animals with NO deposit (status:confirmed + a $0 Order). Capacity-checked. */
  myAddOnJobSplit?: Maybe<Split>;
  /** Re-link the signed-in producer's own floating animals onto a job they requested. */
  myAnimalAssignToJob?: Maybe<HerdAssignToJobPayload>;
  /** Upload and validate a CSV of the signed-in producer's animals */
  myAnimalCsvImportUpload?: Maybe<MyAnimalCsvImportUploadPayload>;
  /** Remove one of the signed-in producer's unassigned animals. */
  myAnimalDelete?: Maybe<Animal>;
  /** Producer quick-add: create floating (unassigned) animals owned by the signed-in producer. */
  myAnimalQuickAdd?: Maybe<Array<Maybe<Animal>>>;
  /** Assign buyers to the split slots of one of the signed-in producer's unassigned animals. */
  myAnimalSetSplitBuyers?: Maybe<Animal>;
  /** Edit one of the signed-in producer's own animals. */
  myAnimalUpdate?: Maybe<Animal>;
  /** Producer: generate the sale invoice for a buyer's split on the signed-in producer's own animal — persist the producer-approved sale amount, credit the deposit, and compute balanceDue. An assigned split with no Order yet mints its $0 no-deposit Order here (requires the producer's Stripe payout account to be set up). Session-scoped: ownership is checked via the shared producer guard. */
  myGenerateSaleInvoice?: Maybe<OrderInvoiceResult>;
  /** Producer: close out a buyer's invoiced sale as settled OFF-PLATFORM (no Stripe charge) — the buyer paid the producer directly. Session-scoped: ownership and producer-listing are checked via the shared producer guard; delegates to the same recorder the processor/admin off-platform settle paths use. */
  myMarkOrderSettledOffPlatform?: Maybe<OrderInvoiceResult>;
  /** Producer: manually nudge one buyer about their section on one of the signed-in producer's own producer-listed animals (rate-limited to ~1/day/section). Context-aware: an unpaid claimed hold gets the deposit reminder; a paid section missing its cutsheet gets the cutsheet reminder (requires the animal to be on a job). */
  myNudgeSectionBuyer?: Maybe<MyNudgeSectionBuyerPayload>;
  /** Producer: place a buyer onto one section of one of the signed-in producer's own producer-owned on-job animals WITH a deposit (claimed Split under a ~3-day placement hold + a Pay-Deposit notification). Works on an unlisted/off-market animal too. Optional depositAmount overrides the producer's per-species default (clamped to the platform minimum). Requires completed Stripe onboarding. Capacity-checked. */
  myPlaceBuyerOnAnimal?: Maybe<Split>;
  /** Producer: reassign a buyer's split to a different buyer on one of the signed-in producer's own producer-listed animals. Always refunds the original payer (Decision 13 default) — forfeiture and admin-correction are not producer powers. The new buyer receives a fresh 3-day placement hold (same window as placing them outright). */
  myReassignBuyerSplit?: Maybe<Split>;
  /** Producer: release/unassign a buyer's split on one of the signed-in producer's own animals WITHOUT a refund. Frees the section (soft-delete) but does NOT return the buyer's deposit. */
  myReleaseBuyerSplit?: Maybe<Split>;
  /** Producer: remove a buyer's split on one of the signed-in producer's own producer-listed animals. Refunds the deposit if paid. */
  myRemoveBuyerSplit?: Maybe<Split>;
  /** Producer: revise an already-sent sale invoice for a buyer's split on the signed-in producer's own producer-listed animal — rewrite the charge in place (before any balance is paid), recompute balanceDue, and re-notify the buyer that the amount changed. */
  myReviseSaleInvoice?: Maybe<OrderInvoiceResult>;
  /** Create or return the direct chat room between the signed-in producer and a connected buyer. */
  myStartBuyerChat?: Maybe<ChatRoom>;
  /** Create or return the direct chat room between the signed-in buyer and a producer. */
  myStartProducerChat?: Maybe<ChatRoom>;
  /** Producer: void an already-sent, unpaid sale invoice for a buyer's split on the signed-in producer's own producer-listed animal — revert it to deposit_paid (the deposit stays credited) so a corrected invoice can be re-sent, and notify the buyer it was withdrawn. */
  myVoidSaleInvoice?: Maybe<OrderInvoiceResult>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  noteCreateMany?: Maybe<CreateManyNotePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  noteCreateOne?: Maybe<CreateOneNotePayload>;
  /** Delete a note by ID. */
  noteDelete?: Maybe<Note>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateById?: Maybe<UpdateByIdNotePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  noteUpdateMany?: Maybe<UpdateManyNotePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateOne?: Maybe<UpdateOneNotePayload>;
  /** Upsert a note for a processor scheduling. */
  noteUpsert?: Maybe<Note>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  notificationCreateMany?: Maybe<CreateManyNotificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  notificationCreateOne?: Maybe<CreateOneNotificationPayload>;
  notificationPreferenceUpdate?: Maybe<Array<Maybe<NotificationPreference>>>;
  notificationPromptAnswer?: Maybe<NotificationPromptState>;
  notificationPromptAnswerByToken?: Maybe<NotificationPromptPublic>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  notificationSettingsCreateMany?: Maybe<CreateManyNotificationSettingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  notificationSettingsCreateOne?: Maybe<CreateOneNotificationSettingPayload>;
  /** Update notification settings by ID */
  notificationSettingsUpdate?: Maybe<NotificationSetting>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationSettingsUpdateById?: Maybe<UpdateByIdNotificationSettingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  notificationSettingsUpdateMany?: Maybe<UpdateManyNotificationSettingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationSettingsUpdateOne?: Maybe<UpdateOneNotificationSettingPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationUpdateById?: Maybe<UpdateByIdNotificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  notificationUpdateMany?: Maybe<UpdateManyNotificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationUpdateOne?: Maybe<UpdateOneNotificationPayload>;
  /** Parse a cutsheet (PDF or image) using AI to extract catalog data and generate a questionnaire */
  parseCutsheet?: Maybe<ParseCutsheetPayload>;
  /** Extract a customer’s answers from a filled-in cutsheet (PDF/image) for a given questionnaire. No response is created — the page images are stored so a response saved from the review can keep them as its original. */
  parseFilledCutsheet?: Maybe<ParseFilledCutsheetPayload>;
  /** Remove one of the current vendor's partner connections. Its delivery and inbound history is kept. */
  partnerIntegrationDelete?: Maybe<PartnerIntegrationDeleteResult>;
  /** Issue (or rotate) the inbound bearer token for a partner integration. The plaintext token is returned once and never stored. */
  partnerIntegrationIssueToken?: Maybe<PartnerIntegrationToken>;
  /** Create or update the current vendor's connection to a partner platform. Secrets are write-only; omit them to leave the stored value unchanged. */
  partnerIntegrationUpsert?: Maybe<Integration>;
  /** Create or update a pickup location on the caller's active vendor. Ownership always comes from the session — the input carries no vendorId. */
  pickupLocationUpsert: PickupLocation;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCreateMany?: Maybe<CreateManyPrimalPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCreateOne?: Maybe<CreateOnePrimalPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutBlockerCreateMany?: Maybe<CreateManyPrimalCutBlockerPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutBlockerCreateOne?: Maybe<CreateOnePrimalCutBlockerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutBlockerUpdateById?: Maybe<UpdateByIdPrimalCutBlockerPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutBlockerUpdateMany?: Maybe<UpdateManyPrimalCutBlockerPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutBlockerUpdateOne?: Maybe<UpdateOnePrimalCutBlockerPayload>;
  /** Upsert a primal cut blocker */
  primalCutBlockerUpsert?: Maybe<PrimalCutBlocker>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutCreateMany?: Maybe<CreateManyPrimalCutPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutCreateOne?: Maybe<CreateOnePrimalCutPayload>;
  /** Soft delete of primal cut */
  primalCutSoftDelete?: Maybe<PrimalCut>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutTypeCreateMany?: Maybe<CreateManyPrimalCutTypePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutTypeCreateOne?: Maybe<CreateOnePrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutTypeUpdateById?: Maybe<UpdateByIdPrimalCutTypePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutTypeUpdateMany?: Maybe<UpdateManyPrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutTypeUpdateOne?: Maybe<UpdateOnePrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutUpdateById?: Maybe<UpdateByIdPrimalCutPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutUpdateMany?: Maybe<UpdateManyPrimalCutPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutUpdateOne?: Maybe<UpdateOnePrimalCutPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalGroupCreateMany?: Maybe<CreateManyPrimalGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalGroupCreateOne?: Maybe<CreateOnePrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalGroupUpdateById?: Maybe<UpdateByIdPrimalGroupPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalGroupUpdateMany?: Maybe<UpdateManyPrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalGroupUpdateOne?: Maybe<UpdateOnePrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalUpdateById?: Maybe<UpdateByIdPrimalPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalUpdateMany?: Maybe<UpdateManyPrimalPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalUpdateOne?: Maybe<UpdateOnePrimalPayload>;
  /** Force update the status of a processor scheduling job, bypassing workflow logic and validations. Moving a job FORWARD notifies the customer, exactly like the normal status change; so do "Denied By Processor" and "Missed Drop Off", which carry no invoice coupling. Backward and same-status corrections stay silent, as do the cancel statuses — cancelling here would not void the job's open invoices, so use the normal cancel action for that. Milestone dates (killedDate / scheduledDate / completedDate) are stamped on ANY entry into those statuses, including a backward correction, so the job stays visible to reporting that filters on them. A move into "Scheduled" also runs the acceptance hooks (listings go live, staged splits become orders, linked waitlist entry closes). Example: Moving a job from "Invoicing" back to "Killed" if it was prematurely advanced. */
  processingJobForceUpdateStatus?: Maybe<ProcessorSchedulingForceUpdateStatusResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processingPartnersCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processingPartnersCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processingPartnersOneCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processingPartnersOneCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersOneUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processingPartnersOneUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersOneUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processingPartnersUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorCapabilityCreateMany?: Maybe<CreateManyProcessorCapabilityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorCapabilityCreateOne?: Maybe<CreateOneProcessorCapabilityPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorCapabilitySpecificationCreateMany?: Maybe<CreateManyProcessorCapabilitySpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorCapabilitySpecificationCreateOne?: Maybe<CreateOneProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilitySpecificationUpdateById?: Maybe<UpdateByIdProcessorCapabilitySpecificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorCapabilitySpecificationUpdateMany?: Maybe<UpdateManyProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilitySpecificationUpdateOne?: Maybe<UpdateOneProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilityUpdateById?: Maybe<UpdateByIdProcessorCapabilityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorCapabilityUpdateMany?: Maybe<UpdateManyProcessorCapabilityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilityUpdateOne?: Maybe<UpdateOneProcessorCapabilityPayload>;
  /** Upsert processor capabilities for an animal type. */
  processorCapabilityUpsert?: Maybe<ProcessorCapability>;
  /** Create a card PaymentIntent so the processor can collect an outstanding deposit. */
  processorDepositPaymentIntentCreate?: Maybe<DepositPaymentIntentResponse>;
  /** Exports a CSV for a vendor. */
  processorExportCsv?: Maybe<ProcessorExportCsvResponse>;
  /** Generates CSV for a vendor. */
  processorExportCsvByVendorId?: Maybe<ProcessorExportCsvResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorNotificationCreateMany?: Maybe<CreateManyProcessorNotificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorNotificationCreateOne?: Maybe<CreateOneProcessorNotificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorNotificationUpdateById?: Maybe<UpdateByIdProcessorNotificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorNotificationUpdateMany?: Maybe<UpdateManyProcessorNotificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorNotificationUpdateOne?: Maybe<UpdateOneProcessorNotificationPayload>;
  /** Bulk update of animal heads on a particular processing job. */
  processorSchedulingAnimalHeadBulkUpdate?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Delete an animal head from a scheduled job. */
  processorSchedulingAnimalHeadDelete?: Maybe<ProcessorScheduling>;
  /** Partial update of a single animal head on a particular processing job. */
  processorSchedulingAnimalHeadPartialUpdateById?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Bulk update of head fields and job status across multiple processor scheduling jobs. Returns per-job results so callers can show partial-success state. */
  processorSchedulingBulkAction?: Maybe<ProcessorSchedulingBulkActionResponse>;
  processorSchedulingBuyerCutsheetReminder?: Maybe<ProcessorScheduling>;
  /** Create a new processor scheduling. */
  processorSchedulingCreate?: Maybe<CreateProcessorScheduleResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSchedulingCreateMany?: Maybe<CreateManyProcessorSchedulingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSchedulingCreateOne?: Maybe<CreateOneProcessorSchedulingPayload>;
  processorSchedulingCutsheetReminder?: Maybe<ProcessorScheduling>;
  /** Charge a customer's saved card for an outstanding deposit. */
  processorSchedulingDepositChargeCard?: Maybe<ProcessorScheduling>;
  /** Find a deposit payment the job's customer already made in Stripe that isn't recorded on any job, and record it on this one. */
  processorSchedulingDepositCheckStripe?: Maybe<DepositCheckStripeResponse>;
  /** Record a deposit as paid offline (cash or check). */
  processorSchedulingDepositMarkPaid?: Maybe<ProcessorScheduling>;
  /** Update the dropoff date, cut date, and kill date, if exists, for a processor scheduling job. This is only used for the calendar drag and drop feature. */
  processorSchedulingDragAndDropUpdate?: Maybe<ProcessorScheduling>;
  processorSchedulingDropoffConfirmationSet?: Maybe<ProcessorScheduling>;
  /** Generates the billing statement for the proceessing job and returns it to be downloaded. */
  processorSchedulingGenerateBillingStatement?: Maybe<GenerateBillingStatementResponse>;
  /** Generates a single combined carcass tags pdf across multiple scheduled jobs, optionally filtered by kill date. */
  processorSchedulingGenerateBulkCarcassTags?: Maybe<GenerateBulkCarcassTagsResponse>;
  /** Generates a single combined cutsheet pdf for multiple cutsheet requests across one or more scheduled jobs. */
  processorSchedulingGenerateBulkCutsheetRequests?: Maybe<GenerateBulkCutsheetsResponse>;
  /** Generates carcass tag pdfs for a scheduled job or specific animal heads in the job. */
  processorSchedulingGenerateCarcassTags?: Maybe<GenerateCarcassTagsResponse>;
  /** Generates CSV for a vendor. */
  processorSchedulingGenerateCsvByVendorId?: Maybe<GenerateCsvResponse>;
  /** Generates the cutsheet pdf(s) for a scheduled job and cutsheet request. */
  processorSchedulingGenerateCutsheetRequest?: Maybe<GenerateCutsheetResponse>;
  /** Generates CSV for a vendor for hanging weights. */
  processorSchedulingGenerateHangingWeightCsv?: Maybe<GenerateHangingWeightCsvResponse>;
  /** Generates kill sheet pdf for the selected date. */
  processorSchedulingGenerateKillSheet?: Maybe<GenerateKillSheetResponse>;
  /** Generates per-customer packing slips for the processing job, listing the recorded yield per split. When `cutsheetInformationId` is provided, the slip is scoped to just that split. */
  processorSchedulingGeneratePackingSlip?: Maybe<GeneratePackingSlipResponse>;
  /** Manually send out an email. You will have to give us the type and the right information. */
  processorSchedulingNotificationSend?: Maybe<ProcessorScheduling>;
  /** Partial update of a single processor scheduling job with support for adding new animal heads */
  processorSchedulingPartialUpdateById?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Send the customer a deposit-payment notification. */
  processorSchedulingResendDepositNotification?: Maybe<ProcessorScheduling>;
  /** Manually send an enabled notification for a job to selected users on selected channels. */
  processorSchedulingSendManualNotification?: Maybe<ProcessorScheduling>;
  /** Update the split type and contact information for a specific animal head on a processor scheduling. */
  processorSchedulingSplitTypeUpdateById?: Maybe<ProcessorSchedulingSplitTypeUpdateResponse>;
  /** Update a processor scheduling job */
  processorSchedulingUpdate?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSchedulingUpdateById?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Partial update of cutsheets associated to a processor scheduling */
  processorSchedulingUpdateCutsheets?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSchedulingUpdateMany?: Maybe<UpdateManyProcessorSchedulingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSchedulingUpdateOne?: Maybe<UpdateOneProcessorSchedulingPayload>;
  /** Add new processor settings to the partners platform. Can include custom capacities for specific days. */
  processorSettingsCreate?: Maybe<CreateProcessorSettingsWithCustomCapacity>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSettingsCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSettingsCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSettingsCustomCapacityCreateMany?: Maybe<CreateManyProcessorSettingsCustomCapacityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSettingsCustomCapacityCreateOne?: Maybe<CreateOneProcessorSettingsCustomCapacityPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsCustomCapacityUpdateById?: Maybe<UpdateByIdProcessorSettingsCustomCapacityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSettingsCustomCapacityUpdateMany?: Maybe<UpdateManyProcessorSettingsCustomCapacityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsCustomCapacityUpdateOne?: Maybe<UpdateOneProcessorSettingsCustomCapacityPayload>;
  /** Update processor settings to the partners platform. Supports customized day scheduling updates. */
  processorSettingsUpdate?: Maybe<UpdateProcessorSettingsWithCustomCapacity>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSettingsUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Update the workflow-funnel facility capacity config (pen / kill-per-day / cooler rail / target hang days / further-processing / freezer) for the current vendor. */
  processorWorkflowCapacityUpdate: Scalars['JSON']['output'];
  /** Save the signed-in producer's default deposit matrix. */
  producerSettingsUpdate?: Maybe<ProducerSettings>;
  /** Create (or refresh) a Stripe Connect account for the signed-in producer. */
  producerStripeAccountCreate?: Maybe<ProducerStripeConfig>;
  /** Create (or reuse) an embedded onboarding session for the signed-in producer's Stripe Connect account. */
  producerStripeSessionCreate?: Maybe<ProducerStripeSession>;
  /** Provision a new Twilio phone number for a processor */
  provisionPhoneNumber?: Maybe<ProvisionPhoneNumberResponse>;
  /** End a recurring series and cancel its upcoming scheduled jobs. */
  recurringSeriesCancelUpcomingJobs?: Maybe<RecurringSeriesCancelUpcomingResponse>;
  /** Create a recurring series from explicit booking inputs. */
  recurringSeriesCreate: RecurringSeries;
  /** Make an existing ProcessorScheduling job recurring. */
  recurringSeriesCreateFromJob: RecurringSeries;
  /** Pause or resume a recurring series. */
  recurringSeriesSetActive: RecurringSeries;
  /** Change a recurring series' recurrence rule. */
  recurringSeriesUpdateRule: RecurringSeries;
  /** Refresh the status of a phone number (hosted landline order or provisioned number) */
  refreshHostedNumberStatus?: Maybe<RefreshHostedNumberStatusResponse>;
  /** Release a phone number from a processor */
  releasePhoneNumber?: Maybe<ReleasePhoneNumberResponse>;
  /** Sending message between customer and processor */
  sendMessage?: Maybe<ChatMessage>;
  /** Send a test notification to a given email address or phone number using sample data. Pass emailContent/smsContent to override the saved template (e.g. unsaved editor content). */
  sendTestNotification?: Maybe<SendTestNotificationResult>;
  /** Toggle a split's send-notifications master switch */
  splitSendNotificationsUpdate?: Maybe<Split>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  stateCreateMany?: Maybe<CreateManyStatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  stateCreateOne?: Maybe<CreateOneStatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  stateUpdateById?: Maybe<UpdateByIdStatePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  stateUpdateMany?: Maybe<UpdateManyStatePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  stateUpdateOne?: Maybe<UpdateOneStatePayload>;
  /** Create an stripe account for active_vendor. */
  stripeAccountCreate?: Maybe<Vendor>;
  /** Create an stripe session for active_vendor. */
  stripeSessionCreate?: Maybe<Vendor>;
  /** Submit a hosted landline number order to SMS-enable an existing business phone */
  submitHostedLandlineOrder?: Maybe<SubmitHostedLandlineOrderResponse>;
  /** Sync all Twilio conversation SMS participants to use the vendor's current phone number */
  syncConversationPhoneNumbers?: Maybe<SyncConversationPhoneNumbersResponse>;
  /** Add new tenant to Partners platform. */
  tenantCreate?: Maybe<Tenant>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tenantCreateMany?: Maybe<CreateManyTenantPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tenantCreateOne?: Maybe<CreateOneTenantPayload>;
  /** Enable or disable a tenant on the Partners platform. */
  tenantEnabledEdit?: Maybe<Tenant>;
  /** Modify tenant picture by uploading an image file. */
  tenantPictureUrlEdit?: Maybe<Tenant>;
  /** Modify tenant subscription on the Partners platform. */
  tenantSubscriptionEdit?: Maybe<Tenant>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tenantUpdateById?: Maybe<UpdateByIdTenantPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  tenantUpdateMany?: Maybe<UpdateManyTenantPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tenantUpdateOne?: Maybe<UpdateOneTenantPayload>;
  updateAuthMethod?: Maybe<UpdateAuthMethodPayload>;
  /** Update the SMS webhook URL for an existing phone number to receive inbound SMS */
  updatePhoneNumberSmsWebhook?: Maybe<UpdatePhoneNumberSmsWebhookResponse>;
  /** Update the authenticated user's profile information. */
  updateProfile?: Maybe<User>;
  /** Activate user on Partners platform. */
  userActivate?: Maybe<User>;
  /** Create or update a basic user. */
  userBasicUpsert?: Maybe<UserBasicUpsertPayload>;
  /** Add new user to Partners platform. */
  userCreate?: Maybe<User>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  userCreateMany?: Maybe<CreateManyUserPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  userCreateOne?: Maybe<CreateOneUserPayload>;
  /** Deactivate user on Partners platform. */
  userDeactivate?: Maybe<User>;
  /** Set or clear a producer hang time preference for a vendor + species. */
  userHangTimePreferenceUpdate?: Maybe<HangTimePreferenceResponse>;
  /** Admin: manually send the notification summary digest to a user for each vendor they have unread in-app notifications from (email/SMS per the vendor's NotificationSummary setting). Pass vendorId to scope to a single vendor. */
  userNotificationSummarySend?: Maybe<UserNotificationSummarySendResult>;
  /** Set or clear a customer's manual rebooking interval override. */
  userRebookingOverrideUpdate?: Maybe<CustomerRebookingCadence>;
  /** Update the current authenticated user's settings. */
  userSettingsUpdate?: Maybe<User>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateById?: Maybe<UpdateByIdUserPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  userUpdateMany?: Maybe<UpdateManyUserPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateOne?: Maybe<UpdateOneUserPayload>;
  /** Processor assignment: add one section of a chosen size + buyer to an on-job animal (status:open, no deposit). Session-scoped: vendor derives from the signed-in processor user. Capacity-checked. */
  vendorAddOnJobSplit?: Maybe<Animal>;
  /** Forward-only status change for animals on one of the signed-in processor's jobs; re-derives the job's status from its animals. */
  vendorAnimalStatusUpdate?: Maybe<AnimalStatusUpdatePayload>;
  /** Copy selected settings buckets from a source vendor to a target vendor. */
  vendorCopySettings?: Maybe<Scalars['JSON']['output']>;
  /** Add new vendor to Partners platform. */
  vendorCreate?: Maybe<Vendor>;
  /** Create a distinct in-house producer identity for the signed-in processor's own farm operation, pointing at the vendor's existing Stripe account (no onboarding). Vendor is session-derived; only a processor of that vendor (or admin) may call it. */
  vendorCreateInHouseProducer?: Maybe<InHouseProducer>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  vendorCreateMany?: Maybe<CreateManyVendorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  vendorCreateOne?: Maybe<CreateOneVendorPayload>;
  vendorCustomerNotificationDefaultsUpdate?: Maybe<CustomerNotificationDefaults>;
  /** Decline an active split request for the signed-in processor's vendor: sets active:false + declinedAt (without touching fulfilledSplit/cancelledAt). Vendor is session-derived and ownership-checked; a non-owned/absent/inactive id yields a generic 'Request not found.' */
  vendorDeclineRequest?: Maybe<MarketplaceRequest>;
  /** Processor: generate the per-section invoice for an Order — persist the processing charge, credit the deposit, compute balanceDue, and choose the per-invoice balance channel (stripe | in_person). Session-scoped: vendor derives from the signed-in processor; IDOR-checked against the Order's vendor. */
  vendorGenerateOrderInvoice?: Maybe<OrderInvoiceResult>;
  /** Remove one of the signed-in processor's unassigned animals. */
  vendorHerdAnimalDelete?: Maybe<Animal>;
  /** Assign buyers to the split slots of one of the signed-in processor's unassigned animals. */
  vendorHerdAnimalSetSplitBuyers?: Maybe<Animal>;
  /** Edit one of the signed-in processor's unassigned animals. */
  vendorHerdAnimalUpdate?: Maybe<Animal>;
  /** Re-link the signed-in processor's floating animals onto one of its existing jobs. */
  vendorHerdAssignAnimalsToJob?: Maybe<HerdAssignToJobPayload>;
  /** Processor quick-add: create floating (unassigned) animals for the signed-in processor, attributed to a producer. */
  vendorHerdQuickAdd?: Maybe<Array<Maybe<Animal>>>;
  /** Save the marketplace defaults of the signed-in processor's in-house producer. Vendor and producer are both session-derived; the client supplies values only. */
  vendorInHouseProducerSettingsUpdate?: Maybe<ProducerSettings>;
  /** Link one of the vendor's own existing producers as its in-house producer identity by re-pointing it at the vendor's Stripe account. Vendor is session-derived; the target must already be one of the vendor's producers and must not have its own separate completed Stripe account. */
  vendorLinkInHouseProducer?: Maybe<InHouseProducer>;
  /** Processor: mark an in-person invoice settled — record invoicePaidAt, zero the balance, and flip the Order to paid. Session-scoped: vendor derives from the signed-in processor; IDOR-checked against the Order's vendor. */
  vendorMarkOrderSettledInPerson?: Maybe<OrderInvoiceResult>;
  /** Create or update a module for a vendor. */
  vendorModuleUpsert?: Maybe<VendorModule>;
  /** Manually nudge one buyer about their section (processor-initiated, rate-limited to ~1/day/section). Context-aware: an unpaid claimed hold gets the deposit reminder; a paid section missing its cutsheet gets the cutsheet reminder (requires the animal to be on a job). Vendor is session-derived; the split's animal must belong to that vendor. */
  vendorNudgeSectionBuyer?: Maybe<VendorNudgeSectionBuyerPayload>;
  /** Place a buyer's active split request onto one of the signed-in processor's eligible animals: creates a claimed Split (deposit-pending 3-day hold) on the buyer's behalf and marks the request fulfilled. Vendor is session-derived; request + animal must both belong to that vendor. */
  vendorPlaceRequestOnAnimal?: Maybe<MarketplaceRequest>;
  /** Processor override: reassign a marketplace split to a different buyer. Default (Decision 13) = REFUND the original payer against their Order and move the section to the new buyer UNPAID (no successor Order until they pay). Pass forfeit:true to instead close the prior Order by forfeiture (processor keeps the deposit). Pass adminCorrection:true for the narrow no-refund/same-customer-of-record path (order stays open, occupant re-pointed). Session-scoped: vendor derives from the signed-in processor user. */
  vendorReassignBuyerSplit?: Maybe<Split>;
  /** Processor: record a cash or check payment received in person against EVERY unsettled split on an animal. Loops the per-split settlement primitive (identical records) and returns a per-split report (settled / skipped / error). Session-scoped: vendor derives from the signed-in processor; IDOR-checked against the animal's vendor. */
  vendorRecordAnimalSettlement?: Maybe<AnimalSettlementReport>;
  /** Processor: record a cash or check payment received in person against ONE split. Marks that split's active invoice collected in Stripe (out-of-band) and QuickBooks, records the method as an audit trail, and re-derives the animal/job status. Session-scoped: vendor derives from the signed-in processor; IDOR-checked against the split's vendor. */
  vendorRecordSplitSettlement?: Maybe<Invoice>;
  /** Admin or processor: release/unassign a marketplace split WITHOUT a refund. Frees the section (soft-delete) but does NOT return the buyer's deposit. A processor is scoped to their session vendor; an admin may act on any vendor's split. */
  vendorReleaseBuyerSplit?: Maybe<Split>;
  /** Remove a buyer's pending (requested), claimed, or confirmed (deposit-paid) marketplace split on a published animal. Session-scoped: vendor derives from the signed-in processor user. Confirmed splits trigger a deposit refund before soft-delete. */
  vendorRemoveBuyerSplit?: Maybe<Split>;
  /** Apply the processor's current profile (logo, name, address, payout account, banner, thumbnail, about text, highlights) to its in-house producer. Vendor is session-derived; marketplace defaults are not touched. Returns `changed` (fields that moved) and `unavailable` (fields the processor's own profile had nothing to copy for, each saying what to fix). A refusal — no producer attached, or one that is a staff account — throws instead. */
  vendorSyncInHouseProducer: VendorSyncInHouseProducerResult;
  /** Invite a new staff member to the caller's vendor team. */
  vendorTeamMemberInvite?: Maybe<User>;
  /** Change the role of a member of the caller's vendor team. */
  vendorTeamMemberRoleUpdate?: Maybe<User>;
  /** Enable or disable a member of the caller's vendor team. */
  vendorTeamMemberSetEnabled?: Maybe<User>;
  /** Undo a decline: reactivate a previously-declined request (active:false + declinedAt set + fulfilledAt null) for the signed-in processor's vendor — sets active:true and clears declinedAt. Vendor is session-derived and ownership-checked; a duplicate active tuple (buyer re-submitted) yields a friendly 'already requested' error. */
  vendorUndoDecline?: Maybe<MarketplaceRequest>;
  /** Undo a placement for the signed-in processor's vendor: releases the placed Split's UNPAID claimed hold (same path as buyer-cancel-split, freeing capacity) and reactivates the request. RELEASES FIRST so a deposit paid in the race window leaves the request fulfilled (never re-placeable). REFUSES when the Split is confirmed/paid, a settled Order exists, or a payment is in flight (money is never reversed). Vendor session-derived + ownership-checked. */
  vendorUndoPlacement?: Maybe<MarketplaceRequest>;
  /** Clear the vendor's in-house producer identity. Vendor is session-derived and there is no input; the producer User record itself is left untouched. */
  vendorUnlinkInHouseProducer: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  vendorUpdateById?: Maybe<UpdateByIdVendorPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  vendorUpdateMany?: Maybe<UpdateManyVendorPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  vendorUpdateOne?: Maybe<UpdateOneVendorPayload>;
  waitlistAdd?: Maybe<Waitlist>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  waitlistCreateMany?: Maybe<CreateManyWaitlistPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  waitlistCreateOne?: Maybe<CreateOneWaitlistPayload>;
  waitlistDelete?: Maybe<Waitlist>;
  waitlistUnsubscribe?: Maybe<Waitlist>;
  waitlistUpdate?: Maybe<Waitlist>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  waitlistUpdateById?: Maybe<UpdateByIdWaitlistPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  waitlistUpdateMany?: Maybe<UpdateManyWaitlistPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  waitlistUpdateOne?: Maybe<UpdateOneWaitlistPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  webhookCreateMany?: Maybe<CreateManyVendorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  webhookCreateOne?: Maybe<CreateOneVendorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  webhookUpdateById?: Maybe<UpdateByIdVendorPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  webhookUpdateMany?: Maybe<UpdateManyVendorPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  webhookUpdateOne?: Maybe<UpdateOneVendorPayload>;
};


export type MutationCutsheetCapabilityCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityInput>;
};


export type MutationCutsheetCapabilityCreateOneArgs = {
  record: CreateOneCutsheetCapabilityInput;
};


export type MutationCutsheetCapabilityDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityDuplicateArgs = {
  allowCrossVendor?: InputMaybe<Scalars['Boolean']['input']>;
  includeAssignmentRules: Scalars['Boolean']['input'];
  includeQuestionnaires: Scalars['Boolean']['input'];
  sourceCapabilityId: Scalars['MongoID']['input'];
  targetCapabilityId: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityMigrateLegacyArgs = {
  capabilityId: Scalars['MongoID']['input'];
  deactivateUnusedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCutsheetCapabilityPrintSettingsUpdateArgs = {
  alwaysShowPrimalNotes: Scalars['Boolean']['input'];
  baseFontSize: Scalars['Float']['input'];
  checkboxStyle: Scalars['String']['input'];
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds: Array<Scalars['String']['input']>;
  hiddenItemIds: Array<Scalars['String']['input']>;
  hiddenSpecificationIds: Array<Scalars['String']['input']>;
  hideUnselectedCuts: Scalars['Boolean']['input'];
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['MongoID']['input'];
  orientation: Scalars['String']['input'];
  primalColumns: Scalars['Float']['input'];
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup: Scalars['Boolean']['input'];
  specsLayoutPosition: Scalars['String']['input'];
};


export type MutationCutsheetCapabilitySetLegacyMapArgs = {
  id: Scalars['MongoID']['input'];
  legacyInspectionLevelMap: Array<InputMaybe<CutsheetLegacyInspectionLevelEntryInput>>;
};


export type MutationCutsheetCapabilityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityInput;
};


export type MutationCutsheetCapabilityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityInput>;
};


export type MutationCutsheetCapabilityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityInput>;
  record: UpdateOneCutsheetCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityInput>;
};


export type MutationCutsheetCapabilityUpsertArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  species: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationAddPhoneToMessagingServiceArgs = {
  input?: InputMaybe<AddPhoneToMessagingServiceInput>;
};


export type MutationAddressCreateManyArgs = {
  records: Array<CreateManyAddressInput>;
};


export type MutationAddressCreateOneArgs = {
  record: CreateOneAddressInput;
};


export type MutationAddressUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAddressInput;
};


export type MutationAddressUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyAddressInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyAddressInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyAddressInput>;
};


export type MutationAddressUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneAddressInput>;
  record: UpdateOneAddressInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneAddressInput>;
};


export type MutationAdminClearListingVetoArgs = {
  animalId: Scalars['MongoID']['input'];
};


export type MutationAdminForceSettleOrderBalanceArgs = {
  orderId: Scalars['MongoID']['input'];
  overrideCombinedChargeGuard?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminUserUpdateArgs = {
  address?: InputMaybe<AdminUserAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<AdminUserRelationshipInput>>>;
  role?: InputMaybe<EnumUserRole>;
  userId: Scalars['MongoID']['input'];
};


export type MutationAnimalForceUpdateStatusArgs = {
  animalId: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
};


export type MutationApplyCutsheetCatalogChangesArgs = {
  capabilityId: Scalars['MongoID']['input'];
  changes: Array<CutsheetProposedChangeInput>;
};


export type MutationApplyCutsheetQuestionnaireChangesArgs = {
  capabilityId: Scalars['MongoID']['input'];
  changes: Array<CutsheetProposedChangeInput>;
  questions: Scalars['JSON']['input'];
};


export type MutationAuthCheckUserArgs = {
  clientOrigin?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthConfirmForgotPasswordArgs = {
  code: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationAuthForgotPasswordArgs = {
  identifier: Scalars['String']['input'];
};


export type MutationAuthLoginOAuthArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationAuthLoginPasswordArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAuthRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAuthRegisterArgs = {
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthRegisterAndSignInArgs = {
  acceptTos: Scalars['Boolean']['input'];
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthSendOtpArgs = {
  identifier: Scalars['String']['input'];
};


export type MutationAuthVerifyOtpArgs = {
  identifier: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBookingDepositPaymentIntentCreateArgs = {
  headCount: Scalars['Int']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  species: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationBuildCutsheetCatalogArgs = {
  capabilityId: Scalars['MongoID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationBuyerAddAnimalSectionArgs = {
  animalId: Scalars['MongoID']['input'];
  pickupLocationId?: InputMaybe<Scalars['MongoID']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  splitPart: Scalars['String']['input'];
};


export type MutationBuyerCancelRequestArgs = {
  requestId: Scalars['MongoID']['input'];
};


export type MutationBuyerCancelSplitArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationBuyerClaimSplitArgs = {
  animalId: Scalars['MongoID']['input'];
  pickupLocationId?: InputMaybe<Scalars['MongoID']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  splitPart: Scalars['String']['input'];
};


export type MutationBuyerCreateBalanceCheckoutArgs = {
  orderId: Scalars['MongoID']['input'];
};


export type MutationBuyerCreateCombinedSettlementIntentArgs = {
  orderId: Scalars['MongoID']['input'];
};


export type MutationBuyerCreateDepositCheckoutArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  splitId: Scalars['MongoID']['input'];
};


export type MutationBuyerCreateDepositIntentArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationBuyerInterestUnsubscribeArgs = {
  token: Scalars['String']['input'];
};


export type MutationBuyerPayInvoiceArgs = {
  invoiceId: Scalars['MongoID']['input'];
};


export type MutationBuyerPayOrderBalanceArgs = {
  orderId: Scalars['MongoID']['input'];
};


export type MutationBuyerRegisterInterestArgs = {
  species: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationBuyerRegisterProducerInterestArgs = {
  producerId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
};


export type MutationBuyerRemoveInterestArgs = {
  species: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationBuyerRemoveProducerInterestArgs = {
  producerId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
};


export type MutationBuyerSubmitRequestArgs = {
  desiredPickupDate?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  species: Scalars['String']['input'];
  splitType: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationBuyerSyncBalanceCheckoutArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationBuyerSyncCombinedSettlementArgs = {
  orderId: Scalars['MongoID']['input'];
};


export type MutationBuyerSyncDepositCheckoutArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationBuyerSyncDepositIntentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationBuyerSyncOrderBalanceArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationCalendarEventCreateOneArgs = {
  record: CreateOneCalendarEventInput;
};


export type MutationCalendarEventRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationCalendarEventTypeCreateOneArgs = {
  record: CreateOneCalendarEventTypeInput;
};


export type MutationCalendarEventTypeRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationCalendarEventTypeUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCalendarEventTypeInput;
};


export type MutationCalendarEventUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCalendarEventInput;
};


export type MutationCancellationReasonCreateManyArgs = {
  records: Array<CreateManyCancellationReasonInput>;
};


export type MutationCancellationReasonCreateOneArgs = {
  record: CreateOneCancellationReasonInput;
};


export type MutationCancellationReasonUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCancellationReasonInput;
};


export type MutationCancellationReasonUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCancellationReasonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCancellationReasonInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCancellationReasonInput>;
};


export type MutationCancellationReasonUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCancellationReasonInput>;
  record: UpdateOneCancellationReasonInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCancellationReasonInput>;
};


export type MutationCarcassTagPreviewArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationChatRoomCreateOneArgs = {
  record: CreateOneChatRoomInput;
};


export type MutationCsvImportCancelJobArgs = {
  jobId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
};


export type MutationCsvImportDeleteRecordArgs = {
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
};


export type MutationCsvImportExecuteArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportForceCancelArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportJobCreateManyArgs = {
  records: Array<CreateManyCsvImportJobInput>;
};


export type MutationCsvImportJobCreateOneArgs = {
  record: CreateOneCsvImportJobInput;
};


export type MutationCsvImportJobUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCsvImportJobInput;
};


export type MutationCsvImportJobUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCsvImportJobInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCsvImportJobInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCsvImportJobInput>;
};


export type MutationCsvImportJobUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCsvImportJobInput>;
  record: UpdateOneCsvImportJobInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCsvImportJobInput>;
};


export type MutationCsvImportRevalidateArgs = {
  data: Scalars['JSON']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportSaveColumnMappingArgs = {
  columnMapping: Scalars['JSON']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportUpdateRowsArgs = {
  jobId: Scalars['String']['input'];
  updatedRows: Scalars['JSON']['input'];
};


export type MutationCsvImportUploadArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  tenantId: Scalars['MongoID']['input'];
  type: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCustomFieldDefinitionCreateManyArgs = {
  records: Array<CreateManyCustomFieldDefinitionInput>;
};


export type MutationCustomFieldDefinitionCreateOneArgs = {
  record: CreateOneCustomFieldDefinitionInput;
};


export type MutationCustomFieldDefinitionSoftDeleteArgs = {
  definitionId: Scalars['MongoID']['input'];
};


export type MutationCustomFieldDefinitionUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCustomFieldDefinitionInput;
};


export type MutationCustomFieldDefinitionUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCustomFieldDefinitionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCustomFieldDefinitionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCustomFieldDefinitionInput>;
};


export type MutationCustomFieldDefinitionUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCustomFieldDefinitionInput>;
  record: UpdateOneCustomFieldDefinitionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCustomFieldDefinitionInput>;
};


export type MutationCustomFieldValueBulkSaveArgs = {
  inputs?: InputMaybe<Array<CustomFieldValueBulkInput>>;
};


export type MutationCustomFieldValueClearArgs = {
  inputs?: InputMaybe<Array<CustomFieldValueClearInput>>;
};


export type MutationCustomFieldValueCreateManyArgs = {
  records: Array<CreateManyCustomFieldValueInput>;
};


export type MutationCustomFieldValueCreateOneArgs = {
  record: CreateOneCustomFieldValueInput;
};


export type MutationCustomFieldValueUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCustomFieldValueInput;
};


export type MutationCustomFieldValueUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCustomFieldValueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCustomFieldValueInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCustomFieldValueInput>;
};


export type MutationCustomFieldValueUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCustomFieldValueInput>;
  record: UpdateOneCustomFieldValueInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCustomFieldValueInput>;
};


export type MutationCustomerDeleteArgs = {
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCustomerMergeArgs = {
  fieldSelections?: InputMaybe<Array<CustomerMergeFieldSelectionInput>>;
  loserIds: Array<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  winnerId: Scalars['MongoID']['input'];
};


export type MutationCustomerNotificationPreferenceUpdateArgs = {
  category: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['MongoID']['input'];
};


export type MutationCutsheetAssignmentRuleSetCreateManyArgs = {
  records: Array<CreateManyCutsheetAssignmentRuleSetInput>;
};


export type MutationCutsheetAssignmentRuleSetCreateOneArgs = {
  record: CreateOneCutsheetAssignmentRuleSetInput;
};


export type MutationCutsheetAssignmentRuleSetDeleteArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type MutationCutsheetAssignmentRuleSetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetAssignmentRuleSetInput;
};


export type MutationCutsheetAssignmentRuleSetUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetAssignmentRuleSetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetAssignmentRuleSetInput>;
};


export type MutationCutsheetAssignmentRuleSetUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetInput>;
  record: UpdateOneCutsheetAssignmentRuleSetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetAssignmentRuleSetInput>;
};


export type MutationCutsheetAssignmentRuleSetUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetAssignmentRuleInput>>>;
};


export type MutationCutsheetCapabilityGenerateBlankCutsheetArgs = {
  cutsheetCapabilityId: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityOptionCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCapabilityOptionCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCapabilityOptionDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityOptionUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCapabilityOptionUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCapabilityOptionUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCapabilityOptionUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType: Scalars['String']['input'];
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>>;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecificationInput>>>;
  title: Scalars['String']['input'];
};


export type MutationCutsheetCatalogChatArgs = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  capabilityId: Scalars['MongoID']['input'];
  messages: Array<CutsheetCatalogChatMessageInput>;
};


export type MutationCutsheetCreateManyArgs = {
  records: Array<CreateManyCutsheetInput>;
};


export type MutationCutsheetCreateOneArgs = {
  record: CreateOneCutsheetInput;
};


export type MutationCutsheetCutCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCutCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCutDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetCutUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCutUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCutUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCutUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>>;
  pricing?: InputMaybe<CutsheetCutPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCutSpecificationInput>>>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetDescriptionLibraryCreateManyArgs = {
  records: Array<CreateManyCutsheetDescriptionLibraryInput>;
};


export type MutationCutsheetDescriptionLibraryCreateOneArgs = {
  record: CreateOneCutsheetDescriptionLibraryInput;
};


export type MutationCutsheetDescriptionLibraryRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationCutsheetDescriptionLibraryUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetDescriptionLibraryInput;
};


export type MutationCutsheetDescriptionLibraryUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetDescriptionLibraryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetDescriptionLibraryInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetDescriptionLibraryInput>;
};


export type MutationCutsheetDescriptionLibraryUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetDescriptionLibraryInput>;
  record: UpdateOneCutsheetDescriptionLibraryInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetDescriptionLibraryInput>;
};


export type MutationCutsheetExtraCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetExtraCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetExtraDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetExtraUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetExtraUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetExtraUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetExtraUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>>;
  pricing?: InputMaybe<CutsheetExtraPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetExtraSpecificationInput>>>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetGroupCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityGroupInput>;
};


export type MutationCutsheetGroupCreateOneArgs = {
  record: CreateOneCutsheetCapabilityGroupInput;
};


export type MutationCutsheetGroupDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetGroupReorderArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationCutsheetGroupUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityGroupInput;
};


export type MutationCutsheetGroupUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityGroupInput>;
};


export type MutationCutsheetGroupUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupInput>;
  record: UpdateOneCutsheetCapabilityGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityGroupInput>;
};


export type MutationCutsheetGroupUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetHeaderPreviewArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetImageLibraryCreateManyArgs = {
  records: Array<CreateManyCutsheetImageLibraryInput>;
};


export type MutationCutsheetImageLibraryCreateOneArgs = {
  record: CreateOneCutsheetImageLibraryInput;
};


export type MutationCutsheetImageLibraryRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationCutsheetImageLibraryUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetImageLibraryInput;
};


export type MutationCutsheetImageLibraryUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetImageLibraryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetImageLibraryInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetImageLibraryInput>;
};


export type MutationCutsheetImageLibraryUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetImageLibraryInput>;
  record: UpdateOneCutsheetImageLibraryInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetImageLibraryInput>;
};


export type MutationCutsheetMarkConvertedArgs = {
  cutsheetId: Scalars['MongoID']['input'];
  responseId: Scalars['MongoID']['input'];
};


export type MutationCutsheetOptionReorderArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationCutsheetQuestionnaireChatArgs = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  capabilityId: Scalars['MongoID']['input'];
  messages: Array<CutsheetCatalogChatMessageInput>;
  questions: Scalars['JSON']['input'];
};


export type MutationCutsheetQuestionnaireCreateManyArgs = {
  records: Array<CreateManyCutsheetQuestionnaireInput>;
};


export type MutationCutsheetQuestionnaireCreateOneArgs = {
  record: CreateOneCutsheetQuestionnaireInput;
};


export type MutationCutsheetQuestionnaireDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetQuestionnaireResponseAttachSourceArgs = {
  annotations?: InputMaybe<Array<CutsheetResponseSourceAnnotationInput>>;
  id: Scalars['MongoID']['input'];
  pages: Array<CutsheetResponseSourcePageInput>;
};


export type MutationCutsheetQuestionnaireResponseGeneratePdfArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetQuestionnaireResponseReassignArgs = {
  id: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationCutsheetQuestionnaireResponseRestoreArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetQuestionnaireResponseSoftDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetQuestionnaireResponseUpsertArgs = {
  extraSelections?: InputMaybe<CutsheetResponseExtraResponseInput>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalNotes?: InputMaybe<Array<InputMaybe<CutsheetResponseNoteEntryInput>>>;
  questionnaireId: Scalars['MongoID']['input'];
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetResponseCutOptionInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
  timeToComplete?: InputMaybe<Scalars['Int']['input']>;
  trimSectionNotes?: InputMaybe<Scalars['String']['input']>;
  trimSelections?: InputMaybe<CutsheetResponseTrimResponseInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationCutsheetQuestionnaireRestoreArgs = {
  id: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
};


export type MutationCutsheetQuestionnaireUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetQuestionnaireInput;
};


export type MutationCutsheetQuestionnaireUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetQuestionnaireInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetQuestionnaireInput>;
};


export type MutationCutsheetQuestionnaireUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireInput>;
  record: UpdateOneCutsheetQuestionnaireInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetQuestionnaireInput>;
};


export type MutationCutsheetQuestionnaireUpsertArgs = {
  additionalCharges?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireAdditionalChargeInput>>>;
  capabilityId: Scalars['MongoID']['input'];
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  killFee?: InputMaybe<CutsheetQuestionnaireFeeInput>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetPricingOverrideEntryInput>>>;
  printSettings?: InputMaybe<CutsheetQuestionnairePrintSettingsOverrideInput>;
  processingFee?: InputMaybe<CutsheetQuestionnaireFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<CutsheetQuestionInput>>>;
  specOptionPricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetSpecOptionPricingEntryInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCutsheetRestoreArgs = {
  cutsheetId: Scalars['MongoID']['input'];
};


export type MutationCutsheetSoftDeleteArgs = {
  cutsheetId: Scalars['MongoID']['input'];
};


export type MutationCutsheetSpecificationCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilitySpecificationInput>;
};


export type MutationCutsheetSpecificationCreateOneArgs = {
  record: CreateOneCutsheetCapabilitySpecificationInput;
};


export type MutationCutsheetSpecificationDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetSpecificationReorderArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationCutsheetSpecificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilitySpecificationInput;
};


export type MutationCutsheetSpecificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilitySpecificationInput>;
};


export type MutationCutsheetSpecificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationInput>;
  record: UpdateOneCutsheetCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilitySpecificationInput>;
};


export type MutationCutsheetSpecificationUpsertArgs = {
  assignedToIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  capabilityId: Scalars['MongoID']['input'];
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetTrimCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetTrimCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetTrimDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetTrimUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetTrimUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetTrimUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetTrimUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>>;
  pricing?: InputMaybe<CutsheetTrimPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetTrimSpecificationInput>>>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetInput;
};


export type MutationCutsheetUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetInput>;
};


export type MutationCutsheetUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetInput>;
  record: UpdateOneCutsheetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetInput>;
};


export type MutationCutsheetUpsertArgs = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  cutsheetId?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasTypeInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  name: Scalars['String']['input'];
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimTypeInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationDataImportCancelJobArgs = {
  jobId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
};


export type MutationDataImportClearMatchDecisionArgs = {
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  side: Scalars['String']['input'];
};


export type MutationDataImportDeleteRecordArgs = {
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
};


export type MutationDataImportEnableAnimalSpeciesArgs = {
  addInspectionLevel?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  species: Scalars['String']['input'];
};


export type MutationDataImportExecuteArgs = {
  excludedRowNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId: Scalars['String']['input'];
  skippedWarningRowNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationDataImportFinalizeHygieneArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDataImportForceCancelArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDataImportJobCreateManyArgs = {
  records: Array<CreateManyDataImportJobInput>;
};


export type MutationDataImportJobCreateOneArgs = {
  record: CreateOneDataImportJobInput;
};


export type MutationDataImportJobUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDataImportJobInput;
};


export type MutationDataImportJobUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyDataImportJobInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyDataImportJobInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyDataImportJobInput>;
};


export type MutationDataImportJobUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneDataImportJobInput>;
  record: UpdateOneDataImportJobInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneDataImportJobInput>;
};


export type MutationDataImportResolveJobDuplicateArgs = {
  action: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
};


export type MutationDataImportRevalidateArgs = {
  data: Scalars['JSON']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationDataImportRevertToHygieneArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDataImportRunHygieneArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDataImportSaveColumnMappingArgs = {
  columnMapping: Scalars['JSON']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationDataImportSaveHygieneActionArgs = {
  buyerClusterId?: InputMaybe<Scalars['String']['input']>;
  canonicalA?: InputMaybe<Scalars['JSON']['input']>;
  canonicalB?: InputMaybe<Scalars['JSON']['input']>;
  canonicalOverride?: InputMaybe<Scalars['JSON']['input']>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  clusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  fromClusterId?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  jobAssignedTo?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  jobPatch?: InputMaybe<Scalars['JSON']['input']>;
  kind: Scalars['String']['input'];
  patch?: InputMaybe<Scalars['JSON']['input']>;
  producer?: InputMaybe<Scalars['JSON']['input']>;
  producerClusterId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Int']['input']>;
  rowIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  side?: InputMaybe<Scalars['String']['input']>;
  sourceClusterId?: InputMaybe<Scalars['String']['input']>;
  splitRows?: InputMaybe<Array<Scalars['Int']['input']>>;
  toClusterId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDataImportSaveMatchDecisionArgs = {
  action: Scalars['String']['input'];
  fieldsToApply?: InputMaybe<Array<Scalars['String']['input']>>;
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  side: Scalars['String']['input'];
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDataImportUpdateRowsArgs = {
  jobId: Scalars['String']['input'];
  updatedRows: Scalars['JSON']['input'];
};


export type MutationDataImportUploadArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  tenantId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationDepositPaymentIntentCreateArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type MutationDepositPaymentIntentSettleArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type MutationDepositSetupIntentCreateArgs = {
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationDocumentAddVersionArgs = {
  documentId: Scalars['MongoID']['input'];
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDocumentCategoryUpsertArgs = {
  name: Scalars['String']['input'];
};


export type MutationDocumentCreateArgs = {
  category: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  links?: InputMaybe<Array<DocumentLinkInput>>;
  mimeType: Scalars['String']['input'];
};


export type MutationDocumentCreateFromChatAttachmentArgs = {
  category: Scalars['String']['input'];
  chatMessageId: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<DocumentLinkInput>>;
};


export type MutationDocumentDeleteArgs = {
  documentId: Scalars['MongoID']['input'];
};


export type MutationDocumentRestoreVersionArgs = {
  documentId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationDocumentSetLinksArgs = {
  documentId: Scalars['MongoID']['input'];
  links: Array<DocumentLinkInput>;
};


export type MutationExportPresetCreateManyArgs = {
  records: Array<CreateManyExportPresetInput>;
};


export type MutationExportPresetCreateOneArgs = {
  record: CreateOneExportPresetInput;
};


export type MutationExportPresetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdExportPresetInput;
};


export type MutationExportPresetUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyExportPresetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyExportPresetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyExportPresetInput>;
};


export type MutationExportPresetUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneExportPresetInput>;
  record: UpdateOneExportPresetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneExportPresetInput>;
};


export type MutationExportSettingCreateManyArgs = {
  records: Array<CreateManyExportSettingInput>;
};


export type MutationExportSettingCreateOneArgs = {
  record: CreateOneExportSettingInput;
};


export type MutationExportSettingUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdExportSettingInput;
};


export type MutationExportSettingUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyExportSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyExportSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyExportSettingInput>;
};


export type MutationExportSettingUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneExportSettingInput>;
  record: UpdateOneExportSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneExportSettingInput>;
};


export type MutationFinancialMetricsActualsRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationFinancialMetricsActualsUpsertArgs = {
  record: FinancialMetricsActualsUpsertInput;
};


export type MutationFinancialReportingConfigCreateManyArgs = {
  records: Array<CreateManyFinancialReportingConfigInput>;
};


export type MutationFinancialReportingConfigCreateOneArgs = {
  record: CreateOneFinancialReportingConfigInput;
};


export type MutationFinancialReportingConfigUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFinancialReportingConfigInput;
};


export type MutationFinancialReportingConfigUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyFinancialReportingConfigInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyFinancialReportingConfigInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyFinancialReportingConfigInput>;
};


export type MutationFinancialReportingConfigUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneFinancialReportingConfigInput>;
  record: UpdateOneFinancialReportingConfigInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneFinancialReportingConfigInput>;
};


export type MutationFinancialReportingConfigUpsertArgs = {
  record: FinancialReportingConfigUpsertInput;
};


export type MutationFixVendorPhoneConfigArgs = {
  input?: InputMaybe<FixVendorPhoneConfigInput>;
};


export type MutationGameJobAddAnimalsArgs = {
  input: GameJobAddAnimalsInput;
};


export type MutationGameJobCreateArgs = {
  input: GameJobCreateInput;
};


export type MutationGameKioskAddressSetupArgs = {
  input: GameKioskAddressSetupInput;
};


export type MutationGameKioskDropoffCreateArgs = {
  input: GameKioskDropoffInput;
};


export type MutationGameKioskSignGenerateArgs = {
  vendor: Scalars['MongoID']['input'];
};


export type MutationGenerateCutsheetQuestionnaireArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type MutationGenerateInvoicePdfArgs = {
  invoiceId: Scalars['MongoID']['input'];
};


export type MutationGenerateUploadUrlArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
};


export type MutationInAppNotificationsMarkSeenArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationIntegrationCreateManyArgs = {
  records: Array<CreateManyIntegrationInput>;
};


export type MutationIntegrationCreateOneArgs = {
  record: CreateOneIntegrationInput;
};


export type MutationIntegrationDeliveryRetryArgs = {
  deliveryId?: InputMaybe<Scalars['MongoID']['input']>;
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationIntegrationInboundRecordResolveArgs = {
  action: Scalars['String']['input'];
  recordId: Scalars['MongoID']['input'];
};


export type MutationIntegrationInitArgs = {
  integrationName: EnumIntegrationName;
  shop?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIntegrationPollNowArgs = {
  adapter: Scalars['String']['input'];
};


export type MutationIntegrationPreflightArgs = {
  adapter: Scalars['String']['input'];
};


export type MutationIntegrationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdIntegrationInput;
};


export type MutationIntegrationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyIntegrationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyIntegrationInput>;
};


export type MutationIntegrationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneIntegrationInput>;
  record: UpdateOneIntegrationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneIntegrationInput>;
};


export type MutationInvoiceCreateForSchedulingJobArgs = {
  input?: InputMaybe<CreateInvoiceForSchedulingJobInput>;
};


export type MutationInvoiceCreateManyArgs = {
  records: Array<CreateManyInvoiceInput>;
};


export type MutationInvoiceCreateOneArgs = {
  record: CreateOneInvoiceInput;
};


export type MutationInvoiceFinalizeAndSendArgs = {
  input?: InputMaybe<VoidInvoiceInput>;
};


export type MutationInvoiceLineItemCreateManyArgs = {
  records: Array<CreateManyInvoiceLineItemInput>;
};


export type MutationInvoiceLineItemCreateOneArgs = {
  record: CreateOneInvoiceLineItemInput;
};


export type MutationInvoiceLineItemUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInvoiceLineItemInput;
};


export type MutationInvoiceLineItemUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyInvoiceLineItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyInvoiceLineItemInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyInvoiceLineItemInput>;
};


export type MutationInvoiceLineItemUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneInvoiceLineItemInput>;
  record: UpdateOneInvoiceLineItemInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneInvoiceLineItemInput>;
};


export type MutationInvoiceMarkAsPaidArgs = {
  input?: InputMaybe<MarkAsPaidInput>;
};


export type MutationInvoiceRefundArgs = {
  input?: InputMaybe<RefundInvoiceInput>;
};


export type MutationInvoiceUpdateArgs = {
  input?: InputMaybe<UpdateInvoiceInput>;
};


export type MutationInvoiceUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInvoiceInput;
};


export type MutationInvoiceUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyInvoiceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyInvoiceInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyInvoiceInput>;
};


export type MutationInvoiceUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneInvoiceInput>;
  record: UpdateOneInvoiceInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneInvoiceInput>;
};


export type MutationInvoiceVoidArgs = {
  input?: InputMaybe<VoidInvoiceInput>;
};


export type MutationJobIntegrationPushArgs = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
  jobId: Scalars['MongoID']['input'];
};


export type MutationJobTagCreateOneArgs = {
  record: CreateOneJobTagInput;
};


export type MutationJobTagRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationJobTagUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdJobTagInput;
};


export type MutationKillSheetPreviewArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type MutationLandingPageCreateManyArgs = {
  records: Array<CreateManyLandingPageSettingsInput>;
};


export type MutationLandingPageCreateOneArgs = {
  record: CreateOneLandingPageSettingsInput;
};


export type MutationLandingPageOneCreateManyArgs = {
  records: Array<CreateManyLandingPageSettingsInput>;
};


export type MutationLandingPageOneCreateOneArgs = {
  record: CreateOneLandingPageSettingsInput;
};


export type MutationLandingPageOneUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLandingPageSettingsInput;
};


export type MutationLandingPageOneUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyLandingPageSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyLandingPageSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyLandingPageSettingsInput>;
};


export type MutationLandingPageOneUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneLandingPageSettingsInput>;
  record: UpdateOneLandingPageSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneLandingPageSettingsInput>;
};


export type MutationLandingPageRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationLandingPageUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLandingPageSettingsInput;
};


export type MutationLandingPageUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyLandingPageSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyLandingPageSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyLandingPageSettingsInput>;
};


export type MutationLandingPageUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneLandingPageSettingsInput>;
  record: UpdateOneLandingPageSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneLandingPageSettingsInput>;
};


export type MutationLandingPageUpsertArgs = {
  input: LandingPageUpsertInput;
};


export type MutationMarkChatRoomAsReadArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  markMessagesRead?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkChatRoomAsUnreadArgs = {
  chatRoomId: Scalars['MongoID']['input'];
};


export type MutationMarketplaceLeadExportCsvArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarketplaceLeadSubmitArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  species: Scalars['String']['input'];
  timeline: Scalars['String']['input'];
};


export type MutationModuleCreateManyArgs = {
  records: Array<CreateManyVendorModuleInput>;
};


export type MutationModuleCreateOneArgs = {
  record: CreateOneVendorModuleInput;
};


export type MutationModuleUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorModuleInput;
};


export type MutationModuleUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorModuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorModuleInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorModuleInput>;
};


export type MutationModuleUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorModuleInput>;
  record: UpdateOneVendorModuleInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorModuleInput>;
};


export type MutationMyAddOnJobSplitArgs = {
  animalId: Scalars['MongoID']['input'];
  buyerId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
};


export type MutationMyAnimalAssignToJobArgs = {
  animalIds: Array<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  jobId: Scalars['MongoID']['input'];
  listing?: InputMaybe<ProcessorSchedulingListingInput>;
};


export type MutationMyAnimalCsvImportUploadArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationMyAnimalDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationMyAnimalQuickAddArgs = {
  animals: Array<QuickAddAnimalInput>;
};


export type MutationMyAnimalSetSplitBuyersArgs = {
  _id: Scalars['MongoID']['input'];
  splits: Array<HerdSplitBuyerInput>;
};


export type MutationMyAnimalUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  allowedSectionSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableToBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  claimMode?: InputMaybe<Scalars['String']['input']>;
  descriptorChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  listingDeposits?: InputMaybe<MyAnimalListingDepositsInput>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  liveWeightHigh?: InputMaybe<Scalars['Float']['input']>;
  producerDescription?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sizeTier?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMyGenerateSaleInvoiceArgs = {
  adjustments?: InputMaybe<Array<InputMaybe<OrderAdjustmentInput>>>;
  saleAmount: Scalars['Float']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyMarkOrderSettledOffPlatformArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyNudgeSectionBuyerArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyPlaceBuyerOnAnimalArgs = {
  animalId: Scalars['MongoID']['input'];
  buyerId: Scalars['MongoID']['input'];
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  splitPart: Scalars['String']['input'];
};


export type MutationMyReassignBuyerSplitArgs = {
  newBuyerId: Scalars['MongoID']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyReleaseBuyerSplitArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyRemoveBuyerSplitArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyReviseSaleInvoiceArgs = {
  adjustments?: InputMaybe<Array<InputMaybe<OrderAdjustmentInput>>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  saleAmount: Scalars['Float']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type MutationMyStartBuyerChatArgs = {
  buyerId: Scalars['MongoID']['input'];
};


export type MutationMyStartProducerChatArgs = {
  animalId?: InputMaybe<Scalars['MongoID']['input']>;
  producerId: Scalars['MongoID']['input'];
};


export type MutationMyVoidSaleInvoiceArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  splitId: Scalars['MongoID']['input'];
};


export type MutationNoteCreateManyArgs = {
  records: Array<CreateManyNoteInput>;
};


export type MutationNoteCreateOneArgs = {
  record: CreateOneNoteInput;
};


export type MutationNoteDeleteArgs = {
  noteId: Scalars['MongoID']['input'];
};


export type MutationNoteUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
};


export type MutationNoteUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNoteInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNoteInput>;
};


export type MutationNoteUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNoteInput>;
  record: UpdateOneNoteInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNoteInput>;
};


export type MutationNoteUpsertArgs = {
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  note: Scalars['String']['input'];
  noteId?: InputMaybe<Scalars['MongoID']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  removeAttachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<EnumNoteType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationNotificationCreateManyArgs = {
  records: Array<CreateManyNotificationInput>;
};


export type MutationNotificationCreateOneArgs = {
  record: CreateOneNotificationInput;
};


export type MutationNotificationPreferenceUpdateArgs = {
  category: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationNotificationPromptAnswerArgs = {
  answer: Scalars['String']['input'];
  promptId: Scalars['ID']['input'];
  via?: InputMaybe<Scalars['String']['input']>;
};


export type MutationNotificationPromptAnswerByTokenArgs = {
  answer: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationNotificationSettingsCreateManyArgs = {
  records: Array<CreateManyNotificationSettingInput>;
};


export type MutationNotificationSettingsCreateOneArgs = {
  record: CreateOneNotificationSettingInput;
};


export type MutationNotificationSettingsUpdateArgs = {
  notificationSettingId: Scalars['MongoID']['input'];
  settings: NotificationSettingsInput;
};


export type MutationNotificationSettingsUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNotificationSettingInput;
};


export type MutationNotificationSettingsUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNotificationSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNotificationSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNotificationSettingInput>;
};


export type MutationNotificationSettingsUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNotificationSettingInput>;
  record: UpdateOneNotificationSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNotificationSettingInput>;
};


export type MutationNotificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNotificationInput;
};


export type MutationNotificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNotificationInput>;
};


export type MutationNotificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNotificationInput>;
  record: UpdateOneNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNotificationInput>;
};


export type MutationParseCutsheetArgs = {
  capabilityId: Scalars['MongoID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationParseFilledCutsheetArgs = {
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  questionnaireId: Scalars['MongoID']['input'];
};


export type MutationPartnerIntegrationDeleteArgs = {
  integrationId: Scalars['MongoID']['input'];
};


export type MutationPartnerIntegrationIssueTokenArgs = {
  adapter: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationPartnerIntegrationUpsertArgs = {
  adapter: Scalars['String']['input'];
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inboundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  weightMode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPickupLocationUpsertArgs = {
  input: PickupLocationUpsertInput;
};


export type MutationPrimalCreateManyArgs = {
  records: Array<CreateManyPrimalInput>;
};


export type MutationPrimalCreateOneArgs = {
  record: CreateOnePrimalInput;
};


export type MutationPrimalCutBlockerCreateManyArgs = {
  records: Array<CreateManyPrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerCreateOneArgs = {
  record: CreateOnePrimalCutBlockerInput;
};


export type MutationPrimalCutBlockerUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutBlockerInput;
};


export type MutationPrimalCutBlockerUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutBlockerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutBlockerInput>;
  record: UpdateOnePrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerUpsertArgs = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<BlockedByInput>>>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};


export type MutationPrimalCutCreateManyArgs = {
  records: Array<CreateManyPrimalCutInput>;
};


export type MutationPrimalCutCreateOneArgs = {
  record: CreateOnePrimalCutInput;
};


export type MutationPrimalCutSoftDeleteArgs = {
  primalCutId: Scalars['MongoID']['input'];
};


export type MutationPrimalCutTypeCreateManyArgs = {
  records: Array<CreateManyPrimalCutTypeInput>;
};


export type MutationPrimalCutTypeCreateOneArgs = {
  record: CreateOnePrimalCutTypeInput;
};


export type MutationPrimalCutTypeUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutTypeInput;
};


export type MutationPrimalCutTypeUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutTypeInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutTypeInput>;
};


export type MutationPrimalCutTypeUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutTypeInput>;
  record: UpdateOnePrimalCutTypeInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutTypeInput>;
};


export type MutationPrimalCutUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutInput;
};


export type MutationPrimalCutUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutInput>;
};


export type MutationPrimalCutUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutInput>;
  record: UpdateOnePrimalCutInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutInput>;
};


export type MutationPrimalGroupCreateManyArgs = {
  records: Array<CreateManyPrimalGroupInput>;
};


export type MutationPrimalGroupCreateOneArgs = {
  record: CreateOnePrimalGroupInput;
};


export type MutationPrimalGroupUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalGroupInput;
};


export type MutationPrimalGroupUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalGroupInput>;
};


export type MutationPrimalGroupUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalGroupInput>;
  record: UpdateOnePrimalGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalGroupInput>;
};


export type MutationPrimalUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalInput;
};


export type MutationPrimalUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalInput>;
};


export type MutationPrimalUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalInput>;
  record: UpdateOnePrimalInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalInput>;
};


export type MutationProcessingJobForceUpdateStatusArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  processorSchedulingStatus: Scalars['String']['input'];
};


export type MutationProcessingPartnersCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessingPartnersOneCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersOneCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessingPartnersOneUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessingPartnersOneUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersOneUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessingPartnersUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessingPartnersUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessorCapabilityCreateManyArgs = {
  records: Array<CreateManyProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityCreateOneArgs = {
  record: CreateOneProcessorCapabilityInput;
};


export type MutationProcessorCapabilitySpecificationCreateManyArgs = {
  records: Array<CreateManyProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilitySpecificationCreateOneArgs = {
  record: CreateOneProcessorCapabilitySpecificationInput;
};


export type MutationProcessorCapabilitySpecificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorCapabilitySpecificationInput;
};


export type MutationProcessorCapabilitySpecificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilitySpecificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationInput>;
  record: UpdateOneProcessorCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorCapabilityInput;
};


export type MutationProcessorCapabilityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorCapabilityInput>;
  record: UpdateOneProcessorCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityUpsertArgs = {
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  canSelectMoreThanOneTrim: Scalars['Boolean']['input'];
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasModelInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImage?: InputMaybe<Scalars['Upload']['input']>;
  extrasImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  newCutBlockers?: InputMaybe<Scalars['JSON']['input']>;
  primalCuts: Array<Scalars['MongoID']['input']>;
  primalGroups?: InputMaybe<Array<InputMaybe<ProcessorCapabilityPrimalGroupInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimModelInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImage?: InputMaybe<Scalars['Upload']['input']>;
  trimImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessorDepositPaymentIntentCreateArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type MutationProcessorExportCsvArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ExportColumnInput>>>;
  endDate: Scalars['String']['input'];
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ExportFilterInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExportSortInput>>>;
  startDate: Scalars['String']['input'];
  type: ProcessorExportTypeEnum;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorExportCsvByVendorIdArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorNotificationCreateManyArgs = {
  records: Array<CreateManyProcessorNotificationInput>;
};


export type MutationProcessorNotificationCreateOneArgs = {
  record: CreateOneProcessorNotificationInput;
};


export type MutationProcessorNotificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorNotificationInput;
};


export type MutationProcessorNotificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorNotificationInput>;
};


export type MutationProcessorNotificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorNotificationInput>;
  record: UpdateOneProcessorNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorNotificationInput>;
};


export type MutationProcessorSchedulingAnimalHeadBulkUpdateArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  updatedAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadUpdatesInput>>>;
};


export type MutationProcessorSchedulingAnimalHeadDeleteArgs = {
  animalHeadId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingAnimalHeadPartialUpdateByIdArgs = {
  animalHeadId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingPartialUpdateAnimalHeadInput>;
  suppressNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProcessorSchedulingBulkActionArgs = {
  jobs?: InputMaybe<Array<ProcessorSchedulingBulkActionJobInput>>;
};


export type MutationProcessorSchedulingBuyerCutsheetReminderArgs = {
  contactUserId: Scalars['MongoID']['input'];
  schedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingCreateArgs = {
  newSchedule?: InputMaybe<CreateProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingCreateManyArgs = {
  records: Array<CreateManyProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingCreateOneArgs = {
  record: CreateOneProcessorSchedulingInput;
};


export type MutationProcessorSchedulingCutsheetReminderArgs = {
  schedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingDepositChargeCardArgs = {
  jobId: Scalars['MongoID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationProcessorSchedulingDepositCheckStripeArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingDepositMarkPaidArgs = {
  jobId: Scalars['MongoID']['input'];
  method: DepositManualMethod;
};


export type MutationProcessorSchedulingDragAndDropUpdateArgs = {
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventDate: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingDropoffConfirmationSetArgs = {
  jobId: Scalars['MongoID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessorSchedulingGenerateBillingStatementArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateBulkCarcassTagsArgs = {
  killDate?: InputMaybe<Scalars['String']['input']>;
  processorSchedulingIds: Array<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateBulkCutsheetRequestsArgs = {
  requests: Array<BulkCutsheetRequestInput>;
};


export type MutationProcessorSchedulingGenerateCarcassTagsArgs = {
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateCsvByVendorIdArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateCutsheetRequestArgs = {
  cutsheetRequestId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateHangingWeightCsvArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateKillSheetArgs = {
  date: Scalars['Date']['input'];
};


export type MutationProcessorSchedulingGeneratePackingSlipArgs = {
  cutsheetInformationId?: InputMaybe<Scalars['MongoID']['input']>;
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingNotificationSendArgs = {
  request?: InputMaybe<NotificationRequestInput>;
  type?: InputMaybe<Scalars['NotificationTypeInput']['input']>;
};


export type MutationProcessorSchedulingPartialUpdateByIdArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingPartialUpdateInput>;
  suppressNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProcessorSchedulingResendDepositNotificationArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingSendManualNotificationArgs = {
  jobId: Scalars['MongoID']['input'];
  notificationSettingId: Scalars['MongoID']['input'];
  recipients: Array<ManualNotificationRecipientInput>;
};


export type MutationProcessorSchedulingSplitTypeUpdateByIdArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingSplitTypeUpdateInput>;
};


export type MutationProcessorSchedulingUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
  record: UpdateByIdProcessorSchedulingInput;
};


export type MutationProcessorSchedulingUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSchedulingInput;
};


export type MutationProcessorSchedulingUpdateCutsheetsArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<Array<InputMaybe<CutsheetPartialUpdateInput>>>;
};


export type MutationProcessorSchedulingUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSchedulingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSchedulingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSchedulingInput>;
  record: UpdateOneProcessorSchedulingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSchedulingInput>;
};


export type MutationProcessorSettingsCreateArgs = {
  newProcessor?: InputMaybe<CreateProcessorSettingsWithCustomCapacityInput>;
};


export type MutationProcessorSettingsCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessorSettingsCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessorSettingsCustomCapacityCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsCustomCapacityCreateOneArgs = {
  record: CreateOneProcessorSettingsCustomCapacityInput;
};


export type MutationProcessorSettingsCustomCapacityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsCustomCapacityInput;
};


export type MutationProcessorSettingsCustomCapacityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsCustomCapacityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsCustomCapacityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityInput>;
  record: UpdateOneProcessorSettingsCustomCapacityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsUpdateArgs = {
  updateProcessor?: InputMaybe<UpdateProcessorSettingsWithCustomCapacityInput>;
};


export type MutationProcessorSettingsUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessorSettingsUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessorSettingsUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessorWorkflowCapacityUpdateArgs = {
  capacity: Scalars['JSON']['input'];
};


export type MutationProducerSettingsUpdateArgs = {
  listingPresets?: InputMaybe<Array<InputMaybe<ProducerListingPresetInput>>>;
  splitDeposits: Array<ProducerSplitDepositInput>;
};


export type MutationProvisionPhoneNumberArgs = {
  input?: InputMaybe<ProvisionPhoneNumberInput>;
};


export type MutationRecurringSeriesCancelUpcomingJobsArgs = {
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  customText?: InputMaybe<Scalars['String']['input']>;
  seriesId: Scalars['MongoID']['input'];
};


export type MutationRecurringSeriesCreateArgs = {
  animalSpecies: Scalars['String']['input'];
  headCount: Scalars['Int']['input'];
  inspectionLevel: Scalars['String']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rule: RecurrenceRuleInput;
  targetUpcomingCount?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationRecurringSeriesCreateFromJobArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  rule: RecurrenceRuleInput;
  targetUpcomingCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRecurringSeriesSetActiveArgs = {
  active: Scalars['Boolean']['input'];
  seriesId: Scalars['MongoID']['input'];
};


export type MutationRecurringSeriesUpdateRuleArgs = {
  rule: RecurrenceRuleInput;
  seriesId: Scalars['MongoID']['input'];
  targetUpcomingCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRefreshHostedNumberStatusArgs = {
  input?: InputMaybe<RefreshHostedNumberStatusInput>;
};


export type MutationReleasePhoneNumberArgs = {
  input?: InputMaybe<ReleasePhoneNumberInput>;
};


export type MutationSendMessageArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  chatRoomId: Scalars['MongoID']['input'];
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  message: Scalars['String']['input'];
};


export type MutationSendTestNotificationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailContent?: InputMaybe<Scalars['String']['input']>;
  notificationSettingId: Scalars['MongoID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  smsContent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSplitSendNotificationsUpdateArgs = {
  sendNotifications: Scalars['Boolean']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type MutationStateCreateManyArgs = {
  records: Array<CreateManyStateInput>;
};


export type MutationStateCreateOneArgs = {
  record: CreateOneStateInput;
};


export type MutationStateUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdStateInput;
};


export type MutationStateUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyStateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyStateInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyStateInput>;
};


export type MutationStateUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneStateInput>;
  record: UpdateOneStateInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneStateInput>;
};


export type MutationStripeAccountCreateArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationStripeSessionCreateArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationSubmitHostedLandlineOrderArgs = {
  input?: InputMaybe<SubmitHostedLandlineOrderInput>;
};


export type MutationSyncConversationPhoneNumbersArgs = {
  input?: InputMaybe<SyncConversationPhoneNumbersInput>;
};


export type MutationTenantCreateArgs = {
  newTenant: CreateOneTenantInput;
};


export type MutationTenantCreateManyArgs = {
  records: Array<CreateManyTenantInput>;
};


export type MutationTenantCreateOneArgs = {
  record: CreateOneTenantInput;
};


export type MutationTenantEnabledEditArgs = {
  enabled: Scalars['Boolean']['input'];
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantPictureUrlEditArgs = {
  pictureImage?: InputMaybe<Scalars['Upload']['input']>;
  pictureImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantSubscriptionEditArgs = {
  subscription: Scalars['String']['input'];
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTenantInput;
};


export type MutationTenantUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyTenantInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyTenantInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyTenantInput>;
};


export type MutationTenantUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneTenantInput>;
  record: UpdateOneTenantInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneTenantInput>;
};


export type MutationUpdateAuthMethodArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  targetAuthMethod: Scalars['String']['input'];
};


export type MutationUpdatePhoneNumberSmsWebhookArgs = {
  input?: InputMaybe<UpdatePhoneNumberSmsWebhookInput>;
};


export type MutationUpdateProfileArgs = {
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInputForProfile>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<Scalars['String']['input']>>;
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveSms?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserActivateArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationUserBasicUpsertArgs = {
  address?: InputMaybe<AddressInputForUser>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<RelationshipsInputForUser>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationUserCreateArgs = {
  newUser: CreateOneUserInput;
};


export type MutationUserCreateManyArgs = {
  records: Array<CreateManyUserInput>;
};


export type MutationUserCreateOneArgs = {
  record: CreateOneUserInput;
};


export type MutationUserDeactivateArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationUserHangTimePreferenceUpdateArgs = {
  preferredDays?: InputMaybe<Scalars['Int']['input']>;
  species: Scalars['String']['input'];
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationUserNotificationSummarySendArgs = {
  userId: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationUserRebookingOverrideUpdateArgs = {
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationUserSettingsUpdateArgs = {
  settings: UserSettingsInput;
  userId: Scalars['MongoID']['input'];
};


export type MutationUserUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
};


export type MutationUserUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyUserInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyUserInput>;
};


export type MutationUserUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneUserInput>;
  record: UpdateOneUserInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneUserInput>;
};


export type MutationVendorAddOnJobSplitArgs = {
  animalId: Scalars['MongoID']['input'];
  buyerId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
};


export type MutationVendorAnimalStatusUpdateArgs = {
  animalIds: Array<Scalars['MongoID']['input']>;
  status: Scalars['String']['input'];
};


export type MutationVendorCopySettingsArgs = {
  buckets: Array<Scalars['String']['input']>;
  sourceVendorId: Scalars['MongoID']['input'];
  species?: InputMaybe<Array<Scalars['String']['input']>>;
  targetVendorId: Scalars['MongoID']['input'];
};


export type MutationVendorCreateArgs = {
  newVendor: CreateOneVendorInput;
};


export type MutationVendorCreateInHouseProducerArgs = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  photo: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVendorCreateManyArgs = {
  records: Array<CreateManyVendorInput>;
};


export type MutationVendorCreateOneArgs = {
  record: CreateOneVendorInput;
};


export type MutationVendorCustomerNotificationDefaultsUpdateArgs = {
  animal: Scalars['Boolean']['input'];
  job: Scalars['Boolean']['input'];
  split: Scalars['Boolean']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationVendorDeclineRequestArgs = {
  requestId: Scalars['MongoID']['input'];
};


export type MutationVendorGenerateOrderInvoiceArgs = {
  orderId: Scalars['MongoID']['input'];
  paymentMethod: Scalars['String']['input'];
  processingAmount: Scalars['Float']['input'];
};


export type MutationVendorHerdAnimalDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationVendorHerdAnimalSetSplitBuyersArgs = {
  _id: Scalars['MongoID']['input'];
  splits: Array<HerdSplitBuyerInput>;
};


export type MutationVendorHerdAnimalUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  allowedSectionSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableToBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  claimMode?: InputMaybe<Scalars['String']['input']>;
  descriptorChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  listingDeposits?: InputMaybe<MyAnimalListingDepositsInput>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  liveWeightHigh?: InputMaybe<Scalars['Float']['input']>;
  producerDescription?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sizeTier?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVendorHerdAssignAnimalsToJobArgs = {
  animalIds: Array<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  jobId: Scalars['MongoID']['input'];
};


export type MutationVendorHerdQuickAddArgs = {
  animals: Array<QuickAddAnimalInput>;
  producer: HerdIntakeProducerInput;
};


export type MutationVendorInHouseProducerSettingsUpdateArgs = {
  listingPresets?: InputMaybe<Array<InputMaybe<ProducerListingPresetInput>>>;
  splitDeposits: Array<ProducerSplitDepositInput>;
};


export type MutationVendorLinkInHouseProducerArgs = {
  confirmStaffAccount?: InputMaybe<Scalars['Boolean']['input']>;
  producerUserId: Scalars['MongoID']['input'];
};


export type MutationVendorMarkOrderSettledInPersonArgs = {
  orderId: Scalars['MongoID']['input'];
};


export type MutationVendorModuleUpsertArgs = {
  active: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moduleType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationVendorNudgeSectionBuyerArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationVendorPlaceRequestOnAnimalArgs = {
  animalId: Scalars['MongoID']['input'];
  requestId: Scalars['MongoID']['input'];
};


export type MutationVendorReassignBuyerSplitArgs = {
  adminCorrection?: InputMaybe<Scalars['Boolean']['input']>;
  forfeit?: InputMaybe<Scalars['Boolean']['input']>;
  newBuyerId: Scalars['MongoID']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type MutationVendorRecordAnimalSettlementArgs = {
  animalId: Scalars['MongoID']['input'];
  method: Scalars['String']['input'];
};


export type MutationVendorRecordSplitSettlementArgs = {
  method: Scalars['String']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type MutationVendorReleaseBuyerSplitArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationVendorRemoveBuyerSplitArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type MutationVendorTeamMemberInviteArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: EnumUserRole;
};


export type MutationVendorTeamMemberRoleUpdateArgs = {
  role: EnumUserRole;
  userId: Scalars['MongoID']['input'];
};


export type MutationVendorTeamMemberSetEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['MongoID']['input'];
};


export type MutationVendorUndoDeclineArgs = {
  requestId: Scalars['MongoID']['input'];
};


export type MutationVendorUndoPlacementArgs = {
  requestId: Scalars['MongoID']['input'];
};


export type MutationVendorUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorInput;
};


export type MutationVendorUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorInput>;
};


export type MutationVendorUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorInput>;
  record: UpdateOneVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorInput>;
};


export type MutationWaitlistAddArgs = {
  animal: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationWaitlistCreateManyArgs = {
  records: Array<CreateManyWaitlistInput>;
};


export type MutationWaitlistCreateOneArgs = {
  record: CreateOneWaitlistInput;
};


export type MutationWaitlistDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWaitlistUnsubscribeArgs = {
  token: Scalars['String']['input'];
};


export type MutationWaitlistUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  animal?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWaitlistUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWaitlistInput;
};


export type MutationWaitlistUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyWaitlistInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyWaitlistInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyWaitlistInput>;
};


export type MutationWaitlistUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneWaitlistInput>;
  record: UpdateOneWaitlistInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneWaitlistInput>;
};


export type MutationWebhookCreateManyArgs = {
  records: Array<CreateManyVendorInput>;
};


export type MutationWebhookCreateOneArgs = {
  record: CreateOneVendorInput;
};


export type MutationWebhookUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorInput;
};


export type MutationWebhookUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorInput>;
};


export type MutationWebhookUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorInput>;
  record: UpdateOneVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorInput>;
};

export type MyAnimalAvailableColumn = {
  __typename?: 'MyAnimalAvailableColumn';
  aliases: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  validationRules?: Maybe<Scalars['String']['output']>;
};

export type MyAnimalCsvImportUploadPayload = {
  __typename?: 'MyAnimalCSVImportUploadPayload';
  availableColumns: Array<MyAnimalAvailableColumn>;
  detectedColumns: Array<Scalars['String']['output']>;
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  suggestedMapping?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Int']['output'];
  validationErrors: Array<MyAnimalCsvValidationError>;
};

export type MyAnimalCsvValidationError = {
  __typename?: 'MyAnimalCSVValidationError';
  errorMessages: Array<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  warningMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export type MyAnimalListingDepositsInput = {
  half?: InputMaybe<Scalars['Float']['input']>;
  quarter?: InputMaybe<Scalars['Float']['input']>;
  whole?: InputMaybe<Scalars['Float']['input']>;
};

export type MyAnimalsStats = {
  __typename?: 'MyAnimalsStats';
  listed: Scalars['Int']['output'];
  reserved: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MyNudgeSectionBuyerPayload = {
  __typename?: 'MyNudgeSectionBuyerPayload';
  nudgeCase: Scalars['String']['output'];
  nudgedAt: Scalars['Date']['output'];
  splitId: Scalars['MongoID']['output'];
};

/** Aggregated counts used to populate alert badges on main-nav items. */
export type NavBadgeCounts = {
  __typename?: 'NavBadgeCounts';
  requestedJobs?: Maybe<Scalars['Int']['output']>;
  unreadChats?: Maybe<Scalars['Int']['output']>;
  waitlist?: Maybe<Scalars['Int']['output']>;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['MongoID']['output'];
  animalHead?: Maybe<Scalars['MongoID']['output']>;
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<NoteAttachments>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  note?: Maybe<Scalars['String']['output']>;
  processorScheduling?: Maybe<Scalars['MongoID']['output']>;
  type: EnumNoteType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Scalars['MongoID']['output']>;
  vendor?: Maybe<Scalars['MongoID']['output']>;
};

export type NoteAttachments = {
  __typename?: 'NoteAttachments';
  _id?: Maybe<Scalars['MongoID']['output']>;
  filename: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type NoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** List of items with pagination. */
export type NotePagination = {
  __typename?: 'NotePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Note>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['MongoID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Array<Maybe<EnumNotificationChannel>>>;
  chatRoomId?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailTo?: Maybe<Scalars['String']['output']>;
  error?: Maybe<NotificationError>;
  errorMessage?: Maybe<NotificationErrorMessage>;
  groupId?: Maybe<Scalars['String']['output']>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['MongoID']['output']>;
  notificationType?: Maybe<EnumNotificationNotificationType>;
  sentOn?: Maybe<Scalars['Date']['output']>;
  sentTo?: Maybe<Scalars['String']['output']>;
  smsTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NotificationStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['MongoID']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type NotificationAuditChannelOutcome = {
  __typename?: 'NotificationAuditChannelOutcome';
  provider?: Maybe<NotificationAuditChannelProvider>;
  reason?: Maybe<Scalars['String']['output']>;
  sentTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type NotificationAuditChannelProvider = {
  __typename?: 'NotificationAuditChannelProvider';
  errorMessage?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type NotificationAuditChannels = {
  __typename?: 'NotificationAuditChannels';
  chat?: Maybe<NotificationAuditChannelOutcome>;
  email?: Maybe<NotificationAuditChannelOutcome>;
  inApp?: Maybe<NotificationAuditChannelOutcome>;
  sms?: Maybe<NotificationAuditChannelOutcome>;
};

export type NotificationAuditOutcomeCount = {
  __typename?: 'NotificationAuditOutcomeCount';
  count?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
};

export type NotificationAuditRecord = {
  __typename?: 'NotificationAuditRecord';
  attempt?: Maybe<Scalars['Int']['output']>;
  channels?: Maybe<NotificationAuditChannels>;
  correlationId?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  forced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  refs?: Maybe<Array<Maybe<NotificationAuditRef>>>;
  runId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type NotificationAuditRef = {
  __typename?: 'NotificationAuditRef';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NotificationAuditSearchResponse = {
  __typename?: 'NotificationAuditSearchResponse';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  outcomeCounts?: Maybe<Array<Maybe<NotificationAuditOutcomeCount>>>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  records?: Maybe<Array<Maybe<NotificationAuditRecord>>>;
  total: Scalars['Int']['output'];
};

export type NotificationError = {
  __typename?: 'NotificationError';
  email?: Maybe<NotificationErrorMessage>;
  sms?: Maybe<NotificationErrorMessage>;
};

export type NotificationErrorInput = {
  email?: InputMaybe<NotificationErrorMessageInput>;
  sms?: InputMaybe<NotificationErrorMessageInput>;
};

export type NotificationErrorMessage = {
  __typename?: 'NotificationErrorMessage';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type NotificationPagination = {
  __typename?: 'NotificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sms: Scalars['Boolean']['output'];
};

/** A confirmable notification looked up by the token in its email links. */
export type NotificationPromptPublic = {
  __typename?: 'NotificationPromptPublic';
  animalSpecies?: Maybe<Scalars['String']['output']>;
  dropoffDate?: Maybe<Scalars['String']['output']>;
  expiredReason?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  kind: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
};

/** The yes/no question a notification asked, and whether the viewer can still answer it. */
export type NotificationPromptState = {
  __typename?: 'NotificationPromptState';
  _id: Scalars['ID']['output'];
  canAnswer: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  kind: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type NotificationRequestInput = {
  contactUserId: Scalars['MongoID']['input'];
  scheduledJobId: Scalars['MongoID']['input'];
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  _id: Scalars['MongoID']['output'];
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  defaultConfirmationMessage?: Maybe<Scalars['String']['output']>;
  emailMessage?: Maybe<NotificationTemplate>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  preferredChannel?: Maybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: Maybe<Scalars['Boolean']['output']>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendInApp?: Maybe<Scalars['Boolean']['output']>;
  sendSMS?: Maybe<Scalars['Boolean']['output']>;
  smsMessage?: Maybe<NotificationTemplate>;
  timings?: Maybe<Array<Maybe<NotificationSettingTimings>>>;
  trigger: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type NotificationSettingPagination = {
  __typename?: 'NotificationSettingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<NotificationSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type NotificationSettingTimings = {
  __typename?: 'NotificationSettingTimings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  days: Scalars['Float']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  relation: EnumNotificationSettingTimingsRelation;
};

export type NotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation: EnumNotificationSettingTimingsRelation;
};

export type NotificationSettingsInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<NotificationMessageInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<NotificationMessageInput>;
  timings?: InputMaybe<Array<InputMaybe<NotificationTimingInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationStatus = {
  __typename?: 'NotificationStatus';
  email?: Maybe<EnumNotificationStatusEmail>;
  sms?: Maybe<EnumNotificationStatusSms>;
};

export type NotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  _id: Scalars['MongoID']['output'];
  channel: EnumNotificationTemplateChannel;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  type: EnumNotificationTemplateType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NotificationTimingInput = {
  days: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  relation: Scalars['String']['input'];
};

export type OrderAdjustmentInput = {
  amount: Scalars['Float']['input'];
  label: Scalars['String']['input'];
};

export type OrderAdjustmentResult = {
  __typename?: 'OrderAdjustmentResult';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

export type OrderInvoiceResult = {
  __typename?: 'OrderInvoiceResult';
  _id: Scalars['MongoID']['output'];
  adjustments?: Maybe<Array<Maybe<OrderAdjustmentResult>>>;
  balanceDue?: Maybe<Scalars['Float']['output']>;
  balancePaidAt?: Maybe<Scalars['Date']['output']>;
  depositRecipientParty?: Maybe<Scalars['String']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  invoicePaidAt?: Maybe<Scalars['Date']['output']>;
  invoicedAt?: Maybe<Scalars['Date']['output']>;
  listingFee?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  saleBaseAmount?: Maybe<Scalars['Float']['output']>;
  settledOffPlatform?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
};

export type OverheadCostInput = {
  amount: Scalars['Float']['input'];
  frequency: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type ParentProduct = {
  __typename?: 'ParentProduct';
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  integration?: Maybe<Scalars['MongoID']['output']>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock_quantity?: Maybe<Scalars['Float']['output']>;
  stock_status?: Maybe<EnumParentProductStock_Status>;
  type?: Maybe<EnumParentProductType>;
  vendor: Scalars['MongoID']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParseCutsheetPayload = {
  __typename?: 'ParseCutsheetPayload';
  catalog: ParsedCutsheetCatalog;
  questionnaire: ParsedCutsheetQuestionnaire;
};

export type ParseFilledCutsheetCustomerDetails = {
  __typename?: 'ParseFilledCutsheetCustomerDetails';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ParseFilledCutsheetCutSelection = {
  __typename?: 'ParseFilledCutsheetCutSelection';
  optionId: Scalars['String']['output'];
  specifications?: Maybe<Array<ParseFilledCutsheetSpecificationSelection>>;
};

export type ParseFilledCutsheetDefaultSelections = {
  __typename?: 'ParseFilledCutsheetDefaultSelections';
  extraSelections?: Maybe<ParseFilledCutsheetExtraSelections>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  primalNotes?: Maybe<Array<ParseFilledCutsheetNoteEntry>>;
  selectedCuts: Array<ParseFilledCutsheetCutSelection>;
  specifications: Array<ParseFilledCutsheetSpecificationSelection>;
  trimSectionNotes?: Maybe<Scalars['String']['output']>;
  trimSelections?: Maybe<ParseFilledCutsheetTrimSelections>;
};

export type ParseFilledCutsheetExtraSelection = {
  __typename?: 'ParseFilledCutsheetExtraSelection';
  optionId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type ParseFilledCutsheetExtraSelections = {
  __typename?: 'ParseFilledCutsheetExtraSelections';
  extras: Array<ParseFilledCutsheetExtraSelection>;
};

export type ParseFilledCutsheetNoteEntry = {
  __typename?: 'ParseFilledCutsheetNoteEntry';
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type ParseFilledCutsheetPage = {
  __typename?: 'ParseFilledCutsheetPage';
  height: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type ParseFilledCutsheetPayload = {
  __typename?: 'ParseFilledCutsheetPayload';
  customerDetails?: Maybe<ParseFilledCutsheetCustomerDetails>;
  defaultSelections: ParseFilledCutsheetDefaultSelections;
  pages: Array<ParseFilledCutsheetPage>;
  report: ParseFilledCutsheetReport;
};

export type ParseFilledCutsheetRegion = {
  __typename?: 'ParseFilledCutsheetRegion';
  height: Scalars['Float']['output'];
  page: Scalars['Int']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type ParseFilledCutsheetReport = {
  __typename?: 'ParseFilledCutsheetReport';
  counts: ParseFilledCutsheetReportCounts;
  documentSummary: Scalars['String']['output'];
  items: Array<ParseFilledCutsheetReportItem>;
  suggestedName?: Maybe<Scalars['String']['output']>;
};

export type ParseFilledCutsheetReportCounts = {
  __typename?: 'ParseFilledCutsheetReportCounts';
  lowConfidence: Scalars['Int']['output'];
  matched: Scalars['Int']['output'];
  unmatched: Scalars['Int']['output'];
};

export type ParseFilledCutsheetReportItem = {
  __typename?: 'ParseFilledCutsheetReportItem';
  anchorId?: Maybe<Scalars['String']['output']>;
  anchorKind?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  matchedId?: Maybe<Scalars['String']['output']>;
  matchedTitle?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  rawText: Scalars['String']['output'];
  regions: Array<ParseFilledCutsheetRegion>;
  status: Scalars['String']['output'];
};

export type ParseFilledCutsheetSpecificationSelection = {
  __typename?: 'ParseFilledCutsheetSpecificationSelection';
  specification: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type ParseFilledCutsheetTrimSelection = {
  __typename?: 'ParseFilledCutsheetTrimSelection';
  optionId: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  specifications?: Maybe<Array<ParseFilledCutsheetSpecificationSelection>>;
};

export type ParseFilledCutsheetTrimSelections = {
  __typename?: 'ParseFilledCutsheetTrimSelections';
  trim: Array<ParseFilledCutsheetTrimSelection>;
  type: Scalars['String']['output'];
};

export type ParsedCutsheetCatalog = {
  __typename?: 'ParsedCutsheetCatalog';
  animalType: Scalars['String']['output'];
  cuts: Array<ParsedCutsheetCut>;
  description?: Maybe<Scalars['String']['output']>;
  extras: Array<ParsedCutsheetExtra>;
  name: Scalars['String']['output'];
  primals: Array<ParsedCutsheetGroup>;
  specifications: Array<ParsedCutsheetSpecification>;
  trim: Array<ParsedCutsheetTrim>;
};

export type ParsedCutsheetCut = {
  __typename?: 'ParsedCutsheetCut';
  description?: Maybe<Scalars['String']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  priceFee?: Maybe<Scalars['Float']['output']>;
  priceFeePerPound?: Maybe<Scalars['Float']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  primalName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetExtra = {
  __typename?: 'ParsedCutsheetExtra';
  description?: Maybe<Scalars['String']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  priceFee?: Maybe<Scalars['Float']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetGroup = {
  __typename?: 'ParsedCutsheetGroup';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetQuestion = {
  __typename?: 'ParsedCutsheetQuestion';
  allowMultiple?: Maybe<Scalars['Boolean']['output']>;
  availableCutIds?: Maybe<Array<Scalars['String']['output']>>;
  availableTrimIds?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  requireExactTotal?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Int']['output'];
  specificationId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ParsedCutsheetQuestionnaire = {
  __typename?: 'ParsedCutsheetQuestionnaire';
  animalType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questions: Array<ParsedCutsheetQuestion>;
};

export type ParsedCutsheetSpecification = {
  __typename?: 'ParsedCutsheetSpecification';
  cutName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetTrim = {
  __typename?: 'ParsedCutsheetTrim';
  description?: Maybe<Scalars['String']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  priceFee?: Maybe<Scalars['Float']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type PartnerIntegrationDeleteResult = {
  __typename?: 'PartnerIntegrationDeleteResult';
  ok: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type PartnerIntegrationToken = {
  __typename?: 'PartnerIntegrationToken';
  hint: Scalars['String']['output'];
  inboundUrl: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type PickupLocation = {
  __typename?: 'PickupLocation';
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<PickupLocationLocation>;
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type PickupLocationAddressInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PickupLocationLocation = {
  __typename?: 'PickupLocationLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<EnumPickupLocationLocationType>;
};

/** List of items with pagination. */
export type PickupLocationPagination = {
  __typename?: 'PickupLocationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PickupLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PickupLocationUpsertInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<PickupLocationAddressInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Primal = {
  __typename?: 'Primal';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuts: Array<PrimalCut>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<PrimalGroup>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type PrimalCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};

export type PrimalCut = {
  __typename?: 'PrimalCut';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cutType?: Maybe<PrimalCutType>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  primal?: Maybe<Primal>;
  type?: Maybe<EnumPrimalCutType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PrimalCutBlocker = {
  __typename?: 'PrimalCutBlocker';
  _id: Scalars['MongoID']['output'];
  animalSpecies: Scalars['String']['output'];
  blockedBy?: Maybe<Array<Maybe<PrimalCutBlockerBlockedBy>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  inspectionLevel: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primalCutId: Scalars['MongoID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type PrimalCutBlockerBlockedBy = {
  __typename?: 'PrimalCutBlockerBlockedBy';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  primalCutId: Scalars['MongoID']['output'];
};

export type PrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};

/** List of items with pagination. */
export type PrimalCutBlockerPagination = {
  __typename?: 'PrimalCutBlockerPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCutBlocker>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PrimalCutPagination = {
  __typename?: 'PrimalCutPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCut>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PrimalCutType = {
  __typename?: 'PrimalCutType';
  _id: Scalars['MongoID']['output'];
  animalSpecies?: Maybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lid?: Maybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['output'];
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type PrimalCutTypePagination = {
  __typename?: 'PrimalCutTypePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCutType>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PrimalGroup = {
  __typename?: 'PrimalGroup';
  _id: Scalars['MongoID']['output'];
  animalSpecies?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  animalType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  primals?: Maybe<Array<Maybe<Primal>>>;
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type PrimalGroupPagination = {
  __typename?: 'PrimalGroupPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PrimalPagination = {
  __typename?: 'PrimalPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Primal>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessingPartnerPremierProducer = {
  __typename?: 'ProcessingPartnerPremierProducer';
  badge?: Maybe<Scalars['String']['output']>;
  producerId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessingPartnerTenant = {
  __typename?: 'ProcessingPartnerTenant';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
};

export type ProcessingPartnerVendor = {
  __typename?: 'ProcessingPartnerVendor';
  _id?: Maybe<Scalars['MongoID']['output']>;
  address?: Maybe<Address>;
  shop_name?: Maybe<Scalars['String']['output']>;
  stripe_config?: Maybe<Scalars['JSON']['output']>;
  tenant?: Maybe<ProcessingPartnerTenant>;
};

export type ProcessingPartners = {
  __typename?: 'ProcessingPartners';
  _id?: Maybe<Scalars['MongoID']['output']>;
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsSpecies>>>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  landingPage?: Maybe<LandingPageSettings>;
  openSplitCount?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<ProcessingPartnerVendor>;
};

export type ProcessorCapability = {
  __typename?: 'ProcessorCapability';
  _id: Scalars['MongoID']['output'];
  activeSpecification?: Maybe<ProcessorCapabilitySpecification>;
  animalSpecies?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  animalType?: Maybe<Scalars['String']['output']>;
  canSelectMoreThanOneTrim?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuts?: Maybe<Array<Maybe<PrimalCut>>>;
  extras?: Maybe<Array<Maybe<ProcessorCapabilityExtras>>>;
  extrasDescription?: Maybe<Scalars['String']['output']>;
  extrasImageUrl?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  primalCuts?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  primalGroups?: Maybe<Array<Maybe<PrimalGroup>>>;
  specificationSnapshots: Array<ProcessorCapabilitySpecification>;
  trim?: Maybe<Array<Maybe<ProcessorCapabilityTrim>>>;
  trimDescription?: Maybe<Scalars['String']['output']>;
  trimImageUrl?: Maybe<Scalars['String']['output']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
  wizardWelcomeContent?: Maybe<Scalars['String']['output']>;
  wizardWelcomeTitle?: Maybe<Scalars['String']['output']>;
};


export type ProcessorCapabilitySpecificationSnapshotsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilitySpecificationInput>;
};

export type ProcessorCapabilityExtras = {
  __typename?: 'ProcessorCapabilityExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  type: EnumProcessorCapabilityExtrasType;
};

export type ProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type: EnumProcessorCapabilityExtrasType;
};

export type ProcessorCapabilityExtrasModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

/** List of items with pagination. */
export type ProcessorCapabilityPagination = {
  __typename?: 'ProcessorCapabilityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorCapability>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorCapabilityPrimalCutInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutType?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessorCapabilityPrimalGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  primals?: InputMaybe<Array<InputMaybe<ProcessorCapabilityPrimalInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ProcessorCapabilityPrimalInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cuts?: InputMaybe<Array<InputMaybe<ProcessorCapabilityPrimalCutInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessorCapabilitySpecification = {
  __typename?: 'ProcessorCapabilitySpecification';
  _id: Scalars['MongoID']['output'];
  capability?: Maybe<ProcessorCapability>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  specifications?: Maybe<Array<Maybe<ProcessorCapabilitySpecificationSpecifications>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ProcessorCapabilitySpecificationPagination = {
  __typename?: 'ProcessorCapabilitySpecificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorCapabilitySpecification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorCapabilitySpecificationSpecifications = {
  __typename?: 'ProcessorCapabilitySpecificationSpecifications';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fid?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  measurementUnit?: Maybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name: Scalars['String']['output'];
  options: Array<Maybe<ProcessorCapabilitySpecificationSpecificationsOptions>>;
};

export type ProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  measurementUnit: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit;
  name: Scalars['String']['input'];
  options: Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsOptionsInput>>;
};

export type ProcessorCapabilitySpecificationSpecificationsOptions = {
  __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ProcessorCapabilityTrim = {
  __typename?: 'ProcessorCapabilityTrim';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound: Scalars['Float']['output'];
};

export type ProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
};

export type ProcessorCapabilityTrimModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
};

export type ProcessorExportCsvResponse = {
  __typename?: 'ProcessorExportCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export enum ProcessorExportTypeEnum {
  /** Export animal data (one row per animal, no split data) */
  Animal = 'animal',
  /** Export invoice data */
  Invoice = 'invoice',
  /** Export job data */
  Job = 'job',
  /** Export customers as a QuickBooks Desktop IIF customer list */
  QuickbooksDesktopCustomers = 'quickbooks_desktop_customers',
  /** Export invoices as a QuickBooks Desktop IIF transaction file */
  QuickbooksDesktopInvoices = 'quickbooks_desktop_invoices',
  /** Export splits data */
  Splits = 'splits',
  /** Export splits data with cutsheet */
  SplitsCutsheet = 'splits_cutsheet',
  /** Export user data */
  User = 'user'
}

export type ProcessorNotification = {
  __typename?: 'ProcessorNotification';
  _id: Scalars['MongoID']['output'];
  errorMessage?: Maybe<Scalars['JSON']['output']>;
  notificationType: Scalars['String']['output'];
  sentOn: Scalars['Date']['output'];
  sentTo: Scalars['String']['output'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type ProcessorNotificationPagination = {
  __typename?: 'ProcessorNotificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorOfferedSplit = {
  __typename?: 'ProcessorOfferedSplit';
  species: Scalars['String']['output'];
  splitTypes: Array<Scalars['String']['output']>;
};

export type ProcessorScheduling = {
  __typename?: 'ProcessorScheduling';
  _id: Scalars['MongoID']['output'];
  additionalPickupDetails?: Maybe<Scalars['String']['output']>;
  animalHeads?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeads>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: Maybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: Maybe<Scalars['Float']['output']>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  cancellationCustomText?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['MongoID']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerConfirmation?: Maybe<ProcessorSchedulingCustomerConfirmation>;
  customerConfirmationHistory?: Maybe<Array<Maybe<ProcessorSchedulingCustomerConfirmationHistory>>>;
  deposit?: Maybe<ProcessorSchedulingDeposit>;
  depositAcknowledgedAt?: Maybe<Scalars['Date']['output']>;
  dropoffConfirmationRequested?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  dropoffDateStr?: Maybe<Scalars['String']['output']>;
  expectedArrivalTime?: Maybe<Scalars['String']['output']>;
  externalIds?: Maybe<Scalars['JSON']['output']>;
  /** Return Kill Date from the first animal head */
  firstKillDate?: Maybe<Scalars['Date']['output']>;
  /** Whether the processor vendor has the Cutsheet Needed notification enabled */
  hasCutsheetNeededNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the processor vendor has the Cutsheet Reminder notification enabled */
  hasCutsheetReminderNotification?: Maybe<Scalars['Boolean']['output']>;
  /** A head with any live slot that has no buyer (an unfilled layout slot, or an unassigned claim) is considered missing. Marketplace claims always carry a buyer, and unsold capacity has no slot, so neither is flagged. Evaluates the real Split docs. */
  hasMissingContacts?: Maybe<Scalars['Boolean']['output']>;
  /** A head with a live capacity-holding slot (claimed/confirmed/occupied) lacking a cutsheet/questionnaireResponse is considered missing. Bare open placeholders are not gaps. Evaluates the real Split docs. */
  hasMissingCutsheets?: Maybe<Scalars['Boolean']['output']>;
  /** Any animal head with NO live splits at all is considered missing — its layout was never decided. Under eager slot materialization a laid-out head always has (open) splits, and a marketplace claim is a live split. */
  hasMissingSplits?: Maybe<Scalars['Boolean']['output']>;
  headCount: Scalars['Float']['output'];
  invoice?: Maybe<ProcessorSchedulingInvoice>;
  invoices?: Maybe<ProcessorSchedulingInvoices>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isOnBehalfOf?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['String']['output'];
  killedDate?: Maybe<Scalars['Date']['output']>;
  linkedInvoices?: Maybe<Array<Maybe<Invoice>>>;
  matchedHeadStatuses?: Maybe<Array<ProcessorSchedulingHeadStatusMatch>>;
  notificationHistory: Array<Notification>;
  pickupLocation?: Maybe<PickupLocation>;
  processorCapabilities: Array<ProcessorCapability>;
  processorSettings?: Maybe<ProcessorSettings>;
  recurringSeries?: Maybe<Scalars['MongoID']['output']>;
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<User>;
  scheduledDate?: Maybe<Scalars['Date']['output']>;
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusChanges?: Maybe<Array<Maybe<ProcessorSchedulingStatusChanges>>>;
  statusLastUpdated?: Maybe<Scalars['Date']['output']>;
  tags: Array<JobTag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
  vendorCutsheets: Array<Cutsheet>;
  waitlist?: Maybe<Scalars['MongoID']['output']>;
};


export type ProcessorSchedulingNotificationHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProcessorSchedulingProcessorCapabilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type ProcessorSchedulingVendorCutsheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};

export type ProcessorSchedulingAnimalHeads = {
  __typename?: 'ProcessorSchedulingAnimalHeads';
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Section sizes a buyer may claim when listed (whole/half/quarter). */
  allowedSectionSizes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** True when the animal is listed on the buyer marketplace. */
  availableToBuyers?: Maybe<Scalars['Boolean']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  cutDateStr?: Maybe<Scalars['String']['output']>;
  dateFirstEnteredHangingWeight?: Maybe<Scalars['Date']['output']>;
  dateUpdatedHangingWeight?: Maybe<Scalars['Date']['output']>;
  /** Producer-curated buyer-card descriptor chip codes (see @farmshare/utils ANIMAL_DESCRIPTOR_CHIPS) — carried by the Animal doc; exposed so the job page's listing editor can edit the buyer card in place. */
  descriptorChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grade?: Maybe<Scalars['String']['output']>;
  hangTimeDays?: Maybe<Scalars['Float']['output']>;
  hangingWeight?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideA?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideB?: Maybe<Scalars['Float']['output']>;
  /** This animal has a live slot with no buyer (an unfilled layout slot, or an unassigned claim). */
  hasMissingContacts?: Maybe<Scalars['Boolean']['output']>;
  /** This animal has a live capacity-holding slot (claimed/confirmed/occupied) lacking a cutsheet/questionnaireResponse. Bare open placeholders are not gaps. */
  hasMissingCutsheets?: Maybe<Scalars['Boolean']['output']>;
  /** This animal has NO live splits at all — its layout was never decided. */
  hasMissingSplits?: Maybe<Scalars['Boolean']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: Maybe<ProcessorSchedulingAnimalHeadsInvoice>;
  invoice_line_item?: Maybe<Scalars['MongoID']['output']>;
  isHangingWeightPerSide?: Maybe<Scalars['Boolean']['output']>;
  isKillAndChill?: Maybe<Scalars['Boolean']['output']>;
  isOverThirtyMonths?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  killDateStr?: Maybe<Scalars['String']['output']>;
  /** Who published the current listing — 'producer' or 'processor'. */
  listedBy?: Maybe<Scalars['String']['output']>;
  /** Producer-set per-size deposit (dollars), keyed by split size. */
  listingDeposits?: Maybe<ProcessorSchedulingAnimalHeadsListingDeposits>;
  /** Producer's $/lb hanging-weight listing rate (dollars). */
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  /** Producer-set flat all-in listing price (dollars). */
  listingTotalPrice?: Maybe<Scalars['Float']['output']>;
  liveWeight?: Maybe<Scalars['Float']['output']>;
  /** Top of the producer live-weight range (lbs). */
  liveWeightHigh?: Maybe<Scalars['Float']['output']>;
  /** Producer's buyer-facing free-text description of the animal (600 chars max) — carried by the Animal doc; exposed so the job page's listing editor can edit it alongside the chips. */
  producerDescription?: Maybe<Scalars['String']['output']>;
  producerIdentifier?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  questionnaire?: Maybe<Scalars['MongoID']['output']>;
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  /** Coarse live-size bucket for the buyer cost estimate (xs–xl). */
  sizeTier?: Maybe<Scalars['String']['output']>;
  /** Whole-animal layout ('whole' | 'half' | 'quarters' | 'half_and_two_quarters'), derived from the head's splits. */
  splitType?: Maybe<Scalars['String']['output']>;
  splits?: Maybe<Array<Maybe<Split>>>;
  /** The individual animal's status — independently writable within the job's processing flow. */
  status?: Maybe<Scalars['String']['output']>;
  /** Per-animal status audit trail: every direct edit, job cascade, and force-update. changedByName is empty for system writes (webhooks, crons). */
  statusChanges?: Maybe<Array<Maybe<AnimalStatusChange>>>;
  thirdPartyFee?: Maybe<Scalars['Float']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  /** The ratio of carcass weight to live weight, expressed as a percentage. */
  yield?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoice = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoice';
  _id?: Maybe<Scalars['MongoID']['output']>;
  additionalCharges?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges>>>;
  additionalCost?: Maybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost>;
  extras?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceExtras>>>;
  finishedWeights?: Maybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights>;
  trims?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceTrims>>>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost';
  cost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceExtras = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights';
  categories?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories>>>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceTrims = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsListingDeposits = {
  __typename?: 'ProcessorSchedulingAnimalHeadsListingDeposits';
  half?: Maybe<Scalars['Float']['output']>;
  quarter?: Maybe<Scalars['Float']['output']>;
  whole?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingBulkActionAnimalHeadInput = {
  animalHeadId: Scalars['MongoID']['input'];
  customFieldValues?: InputMaybe<Array<InputMaybe<ProcessorSchedulingBulkActionCustomFieldValueInput>>>;
  cutDate?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  killDate?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingBulkActionCustomFieldValueInput = {
  definitionId: Scalars['MongoID']['input'];
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingBulkActionJobInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<ProcessorSchedulingBulkActionAnimalHeadInput>>>;
  processorSchedulingId: Scalars['MongoID']['input'];
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
};

export type ProcessorSchedulingBulkActionResponse = {
  __typename?: 'ProcessorSchedulingBulkActionResponse';
  results?: Maybe<Array<ProcessorSchedulingBulkActionResult>>;
};

export type ProcessorSchedulingBulkActionResult = {
  __typename?: 'ProcessorSchedulingBulkActionResult';
  error?: Maybe<Scalars['String']['output']>;
  processorSchedulingId: Scalars['MongoID']['output'];
  record?: Maybe<ProcessorScheduling>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProcessorSchedulingCustomerConfirmation = {
  __typename?: 'ProcessorSchedulingCustomerConfirmation';
  prompt?: Maybe<Scalars['MongoID']['output']>;
  respondedAt: Scalars['Date']['output'];
  respondedBy?: Maybe<Scalars['MongoID']['output']>;
  respondedByName?: Maybe<Scalars['String']['output']>;
  status: EnumProcessorSchedulingCustomerConfirmationStatus;
  via: EnumProcessorSchedulingCustomerConfirmationVia;
};

export type ProcessorSchedulingCustomerConfirmationHistory = {
  __typename?: 'ProcessorSchedulingCustomerConfirmationHistory';
  prompt?: Maybe<Scalars['MongoID']['output']>;
  respondedAt: Scalars['Date']['output'];
  respondedBy?: Maybe<Scalars['MongoID']['output']>;
  respondedByName?: Maybe<Scalars['String']['output']>;
  status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus;
  via: EnumProcessorSchedulingCustomerConfirmationHistoryVia;
};

export type ProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt: Scalars['Date']['input'];
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus;
  via: EnumProcessorSchedulingCustomerConfirmationHistoryVia;
};

export type ProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt: Scalars['Date']['input'];
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status: EnumProcessorSchedulingCustomerConfirmationStatus;
  via: EnumProcessorSchedulingCustomerConfirmationVia;
};

export type ProcessorSchedulingDeposit = {
  __typename?: 'ProcessorSchedulingDeposit';
  amount?: Maybe<Scalars['Float']['output']>;
  checkoutSession?: Maybe<ProcessorSchedulingDepositCheckoutSession>;
  method?: Maybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: Maybe<Scalars['Date']['output']>;
  paidAt?: Maybe<Scalars['Date']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  price_external_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumProcessorSchedulingDepositStatus>;
};

export type ProcessorSchedulingDepositCheckoutSession = {
  __typename?: 'ProcessorSchedulingDepositCheckoutSession';
  customer_id?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<ProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type ProcessorSchedulingForceUpdateStatusResponse = {
  __typename?: 'ProcessorSchedulingForceUpdateStatusResponse';
  newStatus?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingHeadStatusMatch = {
  __typename?: 'ProcessorSchedulingHeadStatusMatch';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type ProcessorSchedulingInvoice = {
  __typename?: 'ProcessorSchedulingInvoice';
  additionalCost?: Maybe<ProcessorSchedulingInvoiceAdditionalCost>;
  invoice_external_id?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  isPayAtPickup?: Maybe<Scalars['Boolean']['output']>;
  sendInvoicePDF?: Maybe<Scalars['Boolean']['output']>;
  sendPaymentLink?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSchedulingInvoiceAdditionalCost = {
  __typename?: 'ProcessorSchedulingInvoiceAdditionalCost';
  cost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<ProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSchedulingInvoices = {
  __typename?: 'ProcessorSchedulingInvoices';
  _id?: Maybe<Scalars['MongoID']['output']>;
  contacts?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContacts>>>;
  pricing?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesPricing>>>;
};

export type ProcessorSchedulingInvoicesContacts = {
  __typename?: 'ProcessorSchedulingInvoicesContacts';
  _id?: Maybe<Scalars['MongoID']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  invoice_external_id?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  isPayAtPickup?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sendPaymentLink?: Maybe<Scalars['Boolean']['output']>;
  splits?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplits>>>;
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplits = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplits';
  _id?: Maybe<Scalars['MongoID']['output']>;
  additionalCharges?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges>>>;
  animalHeadPublicId?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsExtras>>>;
  finishedWeights?: Maybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeights>;
  splitType?: Maybe<Scalars['String']['output']>;
  trims?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsTrims>>>;
};

export type ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsExtras = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeights = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsFinishedWeights';
  categories?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories>>>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type ProcessorSchedulingInvoicesContactsSplitsTrims = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsTrims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesPricingInput>>>;
};

export type ProcessorSchedulingInvoicesPricing = {
  __typename?: 'ProcessorSchedulingInvoicesPricing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type ProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type ProcessorSchedulingListingDepositsInput = {
  half?: InputMaybe<Scalars['Float']['input']>;
  quarter?: InputMaybe<Scalars['Float']['input']>;
  whole?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingListingInput = {
  allowedSectionSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingDeposits?: InputMaybe<ProcessorSchedulingListingDepositsInput>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type ProcessorSchedulingPagination = {
  __typename?: 'ProcessorSchedulingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorScheduling>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSchedulingPartialUpdateAnimalHeadInput = {
  cutDate?: InputMaybe<Scalars['String']['input']>;
  cutsheetInformation?: InputMaybe<CutsheetInformationPartialUpdateInput>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  killDate?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  thirdPartyFee?: InputMaybe<Scalars['Float']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingPartialUpdateInput = {
  addAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadInput>>>;
  addTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  blockIndex?: InputMaybe<Scalars['Int']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  dropoffDate?: InputMaybe<Scalars['String']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  markInvoicePaid?: InputMaybe<Scalars['Boolean']['input']>;
  pickupLocation?: InputMaybe<Scalars['String']['input']>;
  removeTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requestedBy?: InputMaybe<ProcessorSchedulingPartialUpdateRequestedByInput>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUpdateExistingUser?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type ProcessorSchedulingPartialUpdateRequestedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingPartialUpdateResponse = {
  __typename?: 'ProcessorSchedulingPartialUpdateResponse';
  error?: Maybe<ErrorInterface>;
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
  warnings?: Maybe<Array<Maybe<ProcessorSchedulingPartialUpdateWarning>>>;
};

export type ProcessorSchedulingPartialUpdateWarning = {
  __typename?: 'ProcessorSchedulingPartialUpdateWarning';
  message?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingSplitTypeUpdateInput = {
  animalHeadId: Scalars['MongoID']['input'];
  cutsheetInformation?: InputMaybe<Array<InputMaybe<CutsheetInformationInput>>>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingSplitTypeUpdateResponse = {
  __typename?: 'ProcessorSchedulingSplitTypeUpdateResponse';
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingStatusChanges = {
  __typename?: 'ProcessorSchedulingStatusChanges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  changedBy?: Maybe<Scalars['MongoID']['output']>;
  changedByName?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  newStatus: EnumProcessorSchedulingStatusChangesNewStatus;
  previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus;
};

export type ProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  newStatus: EnumProcessorSchedulingStatusChangesNewStatus;
  previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus;
};

export type ProcessorSettings = {
  __typename?: 'ProcessorSettings';
  _id: Scalars['MongoID']['output'];
  about?: Maybe<Scalars['String']['output']>;
  acceptsInPersonDeposits?: Maybe<Scalars['Boolean']['output']>;
  animalSettings?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettings>>>;
  animals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: Maybe<Array<Maybe<ProcessorSettingsAutoSchedulingSettings>>>;
  butcherSlotPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  capacityConfigurationType?: Maybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: Maybe<Array<Maybe<ProcessorSettingsCapacitySettings>>>;
  carcassSettings?: Maybe<Array<Maybe<ProcessorSettingsCarcassSettings>>>;
  commercialStartDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customCapacities: Array<ProcessorSettingsCustomCapacity>;
  customCutsheetPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  customerNotificationDefaults?: Maybe<ProcessorSettingsCustomerNotificationDefaults>;
  documentSettings?: Maybe<ProcessorSettingsDocumentSettings>;
  enabledAnimalSplits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The enabled animals are ones that don't currently have validation errors associated to them. */
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimals>>>;
  faq?: Maybe<Scalars['String']['output']>;
  hangTimeSettings?: Maybe<Array<Maybe<ProcessorSettingsHangTimeSettings>>>;
  invoicing?: Maybe<ProcessorSettingsInvoicing>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProcessorNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  killAndChillSettings?: Maybe<Array<Maybe<ProcessorSettingsKillAndChillSettings>>>;
  kioskShortCode?: Maybe<Scalars['String']['output']>;
  kioskToken?: Maybe<Scalars['String']['output']>;
  landingPage?: Maybe<LandingPageSettings>;
  marketplaceInterestNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  outsideWindowNote?: Maybe<Scalars['String']['output']>;
  processorNotificationEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  schedulingDeposit?: Maybe<Scalars['Float']['output']>;
  sendWeeklySummaryEmail?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  timeTrackingConfig?: Maybe<ProcessorSettingsTimeTrackingConfig>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validationErrors?: Maybe<Array<Maybe<ProcessorSettingsValidationErrors>>>;
  vendor?: Maybe<Vendor>;
  workflowCapacity?: Maybe<ProcessorSettingsWorkflowCapacity>;
};


export type ProcessorSettingsCustomCapacitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProcessorSettingsLandingPageArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLandingPageSettingsInput>;
};

export type ProcessorSettingsAnimalRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Int']['input']>;
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
  isEnabled: Scalars['Boolean']['input'];
};

export type ProcessorSettingsAnimalSettings = {
  __typename?: 'ProcessorSettingsAnimalSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  butcherSlotPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  customCutsheetPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  inspectionLevels?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['output'];
  maxSchedulingDays?: Maybe<Scalars['Float']['output']>;
  minSchedulingDays?: Maybe<Scalars['Float']['output']>;
  rebooking?: Maybe<ProcessorSettingsAnimalSettingsRebooking>;
  requestDropoffConfirmation?: Maybe<Scalars['Boolean']['output']>;
  schedulingDeposit?: Maybe<Scalars['Float']['output']>;
  showOutsideWindowDates?: Maybe<Scalars['Boolean']['output']>;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightedAnimalUnit?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSettingsAnimalSettingsButcherSlotPricing = {
  __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing';
  animal?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  species?: Maybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type ProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type ProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['input'];
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<ProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSettingsAnimalSettingsPricingInput = {
  inspectionLevel: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type ProcessorSettingsAnimalSettingsRebooking = {
  __typename?: 'ProcessorSettingsAnimalSettingsRebooking';
  dueSoonWindowDays?: Maybe<Scalars['Float']['output']>;
  intervalDays?: Maybe<Scalars['Float']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSettingsAutoCarcassNumberSettingsInput = {
  currentNumber: Scalars['Float']['input'];
  inspectionLevel: EnumProcessorSettingsAnimalSettingsInspectionLevels;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingInput = {
  cutDateDays: Scalars['Int']['input'];
  harvestDateDays: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingSettings = {
  __typename?: 'ProcessorSettingsAutoSchedulingSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  cutDateDays: Scalars['Float']['output'];
  harvestDateDays: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays: Scalars['Float']['input'];
  harvestDateDays: Scalars['Float']['input'];
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export enum ProcessorSettingsCapacityConfigurationType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export type ProcessorSettingsCapacitySettings = {
  __typename?: 'ProcessorSettingsCapacitySettings';
  dailyCapacities?: Maybe<Array<Maybe<DailyCapacity>>>;
  dayOfWeek: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export type ProcessorSettingsCapacitySettingsDailyCapacityBlockInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<DailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value: Scalars['Float']['input'];
};

export type ProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  dayOfWeek: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type ProcessorSettingsCarcassSettings = {
  __typename?: 'ProcessorSettingsCarcassSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  currentNumber: Scalars['Float']['output'];
  inspectionLevel: Scalars['String']['output'];
  lastTakenNumber: Scalars['Float']['output'];
  species: Scalars['String']['output'];
  year: Scalars['Float']['output'];
};

export type ProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber: Scalars['Float']['input'];
  inspectionLevel: Scalars['String']['input'];
  lastTakenNumber: Scalars['Float']['input'];
  species: Scalars['String']['input'];
  year: Scalars['Float']['input'];
};

export type ProcessorSettingsCustomCapacity = {
  __typename?: 'ProcessorSettingsCustomCapacity';
  _id: Scalars['MongoID']['output'];
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyCapacities?: Maybe<Array<Maybe<DailyCapacity>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['output'];
  /** The date formatted from UTC time to be MM/DD/YYYY */
  dateStr?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  processorSettings?: Maybe<ProcessorSettings>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ProcessorSettingsCustomCapacityPagination = {
  __typename?: 'ProcessorSettingsCustomCapacityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorSettingsCustomCapacity>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSettingsCustomerNotificationDefaults = {
  __typename?: 'ProcessorSettingsCustomerNotificationDefaults';
  _id?: Maybe<Scalars['MongoID']['output']>;
  animal?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Scalars['Boolean']['output']>;
  split?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSettingsDocumentSettings = {
  __typename?: 'ProcessorSettingsDocumentSettings';
  calendarTooltip?: Maybe<ProcessorSettingsDocumentSettingsCalendarTooltip>;
  carcassTag?: Maybe<ProcessorSettingsDocumentSettingsCarcassTag>;
  cutsheet?: Maybe<ProcessorSettingsDocumentSettingsCutsheet>;
  cutsheetHeader?: Maybe<ProcessorSettingsDocumentSettingsCutsheetHeader>;
  killSheet?: Maybe<ProcessorSettingsDocumentSettingsKillSheet>;
};

export type ProcessorSettingsDocumentSettingsCalendarTooltip = {
  __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip';
  fields?: Maybe<Array<Maybe<ProcessorSettingsDocumentSettingsCarcassTagFields>>>;
};

export type ProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type ProcessorSettingsDocumentSettingsCarcassTag = {
  __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag';
  fields?: Maybe<Array<Maybe<ProcessorSettingsDocumentSettingsCarcassTagFields>>>;
  title?: Maybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type ProcessorSettingsDocumentSettingsCarcassTagFields = {
  __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields';
  column?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fieldKey: Scalars['String']['output'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['output'];
};

export type ProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource;
  label: Scalars['String']['input'];
};

export type ProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type ProcessorSettingsDocumentSettingsCutsheet = {
  __typename?: 'ProcessorSettingsDocumentSettingsCutsheet';
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type ProcessorSettingsDocumentSettingsCutsheetHeader = {
  __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader';
  fields?: Maybe<Array<Maybe<ProcessorSettingsDocumentSettingsCarcassTagFields>>>;
  media?: Maybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type ProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type ProcessorSettingsDocumentSettingsCutsheetInput = {
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type ProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<ProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<ProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<ProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<ProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type ProcessorSettingsDocumentSettingsKillSheet = {
  __typename?: 'ProcessorSettingsDocumentSettingsKillSheet';
  fields?: Maybe<Array<Maybe<ProcessorSettingsDocumentSettingsCarcassTagFields>>>;
};

export type ProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type ProcessorSettingsHangTimeInput = {
  isEnabled: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<InputMaybe<ProcessorSettingsHangTimeOptionInput>>>;
  species: Scalars['String']['input'];
};

export type ProcessorSettingsHangTimeOptionInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays: Scalars['Int']['input'];
  isDefault: Scalars['Boolean']['input'];
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSettingsHangTimeSettings = {
  __typename?: 'ProcessorSettingsHangTimeSettings';
  isEnabled: Scalars['Boolean']['output'];
  options?: Maybe<Array<Maybe<ProcessorSettingsHangTimeSettingsOptions>>>;
  species: EnumProcessorSettingsHangTimeSettingsSpecies;
};

export type ProcessorSettingsHangTimeSettingsInput = {
  isEnabled: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<InputMaybe<ProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species: EnumProcessorSettingsHangTimeSettingsSpecies;
};

export type ProcessorSettingsHangTimeSettingsOptions = {
  __typename?: 'ProcessorSettingsHangTimeSettingsOptions';
  availableAtBooking?: Maybe<Scalars['Boolean']['output']>;
  durationDays: Scalars['Float']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  upcharge?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays: Scalars['Float']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSettingsInvoicing = {
  __typename?: 'ProcessorSettingsInvoicing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  defaultSplitRule?: Maybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  trackYields?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSettingsKillAndChillInput = {
  isEnabled: Scalars['Boolean']['input'];
  pricePerHead: Scalars['Float']['input'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

export type ProcessorSettingsKillAndChillSettings = {
  __typename?: 'ProcessorSettingsKillAndChillSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  pricePerHead: Scalars['Float']['output'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

export type ProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  pricePerHead: Scalars['Float']['input'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

/** List of items with pagination. */
export type ProcessorSettingsPagination = {
  __typename?: 'ProcessorSettingsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorSettings>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSettingsTimeTrackingConfig = {
  __typename?: 'ProcessorSettingsTimeTrackingConfig';
  baseDigitalSavings: Scalars['Float']['output'];
  hourlyRate: Scalars['Float']['output'];
  timePerBooking: Scalars['Float']['output'];
  timePerCutsheet: Scalars['Float']['output'];
  timePerNotification: Scalars['Float']['output'];
};

export type ProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
};

export type ProcessorSettingsValidationErrors = {
  __typename?: 'ProcessorSettingsValidationErrors';
  group?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  property?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProcessorSettingsWorkflowCapacity = {
  __typename?: 'ProcessorSettingsWorkflowCapacity';
  coolerRailCapacity?: Maybe<Scalars['Float']['output']>;
  dropoffPenCapacity?: Maybe<Scalars['Float']['output']>;
  freezerCapacity?: Maybe<Scalars['Float']['output']>;
  furtherProcessingCapacity?: Maybe<Scalars['Float']['output']>;
  killPerDay?: Maybe<Scalars['Float']['output']>;
  targetHangDays?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

/** Counts behind the producer dashboard's action cards — what needs this producer's attention across their whole book, not just the page of jobs the browser has loaded. */
export type ProducerActionCounts = {
  __typename?: 'ProducerActionCounts';
  depositDue: Scalars['Int']['output'];
  dropoffsToConfirm: Scalars['Int']['output'];
  missingBuyers: Scalars['Int']['output'];
  missingCutsheets: Scalars['Int']['output'];
  missingSplits: Scalars['Int']['output'];
  openInvoiceTotal: Scalars['Float']['output'];
  openInvoices: Scalars['Int']['output'];
};

export type ProducerCustomerAdjustment = {
  __typename?: 'ProducerCustomerAdjustment';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

export type ProducerCustomerBalance = {
  __typename?: 'ProducerCustomerBalance';
  amount?: Maybe<Scalars['Float']['output']>;
  kind: Scalars['String']['output'];
};

export type ProducerCustomerClaim = {
  __typename?: 'ProducerCustomerClaim';
  adjustments?: Maybe<Array<Maybe<ProducerCustomerAdjustment>>>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  animalId: Scalars['MongoID']['output'];
  availableToBuyers?: Maybe<Scalars['Boolean']['output']>;
  balanceDue?: Maybe<Scalars['Float']['output']>;
  balancePaid?: Maybe<Scalars['Boolean']['output']>;
  cutsheetKeepReason?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositOverrideState?: Maybe<Scalars['String']['output']>;
  depositRecipientParty?: Maybe<Scalars['String']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  hangingWeight?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideA?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideB?: Maybe<Scalars['Float']['output']>;
  hasCutsheet: Scalars['Boolean']['output'];
  holdExpiresAt?: Maybe<Scalars['Date']['output']>;
  invoicedAt?: Maybe<Scalars['Date']['output']>;
  isHangingWeightPerSide?: Maybe<Scalars['Boolean']['output']>;
  isPendingAcceptance?: Maybe<Scalars['Boolean']['output']>;
  isVetoed?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['MongoID']['output']>;
  jobPublicId?: Maybe<Scalars['String']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  listingFee?: Maybe<Scalars['Float']['output']>;
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  listingTotalPrice?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['MongoID']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  saleBaseAmount?: Maybe<Scalars['Float']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  splitId: Scalars['MongoID']['output'];
  splitPart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
  vetoedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProducerCustomerLastOrder = {
  __typename?: 'ProducerCustomerLastOrder';
  amount?: Maybe<Scalars['Float']['output']>;
  animalLabel: Scalars['String']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  orderId: Scalars['MongoID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type ProducerCustomerRow = {
  __typename?: 'ProducerCustomerRow';
  balance: ProducerCustomerBalance;
  buyerId: Scalars['MongoID']['output'];
  claims?: Maybe<Array<ProducerCustomerClaim>>;
  claimsCount: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  lastActivityAt?: Maybe<Scalars['Date']['output']>;
  lastOrder?: Maybe<ProducerCustomerLastOrder>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  relationshipSummary: Scalars['String']['output'];
};

export type ProducerCustomersPage = {
  __typename?: 'ProducerCustomersPage';
  count: Scalars['Int']['output'];
  items?: Maybe<Array<ProducerCustomerRow>>;
  pageInfo: ProducerCustomersPageInfo;
};

export type ProducerCustomersPageInfo = {
  __typename?: 'ProducerCustomersPageInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

export type ProducerListingEligibility = {
  __typename?: 'ProducerListingEligibility';
  eligible: Scalars['Boolean']['output'];
  marketplaceEnabled?: Maybe<Scalars['Boolean']['output']>;
  missing: Array<Scalars['String']['output']>;
};

export type ProducerListingEstimate = {
  __typename?: 'ProducerListingEstimate';
  sections?: Maybe<Array<Maybe<ProducerListingSectionEstimate>>>;
};

export type ProducerListingPreset = {
  __typename?: 'ProducerListingPreset';
  allowedSectionSizes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  descriptorChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  listingTotalPrice?: Maybe<Scalars['Float']['output']>;
  pricingMode?: Maybe<Scalars['String']['output']>;
  sizeTier?: Maybe<Scalars['String']['output']>;
  species: Scalars['String']['output'];
};

export type ProducerListingPresetInput = {
  allowedSectionSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptorChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
  pricingMode?: InputMaybe<Scalars['String']['input']>;
  sizeTier?: InputMaybe<Scalars['String']['input']>;
  species: Scalars['String']['input'];
};

export type ProducerListingSectionEstimate = {
  __typename?: 'ProducerListingSectionEstimate';
  estimatedTotalHigh: Scalars['Float']['output'];
  estimatedTotalLow: Scalars['Float']['output'];
  meatHigh: Scalars['Float']['output'];
  meatLow: Scalars['Float']['output'];
  processingHigh: Scalars['Float']['output'];
  processingLow: Scalars['Float']['output'];
  size: Scalars['String']['output'];
};

export type ProducerRosterAnimal = {
  __typename?: 'ProducerRosterAnimal';
  animalId: Scalars['MongoID']['output'];
  availableToBuyers?: Maybe<Scalars['Boolean']['output']>;
  buyers?: Maybe<Array<Maybe<ProducerRosterBuyer>>>;
  hangingWeight?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideA?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideB?: Maybe<Scalars['Float']['output']>;
  isHangingWeightPerSide?: Maybe<Scalars['Boolean']['output']>;
  isPendingAcceptance?: Maybe<Scalars['Boolean']['output']>;
  isVetoed?: Maybe<Scalars['Boolean']['output']>;
  listingRatePerLb?: Maybe<Scalars['Float']['output']>;
  listingTotalPrice?: Maybe<Scalars['Float']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  vetoedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProducerRosterBuyer = {
  __typename?: 'ProducerRosterBuyer';
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  balanceDue?: Maybe<Scalars['Float']['output']>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  buyerId?: Maybe<Scalars['MongoID']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  buyerPhone?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositOverrideState?: Maybe<Scalars['String']['output']>;
  depositRecipientParty?: Maybe<Scalars['String']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  holdExpiresAt?: Maybe<Scalars['Date']['output']>;
  invoicedAt?: Maybe<Scalars['Date']['output']>;
  orderId?: Maybe<Scalars['MongoID']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  splitDepositAmount?: Maybe<Scalars['Float']['output']>;
  splitId: Scalars['MongoID']['output'];
  splitPart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProducerSettings = {
  __typename?: 'ProducerSettings';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  boxImageUrl?: Maybe<Scalars['String']['output']>;
  buyerBio?: Maybe<Scalars['String']['output']>;
  buyerChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listingPresets?: Maybe<Array<Maybe<ProducerListingPreset>>>;
  producer?: Maybe<Scalars['MongoID']['output']>;
  splitDeposits: Array<ProducerSplitDeposit>;
};

export type ProducerSplitDeposit = {
  __typename?: 'ProducerSplitDeposit';
  half?: Maybe<Scalars['Float']['output']>;
  quarter?: Maybe<Scalars['Float']['output']>;
  species: Scalars['String']['output'];
  whole?: Maybe<Scalars['Float']['output']>;
};

export type ProducerSplitDepositInput = {
  half?: InputMaybe<Scalars['Float']['input']>;
  quarter?: InputMaybe<Scalars['Float']['input']>;
  species: Scalars['String']['input'];
  whole?: InputMaybe<Scalars['Float']['input']>;
};

export type ProducerStripeConfig = {
  __typename?: 'ProducerStripeConfig';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProducerStripeSession = {
  __typename?: 'ProducerStripeSession';
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID']['output'];
  children?: Maybe<Array<Maybe<ParentProduct>>>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  integration?: Maybe<Integration>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ParentProduct>;
  permalink?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock_quantity?: Maybe<Scalars['Float']['output']>;
  stock_status?: Maybe<EnumProductStock_Status>;
  type?: Maybe<EnumProductType>;
  vendor?: Maybe<Vendor>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProvisionPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type ProvisionPhoneNumberResponse = {
  __typename?: 'ProvisionPhoneNumberResponse';
  error?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PublicProducer = {
  __typename?: 'PublicProducer';
  _id?: Maybe<Scalars['MongoID']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  buyerBio?: Maybe<Scalars['String']['output']>;
  buyerChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  partnerProcessors: Array<PublicProducerProcessor>;
  slug: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PublicProducerProcessor = {
  __typename?: 'PublicProducerProcessor';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  CutsheetCapabilityById?: Maybe<CutsheetCapability>;
  CutsheetCapabilityByIds: Array<CutsheetCapability>;
  /** Retrieve cutsheet capabilities for a vendor and animal type */
  CutsheetCapabilityByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapability>>>;
  CutsheetCapabilityCount?: Maybe<Scalars['Int']['output']>;
  CutsheetCapabilityMany: Array<CutsheetCapability>;
  CutsheetCapabilityOne?: Maybe<CutsheetCapability>;
  CutsheetCapabilityPagination?: Maybe<CutsheetCapabilityPagination>;
  /** Load legacy ProcessorCapability data for a capability, organized by inspection level */
  CutsheetLegacyCapabilityData: Array<Maybe<LegacyCapabilityData>>;
  /** Retrieve a list of all active vendors. */
  activeVendorList?: Maybe<Array<Maybe<Vendor>>>;
  addressById?: Maybe<Address>;
  addressByIds: Array<Address>;
  addressCount?: Maybe<Scalars['Int']['output']>;
  addressMany: Array<Address>;
  addressOne?: Maybe<Address>;
  addressPagination?: Maybe<AddressPagination>;
  /** Account activity per enabled vendor over a date range, with a comparison period: how many staff, producer and buyer accounts signed in and took an action. Admin only. */
  adminAccountActivity: Scalars['JSON']['output'];
  /** Platform-wide business stats (the daily Slack stats) over a date range, with a comparison period. Set consistentCohort to restrict both windows to the processors active in the comparison window, so newly-onboarded processors do not inflate the period-over-period deltas. Admin only. */
  adminBusinessStats: Scalars['JSON']['output'];
  /** Admin-only: producers linked to a vendor, for relationship pickers. */
  adminProducerSearch: Array<User>;
  /** Admin-only user search with filters */
  adminUserSearch: Array<User>;
  /** Admin-only: list every vendor across all tenants. */
  adminVendorList: Array<Vendor>;
  /** Admin-only: distinct animal species configured for a vendor (processor + cutsheets). */
  adminVendorSpecies: Array<Scalars['String']['output']>;
  /** Analyze historical processing data and suggest optimal animal configurations based on configurable time range. */
  analyzeAnimalConfigurations: Scalars['JSON']['output'];
  /** Analyze historical processing data for seasonality patterns and suggest monthly modifiers based on configurable time range. */
  analyzeSeasonality: Scalars['JSON']['output'];
  buyerActiveHolds?: Maybe<Array<Maybe<BuyerActiveHold>>>;
  buyerAnimalDetail?: Maybe<BuyerAnimalDetail>;
  /** Session-scoped: return nearby animals published to buyers, sorted by distance. */
  buyerAvailableAnimals?: Maybe<Array<Maybe<BuyerAvailableAnimal>>>;
  /** Return the signed-in buyer's active marketplace interest subscriptions (processor + species). Session-scoped. */
  buyerInterests?: Maybe<Array<Maybe<MarketplaceInterest>>>;
  /** Retrieve the session buyer's processing invoice for a job. */
  buyerInvoiceForJob?: Maybe<Invoice>;
  /** Session-scoped: the signed-in buyer's orders, read from the immutable Order collection (frozen snapshot + persisted deposit/fee/total + live operational status joined from the Animal). IDOR-safe; newest-first. */
  buyerOrders?: Maybe<Array<Maybe<BuyerOrder>>>;
  buyerOrdersPagination?: Maybe<ProcessorSchedulingPagination>;
  /** Return the signed-in buyer's own split requests (all lifecycle states), newest first. Session-scoped: buyerId derives from req.user._id. */
  buyerRequests?: Maybe<Array<Maybe<MarketplaceRequest>>>;
  buyerSavedPaymentMethods?: Maybe<Array<Maybe<BuyerSavedPaymentMethod>>>;
  buyerSplitForCutsheet?: Maybe<BuyerSplitForCutsheet>;
  /** Session-scoped: return the signed-in buyer's settled transaction history (paid deposits, refunds, forfeitures) with job/invoice context. */
  buyerTransactions?: Maybe<Array<Maybe<BuyerTransaction>>>;
  /** Calculate available processor capacity for a given date range */
  calculateProcessorCapacity?: Maybe<CapacityCalculationResult>;
  /** Calculate available processor capacity for all enabled animal species */
  calculateProcessorCapacityAllSpecies?: Maybe<CapacityCalculationAllSpeciesResult>;
  calendarEventCount?: Maybe<Scalars['Int']['output']>;
  calendarEventMany: Array<CalendarEvent>;
  calendarEventOne?: Maybe<CalendarEvent>;
  calendarEventPagination?: Maybe<CalendarEventPagination>;
  calendarEventTypeCount?: Maybe<Scalars['Int']['output']>;
  calendarEventTypeMany: Array<CalendarEventType>;
  calendarEventTypeOne?: Maybe<CalendarEventType>;
  calendarEventTypePagination?: Maybe<CalendarEventTypePagination>;
  cancellationReasonById?: Maybe<CancellationReason>;
  cancellationReasonByIds: Array<CancellationReason>;
  cancellationReasonCount?: Maybe<Scalars['Int']['output']>;
  cancellationReasonMany: Array<CancellationReason>;
  cancellationReasonOne?: Maybe<CancellationReason>;
  cancellationReasonPagination?: Maybe<CancellationReasonPagination>;
  csvImportJobById?: Maybe<CsvImportJob>;
  csvImportJobByIds: Array<CsvImportJob>;
  csvImportJobCount?: Maybe<Scalars['Int']['output']>;
  csvImportJobMany: Array<CsvImportJob>;
  csvImportJobOne?: Maybe<CsvImportJob>;
  csvImportJobPagination?: Maybe<CsvImportJobPagination>;
  /** Get the status of a CSV import job (for polling) */
  csvImportJobStatus?: Maybe<CsvImportJobStatus>;
  /** List CSV import jobs for a tenant/vendor */
  csvImportJobs?: Maybe<CsvImportJobsPayload>;
  customFieldDefinitionById?: Maybe<CustomFieldDefinition>;
  customFieldDefinitionByIds: Array<CustomFieldDefinition>;
  customFieldDefinitionCount?: Maybe<Scalars['Int']['output']>;
  customFieldDefinitionMany: Array<CustomFieldDefinition>;
  customFieldDefinitionOne?: Maybe<CustomFieldDefinition>;
  customFieldDefinitionPagination?: Maybe<CustomFieldDefinitionPagination>;
  customFieldValueById?: Maybe<CustomFieldValue>;
  customFieldValueByIds: Array<CustomFieldValue>;
  customFieldValueCount?: Maybe<Scalars['Int']['output']>;
  customFieldValueMany: Array<CustomFieldValue>;
  customFieldValueOne?: Maybe<CustomFieldValue>;
  customFieldValuePagination?: Maybe<CustomFieldValuePagination>;
  /** Read-only pre-flight for a customer delete: counts tenant-scoped associated records (excluding AuditLog) and whether a direct delete is allowed. Non-zero means the UI should route to the merge flow. */
  customerDeletePreview?: Maybe<CustomerDeletePreview>;
  /** Identity fields (incl. formatted address) for the selected merge candidates — drives the compare/pick step of the merge wizard. */
  customerMergeCandidates?: Maybe<Array<Maybe<CustomerMergeCandidate>>>;
  /** Read-only pre-flight for a customer merge: the total records that would be repointed across all losers, whether the merge exceeds the cap, and whether any pair is cross-type or touches a local QuickBooks link. */
  customerMergePreview?: Maybe<CustomerMergePreview>;
  customerNotificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  /** List a customer's saved cards on a vendor's Stripe account. */
  customerSavedCards?: Maybe<Array<Maybe<SavedCard>>>;
  /** Retrieve the ordered assignment rule set for a cutsheet capability */
  cutsheetAssignmentRuleSetByCapabilityId?: Maybe<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetById?: Maybe<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetByIds: Array<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetCount?: Maybe<Scalars['Int']['output']>;
  cutsheetAssignmentRuleSetMany: Array<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetOne?: Maybe<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetPagination?: Maybe<CutsheetAssignmentRuleSetPagination>;
  cutsheetById?: Maybe<Cutsheet>;
  cutsheetByIds: Array<Cutsheet>;
  cutsheetCapabilityOptionById?: Maybe<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionByIds: Array<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionCount?: Maybe<Scalars['Int']['output']>;
  cutsheetCapabilityOptionMany: Array<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Retrieve capability options (cuts) for a specific group */
  cutsheetCapabilityOptionsByGroupId?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  /** Retrieve capability options for a capability */
  cutsheetCapabilityOptionsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetCount?: Maybe<Scalars['Int']['output']>;
  cutsheetCutById?: Maybe<CutsheetCapabilityOption>;
  cutsheetCutByIds: Array<CutsheetCapabilityOption>;
  cutsheetCutCount?: Maybe<Scalars['Int']['output']>;
  cutsheetCutMany: Array<CutsheetCapabilityOption>;
  cutsheetCutOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetCutPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Retrieve cuts for a specific primal */
  cutsheetCutsByGroupId?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  /** Retrieve cuts for a capability */
  cutsheetCutsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetDescriptionLibraryById?: Maybe<CutsheetDescriptionLibrary>;
  cutsheetDescriptionLibraryByIds: Array<CutsheetDescriptionLibrary>;
  cutsheetDescriptionLibraryCount?: Maybe<Scalars['Int']['output']>;
  cutsheetDescriptionLibraryMany: Array<CutsheetDescriptionLibrary>;
  cutsheetDescriptionLibraryOne?: Maybe<CutsheetDescriptionLibrary>;
  cutsheetDescriptionLibraryPagination?: Maybe<CutsheetDescriptionLibraryPagination>;
  /** Search the global cutsheet description library by free-text query and/or tags. */
  cutsheetDescriptionLibrarySearch: Array<CutsheetDescriptionLibrary>;
  /** Return all distinct tags currently in use across the global cutsheet description library. */
  cutsheetDescriptionLibraryTags: Array<Scalars['String']['output']>;
  cutsheetExtraById?: Maybe<CutsheetCapabilityOption>;
  cutsheetExtraByIds: Array<CutsheetCapabilityOption>;
  cutsheetExtraCount?: Maybe<Scalars['Int']['output']>;
  cutsheetExtraMany: Array<CutsheetCapabilityOption>;
  cutsheetExtraOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetExtraPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Retrieve extras for a capability */
  cutsheetExtrasByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetGroupById?: Maybe<CutsheetCapabilityGroup>;
  cutsheetGroupByIds: Array<CutsheetCapabilityGroup>;
  cutsheetGroupCount?: Maybe<Scalars['Int']['output']>;
  cutsheetGroupMany: Array<CutsheetCapabilityGroup>;
  cutsheetGroupOne?: Maybe<CutsheetCapabilityGroup>;
  cutsheetGroupPagination?: Maybe<CutsheetCapabilityGroupPagination>;
  /** Retrieve cutsheetGroupsByVendorAndAnimal for a capability */
  cutsheetGroupsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityGroup>>>;
  cutsheetImageLibraryById?: Maybe<CutsheetImageLibrary>;
  cutsheetImageLibraryByIds: Array<CutsheetImageLibrary>;
  cutsheetImageLibraryCount?: Maybe<Scalars['Int']['output']>;
  cutsheetImageLibraryMany: Array<CutsheetImageLibrary>;
  cutsheetImageLibraryOne?: Maybe<CutsheetImageLibrary>;
  cutsheetImageLibraryPagination?: Maybe<CutsheetImageLibraryPagination>;
  /** Search the global cutsheet image library by free-text query and/or tags. */
  cutsheetImageLibrarySearch: Array<CutsheetImageLibrary>;
  /** Return all distinct tags currently in use across the global cutsheet image library. */
  cutsheetImageLibraryTags: Array<Scalars['String']['output']>;
  cutsheetMany: Array<Cutsheet>;
  cutsheetOne?: Maybe<Cutsheet>;
  cutsheetPagination?: Maybe<CutsheetPagination>;
  cutsheetQuestionnaireById?: Maybe<CutsheetQuestionnaire>;
  cutsheetQuestionnaireByIds: Array<CutsheetQuestionnaire>;
  cutsheetQuestionnaireCount?: Maybe<Scalars['Int']['output']>;
  cutsheetQuestionnaireMany: Array<CutsheetQuestionnaire>;
  cutsheetQuestionnaireOne?: Maybe<CutsheetQuestionnaire>;
  cutsheetQuestionnairePagination?: Maybe<CutsheetQuestionnairePagination>;
  cutsheetQuestionnaireResponseById?: Maybe<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponseByIds: Array<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponseCount?: Maybe<Scalars['Int']['output']>;
  cutsheetQuestionnaireResponseMany: Array<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponseOne?: Maybe<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponsePagination?: Maybe<CutsheetQuestionnaireResponsePagination>;
  /** Paginated search over questionnaire responses with vendor, user, questionnaire, type, and text filtering */
  cutsheetQuestionnaireResponseSearch?: Maybe<CutsheetQuestionnaireResponsePagination>;
  /** Retrieve all customer responses for a specific questionnaire (vendor view) */
  cutsheetQuestionnaireResponsesByQuestionnaire?: Maybe<Array<Maybe<CutsheetQuestionnaireResponse>>>;
  /** Retrieve all of a customer's questionnaire responses, optionally filtered by questionnaire */
  cutsheetQuestionnaireResponsesByUser?: Maybe<Array<Maybe<CutsheetQuestionnaireResponse>>>;
  /** Retrieve all customer questionnaire responses for a vendor (processor admin view) */
  cutsheetQuestionnaireResponsesByVendor?: Maybe<Array<Maybe<CutsheetQuestionnaireResponse>>>;
  /** Retrieve all questionnaires for a vendor */
  cutsheetQuestionnairesByVendor?: Maybe<Array<Maybe<CutsheetQuestionnaire>>>;
  /** Retrieve questionnaires for a capability */
  cutsheetQuestionnairesByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetQuestionnaire>>>;
  /** Enhanced cutsheet search with buyer, vendor, and type filtering */
  cutsheetSearch?: Maybe<CutsheetPagination>;
  cutsheetSpecificationById?: Maybe<CutsheetCapabilitySpecification>;
  cutsheetSpecificationByIds: Array<CutsheetCapabilitySpecification>;
  cutsheetSpecificationCount?: Maybe<Scalars['Int']['output']>;
  cutsheetSpecificationMany: Array<CutsheetCapabilitySpecification>;
  cutsheetSpecificationOne?: Maybe<CutsheetCapabilitySpecification>;
  cutsheetSpecificationPagination?: Maybe<CutsheetCapabilitySpecificationPagination>;
  /** Retrieve specifications for a capability */
  cutsheetSpecificationsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilitySpecification>>>;
  cutsheetTrimById?: Maybe<CutsheetCapabilityOption>;
  cutsheetTrimByIds: Array<CutsheetCapabilityOption>;
  /** Retrieve trims for a capability */
  cutsheetTrimByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetTrimCount?: Maybe<Scalars['Int']['output']>;
  cutsheetTrimMany: Array<CutsheetCapabilityOption>;
  cutsheetTrimOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetTrimPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Minimal animalSettings payload (species / isEnabled / splitTypes / inspectionLevels) for the data-import wizard's Edit-Job dialog, scoped by jobId. */
  dataImportAnimalSettings?: Maybe<DataImportAnimalSettingsPayload>;
  dataImportJobById?: Maybe<DataImportJob>;
  dataImportJobByIds: Array<DataImportJob>;
  dataImportJobCount?: Maybe<Scalars['Int']['output']>;
  dataImportJobMany: Array<DataImportJob>;
  dataImportJobOne?: Maybe<DataImportJob>;
  dataImportJobPagination?: Maybe<DataImportJobPagination>;
  /** Get the status of a CSV import job (for polling) */
  dataImportJobStatus?: Maybe<DataImportJobStatus>;
  /** List CSV import jobs for a tenant/vendor */
  dataImportJobs?: Maybe<DataImportJobsPayload>;
  /** Load enough session state to resume an in-progress CSV import */
  dataImportSession?: Maybe<DataImportSessionPayload>;
  /** Search the current vendor’s customers and jobs to assign a document to. Returns a merged, capped list. */
  documentAssignableEntities?: Maybe<Array<Maybe<DocumentAssignableEntity>>>;
  /** List document categories available to the current vendor: global defaults plus the vendor’s own custom types. */
  documentCategoriesForVendor?: Maybe<Array<Maybe<DocumentCategory>>>;
  documentCategoryCount?: Maybe<Scalars['Int']['output']>;
  documentCategoryMany: Array<DocumentCategory>;
  documentCategoryOne?: Maybe<DocumentCategory>;
  documentCategoryPagination?: Maybe<DocumentCategoryPagination>;
  documentCount?: Maybe<Scalars['Int']['output']>;
  /** Faceted folder browser: given an ordered set of grouping dimensions (category/customer/job) and the current path, returns the sub-folders (distinct values of the next facet) and the documents at this level. */
  documentFolder?: Maybe<DocumentFolderResult>;
  documentMany: Array<Document>;
  documentOne?: Maybe<Document>;
  documentPagination?: Maybe<DocumentPagination>;
  /** Vendor-wide document search for the management page: matches file name or a linked entity (customer name/email/phone/company, or job id), filters by category and assignment. */
  documentSearch?: Maybe<DocumentPagination>;
  /** Presigned GET URL for a specific version of a document. Vendor-scoped. */
  documentVersionUrl?: Maybe<Scalars['String']['output']>;
  /** List the current vendor’s documents linked to a specific customer or job, newest first. */
  documentsForEntity?: Maybe<DocumentPagination>;
  /** A short-lived download URL for a delivered scheduled export, for a signed-in member of the vendor it belongs to. */
  exportDeliveryDownloadUrl: Scalars['String']['output'];
  exportPresetById?: Maybe<ExportPreset>;
  exportPresetByIds: Array<ExportPreset>;
  exportPresetCount?: Maybe<Scalars['Int']['output']>;
  exportPresetMany: Array<ExportPreset>;
  exportPresetOne?: Maybe<ExportPreset>;
  exportPresetPagination?: Maybe<ExportPresetPagination>;
  exportSettingById?: Maybe<ExportSetting>;
  exportSettingByIds: Array<ExportSetting>;
  exportSettingCount?: Maybe<Scalars['Int']['output']>;
  exportSettingMany: Array<ExportSetting>;
  exportSettingOne?: Maybe<ExportSetting>;
  exportSettingPagination?: Maybe<ExportSettingPagination>;
  financialMetricsActualsCount?: Maybe<Scalars['Int']['output']>;
  financialMetricsActualsMany: Array<FinancialMetricsActuals>;
  financialMetricsActualsOne?: Maybe<FinancialMetricsActuals>;
  financialMetricsActualsPagination?: Maybe<FinancialMetricsActualsPagination>;
  financialReportingConfigById?: Maybe<FinancialReportingConfig>;
  financialReportingConfigByIds: Array<FinancialReportingConfig>;
  financialReportingConfigCount?: Maybe<Scalars['Int']['output']>;
  financialReportingConfigMany: Array<FinancialReportingConfig>;
  financialReportingConfigOne?: Maybe<FinancialReportingConfig>;
  financialReportingConfigPagination?: Maybe<FinancialReportingConfigPagination>;
  /** Calculate comprehensive financial reporting metrics for the current vendor with optional comparison type (defaults to previous period). */
  financialReportingMetrics: Scalars['JSON']['output'];
  /** Get all notification settings for a given vendorId */
  findNotificationSettingsByVendorId?: Maybe<NotificationSettingPagination>;
  /** Get notifications for a ProcessorScheduling job by jobId (paginated). */
  findNotificationsByJobId?: Maybe<NotificationPagination>;
  /** Retrieve a single processor scheduling job. */
  findProcessorSchedulingById?: Maybe<ProcessorScheduling>;
  /** Get all records with missing cutsheets in valid statuses for notifications */
  findProcessorSchedulingsWithMissingCutsheets?: Maybe<ProcessorSchedulingPagination>;
  /** Get all records with missing hanging weights that killDate is in past and there is no hanging weights */
  findProcessorSchedulingsWithMissingHangingWeights?: Maybe<ProcessorSchedulingPagination>;
  /** A processor's existing kiosk address, or null if they have never set one up. Reading never mints one. */
  gameKioskAddress?: Maybe<GameKioskAddressCurrent>;
  /** Public: resolve a wild-game kiosk token to the plant it belongs to. */
  gameKioskByToken?: Maybe<GameKioskResponse>;
  /** Public: the questionnaire and catalog a kiosk cut sheet needs, scoped to the token’s plant. */
  gameKioskCutsheet?: Maybe<GameKioskCutsheetResponse>;
  /** Public: whether a kiosk can check in a hunter with these contact details. Errors with a hunter-facing message when not. */
  gameKioskHunterCheck: Scalars['Boolean']['output'];
  /** Geocode a freeform location query (ZIP, city, or address) to coordinates for proximity search. */
  geocodeLocation?: Maybe<GeocodeLocationResult>;
  /** Retrieve the field-level audit history for one document or a set of documents, sorted newest first. */
  getAuditLogs?: Maybe<AuditLogsResponse>;
  /** A customer's rebooking cadence: stored auto/override intervals, the effective interval + window after precedence, and the resulting status and next-booking estimate. */
  getCustomerRebooking?: Maybe<CustomerRebookingCadence>;
  /** Get comprehensive summary details for a customer including job counts and relationship data */
  getCustomerSummaryDetails?: Maybe<CustomerSummaryDetails>;
  /** Get all jobs with custom filters */
  getFilteredProcessorScheduling?: Maybe<ProcessorSchedulingPagination>;
  /** Get filtered tenants with search and pagination */
  getFilteredTenants?: Maybe<TenantPagination>;
  /** Admin-only filtered, paginated search across all users. */
  getFilteredUsers?: Maybe<UserPagination>;
  /** Get all customers with custom filters */
  getProcessorCustomers?: Maybe<UserPagination>;
  /** Get processor scheduled jobs between the two dates. */
  getProcessorSchedulingCalendar?: Maybe<Array<Maybe<ProcessorScheduling>>>;
  /** Get public holidays for a specific country and date range. */
  getPublicHolidays?: Maybe<HolidaysResponse>;
  /** List a vendor's recurring series for management. */
  getRecurringSeriesList?: Maybe<Array<RecurringSeries>>;
  /** Every partner integration this deployment can talk to, with the events each supports and the settings each needs. */
  integrationAdapters: Array<IntegrationAdapterInfo>;
  integrationById?: Maybe<Integration>;
  integrationByIds: Array<Integration>;
  integrationCount?: Maybe<Scalars['Int']['output']>;
  integrationDeliveryAttemptCount?: Maybe<Scalars['Int']['output']>;
  integrationDeliveryAttemptMany: Array<IntegrationDeliveryAttempt>;
  integrationDeliveryAttemptOne?: Maybe<IntegrationDeliveryAttempt>;
  integrationDeliveryAttemptPagination?: Maybe<IntegrationDeliveryAttemptPagination>;
  integrationDeliveryCount?: Maybe<Scalars['Int']['output']>;
  integrationDeliveryMany: Array<IntegrationDelivery>;
  integrationDeliveryOne?: Maybe<IntegrationDelivery>;
  integrationDeliveryPagination?: Maybe<IntegrationDeliveryPagination>;
  integrationInboundRecordCount?: Maybe<Scalars['Int']['output']>;
  integrationInboundRecordMany: Array<IntegrationInboundRecord>;
  integrationInboundRecordOne?: Maybe<IntegrationInboundRecord>;
  integrationInboundRecordPagination?: Maybe<IntegrationInboundRecordPagination>;
  integrationMany: Array<Integration>;
  integrationOne?: Maybe<Integration>;
  integrationPagination?: Maybe<IntegrationPagination>;
  /** A connected partner's current list of products a cut can be mapped to. */
  integrationPartnerProducts: IntegrationPartnerProducts;
  invoiceById?: Maybe<Invoice>;
  invoiceByIds: Array<Invoice>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  invoiceLineItemById?: Maybe<InvoiceLineItem>;
  invoiceLineItemByIds: Array<InvoiceLineItem>;
  invoiceLineItemCount?: Maybe<Scalars['Int']['output']>;
  invoiceLineItemMany: Array<InvoiceLineItem>;
  invoiceLineItemOne?: Maybe<InvoiceLineItem>;
  invoiceLineItemPagination?: Maybe<InvoiceLineItemPagination>;
  invoiceMany: Array<Invoice>;
  invoiceOne?: Maybe<Invoice>;
  invoicePagination?: Maybe<InvoicePagination>;
  jobManualNotificationOptions: Array<ManualNotificationOption>;
  jobTagCount?: Maybe<Scalars['Int']['output']>;
  jobTagMany: Array<JobTag>;
  jobTagOne?: Maybe<JobTag>;
  jobTagPagination?: Maybe<JobTagPagination>;
  landingPageById?: Maybe<LandingPageSettings>;
  landingPageByIds: Array<LandingPageSettings>;
  landingPageCount?: Maybe<Scalars['Int']['output']>;
  /** Paginated admin listing of landing pages with search and link-status filter. */
  landingPageList?: Maybe<LandingPageSettingsPagination>;
  landingPageMany: Array<LandingPageSettings>;
  /** Retrieve a single landing page by vendor id */
  landingPageOne?: Maybe<LandingPageSettings>;
  landingPageOneById?: Maybe<LandingPageSettings>;
  landingPageOneByIds: Array<LandingPageSettings>;
  landingPageOneCount?: Maybe<Scalars['Int']['output']>;
  landingPageOneMany: Array<LandingPageSettings>;
  landingPageOneOne?: Maybe<LandingPageSettings>;
  landingPageOnePagination?: Maybe<LandingPageSettingsPagination>;
  landingPagePagination?: Maybe<LandingPageSettingsPagination>;
  /** Retrieve a single landing page by id for public display. Hidden when `showInDirectory` is false. */
  landingPagePublicById?: Maybe<LandingPageSettings>;
  /** Retrieve a single landing page by slug for public display. Hidden when `showInDirectory` is false. */
  landingPagePublicBySlug?: Maybe<LandingPageSettings>;
  /** Admin-only: paginated marketplace lead search with free-text, species, quantity, timeline and date-range filters. */
  marketplaceLeadSearch?: Maybe<MarketplaceLeadSearchResult>;
  /** Get all chat rooms for the logged in user */
  messagesByChatRoom?: Maybe<ChatMessagePagination>;
  moduleById?: Maybe<VendorModule>;
  moduleByIds: Array<VendorModule>;
  moduleCount?: Maybe<Scalars['Int']['output']>;
  moduleMany: Array<VendorModule>;
  moduleOne?: Maybe<VendorModule>;
  modulePagination?: Maybe<VendorModulePagination>;
  /** Retrieve the signed-in producer's animals, paginated (scope: unassigned | assigned | all; defaults to unassigned). */
  myAnimals?: Maybe<AnimalPagination>;
  /** Whole-herd counts (total/listed/reserved) for the signed-in producer's Animals stat strip — unaffected by the current page or active browse filters. */
  myAnimalsStats?: Maybe<MyAnimalsStats>;
  /** A single chat room visible to the current user, or null. */
  myChatRoom?: Maybe<ChatRoom>;
  /** Chat rooms visible to the current user that changed after `since`, for delta polling. */
  myChatRoomUpdates: Array<ChatRoom>;
  /** Get all chat-rooms for given processor for logged in user and Basic user */
  myChatRooms?: Maybe<ChatRoomPagination>;
  myInAppNotifications?: Maybe<InAppNotificationFeed>;
  /** Retrieve one of the session user's own invoices by id, or null if it is not theirs to see. */
  myInvoice?: Maybe<Invoice>;
  /** Retrieve the session user's own invoices: open ones first (soonest due first), then settled ones, newest first. */
  myInvoices: Array<Invoice>;
  myNotificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  /** Retrieve the signed-in producer’s waitlist entries. */
  myWaitlist?: Maybe<Array<Maybe<Waitlist>>>;
  navBadgeCounts?: Maybe<NavBadgeCounts>;
  noteById?: Maybe<Note>;
  noteByIds: Array<Note>;
  noteCount?: Maybe<Scalars['Int']['output']>;
  noteMany: Array<Note>;
  noteOne?: Maybe<Note>;
  notePagination?: Maybe<NotePagination>;
  /** Search the notification audit log (admins, plus processors scoped to their own vendor). Returns delivery decisions incl. suppressions/non-sends, plus an outcome rollup over the filtered set. */
  notificationAuditSearch?: Maybe<NotificationAuditSearchResponse>;
  notificationById?: Maybe<Notification>;
  notificationByIds: Array<Notification>;
  notificationCount?: Maybe<Scalars['Int']['output']>;
  notificationMany: Array<Notification>;
  notificationOne?: Maybe<Notification>;
  notificationPagination?: Maybe<NotificationPagination>;
  notificationPromptByToken?: Maybe<NotificationPromptPublic>;
  notificationSettingsById?: Maybe<NotificationSetting>;
  notificationSettingsByIds: Array<NotificationSetting>;
  notificationSettingsCount?: Maybe<Scalars['Int']['output']>;
  notificationSettingsMany: Array<NotificationSetting>;
  notificationSettingsOne?: Maybe<NotificationSetting>;
  notificationSettingsPagination?: Maybe<NotificationSettingPagination>;
  /** Get all notifications for a given chat room with pagination. */
  notificationsByChatRoom?: Maybe<NotificationPagination>;
  pickupLocationCount?: Maybe<Scalars['Int']['output']>;
  /** A vendor's pickup locations, ordered for display. Defaults to the caller's active vendor and to active locations only; the settings editor passes includeInactive to manage archived rows. */
  pickupLocationList?: Maybe<Array<Maybe<PickupLocation>>>;
  pickupLocationMany: Array<PickupLocation>;
  pickupLocationOne?: Maybe<PickupLocation>;
  pickupLocationPagination?: Maybe<PickupLocationPagination>;
  primalById?: Maybe<Primal>;
  primalByIds: Array<Primal>;
  primalCount?: Maybe<Scalars['Int']['output']>;
  primalCutBlockerById?: Maybe<PrimalCutBlocker>;
  primalCutBlockerByIds: Array<PrimalCutBlocker>;
  primalCutBlockerCount?: Maybe<Scalars['Int']['output']>;
  primalCutBlockerMany: Array<PrimalCutBlocker>;
  primalCutBlockerOne?: Maybe<PrimalCutBlocker>;
  primalCutBlockerPagination?: Maybe<PrimalCutBlockerPagination>;
  primalCutById?: Maybe<PrimalCut>;
  primalCutByIds: Array<PrimalCut>;
  primalCutCount?: Maybe<Scalars['Int']['output']>;
  primalCutMany: Array<PrimalCut>;
  primalCutOne?: Maybe<PrimalCut>;
  primalCutPagination?: Maybe<PrimalCutPagination>;
  primalCutTypeById?: Maybe<PrimalCutType>;
  primalCutTypeByIds: Array<PrimalCutType>;
  primalCutTypeCount?: Maybe<Scalars['Int']['output']>;
  primalCutTypeMany: Array<PrimalCutType>;
  primalCutTypeOne?: Maybe<PrimalCutType>;
  primalCutTypePagination?: Maybe<PrimalCutTypePagination>;
  primalGroupById?: Maybe<PrimalGroup>;
  primalGroupByIds: Array<PrimalGroup>;
  primalGroupCount?: Maybe<Scalars['Int']['output']>;
  primalGroupMany: Array<PrimalGroup>;
  primalGroupOne?: Maybe<PrimalGroup>;
  primalGroupPagination?: Maybe<PrimalGroupPagination>;
  primalMany: Array<Primal>;
  primalOne?: Maybe<Primal>;
  primalPagination?: Maybe<PrimalPagination>;
  /** Retrieve the public directory of processing partners. Includes both signed-up processors (with vendor) and admin-managed placeholders (vendorless landing pages flagged showInDirectory). */
  processingPartners?: Maybe<Array<Maybe<ProcessingPartners>>>;
  processingPartnersById?: Maybe<ProcessorSettings>;
  processingPartnersByIds: Array<ProcessorSettings>;
  processingPartnersCount?: Maybe<Scalars['Int']['output']>;
  processingPartnersMany: Array<ProcessorSettings>;
  /** Retrieve a single processing partner */
  processingPartnersOne?: Maybe<ProcessingPartnersOne>;
  processingPartnersOneById?: Maybe<ProcessorSettings>;
  processingPartnersOneByIds: Array<ProcessorSettings>;
  processingPartnersOneCount?: Maybe<Scalars['Int']['output']>;
  processingPartnersOneMany: Array<ProcessorSettings>;
  processingPartnersOneOne?: Maybe<ProcessorSettings>;
  processingPartnersOnePagination?: Maybe<ProcessorSettingsPagination>;
  processingPartnersPagination?: Maybe<ProcessorSettingsPagination>;
  /** Benchmark the current processor against same-region (US Census region) and national peers (anonymized percentages only). Restricted to vendor owners and admins. */
  processorBenchmarks: Scalars['JSON']['output'];
  processorCapabilityById?: Maybe<ProcessorCapability>;
  processorCapabilityByIds: Array<ProcessorCapability>;
  processorCapabilityCount?: Maybe<Scalars['Int']['output']>;
  processorCapabilityMany: Array<ProcessorCapability>;
  processorCapabilityOne?: Maybe<ProcessorCapability>;
  processorCapabilityPagination?: Maybe<ProcessorCapabilityPagination>;
  processorCapabilitySpecificationById?: Maybe<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationByIds: Array<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationCount?: Maybe<Scalars['Int']['output']>;
  processorCapabilitySpecificationMany: Array<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationOne?: Maybe<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationPagination?: Maybe<ProcessorCapabilitySpecificationPagination>;
  /** First rows of an export as they would be written, plus the columns available to select. */
  processorExportPreview: Scalars['JSON']['output'];
  processorNotificationById?: Maybe<ProcessorNotification>;
  processorNotificationByIds: Array<ProcessorNotification>;
  processorNotificationCount?: Maybe<Scalars['Int']['output']>;
  processorNotificationMany: Array<ProcessorNotification>;
  processorNotificationOne?: Maybe<ProcessorNotification>;
  processorNotificationPagination?: Maybe<ProcessorNotificationPagination>;
  /** The buyer-requestable splits (species + part sizes) a processor offers, for a storefront slug. Derived from enabled ProcessorSettings.animalSettings; species with no offered sizes are excluded. */
  processorOfferedSplits?: Maybe<Array<Maybe<ProcessorOfferedSplit>>>;
  processorSchedulingById?: Maybe<ProcessorScheduling>;
  processorSchedulingByIds: Array<ProcessorScheduling>;
  processorSchedulingCount?: Maybe<Scalars['Int']['output']>;
  processorSchedulingIdsForContact: Array<Scalars['MongoID']['output']>;
  processorSchedulingIdsReadyToInvoice: Array<Scalars['MongoID']['output']>;
  processorSchedulingMany: Array<ProcessorScheduling>;
  processorSchedulingOne?: Maybe<ProcessorScheduling>;
  processorSchedulingPagination?: Maybe<ProcessorSchedulingPagination>;
  processorSettingsById?: Maybe<ProcessorSettings>;
  processorSettingsByIds: Array<ProcessorSettings>;
  processorSettingsCount?: Maybe<Scalars['Int']['output']>;
  processorSettingsCustomCapacityById?: Maybe<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityByIds: Array<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityCount?: Maybe<Scalars['Int']['output']>;
  processorSettingsCustomCapacityMany: Array<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityOne?: Maybe<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityPagination?: Maybe<ProcessorSettingsCustomCapacityPagination>;
  processorSettingsMany: Array<ProcessorSettings>;
  processorSettingsOne?: Maybe<ProcessorSettings>;
  processorSettingsPagination?: Maybe<ProcessorSettingsPagination>;
  /** Return every active split request for the signed-in processor's vendor, newest-first, with a minimal buyer contact (name/email/phone) and the server-computed deposit per {species, splitType}. Vendor is session-derived (never a client arg); requests past their desiredPickupDate are excluded (dateless ones appear). */
  processorSplitRequests?: Maybe<Array<Maybe<MarketplaceRequest>>>;
  /** Workflow-funnel analysis (on-hand head, dwell time, and capacity utilization per stage) for the current vendor's processing pipeline. The report covers head whose anchor date (created, dropoff, kill or cut; default kill) falls in startDate→endDate, with on-hand counts as of endDate; capacity figures span the same window facility-wide. */
  processorWorkflowFunnel: Scalars['JSON']['output'];
  producerActionCounts: ProducerActionCounts;
  /** Public: all currently-available splits for a producer across all their partner processors, shaped as BuyerAvailableAnimal so AvailableSplitCard renders them directly. Anonymous-safe. Returns [] for unknown slugs and in-house producers. */
  producerAvailableSplits?: Maybe<Array<Maybe<BuyerAvailableAnimal>>>;
  /** Session-scoped: the signed-in producer's buyer roster — every owned animal with buyer-bearing splits (whether producer-listed, processor-listed, or never listed), plus every producer-listed animal even when buyer-less (including delisted/vetoed ones awaiting resolution) — with its splits' claim state, buyer contact, and Order-derived paid/refund state. Admin may pass `producerId` to view another producer's roster. */
  producerBuyerRoster?: Maybe<Array<Maybe<ProducerRosterAnimal>>>;
  /** Retrieve a public producer header by slug (anonymous-safe). Returns null for unknown slugs and for in-house producers. */
  producerBySlug?: Maybe<PublicProducer>;
  /** Session-scoped, paginated: the signed-in producer's customer roster — one row per buyer with EITHER a live claim (requested/claimed/confirmed) on this producer's listed animals, OR a producer-stamped Order with no live claim left (settled/refunded/removed/deleted-animal - see the file-header docstring). Rolled up into a relationship summary, last-activity timestamp, balance chip state, and a `lastOrder` line. Default sort: last activity, descending; also supports name and balance (money-attention first) sorts, and a `balanceDueOnly` filter. Admin may pass `producerId` to view another producer's roster. */
  producerCustomers?: Maybe<ProducerCustomersPage>;
  /** The signed-in producer's booked drop-offs still awaiting a confirmation. */
  producerDropoffsToConfirm: Array<ProcessorScheduling>;
  producerJobIdsNeedingAttention: Array<Scalars['MongoID']['output']>;
  /** The signed-in producer's jobs, searchable and paginated. */
  producerJobs?: Maybe<ProcessorSchedulingPagination>;
  /** Compute the signed-in user's eligibility to list on the marketplace as a producer. */
  producerListingEligibility?: Maybe<ProducerListingEligibility>;
  /** Estimated buyer cost ranges (whole/half/quarter) for one of the signed-in producer's animals, using draft listing inputs. */
  producerListingEstimate?: Maybe<ProducerListingEstimate>;
  /** Distinct set of species a producer raises, sourced from the producer's own animals. Public, read-only. */
  producerOfferedSpecies: Array<Scalars['String']['output']>;
  /** The signed-in producer's own selling settings. */
  producerSettings?: Maybe<ProducerSettings>;
  recurringSeriesCount?: Maybe<Scalars['Int']['output']>;
  recurringSeriesMany: Array<RecurringSeries>;
  recurringSeriesOne?: Maybe<RecurringSeries>;
  recurringSeriesPagination?: Maybe<RecurringSeriesPagination>;
  /** Count upcoming cancellable jobs for a recurring series. */
  recurringSeriesUpcomingJobCount: Scalars['Int']['output'];
  /** Render a notification email template with sample data and return the HTML */
  renderNotificationEmailPreview?: Maybe<EmailPreviewResult>;
  /** Search for available Twilio phone numbers to provision */
  searchAvailablePhoneNumbers?: Maybe<Array<Maybe<AvailablePhoneNumber>>>;
  /** Search customer users with optional filters */
  searchCustomers: Array<User>;
  /** Get all invoices with custom filters */
  searchInvoices?: Maybe<InvoicePagination>;
  /** Paginated, searchable list of a vendor's recurring series. */
  searchRecurringSeries?: Maybe<RecurringSeriesPagination>;
  serverTime: Scalars['Date']['output'];
  /** Resolve a Farmshare short-link code into link-preview metadata */
  shortUrlPreview?: Maybe<ShortUrlPreview>;
  splitCount?: Maybe<Scalars['Int']['output']>;
  splitCutsheetQuestionnaire?: Maybe<SplitCutsheetQuestionnaire>;
  splitMany: Array<Split>;
  splitOne?: Maybe<Split>;
  splitPagination?: Maybe<SplitPagination>;
  stateById?: Maybe<State>;
  stateByIds: Array<State>;
  stateCount?: Maybe<Scalars['Int']['output']>;
  stateMany: Array<State>;
  stateOne?: Maybe<State>;
  statePagination?: Maybe<StatePagination>;
  tenantById?: Maybe<Tenant>;
  tenantByIds: Array<Tenant>;
  tenantCount?: Maybe<Scalars['Int']['output']>;
  tenantMany: Array<Tenant>;
  tenantOne?: Maybe<Tenant>;
  tenantPagination?: Maybe<TenantPagination>;
  userById?: Maybe<User>;
  userByIds: Array<User>;
  userCount?: Maybe<Scalars['Int']['output']>;
  userMany: Array<User>;
  userOne?: Maybe<User>;
  userPagination?: Maybe<UserPagination>;
  /** Get a user's settings by their user ID. */
  userSettingsByUserId?: Maybe<UserSettingsByUserId>;
  /** Get the user/tenant/vendor associated with a user. */
  userTenantVendor?: Maybe<User>;
  vendorById?: Maybe<Vendor>;
  vendorByIds: Array<Vendor>;
  vendorCount?: Maybe<Scalars['Int']['output']>;
  /** One customer's jobs at the session vendor. */
  vendorCustomerJobs?: Maybe<ProcessorSchedulingPagination>;
  vendorCustomerNotificationDefaults?: Maybe<CustomerNotificationDefaults>;
  /** Retrieve the signed-in processor's intook animals, paginated (scope: unassigned | assigned | all; defaults to unassigned). */
  vendorHerdAnimals?: Maybe<AnimalPagination>;
  /** Upcoming, assignable jobs for the signed-in processor's vendor (herd assign picker). */
  vendorHerdAssignableJobs?: Maybe<Array<Maybe<ProcessorScheduling>>>;
  /** Read the signed-in processor's single in-house producer identity, or null if none exists. Vendor is session-derived. */
  vendorInHouseProducerOne?: Maybe<InHouseProducer>;
  /** Read the marketplace defaults of the signed-in processor's in-house producer, or null if the vendor has none. Vendor and producer are both session-derived; the client supplies no identifier. */
  vendorInHouseProducerSettingsOne?: Maybe<ProducerSettings>;
  /** List the signed-in processor's own producers eligible to be linked as its in-house producer identity. Vendor is session-derived. */
  vendorLinkableProducers?: Maybe<Array<Maybe<LinkableProducer>>>;
  /** Retrieve a list of all vendors. */
  vendorList?: Maybe<Array<Maybe<Vendor>>>;
  vendorMany: Array<Vendor>;
  vendorOne?: Maybe<Vendor>;
  vendorPagination?: Maybe<VendorPagination>;
  /** List the staff on the caller's vendor team. */
  vendorTeamMembers: Array<User>;
  waitlistById?: Maybe<Waitlist>;
  waitlistByIds: Array<Waitlist>;
  /** Retrieve the waitlist for a vendor. */
  waitlistByVendorId?: Maybe<Array<Maybe<Waitlist>>>;
  /** Paginated, searchable waitlist for a vendor. */
  waitlistByVendorPagination?: Maybe<WaitlistPagination>;
  waitlistCount?: Maybe<Scalars['Int']['output']>;
  waitlistMany: Array<Waitlist>;
  waitlistOne?: Maybe<Waitlist>;
  waitlistPagination?: Maybe<WaitlistPagination>;
  webhookById?: Maybe<Vendor>;
  webhookByIds: Array<Vendor>;
  webhookCount?: Maybe<Scalars['Int']['output']>;
  webhookMany: Array<Vendor>;
  webhookOne?: Maybe<Vendor>;
  webhookPagination?: Maybe<VendorPagination>;
};


export type QueryCutsheetCapabilityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetCapabilityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityByVendorAndAnimalArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetCapabilityCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityInput>;
};


export type QueryCutsheetLegacyCapabilityDataArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type QueryAddressByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAddressByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAddressInput>;
};


export type QueryAddressCountArgs = {
  filter?: InputMaybe<FilterCountAddressInput>;
};


export type QueryAddressManyArgs = {
  filter?: InputMaybe<FilterFindManyAddressInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAddressInput>;
};


export type QueryAddressOneArgs = {
  filter?: InputMaybe<FilterFindOneAddressInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneAddressInput>;
};


export type QueryAddressPaginationArgs = {
  filter?: InputMaybe<FilterFindManyAddressInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAddressInput>;
};


export type QueryAdminAccountActivityArgs = {
  comparisonType?: InputMaybe<ComparisonType>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAdminBusinessStatsArgs = {
  comparisonType?: InputMaybe<ComparisonType>;
  consistentCohort?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAdminProducerSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryAdminUserSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<EnumUserRole>;
  search: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminVendorSpeciesArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryAnalyzeAnimalConfigurationsArgs = {
  backwardMonths?: InputMaybe<Scalars['Int']['input']>;
  forwardMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAnalyzeSeasonalityArgs = {
  backwardMonths?: InputMaybe<Scalars['Int']['input']>;
  forwardMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBuyerAnimalDetailArgs = {
  animalId: Scalars['MongoID']['input'];
};


export type QueryBuyerAvailableAnimalsArgs = {
  anyDistance?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  lng: Scalars['Float']['input'];
  pickupMonth?: InputMaybe<Scalars['String']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  sectionSize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryBuyerInvoiceForJobArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type QueryBuyerOrdersPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryBuyerSavedPaymentMethodsArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type QueryBuyerSplitForCutsheetArgs = {
  splitId: Scalars['MongoID']['input'];
};


export type QueryCalculateProcessorCapacityArgs = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  groupFormat?: InputMaybe<Scalars['String']['input']>;
  selectedAnimalSpecies: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};


export type QueryCalculateProcessorCapacityAllSpeciesArgs = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  groupFormat?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};


export type QueryCalendarEventCountArgs = {
  filter?: InputMaybe<FilterCountCalendarEventInput>;
};


export type QueryCalendarEventManyArgs = {
  filter?: InputMaybe<FilterFindManyCalendarEventInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalendarEventInput>;
};


export type QueryCalendarEventOneArgs = {
  filter?: InputMaybe<FilterFindOneCalendarEventInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCalendarEventInput>;
};


export type QueryCalendarEventPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCalendarEventInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalendarEventInput>;
};


export type QueryCalendarEventTypeCountArgs = {
  filter?: InputMaybe<FilterCountCalendarEventTypeInput>;
};


export type QueryCalendarEventTypeManyArgs = {
  filter?: InputMaybe<FilterFindManyCalendarEventTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalendarEventTypeInput>;
};


export type QueryCalendarEventTypeOneArgs = {
  filter?: InputMaybe<FilterFindOneCalendarEventTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCalendarEventTypeInput>;
};


export type QueryCalendarEventTypePaginationArgs = {
  filter?: InputMaybe<FilterFindManyCalendarEventTypeInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalendarEventTypeInput>;
};


export type QueryCancellationReasonByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCancellationReasonByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCancellationReasonInput>;
};


export type QueryCancellationReasonCountArgs = {
  filter?: InputMaybe<FilterCountCancellationReasonInput>;
};


export type QueryCancellationReasonManyArgs = {
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
};


export type QueryCancellationReasonOneArgs = {
  filter?: InputMaybe<FilterFindOneCancellationReasonInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCancellationReasonInput>;
};


export type QueryCancellationReasonPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
};


export type QueryCsvImportJobByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCsvImportJobByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCsvImportJobInput>;
};


export type QueryCsvImportJobCountArgs = {
  filter?: InputMaybe<FilterCountCsvImportJobInput>;
};


export type QueryCsvImportJobManyArgs = {
  filter?: InputMaybe<FilterFindManyCsvImportJobInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCsvImportJobInput>;
};


export type QueryCsvImportJobOneArgs = {
  filter?: InputMaybe<FilterFindOneCsvImportJobInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCsvImportJobInput>;
};


export type QueryCsvImportJobPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCsvImportJobInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCsvImportJobInput>;
};


export type QueryCsvImportJobStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryCsvImportJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomFieldDefinitionByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCustomFieldDefinitionByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCustomFieldDefinitionInput>;
};


export type QueryCustomFieldDefinitionCountArgs = {
  filter?: InputMaybe<FilterCountCustomFieldDefinitionInput>;
};


export type QueryCustomFieldDefinitionManyArgs = {
  filter?: InputMaybe<FilterFindManyCustomFieldDefinitionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCustomFieldDefinitionInput>;
};


export type QueryCustomFieldDefinitionOneArgs = {
  filter?: InputMaybe<FilterFindOneCustomFieldDefinitionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCustomFieldDefinitionInput>;
};


export type QueryCustomFieldDefinitionPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCustomFieldDefinitionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCustomFieldDefinitionInput>;
};


export type QueryCustomFieldValueByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCustomFieldValueByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCustomFieldValueInput>;
};


export type QueryCustomFieldValueCountArgs = {
  filter?: InputMaybe<FilterCountCustomFieldValueInput>;
};


export type QueryCustomFieldValueManyArgs = {
  filter?: InputMaybe<FilterFindManyCustomFieldValueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCustomFieldValueInput>;
};


export type QueryCustomFieldValueOneArgs = {
  filter?: InputMaybe<FilterFindOneCustomFieldValueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCustomFieldValueInput>;
};


export type QueryCustomFieldValuePaginationArgs = {
  filter?: InputMaybe<FilterFindManyCustomFieldValueInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCustomFieldValueInput>;
};


export type QueryCustomerDeletePreviewArgs = {
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCustomerMergeCandidatesArgs = {
  ids: Array<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryCustomerMergePreviewArgs = {
  loserIds: Array<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  winnerId: Scalars['MongoID']['input'];
};


export type QueryCustomerNotificationPreferencesArgs = {
  userId: Scalars['MongoID']['input'];
};


export type QueryCustomerSavedCardsArgs = {
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetAssignmentRuleSetByCapabilityIdArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type QueryCutsheetAssignmentRuleSetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetAssignmentRuleSetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetInput>;
};


export type QueryCutsheetCapabilityOptionByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetCapabilityOptionByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionsByGroupIdArgs = {
  groupId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetCapabilityOptionsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  optionType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCutsheetCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetInput>;
};


export type QueryCutsheetCutByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetCutByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutsByGroupIdArgs = {
  groupId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetCutsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetDescriptionLibraryByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetDescriptionLibraryByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetDescriptionLibraryInput>;
};


export type QueryCutsheetDescriptionLibraryCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetDescriptionLibraryInput>;
};


export type QueryCutsheetDescriptionLibraryManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetDescriptionLibraryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetDescriptionLibraryInput>;
};


export type QueryCutsheetDescriptionLibraryOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetDescriptionLibraryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetDescriptionLibraryInput>;
};


export type QueryCutsheetDescriptionLibraryPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetDescriptionLibraryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetDescriptionLibraryInput>;
};


export type QueryCutsheetDescriptionLibrarySearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCutsheetExtraByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetExtraByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtrasByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetImageLibraryByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetImageLibraryByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetImageLibraryInput>;
};


export type QueryCutsheetImageLibraryCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetImageLibraryInput>;
};


export type QueryCutsheetImageLibraryManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetImageLibraryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetImageLibraryInput>;
};


export type QueryCutsheetImageLibraryOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetImageLibraryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetImageLibraryInput>;
};


export type QueryCutsheetImageLibraryPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetImageLibraryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetImageLibraryInput>;
};


export type QueryCutsheetImageLibrarySearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCutsheetManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};


export type QueryCutsheetOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetInput>;
};


export type QueryCutsheetPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};


export type QueryCutsheetQuestionnaireByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetQuestionnaireInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnairePaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireResponseByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireResponseByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponsePaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseSearchArgs = {
  capabilitySetId?: InputMaybe<Scalars['MongoID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sort: SortFindManyCutsheetQuestionnaireResponseInput;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireResponseType>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryCutsheetQuestionnaireResponsesByQuestionnaireArgs = {
  questionnaireId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireResponsesByUserArgs = {
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  userId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireResponsesByVendorArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnairesByVendorArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnairesByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCutsheetSearchArgs = {
  buyerId?: InputMaybe<Scalars['MongoID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel?: InputMaybe<EnumCutsheetInspectionLevels>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyCutsheetInput;
  species?: InputMaybe<EnumCutsheetAnimalSpecies>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetType>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryCutsheetSpecificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetSpecificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetTrimByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetTrimByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetTrimCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryDataImportAnimalSettingsArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryDataImportJobByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDataImportJobByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsDataImportJobInput>;
};


export type QueryDataImportJobCountArgs = {
  filter?: InputMaybe<FilterCountDataImportJobInput>;
};


export type QueryDataImportJobManyArgs = {
  filter?: InputMaybe<FilterFindManyDataImportJobInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDataImportJobInput>;
};


export type QueryDataImportJobOneArgs = {
  filter?: InputMaybe<FilterFindOneDataImportJobInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneDataImportJobInput>;
};


export type QueryDataImportJobPaginationArgs = {
  filter?: InputMaybe<FilterFindManyDataImportJobInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDataImportJobInput>;
};


export type QueryDataImportJobStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryDataImportJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataImportSessionArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryDocumentAssignableEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentCategoryCountArgs = {
  filter?: InputMaybe<FilterCountDocumentCategoryInput>;
};


export type QueryDocumentCategoryManyArgs = {
  filter?: InputMaybe<FilterFindManyDocumentCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDocumentCategoryInput>;
};


export type QueryDocumentCategoryOneArgs = {
  filter?: InputMaybe<FilterFindOneDocumentCategoryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneDocumentCategoryInput>;
};


export type QueryDocumentCategoryPaginationArgs = {
  filter?: InputMaybe<FilterFindManyDocumentCategoryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDocumentCategoryInput>;
};


export type QueryDocumentCountArgs = {
  filter?: InputMaybe<FilterCountDocumentInput>;
};


export type QueryDocumentFolderArgs = {
  facetOrder: Array<Scalars['String']['input']>;
  includeGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  perPage: Scalars['Int']['input'];
  scopeEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  scopeEntityType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<EnumDocumentSearchSort>;
};


export type QueryDocumentManyArgs = {
  filter?: InputMaybe<FilterFindManyDocumentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDocumentInput>;
};


export type QueryDocumentOneArgs = {
  filter?: InputMaybe<FilterFindOneDocumentInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneDocumentInput>;
};


export type QueryDocumentPaginationArgs = {
  filter?: InputMaybe<FilterFindManyDocumentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDocumentInput>;
};


export type QueryDocumentSearchArgs = {
  assignment?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<EnumDocumentSearchSort>;
};


export type QueryDocumentVersionUrlArgs = {
  documentId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type QueryDocumentsForEntityArgs = {
  entityId: Scalars['MongoID']['input'];
  entityType: EnumDocumentEntityType;
  includeGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportDeliveryDownloadUrlArgs = {
  presetId: Scalars['MongoID']['input'];
  token: Scalars['String']['input'];
};


export type QueryExportPresetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryExportPresetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsExportPresetInput>;
};


export type QueryExportPresetCountArgs = {
  filter?: InputMaybe<FilterCountExportPresetInput>;
};


export type QueryExportPresetManyArgs = {
  filter?: InputMaybe<FilterFindManyExportPresetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyExportPresetInput>;
};


export type QueryExportPresetOneArgs = {
  filter?: InputMaybe<FilterFindOneExportPresetInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneExportPresetInput>;
};


export type QueryExportPresetPaginationArgs = {
  filter?: InputMaybe<FilterFindManyExportPresetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyExportPresetInput>;
};


export type QueryExportSettingByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryExportSettingByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsExportSettingInput>;
};


export type QueryExportSettingCountArgs = {
  filter?: InputMaybe<FilterCountExportSettingInput>;
};


export type QueryExportSettingManyArgs = {
  filter?: InputMaybe<FilterFindManyExportSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyExportSettingInput>;
};


export type QueryExportSettingOneArgs = {
  filter?: InputMaybe<FilterFindOneExportSettingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneExportSettingInput>;
};


export type QueryExportSettingPaginationArgs = {
  filter?: InputMaybe<FilterFindManyExportSettingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyExportSettingInput>;
};


export type QueryFinancialMetricsActualsCountArgs = {
  filter?: InputMaybe<FilterCountFinancialMetricsActualsInput>;
};


export type QueryFinancialMetricsActualsManyArgs = {
  filter?: InputMaybe<FilterFindManyFinancialMetricsActualsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFinancialMetricsActualsInput>;
};


export type QueryFinancialMetricsActualsOneArgs = {
  filter?: InputMaybe<FilterFindOneFinancialMetricsActualsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneFinancialMetricsActualsInput>;
};


export type QueryFinancialMetricsActualsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyFinancialMetricsActualsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFinancialMetricsActualsInput>;
};


export type QueryFinancialReportingConfigByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryFinancialReportingConfigByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigCountArgs = {
  filter?: InputMaybe<FilterCountFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigManyArgs = {
  filter?: InputMaybe<FilterFindManyFinancialReportingConfigInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigOneArgs = {
  filter?: InputMaybe<FilterFindOneFinancialReportingConfigInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigPaginationArgs = {
  filter?: InputMaybe<FilterFindManyFinancialReportingConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFinancialReportingConfigInput>;
};


export type QueryFinancialReportingMetricsArgs = {
  comparisonType?: InputMaybe<ComparisonType>;
  dateAnchor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindNotificationSettingsByVendorIdArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryFindNotificationsByJobIdArgs = {
  jobId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryFindProcessorSchedulingByIdArgs = {
  _id: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
};


export type QueryFindProcessorSchedulingsWithMissingCutsheetsArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryFindProcessorSchedulingsWithMissingHangingWeightsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGameKioskAddressArgs = {
  vendor: Scalars['MongoID']['input'];
};


export type QueryGameKioskByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGameKioskCutsheetArgs = {
  questionnaireId: Scalars['MongoID']['input'];
  token: Scalars['String']['input'];
};


export type QueryGameKioskHunterCheckArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type QueryGeocodeLocationArgs = {
  query: Scalars['String']['input'];
};


export type QueryGetAuditLogsArgs = {
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<InputMaybe<AuditLogTargetInput>>>;
};


export type QueryGetCustomerRebookingArgs = {
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetCustomerSummaryDetailsArgs = {
  customerId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetFilteredProcessorSchedulingArgs = {
  animalSpecies?: InputMaybe<Array<Scalars['String']['input']>>;
  confirmation?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateFrom?: InputMaybe<Scalars['Date']['input']>;
  cutDateTo?: InputMaybe<Scalars['Date']['input']>;
  dropoffDateFrom?: InputMaybe<Scalars['Date']['input']>;
  dropoffDateTo?: InputMaybe<Scalars['Date']['input']>;
  harvestDateFrom?: InputMaybe<Scalars['Date']['input']>;
  harvestDateTo?: InputMaybe<Scalars['Date']['input']>;
  issues?: InputMaybe<Array<Scalars['String']['input']>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  matchHeadStatus?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyProcessorSchedulingInput;
  statusFilter?: InputMaybe<Array<EnumProcessorSchedulingStatus>>;
  tags?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetFilteredTenantsArgs = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyTenantInput;
};


export type QueryGetFilteredUsersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  relationshipProducerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  relationshipVendorId?: InputMaybe<Scalars['MongoID']['input']>;
  roles?: InputMaybe<Array<EnumUserRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
};


export type QueryGetProcessorCustomersArgs = {
  latestDropoffDateFrom?: InputMaybe<Scalars['Date']['input']>;
  latestDropoffDateTo?: InputMaybe<Scalars['Date']['input']>;
  latestDropoffSort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rebookingStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetProcessorSchedulingCalendarArgs = {
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  startDate: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetPublicHolidaysArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecurringSeriesListArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryIntegrationAdaptersArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIntegrationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryIntegrationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsIntegrationInput>;
};


export type QueryIntegrationCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationInput>;
};


export type QueryIntegrationDeliveryAttemptCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationDeliveryAttemptInput>;
};


export type QueryIntegrationDeliveryAttemptManyArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationDeliveryAttemptInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationDeliveryAttemptInput>;
};


export type QueryIntegrationDeliveryAttemptOneArgs = {
  filter?: InputMaybe<FilterFindOneIntegrationDeliveryAttemptInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneIntegrationDeliveryAttemptInput>;
};


export type QueryIntegrationDeliveryAttemptPaginationArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationDeliveryAttemptInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationDeliveryAttemptInput>;
};


export type QueryIntegrationDeliveryCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationDeliveryInput>;
};


export type QueryIntegrationDeliveryManyArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationDeliveryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationDeliveryInput>;
};


export type QueryIntegrationDeliveryOneArgs = {
  filter?: InputMaybe<FilterFindOneIntegrationDeliveryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneIntegrationDeliveryInput>;
};


export type QueryIntegrationDeliveryPaginationArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationDeliveryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationDeliveryInput>;
};


export type QueryIntegrationInboundRecordCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationInboundRecordInput>;
};


export type QueryIntegrationInboundRecordManyArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInboundRecordInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInboundRecordInput>;
};


export type QueryIntegrationInboundRecordOneArgs = {
  filter?: InputMaybe<FilterFindOneIntegrationInboundRecordInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneIntegrationInboundRecordInput>;
};


export type QueryIntegrationInboundRecordPaginationArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInboundRecordInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInboundRecordInput>;
};


export type QueryIntegrationManyArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type QueryIntegrationOneArgs = {
  filter?: InputMaybe<FilterFindOneIntegrationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneIntegrationInput>;
};


export type QueryIntegrationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type QueryIntegrationPartnerProductsArgs = {
  adapter: Scalars['String']['input'];
};


export type QueryInvoiceByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInvoiceByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInvoiceInput>;
};


export type QueryInvoiceCountArgs = {
  filter?: InputMaybe<FilterCountInvoiceInput>;
};


export type QueryInvoiceLineItemByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInvoiceLineItemByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemCountArgs = {
  filter?: InputMaybe<FilterCountInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemManyArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemOneArgs = {
  filter?: InputMaybe<FilterFindOneInvoiceLineItemInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineItemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};


export type QueryInvoiceManyArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceInput>;
};


export type QueryInvoiceOneArgs = {
  filter?: InputMaybe<FilterFindOneInvoiceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneInvoiceInput>;
};


export type QueryInvoicePaginationArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceInput>;
};


export type QueryJobManualNotificationOptionsArgs = {
  jobId: Scalars['MongoID']['input'];
};


export type QueryJobTagCountArgs = {
  filter?: InputMaybe<FilterCountJobTagInput>;
};


export type QueryJobTagManyArgs = {
  filter?: InputMaybe<FilterFindManyJobTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyJobTagInput>;
};


export type QueryJobTagOneArgs = {
  filter?: InputMaybe<FilterFindOneJobTagInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneJobTagInput>;
};


export type QueryJobTagPaginationArgs = {
  filter?: InputMaybe<FilterFindManyJobTagInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyJobTagInput>;
};


export type QueryLandingPageByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLandingPageByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLandingPageSettingsInput>;
};


export type QueryLandingPageCountArgs = {
  filter?: InputMaybe<FilterCountLandingPageSettingsInput>;
};


export type QueryLandingPageListArgs = {
  linkStatus?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortFindManyLandingPageSettingsInput>;
};


export type QueryLandingPageManyArgs = {
  filter?: InputMaybe<FilterFindManyLandingPageSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLandingPageSettingsInput>;
};


export type QueryLandingPageOneArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryLandingPageOneByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLandingPageOneByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLandingPageSettingsInput>;
};


export type QueryLandingPageOneCountArgs = {
  filter?: InputMaybe<FilterCountLandingPageSettingsInput>;
};


export type QueryLandingPageOneManyArgs = {
  filter?: InputMaybe<FilterFindManyLandingPageSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLandingPageSettingsInput>;
};


export type QueryLandingPageOneOneArgs = {
  filter?: InputMaybe<FilterFindOneLandingPageSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLandingPageSettingsInput>;
};


export type QueryLandingPageOnePaginationArgs = {
  filter?: InputMaybe<FilterFindManyLandingPageSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLandingPageSettingsInput>;
};


export type QueryLandingPagePaginationArgs = {
  filter?: InputMaybe<FilterFindManyLandingPageSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLandingPageSettingsInput>;
};


export type QueryLandingPagePublicByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLandingPagePublicBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryMarketplaceLeadSearchArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagesByChatRoomArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryModuleByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryModuleByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorModuleInput>;
};


export type QueryModuleCountArgs = {
  filter?: InputMaybe<FilterCountVendorModuleInput>;
};


export type QueryModuleManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorModuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorModuleInput>;
};


export type QueryModuleOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorModuleInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorModuleInput>;
};


export type QueryModulePaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorModuleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorModuleInput>;
};


export type QueryMyAnimalsArgs = {
  cutWithinDays?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  saleProgress?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyChatRoomArgs = {
  chatRoomId: Scalars['MongoID']['input'];
};


export type QueryMyChatRoomUpdatesArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  since: Scalars['Date']['input'];
};


export type QueryMyChatRoomsArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryMyInAppNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyInvoiceArgs = {
  id: Scalars['MongoID']['input'];
};


export type QueryMyInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  openOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNoteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNoteByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNoteInput>;
};


export type QueryNoteCountArgs = {
  filter?: InputMaybe<FilterCountNoteInput>;
};


export type QueryNoteManyArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNoteOneArgs = {
  filter?: InputMaybe<FilterFindOneNoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNoteInput>;
};


export type QueryNotePaginationArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNotificationAuditSearchArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNotificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNotificationInput>;
};


export type QueryNotificationCountArgs = {
  filter?: InputMaybe<FilterCountNotificationInput>;
};


export type QueryNotificationManyArgs = {
  filter?: InputMaybe<FilterFindManyNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationInput>;
};


export type QueryNotificationOneArgs = {
  filter?: InputMaybe<FilterFindOneNotificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNotificationInput>;
};


export type QueryNotificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyNotificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationInput>;
};


export type QueryNotificationPromptByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryNotificationSettingsByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNotificationSettingsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNotificationSettingInput>;
};


export type QueryNotificationSettingsCountArgs = {
  filter?: InputMaybe<FilterCountNotificationSettingInput>;
};


export type QueryNotificationSettingsManyArgs = {
  filter?: InputMaybe<FilterFindManyNotificationSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationSettingInput>;
};


export type QueryNotificationSettingsOneArgs = {
  filter?: InputMaybe<FilterFindOneNotificationSettingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNotificationSettingInput>;
};


export type QueryNotificationSettingsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyNotificationSettingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationSettingInput>;
};


export type QueryNotificationsByChatRoomArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryPickupLocationCountArgs = {
  filter?: InputMaybe<FilterCountPickupLocationInput>;
};


export type QueryPickupLocationListArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryPickupLocationManyArgs = {
  filter?: InputMaybe<FilterFindManyPickupLocationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPickupLocationInput>;
};


export type QueryPickupLocationOneArgs = {
  filter?: InputMaybe<FilterFindOnePickupLocationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePickupLocationInput>;
};


export type QueryPickupLocationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPickupLocationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPickupLocationInput>;
};


export type QueryPrimalByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalInput>;
};


export type QueryPrimalCountArgs = {
  filter?: InputMaybe<FilterCountPrimalInput>;
};


export type QueryPrimalCutBlockerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutBlockerByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutBlockerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutBlockerInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutBlockerInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutBlockerInput>;
};


export type QueryPrimalCutByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};


export type QueryPrimalCutCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutInput>;
};


export type QueryPrimalCutManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};


export type QueryPrimalCutOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutInput>;
};


export type QueryPrimalCutPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};


export type QueryPrimalCutTypeByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutTypeByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutTypeInput>;
};


export type QueryPrimalCutTypePaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutTypeInput>;
};


export type QueryPrimalGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalGroupInput>;
};


export type QueryPrimalGroupCountArgs = {
  filter?: InputMaybe<FilterCountPrimalGroupInput>;
};


export type QueryPrimalGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type QueryPrimalGroupOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalGroupInput>;
};


export type QueryPrimalGroupPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type QueryPrimalManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};


export type QueryPrimalOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalInput>;
};


export type QueryPrimalPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};


export type QueryProcessingPartnersArgs = {
  buyerMarketplaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  maxDistanceMiles?: InputMaybe<Scalars['Int']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type QueryProcessingPartnersByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessingPartnersByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessingPartnersCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessingPartnersManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProcessingPartnersOneByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessingPartnersOneByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type QueryProcessingPartnersOnePaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorBenchmarksArgs = {
  comparisonType?: InputMaybe<ComparisonType>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProcessorCapabilityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorCapabilityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityCountArgs = {
  filter?: InputMaybe<FilterCountProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorCapabilityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type QueryProcessorCapabilitySpecificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorCapabilitySpecificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationCountArgs = {
  filter?: InputMaybe<FilterCountProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorCapabilitySpecificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorExportPreviewArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ExportColumnInput>>>;
  endDate: Scalars['String']['input'];
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ExportFilterInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sampleColumns?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExportSortInput>>>;
  startDate: Scalars['String']['input'];
  type: ProcessorExportTypeEnum;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryProcessorNotificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorNotificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorNotificationInput>;
};


export type QueryProcessorNotificationCountArgs = {
  filter?: InputMaybe<FilterCountProcessorNotificationInput>;
};


export type QueryProcessorNotificationManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorNotificationInput>;
};


export type QueryProcessorNotificationOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorNotificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorNotificationInput>;
};


export type QueryProcessorNotificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorNotificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorNotificationInput>;
};


export type QueryProcessorOfferedSplitsArgs = {
  slug: Scalars['String']['input'];
};


export type QueryProcessorSchedulingByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSchedulingByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingIdsForContactArgs = {
  contactUserId: Scalars['MongoID']['input'];
};


export type QueryProcessorSchedulingManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryProcessorSettingsByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSettingsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessorSettingsCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessorSettingsCustomCapacityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSettingsCustomCapacityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorSettingsOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type QueryProcessorSettingsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorWorkflowFunnelArgs = {
  anchor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProducerActionCountsArgs = {
  buyerOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProducerAvailableSplitsArgs = {
  producerSlug: Scalars['String']['input'];
};


export type QueryProducerBuyerRosterArgs = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProducerBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryProducerCustomersArgs = {
  balanceDueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProducerJobIdsNeedingAttentionArgs = {
  category: Scalars['String']['input'];
};


export type QueryProducerJobsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProducerListingEligibilityArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProducerListingEstimateArgs = {
  animalId: Scalars['MongoID']['input'];
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  liveWeightHigh?: InputMaybe<Scalars['Float']['input']>;
  sizeTier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProducerOfferedSpeciesArgs = {
  producerId: Scalars['MongoID']['input'];
};


export type QueryRecurringSeriesCountArgs = {
  filter?: InputMaybe<FilterCountRecurringSeriesInput>;
};


export type QueryRecurringSeriesManyArgs = {
  filter?: InputMaybe<FilterFindManyRecurringSeriesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRecurringSeriesInput>;
};


export type QueryRecurringSeriesOneArgs = {
  filter?: InputMaybe<FilterFindOneRecurringSeriesInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneRecurringSeriesInput>;
};


export type QueryRecurringSeriesPaginationArgs = {
  filter?: InputMaybe<FilterFindManyRecurringSeriesInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRecurringSeriesInput>;
};


export type QueryRecurringSeriesUpcomingJobCountArgs = {
  seriesId: Scalars['MongoID']['input'];
};


export type QueryRenderNotificationEmailPreviewArgs = {
  content: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
  vendorName: Scalars['String']['input'];
};


export type QuerySearchAvailablePhoneNumbersArgs = {
  input?: InputMaybe<SearchAvailablePhoneNumbersInput>;
};


export type QuerySearchCustomersArgs = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  relationshipTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QuerySearchInvoicesArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyInvoiceInput;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};


export type QuerySearchRecurringSeriesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryShortUrlPreviewArgs = {
  code: Scalars['String']['input'];
};


export type QuerySplitCountArgs = {
  filter?: InputMaybe<FilterCountSplitInput>;
};


export type QuerySplitCutsheetQuestionnaireArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  splitId: Scalars['MongoID']['input'];
};


export type QuerySplitManyArgs = {
  filter?: InputMaybe<FilterFindManySplitInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySplitInput>;
};


export type QuerySplitOneArgs = {
  filter?: InputMaybe<FilterFindOneSplitInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneSplitInput>;
};


export type QuerySplitPaginationArgs = {
  filter?: InputMaybe<FilterFindManySplitInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySplitInput>;
};


export type QueryStateByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryStateByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsStateInput>;
};


export type QueryStateCountArgs = {
  filter?: InputMaybe<FilterCountStateInput>;
};


export type QueryStateManyArgs = {
  filter?: InputMaybe<FilterFindManyStateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStateInput>;
};


export type QueryStateOneArgs = {
  filter?: InputMaybe<FilterFindOneStateInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneStateInput>;
};


export type QueryStatePaginationArgs = {
  filter?: InputMaybe<FilterFindManyStateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStateInput>;
};


export type QueryTenantByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTenantByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTenantInput>;
};


export type QueryTenantCountArgs = {
  filter?: InputMaybe<FilterCountTenantInput>;
};


export type QueryTenantManyArgs = {
  filter?: InputMaybe<FilterFindManyTenantInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTenantInput>;
};


export type QueryTenantOneArgs = {
  filter?: InputMaybe<FilterFindOneTenantInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTenantInput>;
};


export type QueryTenantPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTenantInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTenantInput>;
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};


export type QueryUserCountArgs = {
  filter?: InputMaybe<FilterCountUserInput>;
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserOneArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};


export type QueryUserPaginationArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserSettingsByUserIdArgs = {
  userId: Scalars['MongoID']['input'];
};


export type QueryVendorByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryVendorByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorInput>;
};


export type QueryVendorCountArgs = {
  filter?: InputMaybe<FilterCountVendorInput>;
};


export type QueryVendorCustomerJobsArgs = {
  buyerJobIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  customerId: Scalars['MongoID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVendorCustomerNotificationDefaultsArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryVendorHerdAnimalsArgs = {
  cutWithinDays?: InputMaybe<Scalars['Int']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  listed?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  saleProgress?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVendorHerdAssignableJobsArgs = {
  dropoffDateFrom?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVendorListArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryVendorManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryVendorOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorInput>;
};


export type QueryVendorPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryWaitlistByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWaitlistByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsWaitlistInput>;
};


export type QueryWaitlistByVendorIdArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryWaitlistByVendorPaginationArgs = {
  animal?: InputMaybe<Array<Scalars['String']['input']>>;
  inspectionLevel?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryWaitlistCountArgs = {
  filter?: InputMaybe<FilterCountWaitlistInput>;
};


export type QueryWaitlistManyArgs = {
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWaitlistInput>;
};


export type QueryWaitlistOneArgs = {
  filter?: InputMaybe<FilterFindOneWaitlistInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneWaitlistInput>;
};


export type QueryWaitlistPaginationArgs = {
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWaitlistInput>;
};


export type QueryWebhookByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWebhookByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorInput>;
};


export type QueryWebhookCountArgs = {
  filter?: InputMaybe<FilterCountVendorInput>;
};


export type QueryWebhookManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryWebhookOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorInput>;
};


export type QueryWebhookPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};

export type QuickAddAnimalInput = {
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  species: Scalars['String']['input'];
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type RecurrenceByDayInput = {
  day: Scalars['String']['input'];
  ordinal?: InputMaybe<Scalars['Int']['input']>;
};

export type RecurrenceRuleInput = {
  anchor: Scalars['String']['input'];
  byDay?: InputMaybe<Array<InputMaybe<RecurrenceByDayInput>>>;
  byMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  byMonthDay?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  bySetPos?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  freq: Scalars['String']['input'];
  interval: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  until?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringSeries = {
  __typename?: 'RecurringSeries';
  _id: Scalars['MongoID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  exDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  horizonWeeks?: Maybe<Scalars['Float']['output']>;
  jobTemplate: RecurringSeriesJobTemplate;
  nextOccurrence?: Maybe<Scalars['Date']['output']>;
  producerName?: Maybe<Scalars['String']['output']>;
  rule: RecurringSeriesRule;
  targetUpcomingCount?: Maybe<Scalars['Float']['output']>;
  upcomingJobCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type RecurringSeriesCancelUpcomingResponse = {
  __typename?: 'RecurringSeriesCancelUpcomingResponse';
  cancelled: Scalars['Int']['output'];
};

export type RecurringSeriesJobTemplate = {
  __typename?: 'RecurringSeriesJobTemplate';
  animalHeads?: Maybe<Array<Maybe<RecurringSeriesJobTemplateAnimalHeads>>>;
  animalSpecies: EnumRecurringSeriesJobTemplateAnimalSpecies;
  blockIndex?: Maybe<Scalars['Float']['output']>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  customFieldValues?: Maybe<Array<Maybe<RecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValues>>>;
  headCount: Scalars['Float']['output'];
  processorSettings: Scalars['MongoID']['output'];
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  requestedBy?: Maybe<Scalars['MongoID']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  vendor: Scalars['MongoID']['output'];
};

export type RecurringSeriesJobTemplateAnimalHeads = {
  __typename?: 'RecurringSeriesJobTemplateAnimalHeads';
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  customFieldValues?: Maybe<Array<Maybe<RecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValues>>>;
  cutsheetInformation?: Maybe<Array<Maybe<RecurringSeriesJobTemplateAnimalHeadsCutsheetInformation>>>;
  hangTimeDays?: Maybe<Scalars['Float']['output']>;
  inspectionLevel?: Maybe<EnumRecurringSeriesJobTemplateAnimalHeadsInspectionLevel>;
  isKillAndChill?: Maybe<Scalars['Boolean']['output']>;
  isOverThirtyMonths?: Maybe<Scalars['Boolean']['output']>;
  producerIdentifier?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  splitType?: Maybe<Scalars['String']['output']>;
};

export type RecurringSeriesJobTemplateAnimalHeadsCutsheetInformation = {
  __typename?: 'RecurringSeriesJobTemplateAnimalHeadsCutsheetInformation';
  contactUser?: Maybe<Scalars['MongoID']['output']>;
  customFieldValues?: Maybe<Array<Maybe<RecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValues>>>;
  cutsheet?: Maybe<Scalars['MongoID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  questionnaire?: Maybe<Scalars['MongoID']['output']>;
  splitPart?: Maybe<Scalars['String']['output']>;
};

export type RecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValues = {
  __typename?: 'RecurringSeriesJobTemplateAnimalHeadsCutsheetInformationCustomFieldValues';
  definition: Scalars['MongoID']['output'];
  value_boolean?: Maybe<Scalars['Boolean']['output']>;
  value_json?: Maybe<Scalars['JSON']['output']>;
  value_number?: Maybe<Scalars['Float']['output']>;
  value_text?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type RecurringSeriesPagination = {
  __typename?: 'RecurringSeriesPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RecurringSeries>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RecurringSeriesRule = {
  __typename?: 'RecurringSeriesRule';
  anchor: Scalars['String']['output'];
  byDay?: Maybe<Array<Maybe<RecurringSeriesRuleByDay>>>;
  byMonth?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  byMonthDay?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  bySetPos?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  count?: Maybe<Scalars['Float']['output']>;
  freq: EnumRecurringSeriesRuleFreq;
  interval: Scalars['Float']['output'];
  timezone: Scalars['String']['output'];
  until?: Maybe<Scalars['String']['output']>;
};

export type RecurringSeriesRuleByDay = {
  __typename?: 'RecurringSeriesRuleByDay';
  day: EnumRecurringSeriesRuleByDayDay;
  ordinal?: Maybe<Scalars['Float']['output']>;
};

export type RefreshHostedNumberStatusInput = {
  vendorId: Scalars['String']['input'];
};

export type RefreshHostedNumberStatusResponse = {
  __typename?: 'RefreshHostedNumberStatusResponse';
  error?: Maybe<Scalars['String']['output']>;
  isProvisioned?: Maybe<Scalars['Boolean']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RefundInvoiceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RelationshipsInputForUser = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ReleasePhoneNumberInput = {
  vendorId: Scalars['String']['input'];
};

export type ReleasePhoneNumberResponse = {
  __typename?: 'ReleasePhoneNumberResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveByIdCalendarEventPayload = {
  __typename?: 'RemoveByIdCalendarEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CalendarEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCalendarEventTypePayload = {
  __typename?: 'RemoveByIdCalendarEventTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CalendarEventType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCutsheetDescriptionLibraryPayload = {
  __typename?: 'RemoveByIdCutsheetDescriptionLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CutsheetDescriptionLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCutsheetImageLibraryPayload = {
  __typename?: 'RemoveByIdCutsheetImageLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CutsheetImageLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdJobTagPayload = {
  __typename?: 'RemoveByIdJobTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<JobTag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLandingPageSettingsPayload = {
  __typename?: 'RemoveByIdLandingPageSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LandingPageSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RequesterContactInformationInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SavedCard = {
  __typename?: 'SavedCard';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type SearchAvailablePhoneNumbersInput = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['String']['input'];
};

export type SendTestNotificationResult = {
  __typename?: 'SendTestNotificationResult';
  emailSent: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
};

export type ShortUrlPreview = {
  __typename?: 'ShortUrlPreview';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationUrl: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum SortFindByIdsAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  ProduceridAsc = 'PRODUCERID_ASC',
  ProduceridDesc = 'PRODUCERID_DESC',
  ProduceridCreatedatAsc = 'PRODUCERID__CREATEDAT_ASC',
  ProduceridCreatedatDesc = 'PRODUCERID__CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCustomFieldDefinitionInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorFieldkeyAsc = 'VENDOR__FIELDKEY_ASC',
  VendorFieldkeyDesc = 'VENDOR__FIELDKEY_DESC',
  VendorFieldsourceAsc = 'VENDOR__FIELDSOURCE_ASC',
  VendorFieldsourceDesc = 'VENDOR__FIELDSOURCE_DESC',
  VendorModeltypeAsc = 'VENDOR__MODELTYPE_ASC',
  VendorModeltypeDesc = 'VENDOR__MODELTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCustomFieldValueInput {
  DefinitionAsc = 'DEFINITION_ASC',
  DefinitionDesc = 'DEFINITION_DESC',
  DefinitionRecordidAsc = 'DEFINITION__RECORDID_ASC',
  DefinitionRecordidDesc = 'DEFINITION__RECORDID_DESC',
  RecordidAsc = 'RECORDID_ASC',
  RecordidDesc = 'RECORDID_DESC',
  RecordidRecordtypeAsc = 'RECORDID__RECORDTYPE_ASC',
  RecordidRecordtypeDesc = 'RECORDID__RECORDTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetDescriptionLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetImageLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsDataImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsExportPresetInput {
  ScheduleEnabledAsc = 'SCHEDULE__ENABLED_ASC',
  ScheduleEnabledDesc = 'SCHEDULE__ENABLED_DESC',
  ScheduleEnabledScheduleNextrunatAsc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_ASC',
  ScheduleEnabledScheduleNextrunatDesc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsdeletedAsc = 'VENDOR__ISDELETED_ASC',
  VendorIsdeletedDesc = 'VENDOR__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsExportSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsIntegrationInput {
  InboundTokenhashAsc = 'INBOUND__TOKENHASH_ASC',
  InboundTokenhashDesc = 'INBOUND__TOKENHASH_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorAdapterAsc = 'VENDOR__ADAPTER_ASC',
  VendorAdapterDesc = 'VENDOR__ADAPTER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameAdapterAsc = 'VENDOR__NAME__ADAPTER_ASC',
  VendorNameAdapterDesc = 'VENDOR__NAME__ADAPTER_DESC',
  VendorNameAdapterKeyAsc = 'VENDOR__NAME__ADAPTER__KEY_ASC',
  VendorNameAdapterKeyDesc = 'VENDOR__NAME__ADAPTER__KEY_DESC',
  VendorNameAdapterKeyInstancerefAsc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_ASC',
  VendorNameAdapterKeyInstancerefDesc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_DESC',
  VendorNameEnabledAsc = 'VENDOR__NAME__ENABLED_ASC',
  VendorNameEnabledDesc = 'VENDOR__NAME__ENABLED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInvoiceInput {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalLinksStripeAsc = 'EXTERNAL_LINKS__STRIPE_ASC',
  ExternalLinksStripeDesc = 'EXTERNAL_LINKS__STRIPE_DESC',
  LinksParententityidAsc = 'LINKS__PARENTENTITYID_ASC',
  LinksParententityidDesc = 'LINKS__PARENTENTITYID_DESC',
  LinksSubentityidAsc = 'LINKS__SUBENTITYID_ASC',
  LinksSubentityidDesc = 'LINKS__SUBENTITYID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInvoiceLineItemInput {
  InvoiceAsc = 'INVOICE_ASC',
  InvoiceDesc = 'INVOICE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsLandingPageSettingsInput {
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNoteInput {
  AnimalheadAsc = 'ANIMALHEAD_ASC',
  AnimalheadDesc = 'ANIMALHEAD_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserVendorAsc = 'USER__VENDOR_ASC',
  UserVendorDesc = 'USER__VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  JobidCreatedatAsc = 'JOBID__CREATEDAT_ASC',
  JobidCreatedatDesc = 'JOBID__CREATEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNotificationSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorTriggerAsc = 'VENDOR__TRIGGER_ASC',
  VendorTriggerDesc = 'VENDOR__TRIGGER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSchedulingInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  RecurringseriesAsc = 'RECURRINGSERIES_ASC',
  RecurringseriesDesc = 'RECURRINGSERIES_DESC',
  RecurringseriesDropoffdateAsc = 'RECURRINGSERIES__DROPOFFDATE_ASC',
  RecurringseriesDropoffdateDesc = 'RECURRINGSERIES__DROPOFFDATE_DESC',
  RecurringseriesStatusAsc = 'RECURRINGSERIES__STATUS_ASC',
  RecurringseriesStatusDesc = 'RECURRINGSERIES__STATUS_DESC',
  RequestidAsc = 'REQUESTID_ASC',
  RequestidDesc = 'REQUESTID_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  SourceCreatedatAsc = 'SOURCE__CREATEDAT_ASC',
  SourceCreatedatDesc = 'SOURCE__CREATEDAT_DESC',
  StatuslastupdatedAsc = 'STATUSLASTUPDATED_ASC',
  StatuslastupdatedDesc = 'STATUSLASTUPDATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDropoffdateAsc = 'VENDOR__DROPOFFDATE_ASC',
  VendorDropoffdateDesc = 'VENDOR__DROPOFFDATE_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSettingsInput {
  KiosktokenAsc = 'KIOSKTOKEN_ASC',
  KiosktokenDesc = 'KIOSKTOKEN_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsWaitlistInput {
  ProducerAsc = 'PRODUCER_ASC',
  ProducerDesc = 'PRODUCER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusEnddateAsc = 'STATUS__ENDDATE_ASC',
  StatusEnddateDesc = 'STATUS__ENDDATE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  ProduceridAsc = 'PRODUCERID_ASC',
  ProduceridDesc = 'PRODUCERID_DESC',
  ProduceridCreatedatAsc = 'PRODUCERID__CREATEDAT_ASC',
  ProduceridCreatedatDesc = 'PRODUCERID__CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCalendarEventInput {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  EventtypeAsc = 'EVENTTYPE_ASC',
  EventtypeDesc = 'EVENTTYPE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDateAsc = 'VENDOR__DATE_ASC',
  VendorDateDesc = 'VENDOR__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCalendarEventTypeInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsenabledAsc = 'VENDOR__ISENABLED_ASC',
  VendorIsenabledDesc = 'VENDOR__ISENABLED_DESC',
  VendorIsenabledSortorderAsc = 'VENDOR__ISENABLED__SORTORDER_ASC',
  VendorIsenabledSortorderDesc = 'VENDOR__ISENABLED__SORTORDER_DESC',
  VendorTitleAsc = 'VENDOR__TITLE_ASC',
  VendorTitleDesc = 'VENDOR__TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChatRoomInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DirectkeyAsc = 'DIRECTKEY_ASC',
  DirectkeyDesc = 'DIRECTKEY_DESC',
  ParticipantsAsc = 'PARTICIPANTS_ASC',
  ParticipantsDesc = 'PARTICIPANTS_DESC',
  ParticipantsUpdatedatAsc = 'PARTICIPANTS__UPDATEDAT_ASC',
  ParticipantsUpdatedatDesc = 'PARTICIPANTS__UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorCustomerAsc = 'VENDOR__CUSTOMER_ASC',
  VendorCustomerDesc = 'VENDOR__CUSTOMER_DESC',
  VendorUpdatedatAsc = 'VENDOR__UPDATEDAT_ASC',
  VendorUpdatedatDesc = 'VENDOR__UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCustomFieldDefinitionInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorFieldkeyAsc = 'VENDOR__FIELDKEY_ASC',
  VendorFieldkeyDesc = 'VENDOR__FIELDKEY_DESC',
  VendorFieldsourceAsc = 'VENDOR__FIELDSOURCE_ASC',
  VendorFieldsourceDesc = 'VENDOR__FIELDSOURCE_DESC',
  VendorModeltypeAsc = 'VENDOR__MODELTYPE_ASC',
  VendorModeltypeDesc = 'VENDOR__MODELTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCustomFieldValueInput {
  DefinitionAsc = 'DEFINITION_ASC',
  DefinitionDesc = 'DEFINITION_DESC',
  DefinitionRecordidAsc = 'DEFINITION__RECORDID_ASC',
  DefinitionRecordidDesc = 'DEFINITION__RECORDID_DESC',
  RecordidAsc = 'RECORDID_ASC',
  RecordidDesc = 'RECORDID_DESC',
  RecordidRecordtypeAsc = 'RECORDID__RECORDTYPE_ASC',
  RecordidRecordtypeDesc = 'RECORDID__RECORDTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetDescriptionLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetImageLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDataImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDocumentCategoryInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDocumentInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorGeneratorAsc = 'VENDOR__GENERATOR_ASC',
  VendorGeneratorDesc = 'VENDOR__GENERATOR_DESC',
  VendorGeneratorSourcerefAsc = 'VENDOR__GENERATOR__SOURCEREF_ASC',
  VendorGeneratorSourcerefDesc = 'VENDOR__GENERATOR__SOURCEREF_DESC',
  VendorHashAsc = 'VENDOR__HASH_ASC',
  VendorHashDesc = 'VENDOR__HASH_DESC',
  VendorLinksEntitytypeAsc = 'VENDOR__LINKS__ENTITYTYPE_ASC',
  VendorLinksEntitytypeDesc = 'VENDOR__LINKS__ENTITYTYPE_DESC',
  VendorLinksEntitytypeLinksEntityidAsc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID_ASC',
  VendorLinksEntitytypeLinksEntityidDesc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID_DESC',
  VendorLinksEntitytypeLinksEntityidUpdatedatAsc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID__UPDATEDAT_ASC',
  VendorLinksEntitytypeLinksEntityidUpdatedatDesc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID__UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyExportPresetInput {
  ScheduleEnabledAsc = 'SCHEDULE__ENABLED_ASC',
  ScheduleEnabledDesc = 'SCHEDULE__ENABLED_DESC',
  ScheduleEnabledScheduleNextrunatAsc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_ASC',
  ScheduleEnabledScheduleNextrunatDesc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsdeletedAsc = 'VENDOR__ISDELETED_ASC',
  VendorIsdeletedDesc = 'VENDOR__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyExportSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyFinancialMetricsActualsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorPeriodAsc = 'VENDOR__PERIOD_ASC',
  VendorPeriodDesc = 'VENDOR__PERIOD_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationDeliveryAttemptInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DeliveryAsc = 'DELIVERY_ASC',
  DeliveryDesc = 'DELIVERY_DESC',
  DeliveryAttemptAsc = 'DELIVERY__ATTEMPT_ASC',
  DeliveryAttemptDesc = 'DELIVERY__ATTEMPT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationDeliveryInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  EventidAsc = 'EVENTID_ASC',
  EventidDesc = 'EVENTID_DESC',
  EventidIntegrationAsc = 'EVENTID__INTEGRATION_ASC',
  EventidIntegrationDesc = 'EVENTID__INTEGRATION_DESC',
  IntegrationAsc = 'INTEGRATION_ASC',
  IntegrationDesc = 'INTEGRATION_DESC',
  IntegrationSubjecttypeAsc = 'INTEGRATION__SUBJECTTYPE_ASC',
  IntegrationSubjecttypeDesc = 'INTEGRATION__SUBJECTTYPE_DESC',
  IntegrationSubjecttypeSubjectidAsc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID_ASC',
  IntegrationSubjecttypeSubjectidDesc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID_DESC',
  IntegrationSubjecttypeSubjectidOccurredatAsc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID__OCCURREDAT_ASC',
  IntegrationSubjecttypeSubjectidOccurredatDesc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID__OCCURREDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  VendorStatusCreatedatAsc = 'VENDOR__STATUS__CREATEDAT_ASC',
  VendorStatusCreatedatDesc = 'VENDOR__STATUS__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationInboundRecordInput {
  IntegrationAsc = 'INTEGRATION_ASC',
  IntegrationDesc = 'INTEGRATION_DESC',
  IntegrationExternalrefAsc = 'INTEGRATION__EXTERNALREF_ASC',
  IntegrationExternalrefDesc = 'INTEGRATION__EXTERNALREF_DESC',
  MatchJobAsc = 'MATCH__JOB_ASC',
  MatchJobDesc = 'MATCH__JOB_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  VendorStatusReceivedatAsc = 'VENDOR__STATUS__RECEIVEDAT_ASC',
  VendorStatusReceivedatDesc = 'VENDOR__STATUS__RECEIVEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationInput {
  InboundTokenhashAsc = 'INBOUND__TOKENHASH_ASC',
  InboundTokenhashDesc = 'INBOUND__TOKENHASH_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorAdapterAsc = 'VENDOR__ADAPTER_ASC',
  VendorAdapterDesc = 'VENDOR__ADAPTER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameAdapterAsc = 'VENDOR__NAME__ADAPTER_ASC',
  VendorNameAdapterDesc = 'VENDOR__NAME__ADAPTER_DESC',
  VendorNameAdapterKeyAsc = 'VENDOR__NAME__ADAPTER__KEY_ASC',
  VendorNameAdapterKeyDesc = 'VENDOR__NAME__ADAPTER__KEY_DESC',
  VendorNameAdapterKeyInstancerefAsc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_ASC',
  VendorNameAdapterKeyInstancerefDesc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_DESC',
  VendorNameEnabledAsc = 'VENDOR__NAME__ENABLED_ASC',
  VendorNameEnabledDesc = 'VENDOR__NAME__ENABLED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalLinksStripeAsc = 'EXTERNAL_LINKS__STRIPE_ASC',
  ExternalLinksStripeDesc = 'EXTERNAL_LINKS__STRIPE_DESC',
  LinksParententityidAsc = 'LINKS__PARENTENTITYID_ASC',
  LinksParententityidDesc = 'LINKS__PARENTENTITYID_DESC',
  LinksSubentityidAsc = 'LINKS__SUBENTITYID_ASC',
  LinksSubentityidDesc = 'LINKS__SUBENTITYID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceLineItemInput {
  InvoiceAsc = 'INVOICE_ASC',
  InvoiceDesc = 'INVOICE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyJobTagInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsenabledAsc = 'VENDOR__ISENABLED_ASC',
  VendorIsenabledDesc = 'VENDOR__ISENABLED_DESC',
  VendorIsenabledSortorderAsc = 'VENDOR__ISENABLED__SORTORDER_ASC',
  VendorIsenabledSortorderDesc = 'VENDOR__ISENABLED__SORTORDER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyLandingPageSettingsInput {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNoteInput {
  AnimalheadAsc = 'ANIMALHEAD_ASC',
  AnimalheadDesc = 'ANIMALHEAD_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserVendorAsc = 'USER__VENDOR_ASC',
  UserVendorDesc = 'USER__VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  JobidCreatedatAsc = 'JOBID__CREATEDAT_ASC',
  JobidCreatedatDesc = 'JOBID__CREATEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNotificationSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorTriggerAsc = 'VENDOR__TRIGGER_ASC',
  VendorTriggerDesc = 'VENDOR__TRIGGER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPickupLocationInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorActiveAsc = 'VENDOR__ACTIVE_ASC',
  VendorActiveDesc = 'VENDOR__ACTIVE_DESC',
  VendorActiveSortorderAsc = 'VENDOR__ACTIVE__SORTORDER_ASC',
  VendorActiveSortorderDesc = 'VENDOR__ACTIVE__SORTORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSchedulingInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  RecurringseriesAsc = 'RECURRINGSERIES_ASC',
  RecurringseriesDesc = 'RECURRINGSERIES_DESC',
  RecurringseriesDropoffdateAsc = 'RECURRINGSERIES__DROPOFFDATE_ASC',
  RecurringseriesDropoffdateDesc = 'RECURRINGSERIES__DROPOFFDATE_DESC',
  RecurringseriesStatusAsc = 'RECURRINGSERIES__STATUS_ASC',
  RecurringseriesStatusDesc = 'RECURRINGSERIES__STATUS_DESC',
  RequestidAsc = 'REQUESTID_ASC',
  RequestidDesc = 'REQUESTID_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  SourceCreatedatAsc = 'SOURCE__CREATEDAT_ASC',
  SourceCreatedatDesc = 'SOURCE__CREATEDAT_DESC',
  StatuslastupdatedAsc = 'STATUSLASTUPDATED_ASC',
  StatuslastupdatedDesc = 'STATUSLASTUPDATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TrackingAsc = 'TRACKING_ASC',
  TrackingDesc = 'TRACKING_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDropoffdateAsc = 'VENDOR__DROPOFFDATE_ASC',
  VendorDropoffdateDesc = 'VENDOR__DROPOFFDATE_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSettingsInput {
  KiosktokenAsc = 'KIOSKTOKEN_ASC',
  KiosktokenDesc = 'KIOSKTOKEN_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRecurringSeriesInput {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySplitInput {
  ActiveinvoiceAsc = 'ACTIVEINVOICE_ASC',
  ActiveinvoiceDesc = 'ACTIVEINVOICE_DESC',
  AnimalAsc = 'ANIMAL_ASC',
  AnimalDesc = 'ANIMAL_DESC',
  AnimalStatusAsc = 'ANIMAL__STATUS_ASC',
  AnimalStatusDesc = 'ANIMAL__STATUS_DESC',
  BuyerAsc = 'BUYER_ASC',
  BuyerDesc = 'BUYER_DESC',
  BuyerVendorAsc = 'BUYER__VENDOR_ASC',
  BuyerVendorDesc = 'BUYER__VENDOR_DESC',
  ClaimrequestidAsc = 'CLAIMREQUESTID_ASC',
  ClaimrequestidDesc = 'CLAIMREQUESTID_DESC',
  QuestionnaireresponseAsc = 'QUESTIONNAIRERESPONSE_ASC',
  QuestionnaireresponseDesc = 'QUESTIONNAIRERESPONSE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusHoldexpiresatAsc = 'STATUS__HOLDEXPIRESAT_ASC',
  StatusHoldexpiresatDesc = 'STATUS__HOLDEXPIRESAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorKindAsc = 'VENDOR__KIND_ASC',
  VendorKindDesc = 'VENDOR__KIND_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStateInput {
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTenantInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVendorInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  VendorNameAsc = 'VENDOR_NAME_ASC',
  VendorNameDesc = 'VENDOR_NAME_DESC',
  VendorNumberAsc = 'VENDOR_NUMBER_ASC',
  VendorNumberDesc = 'VENDOR_NUMBER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyWaitlistInput {
  ProducerAsc = 'PRODUCER_ASC',
  ProducerDesc = 'PRODUCER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusEnddateAsc = 'STATUS__ENDDATE_ASC',
  StatusEnddateDesc = 'STATUS__ENDDATE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  ProduceridAsc = 'PRODUCERID_ASC',
  ProduceridDesc = 'PRODUCERID_DESC',
  ProduceridCreatedatAsc = 'PRODUCERID__CREATEDAT_ASC',
  ProduceridCreatedatDesc = 'PRODUCERID__CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCalendarEventInput {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  EventtypeAsc = 'EVENTTYPE_ASC',
  EventtypeDesc = 'EVENTTYPE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDateAsc = 'VENDOR__DATE_ASC',
  VendorDateDesc = 'VENDOR__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCalendarEventTypeInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsenabledAsc = 'VENDOR__ISENABLED_ASC',
  VendorIsenabledDesc = 'VENDOR__ISENABLED_DESC',
  VendorIsenabledSortorderAsc = 'VENDOR__ISENABLED__SORTORDER_ASC',
  VendorIsenabledSortorderDesc = 'VENDOR__ISENABLED__SORTORDER_DESC',
  VendorTitleAsc = 'VENDOR__TITLE_ASC',
  VendorTitleDesc = 'VENDOR__TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCustomFieldDefinitionInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorFieldkeyAsc = 'VENDOR__FIELDKEY_ASC',
  VendorFieldkeyDesc = 'VENDOR__FIELDKEY_DESC',
  VendorFieldsourceAsc = 'VENDOR__FIELDSOURCE_ASC',
  VendorFieldsourceDesc = 'VENDOR__FIELDSOURCE_DESC',
  VendorModeltypeAsc = 'VENDOR__MODELTYPE_ASC',
  VendorModeltypeDesc = 'VENDOR__MODELTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCustomFieldValueInput {
  DefinitionAsc = 'DEFINITION_ASC',
  DefinitionDesc = 'DEFINITION_DESC',
  DefinitionRecordidAsc = 'DEFINITION__RECORDID_ASC',
  DefinitionRecordidDesc = 'DEFINITION__RECORDID_DESC',
  RecordidAsc = 'RECORDID_ASC',
  RecordidDesc = 'RECORDID_DESC',
  RecordidRecordtypeAsc = 'RECORDID__RECORDTYPE_ASC',
  RecordidRecordtypeDesc = 'RECORDID__RECORDTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetDescriptionLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetImageLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneDataImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneDocumentCategoryInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneDocumentInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorGeneratorAsc = 'VENDOR__GENERATOR_ASC',
  VendorGeneratorDesc = 'VENDOR__GENERATOR_DESC',
  VendorGeneratorSourcerefAsc = 'VENDOR__GENERATOR__SOURCEREF_ASC',
  VendorGeneratorSourcerefDesc = 'VENDOR__GENERATOR__SOURCEREF_DESC',
  VendorHashAsc = 'VENDOR__HASH_ASC',
  VendorHashDesc = 'VENDOR__HASH_DESC',
  VendorLinksEntitytypeAsc = 'VENDOR__LINKS__ENTITYTYPE_ASC',
  VendorLinksEntitytypeDesc = 'VENDOR__LINKS__ENTITYTYPE_DESC',
  VendorLinksEntitytypeLinksEntityidAsc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID_ASC',
  VendorLinksEntitytypeLinksEntityidDesc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID_DESC',
  VendorLinksEntitytypeLinksEntityidUpdatedatAsc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID__UPDATEDAT_ASC',
  VendorLinksEntitytypeLinksEntityidUpdatedatDesc = 'VENDOR__LINKS__ENTITYTYPE__LINKS__ENTITYID__UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneExportPresetInput {
  ScheduleEnabledAsc = 'SCHEDULE__ENABLED_ASC',
  ScheduleEnabledDesc = 'SCHEDULE__ENABLED_DESC',
  ScheduleEnabledScheduleNextrunatAsc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_ASC',
  ScheduleEnabledScheduleNextrunatDesc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsdeletedAsc = 'VENDOR__ISDELETED_ASC',
  VendorIsdeletedDesc = 'VENDOR__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneExportSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneFinancialMetricsActualsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorPeriodAsc = 'VENDOR__PERIOD_ASC',
  VendorPeriodDesc = 'VENDOR__PERIOD_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneIntegrationDeliveryAttemptInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DeliveryAsc = 'DELIVERY_ASC',
  DeliveryDesc = 'DELIVERY_DESC',
  DeliveryAttemptAsc = 'DELIVERY__ATTEMPT_ASC',
  DeliveryAttemptDesc = 'DELIVERY__ATTEMPT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneIntegrationDeliveryInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  EventidAsc = 'EVENTID_ASC',
  EventidDesc = 'EVENTID_DESC',
  EventidIntegrationAsc = 'EVENTID__INTEGRATION_ASC',
  EventidIntegrationDesc = 'EVENTID__INTEGRATION_DESC',
  IntegrationAsc = 'INTEGRATION_ASC',
  IntegrationDesc = 'INTEGRATION_DESC',
  IntegrationSubjecttypeAsc = 'INTEGRATION__SUBJECTTYPE_ASC',
  IntegrationSubjecttypeDesc = 'INTEGRATION__SUBJECTTYPE_DESC',
  IntegrationSubjecttypeSubjectidAsc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID_ASC',
  IntegrationSubjecttypeSubjectidDesc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID_DESC',
  IntegrationSubjecttypeSubjectidOccurredatAsc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID__OCCURREDAT_ASC',
  IntegrationSubjecttypeSubjectidOccurredatDesc = 'INTEGRATION__SUBJECTTYPE__SUBJECTID__OCCURREDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  VendorStatusCreatedatAsc = 'VENDOR__STATUS__CREATEDAT_ASC',
  VendorStatusCreatedatDesc = 'VENDOR__STATUS__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneIntegrationInboundRecordInput {
  IntegrationAsc = 'INTEGRATION_ASC',
  IntegrationDesc = 'INTEGRATION_DESC',
  IntegrationExternalrefAsc = 'INTEGRATION__EXTERNALREF_ASC',
  IntegrationExternalrefDesc = 'INTEGRATION__EXTERNALREF_DESC',
  MatchJobAsc = 'MATCH__JOB_ASC',
  MatchJobDesc = 'MATCH__JOB_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  VendorStatusReceivedatAsc = 'VENDOR__STATUS__RECEIVEDAT_ASC',
  VendorStatusReceivedatDesc = 'VENDOR__STATUS__RECEIVEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneIntegrationInput {
  InboundTokenhashAsc = 'INBOUND__TOKENHASH_ASC',
  InboundTokenhashDesc = 'INBOUND__TOKENHASH_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorAdapterAsc = 'VENDOR__ADAPTER_ASC',
  VendorAdapterDesc = 'VENDOR__ADAPTER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameAdapterAsc = 'VENDOR__NAME__ADAPTER_ASC',
  VendorNameAdapterDesc = 'VENDOR__NAME__ADAPTER_DESC',
  VendorNameAdapterKeyAsc = 'VENDOR__NAME__ADAPTER__KEY_ASC',
  VendorNameAdapterKeyDesc = 'VENDOR__NAME__ADAPTER__KEY_DESC',
  VendorNameAdapterKeyInstancerefAsc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_ASC',
  VendorNameAdapterKeyInstancerefDesc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_DESC',
  VendorNameEnabledAsc = 'VENDOR__NAME__ENABLED_ASC',
  VendorNameEnabledDesc = 'VENDOR__NAME__ENABLED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneInvoiceInput {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalLinksStripeAsc = 'EXTERNAL_LINKS__STRIPE_ASC',
  ExternalLinksStripeDesc = 'EXTERNAL_LINKS__STRIPE_DESC',
  LinksParententityidAsc = 'LINKS__PARENTENTITYID_ASC',
  LinksParententityidDesc = 'LINKS__PARENTENTITYID_DESC',
  LinksSubentityidAsc = 'LINKS__SUBENTITYID_ASC',
  LinksSubentityidDesc = 'LINKS__SUBENTITYID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneInvoiceLineItemInput {
  InvoiceAsc = 'INVOICE_ASC',
  InvoiceDesc = 'INVOICE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneJobTagInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsenabledAsc = 'VENDOR__ISENABLED_ASC',
  VendorIsenabledDesc = 'VENDOR__ISENABLED_DESC',
  VendorIsenabledSortorderAsc = 'VENDOR__ISENABLED__SORTORDER_ASC',
  VendorIsenabledSortorderDesc = 'VENDOR__ISENABLED__SORTORDER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneLandingPageSettingsInput {
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNoteInput {
  AnimalheadAsc = 'ANIMALHEAD_ASC',
  AnimalheadDesc = 'ANIMALHEAD_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserVendorAsc = 'USER__VENDOR_ASC',
  UserVendorDesc = 'USER__VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  JobidCreatedatAsc = 'JOBID__CREATEDAT_ASC',
  JobidCreatedatDesc = 'JOBID__CREATEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNotificationSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorTriggerAsc = 'VENDOR__TRIGGER_ASC',
  VendorTriggerDesc = 'VENDOR__TRIGGER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePickupLocationInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorActiveAsc = 'VENDOR__ACTIVE_ASC',
  VendorActiveDesc = 'VENDOR__ACTIVE_DESC',
  VendorActiveSortorderAsc = 'VENDOR__ACTIVE__SORTORDER_ASC',
  VendorActiveSortorderDesc = 'VENDOR__ACTIVE__SORTORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSchedulingInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  RecurringseriesAsc = 'RECURRINGSERIES_ASC',
  RecurringseriesDesc = 'RECURRINGSERIES_DESC',
  RecurringseriesDropoffdateAsc = 'RECURRINGSERIES__DROPOFFDATE_ASC',
  RecurringseriesDropoffdateDesc = 'RECURRINGSERIES__DROPOFFDATE_DESC',
  RecurringseriesStatusAsc = 'RECURRINGSERIES__STATUS_ASC',
  RecurringseriesStatusDesc = 'RECURRINGSERIES__STATUS_DESC',
  RequestidAsc = 'REQUESTID_ASC',
  RequestidDesc = 'REQUESTID_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  SourceCreatedatAsc = 'SOURCE__CREATEDAT_ASC',
  SourceCreatedatDesc = 'SOURCE__CREATEDAT_DESC',
  StatuslastupdatedAsc = 'STATUSLASTUPDATED_ASC',
  StatuslastupdatedDesc = 'STATUSLASTUPDATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDropoffdateAsc = 'VENDOR__DROPOFFDATE_ASC',
  VendorDropoffdateDesc = 'VENDOR__DROPOFFDATE_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSettingsInput {
  KiosktokenAsc = 'KIOSKTOKEN_ASC',
  KiosktokenDesc = 'KIOSKTOKEN_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneRecurringSeriesInput {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneSplitInput {
  ActiveinvoiceAsc = 'ACTIVEINVOICE_ASC',
  ActiveinvoiceDesc = 'ACTIVEINVOICE_DESC',
  AnimalAsc = 'ANIMAL_ASC',
  AnimalDesc = 'ANIMAL_DESC',
  AnimalStatusAsc = 'ANIMAL__STATUS_ASC',
  AnimalStatusDesc = 'ANIMAL__STATUS_DESC',
  BuyerAsc = 'BUYER_ASC',
  BuyerDesc = 'BUYER_DESC',
  BuyerVendorAsc = 'BUYER__VENDOR_ASC',
  BuyerVendorDesc = 'BUYER__VENDOR_DESC',
  ClaimrequestidAsc = 'CLAIMREQUESTID_ASC',
  ClaimrequestidDesc = 'CLAIMREQUESTID_DESC',
  QuestionnaireresponseAsc = 'QUESTIONNAIRERESPONSE_ASC',
  QuestionnaireresponseDesc = 'QUESTIONNAIRERESPONSE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusHoldexpiresatAsc = 'STATUS__HOLDEXPIRESAT_ASC',
  StatusHoldexpiresatDesc = 'STATUS__HOLDEXPIRESAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorKindAsc = 'VENDOR__KIND_ASC',
  VendorKindDesc = 'VENDOR__KIND_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneWaitlistInput {
  ProducerAsc = 'PRODUCER_ASC',
  ProducerDesc = 'PRODUCER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusEnddateAsc = 'STATUS__ENDDATE_ASC',
  StatusEnddateDesc = 'STATUS__ENDDATE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  ProduceridAsc = 'PRODUCERID_ASC',
  ProduceridDesc = 'PRODUCERID_DESC',
  ProduceridCreatedatAsc = 'PRODUCERID__CREATEDAT_ASC',
  ProduceridCreatedatDesc = 'PRODUCERID__CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCustomFieldDefinitionInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorFieldkeyAsc = 'VENDOR__FIELDKEY_ASC',
  VendorFieldkeyDesc = 'VENDOR__FIELDKEY_DESC',
  VendorFieldsourceAsc = 'VENDOR__FIELDSOURCE_ASC',
  VendorFieldsourceDesc = 'VENDOR__FIELDSOURCE_DESC',
  VendorModeltypeAsc = 'VENDOR__MODELTYPE_ASC',
  VendorModeltypeDesc = 'VENDOR__MODELTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCustomFieldValueInput {
  DefinitionAsc = 'DEFINITION_ASC',
  DefinitionDesc = 'DEFINITION_DESC',
  DefinitionRecordidAsc = 'DEFINITION__RECORDID_ASC',
  DefinitionRecordidDesc = 'DEFINITION__RECORDID_DESC',
  RecordidAsc = 'RECORDID_ASC',
  RecordidDesc = 'RECORDID_DESC',
  RecordidRecordtypeAsc = 'RECORDID__RECORDTYPE_ASC',
  RecordidRecordtypeDesc = 'RECORDID__RECORDTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetDescriptionLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetImageLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyDataImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyExportPresetInput {
  ScheduleEnabledAsc = 'SCHEDULE__ENABLED_ASC',
  ScheduleEnabledDesc = 'SCHEDULE__ENABLED_DESC',
  ScheduleEnabledScheduleNextrunatAsc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_ASC',
  ScheduleEnabledScheduleNextrunatDesc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsdeletedAsc = 'VENDOR__ISDELETED_ASC',
  VendorIsdeletedDesc = 'VENDOR__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyExportSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyIntegrationInput {
  InboundTokenhashAsc = 'INBOUND__TOKENHASH_ASC',
  InboundTokenhashDesc = 'INBOUND__TOKENHASH_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorAdapterAsc = 'VENDOR__ADAPTER_ASC',
  VendorAdapterDesc = 'VENDOR__ADAPTER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameAdapterAsc = 'VENDOR__NAME__ADAPTER_ASC',
  VendorNameAdapterDesc = 'VENDOR__NAME__ADAPTER_DESC',
  VendorNameAdapterKeyAsc = 'VENDOR__NAME__ADAPTER__KEY_ASC',
  VendorNameAdapterKeyDesc = 'VENDOR__NAME__ADAPTER__KEY_DESC',
  VendorNameAdapterKeyInstancerefAsc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_ASC',
  VendorNameAdapterKeyInstancerefDesc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_DESC',
  VendorNameEnabledAsc = 'VENDOR__NAME__ENABLED_ASC',
  VendorNameEnabledDesc = 'VENDOR__NAME__ENABLED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyInvoiceInput {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalLinksStripeAsc = 'EXTERNAL_LINKS__STRIPE_ASC',
  ExternalLinksStripeDesc = 'EXTERNAL_LINKS__STRIPE_DESC',
  LinksParententityidAsc = 'LINKS__PARENTENTITYID_ASC',
  LinksParententityidDesc = 'LINKS__PARENTENTITYID_DESC',
  LinksSubentityidAsc = 'LINKS__SUBENTITYID_ASC',
  LinksSubentityidDesc = 'LINKS__SUBENTITYID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyInvoiceLineItemInput {
  InvoiceAsc = 'INVOICE_ASC',
  InvoiceDesc = 'INVOICE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyLandingPageSettingsInput {
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNoteInput {
  AnimalheadAsc = 'ANIMALHEAD_ASC',
  AnimalheadDesc = 'ANIMALHEAD_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserVendorAsc = 'USER__VENDOR_ASC',
  UserVendorDesc = 'USER__VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  JobidCreatedatAsc = 'JOBID__CREATEDAT_ASC',
  JobidCreatedatDesc = 'JOBID__CREATEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNotificationSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorTriggerAsc = 'VENDOR__TRIGGER_ASC',
  VendorTriggerDesc = 'VENDOR__TRIGGER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSchedulingInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  RecurringseriesAsc = 'RECURRINGSERIES_ASC',
  RecurringseriesDesc = 'RECURRINGSERIES_DESC',
  RecurringseriesDropoffdateAsc = 'RECURRINGSERIES__DROPOFFDATE_ASC',
  RecurringseriesDropoffdateDesc = 'RECURRINGSERIES__DROPOFFDATE_DESC',
  RecurringseriesStatusAsc = 'RECURRINGSERIES__STATUS_ASC',
  RecurringseriesStatusDesc = 'RECURRINGSERIES__STATUS_DESC',
  RequestidAsc = 'REQUESTID_ASC',
  RequestidDesc = 'REQUESTID_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  SourceCreatedatAsc = 'SOURCE__CREATEDAT_ASC',
  SourceCreatedatDesc = 'SOURCE__CREATEDAT_DESC',
  StatuslastupdatedAsc = 'STATUSLASTUPDATED_ASC',
  StatuslastupdatedDesc = 'STATUSLASTUPDATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDropoffdateAsc = 'VENDOR__DROPOFFDATE_ASC',
  VendorDropoffdateDesc = 'VENDOR__DROPOFFDATE_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSettingsInput {
  KiosktokenAsc = 'KIOSKTOKEN_ASC',
  KiosktokenDesc = 'KIOSKTOKEN_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyWaitlistInput {
  ProducerAsc = 'PRODUCER_ASC',
  ProducerDesc = 'PRODUCER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusEnddateAsc = 'STATUS__ENDDATE_ASC',
  StatusEnddateDesc = 'STATUS__ENDDATE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  ProduceridAsc = 'PRODUCERID_ASC',
  ProduceridDesc = 'PRODUCERID_DESC',
  ProduceridCreatedatAsc = 'PRODUCERID__CREATEDAT_ASC',
  ProduceridCreatedatDesc = 'PRODUCERID__CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCustomFieldDefinitionInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorFieldkeyAsc = 'VENDOR__FIELDKEY_ASC',
  VendorFieldkeyDesc = 'VENDOR__FIELDKEY_DESC',
  VendorFieldsourceAsc = 'VENDOR__FIELDSOURCE_ASC',
  VendorFieldsourceDesc = 'VENDOR__FIELDSOURCE_DESC',
  VendorModeltypeAsc = 'VENDOR__MODELTYPE_ASC',
  VendorModeltypeDesc = 'VENDOR__MODELTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCustomFieldValueInput {
  DefinitionAsc = 'DEFINITION_ASC',
  DefinitionDesc = 'DEFINITION_DESC',
  DefinitionRecordidAsc = 'DEFINITION__RECORDID_ASC',
  DefinitionRecordidDesc = 'DEFINITION__RECORDID_DESC',
  RecordidAsc = 'RECORDID_ASC',
  RecordidDesc = 'RECORDID_DESC',
  RecordidRecordtypeAsc = 'RECORDID__RECORDTYPE_ASC',
  RecordidRecordtypeDesc = 'RECORDID__RECORDTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetDescriptionLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetImageLibraryInput {
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneDataImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneExportPresetInput {
  ScheduleEnabledAsc = 'SCHEDULE__ENABLED_ASC',
  ScheduleEnabledDesc = 'SCHEDULE__ENABLED_DESC',
  ScheduleEnabledScheduleNextrunatAsc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_ASC',
  ScheduleEnabledScheduleNextrunatDesc = 'SCHEDULE__ENABLED__SCHEDULE__NEXTRUNAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorIsdeletedAsc = 'VENDOR__ISDELETED_ASC',
  VendorIsdeletedDesc = 'VENDOR__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneExportSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneIntegrationInput {
  InboundTokenhashAsc = 'INBOUND__TOKENHASH_ASC',
  InboundTokenhashDesc = 'INBOUND__TOKENHASH_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorAdapterAsc = 'VENDOR__ADAPTER_ASC',
  VendorAdapterDesc = 'VENDOR__ADAPTER_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameAdapterAsc = 'VENDOR__NAME__ADAPTER_ASC',
  VendorNameAdapterDesc = 'VENDOR__NAME__ADAPTER_DESC',
  VendorNameAdapterKeyAsc = 'VENDOR__NAME__ADAPTER__KEY_ASC',
  VendorNameAdapterKeyDesc = 'VENDOR__NAME__ADAPTER__KEY_DESC',
  VendorNameAdapterKeyInstancerefAsc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_ASC',
  VendorNameAdapterKeyInstancerefDesc = 'VENDOR__NAME__ADAPTER__KEY__INSTANCEREF_DESC',
  VendorNameEnabledAsc = 'VENDOR__NAME__ENABLED_ASC',
  VendorNameEnabledDesc = 'VENDOR__NAME__ENABLED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneInvoiceInput {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalLinksStripeAsc = 'EXTERNAL_LINKS__STRIPE_ASC',
  ExternalLinksStripeDesc = 'EXTERNAL_LINKS__STRIPE_DESC',
  LinksParententityidAsc = 'LINKS__PARENTENTITYID_ASC',
  LinksParententityidDesc = 'LINKS__PARENTENTITYID_DESC',
  LinksSubentityidAsc = 'LINKS__SUBENTITYID_ASC',
  LinksSubentityidDesc = 'LINKS__SUBENTITYID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneInvoiceLineItemInput {
  InvoiceAsc = 'INVOICE_ASC',
  InvoiceDesc = 'INVOICE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneLandingPageSettingsInput {
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNoteInput {
  AnimalheadAsc = 'ANIMALHEAD_ASC',
  AnimalheadDesc = 'ANIMALHEAD_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserVendorAsc = 'USER__VENDOR_ASC',
  UserVendorDesc = 'USER__VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  JobidCreatedatAsc = 'JOBID__CREATEDAT_ASC',
  JobidCreatedatDesc = 'JOBID__CREATEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNotificationSettingInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorTriggerAsc = 'VENDOR__TRIGGER_ASC',
  VendorTriggerDesc = 'VENDOR__TRIGGER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSchedulingInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  RecurringseriesAsc = 'RECURRINGSERIES_ASC',
  RecurringseriesDesc = 'RECURRINGSERIES_DESC',
  RecurringseriesDropoffdateAsc = 'RECURRINGSERIES__DROPOFFDATE_ASC',
  RecurringseriesDropoffdateDesc = 'RECURRINGSERIES__DROPOFFDATE_DESC',
  RecurringseriesStatusAsc = 'RECURRINGSERIES__STATUS_ASC',
  RecurringseriesStatusDesc = 'RECURRINGSERIES__STATUS_DESC',
  RequestidAsc = 'REQUESTID_ASC',
  RequestidDesc = 'REQUESTID_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  SourceCreatedatAsc = 'SOURCE__CREATEDAT_ASC',
  SourceCreatedatDesc = 'SOURCE__CREATEDAT_DESC',
  StatuslastupdatedAsc = 'STATUSLASTUPDATED_ASC',
  StatuslastupdatedDesc = 'STATUSLASTUPDATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorDropoffdateAsc = 'VENDOR__DROPOFFDATE_ASC',
  VendorDropoffdateDesc = 'VENDOR__DROPOFFDATE_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSettingsInput {
  KiosktokenAsc = 'KIOSKTOKEN_ASC',
  KiosktokenDesc = 'KIOSKTOKEN_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneWaitlistInput {
  ProducerAsc = 'PRODUCER_ASC',
  ProducerDesc = 'PRODUCER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusEnddateAsc = 'STATUS__ENDDATE_ASC',
  StatusEnddateDesc = 'STATUS__ENDDATE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorStatusAsc = 'VENDOR__STATUS_ASC',
  VendorStatusDesc = 'VENDOR__STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type SpeciesComplexAnimalCapacitySchema = {
  __typename?: 'SpeciesComplexAnimalCapacitySchema';
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type SpeciesInspectionComplexAnimalCapacitySchema = {
  __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema';
  inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel;
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type Split = {
  __typename?: 'Split';
  _id: Scalars['MongoID']['output'];
  activeInvoice?: Maybe<Scalars['MongoID']['output']>;
  animal?: Maybe<Animal>;
  buyer?: Maybe<User>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  checkoutSessionId?: Maybe<Scalars['String']['output']>;
  claimRequestId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cutsheet?: Maybe<Cutsheet>;
  cutsheetChanges?: Maybe<Array<Maybe<SplitCutsheetChanges>>>;
  cutsheetConfirmationSentAt?: Maybe<Scalars['Date']['output']>;
  cutsheetSource?: Maybe<EnumSplitCutsheetSource>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  /** The committed section's deposit override state derived from its immutable Order: 'paid' (overridable) | 'credited' | 'refunding' | 'refunded' | 'forfeited' | 'invoiced' (invoice sent, balance outstanding) | 'settled' (balance paid) (all read-only) | null (no Order — unpaid hold/legacy). Mirrors the backend override gates exactly. */
  depositOverrideState?: Maybe<Scalars['String']['output']>;
  depositReminderSentAt?: Maybe<Scalars['Date']['output']>;
  expiryNotifiedAt?: Maybe<Scalars['Date']['output']>;
  externalIds?: Maybe<Scalars['JSON']['output']>;
  holdExpiresAt?: Maybe<Scalars['Date']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** True when the split is a confirmed (paid) commitment locked into its slot. Distinct from the persisted `locked` cutsheet flag. */
  isDepositLocked?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<EnumSplitKind>;
  lastNudgeKind?: Maybe<EnumSplitLastNudgeKind>;
  lastNudgedAt?: Maybe<Scalars['Date']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** The split's linked Order (money/status fields only) — null when no Order exists yet. */
  order?: Maybe<OrderInvoiceResult>;
  paymentIntent?: Maybe<Scalars['String']['output']>;
  pickupLocation?: Maybe<PickupLocation>;
  placedBy?: Maybe<EnumSplitPlacedBy>;
  placementHoldAt?: Maybe<Scalars['Date']['output']>;
  progress?: Maybe<EnumSplitProgress>;
  questionnaire?: Maybe<CutsheetQuestionnaire>;
  questionnaireResponse?: Maybe<CutsheetQuestionnaireResponse>;
  reassignedFromOrder?: Maybe<Scalars['MongoID']['output']>;
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** The split's per-split settlement sub-status (payer label, invoiced, settled, collected) — derived, batched, in lock-step with the projection's `settled` signal. Resolves ONLY for the split's own processor (session vendor === split.vendor) or an admin; every other session gets null. */
  settlementStatus?: Maybe<SplitSettlementView>;
  splitPart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumSplitStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
  yield?: Maybe<Array<Maybe<SplitYield>>>;
};

export type SplitCutsheetChanges = {
  __typename?: 'SplitCutsheetChanges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  cutsheet?: Maybe<Cutsheet>;
  enteredBy?: Maybe<User>;
  previousCutsheet?: Maybe<Cutsheet>;
  previousQuestionnaireResponse?: Maybe<CutsheetQuestionnaireResponse>;
  questionnaireResponse?: Maybe<CutsheetQuestionnaireResponse>;
  source: EnumSplitCutsheetChangesSource;
  timestamp: Scalars['Date']['output'];
};

export type SplitCutsheetQuestionnaire = {
  __typename?: 'SplitCutsheetQuestionnaire';
  capabilitiesV1Active: Scalars['Boolean']['output'];
  capabilitiesV2Active: Scalars['Boolean']['output'];
  questionnaireId?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type SplitPagination = {
  __typename?: 'SplitPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Split>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SplitSettlementView = {
  __typename?: 'SplitSettlementView';
  billable: Scalars['Boolean']['output'];
  collected: Scalars['Boolean']['output'];
  invoiceId?: Maybe<Scalars['MongoID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceStatus?: Maybe<Scalars['String']['output']>;
  invoiced: Scalars['Boolean']['output'];
  payerLabel?: Maybe<Scalars['String']['output']>;
  payerParty?: Maybe<Scalars['String']['output']>;
  producerSettled?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
  settled: Scalars['Boolean']['output'];
  settlementMethod?: Maybe<Scalars['String']['output']>;
};

export type SplitYield = {
  __typename?: 'SplitYield';
  _id?: Maybe<Scalars['MongoID']['output']>;
  capabilityOptionId?: Maybe<Scalars['String']['output']>;
  itemCount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  packageCount: Scalars['Float']['output'];
  packageIdentifier?: Maybe<Scalars['String']['output']>;
  weightLbs: Scalars['Float']['output'];
};

export type SplitYieldItemInput = {
  capabilityOptionId?: InputMaybe<Scalars['String']['input']>;
  itemCount: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  packageCount: Scalars['Int']['input'];
  packageIdentifier?: InputMaybe<Scalars['String']['input']>;
  weightLbs: Scalars['Float']['input'];
};

export type State = {
  __typename?: 'State';
  _id: Scalars['MongoID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** List of items with pagination. */
export type StatePagination = {
  __typename?: 'StatePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<State>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type StorefrontPickupLocation = {
  __typename?: 'StorefrontPickupLocation';
  _id: Scalars['MongoID']['output'];
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type SubmitHostedLandlineOrderInput = {
  phoneNumber: Scalars['String']['input'];
  smsWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type SubmitHostedLandlineOrderResponse = {
  __typename?: 'SubmitHostedLandlineOrderResponse';
  error?: Maybe<Scalars['String']['output']>;
  hostedNumberOrderSid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SyncConversationPhoneNumbersInput = {
  vendorId: Scalars['String']['input'];
};

export type SyncConversationPhoneNumbersResponse = {
  __typename?: 'SyncConversationPhoneNumbersResponse';
  error?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  _id: Scalars['MongoID']['output'];
  date_created: Scalars['Date']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_ids?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  picture_url?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  vendors: Array<Vendor>;
};


export type TenantUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type TenantVendorsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** List of items with pagination. */
export type TenantPagination = {
  __typename?: 'TenantPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tenant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TimeConfigurationInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerInvoicing: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
  timePerProducerBooking: Scalars['Float']['input'];
};

export type TimeTrackingConfigInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
};

export type UpdateAuthMethodPayload = {
  __typename?: 'UpdateAuthMethodPayload';
  authMethod: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateByIdAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateByIdAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateByIdAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type UpdateByIdAddressPayload = {
  __typename?: 'UpdateByIdAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<UpdateByIdCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateByIdCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCsvImportJobPayload = {
  __typename?: 'UpdateByIdCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CsvImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdCalendarEventInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCalendarEventPayload = {
  __typename?: 'UpdateByIdCalendarEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CalendarEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCalendarEventTypeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCalendarEventTypePayload = {
  __typename?: 'UpdateByIdCalendarEventTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CalendarEventType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCancellationReasonPayload = {
  __typename?: 'UpdateByIdCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCustomFieldDefinitionInput = {
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCustomFieldDefinitionPayload = {
  __typename?: 'UpdateByIdCustomFieldDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CustomFieldDefinition>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCustomFieldValueInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCustomFieldValuePayload = {
  __typename?: 'UpdateByIdCustomFieldValuePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CustomFieldValue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetAssignmentRuleSetInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetAssignmentRuleSetPayload = {
  __typename?: 'UpdateByIdCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetAssignmentRuleSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type UpdateByIdCutsheetCapabilityGroupInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityGroupPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<UpdateByIdCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<UpdateByIdCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityOption>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type UpdateByIdCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilitySpecificationPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetDescriptionLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdCutsheetDescriptionLibraryPayload = {
  __typename?: 'UpdateByIdCutsheetDescriptionLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetDescriptionLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateByIdCutsheetImageLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdCutsheetImageLibraryPayload = {
  __typename?: 'UpdateByIdCutsheetImageLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetImageLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetPayload = {
  __typename?: 'UpdateByIdCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<UpdateByIdCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<UpdateByIdCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<UpdateByIdCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetQuestionnairePayload = {
  __typename?: 'UpdateByIdCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetQuestionnaire>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type UpdateByIdCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type UpdateByIdCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type UpdateByIdCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateByIdDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateByIdDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type UpdateByIdDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<UpdateByIdDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type UpdateByIdDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type UpdateByIdDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<UpdateByIdDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type UpdateByIdDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<UpdateByIdDataImportJobHygieneNormalizationSummaryInput>;
};

export type UpdateByIdDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<UpdateByIdDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<UpdateByIdDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDataImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<UpdateByIdDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateByIdDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDataImportJobPayload = {
  __typename?: 'UpdateByIdDataImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<DataImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdExportPresetInput = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<UpdateByIdExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<UpdateByIdExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<UpdateByIdExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdExportPresetPayload = {
  __typename?: 'UpdateByIdExportPresetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ExportPreset>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdExportSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<UpdateByIdExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdExportSettingPayload = {
  __typename?: 'UpdateByIdExportSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ExportSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type UpdateByIdFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<UpdateByIdFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<UpdateByIdFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<UpdateByIdFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<UpdateByIdFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFinancialReportingConfigPayload = {
  __typename?: 'UpdateByIdFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FinancialReportingConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type UpdateByIdIntegrationInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<UpdateByIdIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdIntegrationPayload = {
  __typename?: 'UpdateByIdIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateByIdInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateByIdInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoiceLineItemPayload = {
  __typename?: 'UpdateByIdInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoicePayload = {
  __typename?: 'UpdateByIdInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateByIdJobTagInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumJobTagSpecies>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdJobTagPayload = {
  __typename?: 'UpdateByIdJobTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<JobTag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLandingPageSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<UpdateByIdAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<UpdateByIdLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<UpdateByIdLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<UpdateByIdLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<UpdateByIdLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<UpdateByIdLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<UpdateByIdLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

export type UpdateByIdLandingPageSettingsPayload = {
  __typename?: 'UpdateByIdLandingPageSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LandingPageSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNoteInput = {
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateByIdNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotePayload = {
  __typename?: 'UpdateByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationErrorInput = {
  email?: InputMaybe<UpdateByIdNotificationErrorMessageInput>;
  sms?: InputMaybe<UpdateByIdNotificationErrorMessageInput>;
};

export type UpdateByIdNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<UpdateByIdNotificationErrorInput>;
  errorMessage?: InputMaybe<UpdateByIdNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateByIdNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotificationPayload = {
  __typename?: 'UpdateByIdNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Notification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationSettingInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateByIdNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotificationSettingPayload = {
  __typename?: 'UpdateByIdNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateByIdNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type UpdateByIdPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateByIdPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPrimalCutBlockerPayload = {
  __typename?: 'UpdateByIdPrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalCutPayload = {
  __typename?: 'UpdateByIdPrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalCutTypePayload = {
  __typename?: 'UpdateByIdPrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalGroupPayload = {
  __typename?: 'UpdateByIdPrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalPayload = {
  __typename?: 'UpdateByIdPrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateByIdProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorCapabilityPayload = {
  __typename?: 'UpdateByIdProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateByIdProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateByIdProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorNotificationPayload = {
  __typename?: 'UpdateByIdProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDate?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  killDate?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type UpdateByIdProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type UpdateByIdProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateByIdProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type UpdateByIdProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<UpdateByIdProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<UpdateByIdProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateByIdProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateByIdProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateByIdProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateByIdProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateByIdProcessorSchedulingPayload = {
  __typename?: 'UpdateByIdProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateByIdProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type UpdateByIdProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<UpdateByIdProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<UpdateByIdProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<UpdateByIdProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<UpdateByIdProcessorSettingsWorkflowCapacityInput>;
};

export type UpdateByIdProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsPayload = {
  __typename?: 'UpdateByIdProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdStatePayload = {
  __typename?: 'UpdateByIdStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTenantPayload = {
  __typename?: 'UpdateByIdTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<UpdateByIdUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UpdateByIdUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateByIdUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdUserPayload = {
  __typename?: 'UpdateByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserSettingsInput = {
  calendar?: InputMaybe<UpdateByIdUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<UpdateByIdUserSettingsHangTimePreferencesInput>>>;
};

export type UpdateByIdVendorInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<UpdateByIdVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVendorModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdVendorModulePayload = {
  __typename?: 'UpdateByIdVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<VendorModule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdVendorPayload = {
  __typename?: 'UpdateByIdVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type UpdateByIdWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdWaitlistPayload = {
  __typename?: 'UpdateByIdWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateInvoiceInput = {
  description: Scalars['String']['input'];
  id: Scalars['MongoID']['input'];
  invoiceNumber: Scalars['String']['input'];
  line_items?: InputMaybe<Array<InputMaybe<InvoiceUpdateLineItemInput>>>;
};

export type UpdateManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateManyAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateManyAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type UpdateManyAddressPayload = {
  __typename?: 'UpdateManyAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<UpdateManyCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateManyCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCsvImportJobPayload = {
  __typename?: 'UpdateManyCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateManyCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCancellationReasonPayload = {
  __typename?: 'UpdateManyCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCustomFieldDefinitionInput = {
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCustomFieldDefinitionPayload = {
  __typename?: 'UpdateManyCustomFieldDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCustomFieldValueInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCustomFieldValuePayload = {
  __typename?: 'UpdateManyCustomFieldValuePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetAssignmentRuleSetInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetAssignmentRuleSetPayload = {
  __typename?: 'UpdateManyCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type UpdateManyCutsheetCapabilityGroupInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityGroupPayload = {
  __typename?: 'UpdateManyCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<UpdateManyCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<UpdateManyCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionPayload = {
  __typename?: 'UpdateManyCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityPayload = {
  __typename?: 'UpdateManyCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type UpdateManyCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilitySpecificationPayload = {
  __typename?: 'UpdateManyCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetDescriptionLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyCutsheetDescriptionLibraryPayload = {
  __typename?: 'UpdateManyCutsheetDescriptionLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateManyCutsheetImageLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyCutsheetImageLibraryPayload = {
  __typename?: 'UpdateManyCutsheetImageLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetPayload = {
  __typename?: 'UpdateManyCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateManyCutsheetQuestionnaireInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<UpdateManyCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<UpdateManyCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<UpdateManyCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetQuestionnairePayload = {
  __typename?: 'UpdateManyCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type UpdateManyCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type UpdateManyCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type UpdateManyCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type UpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<UpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type UpdateManyDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type UpdateManyDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<UpdateManyDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type UpdateManyDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<UpdateManyDataImportJobHygieneNormalizationSummaryInput>;
};

export type UpdateManyDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<UpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<UpdateManyDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyDataImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<UpdateManyDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateManyDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyDataImportJobPayload = {
  __typename?: 'UpdateManyDataImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateManyExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyExportPresetInput = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateManyExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<UpdateManyExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<UpdateManyExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<UpdateManyExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyExportPresetPayload = {
  __typename?: 'UpdateManyExportPresetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateManyExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyExportSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<UpdateManyExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyExportSettingPayload = {
  __typename?: 'UpdateManyExportSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type UpdateManyFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<UpdateManyFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<UpdateManyFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<UpdateManyFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<UpdateManyFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyFinancialReportingConfigPayload = {
  __typename?: 'UpdateManyFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type UpdateManyIntegrationInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<UpdateManyIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyIntegrationPayload = {
  __typename?: 'UpdateManyIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoiceLineItemPayload = {
  __typename?: 'UpdateManyInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoicePayload = {
  __typename?: 'UpdateManyInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateManyLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyLandingPageSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<UpdateManyAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<UpdateManyLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<UpdateManyLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<UpdateManyLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<UpdateManyLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<UpdateManyLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<UpdateManyLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

export type UpdateManyLandingPageSettingsPayload = {
  __typename?: 'UpdateManyLandingPageSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyNoteInput = {
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateManyNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotePayload = {
  __typename?: 'UpdateManyNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationErrorInput = {
  email?: InputMaybe<UpdateManyNotificationErrorMessageInput>;
  sms?: InputMaybe<UpdateManyNotificationErrorMessageInput>;
};

export type UpdateManyNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<UpdateManyNotificationErrorInput>;
  errorMessage?: InputMaybe<UpdateManyNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateManyNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotificationPayload = {
  __typename?: 'UpdateManyNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationSettingInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotificationSettingPayload = {
  __typename?: 'UpdateManyNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateManyNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type UpdateManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyPrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyPrimalCutBlockerPayload = {
  __typename?: 'UpdateManyPrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalCutPayload = {
  __typename?: 'UpdateManyPrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalCutTypePayload = {
  __typename?: 'UpdateManyPrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalGroupPayload = {
  __typename?: 'UpdateManyPrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalPayload = {
  __typename?: 'UpdateManyPrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateManyProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorCapabilityPayload = {
  __typename?: 'UpdateManyProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateManyProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorNotificationPayload = {
  __typename?: 'UpdateManyProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type UpdateManyProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type UpdateManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateManyProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type UpdateManyProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<UpdateManyProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<UpdateManyProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateManyProcessorSchedulingPayload = {
  __typename?: 'UpdateManyProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<UpdateManyProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateManyProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateManyProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type UpdateManyProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type UpdateManyProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type UpdateManyProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<UpdateManyProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<UpdateManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<UpdateManyProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<UpdateManyProcessorSettingsWorkflowCapacityInput>;
};

export type UpdateManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateManyProcessorSettingsPayload = {
  __typename?: 'UpdateManyProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyStatePayload = {
  __typename?: 'UpdateManyStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyTenantPayload = {
  __typename?: 'UpdateManyTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<UpdateManyUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UpdateManyUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateManyUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyUserPayload = {
  __typename?: 'UpdateManyUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyUserSettingsInput = {
  calendar?: InputMaybe<UpdateManyUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<UpdateManyUserSettingsHangTimePreferencesInput>>>;
};

export type UpdateManyVendorInput = {
  address?: InputMaybe<UpdateManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<UpdateManyVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyVendorModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyVendorModulePayload = {
  __typename?: 'UpdateManyVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyVendorPayload = {
  __typename?: 'UpdateManyVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type UpdateManyWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyWaitlistPayload = {
  __typename?: 'UpdateManyWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateOneAddressLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateOneAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type UpdateOneAddressPayload = {
  __typename?: 'UpdateOneAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<UpdateOneCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  successFilePath?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateOneCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCsvImportJobPayload = {
  __typename?: 'UpdateOneCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CsvImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOneCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCancellationReasonPayload = {
  __typename?: 'UpdateOneCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCustomFieldDefinitionInput = {
  captureAt?: InputMaybe<EnumCustomFieldDefinitionCaptureAt>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumCustomFieldDefinitionFieldSource>;
  fieldType?: InputMaybe<EnumCustomFieldDefinitionFieldType>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<EnumCustomFieldDefinitionModelType>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  speciesFilter?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCustomFieldDefinitionPayload = {
  __typename?: 'UpdateOneCustomFieldDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CustomFieldDefinition>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCustomFieldValueInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  definition?: InputMaybe<Scalars['MongoID']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<EnumCustomFieldValueRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value_boolean?: InputMaybe<Scalars['Boolean']['input']>;
  value_json?: InputMaybe<Scalars['JSON']['input']>;
  value_number?: InputMaybe<Scalars['Float']['input']>;
  value_text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCustomFieldValuePayload = {
  __typename?: 'UpdateOneCustomFieldValuePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CustomFieldValue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetAssignmentRuleSetInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetAssignmentRuleSetPayload = {
  __typename?: 'UpdateOneCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetAssignmentRuleSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type UpdateOneCutsheetCapabilityGroupInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityGroupPayload = {
  __typename?: 'UpdateOneCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<UpdateOneCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hiddenUnlessSelected?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  partnerCodes?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityOptionPartnerCodesInput>>>;
  pricing?: InputMaybe<UpdateOneCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionPartnerCodesInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityOptionPartnerCodesRulesInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionPartnerCodesRulesConditionsInput = {
  specificationId?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionPartnerCodesRulesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityOptionPartnerCodesRulesConditionsInput>>>;
  speciesCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionPayload = {
  __typename?: 'UpdateOneCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityOption>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityPayload = {
  __typename?: 'UpdateOneCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type UpdateOneCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilitySpecificationPayload = {
  __typename?: 'UpdateOneCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetDescriptionLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneCutsheetDescriptionLibraryPayload = {
  __typename?: 'UpdateOneCutsheetDescriptionLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetDescriptionLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateOneCutsheetImageLibraryInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneCutsheetImageLibraryPayload = {
  __typename?: 'UpdateOneCutsheetImageLibraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetImageLibrary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetPayload = {
  __typename?: 'UpdateOneCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetQuestionnaireAdditionalChargesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basis?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesBasis>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<EnumCutsheetQuestionnaireAdditionalChargesPriceType>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateOneCutsheetQuestionnaireInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireAdditionalChargesInput>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  killFee?: InputMaybe<UpdateOneCutsheetQuestionnaireProcessingFeeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<UpdateOneCutsheetQuestionnairePrintSettingsInput>;
  processingFee?: InputMaybe<UpdateOneCutsheetQuestionnaireProcessingFeeInput>;
  questions?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetQuestionnairePayload = {
  __typename?: 'UpdateOneCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetQuestionnaire>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsCheckboxStyle>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition>;
};

export type UpdateOneCutsheetQuestionnaireProcessingFeeInput = {
  amount: Scalars['Float']['input'];
  basis: EnumCutsheetQuestionnaireProcessingFeeBasis;
  priceType: EnumCutsheetQuestionnaireProcessingFeePriceType;
};

export type UpdateOneCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type UpdateOneCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneDataImportJobHygieneActionsInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<EnumDataImportJobHygieneActionsKind>;
};

export type UpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isJoint?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneDataImportJobHygieneCanonicalIdentitiesInput = {
  canonical?: InputMaybe<UpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  crossRoleAttachToProducerCluster?: InputMaybe<Scalars['String']['input']>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesRole>;
  sourceRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobHygieneCanonicalIdentitiesStatus>;
};

export type UpdateOneDataImportJobHygieneClusterAssignmentsInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobHygieneClusterAssignmentsSide>;
};

export type UpdateOneDataImportJobHygieneCrossClusterFlagsInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivation?: InputMaybe<Scalars['String']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  humanReason?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sharedValue?: InputMaybe<UpdateOneDataImportJobHygieneCrossClusterFlagsSharedValueInput>;
  status?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsStatus>;
  type?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsType>;
};

export type UpdateOneDataImportJobHygieneCrossClusterFlagsSharedValueInput = {
  field?: InputMaybe<EnumDataImportJobHygieneCrossClusterFlagsSharedValueField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneDataImportJobHygieneInput = {
  actions?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobHygieneActionsInput>>>;
  canonicalIdentities?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobHygieneCanonicalIdentitiesInput>>>;
  clusterAssignments?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobHygieneClusterAssignmentsInput>>>;
  crossClusterFlags?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobHygieneCrossClusterFlagsInput>>>;
  malformedJobs?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobHygieneMalformedJobsInput>>>;
  normalizationSummary?: InputMaybe<UpdateOneDataImportJobHygieneNormalizationSummaryInput>;
};

export type UpdateOneDataImportJobHygieneMalformedJobsInput = {
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneDataImportJobHygieneNormalizationSummaryInput = {
  diacriticsStripped?: InputMaybe<Scalars['Float']['input']>;
  emailsLowercased?: InputMaybe<Scalars['Float']['input']>;
  phonesNormalized?: InputMaybe<Scalars['Float']['input']>;
  whitespaceTrimmed?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneDataImportJobHygieneReviewBaselineInput = {
  buyer?: InputMaybe<UpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  producer?: InputMaybe<UpdateOneDataImportJobHygieneCanonicalIdentitiesCanonicalInput>;
  rowIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneDataImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumDataImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerCount?: InputMaybe<Scalars['Float']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  detectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  excludedRows?: InputMaybe<Scalars['Float']['input']>;
  hygiene?: InputMaybe<UpdateOneDataImportJobHygieneInput>;
  hygieneReviewBaseline?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobHygieneReviewBaselineInput>>>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobCount?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobImportedCount?: InputMaybe<Scalars['Float']['input']>;
  jobNotImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImported?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobNotImportedInput>>>;
  notImportedCount?: InputMaybe<Scalars['Float']['input']>;
  notImportedFilePath?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  status?: InputMaybe<EnumDataImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  suggestedMapping?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumDataImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateOneDataImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneDataImportJobNotImportedInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneDataImportJobPayload = {
  __typename?: 'UpdateOneDataImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<DataImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneDataImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<EnumDataImportJobValidationErrorsSide>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOneExportPresetColumnsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneExportPresetFiltersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneExportPresetInput = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateOneExportPresetColumnsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  datePreset?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<UpdateOneExportPresetFiltersInput>>>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<UpdateOneExportPresetScheduleInput>;
  sort?: InputMaybe<Array<InputMaybe<UpdateOneExportPresetSortInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneExportPresetPayload = {
  __typename?: 'UpdateOneExportPresetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ExportPreset>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneExportPresetScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<EnumExportPresetScheduleFrequency>;
  hourUtc?: InputMaybe<Scalars['Float']['input']>;
  lastRunAt?: InputMaybe<Scalars['Date']['input']>;
  lastRunError?: InputMaybe<Scalars['String']['input']>;
  lastRunRowCount?: InputMaybe<Scalars['Float']['input']>;
  lastRunStatus?: InputMaybe<EnumExportPresetScheduleLastRunStatus>;
  nextRunAt?: InputMaybe<Scalars['Date']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOneExportPresetSortInput = {
  direction?: InputMaybe<EnumExportPresetSortDirection>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneExportSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  quickbooksDesktop?: InputMaybe<UpdateOneExportSettingQuickbooksDesktopInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneExportSettingPayload = {
  __typename?: 'UpdateOneExportSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ExportSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneExportSettingQuickbooksDesktopInput = {
  adjustmentAccount?: InputMaybe<Scalars['String']['input']>;
  arAccount?: InputMaybe<Scalars['String']['input']>;
  defaultItem?: InputMaybe<Scalars['String']['input']>;
  depositAccount?: InputMaybe<Scalars['String']['input']>;
  discountAccount?: InputMaybe<Scalars['String']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type UpdateOneFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<UpdateOneFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<UpdateOneFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<UpdateOneFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<UpdateOneFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneFinancialReportingConfigPayload = {
  __typename?: 'UpdateOneFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FinancialReportingConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneIntegrationInboundInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['Date']['input']>;
  lastPolledAt?: InputMaybe<Scalars['Date']['input']>;
  pollCursor?: InputMaybe<Scalars['String']['input']>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  tokenHint?: InputMaybe<Scalars['String']['input']>;
  weightMode?: InputMaybe<EnumIntegrationInboundWeightMode>;
};

export type UpdateOneIntegrationInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  inbound?: InputMaybe<UpdateOneIntegrationInboundInput>;
  instanceRef?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastDeliveryAt?: InputMaybe<Scalars['Date']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastErrorAt?: InputMaybe<Scalars['Date']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<InputMaybe<EnumIntegrationSubscribedEvents>>>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneIntegrationPayload = {
  __typename?: 'UpdateOneIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  settlement_method?: InputMaybe<EnumInvoiceSettlement_Method>;
  settlement_recorded_at?: InputMaybe<Scalars['Date']['input']>;
  settlement_recorded_by?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoiceLineItemPayload = {
  __typename?: 'UpdateOneInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoicePayload = {
  __typename?: 'UpdateOneInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateOneLandingPageSettingsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneLandingPageSettingsDocumentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneLandingPageSettingsFaqInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneLandingPageSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<UpdateOneAddressInput>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<UpdateOneLandingPageSettingsContactInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<InputMaybe<UpdateOneLandingPageSettingsDocumentsInput>>>;
  faq?: InputMaybe<Array<InputMaybe<UpdateOneLandingPageSettingsFaqInput>>>;
  galleryImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<UpdateOneLandingPageSettingsLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  premierProducers?: InputMaybe<Array<InputMaybe<UpdateOneLandingPageSettingsPremierProducersInput>>>;
  pricingRows?: InputMaybe<Array<InputMaybe<UpdateOneLandingPageSettingsPricingRowsInput>>>;
  showAbout?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showCommunityListings?: InputMaybe<Scalars['Boolean']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  showDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  showFaq?: InputMaybe<Scalars['Boolean']['input']>;
  showGallery?: InputMaybe<Scalars['Boolean']['input']>;
  showInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<EnumLandingPageSettingsSpecies>>>;
  storefrontProducers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneLandingPageSettingsLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumLandingPageSettingsLocationType>;
};

export type UpdateOneLandingPageSettingsPayload = {
  __typename?: 'UpdateOneLandingPageSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LandingPageSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneLandingPageSettingsPremierProducersInput = {
  badge?: InputMaybe<EnumLandingPageSettingsPremierProducersBadge>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneLandingPageSettingsPricingRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneNoteInput = {
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateOneNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotePayload = {
  __typename?: 'UpdateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationErrorInput = {
  email?: InputMaybe<UpdateOneNotificationErrorMessageInput>;
  sms?: InputMaybe<UpdateOneNotificationErrorMessageInput>;
};

export type UpdateOneNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<UpdateOneNotificationErrorInput>;
  errorMessage?: InputMaybe<UpdateOneNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateOneNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotificationPayload = {
  __typename?: 'UpdateOneNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Notification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationSettingInput = {
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<EnumNotificationSettingPreferredChannel>;
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendInApp?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotificationSettingPayload = {
  __typename?: 'UpdateOneNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateOneNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type UpdateOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOnePrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOnePrimalCutBlockerPayload = {
  __typename?: 'UpdateOnePrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalCutPayload = {
  __typename?: 'UpdateOnePrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalCutTypePayload = {
  __typename?: 'UpdateOnePrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalGroupPayload = {
  __typename?: 'UpdateOnePrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalPayload = {
  __typename?: 'UpdateOnePrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateOneProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorCapabilityPayload = {
  __typename?: 'UpdateOneProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateOneProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorNotificationPayload = {
  __typename?: 'UpdateOneProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSchedulingCustomerConfirmationHistoryInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationHistoryVia>;
};

export type UpdateOneProcessorSchedulingCustomerConfirmationInput = {
  prompt?: InputMaybe<Scalars['MongoID']['input']>;
  respondedAt?: InputMaybe<Scalars['Date']['input']>;
  respondedBy?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationStatus>;
  via?: InputMaybe<EnumProcessorSchedulingCustomerConfirmationVia>;
};

export type UpdateOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateOneProcessorSchedulingDepositCheckoutSessionInput>;
  method?: InputMaybe<EnumProcessorSchedulingDepositMethod>;
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProcessorSchedulingDepositStatus>;
};

export type UpdateOneProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerConfirmation?: InputMaybe<UpdateOneProcessorSchedulingCustomerConfirmationInput>;
  customerConfirmationHistory?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingCustomerConfirmationHistoryInput>>>;
  deposit?: InputMaybe<UpdateOneProcessorSchedulingDepositInput>;
  depositAcknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  expectedArrivalTime?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  pickupLocation?: InputMaybe<Scalars['MongoID']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  recurringSeries?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  waitlist?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateOneProcessorSchedulingPayload = {
  __typename?: 'UpdateOneProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  changedBy?: InputMaybe<Scalars['MongoID']['input']>;
  changedByName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  rebooking?: InputMaybe<UpdateOneProcessorSettingsAnimalSettingsRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsAnimalSettingsRebookingInput = {
  dueSoonWindowDays?: InputMaybe<Scalars['Float']['input']>;
  intervalDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateOneProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsCustomerNotificationDefaultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animal?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCalendarTooltipInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput = {
  column?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldSource?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCutsheetHeaderInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
  media?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateOneProcessorSettingsDocumentSettingsInput = {
  calendarTooltip?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCalendarTooltipInput>;
  carcassTag?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCutsheetInput>;
  cutsheetHeader?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCutsheetHeaderInput>;
  killSheet?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsKillSheetInput>;
};

export type UpdateOneProcessorSettingsDocumentSettingsKillSheetInput = {
  fields?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagFieldsInput>>>;
};

export type UpdateOneProcessorSettingsHangTimeSettingsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsHangTimeSettingsOptionsInput>>>;
  species?: InputMaybe<EnumProcessorSettingsHangTimeSettingsSpecies>;
};

export type UpdateOneProcessorSettingsHangTimeSettingsOptionsInput = {
  availableAtBooking?: InputMaybe<Scalars['Boolean']['input']>;
  durationDays?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  upcharge?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customerNotificationDefaults?: InputMaybe<UpdateOneProcessorSettingsCustomerNotificationDefaultsInput>;
  documentSettings?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsHangTimeSettingsInput>>>;
  invoicing?: InputMaybe<UpdateOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsKillAndChillSettingsInput>>>;
  kioskShortCode?: InputMaybe<Scalars['String']['input']>;
  kioskToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInterestNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<UpdateOneProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  workflowCapacity?: InputMaybe<UpdateOneProcessorSettingsWorkflowCapacityInput>;
};

export type UpdateOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateOneProcessorSettingsPayload = {
  __typename?: 'UpdateOneProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneProcessorSettingsWorkflowCapacityInput = {
  coolerRailCapacity?: InputMaybe<Scalars['Float']['input']>;
  dropoffPenCapacity?: InputMaybe<Scalars['Float']['input']>;
  freezerCapacity?: InputMaybe<Scalars['Float']['input']>;
  furtherProcessingCapacity?: InputMaybe<Scalars['Float']['input']>;
  killPerDay?: InputMaybe<Scalars['Float']['input']>;
  targetHangDays?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneStatePayload = {
  __typename?: 'UpdateOneStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneTenantPayload = {
  __typename?: 'UpdateOneTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  box_image_url?: InputMaybe<Scalars['String']['input']>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact_verified_at?: InputMaybe<Scalars['Date']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['JSON']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<InputMaybe<UpdateOneUserNotificationPreferencesInput>>>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  previousSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UpdateOneUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateOneUserSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  stripeCustomerIds?: InputMaybe<Scalars['JSON']['input']>;
  stripe_customers?: InputMaybe<Scalars['JSON']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  welcome_sent_at?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneUserNotificationPreferencesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneUserPayload = {
  __typename?: 'UpdateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneUserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneUserSettingsInput = {
  calendar?: InputMaybe<UpdateOneUserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<UpdateOneUserSettingsHangTimePreferencesInput>>>;
};

export type UpdateOneVendorInput = {
  address?: InputMaybe<UpdateOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  inHouseProducer?: InputMaybe<Scalars['MongoID']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<UpdateOneVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneVendorModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneVendorModulePayload = {
  __typename?: 'UpdateOneVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<VendorModule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneVendorPayload = {
  __typename?: 'UpdateOneVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type UpdateOneWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumWaitlistInspectionLevel>;
  linkedJob?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumWaitlistStatus>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneWaitlistPayload = {
  __typename?: 'UpdateOneWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdatePhoneNumberSmsWebhookInput = {
  vendorId: Scalars['String']['input'];
};

export type UpdatePhoneNumberSmsWebhookResponse = {
  __typename?: 'UpdatePhoneNumberSmsWebhookResponse';
  error?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProcessorSettingsWithCustomCapacity = {
  __typename?: 'UpdateProcessorSettingsWithCustomCapacity';
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  processorSettings?: Maybe<ProcessorSettings>;
};

export type UpdateProcessorSettingsWithCustomCapacityInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  acceptsInPersonDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsAnimalSettings>>>;
  autoCarcassNumberSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoCarcassNumberSettingsInput>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingInput>>>;
  capacityConfigurationType?: InputMaybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  customCapacities?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsCustomCapacityInput>>>;
  documentSettings?: InputMaybe<DocumentSettingsInput>;
  hangTimeSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsHangTimeInput>>>;
  invoicing?: InputMaybe<CreateProcessorSettingsInvoicingInput>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processorSettingsId: Scalars['MongoID']['input'];
  refundDeadlineDays: Scalars['Int']['input'];
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  sendWeeklySummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  timeTrackingConfig?: InputMaybe<TimeTrackingConfigInput>;
  vendor: Scalars['MongoID']['input'];
};

export type UpsertProcessorSettingsAnimalSettings = {
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['input'];
  maxSchedulingDays?: InputMaybe<Scalars['Int']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Int']['input']>;
  rebooking?: InputMaybe<ProcessorSettingsAnimalRebookingInput>;
  requestDropoffConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertProcessorSettingsCustomCapacityInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityBlockInput>>>;
  date: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID']['output'];
  access_token?: Maybe<Scalars['String']['output']>;
  account_locked_until?: Maybe<Scalars['Date']['output']>;
  active_vendor?: Maybe<Vendor>;
  address?: Maybe<Address>;
  auth_method?: Maybe<EnumUserAuth_Method>;
  banner_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  box_image_url?: Maybe<Scalars['String']['output']>;
  can_receive_email_updates?: Maybe<Scalars['Boolean']['output']>;
  can_receive_sms?: Maybe<Scalars['Boolean']['output']>;
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cognito_username?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contact_verified_at?: Maybe<Scalars['Date']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  externalIds?: Maybe<Scalars['JSON']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  failed_auth_attempts?: Maybe<Scalars['Float']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  intercomWebToken?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  last_auth_at?: Maybe<Scalars['Date']['output']>;
  last_login?: Maybe<Scalars['Float']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  latestDropoffDate?: Maybe<Scalars['Date']['output']>;
  notificationPreferences?: Maybe<Array<Maybe<UserNotificationPreferences>>>;
  password_reset_required?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
  previousSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  privacy_policy_accepted_at?: Maybe<Scalars['Date']['output']>;
  rebookingIntervalSource?: Maybe<Scalars['String']['output']>;
  rebookingStatus?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  relationships?: Maybe<Array<Maybe<UserRelationships>>>;
  role?: Maybe<EnumUserRole>;
  settings?: Maybe<UserSettings>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumUserStatus>;
  stripeCustomerIds?: Maybe<Scalars['JSON']['output']>;
  stripe_customers?: Maybe<Scalars['JSON']['output']>;
  tenant?: Maybe<Tenant>;
  tos_accepted_at?: Maybe<Scalars['Date']['output']>;
  welcome_sent_at?: Maybe<Scalars['Date']['output']>;
};

export type UserBasicUpsertPayload = {
  __typename?: 'UserBasicUpsertPayload';
  message?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserNotificationPreferences = {
  __typename?: 'UserNotificationPreferences';
  category: Scalars['String']['output'];
  email?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Boolean']['output']>;
};

export type UserNotificationPreferencesInput = {
  category: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationSummarySendResult = {
  __typename?: 'UserNotificationSummarySendResult';
  queued: Scalars['Int']['output'];
  totalUnread: Scalars['Int']['output'];
};

/** List of items with pagination. */
export type UserPagination = {
  __typename?: 'UserPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserRelationships = {
  __typename?: 'UserRelationships';
  createdAt?: Maybe<Scalars['Date']['output']>;
  producer?: Maybe<User>;
  producerId?: Maybe<Scalars['MongoID']['output']>;
  source?: Maybe<EnumUserRelationshipsSource>;
  type?: Maybe<EnumUserRelationshipsType>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type UserRelationshipsInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumUserRelationshipsSource>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  calendar?: Maybe<UserSettingsCalendar>;
  hangTimePreferences?: Maybe<Array<Maybe<UserSettingsHangTimePreferences>>>;
};

export type UserSettingsByUserId = {
  __typename?: 'UserSettingsByUserId';
  settings?: Maybe<UserSettings>;
};

export type UserSettingsCalendar = {
  __typename?: 'UserSettingsCalendar';
  calendarView?: Maybe<Scalars['String']['output']>;
  dateConfiguration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAllEvents?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSettingsHangTimePreferences = {
  __typename?: 'UserSettingsHangTimePreferences';
  _id?: Maybe<Scalars['MongoID']['output']>;
  preferredDays?: Maybe<Scalars['Float']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type UserSettingsHangTimePreferencesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  preferredDays?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UserSettingsInput = {
  calendar?: InputMaybe<UserSettingsCalendarInput>;
  hangTimePreferences?: InputMaybe<Array<InputMaybe<UserSettingsHangTimePreferencesInput>>>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  _id: Scalars['MongoID']['output'];
  address: Address;
  annualHangingWeightThroughput?: Maybe<Scalars['Float']['output']>;
  date_created: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_ids?: Maybe<Scalars['JSON']['output']>;
  free_shipping_amount?: Maybe<Scalars['Float']['output']>;
  inHouseProducer?: Maybe<Scalars['MongoID']['output']>;
  integrations: Array<Integration>;
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  modules: Array<VendorModule>;
  pickup_days?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prefers_dropoff?: Maybe<Scalars['Boolean']['output']>;
  processorSettings?: Maybe<ProcessorSettings>;
  products?: Maybe<Array<Maybe<Product>>>;
  shop_name: Scalars['String']['output'];
  shop_slug?: Maybe<Scalars['String']['output']>;
  shop_url?: Maybe<Scalars['String']['output']>;
  show_in_directory: Scalars['Boolean']['output'];
  stripe_config?: Maybe<Scalars['JSON']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  twilioPhoneConfig?: Maybe<VendorTwilioPhoneConfig>;
  zone?: Maybe<Scalars['Float']['output']>;
};


export type VendorIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type VendorModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorModuleInput>;
};


export type VendorProcessorSettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};

export type VendorModule = {
  __typename?: 'VendorModule';
  _id: Scalars['MongoID']['output'];
  active: Scalars['Boolean']['output'];
  href: Scalars['String']['output'];
  label: Scalars['String']['output'];
  moduleType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type VendorModulePagination = {
  __typename?: 'VendorModulePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<VendorModule>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type VendorNudgeSectionBuyerPayload = {
  __typename?: 'VendorNudgeSectionBuyerPayload';
  nudgeCase: Scalars['String']['output'];
  nudgedAt: Scalars['Date']['output'];
  splitId: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type VendorPagination = {
  __typename?: 'VendorPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Vendor>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type VendorSyncInHouseProducerResult = {
  __typename?: 'VendorSyncInHouseProducerResult';
  changed: Array<Scalars['String']['output']>;
  unavailable: Array<Scalars['String']['output']>;
};

export type VendorTwilioPhoneConfig = {
  __typename?: 'VendorTwilioPhoneConfig';
  _id?: Maybe<Scalars['MongoID']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  hostedNumberOrderSid?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  phoneNumberStatus?: Maybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: Maybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type VendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type VoidInvoiceInput = {
  id: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Waitlist = {
  __typename?: 'Waitlist';
  _id: Scalars['MongoID']['output'];
  animal: EnumWaitlistAnimal;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: Maybe<Scalars['Date']['output']>;
  headCount?: Maybe<Scalars['Float']['output']>;
  inspectionLevel?: Maybe<EnumWaitlistInspectionLevel>;
  linkedJob?: Maybe<ProcessorScheduling>;
  producer?: Maybe<User>;
  sendWaitlistEmail?: Maybe<Scalars['Boolean']['output']>;
  sendWaitlistSMS?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: Maybe<Scalars['Date']['output']>;
  status: EnumWaitlistStatus;
  unsubscribeToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
  vendorRef?: Maybe<Vendor>;
};

/** List of items with pagination. */
export type WaitlistPagination = {
  __typename?: 'WaitlistPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Waitlist>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WeightedAnimalComplexAnimalCapacitySchema = {
  __typename?: 'WeightedAnimalComplexAnimalCapacitySchema';
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ProcessingPartnersOne = {
  __typename?: 'processingPartnersOne';
  _id?: Maybe<Scalars['MongoID']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  animalSettings?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettings>>>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  buyerBio?: Maybe<Scalars['String']['output']>;
  buyerChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  capacityConfigurationType?: Maybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: Maybe<Array<Maybe<ProcessorSettingsCapacitySettings>>>;
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsSpecies>>>;
  faq?: Maybe<Scalars['String']['output']>;
  hangTimeSettings?: Maybe<Array<Maybe<ProcessorSettingsHangTimeSettings>>>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  killAndChillSettings?: Maybe<Array<Maybe<ProcessorSettingsKillAndChillSettings>>>;
  pickupLocations?: Maybe<Array<Maybe<StorefrontPickupLocation>>>;
  premierProducers?: Maybe<Array<Maybe<ProcessingPartnerPremierProducer>>>;
  refundDeadlineDays: Scalars['Int']['output'];
  schedulingDeposit?: Maybe<Scalars['Float']['output']>;
  showCommunityListings?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  storefrontProducers?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  vendor?: Maybe<ProcessingPartnerVendor>;
};

export type AddressFragmentFragment = { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any };

export type CapabilitySpecificationFragment = { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null };

export type ChatMessageFragmentFragment = { __typename?: 'ChatMessage', _id: any, content?: string | null, imageUrl?: string | null, isNotification?: boolean | null, animal?: any | null, animalSpecies?: string | null, readAt?: any | null, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, notificationPrompt?: { __typename?: 'NotificationPromptState', _id: string, kind: string, status: string, canAnswer: boolean, jobId?: string | null, expiresAt?: any | null } | null, sender?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null };

export type ChatRoomFragmentFragment = { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, unreadMessagesCount: number, markedUnread: boolean, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, picture_url?: string | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null };

export type CutsheetAssignmentRuleSetFragmentFragment = { __typename?: 'CutsheetAssignmentRuleSet', _id: any, vendor: any, capabilityId: any, defaultQuestionnaireId?: any | null, createdAt?: any | null, updatedAt?: any | null, rules?: Array<{ __typename?: 'CutsheetAssignmentRuleSetRules', sortOrder: number, label?: string | null, inspectionLevel?: Array<EnumCutsheetAssignmentRuleSetRulesInspectionLevel | null> | null, splitType?: Array<EnumCutsheetAssignmentRuleSetRulesSplitType | null> | null, splitIndex?: Array<number | null> | null, producer?: Array<any | null> | null, buyer?: Array<any | null> | null, questionnaireId: any } | null> | null };

export type CutsheetCapabilityFragmentFragment = { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null };

export type CutsheetCapabilityOptionFragmentFragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null };

export type CutsheetCapabilityCutFragmentFragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null };

export type CutsheetDescriptionLibraryFragmentFragment = { __typename?: 'CutsheetDescriptionLibrary', _id: any, name: string, description: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null };

export type CutsheetCapabilityExtraFragmentFragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null };

export type CutsheetFragmentFragment = { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null };

export type CutsheetCapabilityGroupFragmentFragment = { __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null };

export type CutsheetImageLibraryFragmentFragment = { __typename?: 'CutsheetImageLibrary', _id: any, name: string, imageUrl: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null };

export type CutsheetQuestionnaireFragmentFragment = { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, pricePerPound?: number | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, processingFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, killFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, additionalCharges?: Array<{ __typename?: 'CutsheetQuestionnaireAdditionalCharges', id?: string | null, label: string, amount: number, priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType, basis: EnumCutsheetQuestionnaireAdditionalChargesBasis, description?: string | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetQuestionnairePrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetQuestionnairePrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetQuestionnairePrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null };

export type CutsheetCapabilitySpecificationFragmentFragment = { __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null };

export type CutsheetCapabilityTrimFragmentV2Fragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null };

export type DocumentFragmentFragment = { __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null };

export type ExtrasFragmentFragment = { __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null };

export type InvoiceFragmentLineItemFragment = { __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number };

export type InvoiceFragmentFragment = { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null };

export type LandingPageFragmentFragment = { __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, slug?: string | null, species?: Array<EnumLandingPageSettingsSpecies | null> | null, about?: string | null, buyerBio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, tagline?: string | null, logoUrl?: string | null, showAddress?: boolean | null, showOnMap?: boolean | null, showInDirectory?: boolean | null, showAbout?: boolean | null, showContact?: boolean | null, showPricing?: boolean | null, showGallery?: boolean | null, showDocuments?: boolean | null, showFaq?: boolean | null, galleryImages?: Array<string | null> | null, premierProducers?: Array<{ __typename?: 'LandingPageSettingsPremierProducers', producerId: any, badge: EnumLandingPageSettingsPremierProducersBadge } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, type: EnumAddressType } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null, pricingRows?: Array<{ __typename?: 'LandingPageSettingsPricingRows', _id?: any | null, label: string, price?: number | null, unit?: string | null, notes?: string | null } | null> | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null } | null, documents?: Array<{ __typename?: 'LandingPageSettingsDocuments', _id?: any | null, name: string, description?: string | null, fileUrl: string } | null> | null, faq?: Array<{ __typename?: 'LandingPageSettingsFaq', _id?: any | null, question: string, answer: string } | null> | null };

export type NoteFragmentFragment = { __typename?: 'Note', _id: any, note?: string | null, type: EnumNoteType, animalHead?: any | null, createdAt?: any | null, updatedAt?: any | null, attachments?: Array<{ __typename?: 'NoteAttachments', url: string, filename: string, mimeType?: string | null } | null> | null, createdBy?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null };

export type NotificationSettingFragmentFragment = { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, requestConfirmation?: boolean | null, confirmationMessage?: string | null, defaultConfirmationMessage?: string | null, sendEmail?: boolean | null, sendSMS?: boolean | null, sendInApp?: boolean | null, preferredChannel?: EnumNotificationSettingPreferredChannel | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null };

export type PrimalCutBlockerFragmentFragment = { __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null };

export type PrimalCutFragmentFragment = { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null };

export type ProcessorCapabilityFragmentFragment = { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null };

export type ContactUserFragment = { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null };

export type SplitFragment = { __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null };

export type AnimalHeadFragment = { __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, sendNotifications?: boolean | null, status?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, statusChanges?: Array<{ __typename?: 'AnimalStatusChange', date?: any | null, previousStatus?: string | null, newStatus?: string | null, changedByName?: string | null } | null> | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, settlementStatus?: { __typename?: 'SplitSettlementView', billable: boolean, progress?: string | null, ready: boolean, collected: boolean, settled: boolean, invoiced: boolean, invoiceId?: any | null, invoiceNumber?: string | null, invoiceStatus?: string | null, settlementMethod?: string | null, payerLabel?: string | null, payerParty?: string | null, producerSettled?: boolean | null } | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null };

export type ProcessorSchedulingFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, recurringSeries?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, sendNotifications?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, hasCutsheetNeededNotification?: boolean | null, hasCutsheetReminderNotification?: boolean | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, additionalPickupDetails?: string | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus, changedByName?: string | null } | null> | null, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationVia, respondedByName?: string | null } | null, customerConfirmationHistory?: Array<{ __typename?: 'ProcessorSchedulingCustomerConfirmationHistory', status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationHistoryVia, respondedByName?: string | null } | null> | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, sendNotifications?: boolean | null, status?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, statusChanges?: Array<{ __typename?: 'AnimalStatusChange', date?: any | null, previousStatus?: string | null, newStatus?: string | null, changedByName?: string | null } | null> | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, settlementStatus?: { __typename?: 'SplitSettlementView', billable: boolean, progress?: string | null, ready: boolean, collected: boolean, settled: boolean, invoiced: boolean, invoiceId?: any | null, invoiceNumber?: string | null, invoiceStatus?: string | null, settlementMethod?: string | null, payerLabel?: string | null, payerParty?: string | null, producerSettled?: boolean | null } | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null };

export type ProcessorSchedulingCalendarFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, sendNotifications?: boolean | null, recurringSeries?: any | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, kind?: EnumSplitKind | null, isDeleted?: boolean | null, locked?: boolean | null, buyer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null } | null> | null } | null> | null };

export type ProcessorSchedulingSlimFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, status?: string | null } | null> | null };

export type DailyCapacityFragmentFragment = { __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null };

export type DailyCapacityBlockFragmentFragment = { __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null };

export type ProcessorSettingsFragmentFragment = { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null };

export type ProcessorSettingsCustomCapacityFragmentFragment = { __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null };

export type ParentProductFragment = { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null };

export type ProductFragmentFragment = { __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null };

export type TenantFragmentFragment = { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> };

export type TrimFragmentFragment = { __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection };

export type UserFragmentFragment = { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, slug?: string | null, picture_url?: string | null, banner_url?: string | null, box_image_url?: string | null, bio?: string | null, role?: EnumUserRole | null, enabled: boolean, auth_method?: EnumUserAuth_Method | null, can_receive_sms?: boolean | null, can_receive_email_updates?: boolean | null, _id: any, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }>, tenant?: { __typename?: 'Tenant', _id: any, picture_url?: string | null } | null } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null };

export type VendorFragmentFragment = { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null };

export type WaitlistFragmentFragment = { __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null };

export type AdminUserUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  address?: InputMaybe<AdminUserAddressInput>;
  relationships?: InputMaybe<Array<InputMaybe<AdminUserRelationshipInput>> | InputMaybe<AdminUserRelationshipInput>>;
}>;


export type AdminUserUpdateMutation = { __typename?: 'Mutation', adminUserUpdate?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, role?: EnumUserRole | null, enabled: boolean, tenant?: { __typename?: 'Tenant', _id: any, name: string } | null, active_vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null };

export type IntegrationCreateOneMutationVariables = Exact<{
  record: CreateOneIntegrationInput;
}>;


export type IntegrationCreateOneMutation = { __typename?: 'Mutation', integrationCreateOne?: { __typename?: 'CreateOneIntegrationPayload', recordId?: any | null, record?: { __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, _id: any } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type IntegrationUpdateConfigMutationVariables = Exact<{
  integrationId: Scalars['MongoID']['input'];
  config: Scalars['JSON']['input'];
}>;


export type IntegrationUpdateConfigMutation = { __typename?: 'Mutation', integrationUpdateById?: { __typename?: 'UpdateByIdIntegrationPayload', recordId?: any | null } | null };

export type LandingPageRemoveByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type LandingPageRemoveByIdMutation = { __typename?: 'Mutation', landingPageRemoveById?: { __typename?: 'RemoveByIdLandingPageSettingsPayload', recordId?: any | null } | null };

export type MarketplaceLeadExportCsvMutationVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketplaceLeadExportCsvMutation = { __typename?: 'Mutation', marketplaceLeadExportCsv?: { __typename?: 'MarketplaceLeadExportCsvResponse', file: string, filename: string } | null };

export type ProcessorSettingsUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
}>;


export type ProcessorSettingsUpdateByIdMutation = { __typename?: 'Mutation', processorSettingsUpdateById?: { __typename?: 'UpdateByIdProcessorSettingsPayload', recordId?: any | null } | null };

export type TenantCreateMutationVariables = Exact<{
  newTenant: CreateOneTenantInput;
}>;


export type TenantCreateMutation = { __typename?: 'Mutation', tenantCreate?: { __typename?: 'Tenant', external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, _id: any } | null };

export type TenantEnabledEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type TenantEnabledEditMutation = { __typename?: 'Mutation', tenantEnabledEdit?: { __typename?: 'Tenant', _id: any, enabled: boolean } | null };

export type TenantPictureUrlEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  pictureImage?: InputMaybe<Scalars['Upload']['input']>;
  pictureImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TenantPictureUrlEditMutation = { __typename?: 'Mutation', tenantPictureUrlEdit?: { __typename?: 'Tenant', external_id?: string | null, name: string, enabled: boolean, _id: any, picture_url?: string | null } | null };

export type TenantSubscriptionEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  subscription: Scalars['String']['input'];
}>;


export type TenantSubscriptionEditMutation = { __typename?: 'Mutation', tenantSubscriptionEdit?: { __typename?: 'Tenant', external_id?: string | null, external_ids?: any | null, name: string, email: string, date_created: any, picture_url?: string | null, primary_color?: string | null, domain?: string | null, enabled: boolean, _id: any } | null };

export type UserActivateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserActivateMutation = { __typename?: 'Mutation', userActivate?: { __typename?: 'User', external_id?: string | null, enabled: boolean, first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, _id: any } | null };

export type UserCreateMutationVariables = Exact<{
  newUser: CreateOneUserInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, access_token?: string | null, refresh_token?: string | null, last_login?: number | null, _id: any } | null };

export type UserDeactivateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserDeactivateMutation = { __typename?: 'Mutation', userDeactivate?: { __typename?: 'User', external_id?: string | null, enabled: boolean, first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, _id: any } | null };

export type UserNotificationSummarySendMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type UserNotificationSummarySendMutation = { __typename?: 'Mutation', userNotificationSummarySend?: { __typename?: 'UserNotificationSummarySendResult', queued: number, totalUnread: number } | null };

export type VendorCreateMutationVariables = Exact<{
  newVendor: CreateOneVendorInput;
}>;


export type VendorCreateMutation = { __typename?: 'Mutation', vendorCreate?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, tagline?: string | null, enabled: boolean, annualHangingWeightThroughput?: number | null, _id: any } | null };

export type VendorModuleUpsertMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  moduleType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  label: Scalars['String']['input'];
  href: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  active: Scalars['Boolean']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type VendorModuleUpsertMutation = { __typename?: 'Mutation', vendorModuleUpsert?: { __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null } | null };

export type VendorUpdateByIdMutationVariables = Exact<{
  record: UpdateByIdVendorInput;
  _id: Scalars['MongoID']['input'];
}>;


export type VendorUpdateByIdMutation = { __typename?: 'Mutation', vendorUpdateById?: { __typename?: 'UpdateByIdVendorPayload', record?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null } | null };

export type ApplyCutsheetCatalogChangesMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  changes: Array<CutsheetProposedChangeInput> | CutsheetProposedChangeInput;
}>;


export type ApplyCutsheetCatalogChangesMutation = { __typename?: 'Mutation', applyCutsheetCatalogChanges?: { __typename?: 'CutsheetApplyCatalogChangesPayload', catalogChanged: boolean, actions: Array<{ __typename?: 'CutsheetChatAction', kind: string, label: string, itemType: string, itemId?: string | null }> } | null };

export type ApplyCutsheetQuestionnaireChangesMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  questions: Scalars['JSON']['input'];
  changes: Array<CutsheetProposedChangeInput> | CutsheetProposedChangeInput;
}>;


export type ApplyCutsheetQuestionnaireChangesMutation = { __typename?: 'Mutation', applyCutsheetQuestionnaireChanges?: { __typename?: 'CutsheetApplyQuestionnaireChangesPayload', changed: boolean, questions?: any | null, actions: Array<{ __typename?: 'CutsheetChatAction', kind: string, label: string, itemType: string, itemId?: string | null }> } | null };

export type AuthCheckUserMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  clientOrigin?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthCheckUserMutation = { __typename?: 'Mutation', authCheckUser?: { __typename?: 'AuthCheckUserPayload', exists: boolean, authMethod?: string | null, requiresPasswordReset?: boolean | null, redirectUrl?: string | null, otpSent?: boolean | null, session?: string | null, message?: string | null, resetCodeSent?: boolean | null, resetDestination?: string | null } | null };

export type AuthLoginOAuthMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;


export type AuthLoginOAuthMutation = { __typename?: 'Mutation', authLoginOAuth?: { __typename?: 'AuthLoginOAuthPayload', accessToken: string, idToken: string, refreshToken: string, expiresIn: number } | null };

export type AuthLoginPasswordMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AuthLoginPasswordMutation = { __typename?: 'Mutation', authLoginPassword?: { __typename?: 'AuthLoginPasswordPayload', accessToken?: string | null, idToken?: string | null, refreshToken?: string | null, expiresIn?: number | null } | null };

export type AuthRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type AuthRefreshTokenMutation = { __typename?: 'Mutation', authRefreshToken?: { __typename?: 'AuthRefreshTokenPayload', accessToken: string, idToken: string, expiresIn: number } | null };

export type AuthRegisterAndSignInMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  acceptTos: Scalars['Boolean']['input'];
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AuthRegisterAndSignInMutation = { __typename?: 'Mutation', authRegisterAndSignIn?: { __typename?: 'AuthRegisterAndSignInPayload', status: string, accessToken?: string | null, idToken?: string | null, refreshToken?: string | null, session?: string | null, userId?: any | null, message?: string | null } | null };

export type AuthRegisterMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AuthRegisterMutation = { __typename?: 'Mutation', authRegister?: { __typename?: 'AuthRegisterPayload', success: boolean, userId?: any | null, email?: string | null, phone?: string | null, message?: string | null } | null };

export type AuthSendOtpMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type AuthSendOtpMutation = { __typename?: 'Mutation', authSendOTP?: { __typename?: 'AuthSendOTPPayload', success: boolean, message: string, session?: string | null } | null };

export type AuthVerifyOtpMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthVerifyOtpMutation = { __typename?: 'Mutation', authVerifyOTP?: { __typename?: 'AuthVerifyOTPPayload', accessToken?: string | null, idToken?: string | null, refreshToken?: string | null, expiresIn?: number | null, requiresProfileCompletion?: boolean | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', success: boolean, message: string } | null };

export type BookingDepositPaymentIntentCreateMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  headCount: Scalars['Int']['input'];
  species: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookingDepositPaymentIntentCreateMutation = { __typename?: 'Mutation', bookingDepositPaymentIntentCreate?: { __typename?: 'BookingDepositPaymentIntentResponse', clientSecret: string, connectedAccountId: string, paymentIntentId: string, amount: number } | null };

export type BuildCutsheetCatalogMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  capabilityId: Scalars['MongoID']['input'];
}>;


export type BuildCutsheetCatalogMutation = { __typename?: 'Mutation', buildCutsheetCatalog?: { __typename?: 'BuildCutsheetCatalogPayload', capabilityId: any, catalogName: string, animalType: string, primalsCount: number, cutsCount: number, trimCount: number, extrasCount: number, specificationsCount: number } | null };

export type BuyerAddAnimalSectionMutationVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  pickupLocationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type BuyerAddAnimalSectionMutation = { __typename?: 'Mutation', buyerAddAnimalSection?: { __typename?: 'Split', _id: any, splitPart?: string | null, status?: EnumSplitStatus | null } | null };

export type BuyerCancelSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type BuyerCancelSplitMutation = { __typename?: 'Mutation', buyerCancelSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null } | null };

export type BuyerClaimSplitMutationVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  pickupLocationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type BuyerClaimSplitMutation = { __typename?: 'Mutation', buyerClaimSplit?: { __typename?: 'Split', _id: any, splitPart?: string | null, status?: EnumSplitStatus | null } | null };

export type BuyerCreateBalanceCheckoutMutationVariables = Exact<{
  orderId: Scalars['MongoID']['input'];
}>;


export type BuyerCreateBalanceCheckoutMutation = { __typename?: 'Mutation', buyerCreateBalanceCheckout?: { __typename?: 'BuyerBalanceCheckoutResponse', clientSecret: string, sessionId: string, balanceDue: number, processorName?: string | null } | null };

export type BuyerCreateCombinedSettlementIntentMutationVariables = Exact<{
  orderId: Scalars['MongoID']['input'];
}>;


export type BuyerCreateCombinedSettlementIntentMutation = { __typename?: 'Mutation', buyerCreateCombinedSettlementIntent?: { __typename?: 'BuyerCreateCombinedSettlementIntentResponse', clientSecret: string, amountDue: number, chargeableParties?: Array<string> | null, savedPaymentMethods?: Array<{ __typename?: 'BuyerCombinedSettlementSavedPaymentMethod', id: string, brand?: string | null, last4?: string | null, expMonth?: number | null, expYear?: number | null } | null> | null } | null };

export type BuyerCreateDepositCheckoutMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  inline?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BuyerCreateDepositCheckoutMutation = { __typename?: 'Mutation', buyerCreateDepositCheckout?: { __typename?: 'BuyerDepositCheckoutResponse', clientSecret: string, sessionId: string, depositAmount: number, listingFee: number, total: number, splitPart: string, processorName?: string | null, species?: string | null, expiresAt: number } | null };

export type BuyerInterestUnsubscribeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type BuyerInterestUnsubscribeMutation = { __typename?: 'Mutation', buyerInterestUnsubscribe: boolean };

export type BuyerPayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['MongoID']['input'];
}>;


export type BuyerPayInvoiceMutation = { __typename?: 'Mutation', buyerPayInvoice?: { __typename?: 'BuyerPayInvoiceResponse', status: string, clientSecret?: string | null, connectedAccountId: string, amountDue?: number | null } | null };

export type BuyerRegisterInterestMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
}>;


export type BuyerRegisterInterestMutation = { __typename?: 'Mutation', buyerRegisterInterest?: { __typename?: 'MarketplaceInterest', _id: any, species: EnumMarketplaceInterestSpecies, createdAt?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null } | null };

export type BuyerRegisterProducerInterestMutationVariables = Exact<{
  producerId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
}>;


export type BuyerRegisterProducerInterestMutation = { __typename?: 'Mutation', buyerRegisterProducerInterest?: { __typename?: 'MarketplaceInterest', _id: any, species: EnumMarketplaceInterestSpecies, createdAt?: any | null, producer?: { __typename?: 'User', _id: any } | null } | null };

export type BuyerRemoveInterestMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
}>;


export type BuyerRemoveInterestMutation = { __typename?: 'Mutation', buyerRemoveInterest?: { __typename?: 'MarketplaceInterest', _id: any, species: EnumMarketplaceInterestSpecies, createdAt?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null } | null };

export type BuyerRemoveProducerInterestMutationVariables = Exact<{
  producerId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
}>;


export type BuyerRemoveProducerInterestMutation = { __typename?: 'Mutation', buyerRemoveProducerInterest?: { __typename?: 'MarketplaceInterest', _id: any, species: EnumMarketplaceInterestSpecies, createdAt?: any | null, producer?: { __typename?: 'User', _id: any } | null } | null };

export type BuyerSubmitRequestMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
  splitType: Scalars['String']['input'];
  desiredPickupDate?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type BuyerSubmitRequestMutation = { __typename?: 'Mutation', buyerSubmitRequest?: { __typename?: 'MarketplaceRequest', _id: any, species: EnumMarketplaceRequestSpecies, splitType: EnumMarketplaceRequestSplitType, desiredPickupDate?: string | null, note?: string | null, active?: boolean | null, createdAt?: any | null } | null };

export type BuyerSyncBalanceCheckoutMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type BuyerSyncBalanceCheckoutMutation = { __typename?: 'Mutation', buyerSyncBalanceCheckout?: { __typename?: 'BuyerSyncBalanceCheckoutResponse', status: string, orderStatus?: string | null } | null };

export type BuyerSyncCombinedSettlementMutationVariables = Exact<{
  orderId: Scalars['MongoID']['input'];
}>;


export type BuyerSyncCombinedSettlementMutation = { __typename?: 'Mutation', buyerSyncCombinedSettlement?: { __typename?: 'BuyerSyncCombinedSettlementResponse', status: string } | null };

export type BuyerSyncDepositCheckoutMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type BuyerSyncDepositCheckoutMutation = { __typename?: 'Mutation', buyerSyncDepositCheckout?: { __typename?: 'BuyerSyncDepositCheckoutResponse', status: string, splitStatus?: string | null, depositStatus?: string | null } | null };

export type CalendarEventCreateOneMutationVariables = Exact<{
  record: CreateOneCalendarEventInput;
}>;


export type CalendarEventCreateOneMutation = { __typename?: 'Mutation', calendarEventCreateOne?: { __typename?: 'CreateOneCalendarEventPayload', record?: { __typename?: 'CalendarEvent', _id: any, vendor: any, eventType: any, title: string, date: any, description?: string | null } | null } | null };

export type CalendarEventRemoveByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CalendarEventRemoveByIdMutation = { __typename?: 'Mutation', calendarEventRemoveById?: { __typename?: 'RemoveByIdCalendarEventPayload', recordId?: any | null } | null };

export type CalendarEventTypeCreateOneMutationVariables = Exact<{
  record: CreateOneCalendarEventTypeInput;
}>;


export type CalendarEventTypeCreateOneMutation = { __typename?: 'Mutation', calendarEventTypeCreateOne?: { __typename?: 'CreateOneCalendarEventTypePayload', record?: { __typename?: 'CalendarEventType', _id: any, vendor: any, title: string, color: string, isEnabled: boolean, sortOrder?: number | null } | null } | null };

export type CalendarEventTypeRemoveByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CalendarEventTypeRemoveByIdMutation = { __typename?: 'Mutation', calendarEventTypeRemoveById?: { __typename?: 'RemoveByIdCalendarEventTypePayload', recordId?: any | null } | null };

export type CalendarEventTypeUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCalendarEventTypeInput;
}>;


export type CalendarEventTypeUpdateByIdMutation = { __typename?: 'Mutation', calendarEventTypeUpdateById?: { __typename?: 'UpdateByIdCalendarEventTypePayload', record?: { __typename?: 'CalendarEventType', _id: any, vendor: any, title: string, color: string, isEnabled: boolean, sortOrder?: number | null } | null } | null };

export type CalendarEventUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCalendarEventInput;
}>;


export type CalendarEventUpdateByIdMutation = { __typename?: 'Mutation', calendarEventUpdateById?: { __typename?: 'UpdateByIdCalendarEventPayload', record?: { __typename?: 'CalendarEvent', _id: any, vendor: any, eventType: any, title: string, date: any, description?: string | null } | null } | null };

export type CarcassTagPreviewMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type CarcassTagPreviewMutation = { __typename?: 'Mutation', carcassTagPreview?: { __typename?: 'CarcassTagPreviewResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ChatRoomCreateOneMutationVariables = Exact<{
  record: CreateOneChatRoomInput;
}>;


export type ChatRoomCreateOneMutation = { __typename?: 'Mutation', chatRoomCreateOne?: { __typename?: 'CreateOneChatRoomPayload', recordId?: any | null, record?: { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, unreadMessagesCount: number, markedUnread: boolean, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, picture_url?: string | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null } | null } | null };

export type CreateProcessorSchedulingMutationVariables = Exact<{
  newSchedule: CreateProcessorSchedulingInput;
}>;


export type CreateProcessorSchedulingMutation = { __typename?: 'Mutation', processorSchedulingCreate?: { __typename?: 'CreateProcessorScheduleResponse', messages?: Array<string | null> | null, scheduling: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, recurringSeries?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, sendNotifications?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, hasCutsheetNeededNotification?: boolean | null, hasCutsheetReminderNotification?: boolean | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, additionalPickupDetails?: string | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus, changedByName?: string | null } | null> | null, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationVia, respondedByName?: string | null } | null, customerConfirmationHistory?: Array<{ __typename?: 'ProcessorSchedulingCustomerConfirmationHistory', status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationHistoryVia, respondedByName?: string | null } | null> | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, sendNotifications?: boolean | null, status?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, statusChanges?: Array<{ __typename?: 'AnimalStatusChange', date?: any | null, previousStatus?: string | null, newStatus?: string | null, changedByName?: string | null } | null> | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, settlementStatus?: { __typename?: 'SplitSettlementView', billable: boolean, progress?: string | null, ready: boolean, collected: boolean, settled: boolean, invoiced: boolean, invoiceId?: any | null, invoiceNumber?: string | null, invoiceStatus?: string | null, settlementMethod?: string | null, payerLabel?: string | null, payerParty?: string | null, producerSettled?: boolean | null } | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null }, bookingFollowUp?: { __typename?: 'BookingFollowUp', date: string, dayCapacity: number, daySpotsRemaining: number, nextOpenDate?: string | null } | null } | null };

export type CsvImportCancelJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
}>;


export type CsvImportCancelJobMutation = { __typename?: 'Mutation', csvImportCancelJob?: { __typename?: 'CSVImportCancelJobPayload', jobId: string, status: string, cancelledAt: any, cancelledAtStage: string, message: string } | null };

export type CsvImportDeleteRecordMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
}>;


export type CsvImportDeleteRecordMutation = { __typename?: 'Mutation', csvImportDeleteRecord?: { __typename?: 'CSVImportDeleteRecordPayload', jobId: string, deletedRows: Array<number>, validRows: number } | null };

export type CsvImportExecuteMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CsvImportExecuteMutation = { __typename?: 'Mutation', csvImportExecute?: { __typename?: 'CSVImportExecutePayload', jobId: string, status: string, message?: string | null } | null };

export type CsvImportRevalidateMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
}>;


export type CsvImportRevalidateMutation = { __typename?: 'Mutation', csvImportRevalidate?: { __typename?: 'CSVImportRevalidatePayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string> }> } | null };

export type CsvImportSaveColumnMappingMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  columnMapping: Scalars['JSON']['input'];
}>;


export type CsvImportSaveColumnMappingMutation = { __typename?: 'Mutation', csvImportSaveColumnMapping?: { __typename?: 'CSVImportSaveColumnMappingPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, s3Keys?: any | null, parsedData?: any | null, columns: Array<string>, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string>, warningMessages?: Array<string> | null }> } | null };

export type CsvImportUpdateRowsMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  updatedRows: Scalars['JSON']['input'];
}>;


export type CsvImportUpdateRowsMutation = { __typename?: 'Mutation', csvImportUpdateRows?: { __typename?: 'CSVImportUpdateRowsPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string>, warningMessages?: Array<string> | null }> } | null };

export type CsvImportForceCancelMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CsvImportForceCancelMutation = { __typename?: 'Mutation', csvImportForceCancel?: { __typename?: 'CSVImportForceCancelPayload', jobId: string, status: string, cancelledAt: any, message: string, warning?: string | null } | null };

export type CsvImportUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  type: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
  tenantId: Scalars['MongoID']['input'];
}>;


export type CsvImportUploadMutation = { __typename?: 'Mutation', csvImportUpload?: { __typename?: 'CSVImportUploadPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validFilePath?: string | null, invalidFilePath?: string | null, detectedColumns: Array<string>, suggestedMapping?: any | null, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string> }>, availableColumns: Array<{ __typename?: 'AvailableColumn', fieldName: string, aliases: Array<string>, required: boolean, description: string, validationRules?: string | null }> } | null };

export type CustomFieldDefinitionCreateOneMutationVariables = Exact<{
  record: CreateOneCustomFieldDefinitionInput;
}>;


export type CustomFieldDefinitionCreateOneMutation = { __typename?: 'Mutation', customFieldDefinitionCreateOne?: { __typename?: 'CreateOneCustomFieldDefinitionPayload', record?: { __typename?: 'CustomFieldDefinition', _id: any, vendor: any, modelType: EnumCustomFieldDefinitionModelType, label: string, fieldType: EnumCustomFieldDefinitionFieldType, fieldSource?: EnumCustomFieldDefinitionFieldSource | null, fieldKey?: string | null, enabled?: boolean | null, options?: Array<string | null> | null, sortOrder?: number | null, required?: boolean | null, speciesFilter: any, captureAt: EnumCustomFieldDefinitionCaptureAt, hint?: string | null } | null } | null };

export type CustomFieldDefinitionSoftDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CustomFieldDefinitionSoftDeleteMutation = { __typename?: 'Mutation', customFieldDefinitionSoftDelete?: { __typename?: 'CustomFieldDefinition', _id: any } | null };

export type CustomFieldDefinitionUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCustomFieldDefinitionInput;
}>;


export type CustomFieldDefinitionUpdateByIdMutation = { __typename?: 'Mutation', customFieldDefinitionUpdateById?: { __typename?: 'UpdateByIdCustomFieldDefinitionPayload', record?: { __typename?: 'CustomFieldDefinition', _id: any, vendor: any, modelType: EnumCustomFieldDefinitionModelType, label: string, fieldType: EnumCustomFieldDefinitionFieldType, fieldSource?: EnumCustomFieldDefinitionFieldSource | null, fieldKey?: string | null, enabled?: boolean | null, options?: Array<string | null> | null, sortOrder?: number | null, required?: boolean | null, speciesFilter: any, captureAt: EnumCustomFieldDefinitionCaptureAt, hint?: string | null } | null } | null };

export type CustomFieldValueBulkSaveMutationVariables = Exact<{
  inputs: Array<CustomFieldValueBulkInput> | CustomFieldValueBulkInput;
}>;


export type CustomFieldValueBulkSaveMutation = { __typename?: 'Mutation', customFieldValueBulkSave?: { __typename?: 'CustomFieldValueBulkSaveResponse', savedCount: number, errors?: Array<{ __typename?: 'CustomFieldValueBulkSaveError', index: number, message: string }> | null } | null };

export type CustomFieldValueClearMutationVariables = Exact<{
  inputs: Array<CustomFieldValueClearInput> | CustomFieldValueClearInput;
}>;


export type CustomFieldValueClearMutation = { __typename?: 'Mutation', customFieldValueClear?: { __typename?: 'CustomFieldValueClearResponse', deletedCount: number } | null };

export type CustomerDeleteMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type CustomerDeleteMutation = { __typename?: 'Mutation', customerDelete?: { __typename?: 'CustomerDeleteResult', operationId: any, loserSoftDeleted: boolean } | null };

export type CustomerMergeMutationVariables = Exact<{
  winnerId: Scalars['MongoID']['input'];
  loserIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
  fieldSelections?: InputMaybe<Array<CustomerMergeFieldSelectionInput> | CustomerMergeFieldSelectionInput>;
}>;


export type CustomerMergeMutation = { __typename?: 'Mutation', customerMerge?: { __typename?: 'CustomerMergeResult', operationIds: Array<any>, affectedRecordCount: number } | null };

export type CustomerNotificationPreferenceUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  category: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CustomerNotificationPreferenceUpdateMutation = { __typename?: 'Mutation', customerNotificationPreferenceUpdate?: Array<{ __typename?: 'NotificationPreference', category: string, label: string, description?: string | null, email: boolean, sms: boolean } | null> | null };

export type CutsheetAssignmentRuleSetDeleteMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetAssignmentRuleSetDeleteMutation = { __typename?: 'Mutation', cutsheetAssignmentRuleSetDelete?: boolean | null };

export type CutsheetAssignmentRuleSetUpsertMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  rules?: InputMaybe<Array<CutsheetAssignmentRuleInput> | CutsheetAssignmentRuleInput>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CutsheetAssignmentRuleSetUpsertMutation = { __typename?: 'Mutation', cutsheetAssignmentRuleSetUpsert?: { __typename?: 'CutsheetAssignmentRuleSet', _id: any, vendor: any, capabilityId: any, defaultQuestionnaireId?: any | null, createdAt?: any | null, updatedAt?: any | null, rules?: Array<{ __typename?: 'CutsheetAssignmentRuleSetRules', sortOrder: number, label?: string | null, inspectionLevel?: Array<EnumCutsheetAssignmentRuleSetRulesInspectionLevel | null> | null, splitType?: Array<EnumCutsheetAssignmentRuleSetRulesSplitType | null> | null, splitIndex?: Array<number | null> | null, producer?: Array<any | null> | null, buyer?: Array<any | null> | null, questionnaireId: any } | null> | null } | null };

export type CutsheetCapabilityDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityDeleteMutation = { __typename?: 'Mutation', CutsheetCapabilityDelete: boolean };

export type CutsheetCapabilityUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityUpsertMutation = { __typename?: 'Mutation', CutsheetCapabilityUpsert?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCapabilityDuplicateMutationVariables = Exact<{
  sourceCapabilityId: Scalars['MongoID']['input'];
  targetCapabilityId: Scalars['MongoID']['input'];
  includeQuestionnaires: Scalars['Boolean']['input'];
  includeAssignmentRules: Scalars['Boolean']['input'];
  allowCrossVendor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityDuplicateMutation = { __typename?: 'Mutation', CutsheetCapabilityDuplicate?: { __typename?: 'CutsheetCapabilityDuplicateResponse', capability?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null, summary?: { __typename?: 'CutsheetCapabilityDuplicateSummary', groupsCopied: number, optionsCopied: number, specificationsCopied: number, questionnairesCopied: number, assignmentRulesCopied: number } | null } | null };

export type CutsheetCapabilityGenerateBlankCutsheetMutationVariables = Exact<{
  cutsheetCapabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityGenerateBlankCutsheetMutation = { __typename?: 'Mutation', cutsheetCapabilityGenerateBlankCutsheet?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type CutsheetCapabilityMigrateLegacyMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  deactivateUnusedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityMigrateLegacyMutation = { __typename?: 'Mutation', CutsheetCapabilityMigrateLegacy?: { __typename?: 'CutsheetCapabilityMigrateLegacyResponse', capability?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null, summary?: { __typename?: 'CutsheetCapabilityMigrateLegacySummary', inspectionLevelsMigrated: Array<string>, groupsCreated: number, groupsReused: number, cutsCreated: number, cutsReused: number, trimsCreated: number, trimsReused: number, specificationsCreated: number, specificationsReused: number, questionnairesCreated: number, questionnairesReused: number, assignmentRulesAdded: number } | null } | null };

export type CutsheetCapabilityOptionDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityOptionDeleteMutation = { __typename?: 'Mutation', cutsheetCapabilityOptionDelete: boolean };

export type CutsheetCapabilityOptionUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityId: Scalars['MongoID']['input'];
  optionType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<CutsheetCapabilityOptionSpecificationInput> | CutsheetCapabilityOptionSpecificationInput>;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityOptionUpsertMutation = { __typename?: 'Mutation', cutsheetCapabilityOptionUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null };

export type CutsheetCapabilityPrintSettingsUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  baseFontSize: Scalars['Float']['input'];
  primalColumns: Scalars['Float']['input'];
  specsLayoutPosition: Scalars['String']['input'];
  checkboxStyle: Scalars['String']['input'];
  showAllSpecOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimalGroup: Scalars['Boolean']['input'];
  alwaysShowPrimalNotes: Scalars['Boolean']['input'];
  hideUnselectedCuts: Scalars['Boolean']['input'];
  highlightCutsheetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  highlightSectionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  orientation: Scalars['String']['input'];
  hiddenGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  hiddenItemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  hiddenSpecificationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  showCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  customContentTitle?: InputMaybe<Scalars['String']['input']>;
  customContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityPrintSettingsUpdateMutation = { __typename?: 'Mutation', CutsheetCapabilityPrintSettingsUpdate?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCapabilitySetLegacyMapMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  legacyInspectionLevelMap: Array<CutsheetLegacyInspectionLevelEntryInput> | CutsheetLegacyInspectionLevelEntryInput;
}>;


export type CutsheetCapabilitySetLegacyMapMutation = { __typename?: 'Mutation', CutsheetCapabilitySetLegacyMap?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCatalogChatMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  messages: Array<CutsheetCatalogChatMessageInput> | CutsheetCatalogChatMessageInput;
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCatalogChatMutation = { __typename?: 'Mutation', cutsheetCatalogChat?: { __typename?: 'CutsheetCatalogChatPayload', message: string, catalogChanged: boolean, actions: Array<{ __typename?: 'CutsheetChatAction', kind: string, label: string, itemType: string, itemId?: string | null }>, proposedChanges: Array<{ __typename?: 'CutsheetProposedChange', id: string, tool: string, args?: any | null, kind: string, itemType: string, label: string }> } | null };

export type CutsheetCreateOneMutationVariables = Exact<{
  record: CreateOneCutsheetInput;
}>;


export type CutsheetCreateOneMutation = { __typename?: 'Mutation', cutsheetCreateOne?: { __typename?: 'CreateOneCutsheetPayload', recordId?: any | null, record?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null } | null };

export type CutsheetCapabilityCutDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityCutDeleteMutation = { __typename?: 'Mutation', cutsheetCutDelete: boolean };

export type CutsheetCapabilityCutUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<CutsheetCutSpecificationInput> | CutsheetCutSpecificationInput>;
  pricing?: InputMaybe<CutsheetCutPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>> | InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>;
}>;


export type CutsheetCapabilityCutUpsertMutation = { __typename?: 'Mutation', cutsheetCutUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null };

export type CutsheetDescriptionLibraryCreateOneMutationVariables = Exact<{
  record: CreateOneCutsheetDescriptionLibraryInput;
}>;


export type CutsheetDescriptionLibraryCreateOneMutation = { __typename?: 'Mutation', cutsheetDescriptionLibraryCreateOne?: { __typename?: 'CreateOneCutsheetDescriptionLibraryPayload', recordId?: any | null, record?: { __typename?: 'CutsheetDescriptionLibrary', _id: any, name: string, description: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CutsheetDescriptionLibraryRemoveByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type CutsheetDescriptionLibraryRemoveByIdMutation = { __typename?: 'Mutation', cutsheetDescriptionLibraryRemoveById?: { __typename?: 'RemoveByIdCutsheetDescriptionLibraryPayload', recordId?: any | null } | null };

export type CutsheetDescriptionLibraryUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetDescriptionLibraryInput;
}>;


export type CutsheetDescriptionLibraryUpdateByIdMutation = { __typename?: 'Mutation', cutsheetDescriptionLibraryUpdateById?: { __typename?: 'UpdateByIdCutsheetDescriptionLibraryPayload', recordId?: any | null, record?: { __typename?: 'CutsheetDescriptionLibrary', _id: any, name: string, description: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CutsheetCapabilityExtraDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityExtraDeleteMutation = { __typename?: 'Mutation', cutsheetExtraDelete: boolean };

export type CutsheetCapabilityExtraUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  specifications?: InputMaybe<Array<CutsheetExtraSpecificationInput> | CutsheetExtraSpecificationInput>;
  pricing?: InputMaybe<CutsheetExtraPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>> | InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>;
}>;


export type CutsheetCapabilityExtraUpsertMutation = { __typename?: 'Mutation', cutsheetExtraUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null };

export type CutsheetCapabilityGroupDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityGroupDeleteMutation = { __typename?: 'Mutation', cutsheetGroupDelete: boolean };

export type CutsheetCapabilityGroupReorderMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityGroupReorderMutation = { __typename?: 'Mutation', cutsheetGroupReorder: boolean };

export type CutsheetCapabilityGroupUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityGroupUpsertMutation = { __typename?: 'Mutation', cutsheetGroupUpsert?: { __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type CutsheetHeaderPreviewMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type CutsheetHeaderPreviewMutation = { __typename?: 'Mutation', cutsheetHeaderPreview?: { __typename?: 'CutsheetHeaderPreviewResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type CutsheetImageLibraryCreateOneMutationVariables = Exact<{
  record: CreateOneCutsheetImageLibraryInput;
}>;


export type CutsheetImageLibraryCreateOneMutation = { __typename?: 'Mutation', cutsheetImageLibraryCreateOne?: { __typename?: 'CreateOneCutsheetImageLibraryPayload', recordId?: any | null, record?: { __typename?: 'CutsheetImageLibrary', _id: any, name: string, imageUrl: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CutsheetImageLibraryRemoveByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type CutsheetImageLibraryRemoveByIdMutation = { __typename?: 'Mutation', cutsheetImageLibraryRemoveById?: { __typename?: 'RemoveByIdCutsheetImageLibraryPayload', recordId?: any | null } | null };

export type CutsheetImageLibraryUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetImageLibraryInput;
}>;


export type CutsheetImageLibraryUpdateByIdMutation = { __typename?: 'Mutation', cutsheetImageLibraryUpdateById?: { __typename?: 'UpdateByIdCutsheetImageLibraryPayload', recordId?: any | null, record?: { __typename?: 'CutsheetImageLibrary', _id: any, name: string, imageUrl: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CutsheetMarkConvertedMutationVariables = Exact<{
  cutsheetId: Scalars['MongoID']['input'];
  responseId: Scalars['MongoID']['input'];
}>;


export type CutsheetMarkConvertedMutation = { __typename?: 'Mutation', cutsheetMarkConverted?: { __typename?: 'Cutsheet', _id: any, convertedToQuestionnaireResponse?: any | null } | null };

export type CutsheetCapabilityOptionReorderMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityOptionReorderMutation = { __typename?: 'Mutation', cutsheetOptionReorder: boolean };

export type CutsheetQuestionnaireChatMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  questions: Scalars['JSON']['input'];
  messages: Array<CutsheetCatalogChatMessageInput> | CutsheetCatalogChatMessageInput;
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetQuestionnaireChatMutation = { __typename?: 'Mutation', cutsheetQuestionnaireChat?: { __typename?: 'CutsheetQuestionnaireChatPayload', message: string, changed: boolean, questions?: any | null, actions: Array<{ __typename?: 'CutsheetChatAction', kind: string, label: string, itemType: string, itemId?: string | null }>, proposedChanges: Array<{ __typename?: 'CutsheetProposedChange', id: string, tool: string, args?: any | null, kind: string, itemType: string, label: string }> } | null };

export type CutsheetQuestionnaireDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireDeleteMutation = { __typename?: 'Mutation', cutsheetQuestionnaireDelete: boolean };

export type CutsheetQuestionnaireResponseAttachSourceMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  pages: Array<CutsheetResponseSourcePageInput> | CutsheetResponseSourcePageInput;
  annotations?: InputMaybe<Array<CutsheetResponseSourceAnnotationInput> | CutsheetResponseSourceAnnotationInput>;
}>;


export type CutsheetQuestionnaireResponseAttachSourceMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseAttachSource?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any } | null };

export type CutsheetQuestionnaireResponseGeneratePdfMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponseGeneratePdfMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseGeneratePdf?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type CutsheetQuestionnaireResponseReassignMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetQuestionnaireResponseReassignMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseReassign?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, type: EnumCutsheetQuestionnaireResponseType, user?: any | null } | null };

export type CutsheetQuestionnaireResponseRestoreMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponseRestoreMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseRestore: boolean };

export type CutsheetQuestionnaireResponseSoftDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponseSoftDeleteMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseSoftDelete: boolean };

export type CutsheetQuestionnaireResponseUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireId: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetResponseCutOptionInput>> | InputMaybe<CutsheetResponseCutOptionInput>>;
  trimSelections?: InputMaybe<CutsheetResponseTrimResponseInput>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>> | InputMaybe<CutsheetResponseSpecificationSelectionInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primalNotes?: InputMaybe<Array<InputMaybe<CutsheetResponseNoteEntryInput>> | InputMaybe<CutsheetResponseNoteEntryInput>>;
  trimSectionNotes?: InputMaybe<Scalars['String']['input']>;
  timeToComplete?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetQuestionnaireResponseUpsertMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseUpsert?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, questionnaire: any, capabilitySet: any, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, trimSectionNotes?: string | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireResponsePrimalNotes', id: string, note: string } | null> | null } | null };

export type CutsheetQuestionnaireRestoreMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
}>;


export type CutsheetQuestionnaireRestoreMutation = { __typename?: 'Mutation', cutsheetQuestionnaireRestore: boolean };

export type CutsheetQuestionnaireUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityId: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<CutsheetQuestionInput> | CutsheetQuestionInput>;
  pricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetPricingOverrideEntryInput>> | InputMaybe<CutsheetPricingOverrideEntryInput>>;
  specOptionPricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetSpecOptionPricingEntryInput>> | InputMaybe<CutsheetSpecOptionPricingEntryInput>>;
  processingFee?: InputMaybe<CutsheetQuestionnaireFeeInput>;
  killFee?: InputMaybe<CutsheetQuestionnaireFeeInput>;
  additionalCharges?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireAdditionalChargeInput>> | InputMaybe<CutsheetQuestionnaireAdditionalChargeInput>>;
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  printSettings?: InputMaybe<CutsheetQuestionnairePrintSettingsOverrideInput>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetQuestionnaireUpsertMutation = { __typename?: 'Mutation', cutsheetQuestionnaireUpsert?: { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, pricePerPound?: number | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, processingFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, killFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, additionalCharges?: Array<{ __typename?: 'CutsheetQuestionnaireAdditionalCharges', id?: string | null, label: string, amount: number, priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType, basis: EnumCutsheetQuestionnaireAdditionalChargesBasis, description?: string | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetQuestionnairePrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetQuestionnairePrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetQuestionnairePrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null } | null };

export type CutsheetRestoreMutationVariables = Exact<{
  cutsheetId: Scalars['MongoID']['input'];
}>;


export type CutsheetRestoreMutation = { __typename?: 'Mutation', cutsheetRestore?: { __typename?: 'Cutsheet', _id: any } | null };

export type CutsheetSoftDeleteMutationVariables = Exact<{
  cutsheetId: Scalars['MongoID']['input'];
}>;


export type CutsheetSoftDeleteMutation = { __typename?: 'Mutation', cutsheetSoftDelete?: { __typename?: 'Cutsheet', _id: any } | null };

export type CutsheetCapabilitySpecificationDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilitySpecificationDeleteMutation = { __typename?: 'Mutation', cutsheetSpecificationDelete: boolean };

export type CutsheetCapabilitySpecificationReorderMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilitySpecificationReorderMutation = { __typename?: 'Mutation', cutsheetSpecificationReorder: boolean };

export type CutsheetCapabilitySpecificationUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilitySpecificationUpsertMutation = { __typename?: 'Mutation', cutsheetSpecificationUpsert?: { __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type CutsheetCapabilityTrimDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityTrimDeleteMutation = { __typename?: 'Mutation', cutsheetTrimDelete: boolean };

export type CutsheetCapabilityTrimUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<CutsheetTrimSpecificationInput> | CutsheetTrimSpecificationInput>;
  pricing?: InputMaybe<CutsheetTrimPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  partnerCodes?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>> | InputMaybe<CutsheetCapabilityOptionPartnerCodeInput>>;
}>;


export type CutsheetCapabilityTrimUpsertMutation = { __typename?: 'Mutation', cutsheetTrimUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null };

export type CutsheetUpsertMutationVariables = Exact<{
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheetId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumCutsheetType>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>> | InputMaybe<EnumCutsheetInspectionLevels>>;
  primalCuts?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  splitTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  extras?: InputMaybe<Array<CutsheetExtrasTypeInput> | CutsheetExtrasTypeInput>;
  trim?: InputMaybe<Array<CutsheetTrimTypeInput> | CutsheetTrimTypeInput>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CutsheetUpsertMutation = { __typename?: 'Mutation', cutsheetUpsert?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null };

export type DataImportCancelJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
}>;


export type DataImportCancelJobMutation = { __typename?: 'Mutation', dataImportCancelJob?: { __typename?: 'DataImportCancelJobPayload', jobId: string, status: string, cancelledAt: any, cancelledAtStage: string, message: string } | null };

export type DataImportClearMatchDecisionMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  side: Scalars['String']['input'];
}>;


export type DataImportClearMatchDecisionMutation = { __typename?: 'Mutation', dataImportClearMatchDecision?: { __typename?: 'DataImportClearMatchDecisionPayload', jobId: string, rowNumber: number, side: string, clearedRowCount: number } | null };

export type DataImportDeleteRecordMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
}>;


export type DataImportDeleteRecordMutation = { __typename?: 'Mutation', dataImportDeleteRecord?: { __typename?: 'DataImportDeleteRecordPayload', jobId: string, deletedRows: Array<number>, validRows: number } | null };

export type DataImportEnableAnimalSpeciesMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  species: Scalars['String']['input'];
  addInspectionLevel?: InputMaybe<Scalars['String']['input']>;
}>;


export type DataImportEnableAnimalSpeciesMutation = { __typename?: 'Mutation', dataImportEnableAnimalSpecies?: { __typename?: 'DataImportEnableAnimalSpeciesPayload', jobId: string, species: string, malformedJobCount: number } | null };

export type DataImportExecuteMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  excludedRowNumbers?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  skippedWarningRowNumbers?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type DataImportExecuteMutation = { __typename?: 'Mutation', dataImportExecute?: { __typename?: 'DataImportExecutePayload', jobId: string, status: string, message?: string | null } | null };

export type DataImportFinalizeHygieneMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportFinalizeHygieneMutation = { __typename?: 'Mutation', dataImportFinalizeHygiene?: { __typename?: 'DataImportFinalizeHygienePayload', jobId: string, status: string, matchedSideCount: number, skippedSideCount: number } | null };

export type DataImportResolveJobDuplicateMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  action: Scalars['String']['input'];
}>;


export type DataImportResolveJobDuplicateMutation = { __typename?: 'Mutation', dataImportResolveJobDuplicate?: { __typename?: 'DataImportResolveJobDuplicatePayload', jobId: string, rowNumber: number, action: string } | null };

export type DataImportRevalidateMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
}>;


export type DataImportRevalidateMutation = { __typename?: 'Mutation', dataImportRevalidate?: { __typename?: 'DataImportRevalidatePayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validationErrors: Array<{ __typename?: 'DataImportCSVValidationError', row: number, side?: string | null, errorMessages: Array<string>, warningMessages?: Array<string> | null, excludedMessages?: Array<string> | null }> } | null };

export type DataImportRevertToHygieneMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportRevertToHygieneMutation = { __typename?: 'Mutation', dataImportRevertToHygiene?: { __typename?: 'DataImportRevertToHygienePayload', jobId: string, status: string, snapshottedRows: number } | null };

export type DataImportRunHygieneMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportRunHygieneMutation = { __typename?: 'Mutation', dataImportRunHygiene?: { __typename?: 'DataImportRunHygienePayload', jobId: string, status: string, clusterCount: number, flagCount: number, malformedClusterCount: number, needsReviewClusterCount: number } | null };

export type DataImportSaveColumnMappingMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  columnMapping: Scalars['JSON']['input'];
}>;


export type DataImportSaveColumnMappingMutation = { __typename?: 'Mutation', dataImportSaveColumnMapping?: { __typename?: 'DataImportSaveColumnMappingPayload', jobId: string, status: string, totalRows: number, validRows: number, invalidRows: number, s3Keys?: any | null, parsedData?: any | null, columns: Array<string>, hygiene?: any | null, validationErrors: Array<{ __typename?: 'DataImportCSVValidationError', row: number, side?: string | null, errorMessages: Array<string>, warningMessages?: Array<string> | null, excludedMessages?: Array<string> | null }> } | null };

export type DataImportSaveHygieneActionMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  clusterId?: InputMaybe<Scalars['String']['input']>;
  patch?: InputMaybe<Scalars['JSON']['input']>;
  flagId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  clusterIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  splitRows?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  rowIndex?: InputMaybe<Scalars['Int']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  fromClusterId?: InputMaybe<Scalars['String']['input']>;
  toClusterId?: InputMaybe<Scalars['String']['input']>;
  canonicalOverride?: InputMaybe<Scalars['JSON']['input']>;
  sourceClusterId?: InputMaybe<Scalars['String']['input']>;
  canonicalA?: InputMaybe<Scalars['JSON']['input']>;
  canonicalB?: InputMaybe<Scalars['JSON']['input']>;
  producerClusterId?: InputMaybe<Scalars['String']['input']>;
  buyerClusterId?: InputMaybe<Scalars['String']['input']>;
  rowIndices?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  jobAssignedTo?: InputMaybe<Scalars['String']['input']>;
  jobPatch?: InputMaybe<Scalars['JSON']['input']>;
  producer?: InputMaybe<Scalars['JSON']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
}>;


export type DataImportSaveHygieneActionMutation = { __typename?: 'Mutation', dataImportSaveHygieneAction?: { __typename?: 'DataImportSaveHygieneActionPayload', jobId: string, status: string, actionCount: number, openFlagCount: number, needsReviewClusterCount: number, rowsChanged?: number | null, rowsUnchanged?: number | null, rowsAlreadySet?: number | null, rowsIncompatible?: number | null } | null };

export type DataImportSaveMatchDecisionMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  side: Scalars['String']['input'];
  action: Scalars['String']['input'];
  targetUserId?: InputMaybe<Scalars['String']['input']>;
  fieldsToApply?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DataImportSaveMatchDecisionMutation = { __typename?: 'Mutation', dataImportSaveMatchDecision?: { __typename?: 'DataImportSaveMatchDecisionPayload', jobId: string, rowNumber: number, side: string, action: string, targetUserId?: string | null, fieldsToApply?: Array<string> | null } | null };

export type DataImportUpdateRowsMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  updatedRows: Scalars['JSON']['input'];
}>;


export type DataImportUpdateRowsMutation = { __typename?: 'Mutation', dataImportUpdateRows?: { __typename?: 'DataImportUpdateRowsPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, parsedData: any, validationErrors: Array<{ __typename?: 'DataImportCSVValidationError', row: number, side?: string | null, errorMessages: Array<string>, warningMessages?: Array<string> | null, excludedMessages?: Array<string> | null }> } | null };

export type DataImportForceCancelMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportForceCancelMutation = { __typename?: 'Mutation', dataImportForceCancel?: { __typename?: 'DataImportForceCancelPayload', jobId: string, status: string, cancelledAt: any, message: string, warning?: string | null } | null };

export type DataImportUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
  tenantId: Scalars['MongoID']['input'];
}>;


export type DataImportUploadMutation = { __typename?: 'Mutation', dataImportUpload?: { __typename?: 'DataImportUploadPayload', jobId: string, detectedType: string, totalRows: number, validRows: number, invalidRows: number, validFilePath?: string | null, invalidFilePath?: string | null, detectedColumns: Array<string>, suggestedMapping?: any | null, validationErrors: Array<{ __typename?: 'DataImportCSVValidationError', row: number, side?: string | null, errorMessages: Array<string>, warningMessages?: Array<string> | null, excludedMessages?: Array<string> | null }>, availableColumns: Array<{ __typename?: 'DataImportAvailableColumn', fieldName: string, role: string, baseField: string, aliases: Array<string>, required: boolean, description: string, validationRules?: string | null }> } | null };

export type DepositPaymentIntentCreateMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type DepositPaymentIntentCreateMutation = { __typename?: 'Mutation', depositPaymentIntentCreate?: { __typename?: 'DepositPaymentIntentResponse', clientSecret: string, connectedAccountId: string } | null };

export type DepositPaymentIntentSettleMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type DepositPaymentIntentSettleMutation = { __typename?: 'Mutation', depositPaymentIntentSettle?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null } | null } | null };

export type DepositSetupIntentCreateMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
}>;


export type DepositSetupIntentCreateMutation = { __typename?: 'Mutation', depositSetupIntentCreate?: { __typename?: 'DepositSetupIntentResponse', clientSecret: string, customerId: string } | null };

export type DocumentAddVersionMutationVariables = Exact<{
  documentId: Scalars['MongoID']['input'];
  key: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentAddVersionMutation = { __typename?: 'Mutation', documentAddVersion?: { __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null };

export type DocumentCategoryUpsertMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DocumentCategoryUpsertMutation = { __typename?: 'Mutation', documentCategoryUpsert?: { __typename?: 'DocumentCategory', _id: any, name: string, vendor?: any | null } | null };

export type DocumentCreateMutationVariables = Exact<{
  links?: InputMaybe<Array<DocumentLinkInput> | DocumentLinkInput>;
  key: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
}>;


export type DocumentCreateMutation = { __typename?: 'Mutation', documentCreate?: { __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null };

export type DocumentCreateFromChatAttachmentMutationVariables = Exact<{
  chatMessageId: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<DocumentLinkInput> | DocumentLinkInput>;
  category: Scalars['String']['input'];
}>;


export type DocumentCreateFromChatAttachmentMutation = { __typename?: 'Mutation', documentCreateFromChatAttachment?: { __typename?: 'Document', _id: any, filename: string, category: string } | null };

export type DocumentDeleteMutationVariables = Exact<{
  documentId: Scalars['MongoID']['input'];
}>;


export type DocumentDeleteMutation = { __typename?: 'Mutation', documentDelete?: { __typename?: 'Document', _id: any } | null };

export type DocumentRestoreVersionMutationVariables = Exact<{
  documentId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
}>;


export type DocumentRestoreVersionMutation = { __typename?: 'Mutation', documentRestoreVersion?: { __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null };

export type DocumentSetLinksMutationVariables = Exact<{
  documentId: Scalars['MongoID']['input'];
  links: Array<DocumentLinkInput> | DocumentLinkInput;
}>;


export type DocumentSetLinksMutation = { __typename?: 'Mutation', documentSetLinks?: { __typename?: 'Document', _id: any, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null } | null };

export type ExportPresetCreateOneMutationVariables = Exact<{
  record: CreateOneExportPresetInput;
}>;


export type ExportPresetCreateOneMutation = { __typename?: 'Mutation', exportPresetCreateOne?: { __typename?: 'CreateOneExportPresetPayload', recordId?: any | null } | null };

export type ExportPresetUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdExportPresetInput;
}>;


export type ExportPresetUpdateByIdMutation = { __typename?: 'Mutation', exportPresetUpdateById?: { __typename?: 'UpdateByIdExportPresetPayload', recordId?: any | null } | null };

export type ExportPresetDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ExportPresetDeleteByIdMutation = { __typename?: 'Mutation', exportPresetUpdateById?: { __typename?: 'UpdateByIdExportPresetPayload', recordId?: any | null } | null };

export type ExportSettingCreateOneMutationVariables = Exact<{
  record: CreateOneExportSettingInput;
}>;


export type ExportSettingCreateOneMutation = { __typename?: 'Mutation', exportSettingCreateOne?: { __typename?: 'CreateOneExportSettingPayload', recordId?: any | null } | null };

export type ExportSettingUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdExportSettingInput;
}>;


export type ExportSettingUpdateByIdMutation = { __typename?: 'Mutation', exportSettingUpdateById?: { __typename?: 'UpdateByIdExportSettingPayload', recordId?: any | null } | null };

export type GameJobAddAnimalsMutationVariables = Exact<{
  input: GameJobAddAnimalsInput;
}>;


export type GameJobAddAnimalsMutation = { __typename?: 'Mutation', gameJobAddAnimals?: { __typename?: 'GameJobAddAnimalsResponse', addedCount: number, sharedCutSheet: boolean, cutSheetOutcome: string, replayed: boolean, messages?: Array<string | null> | null, scheduling: { __typename?: 'ProcessorScheduling', _id: any, headCount: number } } | null };

export type GameJobCreateMutationVariables = Exact<{
  input: GameJobCreateInput;
}>;


export type GameJobCreateMutation = { __typename?: 'Mutation', gameJobCreate?: { __typename?: 'GameJobCreateResponse', hunterExisted: boolean, replayed: boolean, messages?: Array<string | null> | null, scheduling: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number } } | null };

export type GameKioskAddressSetupMutationVariables = Exact<{
  input: GameKioskAddressSetupInput;
}>;


export type GameKioskAddressSetupMutation = { __typename?: 'Mutation', gameKioskAddressSetup?: { __typename?: 'GameKioskAddressSetupResponse', kioskToken: string, kioskUrl: string, kioskShortUrl: string, created: boolean } | null };

export type GameKioskDropoffCreateMutationVariables = Exact<{
  input: GameKioskDropoffInput;
}>;


export type GameKioskDropoffCreateMutation = { __typename?: 'Mutation', gameKioskDropoffCreate?: { __typename?: 'GameKioskDropoffResponse', jobId: string, animalCount: number, processorName: string, replayed: boolean } | null };

export type GameKioskSignGenerateMutationVariables = Exact<{
  vendor: Scalars['MongoID']['input'];
}>;


export type GameKioskSignGenerateMutation = { __typename?: 'Mutation', gameKioskSignGenerate?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, fileUrl?: string | null, errors?: Array<string | null> | null } | null };

export type GenerateCutsheetQuestionnaireMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type GenerateCutsheetQuestionnaireMutation = { __typename?: 'Mutation', generateCutsheetQuestionnaire?: { __typename?: 'GenerateCutsheetQuestionnairePayload', questionnaireId: any, name: string, questionCount: number } | null };

export type GenerateUploadUrlMutationVariables = Exact<{
  key: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateUploadUrlMutation = { __typename?: 'Mutation', generateUploadUrl?: { __typename?: 'GenerateUploadUrlPayload', uploadUrl: string, cdnUrl: string } | null };

export type InAppNotificationsMarkSeenMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type InAppNotificationsMarkSeenMutation = { __typename?: 'Mutation', inAppNotificationsMarkSeen: number };

export type IntegrationDeliveryRetryMutationVariables = Exact<{
  deliveryId?: InputMaybe<Scalars['MongoID']['input']>;
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type IntegrationDeliveryRetryMutation = { __typename?: 'Mutation', integrationDeliveryRetry?: { __typename?: 'IntegrationRetryResult', requeued: number, reason?: string | null } | null };

export type IntegrationInboundRecordResolveMutationVariables = Exact<{
  recordId: Scalars['MongoID']['input'];
  action: Scalars['String']['input'];
}>;


export type IntegrationInboundRecordResolveMutation = { __typename?: 'Mutation', integrationInboundRecordResolve?: { __typename?: 'IntegrationInboundRecord', _id: any, status: EnumIntegrationInboundRecordStatus, error?: string | null, match?: { __typename?: 'IntegrationInboundRecordMatch', animal?: any | null, matchedOn?: string | null, matchedValue?: string | null } | null } | null };

export type IntegrationInitMutationVariables = Exact<{
  integrationName: EnumIntegrationName;
  shop?: InputMaybe<Scalars['String']['input']>;
}>;


export type IntegrationInitMutation = { __typename?: 'Mutation', integrationInit?: { __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, _id: any } | null };

export type IntegrationPollNowMutationVariables = Exact<{
  adapter: Scalars['String']['input'];
}>;


export type IntegrationPollNowMutation = { __typename?: 'Mutation', integrationPollNow?: { __typename?: 'IntegrationPollNowResult', ok: boolean, received: number, matched: number, applied: number, unmatched: number, duplicates: number, reason?: string | null } | null };

export type InvoiceCreateForSchedulingJobMutationVariables = Exact<{
  input: CreateInvoiceForSchedulingJobInput;
}>;


export type InvoiceCreateForSchedulingJobMutation = { __typename?: 'Mutation', invoiceCreateForSchedulingJob?: { __typename?: 'Invoice', _id: any, number?: string | null, status: EnumInvoiceStatus, amount_due: number, amount_discounted?: number | null, due_date: any, type: EnumInvoiceType, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null } | null } | null };

export type InvoiceFinalizeAndSendMutationVariables = Exact<{
  input?: InputMaybe<VoidInvoiceInput>;
}>;


export type InvoiceFinalizeAndSendMutation = { __typename?: 'Mutation', invoiceFinalizeAndSend?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type GenerateInvoicePdfMutationVariables = Exact<{
  invoiceId: Scalars['MongoID']['input'];
}>;


export type GenerateInvoicePdfMutation = { __typename?: 'Mutation', generateInvoicePdf?: { __typename?: 'GenerateInvoicePdfResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type InvoiceMarkAsPaidMutationVariables = Exact<{
  input?: InputMaybe<MarkAsPaidInput>;
}>;


export type InvoiceMarkAsPaidMutation = { __typename?: 'Mutation', invoiceMarkAsPaid?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, followUp?: { __typename?: 'InvoiceFollowUp', jobId?: any | null, jobSettled: boolean, customerOpenInvoiceCount: number, customerOutstandingBalance: number } | null, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceRefundMutationVariables = Exact<{
  input?: InputMaybe<RefundInvoiceInput>;
}>;


export type InvoiceRefundMutation = { __typename?: 'Mutation', invoiceRefund?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceUpdateMutationVariables = Exact<{
  input?: InputMaybe<UpdateInvoiceInput>;
}>;


export type InvoiceUpdateMutation = { __typename?: 'Mutation', invoiceUpdate?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceVoidMutationVariables = Exact<{
  input?: InputMaybe<VoidInvoiceInput>;
}>;


export type InvoiceVoidMutation = { __typename?: 'Mutation', invoiceVoid?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type JobIntegrationPushMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  adapter?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type JobIntegrationPushMutation = { __typename?: 'Mutation', jobIntegrationPush?: { __typename?: 'JobIntegrationPushResult', queued: number, integrations: Array<string>, reason?: string | null } | null };

export type JobTagCreateOneMutationVariables = Exact<{
  record: CreateOneJobTagInput;
}>;


export type JobTagCreateOneMutation = { __typename?: 'Mutation', jobTagCreateOne?: { __typename?: 'CreateOneJobTagPayload', record?: { __typename?: 'JobTag', _id: any, vendor: any, name: string, icon: string, species?: Array<EnumJobTagSpecies | null> | null, isEnabled: boolean, sortOrder?: number | null } | null } | null };

export type JobTagRemoveByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type JobTagRemoveByIdMutation = { __typename?: 'Mutation', jobTagRemoveById?: { __typename?: 'RemoveByIdJobTagPayload', recordId?: any | null } | null };

export type JobTagUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdJobTagInput;
}>;


export type JobTagUpdateByIdMutation = { __typename?: 'Mutation', jobTagUpdateById?: { __typename?: 'UpdateByIdJobTagPayload', record?: { __typename?: 'JobTag', _id: any, vendor: any, name: string, icon: string, species?: Array<EnumJobTagSpecies | null> | null, isEnabled: boolean, sortOrder?: number | null } | null } | null };

export type KillSheetPreviewMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type KillSheetPreviewMutation = { __typename?: 'Mutation', killSheetPreview?: { __typename?: 'KillSheetPreviewResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type LandingPageUpsertMutationVariables = Exact<{
  input: LandingPageUpsertInput;
}>;


export type LandingPageUpsertMutation = { __typename?: 'Mutation', landingPageUpsert?: { __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, slug?: string | null, species?: Array<EnumLandingPageSettingsSpecies | null> | null, about?: string | null, buyerBio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, tagline?: string | null, logoUrl?: string | null, showAddress?: boolean | null, showOnMap?: boolean | null, showInDirectory?: boolean | null, showAbout?: boolean | null, showContact?: boolean | null, showPricing?: boolean | null, showGallery?: boolean | null, showDocuments?: boolean | null, showFaq?: boolean | null, galleryImages?: Array<string | null> | null, premierProducers?: Array<{ __typename?: 'LandingPageSettingsPremierProducers', producerId: any, badge: EnumLandingPageSettingsPremierProducersBadge } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, type: EnumAddressType } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null, pricingRows?: Array<{ __typename?: 'LandingPageSettingsPricingRows', _id?: any | null, label: string, price?: number | null, unit?: string | null, notes?: string | null } | null> | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null } | null, documents?: Array<{ __typename?: 'LandingPageSettingsDocuments', _id?: any | null, name: string, description?: string | null, fileUrl: string } | null> | null, faq?: Array<{ __typename?: 'LandingPageSettingsFaq', _id?: any | null, question: string, answer: string } | null> | null } | null };

export type MarkChatRoomAsReadMutationVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  markMessagesRead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkChatRoomAsReadMutation = { __typename?: 'Mutation', markChatRoomAsRead?: { __typename?: 'ChatRoom', _id: any, unreadMessagesCount: number, markedUnread: boolean } | null };

export type MarkChatRoomAsUnreadMutationVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
}>;


export type MarkChatRoomAsUnreadMutation = { __typename?: 'Mutation', markChatRoomAsUnread?: { __typename?: 'ChatRoom', _id: any, unreadMessagesCount: number, markedUnread: boolean } | null };

export type MarketplaceLeadSubmitMutationVariables = Exact<{
  species: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  timeline: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketplaceLeadSubmitMutation = { __typename?: 'Mutation', marketplaceLeadSubmit: boolean };

export type MyAddOnJobSplitMutationVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
  buyerId: Scalars['MongoID']['input'];
}>;


export type MyAddOnJobSplitMutation = { __typename?: 'Mutation', myAddOnJobSplit?: { __typename?: 'Split', _id: any } | null };

export type MyAnimalAssignToJobMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  animalIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  listing?: InputMaybe<ProcessorSchedulingListingInput>;
}>;


export type MyAnimalAssignToJobMutation = { __typename?: 'Mutation', myAnimalAssignToJob?: { __typename?: 'HerdAssignToJobPayload', jobId: any, assignedCount: number } | null };

export type MyAnimalCsvImportUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type MyAnimalCsvImportUploadMutation = { __typename?: 'Mutation', myAnimalCsvImportUpload?: { __typename?: 'MyAnimalCSVImportUploadPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validFilePath?: string | null, invalidFilePath?: string | null, detectedColumns: Array<string>, suggestedMapping?: any | null, validationErrors: Array<{ __typename?: 'MyAnimalCSVValidationError', row: number, errorMessages: Array<string> }>, availableColumns: Array<{ __typename?: 'MyAnimalAvailableColumn', fieldName: string, aliases: Array<string>, required: boolean, description: string, validationRules?: string | null }> } | null };

export type MyAnimalDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type MyAnimalDeleteMutation = { __typename?: 'Mutation', myAnimalDelete?: { __typename?: 'Animal', _id: any } | null };

export type MyAnimalQuickAddMutationVariables = Exact<{
  animals: Array<QuickAddAnimalInput> | QuickAddAnimalInput;
}>;


export type MyAnimalQuickAddMutation = { __typename?: 'Mutation', myAnimalQuickAdd?: Array<{ __typename?: 'Animal', _id: any, species: string, tracking?: string | null, splitType?: string | null, producerIdentifier?: string | null } | null> | null };

export type MyAnimalSetSplitBuyersMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  splits: Array<HerdSplitBuyerInput> | HerdSplitBuyerInput;
}>;


export type MyAnimalSetSplitBuyersMutation = { __typename?: 'Mutation', myAnimalSetSplitBuyers?: { __typename?: 'Animal', _id: any, splits?: Array<{ __typename?: 'Split', splitPart?: string | null, buyer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null } | null> | null } | null };

export type MyAnimalUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  species?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  availableToBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  allowedSectionSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  claimMode?: InputMaybe<Scalars['String']['input']>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingDeposits?: InputMaybe<MyAnimalListingDepositsInput>;
  descriptorChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  producerDescription?: InputMaybe<Scalars['String']['input']>;
  sizeTier?: InputMaybe<Scalars['String']['input']>;
  liveWeightHigh?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
}>;


export type MyAnimalUpdateMutation = { __typename?: 'Mutation', myAnimalUpdate?: { __typename?: 'Animal', _id: any, species: string, tracking?: string | null, splitType?: string | null, liveWeight?: number | null, sex?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, availableToBuyers?: boolean | null, allowedSectionSizes?: Array<string | null> | null, claimMode?: EnumAnimalClaimMode | null, listingRatePerLb?: number | null, descriptorChips?: Array<string | null> | null, producerDescription?: string | null, sizeTier?: EnumAnimalSizeTier | null, liveWeightHigh?: number | null, listingTotalPrice?: number | null, remainingCapacity?: number | null, isFull?: boolean | null, listingDeposits?: { __typename?: 'AnimalListingDeposits', whole?: number | null, half?: number | null, quarter?: number | null } | null } | null };

export type MyGenerateSaleInvoiceMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  saleAmount: Scalars['Float']['input'];
  adjustments?: InputMaybe<Array<OrderAdjustmentInput> | OrderAdjustmentInput>;
}>;


export type MyGenerateSaleInvoiceMutation = { __typename?: 'Mutation', myGenerateSaleInvoice?: { __typename?: 'OrderInvoiceResult', _id: any, status: string, finalAmount?: number | null, saleBaseAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null, adjustments?: Array<{ __typename?: 'OrderAdjustmentResult', label: string, amount: number } | null> | null } | null };

export type MyMarkOrderSettledOffPlatformMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type MyMarkOrderSettledOffPlatformMutation = { __typename?: 'Mutation', myMarkOrderSettledOffPlatform?: { __typename?: 'OrderInvoiceResult', _id: any, status: string, finalAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null } | null };

export type MyNudgeSectionBuyerMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type MyNudgeSectionBuyerMutation = { __typename?: 'Mutation', myNudgeSectionBuyer?: { __typename?: 'MyNudgeSectionBuyerPayload', splitId: any, nudgeCase: string, nudgedAt: any } | null };

export type MyPlaceBuyerOnAnimalMutationVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
  buyerId: Scalars['MongoID']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
}>;


export type MyPlaceBuyerOnAnimalMutation = { __typename?: 'Mutation', myPlaceBuyerOnAnimal?: { __typename?: 'Split', _id: any } | null };

export type MyReassignBuyerSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  newBuyerId: Scalars['MongoID']['input'];
}>;


export type MyReassignBuyerSplitMutation = { __typename?: 'Mutation', myReassignBuyerSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null, buyer?: { __typename?: 'User', _id: any } | null } | null };

export type MyReleaseBuyerSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type MyReleaseBuyerSplitMutation = { __typename?: 'Mutation', myReleaseBuyerSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null } | null };

export type MyRemoveBuyerSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type MyRemoveBuyerSplitMutation = { __typename?: 'Mutation', myRemoveBuyerSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null } | null };

export type MyReviseSaleInvoiceMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  saleAmount: Scalars['Float']['input'];
  adjustments?: InputMaybe<Array<OrderAdjustmentInput> | OrderAdjustmentInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyReviseSaleInvoiceMutation = { __typename?: 'Mutation', myReviseSaleInvoice?: { __typename?: 'OrderInvoiceResult', _id: any, status: string, finalAmount?: number | null, saleBaseAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null, adjustments?: Array<{ __typename?: 'OrderAdjustmentResult', label: string, amount: number } | null> | null } | null };

export type MyStartBuyerChatMutationVariables = Exact<{
  buyerId: Scalars['MongoID']['input'];
}>;


export type MyStartBuyerChatMutation = { __typename?: 'Mutation', myStartBuyerChat?: { __typename?: 'ChatRoom', _id: any } | null };

export type MyStartProducerChatMutationVariables = Exact<{
  producerId: Scalars['MongoID']['input'];
  animalId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type MyStartProducerChatMutation = { __typename?: 'Mutation', myStartProducerChat?: { __typename?: 'ChatRoom', _id: any } | null };

export type MyVoidSaleInvoiceMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyVoidSaleInvoiceMutation = { __typename?: 'Mutation', myVoidSaleInvoice?: { __typename?: 'OrderInvoiceResult', _id: any, status: string, finalAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null } | null };

export type NoteDeleteMutationVariables = Exact<{
  noteId: Scalars['MongoID']['input'];
}>;


export type NoteDeleteMutation = { __typename?: 'Mutation', noteDelete?: { __typename?: 'Note', _id: any } | null };

export type NoteUpsertMutationVariables = Exact<{
  noteId?: InputMaybe<Scalars['MongoID']['input']>;
  note: Scalars['String']['input'];
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  animalHead?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  removeAttachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type NoteUpsertMutation = { __typename?: 'Mutation', noteUpsert?: { __typename?: 'Note', _id: any } | null };

export type NotificationPreferenceUpdateMutationVariables = Exact<{
  category: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationPreferenceUpdateMutation = { __typename?: 'Mutation', notificationPreferenceUpdate?: Array<{ __typename?: 'NotificationPreference', category: string, label: string, description?: string | null, email: boolean, sms: boolean } | null> | null };

export type NotificationPromptAnswerMutationVariables = Exact<{
  promptId: Scalars['ID']['input'];
  answer: Scalars['String']['input'];
  via?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationPromptAnswerMutation = { __typename?: 'Mutation', notificationPromptAnswer?: { __typename?: 'NotificationPromptState', _id: string, kind: string, status: string, canAnswer: boolean, jobId?: string | null, expiresAt?: any | null } | null };

export type NotificationPromptAnswerByTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  answer: Scalars['String']['input'];
}>;


export type NotificationPromptAnswerByTokenMutation = { __typename?: 'Mutation', notificationPromptAnswerByToken?: { __typename?: 'NotificationPromptPublic', kind: string, status: string, expiredReason?: string | null, vendorName?: string | null, animalSpecies?: string | null, dropoffDate?: string | null, jobId?: string | null } | null };

export type NotificationSettingsUpdateMutationVariables = Exact<{
  notificationSettingId: Scalars['MongoID']['input'];
  settings: NotificationSettingsInput;
}>;


export type NotificationSettingsUpdateMutation = { __typename?: 'Mutation', notificationSettingsUpdate?: { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, requestConfirmation?: boolean | null, confirmationMessage?: string | null, defaultConfirmationMessage?: string | null, sendEmail?: boolean | null, sendSMS?: boolean | null, sendInApp?: boolean | null, preferredChannel?: EnumNotificationSettingPreferredChannel | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null } | null };

export type ParseCutsheetMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  capabilityId: Scalars['MongoID']['input'];
}>;


export type ParseCutsheetMutation = { __typename?: 'Mutation', parseCutsheet?: { __typename?: 'ParseCutsheetPayload', catalog: { __typename?: 'ParsedCutsheetCatalog', name: string, description?: string | null, animalType: string, primals: Array<{ __typename?: 'ParsedCutsheetGroup', title: string, description?: string | null }>, cuts: Array<{ __typename?: 'ParsedCutsheetCut', title: string, description?: string | null, primalName?: string | null, pricePerPound?: number | null, priceFee?: number | null, priceFeePerPound?: number | null, minLbs?: number | null }>, specifications: Array<{ __typename?: 'ParsedCutsheetSpecification', title: string, description?: string | null, cutName?: string | null, options?: Array<string> | null }>, trim: Array<{ __typename?: 'ParsedCutsheetTrim', title: string, description?: string | null, pricePerPound?: number | null, priceFee?: number | null, minLbs?: number | null }>, extras: Array<{ __typename?: 'ParsedCutsheetExtra', title: string, description?: string | null, pricePerPound?: number | null, priceFee?: number | null, minLbs?: number | null }> }, questionnaire: { __typename?: 'ParsedCutsheetQuestionnaire', name: string, description?: string | null, animalType: string, questions: Array<{ __typename?: 'ParsedCutsheetQuestion', id: string, type: string, title: string, description?: string | null, required?: boolean | null, sortOrder: number, details?: string | null, imageUrl?: string | null, availableCutIds?: Array<string> | null, allowMultiple?: boolean | null, specificationId?: string | null, availableTrimIds?: Array<string> | null, requireExactTotal?: boolean | null }> } } | null };

export type ParseFilledCutsheetMutationVariables = Exact<{
  file?: InputMaybe<Scalars['Upload']['input']>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireId: Scalars['MongoID']['input'];
}>;


export type ParseFilledCutsheetMutation = { __typename?: 'Mutation', parseFilledCutsheet?: { __typename?: 'ParseFilledCutsheetPayload', defaultSelections: { __typename?: 'ParseFilledCutsheetDefaultSelections', name?: string | null, trimSectionNotes?: string | null, notes?: string | null, selectedCuts: Array<{ __typename?: 'ParseFilledCutsheetCutSelection', optionId: string, specifications?: Array<{ __typename?: 'ParseFilledCutsheetSpecificationSelection', specification: string, type: string, value: any }> | null }>, trimSelections?: { __typename?: 'ParseFilledCutsheetTrimSelections', type: string, trim: Array<{ __typename?: 'ParseFilledCutsheetTrimSelection', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'ParseFilledCutsheetSpecificationSelection', specification: string, type: string, value: any }> | null }> } | null, extraSelections?: { __typename?: 'ParseFilledCutsheetExtraSelections', extras: Array<{ __typename?: 'ParseFilledCutsheetExtraSelection', optionId: string, quantity?: number | null }> } | null, specifications: Array<{ __typename?: 'ParseFilledCutsheetSpecificationSelection', specification: string, type: string, value: any }>, primalNotes?: Array<{ __typename?: 'ParseFilledCutsheetNoteEntry', id: string, note: string }> | null }, customerDetails?: { __typename?: 'ParseFilledCutsheetCustomerDetails', name?: string | null, company?: string | null, phone?: string | null, email?: string | null } | null, pages: Array<{ __typename?: 'ParseFilledCutsheetPage', page: number, key?: string | null, url: string, width: number, height: number }>, report: { __typename?: 'ParseFilledCutsheetReport', documentSummary: string, suggestedName?: string | null, items: Array<{ __typename?: 'ParseFilledCutsheetReportItem', category: string, rawText: string, matchedTitle?: string | null, matchedId?: string | null, confidence: number, status: string, questionId?: string | null, detail?: string | null, anchorKind?: string | null, anchorId?: string | null, regions: Array<{ __typename?: 'ParseFilledCutsheetRegion', page: number, x: number, y: number, width: number, height: number }> }>, counts: { __typename?: 'ParseFilledCutsheetReportCounts', matched: number, lowConfidence: number, unmatched: number } } } | null };

export type PartnerIntegrationDeleteMutationVariables = Exact<{
  integrationId: Scalars['MongoID']['input'];
}>;


export type PartnerIntegrationDeleteMutation = { __typename?: 'Mutation', partnerIntegrationDelete?: { __typename?: 'PartnerIntegrationDeleteResult', ok: boolean, reason?: string | null } | null };

export type PartnerIntegrationIssueTokenMutationVariables = Exact<{
  adapter: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type PartnerIntegrationIssueTokenMutation = { __typename?: 'Mutation', partnerIntegrationIssueToken?: { __typename?: 'PartnerIntegrationToken', token: string, hint: string, inboundUrl: string } | null };

export type PartnerIntegrationUpsertMutationVariables = Exact<{
  adapter: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  autoPush?: InputMaybe<Scalars['Boolean']['input']>;
  autoPoll?: InputMaybe<Scalars['Boolean']['input']>;
  inboundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weightMode?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type PartnerIntegrationUpsertMutation = { __typename?: 'Mutation', partnerIntegrationUpsert?: { __typename?: 'Integration', _id: any, adapter?: string | null, label?: string | null, enabled?: boolean | null, subscribedEvents?: Array<EnumIntegrationSubscribedEvents | null> | null, autoPush?: boolean | null, autoPoll?: boolean | null, inbound?: { __typename?: 'IntegrationInbound', enabled?: boolean | null, tokenHint?: string | null, weightMode?: EnumIntegrationInboundWeightMode | null } | null } | null };

export type SearchAvailablePhoneNumbersQueryVariables = Exact<{
  input: SearchAvailablePhoneNumbersInput;
}>;


export type SearchAvailablePhoneNumbersQuery = { __typename?: 'Query', searchAvailablePhoneNumbers?: Array<{ __typename?: 'AvailablePhoneNumber', phoneNumber: string, friendlyName: string, locality?: string | null, region?: string | null, capabilities?: { __typename?: 'AvailablePhoneNumberCapabilities', voice: boolean, sms: boolean, mms: boolean } | null } | null> | null };

export type ProvisionPhoneNumberMutationVariables = Exact<{
  input: ProvisionPhoneNumberInput;
}>;


export type ProvisionPhoneNumberMutation = { __typename?: 'Mutation', provisionPhoneNumber?: { __typename?: 'ProvisionPhoneNumberResponse', success: boolean, error?: string | null, phoneNumber?: string | null, phoneNumberSid?: string | null } | null };

export type ReleasePhoneNumberMutationVariables = Exact<{
  input: ReleasePhoneNumberInput;
}>;


export type ReleasePhoneNumberMutation = { __typename?: 'Mutation', releasePhoneNumber?: { __typename?: 'ReleasePhoneNumberResponse', success: boolean, error?: string | null } | null };

export type SubmitHostedLandlineOrderMutationVariables = Exact<{
  input: SubmitHostedLandlineOrderInput;
}>;


export type SubmitHostedLandlineOrderMutation = { __typename?: 'Mutation', submitHostedLandlineOrder?: { __typename?: 'SubmitHostedLandlineOrderResponse', success: boolean, error?: string | null, hostedNumberOrderSid?: string | null, status?: string | null } | null };

export type RefreshHostedNumberStatusMutationVariables = Exact<{
  input: RefreshHostedNumberStatusInput;
}>;


export type RefreshHostedNumberStatusMutation = { __typename?: 'Mutation', refreshHostedNumberStatus?: { __typename?: 'RefreshHostedNumberStatusResponse', success: boolean, error?: string | null, status?: string | null, phoneNumberSid?: string | null, isProvisioned?: boolean | null } | null };

export type UpdatePhoneNumberSmsWebhookMutationVariables = Exact<{
  input: UpdatePhoneNumberSmsWebhookInput;
}>;


export type UpdatePhoneNumberSmsWebhookMutation = { __typename?: 'Mutation', updatePhoneNumberSmsWebhook?: { __typename?: 'UpdatePhoneNumberSmsWebhookResponse', success: boolean, error?: string | null, phoneNumber?: string | null } | null };

export type AddPhoneToMessagingServiceMutationVariables = Exact<{
  input: AddPhoneToMessagingServiceInput;
}>;


export type AddPhoneToMessagingServiceMutation = { __typename?: 'Mutation', addPhoneToMessagingService?: { __typename?: 'AddPhoneToMessagingServiceResponse', success: boolean, error?: string | null } | null };

export type PickupLocationUpsertMutationVariables = Exact<{
  input: PickupLocationUpsertInput;
}>;


export type PickupLocationUpsertMutation = { __typename?: 'Mutation', pickupLocationUpsert: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, active?: boolean | null, isDefault?: boolean | null, sortOrder?: number | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null, location?: { __typename?: 'PickupLocationLocation', coordinates?: Array<number | null> | null } | null } };

export type PrimalCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalInput;
}>;


export type PrimalCreateOneMutation = { __typename?: 'Mutation', primalCreateOne?: { __typename?: 'CreateOnePrimalPayload', recordId?: any | null } | null };

export type PrimalCutBlockerUpsertMutationVariables = Exact<{
  animalSpecies: Scalars['String']['input'];
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  blockedBy: Array<BlockedByInput> | BlockedByInput;
}>;


export type PrimalCutBlockerUpsertMutation = { __typename?: 'Mutation', primalCutBlockerUpsert?: { __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null } | null };

export type PrimalCutCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalCutInput;
}>;


export type PrimalCutCreateOneMutation = { __typename?: 'Mutation', primalCutCreateOne?: { __typename?: 'CreateOnePrimalCutPayload', recordId?: any | null, record?: { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null } | null };

export type PrimalCutSoftDeleteMutationVariables = Exact<{
  primalCutId: Scalars['MongoID']['input'];
}>;


export type PrimalCutSoftDeleteMutation = { __typename?: 'Mutation', primalCutSoftDelete?: { __typename?: 'PrimalCut', _id: any, primal?: { __typename?: 'Primal', _id: any, group?: { __typename?: 'PrimalGroup', _id: any } | null } | null } | null };

export type PrimalCutTypeCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalCutTypeInput;
}>;


export type PrimalCutTypeCreateOneMutation = { __typename?: 'Mutation', primalCutTypeCreateOne?: { __typename?: 'CreateOnePrimalCutTypePayload', recordId?: any | null } | null };

export type PrimalCutUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutInput;
}>;


export type PrimalCutUpdateByIdMutation = { __typename?: 'Mutation', primalCutUpdateById?: { __typename?: 'UpdateByIdPrimalCutPayload', recordId?: any | null, record?: { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null } | null };

export type PrimalGroupRestoreByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalGroupRestoreByIdMutation = { __typename?: 'Mutation', primalGroupUpdateById?: { __typename?: 'UpdateByIdPrimalGroupPayload', record?: { __typename?: 'PrimalGroup', _id: any, isDeleted?: boolean | null } | null } | null };

export type PrimalGroupSoftDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalGroupSoftDeleteByIdMutation = { __typename?: 'Mutation', primalGroupUpdateById?: { __typename?: 'UpdateByIdPrimalGroupPayload', record?: { __typename?: 'PrimalGroup', _id: any, isDeleted?: boolean | null, deletedAt?: any | null } | null } | null };

export type PrimalRestoreByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalRestoreByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', record?: { __typename?: 'Primal', _id: any, isDeleted?: boolean | null } | null } | null };

export type PrimalSoftDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalSoftDeleteByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', record?: { __typename?: 'Primal', _id: any, isDeleted?: boolean | null, deletedAt?: any | null } | null } | null };

export type PrimalUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalInput;
}>;


export type PrimalUpdateByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', recordId?: any | null } | null };

export type ProcessingJobForceUpdateStatusMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  processorSchedulingStatus: Scalars['String']['input'];
}>;


export type ProcessingJobForceUpdateStatusMutation = { __typename?: 'Mutation', processingJobForceUpdateStatus?: { __typename?: 'ProcessorSchedulingForceUpdateStatusResponse', recordId?: any | null, previousStatus?: string | null, newStatus?: string | null, record?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null } | null } | null };

export type ProcessorCapabilityUpsertMutationVariables = Exact<{
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  canSelectMoreThanOneTrim: Scalars['Boolean']['input'];
  trimSelection: EnumProcessorCapabilityTrimSelection;
  extras?: InputMaybe<Array<ProcessorCapabilityExtrasModelInput> | ProcessorCapabilityExtrasModelInput>;
  trim?: InputMaybe<Array<ProcessorCapabilityTrimModelInput> | ProcessorCapabilityTrimModelInput>;
  specifications?: InputMaybe<Array<ProcessorCapabilitySpecificationSpecificationsInput> | ProcessorCapabilitySpecificationSpecificationsInput>;
  primalGroups?: InputMaybe<Array<ProcessorCapabilityPrimalGroupInput> | ProcessorCapabilityPrimalGroupInput>;
  newCutBlockers?: InputMaybe<Scalars['JSON']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImage?: InputMaybe<Scalars['Upload']['input']>;
  extrasImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  trimImage?: InputMaybe<Scalars['Upload']['input']>;
  trimImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorCapabilityUpsertMutation = { __typename?: 'Mutation', processorCapabilityUpsert?: { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null } | null };

export type ProcessorDepositPaymentIntentCreateMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type ProcessorDepositPaymentIntentCreateMutation = { __typename?: 'Mutation', processorDepositPaymentIntentCreate?: { __typename?: 'DepositPaymentIntentResponse', clientSecret: string, connectedAccountId: string } | null };

export type ProcessorExportCsvMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  type: ProcessorExportTypeEnum;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ExportColumnInput>> | InputMaybe<ExportColumnInput>>;
  sort?: InputMaybe<Array<InputMaybe<ExportSortInput>> | InputMaybe<ExportSortInput>>;
  filters?: InputMaybe<Array<InputMaybe<ExportFilterInput>> | InputMaybe<ExportFilterInput>>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorExportCsvMutation = { __typename?: 'Mutation', processorExportCsv?: { __typename?: 'ProcessorExportCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorExportCsvByVendorIdMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorExportCsvByVendorIdMutation = { __typename?: 'Mutation', processorExportCsvByVendorId?: { __typename?: 'ProcessorExportCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  updatedAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadUpdatesInput>> | InputMaybe<AnimalHeadUpdatesInput>>;
}>;


export type ProcessorSchedulingAnimalHeadBulkUpdateMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadBulkUpdate?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingAnimalHeadDeleteMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingAnimalHeadDeleteMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadDelete?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingPartialUpdateAnimalHeadInput;
  suppressNotifications?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, tracking?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, killDate?: any | null } | null> | null } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingBulkActionMutationVariables = Exact<{
  jobs: Array<ProcessorSchedulingBulkActionJobInput> | ProcessorSchedulingBulkActionJobInput;
}>;


export type ProcessorSchedulingBulkActionMutation = { __typename?: 'Mutation', processorSchedulingBulkAction?: { __typename?: 'ProcessorSchedulingBulkActionResponse', results?: Array<{ __typename?: 'ProcessorSchedulingBulkActionResult', processorSchedulingId: any, warnings?: Array<string> | null, error?: string | null, record?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, killedDate?: any | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, producerIdentifier?: string | null, tracking?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, isHangingWeightPerSide?: boolean | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, liveWeight?: number | null, killDate?: any | null, cutDate?: any | null } | null> | null } | null }> | null } | null };

export type ProcessorSchedulingBuyerCutsheetReminderMutationVariables = Exact<{
  schedulingId: Scalars['MongoID']['input'];
  contactUserId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingBuyerCutsheetReminderMutation = { __typename?: 'Mutation', processorSchedulingBuyerCutsheetReminder?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingCutsheetReminderMutationVariables = Exact<{
  schedulingId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingCutsheetReminderMutation = { __typename?: 'Mutation', processorSchedulingCutsheetReminder?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, recurringSeries?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, sendNotifications?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, hasCutsheetNeededNotification?: boolean | null, hasCutsheetReminderNotification?: boolean | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, additionalPickupDetails?: string | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus, changedByName?: string | null } | null> | null, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationVia, respondedByName?: string | null } | null, customerConfirmationHistory?: Array<{ __typename?: 'ProcessorSchedulingCustomerConfirmationHistory', status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationHistoryVia, respondedByName?: string | null } | null> | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, sendNotifications?: boolean | null, status?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, statusChanges?: Array<{ __typename?: 'AnimalStatusChange', date?: any | null, previousStatus?: string | null, newStatus?: string | null, changedByName?: string | null } | null> | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, settlementStatus?: { __typename?: 'SplitSettlementView', billable: boolean, progress?: string | null, ready: boolean, collected: boolean, settled: boolean, invoiced: boolean, invoiceId?: any | null, invoiceNumber?: string | null, invoiceStatus?: string | null, settlementMethod?: string | null, payerLabel?: string | null, payerParty?: string | null, producerSettled?: boolean | null } | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type ProcessorSchedulingCutsheetsPartialUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: Array<InputMaybe<CutsheetPartialUpdateInput>> | InputMaybe<CutsheetPartialUpdateInput>;
}>;


export type ProcessorSchedulingCutsheetsPartialUpdateMutation = { __typename?: 'Mutation', processorSchedulingUpdateCutsheets?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null } | null };

export type ProcessorSchedulingDepositChargeCardMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type ProcessorSchedulingDepositChargeCardMutation = { __typename?: 'Mutation', processorSchedulingDepositChargeCard?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null } | null } | null };

export type ProcessorSchedulingDepositCheckStripeMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingDepositCheckStripeMutation = { __typename?: 'Mutation', processorSchedulingDepositCheckStripe?: { __typename?: 'DepositCheckStripeResponse', found: boolean, message: string, scheduling?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null } | null } | null } | null };

export type ProcessorSchedulingDepositMarkPaidMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  method: DepositManualMethod;
}>;


export type ProcessorSchedulingDepositMarkPaidMutation = { __typename?: 'Mutation', processorSchedulingDepositMarkPaid?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null } | null } | null };

export type ProcessorSchedulingDragAndDropUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  eventType: Scalars['String']['input'];
  eventDate: Scalars['String']['input'];
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type ProcessorSchedulingDragAndDropUpdateMutation = { __typename?: 'Mutation', processorSchedulingDragAndDropUpdate?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingDropoffConfirmationSetMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorSchedulingDropoffConfirmationSetMutation = { __typename?: 'Mutation', processorSchedulingDropoffConfirmationSet?: { __typename?: 'ProcessorScheduling', _id: any, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationVia, respondedByName?: string | null } | null, customerConfirmationHistory?: Array<{ __typename?: 'ProcessorSchedulingCustomerConfirmationHistory', status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationHistoryVia, respondedByName?: string | null } | null> | null } | null };

export type ProcessorSchedulingGenerateBillingStatementMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateBillingStatementMutation = { __typename?: 'Mutation', processorSchedulingGenerateBillingStatement?: { __typename?: 'GenerateBillingStatementResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateBulkCarcassTagsMutationVariables = Exact<{
  processorSchedulingIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  killDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorSchedulingGenerateBulkCarcassTagsMutation = { __typename?: 'Mutation', processorSchedulingGenerateBulkCarcassTags?: { __typename?: 'GenerateBulkCarcassTagsResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateBulkCutsheetRequestsMutationVariables = Exact<{
  requests: Array<BulkCutsheetRequestInput> | BulkCutsheetRequestInput;
}>;


export type ProcessorSchedulingGenerateBulkCutsheetRequestsMutation = { __typename?: 'Mutation', processorSchedulingGenerateBulkCutsheetRequests?: { __typename?: 'GenerateBulkCutsheetsResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateCarcassTagsMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type ProcessorSchedulingGenerateCarcassTagsMutation = { __typename?: 'Mutation', processorSchedulingGenerateCarcassTags?: { __typename?: 'GenerateCarcassTagsResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateCsvByVendorIdMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingGenerateCsvByVendorIdMutation = { __typename?: 'Mutation', processorSchedulingGenerateCsvByVendorId?: { __typename?: 'GenerateCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingGenerateCutsheetRequestMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  cutsheetRequestId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateCutsheetRequestMutation = { __typename?: 'Mutation', processorSchedulingGenerateCutsheetRequest?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateHangingWeightCsvMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingGenerateHangingWeightCsvMutation = { __typename?: 'Mutation', processorSchedulingGenerateHangingWeightCsv?: { __typename?: 'GenerateHangingWeightCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingGenerateKillSheetMutationVariables = Exact<{
  date: Scalars['Date']['input'];
}>;


export type ProcessorSchedulingGenerateKillSheetMutation = { __typename?: 'Mutation', processorSchedulingGenerateKillSheet?: { __typename?: 'GenerateKillSheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGeneratePackingSlipMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  cutsheetInformationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ProcessorSchedulingGeneratePackingSlipMutation = { __typename?: 'Mutation', processorSchedulingGeneratePackingSlip?: { __typename?: 'GeneratePackingSlipResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingNotificationSendMutationVariables = Exact<{
  type?: InputMaybe<Scalars['NotificationTypeInput']['input']>;
  notificationRequest?: InputMaybe<NotificationRequestInput>;
}>;


export type ProcessorSchedulingNotificationSendMutation = { __typename?: 'Mutation', processorSchedulingNotificationSend?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingPartialUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingPartialUpdateInput;
  suppressNotifications?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorSchedulingPartialUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: Array<InputMaybe<CutsheetPartialUpdateInput>> | InputMaybe<CutsheetPartialUpdateInput>;
}>;


export type ProcessorSchedulingCutsheetInformationPartialUpdateMutation = { __typename?: 'Mutation', processorSchedulingUpdateCutsheets?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null } | null };

export type ProcessorSchedulingResendDepositNotificationMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingResendDepositNotificationMutation = { __typename?: 'Mutation', processorSchedulingResendDepositNotification?: { __typename?: 'ProcessorScheduling', _id: any, deposit?: { __typename?: 'ProcessorSchedulingDeposit', method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null } | null } | null };

export type ProcessorSchedulingSendManualNotificationMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  notificationSettingId: Scalars['MongoID']['input'];
  recipients: Array<ManualNotificationRecipientInput> | ManualNotificationRecipientInput;
}>;


export type ProcessorSchedulingSendManualNotificationMutation = { __typename?: 'Mutation', processorSchedulingSendManualNotification?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingSplitTypeUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingSplitTypeUpdateInput;
}>;


export type ProcessorSchedulingSplitTypeUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingSplitTypeUpdateById?: { __typename?: 'ProcessorSchedulingSplitTypeUpdateResponse', recordId?: any | null } | null };

export type ProcessorSchedulingTagsUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  addTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  removeTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type ProcessorSchedulingTagsUpdateMutation = { __typename?: 'Mutation', processorSchedulingPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }> } | null } | null };

export type ProcessorSchedulingUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSchedulingInput;
}>;


export type ProcessorSchedulingUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingUpdate?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, status?: string | null } | null> | null } | null } | null };

export type ProcessorSettingsCreateMutationVariables = Exact<{
  newProcessorSettings: CreateProcessorSettingsWithCustomCapacityInput;
}>;


export type ProcessorSettingsCreateMutation = { __typename?: 'Mutation', processorSettingsCreate?: { __typename?: 'CreateProcessorSettingsWithCustomCapacity', processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type ProcessorSettingsCustomCapacityCreateOneMutationVariables = Exact<{
  record: CreateOneProcessorSettingsCustomCapacityInput;
}>;


export type ProcessorSettingsCustomCapacityCreateOneMutation = { __typename?: 'Mutation', processorSettingsCustomCapacityCreateOne?: { __typename?: 'CreateOneProcessorSettingsCustomCapacityPayload', recordId?: any | null } | null };

export type ProcessorSettingsCustomCapacityUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsCustomCapacityInput;
}>;


export type ProcessorSettingsCustomCapacityUpdateByIdMutation = { __typename?: 'Mutation', processorSettingsCustomCapacityUpdateById?: { __typename?: 'UpdateByIdProcessorSettingsCustomCapacityPayload', recordId?: any | null } | null };

export type ProcessorSettingsUpdateMutationVariables = Exact<{
  updateProcessorSettings: UpdateProcessorSettingsWithCustomCapacityInput;
}>;


export type ProcessorSettingsUpdateMutation = { __typename?: 'Mutation', processorSettingsUpdate?: { __typename?: 'UpdateProcessorSettingsWithCustomCapacity', processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type ProducerSettingsUpdateMutationVariables = Exact<{
  splitDeposits: Array<ProducerSplitDepositInput> | ProducerSplitDepositInput;
  listingPresets?: InputMaybe<Array<ProducerListingPresetInput> | ProducerListingPresetInput>;
}>;


export type ProducerSettingsUpdateMutation = { __typename?: 'Mutation', producerSettingsUpdate?: { __typename?: 'ProducerSettings', producer?: any | null, splitDeposits: Array<{ __typename?: 'ProducerSplitDeposit', species: string, whole?: number | null, half?: number | null, quarter?: number | null }>, listingPresets?: Array<{ __typename?: 'ProducerListingPreset', species: string, pricingMode?: string | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, sizeTier?: string | null, allowedSectionSizes?: Array<string | null> | null, descriptorChips?: Array<string | null> | null, description?: string | null } | null> | null } | null };

export type RecurringSeriesCancelUpcomingJobsMutationVariables = Exact<{
  seriesId: Scalars['MongoID']['input'];
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  customText?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringSeriesCancelUpcomingJobsMutation = { __typename?: 'Mutation', recurringSeriesCancelUpcomingJobs?: { __typename?: 'RecurringSeriesCancelUpcomingResponse', cancelled: number } | null };

export type RecurringSeriesCreateMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: Scalars['String']['input'];
  inspectionLevel: Scalars['String']['input'];
  headCount: Scalars['Int']['input'];
  rule: RecurrenceRuleInput;
  targetUpcomingCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecurringSeriesCreateMutation = { __typename?: 'Mutation', recurringSeriesCreate: { __typename?: 'RecurringSeries', _id: any, active: boolean } };

export type RecurringSeriesCreateFromJobMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  rule: RecurrenceRuleInput;
  targetUpcomingCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecurringSeriesCreateFromJobMutation = { __typename?: 'Mutation', recurringSeriesCreateFromJob: { __typename?: 'RecurringSeries', _id: any, active: boolean } };

export type RecurringSeriesSetActiveMutationVariables = Exact<{
  seriesId: Scalars['MongoID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type RecurringSeriesSetActiveMutation = { __typename?: 'Mutation', recurringSeriesSetActive: { __typename?: 'RecurringSeries', _id: any, active: boolean } };

export type RecurringSeriesUpdateRuleMutationVariables = Exact<{
  seriesId: Scalars['MongoID']['input'];
  rule: RecurrenceRuleInput;
  targetUpcomingCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecurringSeriesUpdateRuleMutation = { __typename?: 'Mutation', recurringSeriesUpdateRule: { __typename?: 'RecurringSeries', _id: any, active: boolean, nextOccurrence?: any | null, targetUpcomingCount?: number | null, rule: { __typename?: 'RecurringSeriesRule', freq: EnumRecurringSeriesRuleFreq, interval: number, anchor: string, byMonthDay?: Array<number | null> | null, until?: string | null, count?: number | null, byDay?: Array<{ __typename?: 'RecurringSeriesRuleByDay', ordinal?: number | null, day: EnumRecurringSeriesRuleByDayDay } | null> | null } } };

export type CreateFinancialReportingConfigMutationVariables = Exact<{
  record: CreateOneFinancialReportingConfigInput;
}>;


export type CreateFinancialReportingConfigMutation = { __typename?: 'Mutation', financialReportingConfigCreateOne?: { __typename?: 'CreateOneFinancialReportingConfigPayload', record?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type UpdateProcessorWorkflowCapacityMutationVariables = Exact<{
  capacity: Scalars['JSON']['input'];
}>;


export type UpdateProcessorWorkflowCapacityMutation = { __typename?: 'Mutation', processorWorkflowCapacityUpdate: any };

export type UpdateFinancialReportingConfigMutationVariables = Exact<{
  filter: FilterUpdateOneFinancialReportingConfigInput;
  record: UpdateOneFinancialReportingConfigInput;
}>;


export type UpdateFinancialReportingConfigMutation = { __typename?: 'Mutation', financialReportingConfigUpdateOne?: { __typename?: 'UpdateOneFinancialReportingConfigPayload', record?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, updatedAt?: any | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type SendMessageMutationVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  message: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'ChatMessage', _id: any, content?: string | null, imageUrl?: string | null, isNotification?: boolean | null, animal?: any | null, animalSpecies?: string | null, readAt?: any | null, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, notificationPrompt?: { __typename?: 'NotificationPromptState', _id: string, kind: string, status: string, canAnswer: boolean, jobId?: string | null, expiresAt?: any | null } | null, sender?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null } | null };

export type SendTestNotificationMutationVariables = Exact<{
  notificationSettingId: Scalars['MongoID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  emailContent?: InputMaybe<Scalars['String']['input']>;
  smsContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification?: { __typename?: 'SendTestNotificationResult', emailSent: boolean, smsSent: boolean, errors: Array<string> } | null };

export type SplitSendNotificationsUpdateMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  sendNotifications: Scalars['Boolean']['input'];
}>;


export type SplitSendNotificationsUpdateMutation = { __typename?: 'Mutation', splitSendNotificationsUpdate?: { __typename?: 'Split', _id: any, sendNotifications?: boolean | null } | null };

export type ProducerStripeAccountCreateMutationVariables = Exact<{ [key: string]: never; }>;


export type ProducerStripeAccountCreateMutation = { __typename?: 'Mutation', producerStripeAccountCreate?: { __typename?: 'ProducerStripeConfig', id?: string | null, status?: string | null } | null };

export type ProducerStripeSessionCreateMutationVariables = Exact<{ [key: string]: never; }>;


export type ProducerStripeSessionCreateMutation = { __typename?: 'Mutation', producerStripeSessionCreate?: { __typename?: 'ProducerStripeSession', clientSecret?: string | null } | null };

export type StripeAccountCreateMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type StripeAccountCreateMutation = { __typename?: 'Mutation', stripeAccountCreate?: { __typename?: 'Vendor', _id: any, stripe_config?: any | null } | null };

export type StripeSessionCreateMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type StripeSessionCreateMutation = { __typename?: 'Mutation', stripeSessionCreate?: { __typename?: 'Vendor', _id: any, stripe_config?: any | null } | null };

export type UpdateAuthMethodMutationVariables = Exact<{
  targetAuthMethod: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAuthMethodMutation = { __typename?: 'Mutation', updateAuthMethod?: { __typename?: 'UpdateAuthMethodPayload', success: boolean, message: string, authMethod: string } | null };

export type UpdateProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInputForProfile>;
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveSms?: InputMaybe<Scalars['Boolean']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  boxImageUrl?: InputMaybe<Scalars['String']['input']>;
  buyerChips?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  buyerBio?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, picture_url?: string | null, tos_accepted_at?: any | null, privacy_policy_accepted_at?: any | null, can_receive_email_updates?: boolean | null, can_receive_sms?: boolean | null, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null } | null };

export type UserBasicUpsertMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInputForUser>;
  relationships?: InputMaybe<Array<InputMaybe<RelationshipsInputForUser>> | InputMaybe<RelationshipsInputForUser>>;
}>;


export type UserBasicUpsertMutation = { __typename?: 'Mutation', userBasicUpsert?: { __typename?: 'UserBasicUpsertPayload', message?: string | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, role?: EnumUserRole | null, enabled: boolean, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null } | null };

export type UserHangTimePreferenceUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
  preferredDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserHangTimePreferenceUpdateMutation = { __typename?: 'Mutation', userHangTimePreferenceUpdate?: { __typename?: 'HangTimePreferenceResponse', success: boolean } | null };

export type UserRebookingOverrideUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserRebookingOverrideUpdateMutation = { __typename?: 'Mutation', userRebookingOverrideUpdate?: { __typename?: 'CustomerRebookingCadence', latestDropoffDate?: any | null, autoIntervalDays?: number | null, overrideIntervalDays?: number | null, effectiveIntervalDays?: number | null, dueSoonWindowDays?: number | null, expectedNextBookingDate?: any | null, rebookingStatus?: string | null, rebookingIntervalSource?: string | null } | null };

export type UserSettingsUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  settings: UserSettingsInput;
}>;


export type UserSettingsUpdateMutation = { __typename?: 'Mutation', userSettingsUpdate?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, slug?: string | null, picture_url?: string | null, banner_url?: string | null, box_image_url?: string | null, bio?: string | null, role?: EnumUserRole | null, enabled: boolean, auth_method?: EnumUserAuth_Method | null, can_receive_sms?: boolean | null, can_receive_email_updates?: boolean | null, _id: any, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }>, tenant?: { __typename?: 'Tenant', _id: any, picture_url?: string | null } | null } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type UserUpdateActiveVendorMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  active_vendor: Scalars['MongoID']['input'];
}>;


export type UserUpdateActiveVendorMutation = { __typename?: 'Mutation', userUpdateById?: { __typename?: 'UpdateByIdUserPayload', recordId?: any | null } | null };

export type UserUpdateRoleMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  role: EnumUserRole;
}>;


export type UserUpdateRoleMutation = { __typename?: 'Mutation', userUpdateById?: { __typename?: 'UpdateByIdUserPayload', record?: { __typename?: 'User', _id: any, role?: EnumUserRole | null, first_name?: string | null, last_name?: string | null, email?: string | null } | null } | null };

export type VendorAddOnJobSplitMutationVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  splitPart: Scalars['String']['input'];
  buyerId: Scalars['MongoID']['input'];
}>;


export type VendorAddOnJobSplitMutation = { __typename?: 'Mutation', vendorAddOnJobSplit?: { __typename?: 'Animal', _id: any } | null };

export type VendorAnimalStatusUpdateMutationVariables = Exact<{
  animalIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
}>;


export type VendorAnimalStatusUpdateMutation = { __typename?: 'Mutation', vendorAnimalStatusUpdate?: { __typename?: 'AnimalStatusUpdatePayload', jobId: any, updatedCount: number, skippedCount: number, skippedLabels: Array<string>, jobStatus?: string | null } | null };

export type VendorCopySettingsMutationVariables = Exact<{
  sourceVendorId: Scalars['MongoID']['input'];
  targetVendorId: Scalars['MongoID']['input'];
  buckets: Array<Scalars['String']['input']> | Scalars['String']['input'];
  species?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type VendorCopySettingsMutation = { __typename?: 'Mutation', vendorCopySettings?: any | null };

export type VendorCreateInHouseProducerMutationVariables = Exact<{
  name: Scalars['String']['input'];
  photo: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type VendorCreateInHouseProducerMutation = { __typename?: 'Mutation', vendorCreateInHouseProducer?: { __typename?: 'InHouseProducer', id?: any | null, slug?: string | null, company?: string | null } | null };

export type VendorCustomerNotificationDefaultsUpdateMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  job: Scalars['Boolean']['input'];
  animal: Scalars['Boolean']['input'];
  split: Scalars['Boolean']['input'];
}>;


export type VendorCustomerNotificationDefaultsUpdateMutation = { __typename?: 'Mutation', vendorCustomerNotificationDefaultsUpdate?: { __typename?: 'CustomerNotificationDefaults', job: boolean, animal: boolean, split: boolean } | null };

export type VendorDeclineRequestMutationVariables = Exact<{
  requestId: Scalars['MongoID']['input'];
}>;


export type VendorDeclineRequestMutation = { __typename?: 'Mutation', vendorDeclineRequest?: { __typename?: 'MarketplaceRequest', _id: any, active?: boolean | null, declinedAt?: any | null } | null };

export type VendorHerdAnimalDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type VendorHerdAnimalDeleteMutation = { __typename?: 'Mutation', vendorHerdAnimalDelete?: { __typename?: 'Animal', _id: any } | null };

export type VendorHerdAnimalUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  species?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  hangTimeDays?: InputMaybe<Scalars['Int']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  availableToBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  allowedSectionSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  claimMode?: InputMaybe<Scalars['String']['input']>;
  sizeTier?: InputMaybe<Scalars['String']['input']>;
  liveWeightHigh?: InputMaybe<Scalars['Float']['input']>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
  listingDeposits?: InputMaybe<MyAnimalListingDepositsInput>;
  descriptorChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  producerDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type VendorHerdAnimalUpdateMutation = { __typename?: 'Mutation', vendorHerdAnimalUpdate?: { __typename?: 'Animal', _id: any, species: string, tracking?: string | null, splitType?: string | null, liveWeight?: number | null, sex?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, availableToBuyers?: boolean | null, allowedSectionSizes?: Array<string | null> | null, claimMode?: EnumAnimalClaimMode | null, sizeTier?: EnumAnimalSizeTier | null, liveWeightHigh?: number | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, descriptorChips?: Array<string | null> | null, producerDescription?: string | null, remainingCapacity?: number | null, isFull?: boolean | null, listingDeposits?: { __typename?: 'AnimalListingDeposits', whole?: number | null, half?: number | null, quarter?: number | null } | null } | null };

export type VendorHerdAssignAnimalsToJobMutationVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  animalIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
}>;


export type VendorHerdAssignAnimalsToJobMutation = { __typename?: 'Mutation', vendorHerdAssignAnimalsToJob?: { __typename?: 'HerdAssignToJobPayload', jobId: any, assignedCount: number } | null };

export type VendorHerdQuickAddMutationVariables = Exact<{
  producer: HerdIntakeProducerInput;
  animals: Array<QuickAddAnimalInput> | QuickAddAnimalInput;
}>;


export type VendorHerdQuickAddMutation = { __typename?: 'Mutation', vendorHerdQuickAdd?: Array<{ __typename?: 'Animal', _id: any, species: string, tracking?: string | null, splitType?: string | null, producerIdentifier?: string | null, status?: string | null, jobId?: string | null } | null> | null };

export type VendorHerdAnimalSetSplitBuyersMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  splits: Array<HerdSplitBuyerInput> | HerdSplitBuyerInput;
}>;


export type VendorHerdAnimalSetSplitBuyersMutation = { __typename?: 'Mutation', vendorHerdAnimalSetSplitBuyers?: { __typename?: 'Animal', _id: any, splits?: Array<{ __typename?: 'Split', splitPart?: string | null, buyer?: { __typename?: 'User', _id: any } | null } | null> | null } | null };

export type VendorInHouseProducerSettingsUpdateMutationVariables = Exact<{
  splitDeposits: Array<ProducerSplitDepositInput> | ProducerSplitDepositInput;
  listingPresets?: InputMaybe<Array<ProducerListingPresetInput> | ProducerListingPresetInput>;
}>;


export type VendorInHouseProducerSettingsUpdateMutation = { __typename?: 'Mutation', vendorInHouseProducerSettingsUpdate?: { __typename?: 'ProducerSettings', producer?: any | null, splitDeposits: Array<{ __typename?: 'ProducerSplitDeposit', species: string, whole?: number | null, half?: number | null, quarter?: number | null }>, listingPresets?: Array<{ __typename?: 'ProducerListingPreset', species: string, pricingMode?: string | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, sizeTier?: string | null, allowedSectionSizes?: Array<string | null> | null, descriptorChips?: Array<string | null> | null, description?: string | null } | null> | null } | null };

export type VendorLinkInHouseProducerMutationVariables = Exact<{
  producerUserId: Scalars['MongoID']['input'];
  confirmStaffAccount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VendorLinkInHouseProducerMutation = { __typename?: 'Mutation', vendorLinkInHouseProducer?: { __typename?: 'InHouseProducer', id?: any | null, slug?: string | null, company?: string | null, picture_url?: string | null } | null };

export type VendorNudgeSectionBuyerMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type VendorNudgeSectionBuyerMutation = { __typename?: 'Mutation', vendorNudgeSectionBuyer?: { __typename?: 'VendorNudgeSectionBuyerPayload', splitId: any, nudgeCase: string, nudgedAt: any } | null };

export type VendorPlaceRequestOnAnimalMutationVariables = Exact<{
  requestId: Scalars['MongoID']['input'];
  animalId: Scalars['MongoID']['input'];
}>;


export type VendorPlaceRequestOnAnimalMutation = { __typename?: 'Mutation', vendorPlaceRequestOnAnimal?: { __typename?: 'MarketplaceRequest', _id: any, active?: boolean | null, fulfilledSplit?: any | null, fulfilledAt?: any | null } | null };

export type VendorReassignBuyerSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
  newBuyerId: Scalars['MongoID']['input'];
}>;


export type VendorReassignBuyerSplitMutation = { __typename?: 'Mutation', vendorReassignBuyerSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null, buyer?: { __typename?: 'User', _id: any } | null } | null };

export type VendorRecordAnimalSettlementMutationVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  method: Scalars['String']['input'];
}>;


export type VendorRecordAnimalSettlementMutation = { __typename?: 'Mutation', vendorRecordAnimalSettlement?: { __typename?: 'AnimalSettlementReport', animalId: any, method: string, settledCount: number, skippedCount: number, errorCount: number, results: Array<{ __typename?: 'AnimalSettlementSplitResult', splitId: any, splitPart?: string | null, outcome: string, skipReason?: string | null, message?: string | null, invoiceId?: any | null }> } | null };

export type VendorReleaseBuyerSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type VendorReleaseBuyerSplitMutation = { __typename?: 'Mutation', vendorReleaseBuyerSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null, isDeleted?: boolean | null } | null };

export type VendorRemoveBuyerSplitMutationVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type VendorRemoveBuyerSplitMutation = { __typename?: 'Mutation', vendorRemoveBuyerSplit?: { __typename?: 'Split', _id: any, status?: EnumSplitStatus | null } | null };

export type VendorSyncInHouseProducerMutationVariables = Exact<{ [key: string]: never; }>;


export type VendorSyncInHouseProducerMutation = { __typename?: 'Mutation', vendorSyncInHouseProducer: { __typename?: 'VendorSyncInHouseProducerResult', changed: Array<string>, unavailable: Array<string> } };

export type VendorTeamMemberInviteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: EnumUserRole;
}>;


export type VendorTeamMemberInviteMutation = { __typename?: 'Mutation', vendorTeamMemberInvite?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, role?: EnumUserRole | null, enabled: boolean } | null };

export type VendorTeamMemberRoleUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  role: EnumUserRole;
}>;


export type VendorTeamMemberRoleUpdateMutation = { __typename?: 'Mutation', vendorTeamMemberRoleUpdate?: { __typename?: 'User', _id: any, role?: EnumUserRole | null } | null };

export type VendorTeamMemberSetEnabledMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type VendorTeamMemberSetEnabledMutation = { __typename?: 'Mutation', vendorTeamMemberSetEnabled?: { __typename?: 'User', _id: any, enabled: boolean } | null };

export type VendorUndoDeclineMutationVariables = Exact<{
  requestId: Scalars['MongoID']['input'];
}>;


export type VendorUndoDeclineMutation = { __typename?: 'Mutation', vendorUndoDecline?: { __typename?: 'MarketplaceRequest', _id: any, active?: boolean | null, declinedAt?: any | null } | null };

export type VendorUndoPlacementMutationVariables = Exact<{
  requestId: Scalars['MongoID']['input'];
}>;


export type VendorUndoPlacementMutation = { __typename?: 'Mutation', vendorUndoPlacement?: { __typename?: 'MarketplaceRequest', _id: any, active?: boolean | null, fulfilledSplit?: any | null, fulfilledAt?: any | null } | null };

export type WaitlistAddMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  animal: Scalars['String']['input'];
  headCount?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
}>;


export type WaitlistAddMutation = { __typename?: 'Mutation', waitlistAdd?: { __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null } | null };

export type WaitlistDeleteMutationVariables = Exact<{
  customerId: Scalars['MongoID']['input'];
}>;


export type WaitlistDeleteMutation = { __typename?: 'Mutation', waitlistDelete?: { __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null } | null };

export type WaitlistUnsubscribeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type WaitlistUnsubscribeMutation = { __typename?: 'Mutation', waitlistUnsubscribe?: { __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null } | null };

export type WaitlistUpdateMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  headCount?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WaitlistUpdateMutation = { __typename?: 'Mutation', waitlistUpdate?: { __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null } | null };

export type ProducerAvailableSplitsQueryVariables = Exact<{
  producerSlug: Scalars['String']['input'];
}>;


export type ProducerAvailableSplitsQuery = { __typename?: 'Query', producerAvailableSplits?: Array<{ __typename?: 'BuyerAvailableAnimal', _id: any, species?: string | null, splitType?: string | null, allowedSectionSizes?: Array<string | null> | null, claimMode?: string | null, descriptorChips?: Array<string | null> | null, remainingCapacity?: number | null, isFull?: boolean | null, distanceMiles?: number | null, vendorId?: any | null, processorName?: string | null, producerName?: string | null, city?: string | null, state?: string | null, slug?: string | null, logoUrl?: string | null, producerLogoUrl?: string | null, createdAt?: string | null, myClaimedSplitId?: any | null, myClaimedSplitPart?: string | null, hasPendingClaim?: boolean | null, myClaimedSplitStatus?: string | null, myClaimedSplitDepositStatus?: string | null, killDate?: string | null, cutDate?: string | null, inspectionLevel?: string | null, reserveByDate?: string | null, datesEstimated?: boolean | null, isPendingAcceptance?: boolean | null, listingRatePerLb?: number | null, isInHouse?: boolean | null, producerId?: any | null, producerSlug?: string | null, sections?: Array<{ __typename?: 'BuyerAvailableAnimalSection', size?: string | null, deposit?: number | null, available?: boolean | null, estimatedTotalLow?: number | null, estimatedTotalHigh?: number | null } | null> | null } | null> | null };

export type ProducerBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProducerBySlugQuery = { __typename?: 'Query', producerBySlug?: { __typename?: 'PublicProducer', _id?: any | null, slug: string, displayName: string, logoUrl?: string | null, bannerUrl?: string | null, bio?: string | null, buyerChips?: Array<string | null> | null, buyerBio?: string | null, city?: string | null, state?: string | null, partnerProcessors: Array<{ __typename?: 'PublicProducerProcessor', slug: string, name: string }> } | null };

export type ViewProcessingPartnerQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewProcessingPartnerQuery = { __typename?: 'Query', processingPartnersOne?: { __typename?: 'processingPartnersOne', _id?: any | null, about?: string | null, slug?: string | null, buyerBio?: string | null, bannerUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, capacityConfigurationType?: ProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays: number, isWaitlistFunctionalityDisabled?: boolean | null, premierProducers?: Array<{ __typename?: 'ProcessingPartnerPremierProducer', producerId?: any | null, badge?: string | null } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, schedulingDeposit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, pickupLocations?: Array<{ __typename?: 'StorefrontPickupLocation', _id: any, name: string, description?: string | null, isDefault?: boolean | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null } | null> | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, stripe_config?: any | null, address?: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null, _id?: any | null } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null } | null };

export type ViewProcessorAdminQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
}>;


export type ViewProcessorAdminQuery = { __typename?: 'Query', processorSettingsOne?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null }>, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, processorCapabilityMany: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null }> };

export type ViewProcessorAdminLightQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
}>;


export type ViewProcessorAdminLightQuery = { __typename?: 'Query', processorSettingsOne?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null }>, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, processorCapabilityMany: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null }> };

export type ViewSchedulingCreateQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  animalSpeciesCutsheet: EnumCutsheetAnimalSpecies;
  animalSpeciesProcessorCapability: EnumProcessorCapabilityAnimalSpecies;
  statuses?: InputMaybe<Array<EnumProcessorSchedulingStatus> | EnumProcessorSchedulingStatus>;
}>;


export type ViewSchedulingCreateQuery = { __typename?: 'Query', cutsheetMany: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }>, processorCapabilityOne?: { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null } | null, processingPartnersOne?: { __typename?: 'processingPartnersOne', _id?: any | null, capacityConfigurationType?: ProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays: number, faq?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, vendor?: { __typename?: 'ProcessingPartnerVendor', shop_name?: string | null, _id?: any | null, address?: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null, _id?: any | null } | null } | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, schedulingDeposit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null } | null, processorSchedulingMany: Array<{ __typename?: 'ProcessorScheduling', _id: any, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, status?: string | null } | null> | null }> };

export type ViewSchedulingEditQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
  isDeleted: Scalars['Boolean']['input'];
}>;


export type ViewSchedulingEditQuery = { __typename?: 'Query', findProcessorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, isDeleted?: boolean | null, status: EnumProcessorSchedulingStatus, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, isKillAndChill?: boolean | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean } | null } | null> | null } | null> | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendorCutsheets: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }>, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, faq?: string | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', isEnabled: boolean, pricePerHead: number, species: EnumProcessorSettingsKillAndChillSettingsSpecies } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, species: EnumProcessorSettingsAnimalSettingsSpecies, schedulingDeposit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, species?: EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies | null, price: number } | null> | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, species?: EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies | null, price: number } | null> | null } | null> | null, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null, _id: any } | null } | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', date: any, capacity?: any | null, isDeleted: boolean, _id: any }>, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', animal?: string | null, price: number } | null> | null } | null, processorCapabilities: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null }> } | null, cutsheetMany: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> };

export type ActiveVendorListQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveVendorListQuery = { __typename?: 'Query', activeVendorList?: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, enabled: boolean } | null> | null };

export type AdminAccountActivityQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  comparisonType?: InputMaybe<ComparisonType>;
}>;


export type AdminAccountActivityQuery = { __typename?: 'Query', adminAccountActivity: any };

export type AdminBusinessStatsQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  comparisonType?: InputMaybe<ComparisonType>;
  consistentCohort?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminBusinessStatsQuery = { __typename?: 'Query', adminBusinessStats: any };

export type AdminUserSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminUserSearchQuery = { __typename?: 'Query', adminUserSearch: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, role?: EnumUserRole | null, enabled: boolean, company?: string | null, active_vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', type?: EnumUserRelationshipsType | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null } | null> | null }> };

export type AdminProducerSearchQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminProducerSearchQuery = { __typename?: 'Query', adminProducerSearch: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null }> };

export type AdminUsersFilteredQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<EnumUserRole> | EnumUserRole>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  relationshipVendorId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipProducerId?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sort: SortFindManyUserInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type AdminUsersFilteredQuery = { __typename?: 'Query', getFilteredUsers?: { __typename?: 'UserPagination', count?: number | null, items?: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, role?: EnumUserRole | null, enabled: boolean, last_login?: number | null, tenant?: { __typename?: 'Tenant', _id: any, name: string } | null, active_vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type LandingPageByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type LandingPageByIdQuery = { __typename?: 'Query', landingPageById?: { __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, slug?: string | null, species?: Array<EnumLandingPageSettingsSpecies | null> | null, about?: string | null, buyerBio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, tagline?: string | null, logoUrl?: string | null, showAddress?: boolean | null, showOnMap?: boolean | null, showInDirectory?: boolean | null, showAbout?: boolean | null, showContact?: boolean | null, showPricing?: boolean | null, showGallery?: boolean | null, showDocuments?: boolean | null, showFaq?: boolean | null, galleryImages?: Array<string | null> | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, shop_slug?: string | null } | null, premierProducers?: Array<{ __typename?: 'LandingPageSettingsPremierProducers', producerId: any, badge: EnumLandingPageSettingsPremierProducersBadge } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, type: EnumAddressType } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null, pricingRows?: Array<{ __typename?: 'LandingPageSettingsPricingRows', _id?: any | null, label: string, price?: number | null, unit?: string | null, notes?: string | null } | null> | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null } | null, documents?: Array<{ __typename?: 'LandingPageSettingsDocuments', _id?: any | null, name: string, description?: string | null, fileUrl: string } | null> | null, faq?: Array<{ __typename?: 'LandingPageSettingsFaq', _id?: any | null, question: string, answer: string } | null> | null } | null };

export type LandingPageListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  linkStatus?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortFindManyLandingPageSettingsInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type LandingPageListQuery = { __typename?: 'Query', landingPageList?: { __typename?: 'LandingPageSettingsPagination', count?: number | null, items?: Array<{ __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, tagline?: string | null, logoUrl?: string | null, showInDirectory?: boolean | null, showOnMap?: boolean | null, createdAt?: any | null, updatedAt?: any | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type MarketplaceLeadSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarketplaceLeadSearchQuery = { __typename?: 'Query', marketplaceLeadSearch?: { __typename?: 'MarketplaceLeadSearchResult', total: number, records: Array<{ __typename?: 'MarketplaceLead', _id: any, species: EnumMarketplaceLeadSpecies, quantity: EnumMarketplaceLeadQuantity, timeline: EnumMarketplaceLeadTimeline, postcode: string, name: string, email: string, phone: string, note?: string | null, source?: EnumMarketplaceLeadSource | null, createdAt?: any | null, location?: { __typename?: 'MarketplaceLeadLocation', coordinates?: Array<number | null> | null } | null }> } | null };

export type TenantByIdQueryVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
}>;


export type TenantByIdQuery = { __typename?: 'Query', tenantById?: { __typename?: 'Tenant', _id: any, date_created: any, domain?: string | null, email: string, enabled: boolean, external_id?: string | null, external_ids?: any | null, name: string, picture_url?: string | null, primary_color?: string | null, users: Array<{ __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, enabled: boolean, _id: any }>, vendors: Array<{ __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, shop_url?: string | null, tagline?: string | null, prefers_dropoff?: boolean | null, pickup_days?: Array<number | null> | null, free_shipping_amount?: number | null, enabled: boolean, show_in_directory: boolean, is_demo?: boolean | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', config?: any | null, name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, keyHint?: string | null, _id: any }>, processorSettings?: { __typename?: 'ProcessorSettings', isEnabled?: boolean | null, commercialStartDate?: any | null, _id: any } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }> }> } | null };

export type TenantFilteredQueryVariables = Exact<{
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyTenantInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type TenantFilteredQuery = { __typename?: 'Query', getFilteredTenants?: { __typename?: 'TenantPagination', count?: number | null, items?: Array<{ __typename?: 'Tenant', _id: any, external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, users: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, role?: EnumUserRole | null }>, vendors: Array<{ __typename?: 'Vendor', _id: any, date_created: any, shop_name: string, shop_slug?: string | null, enabled: boolean }> }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type TenantPaginationQueryVariables = Exact<{
  sort: SortFindManyTenantInput;
  filter: FilterFindManyTenantInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type TenantPaginationQuery = { __typename?: 'Query', tenantPagination?: { __typename?: 'TenantPagination', count?: number | null, items?: Array<{ __typename?: 'Tenant', external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, _id: any, users: Array<{ __typename?: 'User', first_name?: string | null, last_name?: string | null, role?: EnumUserRole | null, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, shop_name: string, shop_slug?: string | null, enabled: boolean, _id: any }> }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type BuyerActiveHoldsQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerActiveHoldsQuery = { __typename?: 'Query', buyerActiveHolds?: Array<{ __typename?: 'BuyerActiveHold', _id: any, splitPart?: string | null, holdExpiresAt?: any | null, placementHoldAt?: any | null, depositAmount?: number | null, vendorId?: any | null, processorName?: string | null, city?: string | null, state?: string | null, slug?: string | null, animal?: { __typename?: 'BuyerActiveHoldAnimal', _id: any, species?: string | null, killDate?: string | null, cutDate?: string | null, reserveByDate?: string | null } | null } | null> | null };

export type BuyerAnimalDetailQueryVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
}>;


export type BuyerAnimalDetailQuery = { __typename?: 'Query', buyerAnimalDetail?: { __typename?: 'BuyerAnimalDetail', _id: any, species?: string | null, processorName?: string | null, producerName?: string | null, producerSlug?: string | null, producerLogoUrl?: string | null, producerId?: any | null, vendorId?: any | null, killDate?: string | null, cutDate?: string | null, estimatedPickupDate?: string | null, reserveByDate?: string | null, hangTimeDays?: number | null, remainingCapacity?: number | null, totalCapacity?: number | null, isFull?: boolean | null, descriptorChips?: Array<string | null> | null, producerDescription?: string | null, city?: string | null, state?: string | null, slug?: string | null, address?: string | null, myClaimedSplitId?: any | null, myClaimedSplitPart?: string | null, myAssignedSplitId?: any | null, myPickupLocationId?: any | null, hasPendingClaim?: boolean | null, myClaimedSplitStatus?: string | null, myClaimedSplitDepositStatus?: string | null, isPendingAcceptance?: boolean | null, iOwnThis?: boolean | null, sellable?: boolean | null, isMarketplaceListing?: boolean | null, actualHangingWeight?: number | null, thirdPartyFee?: number | null, finalAnimalPrice?: number | null, listingUnavailable?: boolean | null, location?: { __typename?: 'BuyerAnimalDetailLocation', lat: number, lng: number } | null, pickupLocations?: Array<{ __typename?: 'BuyerAnimalDetailPickupLocation', _id: any, name: string, description?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, isDefault?: boolean | null, location?: { __typename?: 'BuyerAnimalDetailLocation', lat: number, lng: number } | null } | null> | null, sections?: Array<{ __typename?: 'BuyerAnimalDetailSection', size: string, deposit?: number | null, available: boolean, estimatedTotalLow?: number | null, estimatedTotalHigh?: number | null } | null> | null, costBreakdown?: Array<{ __typename?: 'BuyerAnimalDetailCostBreakdown', size?: string | null, meatLow?: number | null, meatHigh?: number | null, processingLow?: number | null, processingHigh?: number | null, deposit?: number | null, sizeTier?: string | null, weightRingLow?: number | null, weightRingHigh?: number | null, dressingYieldLow?: number | null, dressingYieldHigh?: number | null, hangingWeightLow?: number | null, hangingWeightHigh?: number | null, takeHomeMeatLow?: number | null, takeHomeMeatHigh?: number | null } | null> | null } | null };

export type BuyerAvailableAnimalsQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  anyDistance?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sectionSize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  pickupMonth?: InputMaybe<Scalars['String']['input']>;
}>;


export type BuyerAvailableAnimalsQuery = { __typename?: 'Query', buyerAvailableAnimals?: Array<{ __typename?: 'BuyerAvailableAnimal', _id: any, species?: string | null, splitType?: string | null, allowedSectionSizes?: Array<string | null> | null, claimMode?: string | null, descriptorChips?: Array<string | null> | null, remainingCapacity?: number | null, isFull?: boolean | null, distanceMiles?: number | null, vendorId?: any | null, processorName?: string | null, producerName?: string | null, city?: string | null, state?: string | null, slug?: string | null, pickupLat?: number | null, pickupLng?: number | null, producerLat?: number | null, producerLng?: number | null, logoUrl?: string | null, producerLogoUrl?: string | null, producerBannerUrl?: string | null, producerBoxUrl?: string | null, producerBio?: string | null, processorBoxUrl?: string | null, createdAt?: string | null, myClaimedSplitId?: any | null, myClaimedSplitPart?: string | null, hasPendingClaim?: boolean | null, myClaimedSplitStatus?: string | null, myClaimedSplitDepositStatus?: string | null, killDate?: string | null, cutDate?: string | null, inspectionLevel?: string | null, reserveByDate?: string | null, datesEstimated?: boolean | null, isPendingAcceptance?: boolean | null, listingRatePerLb?: number | null, isInHouse?: boolean | null, producerId?: any | null, producerSlug?: string | null, sections?: Array<{ __typename?: 'BuyerAvailableAnimalSection', size?: string | null, deposit?: number | null, available?: boolean | null, estimatedTotalLow?: number | null, estimatedTotalHigh?: number | null } | null> | null } | null> | null };

export type BuyerFindProcessorsQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  maxDistanceMiles?: InputMaybe<Scalars['Int']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BuyerFindProcessorsQuery = { __typename?: 'Query', processingPartners?: Array<{ __typename?: 'ProcessingPartners', _id?: any | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, slug?: string | null, landingPage?: { __typename?: 'LandingPageSettings', _id: any, name?: string | null, slug?: string | null, tagline?: string | null, logoUrl?: string | null, address?: { __typename?: 'Address', address_1?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null, contact?: { __typename?: 'LandingPageSettingsContact', phone?: string | null, website?: string | null } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null } | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null } | null } | null } | null> | null };

export type BuyerInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerInterestsQuery = { __typename?: 'Query', buyerInterests?: Array<{ __typename?: 'MarketplaceInterest', _id: any, species: EnumMarketplaceInterestSpecies, createdAt?: any | null, producer?: { __typename?: 'User', _id: any, company?: string | null, first_name?: string | null, last_name?: string | null, slug?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null } | null> | null };

export type BuyerInvoiceForJobQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type BuyerInvoiceForJobQuery = { __typename?: 'Query', buyerInvoiceForJob?: { __typename?: 'Invoice', _id: any, number?: string | null, status: EnumInvoiceStatus, amount_due: number, amount_paid: number, amount_refunded?: number | null, date_created: any, settlement_recorded_at?: any | null, external_links?: { __typename?: 'InvoiceExternal_links', hostedInvoiceUrl?: string | null } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, description: string, quantity: number, amount: number }> } | null };

export type BuyerJobCutsheetByIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type BuyerJobCutsheetByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, splits?: Array<{ __typename?: 'Split', _id: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, buyer?: { __typename?: 'User', _id: any } | null } | null> | null } | null> | null } | null };

export type BuyerOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerOrdersQuery = { __typename?: 'Query', buyerOrders?: Array<{ __typename?: 'BuyerOrder', _id: any, status?: string | null, splitId?: any | null, animalId?: any | null, jobId?: any | null, vendorId?: any | null, processorName?: string | null, producerName?: string | null, producerSlug?: string | null, producerLogoUrl?: string | null, depositRecipientParty?: string | null, isProducerListed?: boolean | null, species?: string | null, splitPart?: string | null, depositAmount?: number | null, listingFee?: number | null, total?: number | null, depositPaidAt?: any | null, createdAt?: any | null, finalAmount?: number | null, saleBaseAmount?: number | null, balanceDue?: number | null, refundedAmount?: number | null, refundedAt?: any | null, isRefunded?: boolean | null, paymentMethod?: string | null, invoicedAt?: any | null, invoicePaidAt?: any | null, balancePaidAt?: any | null, processingStatus?: string | null, isComplete?: boolean | null, adjustments?: Array<{ __typename?: 'BuyerOrderAdjustment', label: string, amount: number } | null> | null, combinedSettlement?: { __typename?: 'BuyerOrderCombinedSettlement', active: boolean, ready: boolean, amountDue: number, paid: boolean, blockedReason?: string | null, producerAmount?: number | null, producerStatus?: string | null, processorAmount?: number | null, processorStatus?: string | null } | null, events?: Array<{ __typename?: 'BuyerOrderEvent', type?: string | null, at?: any | null, amount?: number | null, byRole?: string | null, reason?: string | null } | null> | null } | null> | null };

export type BuyerOrdersPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorSchedulingInput;
  filter: FilterFindManyProcessorSchedulingInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type BuyerOrdersPaginationQuery = { __typename?: 'Query', buyerOrdersPagination?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, additionalPickupDetails?: string | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, pickup_days?: Array<number | null> | null, prefers_dropoff?: boolean | null, address: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, status?: string | null, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, grade?: string | null, yield?: string | null, isKillAndChill?: boolean | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, yield?: Array<{ __typename?: 'SplitYield', _id?: any | null, label: string, weightLbs: number, itemCount: number, packageCount: number, packageIdentifier?: string | null } | null> | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null } | null> | null } | null> | null }> | null } | null };

export type BuyerSplitForCutsheetQueryVariables = Exact<{
  splitId: Scalars['MongoID']['input'];
}>;


export type BuyerSplitForCutsheetQuery = { __typename?: 'Query', buyerSplitForCutsheet?: { __typename?: 'BuyerSplitForCutsheet', _id: any, jobId?: any | null, animalId?: any | null, animalSpecies?: string | null, inspectionLevel?: string | null, splitPart?: string | null, producerId?: any | null, vendorId?: any | null, questionnaireId?: any | null, hasCutsheet?: boolean | null, cutsheetMode?: string | null, cutsheetRequired?: boolean | null, holdExpiresAt?: any | null, placementHoldAt?: any | null, depositStatus?: string | null } | null };

export type BuyerTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerTransactionsQuery = { __typename?: 'Query', buyerTransactions?: Array<{ __typename?: 'BuyerTransaction', _id: any, splitPart?: string | null, status?: string | null, depositStatus?: string | null, depositAmount?: number | null, listingFee?: number | null, depositPaidAt?: any | null, createdAt?: any | null, holdExpiresAt?: any | null, cancelledAt?: any | null, releasedWithoutRefundAt?: any | null, isDeleted?: boolean | null, jobId?: any | null, jobPublicId?: string | null, orderStatus?: string | null, purchaseAmount?: number | null, purchasePaidAt?: any | null, purchasePaidOnline?: boolean | null, depositPaidOnline?: boolean | null, refund?: { __typename?: 'BuyerTransactionRefund', id?: string | null, amount?: number | null, at?: any | null } | null, animal?: { __typename?: 'BuyerTransactionAnimal', _id: any, species?: string | null, tracking?: string | null, publicId?: string | null, producerIdentifier?: string | null, killDate?: string | null, cutDate?: string | null } | null, vendor?: { __typename?: 'BuyerTransactionVendor', _id: any, shop_name?: string | null, pickup_days?: Array<number | null> | null, address?: { __typename?: 'BuyerTransactionVendorAddress', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, phone?: string | null } | null } | null } | null> | null };

export type CalculateProcessorCapacityAllSpeciesQueryVariables = Exact<{
  vendorId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  groupFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalculateProcessorCapacityAllSpeciesQuery = { __typename?: 'Query', calculateProcessorCapacityAllSpecies?: { __typename?: 'CapacityCalculationAllSpeciesResult', spotGroups: any, totalSpots: number, hasAvailableSpots: boolean, bySpecies: any } | null };

export type CalculateProcessorCapacityQueryVariables = Exact<{
  vendorId: Scalars['String']['input'];
  selectedAnimalSpecies: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  groupFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalculateProcessorCapacityQuery = { __typename?: 'Query', calculateProcessorCapacity?: { __typename?: 'CapacityCalculationResult', spotGroups: any, totalSpots: number, hasAvailableSpots: boolean } | null };

export type CalendarEventTypeManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCalendarEventTypeInput>;
  sort?: InputMaybe<SortFindManyCalendarEventTypeInput>;
}>;


export type CalendarEventTypeManyQuery = { __typename?: 'Query', calendarEventTypeMany: Array<{ __typename?: 'CalendarEventType', _id: any, vendor: any, title: string, color: string, isEnabled: boolean, sortOrder?: number | null }> };

export type CalendarEventManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCalendarEventInput>;
}>;


export type CalendarEventManyQuery = { __typename?: 'Query', calendarEventMany: Array<{ __typename?: 'CalendarEvent', _id: any, vendor: any, eventType: any, title: string, date: any, description?: string | null }> };

export type CancellationReasonManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
}>;


export type CancellationReasonManyQuery = { __typename?: 'Query', cancellationReasonMany: Array<{ __typename?: 'CancellationReason', reason: string, index?: number | null, isEnabled: boolean, _id: any }> };

export type CsvImportJobStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CsvImportJobStatusQuery = { __typename?: 'Query', csvImportJobStatus?: { __typename?: 'CSVImportJobStatus', jobId: string, type: string, status: string, totalRows: number, validRows: number, invalidRows: number, processedCount: number, successCount: number, failureCount: number, s3Keys?: any | null, deletedRows: Array<number>, createdAt: any, completedAt?: any | null, failures: Array<{ __typename?: 'CSVImportFailure', row: number, error: string }>, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string>, warningMessages?: Array<string> | null }> } | null };

export type CsvImportJobsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CsvImportJobsQuery = { __typename?: 'Query', csvImportJobs?: { __typename?: 'CSVImportJobsPayload', total: number, hasMore: boolean, jobs: Array<{ __typename?: 'CSVImportJobItem', jobId: string, type: string, status: string, totalRows?: number | null, validRows?: number | null, invalidRows?: number | null, processedCount?: number | null, successCount?: number | null, failureCount?: number | null, s3Keys?: any | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null }> } | null };

export type CustomFieldDefinitionManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCustomFieldDefinitionInput>;
  sort?: InputMaybe<SortFindManyCustomFieldDefinitionInput>;
}>;


export type CustomFieldDefinitionManyQuery = { __typename?: 'Query', customFieldDefinitionMany: Array<{ __typename?: 'CustomFieldDefinition', _id: any, vendor: any, modelType: EnumCustomFieldDefinitionModelType, label: string, fieldType: EnumCustomFieldDefinitionFieldType, fieldSource?: EnumCustomFieldDefinitionFieldSource | null, fieldKey?: string | null, enabled?: boolean | null, options?: Array<string | null> | null, sortOrder?: number | null, required?: boolean | null, speciesFilter: any, captureAt: EnumCustomFieldDefinitionCaptureAt, hint?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type CustomFieldValueManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCustomFieldValueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomFieldValueManyQuery = { __typename?: 'Query', customFieldValueMany: Array<{ __typename?: 'CustomFieldValue', _id: any, definition: any, recordId: string, recordType: EnumCustomFieldValueRecordType, value_text?: string | null, value_number?: number | null, value_boolean?: boolean | null, value_json?: any | null }> };

export type CustomerDeletePreviewQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type CustomerDeletePreviewQuery = { __typename?: 'Query', customerDeletePreview?: { __typename?: 'CustomerDeletePreview', associatedRecordCount: number, canDelete: boolean, blockedReason?: string | null, multiVendor: boolean } | null };

export type CustomerMergeCandidatesQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CustomerMergeCandidatesQuery = { __typename?: 'Query', customerMergeCandidates?: Array<{ __typename?: 'CustomerMergeCandidate', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null, phone?: string | null, address?: string | null, hasLogin: boolean, retireBlockedReason?: string | null } | null> | null };

export type CustomerMergePreviewQueryVariables = Exact<{
  winnerId: Scalars['MongoID']['input'];
  loserIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type CustomerMergePreviewQuery = { __typename?: 'Query', customerMergePreview?: { __typename?: 'CustomerMergePreview', affectedRecordCount: number, exceedsCap: boolean, cap: number, crossType: boolean, touchesQuickbooks: boolean } | null };

export type CustomerNotificationPreferencesQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type CustomerNotificationPreferencesQuery = { __typename?: 'Query', customerNotificationPreferences?: Array<{ __typename?: 'NotificationPreference', category: string, label: string, description?: string | null, email: boolean, sms: boolean } | null> | null };

export type CustomerRebookingQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type CustomerRebookingQuery = { __typename?: 'Query', getCustomerRebooking?: { __typename?: 'CustomerRebookingCadence', latestDropoffDate?: any | null, autoIntervalDays?: number | null, overrideIntervalDays?: number | null, effectiveIntervalDays?: number | null, dueSoonWindowDays?: number | null, expectedNextBookingDate?: any | null, rebookingStatus?: string | null, rebookingIntervalSource?: string | null } | null };

export type CustomerSavedCardsQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
}>;


export type CustomerSavedCardsQuery = { __typename?: 'Query', customerSavedCards?: Array<{ __typename?: 'SavedCard', id: string, brand?: string | null, last4?: string | null, expMonth?: number | null, expYear?: number | null } | null> | null };

export type CutsheetQuestionnaireResponseSearchQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  capabilitySetId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireResponseType>> | InputMaybe<EnumCutsheetQuestionnaireResponseType>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyCutsheetQuestionnaireResponseInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetQuestionnaireResponseSearchQuery = { __typename?: 'Query', cutsheetQuestionnaireResponseSearch?: { __typename?: 'CutsheetQuestionnaireResponsePagination', count?: number | null, items?: Array<{ __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null, type: EnumCutsheetQuestionnaireResponseType, createdAt?: any | null, questionnaire: any, questionnaireName?: string | null, user?: any | null, userFullName?: string | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, itemCount?: number | null, pageCount?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } } | null };

export type CutsheetAssignmentRuleSetByCapabilityIdQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetAssignmentRuleSetByCapabilityIdQuery = { __typename?: 'Query', cutsheetAssignmentRuleSetByCapabilityId?: { __typename?: 'CutsheetAssignmentRuleSet', _id: any, vendor: any, capabilityId: any, defaultQuestionnaireId?: any | null, createdAt?: any | null, updatedAt?: any | null, rules?: Array<{ __typename?: 'CutsheetAssignmentRuleSetRules', sortOrder: number, label?: string | null, inspectionLevel?: Array<EnumCutsheetAssignmentRuleSetRulesInspectionLevel | null> | null, splitType?: Array<EnumCutsheetAssignmentRuleSetRulesSplitType | null> | null, splitIndex?: Array<number | null> | null, producer?: Array<any | null> | null, buyer?: Array<any | null> | null, questionnaireId: any } | null> | null } | null };

export type CutsheetCapabilityByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityByIdQuery = { __typename?: 'Query', CutsheetCapabilityById?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCapabilityManyQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  species?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityManyQuery = { __typename?: 'Query', CutsheetCapabilityByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null> | null };

export type CutsheetCapabilityOptionsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityOptionsByIdsQuery = { __typename?: 'Query', cutsheetCapabilityOptionByIds: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null }> };

export type CutsheetCapabilityOptionsManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  optionType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityOptionsManyQuery = { __typename?: 'Query', cutsheetCapabilityOptionsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null };

export type CutsheetCapabilityCutManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityCutManyQuery = { __typename?: 'Query', cutsheetCutsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null };

export type CutsheetCapabilityExtraManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityExtraManyQuery = { __typename?: 'Query', cutsheetExtrasByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null };

export type CutsheetCapabilityGroupManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityGroupManyQuery = { __typename?: 'Query', cutsheetGroupsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> | null };

export type CutsheetLegacyCapabilityDataQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetLegacyCapabilityDataQuery = { __typename?: 'Query', CutsheetLegacyCapabilityData: Array<{ __typename?: 'LegacyCapabilityData', inspectionLevel: string, cuts: Array<{ __typename?: 'LegacyCut', _id: any, name: string, primalName?: string | null } | null>, trims: Array<{ __typename?: 'LegacyTrim', name: string } | null>, extras: Array<{ __typename?: 'LegacyExtra', name: string } | null>, specifications: Array<{ __typename?: 'LegacySpecification', name: string } | null> } | null> };

export type CutsheetQuestionnaireByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireByIdQuery = { __typename?: 'Query', cutsheetQuestionnaireById?: { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, pricePerPound?: number | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, processingFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, killFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, additionalCharges?: Array<{ __typename?: 'CutsheetQuestionnaireAdditionalCharges', id?: string | null, label: string, amount: number, priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType, basis: EnumCutsheetQuestionnaireAdditionalChargesBasis, description?: string | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetQuestionnairePrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetQuestionnairePrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetQuestionnairePrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null } | null };

export type CutsheetQuestionnaireManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetQuestionnaireManyQuery = { __typename?: 'Query', cutsheetQuestionnairesByVendorAndAnimal?: Array<{ __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, pricePerPound?: number | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, processingFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, killFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, additionalCharges?: Array<{ __typename?: 'CutsheetQuestionnaireAdditionalCharges', id?: string | null, label: string, amount: number, priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType, basis: EnumCutsheetQuestionnaireAdditionalChargesBasis, description?: string | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetQuestionnairePrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetQuestionnairePrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetQuestionnairePrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null } | null> | null };

export type CutsheetQuestionnaireResponseByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponseByIdQuery = { __typename?: 'Query', cutsheetQuestionnaireResponseById?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null, type: EnumCutsheetQuestionnaireResponseType, user?: any | null, questionnaire: any, capabilitySet: any, createdAt?: any | null, trimSectionNotes?: string | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireResponsePrimalNotes', id: string, note: string } | null> | null } | null };

export type CutsheetQuestionnaireResponsesByUserQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CutsheetQuestionnaireResponsesByUserQuery = { __typename?: 'Query', cutsheetQuestionnaireResponsesByUser?: Array<{ __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, questionnaire: any, capabilitySet: any, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null };

export type CutsheetQuestionnaireResponsesByVendorQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponsesByVendorQuery = { __typename?: 'Query', cutsheetQuestionnaireResponsesByVendor?: Array<{ __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, questionnaire: any, user?: any | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string } | null> | null } | null } | null> | null };

export type CutsheetQuestionnairesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnairesByIdsQuery = { __typename?: 'Query', cutsheetQuestionnaireByIds: Array<{ __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, pricePerPound?: number | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, processingFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, killFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, additionalCharges?: Array<{ __typename?: 'CutsheetQuestionnaireAdditionalCharges', id?: string | null, label: string, amount: number, priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType, basis: EnumCutsheetQuestionnaireAdditionalChargesBasis, description?: string | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetQuestionnairePrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetQuestionnairePrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetQuestionnairePrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null }> };

export type CutsheetQuestionnairesByVendorQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnairesByVendorQuery = { __typename?: 'Query', cutsheetQuestionnairesByVendor?: Array<{ __typename?: 'CutsheetQuestionnaire', _id: any, name: string, status?: EnumCutsheetQuestionnaireStatus | null, capabilityId: any } | null> | null };

export type CutsheetCapabilitySpecificationManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilitySpecificationManyQuery = { __typename?: 'Query', cutsheetSpecificationsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> | null };

export type CutsheetCapabilityTrimManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityTrimManyQuery = { __typename?: 'Query', cutsheetTrimByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null };

export type CutsheetDescriptionLibraryNamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetDescriptionLibraryNamesQuery = { __typename?: 'Query', cutsheetDescriptionLibrarySearch: Array<{ __typename?: 'CutsheetDescriptionLibrary', _id: any, name: string }> };

export type CutsheetImageLibraryNamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetImageLibraryNamesQuery = { __typename?: 'Query', cutsheetImageLibrarySearch: Array<{ __typename?: 'CutsheetImageLibrary', _id: any, name: string }> };

export type CutsheetSearchQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  buyerId?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetType>> | InputMaybe<EnumCutsheetType>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumCutsheetAnimalSpecies>;
  inspectionLevel?: InputMaybe<EnumCutsheetInspectionLevels>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyCutsheetInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetSearchQuery = { __typename?: 'Query', cutsheetSearch?: { __typename?: 'CutsheetPagination', count?: number | null, items?: Array<{ __typename?: 'Cutsheet', lastUsedDate?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, itemCount?: number | null, pageCount?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } } | null };

export type CutsheetDescriptionLibraryManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCutsheetDescriptionLibraryInput>;
  sort?: InputMaybe<SortFindManyCutsheetDescriptionLibraryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetDescriptionLibraryManyQuery = { __typename?: 'Query', cutsheetDescriptionLibraryMany: Array<{ __typename?: 'CutsheetDescriptionLibrary', _id: any, name: string, description: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type CutsheetDescriptionLibrarySearchQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetDescriptionLibrarySearchQuery = { __typename?: 'Query', cutsheetDescriptionLibrarySearch: Array<{ __typename?: 'CutsheetDescriptionLibrary', _id: any, name: string, description: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type CutsheetDescriptionLibraryTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type CutsheetDescriptionLibraryTagsQuery = { __typename?: 'Query', cutsheetDescriptionLibraryTags: Array<string> };

export type CutsheetImageLibraryManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCutsheetImageLibraryInput>;
  sort?: InputMaybe<SortFindManyCutsheetImageLibraryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetImageLibraryManyQuery = { __typename?: 'Query', cutsheetImageLibraryMany: Array<{ __typename?: 'CutsheetImageLibrary', _id: any, name: string, imageUrl: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type CutsheetImageLibrarySearchQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CutsheetImageLibrarySearchQuery = { __typename?: 'Query', cutsheetImageLibrarySearch: Array<{ __typename?: 'CutsheetImageLibrary', _id: any, name: string, imageUrl: string, tags: Array<string>, notes?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type CutsheetImageLibraryTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type CutsheetImageLibraryTagsQuery = { __typename?: 'Query', cutsheetImageLibraryTags: Array<string> };

export type CutsheetPaginationQueryVariables = Exact<{
  sort: SortFindManyCutsheetInput;
  filter: FilterFindManyCutsheetInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetPaginationQuery = { __typename?: 'Query', cutsheetPagination?: { __typename?: 'CutsheetPagination', count?: number | null, items?: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type CutsheetSpecificationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetSpecificationByIdsQuery = { __typename?: 'Query', cutsheetSpecificationByIds: Array<{ __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null }> };

export type DataImportJobStageQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportJobStageQuery = { __typename?: 'Query', dataImportJobStatus?: { __typename?: 'DataImportJobStatus', jobId: string, status: string } | null };

export type DataImportAnimalSettingsQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportAnimalSettingsQuery = { __typename?: 'Query', dataImportAnimalSettings?: { __typename?: 'DataImportAnimalSettingsPayload', vendorId: string, animalSettings: Array<{ __typename?: 'DataImportAnimalSetting', species: string, isEnabled: boolean, splitTypes: Array<string>, inspectionLevels: Array<string> }> } | null };

export type DataImportJobStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportJobStatusQuery = { __typename?: 'Query', dataImportJobStatus?: { __typename?: 'DataImportJobStatus', jobId: string, type: string, status: string, totalRows: number, validRows: number, invalidRows: number, excludedRows: number, processedCount: number, successCount: number, notImportedCount: number, importedIdentityCount?: number | null, notImportedIdentityCount?: number | null, jobCount?: number | null, jobImportedCount?: number | null, jobNotImportedCount?: number | null, s3Keys?: any | null, deletedRows: Array<number>, createdAt: any, completedAt?: any | null, notImported: Array<{ __typename?: 'DataImportNotImportedRow', row: number, error: string }>, validationErrors: Array<{ __typename?: 'DataImportCSVValidationError', row: number, side?: string | null, errorMessages: Array<string>, warningMessages?: Array<string> | null, excludedMessages?: Array<string> | null }> } | null };

export type DataImportJobsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DataImportJobsQuery = { __typename?: 'Query', dataImportJobs?: { __typename?: 'DataImportJobsPayload', total: number, hasMore: boolean, jobs: Array<{ __typename?: 'DataImportJobItem', jobId: string, type: string, status: string, totalRows?: number | null, validRows?: number | null, invalidRows?: number | null, customerCount?: number | null, distinctIdentityCount?: number | null, importedIdentityCount?: number | null, notImportedIdentityCount?: number | null, processedCount?: number | null, successCount?: number | null, notImportedCount?: number | null, s3Keys?: any | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null }> } | null };

export type DataImportSessionQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DataImportSessionQuery = { __typename?: 'Query', dataImportSession?: { __typename?: 'DataImportSessionPayload', jobId: string, type: string, stage: string, vendorId: string, totalRows: number, validRows: number, invalidRows: number, customerCount?: number | null, detectedColumns?: Array<string> | null, suggestedMapping?: any | null, columns?: Array<string> | null, data?: any | null, hygiene?: any | null, availableColumns?: Array<{ __typename?: 'DataImportAvailableColumn', fieldName: string, role: string, baseField: string, aliases: Array<string>, required: boolean, description: string, validationRules?: string | null }> | null, validationErrors?: Array<{ __typename?: 'DataImportCSVValidationError', row: number, side?: string | null, errorMessages: Array<string>, warningMessages?: Array<string> | null, excludedMessages?: Array<string> | null }> | null } | null };

export type DocumentAssignableEntitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocumentAssignableEntitiesQuery = { __typename?: 'Query', documentAssignableEntities?: Array<{ __typename?: 'DocumentAssignableEntity', type: string, id: any, label: string, sublabel?: string | null } | null> | null };

export type DocumentCategoriesForVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentCategoriesForVendorQuery = { __typename?: 'Query', documentCategoriesForVendor?: Array<{ __typename?: 'DocumentCategory', _id: any, name: string, vendor?: any | null } | null> | null };

export type DocumentFolderQueryVariables = Exact<{
  facetOrder: Array<Scalars['String']['input']> | Scalars['String']['input'];
  path?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  scopeEntityType?: InputMaybe<Scalars['String']['input']>;
  scopeEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  includeGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<EnumDocumentSearchSort>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type DocumentFolderQuery = { __typename?: 'Query', documentFolder?: { __typename?: 'DocumentFolderResult', facet?: string | null, folders: Array<{ __typename?: 'DocumentFolderEntry', facet: string, value: string, label: string, sublabel?: string | null }>, files: { __typename?: 'DocumentPagination', count?: number | null, items?: Array<{ __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, linkSummaries?: Array<{ __typename?: 'DocumentLinkSummary', entityType?: string | null, entityId?: any | null, label?: string | null, sublabel?: string | null } | null> | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } } | null };

export type DocumentSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignment?: InputMaybe<Scalars['String']['input']>;
  includeGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<EnumDocumentSearchSort>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type DocumentSearchQuery = { __typename?: 'Query', documentSearch?: { __typename?: 'DocumentPagination', count?: number | null, items?: Array<{ __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, linkSummaries?: Array<{ __typename?: 'DocumentLinkSummary', entityType?: string | null, entityId?: any | null, label?: string | null, sublabel?: string | null } | null> | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type DocumentVersionUrlQueryVariables = Exact<{
  documentId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
}>;


export type DocumentVersionUrlQuery = { __typename?: 'Query', documentVersionUrl?: string | null };

export type DocumentsForEntityQueryVariables = Exact<{
  entityType: EnumDocumentEntityType;
  entityId: Scalars['MongoID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  includeGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type DocumentsForEntityQuery = { __typename?: 'Query', documentsForEntity?: { __typename?: 'DocumentPagination', count?: number | null, items?: Array<{ __typename?: 'Document', _id: any, category: string, source: EnumDocumentSource, generator?: EnumDocumentGenerator | null, url?: string | null, filename: string, mimeType: string, fileSize: number, hash?: string | null, currentVersion: number, createdAt?: any | null, updatedAt?: any | null, linkSummaries?: Array<{ __typename?: 'DocumentLinkSummary', entityType?: string | null, entityId?: any | null, label?: string | null, sublabel?: string | null } | null> | null, links?: Array<{ __typename?: 'DocumentLinks', entityType: EnumDocumentLinksEntityType, entityId: any } | null> | null, versions: Array<{ __typename?: 'DocumentVersions', version: number, filename: string, mimeType: string, fileSize: number, isGenerated: boolean, note?: string | null, createdAt: any } | null>, uploadedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type ExportDeliveryDownloadUrlQueryVariables = Exact<{
  presetId: Scalars['MongoID']['input'];
  token: Scalars['String']['input'];
}>;


export type ExportDeliveryDownloadUrlQuery = { __typename?: 'Query', exportDeliveryDownloadUrl: string };

export type ExportPresetManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyExportPresetInput>;
}>;


export type ExportPresetManyQuery = { __typename?: 'Query', exportPresetMany: Array<{ __typename?: 'ExportPreset', _id: any, name: string, type: string, anchorDate?: string | null, datePreset?: string | null, customStart?: string | null, customEnd?: string | null, animalSpecies?: string | null, inspectionLevel?: string | null, filterMode?: string | null, columns?: Array<{ __typename?: 'ExportPresetColumns', key: string, label?: string | null } | null> | null, sort?: Array<{ __typename?: 'ExportPresetSort', key: string, direction?: EnumExportPresetSortDirection | null } | null> | null, filters?: Array<{ __typename?: 'ExportPresetFilters', key: string, operator: string, value?: string | null } | null> | null, schedule?: { __typename?: 'ExportPresetSchedule', enabled?: boolean | null, frequency?: EnumExportPresetScheduleFrequency | null, dayOfWeek?: number | null, dayOfMonth?: number | null, hourUtc?: number | null, recipients?: Array<string | null> | null, lastRunAt?: any | null, nextRunAt?: any | null, lastRunStatus?: EnumExportPresetScheduleLastRunStatus | null, lastRunError?: string | null, lastRunRowCount?: number | null } | null }> };

export type ExportSettingOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneExportSettingInput>;
}>;


export type ExportSettingOneQuery = { __typename?: 'Query', exportSettingOne?: { __typename?: 'ExportSetting', _id: any, quickbooksDesktop?: { __typename?: 'ExportSettingQuickbooksDesktop', arAccount?: string | null, incomeAccount?: string | null, depositAccount?: string | null, discountAccount?: string | null, adjustmentAccount?: string | null, defaultItem?: string | null } | null } | null };

export type GameKioskAddressQueryVariables = Exact<{
  vendor: Scalars['MongoID']['input'];
}>;


export type GameKioskAddressQuery = { __typename?: 'Query', gameKioskAddress?: { __typename?: 'GameKioskAddressCurrent', kioskToken: string, kioskUrl: string, kioskShortUrl: string } | null };

export type GameKioskByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GameKioskByTokenQuery = { __typename?: 'Query', gameKioskByToken?: { __typename?: 'GameKioskResponse', processorName: string, processorSettings: any, vendor: any, species?: Array<{ __typename?: 'GameKioskSpecies', species: string, label: string, inspectionLevels?: Array<string | null> | null, schedulingDeposit: number, cutsheets?: Array<{ __typename?: 'GameKioskCutsheet', id: any, name: string, description?: string | null } | null> | null } | null> | null } | null };

export type GameKioskCutsheetQueryVariables = Exact<{
  token: Scalars['String']['input'];
  questionnaireId: Scalars['MongoID']['input'];
}>;


export type GameKioskCutsheetQuery = { __typename?: 'Query', gameKioskCutsheet?: { __typename?: 'GameKioskCutsheetResponse', questionnaire: { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, pricePerPound?: number | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, processingFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, killFee?: { __typename?: 'CutsheetQuestionnaireProcessingFee', priceType: EnumCutsheetQuestionnaireProcessingFeePriceType, amount: number, basis: EnumCutsheetQuestionnaireProcessingFeeBasis } | null, additionalCharges?: Array<{ __typename?: 'CutsheetQuestionnaireAdditionalCharges', id?: string | null, label: string, amount: number, priceType: EnumCutsheetQuestionnaireAdditionalChargesPriceType, basis: EnumCutsheetQuestionnaireAdditionalChargesBasis, description?: string | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetQuestionnairePrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetQuestionnairePrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetQuestionnairePrintSettingsCheckboxStyle | null, showAllSpecOptions?: boolean | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, highlightCutsheetNotes?: boolean | null, highlightSectionNotes?: boolean | null, orientation?: EnumCutsheetQuestionnairePrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null, showCustomContent?: boolean | null, customContentTitle?: string | null, customContent?: string | null } | null }, catalog: { __typename?: 'GameKioskCatalog', primals?: Array<{ __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, cuts?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null, extras?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null, partnerCodes?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodes', adapter: string, code?: string | null, rules?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRules', code: string, conditions?: Array<{ __typename?: 'CutsheetCapabilityOptionPartnerCodesRulesConditions', specificationId: any, value: string } | null> | null } | null> | null } | null> | null } | null> | null, specifications?: Array<{ __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> | null } } | null };

export type GameKioskHunterCheckQueryVariables = Exact<{
  token: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GameKioskHunterCheckQuery = { __typename?: 'Query', gameKioskHunterCheck: boolean };

export type GeocodeLocationQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GeocodeLocationQuery = { __typename?: 'Query', geocodeLocation?: { __typename?: 'GeocodeLocationResult', lat?: number | null, lng?: number | null } | null };

export type GetPublicHolidaysQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPublicHolidaysQuery = { __typename?: 'Query', getPublicHolidays?: { __typename?: 'HolidaysResponse', holidays?: Array<{ __typename?: 'Holiday', name: string, date: string, type?: string | null, country: string, lang: string } | null> | null, meta?: { __typename?: 'HolidaysMeta', country: string, lang: string, start: string, end: string, count: number } | null } | null };

export type GetAuditLogsQueryVariables = Exact<{
  documentType?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['MongoID']['input']>;
  targets?: InputMaybe<Array<InputMaybe<AuditLogTargetInput>> | InputMaybe<AuditLogTargetInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', getAuditLogs?: { __typename?: 'AuditLogsResponse', total: number, logs?: Array<{ __typename?: 'AuditLogResult', _id: any, documentId: any, documentType: string, actorId?: any | null, createdAt: any, updatedAt: any, actor?: { __typename?: 'AuditLogActorResult', first_name?: string | null, last_name?: string | null, picture_url?: string | null } | null, changes?: Array<{ __typename?: 'AuditLogChangeResult', path: string, from?: any | null, to?: any | null } | null> | null } | null> | null } | null };

export type GetCustomerSummaryDetailsQueryVariables = Exact<{
  customerId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type GetCustomerSummaryDetailsQuery = { __typename?: 'Query', getCustomerSummaryDetails?: { __typename?: 'CustomerSummaryDetails', customerCount?: number | null, jobSummary: { __typename?: 'CustomerJobSummary', inProgressCount: number, needsApprovalCount: number, completedCount: number, cancelledCount: number, firstJobDate?: any | null, lastJobDate?: any | null }, linkedProducer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, phone?: string | null } | null } | null };

export type GetRecurringSeriesListQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type GetRecurringSeriesListQuery = { __typename?: 'Query', getRecurringSeriesList?: Array<{ __typename?: 'RecurringSeries', _id: any, active: boolean, producerName?: string | null, nextOccurrence?: any | null, upcomingJobCount?: number | null, targetUpcomingCount?: number | null, rule: { __typename?: 'RecurringSeriesRule', freq: EnumRecurringSeriesRuleFreq, interval: number, anchor: string, timezone: string, byMonthDay?: Array<number | null> | null, until?: string | null, count?: number | null, byDay?: Array<{ __typename?: 'RecurringSeriesRuleByDay', ordinal?: number | null, day: EnumRecurringSeriesRuleByDayDay } | null> | null }, jobTemplate: { __typename?: 'RecurringSeriesJobTemplate', animalSpecies: EnumRecurringSeriesJobTemplateAnimalSpecies, headCount: number } }> | null };

export type HerdAssignableJobsQueryVariables = Exact<{
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  dropoffDateFrom?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HerdAssignableJobsQuery = { __typename?: 'Query', vendorHerdAssignableJobs?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null } | null> | null };

export type IntegrationAdaptersQueryVariables = Exact<{
  all?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IntegrationAdaptersQuery = { __typename?: 'Query', integrationAdapters: Array<{ __typename?: 'IntegrationAdapterInfo', key: string, label: string, subscribes: Array<string>, supportsInbound: boolean, supportsPolling: boolean, allowsMultiple: boolean, configurableEvents: boolean, supportsProducts: boolean, configFields: Array<{ __typename?: 'IntegrationAdapterConfigField', key: string, label: string, type: string, required?: boolean | null, help?: string | null, keyLabel?: string | null, valueLabel?: string | null, keys?: Array<string> | null, overrideToggleKey?: string | null, advanced?: boolean | null }>, credentialFields: Array<{ __typename?: 'IntegrationAdapterCredentialField', key: string, label: string, help?: string | null, placeholder?: string | null, required?: boolean | null, advanced?: boolean | null }> }> };

export type IntegrationDeliveriesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyIntegrationDeliveryInput>;
}>;


export type IntegrationDeliveriesQuery = { __typename?: 'Query', integrationDeliveryMany: Array<{ __typename?: 'IntegrationDelivery', _id: any, eventId: string, type: string, adapter: string, integration: any, subjectType: EnumIntegrationDeliverySubjectType, subjectId: any, status: EnumIntegrationDeliveryStatus, attempts: number, lastError?: string | null, occurredAt: any, deliveredAt?: any | null, createdAt?: any | null, cause?: { __typename?: 'IntegrationDeliveryCause', model?: string | null, changedPaths?: Array<string | null> | null } | null }> };

export type IntegrationDeliveriesBySubjectQueryVariables = Exact<{
  subjectId: Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IntegrationDeliveriesBySubjectQuery = { __typename?: 'Query', integrationDeliveryMany: Array<{ __typename?: 'IntegrationDelivery', _id: any, eventId: string, type: string, adapter: string, subjectType: EnumIntegrationDeliverySubjectType, subjectId: any, status: EnumIntegrationDeliveryStatus, attempts: number, lastError?: string | null, occurredAt: any, deliveredAt?: any | null, createdAt?: any | null, cause?: { __typename?: 'IntegrationDeliveryCause', model?: string | null, changedPaths?: Array<string | null> | null } | null }> };

export type IntegrationDeliveryAttemptsQueryVariables = Exact<{
  deliveryId: Scalars['MongoID']['input'];
}>;


export type IntegrationDeliveryAttemptsQuery = { __typename?: 'Query', integrationDeliveryAttemptMany: Array<{ __typename?: 'IntegrationDeliveryAttempt', _id: any, attempt: number, at: any, outcome: EnumIntegrationDeliveryAttemptOutcome, statusCode?: number | null, error?: string | null, durationMs: number, exchanges?: Array<{ __typename?: 'IntegrationDeliveryAttemptExchanges', method: string, url: string, requestHeaders?: any | null, requestBody?: string | null, status?: number | null, responseBody?: string | null, error?: string | null, durationMs: number, truncated?: boolean | null } | null> | null }> };

export type IntegrationInboundRecordsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyIntegrationInboundRecordInput>;
}>;


export type IntegrationInboundRecordsQuery = { __typename?: 'Query', integrationInboundRecordMany: Array<{ __typename?: 'IntegrationInboundRecord', _id: any, adapter: string, kind: EnumIntegrationInboundRecordKind, weightLbs?: number | null, liveWeightLbs?: number | null, grade?: string | null, rawPayload?: any | null, status: EnumIntegrationInboundRecordStatus, error?: string | null, externalRef?: string | null, receivedAt: any, identifiers?: any | null, yieldLines?: Array<{ __typename?: 'IntegrationInboundRecordYieldLines', label: string, partnerLabel?: string | null, partnerSku?: string | null, weightLbs: number, packageCount?: number | null } | null> | null, match?: { __typename?: 'IntegrationInboundRecordMatch', job?: any | null, animal?: any | null, split?: any | null, matchedOn?: string | null, matchedValue?: string | null } | null }> };

export type IntegrationOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneIntegrationInput>;
}>;


export type IntegrationOneQuery = { __typename?: 'Query', integrationOne?: { __typename?: 'Integration', _id: any, name: EnumIntegrationName, config?: any | null } | null };

export type IntegrationPartnerProductsQueryVariables = Exact<{
  adapter: Scalars['String']['input'];
}>;


export type IntegrationPartnerProductsQuery = { __typename?: 'Query', integrationPartnerProducts: { __typename?: 'IntegrationPartnerProducts', supported: boolean, error?: string | null, products: Array<{ __typename?: 'IntegrationPartnerProduct', code: string, name: string, updatedAt?: string | null }> } };

export type InvoiceByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type InvoiceByIdQuery = { __typename?: 'Query', invoiceById?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type SearchInvoicesQueryVariables = Exact<{
  type: Scalars['String']['input'];
  sort: SortFindManyInvoiceInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchInvoicesQuery = { __typename?: 'Query', searchInvoices?: { __typename?: 'InvoicePagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null }> | null } | null };

export type JobRequesterQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type JobRequesterQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, requestedBy?: { __typename?: 'User', _id: any } | null } | null };

export type JobManualNotificationOptionsQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type JobManualNotificationOptionsQuery = { __typename?: 'Query', jobManualNotificationOptions: Array<{ __typename?: 'ManualNotificationOption', notificationSettingId: any, eventType: string, name: string, trigger: string, sendEmail: boolean, sendSMS: boolean, recipients: Array<{ __typename?: 'ManualNotificationRecipient', userId: any, name: string, email?: string | null, phone?: string | null, role: string, defaultSelected: boolean, reason?: string | null }> }> };

export type JobTagManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyJobTagInput>;
  sort?: InputMaybe<SortFindManyJobTagInput>;
}>;


export type JobTagManyQuery = { __typename?: 'Query', jobTagMany: Array<{ __typename?: 'JobTag', _id: any, vendor: any, name: string, icon: string, species?: Array<EnumJobTagSpecies | null> | null, isEnabled: boolean, sortOrder?: number | null }> };

export type LandingPageOneQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type LandingPageOneQuery = { __typename?: 'Query', landingPageOne?: { __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, slug?: string | null, species?: Array<EnumLandingPageSettingsSpecies | null> | null, about?: string | null, buyerBio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, tagline?: string | null, logoUrl?: string | null, showAddress?: boolean | null, showOnMap?: boolean | null, showInDirectory?: boolean | null, showAbout?: boolean | null, showContact?: boolean | null, showPricing?: boolean | null, showGallery?: boolean | null, showDocuments?: boolean | null, showFaq?: boolean | null, galleryImages?: Array<string | null> | null, premierProducers?: Array<{ __typename?: 'LandingPageSettingsPremierProducers', producerId: any, badge: EnumLandingPageSettingsPremierProducersBadge } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, type: EnumAddressType } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null, pricingRows?: Array<{ __typename?: 'LandingPageSettingsPricingRows', _id?: any | null, label: string, price?: number | null, unit?: string | null, notes?: string | null } | null> | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null } | null, documents?: Array<{ __typename?: 'LandingPageSettingsDocuments', _id?: any | null, name: string, description?: string | null, fileUrl: string } | null> | null, faq?: Array<{ __typename?: 'LandingPageSettingsFaq', _id?: any | null, question: string, answer: string } | null> | null } | null };

export type LandingPagePublicByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type LandingPagePublicByIdQuery = { __typename?: 'Query', landingPagePublicById?: { __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, slug?: string | null, species?: Array<EnumLandingPageSettingsSpecies | null> | null, about?: string | null, buyerBio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, tagline?: string | null, logoUrl?: string | null, showAddress?: boolean | null, showOnMap?: boolean | null, showInDirectory?: boolean | null, showAbout?: boolean | null, showContact?: boolean | null, showPricing?: boolean | null, showGallery?: boolean | null, showDocuments?: boolean | null, showFaq?: boolean | null, galleryImages?: Array<string | null> | null, premierProducers?: Array<{ __typename?: 'LandingPageSettingsPremierProducers', producerId: any, badge: EnumLandingPageSettingsPremierProducersBadge } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, type: EnumAddressType } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null, pricingRows?: Array<{ __typename?: 'LandingPageSettingsPricingRows', _id?: any | null, label: string, price?: number | null, unit?: string | null, notes?: string | null } | null> | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null } | null, documents?: Array<{ __typename?: 'LandingPageSettingsDocuments', _id?: any | null, name: string, description?: string | null, fileUrl: string } | null> | null, faq?: Array<{ __typename?: 'LandingPageSettingsFaq', _id?: any | null, question: string, answer: string } | null> | null } | null };

export type LandingPagePublicBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type LandingPagePublicBySlugQuery = { __typename?: 'Query', landingPagePublicBySlug?: { __typename?: 'LandingPageSettings', _id: any, vendorId?: any | null, name?: string | null, slug?: string | null, species?: Array<EnumLandingPageSettingsSpecies | null> | null, about?: string | null, buyerBio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, showCommunityListings?: boolean | null, storefrontProducers?: Array<any | null> | null, tagline?: string | null, logoUrl?: string | null, showAddress?: boolean | null, showOnMap?: boolean | null, showInDirectory?: boolean | null, showAbout?: boolean | null, showContact?: boolean | null, showPricing?: boolean | null, showGallery?: boolean | null, showDocuments?: boolean | null, showFaq?: boolean | null, galleryImages?: Array<string | null> | null, premierProducers?: Array<{ __typename?: 'LandingPageSettingsPremierProducers', producerId: any, badge: EnumLandingPageSettingsPremierProducersBadge } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, type: EnumAddressType } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null, pricingRows?: Array<{ __typename?: 'LandingPageSettingsPricingRows', _id?: any | null, label: string, price?: number | null, unit?: string | null, notes?: string | null } | null> | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null } | null, documents?: Array<{ __typename?: 'LandingPageSettingsDocuments', _id?: any | null, name: string, description?: string | null, fileUrl: string } | null> | null, faq?: Array<{ __typename?: 'LandingPageSettingsFaq', _id?: any | null, question: string, answer: string } | null> | null } | null };

export type MessagesByChatRoomQueryVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type MessagesByChatRoomQuery = { __typename?: 'Query', messagesByChatRoom?: { __typename?: 'ChatMessagePagination', count?: number | null, items?: Array<{ __typename?: 'ChatMessage', _id: any, content?: string | null, imageUrl?: string | null, isNotification?: boolean | null, animal?: any | null, animalSpecies?: string | null, readAt?: any | null, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, notificationPrompt?: { __typename?: 'NotificationPromptState', _id: string, kind: string, status: string, canAnswer: boolean, jobId?: string | null, expiresAt?: any | null } | null, sender?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type MyInvoiceQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type MyInvoiceQuery = { __typename?: 'Query', myInvoice?: { __typename?: 'Invoice', _id: any, number?: string | null, description: string, status: EnumInvoiceStatus, type: EnumInvoiceType, date_created: any, due_date: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, settlement_recorded_at?: any | null, external_links?: { __typename?: 'InvoiceExternal_links', hostedInvoiceUrl?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, description: string, quantity: number, amount: number }>, discounts?: Array<{ __typename?: 'InvoiceDiscounts', _id?: any | null, description?: string | null, applied_amount: number } | null> | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any } | null> | null } | null };

export type MyAnimalsQueryVariables = Exact<{
  scope?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
  cutWithinDays?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  saleProgress?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyAnimalsQuery = { __typename?: 'Query', myAnimals?: { __typename?: 'AnimalPagination', count?: number | null, items?: Array<{ __typename?: 'Animal', _id: any, species: string, tracking?: string | null, publicId: string, splitType?: string | null, producerIdentifier?: string | null, status?: string | null, job?: any | null, jobId?: string | null, liveWeight?: number | null, liveWeightHigh?: number | null, sex?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, descriptorChips?: Array<string | null> | null, producerDescription?: string | null, availableToBuyers?: boolean | null, allowedSectionSizes?: Array<string | null> | null, claimMode?: EnumAnimalClaimMode | null, listedBy?: EnumAnimalListedBy | null, sizeTier?: EnumAnimalSizeTier | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, killDate?: any | null, cutDate?: any | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, remainingCapacity?: number | null, isFull?: boolean | null, createdAt?: any | null, listingDeposits?: { __typename?: 'AnimalListingDeposits', whole?: number | null, half?: number | null, quarter?: number | null } | null, vendorRef?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, kind?: EnumSplitKind | null, status?: EnumSplitStatus | null, depositAmount?: number | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, placementHoldAt?: any | null, lastNudgedAt?: any | null, lastNudgeKind?: EnumSplitLastNudgeKind | null, locked?: boolean | null, buyer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any } | null, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null, order?: { __typename?: 'OrderInvoiceResult', _id: any, status: string, finalAmount?: number | null, saleBaseAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null, balancePaidAt?: any | null, depositRecipientParty?: string | null, settledOffPlatform?: boolean | null, listingFee?: number | null, adjustments?: Array<{ __typename?: 'OrderAdjustmentResult', label: string, amount: number } | null> | null } | null } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type MyAnimalsStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAnimalsStatsQuery = { __typename?: 'Query', myAnimalsStats?: { __typename?: 'MyAnimalsStats', total: number, listed: number, reserved: number } | null };

export type MyChatRoomQueryVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
}>;


export type MyChatRoomQuery = { __typename?: 'Query', myChatRoom?: { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, unreadMessagesCount: number, markedUnread: boolean, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, picture_url?: string | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null } | null };

export type MyChatRoomUpdatesQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  since: Scalars['Date']['input'];
}>;


export type MyChatRoomUpdatesQuery = { __typename?: 'Query', myChatRoomUpdates: Array<{ __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, unreadMessagesCount: number, markedUnread: boolean, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, picture_url?: string | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null }> };

export type MyChatRoomsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyChatRoomsQuery = { __typename?: 'Query', serverTime: any, myChatRooms?: { __typename?: 'ChatRoomPagination', count?: number | null, items?: Array<{ __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, unreadMessagesCount: number, markedUnread: boolean, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, picture_url?: string | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type MyInAppNotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyInAppNotificationsQuery = { __typename?: 'Query', myInAppNotifications?: { __typename?: 'InAppNotificationFeed', unseenCount: number, items?: Array<{ __typename?: 'InAppNotificationItem', _id: string, title: string, body?: string | null, ctaUrl?: string | null, trigger?: string | null, type?: string | null, jobId?: string | null, promptText?: string | null, seenAt?: any | null, createdAt?: any | null, prompt?: { __typename?: 'NotificationPromptState', _id: string, kind: string, status: string, canAnswer: boolean, jobId?: string | null, expiresAt?: any | null } | null } | null> | null } | null };

export type MyInvoicesQueryVariables = Exact<{
  openOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyInvoicesQuery = { __typename?: 'Query', myInvoices: Array<{ __typename?: 'Invoice', _id: any, number?: string | null, description: string, status: EnumInvoiceStatus, type: EnumInvoiceType, date_created: any, due_date: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, external_links?: { __typename?: 'InvoiceExternal_links', hostedInvoiceUrl?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null }> };

export type MyNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyNotificationPreferencesQuery = { __typename?: 'Query', myNotificationPreferences?: Array<{ __typename?: 'NotificationPreference', category: string, label: string, description?: string | null, email: boolean, sms: boolean } | null> | null };

export type MyProcessorsQueryVariables = Exact<{
  vendorIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type MyProcessorsQuery = { __typename?: 'Query', processingPartners?: Array<{ __typename?: 'ProcessingPartners', _id?: any | null, slug?: string | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, isWaitlistFunctionalityDisabled?: boolean | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null } | null } | null> | null };

export type MyWaitlistQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWaitlistQuery = { __typename?: 'Query', myWaitlist?: Array<{ __typename?: 'Waitlist', _id: any, vendor: any, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, createdAt?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, vendorRef?: { __typename?: 'Vendor', _id: any, shop_name: string, shop_slug?: string | null } | null } | null> | null };

export type NavBadgeCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type NavBadgeCountsQuery = { __typename?: 'Query', navBadgeCounts?: { __typename?: 'NavBadgeCounts', waitlist?: number | null, unreadChats?: number | null, requestedJobs?: number | null } | null };

export type NotePaginationQueryVariables = Exact<{
  sort: SortFindManyNoteInput;
  filter: FilterFindManyNoteInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotePaginationQuery = { __typename?: 'Query', notePagination?: { __typename?: 'NotePagination', count?: number | null, items?: Array<{ __typename?: 'Note', _id: any, note?: string | null, type: EnumNoteType, animalHead?: any | null, createdAt?: any | null, updatedAt?: any | null, attachments?: Array<{ __typename?: 'NoteAttachments', url: string, filename: string, mimeType?: string | null } | null> | null, createdBy?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotificationAuditSearchQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotificationAuditSearchQuery = { __typename?: 'Query', notificationAuditSearch?: { __typename?: 'NotificationAuditSearchResponse', total: number, page: number, perPage: number, pageCount: number, hasNextPage: boolean, hasPreviousPage: boolean, outcomeCounts?: Array<{ __typename?: 'NotificationAuditOutcomeCount', outcome?: string | null, count?: number | null } | null> | null, records?: Array<{ __typename?: 'NotificationAuditRecord', id: string, timestamp?: any | null, runId?: string | null, correlationId?: string | null, eventType?: string | null, trigger?: string | null, notificationType?: string | null, source?: string | null, vendorId?: string | null, vendorName?: string | null, userId?: string | null, recipientName?: string | null, jobId?: string | null, outcome?: string | null, reason?: string | null, forced?: boolean | null, attempt?: number | null, channels?: { __typename?: 'NotificationAuditChannels', email?: { __typename?: 'NotificationAuditChannelOutcome', status?: string | null, reason?: string | null, sentTo?: string | null, provider?: { __typename?: 'NotificationAuditChannelProvider', name?: string | null, messageId?: string | null, statusCode?: number | null, errorMessage?: string | null } | null } | null, sms?: { __typename?: 'NotificationAuditChannelOutcome', status?: string | null, reason?: string | null, sentTo?: string | null, provider?: { __typename?: 'NotificationAuditChannelProvider', name?: string | null, messageId?: string | null, statusCode?: number | null, errorMessage?: string | null } | null } | null, chat?: { __typename?: 'NotificationAuditChannelOutcome', status?: string | null, reason?: string | null, sentTo?: string | null } | null, inApp?: { __typename?: 'NotificationAuditChannelOutcome', status?: string | null, reason?: string | null, sentTo?: string | null, provider?: { __typename?: 'NotificationAuditChannelProvider', name?: string | null, messageId?: string | null, statusCode?: number | null, errorMessage?: string | null } | null } | null } | null } | null> | null } | null };

export type NotificationPromptByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type NotificationPromptByTokenQuery = { __typename?: 'Query', notificationPromptByToken?: { __typename?: 'NotificationPromptPublic', kind: string, status: string, expiredReason?: string | null, vendorName?: string | null, animalSpecies?: string | null, dropoffDate?: string | null, jobId?: string | null } | null };

export type NotificationSettingsByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationSettingsByVendorIdQuery = { __typename?: 'Query', findNotificationSettingsByVendorId?: { __typename?: 'NotificationSettingPagination', count?: number | null, items?: Array<{ __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, requestConfirmation?: boolean | null, confirmationMessage?: string | null, defaultConfirmationMessage?: string | null, sendEmail?: boolean | null, sendSMS?: boolean | null, sendInApp?: boolean | null, preferredChannel?: EnumNotificationSettingPreferredChannel | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotificationSettingsOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneNotificationSettingInput>;
}>;


export type NotificationSettingsOneQuery = { __typename?: 'Query', notificationSettingsOne?: { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, requestConfirmation?: boolean | null, confirmationMessage?: string | null, defaultConfirmationMessage?: string | null, sendEmail?: boolean | null, sendSMS?: boolean | null, sendInApp?: boolean | null, preferredChannel?: EnumNotificationSettingPreferredChannel | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null } | null };

export type NotificationsByJobIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationsByJobIdQuery = { __typename?: 'Query', findNotificationsByJobId?: { __typename?: 'NotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Notification', _id: any, jobId?: any | null, notificationType?: EnumNotificationNotificationType | null, type?: string | null, sentTo?: string | null, sentOn?: any | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null, phone?: string | null } | null, errorMessage?: { __typename?: 'NotificationErrorMessage', message?: string | null, code?: string | null } | null }> | null } | null };

export type NotificationsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationsByUserIdQuery = { __typename?: 'Query', notificationPagination?: { __typename?: 'NotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Notification', _id: any, jobId?: any | null, notificationType?: EnumNotificationNotificationType | null, type?: string | null, sentTo?: string | null, sentOn?: any | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null, phone?: string | null } | null, errorMessage?: { __typename?: 'NotificationErrorMessage', message?: string | null, code?: string | null } | null }> | null } | null };

export type PartnerIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerIntegrationsQuery = { __typename?: 'Query', integrationMany: Array<{ __typename?: 'Integration', _id: any, adapter?: string | null, label?: string | null, enabled?: boolean | null, subscribedEvents?: Array<EnumIntegrationSubscribedEvents | null> | null, autoPush?: boolean | null, autoPoll?: boolean | null, config?: any | null, endpoint?: string | null, inboundUrl?: string | null, lastDeliveryAt?: any | null, lastErrorAt?: any | null, lastError?: string | null, inbound?: { __typename?: 'IntegrationInbound', enabled?: boolean | null, tokenHint?: string | null, issuedAt?: any | null, weightMode?: EnumIntegrationInboundWeightMode | null } | null }> };

export type PickupLocationListQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PickupLocationListQuery = { __typename?: 'Query', pickupLocationList?: Array<{ __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, active?: boolean | null, isDefault?: boolean | null, sortOrder?: number | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null } | null> | null };

export type PrimalCutBlockerManyQueryVariables = Exact<{
  filter: FilterFindManyPrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrimalCutBlockerManyQuery = { __typename?: 'Query', primalCutBlockerMany: Array<{ __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null }> };

export type PrimalCutManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
}>;


export type PrimalCutManyQuery = { __typename?: 'Query', primalCutMany: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, isDeleted?: boolean | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null, primal?: { __typename?: 'Primal', name: string, order: number, _id: any, group?: { __typename?: 'PrimalGroup', processorSettings?: any | null, isDefault?: boolean | null, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, _id: any } | null } | null }> };

export type PrimalCutTypeManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrimalCutTypeManyQuery = { __typename?: 'Query', primalCutTypeMany: Array<{ __typename?: 'PrimalCutType', _id: any, name: string, isDeleted?: boolean | null, animalSpecies?: EnumPrimalCutTypeAnimalSpecies | null, processorSettings?: any | null }> };

export type PrimalGroupManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
}>;


export type PrimalGroupManyQuery = { __typename?: 'Query', primalGroupMany: Array<{ __typename?: 'PrimalGroup', processorSettings?: any | null, isDefault?: boolean | null, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDeleted?: boolean | null, _id: any, primals?: Array<{ __typename?: 'Primal', isDeleted?: boolean | null, order: number, name: string, description?: string | null, _id: any, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }> } | null> | null }> };

export type ProcessingPartnersQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  maxDistanceMiles?: InputMaybe<Scalars['Int']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  buyerMarketplaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessingPartnersQuery = { __typename?: 'Query', processingPartners?: Array<{ __typename?: 'ProcessingPartners', _id?: any | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, openSplitCount?: number | null, slug?: string | null, landingPage?: { __typename?: 'LandingPageSettings', _id: any, name?: string | null, slug?: string | null, tagline?: string | null, logoUrl?: string | null, boxImageUrl?: string | null, address?: { __typename?: 'Address', address_1?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null, contact?: { __typename?: 'LandingPageSettingsContact', email?: string | null, phone?: string | null, website?: string | null } | null, location?: { __typename?: 'LandingPageSettingsLocation', coordinates?: Array<number | null> | null } | null } | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null } | null } | null } | null> | null };

export type ProcessorCustomerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProcessorCustomerByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, enabled: boolean, company?: string | null, _id: any, relationships?: Array<{ __typename?: 'UserRelationships', type?: EnumUserRelationshipsType | null, vendorId?: any | null, producerId?: any | null, source?: EnumUserRelationshipsSource | null } | null> | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null, settings?: { __typename?: 'UserSettings', hangTimePreferences?: Array<{ __typename?: 'UserSettingsHangTimePreferences', vendorId?: any | null, species?: string | null, preferredDays?: number | null } | null> | null } | null } | null };

export type ProcessorCustomersPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
  vendorId: Scalars['MongoID']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  latestDropoffDateFrom?: InputMaybe<Scalars['Date']['input']>;
  latestDropoffDateTo?: InputMaybe<Scalars['Date']['input']>;
  rebookingStatuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  latestDropoffSort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorCustomersPaginationQuery = { __typename?: 'Query', getProcessorCustomers?: { __typename?: 'UserPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, _id: any, status?: EnumUserStatus | null, latestDropoffDate?: any | null, rebookingStatus?: string | null, rebookingIntervalSource?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null }> | null } | null };

export type ProcessorExportPreviewQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  type: ProcessorExportTypeEnum;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ExportColumnInput>> | InputMaybe<ExportColumnInput>>;
  sort?: InputMaybe<Array<InputMaybe<ExportSortInput>> | InputMaybe<ExportSortInput>>;
  filters?: InputMaybe<Array<InputMaybe<ExportFilterInput>> | InputMaybe<ExportFilterInput>>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  sampleColumns?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProcessorExportPreviewQuery = { __typename?: 'Query', processorExportPreview: any };

export type ProcessorNotificationPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorNotificationInput;
  filter: FilterFindManyProcessorNotificationInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorNotificationPaginationQuery = { __typename?: 'Query', processorNotificationPagination?: { __typename?: 'ProcessorNotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorNotification', _id: any, vendor: any, notificationType: string, type: EnumProcessorNotificationType, sentTo: string, sentOn: any, errorMessage?: any | null }> | null } | null };

export type ProcessorOfferedSplitsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProcessorOfferedSplitsQuery = { __typename?: 'Query', processorOfferedSplits?: Array<{ __typename?: 'ProcessorOfferedSplit', species: string, splitTypes: Array<string> } | null> | null };

export type ProcessorSchedulingByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  includeSplits?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorSchedulingByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', dropoffDate?: any | null, dropoffDateStr?: string | null, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, _id: any, vendor?: { __typename?: 'Vendor', shop_name: string, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, email?: string | null, phone?: string | null, _id: any } } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', payment_status?: string | null } | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, status?: string | null, splitType?: string | null, producerIdentifier?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, tracking?: string | null, publicId: string, hangTimeDays?: number | null, isKillAndChill?: boolean | null, splits?: Array<{ __typename?: 'Split', splitPart?: string | null, notes?: string | null, locked?: boolean | null, _id: any, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null, capabilitySet: any, questionnaire: any, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, quantity?: number | null, percentage?: number | null, rank?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, extraSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelections', extras?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras', optionId: string, quantity?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null, yield?: Array<{ __typename?: 'SplitYield', _id?: any | null, capabilityOptionId?: string | null, label: string, weightLbs: number, itemCount: number, packageCount: number, packageIdentifier?: string | null } | null> | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, company?: string | null } | null } | null> | null } | null> | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type ProcessorSchedulingCalendarQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
}>;


export type ProcessorSchedulingCalendarQuery = { __typename?: 'Query', getProcessorSchedulingCalendar?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, sendNotifications?: boolean | null, recurringSeries?: any | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, kind?: EnumSplitKind | null, isDeleted?: boolean | null, locked?: boolean | null, buyer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null } | null> | null } | null> | null } | null> | null };

export type ProcessorSchedulingFilteredQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyProcessorSchedulingInput;
  statusFilter?: InputMaybe<Array<EnumProcessorSchedulingStatus> | EnumProcessorSchedulingStatus>;
  matchHeadStatus?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['MongoID']['input'];
  animalSpecies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  issues?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  confirmation?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dropoffDateFrom?: InputMaybe<Scalars['Date']['input']>;
  dropoffDateTo?: InputMaybe<Scalars['Date']['input']>;
  harvestDateFrom?: InputMaybe<Scalars['Date']['input']>;
  harvestDateTo?: InputMaybe<Scalars['Date']['input']>;
  cutDateFrom?: InputMaybe<Scalars['Date']['input']>;
  cutDateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ProcessorSchedulingFilteredQuery = { __typename?: 'Query', getFilteredProcessorScheduling?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, matchedHeadStatuses?: Array<{ __typename?: 'ProcessorSchedulingHeadStatusMatch', status: string, count: number }> | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, status?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingFilteredCountQueryVariables = Exact<{
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Array<EnumProcessorSchedulingStatus> | EnumProcessorSchedulingStatus>;
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingFilteredCountQuery = { __typename?: 'Query', getFilteredProcessorScheduling?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null } | null };

export type ProcessorSchedulingIdsForContactQueryVariables = Exact<{
  contactUserId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingIdsForContactQuery = { __typename?: 'Query', processorSchedulingIdsForContact: Array<any> };

export type ProcessorSchedulingIdsReadyToInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessorSchedulingIdsReadyToInvoiceQuery = { __typename?: 'Query', processorSchedulingIdsReadyToInvoice: Array<any> };

export type ProcessorSchedulingManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProcessorSchedulingManyQuery = { __typename?: 'Query', processorSchedulingMany: Array<{ __typename?: 'ProcessorScheduling', jobId: string, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, _id: any, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, tracking?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, liveWeight?: number | null, killDate?: any | null, cutDate?: any | null, hangTimeDays?: number | null, producerIdentifier?: string | null, status?: string | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any } | null } | null> | null } | null> | null }> };

export type ProcessorSchedulingPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorSchedulingInput;
  filter: FilterFindManyProcessorSchedulingInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorSchedulingPaginationQuery = { __typename?: 'Query', processorSchedulingPagination?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, recurringSeries?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, status?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, isKillAndChill?: boolean | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingWithMissingCutsheetsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ProcessorSchedulingWithMissingCutsheetsQuery = { __typename?: 'Query', findProcessorSchedulingsWithMissingCutsheets?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingWithMissingHangingWeightsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingWithMissingHangingWeightsQuery = { __typename?: 'Query', findProcessorSchedulingsWithMissingHangingWeights?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorSchedulingsByUserIdQuery = { __typename?: 'Query', processorSchedulingPagination?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, source?: EnumProcessorSchedulingSource | null, createdAt?: any | null, dropoffDate?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null }> | null } | null };

export type ProcessorSplitRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessorSplitRequestsQuery = { __typename?: 'Query', processorSplitRequests?: Array<{ __typename?: 'MarketplaceRequest', _id: any, buyer: any, species: EnumMarketplaceRequestSpecies, splitType: EnumMarketplaceRequestSplitType, desiredPickupDate?: string | null, note?: string | null, createdAt?: any | null, depositAmount?: number | null, buyerContact?: { __typename?: 'MarketplaceRequestBuyerContact', name?: string | null, email?: string | null, phone?: string | null } | null } | null> | null };

export type ProducerActionCountsQueryVariables = Exact<{
  buyerOnly: Scalars['Boolean']['input'];
}>;


export type ProducerActionCountsQuery = { __typename?: 'Query', producerActionCounts: { __typename?: 'ProducerActionCounts', depositDue: number, dropoffsToConfirm: number, missingSplits: number, missingBuyers: number, missingCutsheets: number, openInvoices: number, openInvoiceTotal: number } };

export type ProducerBuyerRosterQueryVariables = Exact<{ [key: string]: never; }>;


export type ProducerBuyerRosterQuery = { __typename?: 'Query', producerBuyerRoster?: Array<{ __typename?: 'ProducerRosterAnimal', animalId: any, species?: string | null, tracking?: string | null, publicId?: string | null, availableToBuyers?: boolean | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, isPendingAcceptance?: boolean | null, isVetoed?: boolean | null, vetoedAt?: any | null, buyers?: Array<{ __typename?: 'ProducerRosterBuyer', splitId: any, splitPart?: string | null, status?: string | null, buyerId?: any | null, buyerName?: string | null, buyerEmail?: string | null, buyerPhone?: string | null, holdExpiresAt?: any | null, splitDepositAmount?: number | null, orderId?: any | null, orderStatus?: string | null, depositAmount?: number | null, amountRefunded?: number | null, finalAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null, depositRecipientParty?: string | null, depositOverrideState?: string | null } | null> | null } | null> | null };

export type ProducerCustomersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  balanceDueOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProducerCustomersQuery = { __typename?: 'Query', producerCustomers?: { __typename?: 'ProducerCustomersPage', count: number, pageInfo: { __typename?: 'ProducerCustomersPageInfo', currentPage: number, perPage: number, pageCount: number, itemCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'ProducerCustomerRow', buyerId: any, name: string, email?: string | null, phone?: string | null, claimsCount: number, relationshipSummary: string, lastActivityAt?: any | null, balance: { __typename?: 'ProducerCustomerBalance', kind: string, amount?: number | null }, claims?: Array<{ __typename?: 'ProducerCustomerClaim', splitId: any, splitPart?: string | null, status?: string | null, holdExpiresAt?: any | null, orderId?: any | null, orderStatus?: string | null, depositAmount?: number | null, amountRefunded?: number | null, finalAmount?: number | null, saleBaseAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null, balancePaid?: boolean | null, depositRecipientParty?: string | null, listingFee?: number | null, depositOverrideState?: string | null, vendorId?: any | null, hasCutsheet: boolean, cutsheetKeepReason?: string | null, jobId?: any | null, jobPublicId?: string | null, jobStatus?: string | null, animalId: any, species?: string | null, tracking?: string | null, publicId?: string | null, availableToBuyers?: boolean | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, isPendingAcceptance?: boolean | null, isVetoed?: boolean | null, vetoedAt?: any | null, adjustments?: Array<{ __typename?: 'ProducerCustomerAdjustment', label: string, amount: number } | null> | null }> | null, lastOrder?: { __typename?: 'ProducerCustomerLastOrder', date?: any | null, animalLabel: string, amount?: number | null, status?: string | null, orderId: any } | null }> | null } | null };

export type ProducerDropoffsToConfirmQueryVariables = Exact<{ [key: string]: never; }>;


export type ProducerDropoffsToConfirmQuery = { __typename?: 'Query', producerDropoffsToConfirm: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, dropoffConfirmationRequested?: boolean | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus } | null }> };

export type ProducerJobByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProducerJobByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, sendNotifications?: boolean | null, statusLastUpdated?: any | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockTitle?: string | null, expectedArrivalTime?: string | null, dropoffConfirmationRequested?: boolean | null, additionalPickupDetails?: string | null, hasCutsheetNeededNotification?: boolean | null, hasCutsheetReminderNotification?: boolean | null, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationVia } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, status?: string | null, splitType?: string | null, questionnaire?: any | null, publicId: string, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, sendNotifications?: boolean | null, killDate?: any | null, cutDate?: any | null, tracking?: string | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, isHangingWeightPerSide?: boolean | null, producerIdentifier?: string | null, isKillAndChill?: boolean | null, availableToBuyers?: boolean | null, allowedSectionSizes?: Array<string | null> | null, descriptorChips?: Array<string | null> | null, producerDescription?: string | null, listedBy?: string | null, sizeTier?: string | null, liveWeight?: number | null, liveWeightHigh?: number | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, listingDeposits?: { __typename?: 'ProcessorSchedulingAnimalHeadsListingDeposits', whole?: number | null, half?: number | null, quarter?: number | null } | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, depositAmount?: number | null, placementHoldAt?: any | null, lastNudgedAt?: any | null, lastNudgeKind?: EnumSplitLastNudgeKind | null, isDeleted?: boolean | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, yield?: Array<{ __typename?: 'SplitYield', _id?: any | null, capabilityOptionId?: string | null, label: string, weightLbs: number, itemCount: number, packageCount: number, packageIdentifier?: string | null } | null> | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null, questionnaire: any, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, quantity?: number | null, percentage?: number | null, rank?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, extraSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelections', extras?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras', optionId: string, quantity?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null } | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, buyer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null, phone?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, order?: { __typename?: 'OrderInvoiceResult', _id: any, status: string, finalAmount?: number | null, saleBaseAmount?: number | null, balanceDue?: number | null, invoicedAt?: any | null, balancePaidAt?: any | null, depositRecipientParty?: string | null, settledOffPlatform?: boolean | null, listingFee?: number | null, adjustments?: Array<{ __typename?: 'OrderAdjustmentResult', label: string, amount: number } | null> | null } | null } | null> | null } | null> | null, notificationHistory: Array<{ __typename?: 'Notification', _id: any, type?: string | null, notificationType?: EnumNotificationNotificationType | null, sentTo?: string | null, createdAt?: any | null, user?: { __typename?: 'User', _id: any } | null }>, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', species: EnumProcessorSettingsAnimalSettingsSpecies, splitTypes?: Array<string | null> | null } | null> | null } | null } | null };

export type ProducerJobIdsNeedingAttentionQueryVariables = Exact<{
  category: Scalars['String']['input'];
}>;


export type ProducerJobIdsNeedingAttentionQuery = { __typename?: 'Query', producerJobIdsNeedingAttention: Array<any> };

export type ProducerJobsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProducerJobsQuery = { __typename?: 'Query', producerJobs?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, killDate?: any | null, splitType?: string | null, splits?: Array<{ __typename?: 'Split', _id: any, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any } | null, buyer?: { __typename?: 'User', _id: any } | null } | null> | null } | null> | null }> | null } | null };

export type ProducerListingEligibilityQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ProducerListingEligibilityQuery = { __typename?: 'Query', producerListingEligibility?: { __typename?: 'ProducerListingEligibility', eligible: boolean, missing: Array<string>, marketplaceEnabled?: boolean | null } | null };

export type ProducerListingEstimateQueryVariables = Exact<{
  animalId: Scalars['MongoID']['input'];
  sizeTier?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  liveWeightHigh?: InputMaybe<Scalars['Float']['input']>;
  listingRatePerLb?: InputMaybe<Scalars['Float']['input']>;
  listingTotalPrice?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ProducerListingEstimateQuery = { __typename?: 'Query', producerListingEstimate?: { __typename?: 'ProducerListingEstimate', sections?: Array<{ __typename?: 'ProducerListingSectionEstimate', size: string, estimatedTotalLow: number, estimatedTotalHigh: number, meatLow: number, meatHigh: number, processingLow: number, processingHigh: number } | null> | null } | null };

export type ProducerOfferedSpeciesQueryVariables = Exact<{
  producerId: Scalars['MongoID']['input'];
}>;


export type ProducerOfferedSpeciesQuery = { __typename?: 'Query', producerOfferedSpecies: Array<string> };

export type ProducerSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProducerSettingsQuery = { __typename?: 'Query', producerSettings?: { __typename?: 'ProducerSettings', producer?: any | null, bio?: string | null, bannerUrl?: string | null, boxImageUrl?: string | null, buyerChips?: Array<string | null> | null, buyerBio?: string | null, splitDeposits: Array<{ __typename?: 'ProducerSplitDeposit', species: string, whole?: number | null, half?: number | null, quarter?: number | null }>, listingPresets?: Array<{ __typename?: 'ProducerListingPreset', species: string, pricingMode?: string | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, sizeTier?: string | null, allowedSectionSizes?: Array<string | null> | null, descriptorChips?: Array<string | null> | null, description?: string | null } | null> | null } | null };

export type ProducersByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProducersByVendorIdQuery = { __typename?: 'Query', searchCustomers: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, phone?: string | null }> };

export type RecurringSeriesUpcomingJobCountQueryVariables = Exact<{
  seriesId: Scalars['MongoID']['input'];
}>;


export type RecurringSeriesUpcomingJobCountQuery = { __typename?: 'Query', recurringSeriesUpcomingJobCount: number };

export type RenderNotificationEmailPreviewQueryVariables = Exact<{
  content: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenderNotificationEmailPreviewQuery = { __typename?: 'Query', renderNotificationEmailPreview?: { __typename?: 'EmailPreviewResult', html: string } | null };

export type FinancialMetricsActualsManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyFinancialMetricsActualsInput>;
  sort?: InputMaybe<SortFindManyFinancialMetricsActualsInput>;
}>;


export type FinancialMetricsActualsManyQuery = { __typename?: 'Query', financialMetricsActualsMany: Array<{ __typename?: 'FinancialMetricsActuals', _id: any, vendor: any, period: string, overhead: number, costOfGoodsSold: number, totalHangingWeight: number, createdAt?: any | null, updatedAt?: any | null, speciesActuals?: Array<{ __typename?: 'FinancialMetricsActualsSpeciesActuals', species: EnumFinancialMetricsActualsSpeciesActualsSpecies, headCount: number, revenue: number, hangingWeight: number } | null> | null }> };

export type FinancialMetricsActualsUpsertMutationVariables = Exact<{
  record: FinancialMetricsActualsUpsertInput;
}>;


export type FinancialMetricsActualsUpsertMutation = { __typename?: 'Mutation', financialMetricsActualsUpsert?: { __typename?: 'FinancialMetricsActuals', _id: any, vendor: any, period: string, overhead: number, costOfGoodsSold: number, totalHangingWeight: number, speciesActuals?: Array<{ __typename?: 'FinancialMetricsActualsSpeciesActuals', species: EnumFinancialMetricsActualsSpeciesActualsSpecies, headCount: number, revenue: number, hangingWeight: number } | null> | null } | null };

export type FinancialMetricsActualsRemoveMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type FinancialMetricsActualsRemoveMutation = { __typename?: 'Mutation', financialMetricsActualsRemove?: { __typename?: 'FinancialMetricsActuals', _id: any } | null };

export type GetFinancialReportingConfigQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneFinancialReportingConfigInput>;
}>;


export type GetFinancialReportingConfigQuery = { __typename?: 'Query', financialReportingConfigOne?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, dateAnchor?: EnumFinancialReportingConfigDateAnchor | null, createdAt?: any | null, updatedAt?: any | null, animalConfigurations?: Array<{ __typename?: 'FinancialReportingConfigAnimalConfigurations', species: EnumFinancialReportingConfigAnimalConfigurationsSpecies, expectedThroughput: number, maxCapacity: number, processingCost: number, revenue: number, averageHangingWeight: number } | null> | null, overheadCosts?: Array<{ __typename?: 'FinancialReportingConfigOverheadCosts', name: string, amount: number, frequency: EnumFinancialReportingConfigOverheadCostsFrequency } | null> | null, timeConfiguration?: { __typename?: 'FinancialReportingConfigTimeConfiguration', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null, monthlyModifiers?: { __typename?: 'FinancialReportingConfigMonthlyModifiers', january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number } | null } | null };

export type FinancialReportingConfigUpsertMutationVariables = Exact<{
  record: FinancialReportingConfigUpsertInput;
}>;


export type FinancialReportingConfigUpsertMutation = { __typename?: 'Mutation', financialReportingConfigUpsert?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, dateAnchor?: EnumFinancialReportingConfigDateAnchor | null, createdAt?: any | null, updatedAt?: any | null, animalConfigurations?: Array<{ __typename?: 'FinancialReportingConfigAnimalConfigurations', species: EnumFinancialReportingConfigAnimalConfigurationsSpecies, expectedThroughput: number, maxCapacity: number, processingCost: number, revenue: number, averageHangingWeight: number } | null> | null, overheadCosts?: Array<{ __typename?: 'FinancialReportingConfigOverheadCosts', name: string, amount: number, frequency: EnumFinancialReportingConfigOverheadCostsFrequency } | null> | null, timeConfiguration?: { __typename?: 'FinancialReportingConfigTimeConfiguration', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null, monthlyModifiers?: { __typename?: 'FinancialReportingConfigMonthlyModifiers', january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number } | null } | null };

export type GetFinancialReportingMetricsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  dateAnchor?: InputMaybe<Scalars['String']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
}>;


export type GetFinancialReportingMetricsQuery = { __typename?: 'Query', financialReportingMetrics: any };

export type GetProcessorBenchmarksQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
}>;


export type GetProcessorBenchmarksQuery = { __typename?: 'Query', processorBenchmarks: any };

export type GetProcessorWorkflowFunnelQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProcessorWorkflowFunnelQuery = { __typename?: 'Query', processorWorkflowFunnel: any };

export type SearchCustomersQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  relationshipTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchCustomersQuery = { __typename?: 'Query', searchCustomers: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, phone?: string | null }> };

export type SearchRecurringSeriesQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchRecurringSeriesQuery = { __typename?: 'Query', searchRecurringSeries?: { __typename?: 'RecurringSeriesPagination', count?: number | null, items?: Array<{ __typename?: 'RecurringSeries', _id: any, active: boolean, producerName?: string | null, nextOccurrence?: any | null, upcomingJobCount?: number | null, targetUpcomingCount?: number | null, rule: { __typename?: 'RecurringSeriesRule', freq: EnumRecurringSeriesRuleFreq, interval: number, anchor: string, timezone: string, byMonthDay?: Array<number | null> | null, until?: string | null, count?: number | null, byDay?: Array<{ __typename?: 'RecurringSeriesRuleByDay', ordinal?: number | null, day: EnumRecurringSeriesRuleByDayDay } | null> | null }, jobTemplate: { __typename?: 'RecurringSeriesJobTemplate', animalSpecies: EnumRecurringSeriesJobTemplateAnimalSpecies, headCount: number } }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type ServerTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerTimeQuery = { __typename?: 'Query', serverTime: any };

export type ShortUrlPreviewQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ShortUrlPreviewQuery = { __typename?: 'Query', shortUrlPreview?: { __typename?: 'ShortUrlPreview', code: string, url: string, destinationUrl: string, title?: string | null, description?: string | null, imageUrl?: string | null, siteName?: string | null } | null };

export type SplitCutsheetQuestionnaireQueryVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  splitId: Scalars['MongoID']['input'];
}>;


export type SplitCutsheetQuestionnaireQuery = { __typename?: 'Query', splitCutsheetQuestionnaire?: { __typename?: 'SplitCutsheetQuestionnaire', questionnaireId?: any | null, capabilitiesV2Active: boolean, capabilitiesV1Active: boolean } | null };

export type StateManyQueryVariables = Exact<{ [key: string]: never; }>;


export type StateManyQuery = { __typename?: 'Query', stateMany: Array<{ __typename?: 'State', name: string, code: string, _id: any }> };

export type UserSettingsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserSettingsByUserIdQuery = { __typename?: 'Query', userSettingsByUserId?: { __typename?: 'UserSettingsByUserId', settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type UserTenantVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTenantVendorQuery = { __typename?: 'Query', userTenantVendor?: { __typename?: 'User', intercomWebToken?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, slug?: string | null, picture_url?: string | null, banner_url?: string | null, box_image_url?: string | null, bio?: string | null, role?: EnumUserRole | null, enabled: boolean, auth_method?: EnumUserAuth_Method | null, can_receive_sms?: boolean | null, can_receive_email_updates?: boolean | null, _id: any, address?: { __typename?: 'Address', _id: any, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays?: number | null, slug?: string | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, acceptsInPersonDeposits?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, sendWeeklySummaryEmail?: boolean | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, requestDropoffConfirmation?: boolean | null, schedulingDeposit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, rebooking?: { __typename?: 'ProcessorSettingsAnimalSettingsRebooking', isEnabled?: boolean | null, intervalDays?: number | null, dueSoonWindowDays?: number | null } | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, hangTimeSettings?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettings', species: EnumProcessorSettingsHangTimeSettingsSpecies, isEnabled: boolean, options?: Array<{ __typename?: 'ProcessorSettingsHangTimeSettingsOptions', durationDays: number, isDefault?: boolean | null, upcharge?: number | null, availableAtBooking?: boolean | null } | null> | null } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, killSheet?: { __typename?: 'ProcessorSettingsDocumentSettingsKillSheet', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, calendarTooltip?: { __typename?: 'ProcessorSettingsDocumentSettingsCalendarTooltip', fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null } | null> | null } | null, cutsheetHeader?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheetHeader', media?: EnumProcessorSettingsDocumentSettingsCutsheetHeaderMedia | null, fields?: Array<{ __typename?: 'ProcessorSettingsDocumentSettingsCarcassTagFields', fieldKey: string, fieldSource: EnumProcessorSettingsDocumentSettingsCarcassTagFieldsFieldSource, label: string, enabled?: boolean | null, displayOrder?: number | null, column?: number | null } | null> | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: string, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }>, tenant?: { __typename?: 'Tenant', _id: any, picture_url?: string | null } | null } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type VendorCustomerJobsQueryVariables = Exact<{
  customerId: Scalars['MongoID']['input'];
  buyerJobIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VendorCustomerJobsQuery = { __typename?: 'Query', vendorCustomerJobs?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, killDate?: any | null, splitType?: string | null, splits?: Array<{ __typename?: 'Split', _id: any, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any } | null, buyer?: { __typename?: 'User', _id: any } | null } | null> | null } | null> | null }> | null } | null };

export type VendorCustomerNotificationDefaultsQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type VendorCustomerNotificationDefaultsQuery = { __typename?: 'Query', vendorCustomerNotificationDefaults?: { __typename?: 'CustomerNotificationDefaults', job: boolean, animal: boolean, split: boolean } | null };

export type VendorHerdAnimalsQueryVariables = Exact<{
  scope?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  listed?: InputMaybe<Scalars['String']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
  cutWithinDays?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  saleProgress?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VendorHerdAnimalsQuery = { __typename?: 'Query', vendorHerdAnimals?: { __typename?: 'AnimalPagination', count?: number | null, items?: Array<{ __typename?: 'Animal', _id: any, species: string, tracking?: string | null, splitType?: string | null, producerIdentifier?: string | null, status?: string | null, job?: any | null, jobId?: string | null, sex?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, availableToBuyers?: boolean | null, allowedSectionSizes?: Array<string | null> | null, claimMode?: EnumAnimalClaimMode | null, remainingCapacity?: number | null, isFull?: boolean | null, killDate?: any | null, cutDate?: any | null, liveWeight?: number | null, liveWeightHigh?: number | null, sizeTier?: EnumAnimalSizeTier | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, descriptorChips?: Array<string | null> | null, producerDescription?: string | null, listingRecipient?: string | null, hangingWeight?: number | null, grade?: string | null, isKillAndChill?: boolean | null, createdAt?: any | null, producerRef?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, splits?: Array<{ __typename?: 'Split', _id: any, splitPart?: string | null, kind?: EnumSplitKind | null, status?: EnumSplitStatus | null, depositAmount?: number | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, placementHoldAt?: any | null, lastNudgedAt?: any | null, lastNudgeKind?: EnumSplitLastNudgeKind | null, locked?: boolean | null, buyer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any } | null, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null } | null> | null, listingDeposits?: { __typename?: 'AnimalListingDeposits', whole?: number | null, half?: number | null, quarter?: number | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type VendorInHouseProducerOneQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorInHouseProducerOneQuery = { __typename?: 'Query', vendorInHouseProducerOne?: { __typename?: 'InHouseProducer', id?: any | null, slug?: string | null, company?: string | null, picture_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, city?: string | null, state?: string | null, stripeAccountId?: string | null, canList?: boolean | null, missingRequirements?: Array<string> | null } | null };

export type VendorInHouseProducerSettingsOneQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorInHouseProducerSettingsOneQuery = { __typename?: 'Query', vendorInHouseProducerSettingsOne?: { __typename?: 'ProducerSettings', producer?: any | null, splitDeposits: Array<{ __typename?: 'ProducerSplitDeposit', species: string, whole?: number | null, half?: number | null, quarter?: number | null }>, listingPresets?: Array<{ __typename?: 'ProducerListingPreset', species: string, pricingMode?: string | null, listingRatePerLb?: number | null, listingTotalPrice?: number | null, sizeTier?: string | null, allowedSectionSizes?: Array<string | null> | null, descriptorChips?: Array<string | null> | null, description?: string | null } | null> | null } | null };

export type VendorLinkableProducersQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorLinkableProducersQuery = { __typename?: 'Query', vendorLinkableProducers?: Array<{ __typename?: 'LinkableProducer', _id?: any | null, company?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, isStaffAccount?: boolean | null } | null> | null };

export type VendorListQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type VendorListQuery = { __typename?: 'Query', vendorList?: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string } | null } | null> | null };

export type VendorPickerListQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorPickerListQuery = { __typename?: 'Query', adminVendorList: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string } | null }> };

export type VendorSpeciesQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type VendorSpeciesQuery = { __typename?: 'Query', adminVendorSpecies: Array<string> };

export type VendorTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorTeamMembersQuery = { __typename?: 'Query', vendorTeamMembers: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, role?: EnumUserRole | null, enabled: boolean, last_login?: number | null }> };

export type ProcessingJobByIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  includeProcessorSettings: Scalars['Boolean']['input'];
}>;


export type ProcessingJobByIdQuery = { __typename?: 'Query', findProcessorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, recurringSeries?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, sendNotifications?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, hasCutsheetNeededNotification?: boolean | null, hasCutsheetReminderNotification?: boolean | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, blockIndex?: number | null, blockTitle?: string | null, expectedArrivalTime?: string | null, additionalPickupDetails?: string | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, enabledAnimalSplits?: Array<string | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null, tags: Array<{ __typename?: 'JobTag', _id: any, name: string, icon: string, sortOrder?: number | null }>, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus, changedByName?: string | null } | null> | null, customerConfirmation?: { __typename?: 'ProcessorSchedulingCustomerConfirmation', status: EnumProcessorSchedulingCustomerConfirmationStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationVia, respondedByName?: string | null } | null, customerConfirmationHistory?: Array<{ __typename?: 'ProcessorSchedulingCustomerConfirmationHistory', status: EnumProcessorSchedulingCustomerConfirmationHistoryStatus, respondedAt: any, via: EnumProcessorSchedulingCustomerConfirmationHistoryVia, respondedByName?: string | null } | null> | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, method?: EnumProcessorSchedulingDepositMethod | null, status?: EnumProcessorSchedulingDepositStatus | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, hasMissingSplits?: boolean | null, hasMissingContacts?: boolean | null, hasMissingCutsheets?: boolean | null, sendNotifications?: boolean | null, status?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, thirdPartyFee?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, hangTimeDays?: number | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, statusChanges?: Array<{ __typename?: 'AnimalStatusChange', date?: any | null, previousStatus?: string | null, newStatus?: string | null, changedByName?: string | null } | null> | null, splits?: Array<{ __typename?: 'Split', _id: any, sendNotifications?: boolean | null, splitPart?: string | null, kind?: EnumSplitKind | null, notes?: string | null, locked?: boolean | null, status?: EnumSplitStatus | null, depositOverrideState?: string | null, holdExpiresAt?: any | null, cutsheetSource?: EnumSplitCutsheetSource | null, settlementStatus?: { __typename?: 'SplitSettlementView', billable: boolean, progress?: string | null, ready: boolean, collected: boolean, settled: boolean, invoiced: boolean, invoiceId?: any | null, invoiceNumber?: string | null, invoiceStatus?: string | null, settlementMethod?: string | null, payerLabel?: string | null, payerParty?: string | null, producerSettled?: boolean | null } | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaire?: { __typename?: 'CutsheetQuestionnaire', _id: any } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, buyer?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null, pickupLocation?: { __typename?: 'PickupLocation', _id: any, name: string, description?: string | null, address?: { __typename?: 'Address', address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, postcode?: string | null } | null } | null, cutsheetChanges?: Array<{ __typename?: 'SplitCutsheetChanges', _id?: any | null, source: EnumSplitCutsheetChangesSource, timestamp: any, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, previousCutsheet?: { __typename?: 'Cutsheet', _id: any, name: string } | null, previousQuestionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string } | null, enteredBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null } | null } | null> | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type WaitlistByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type WaitlistByVendorIdQuery = { __typename?: 'Query', waitlistByVendorId?: Array<{ __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null } | null> | null };

export type WaitlistByVendorPaginationQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  animal?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type WaitlistByVendorPaginationQuery = { __typename?: 'Query', waitlistByVendorPagination?: { __typename?: 'WaitlistPagination', count?: number | null, items?: Array<{ __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } } | null };

export type WaitlistPaginationQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyWaitlistInput>;
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type WaitlistPaginationQuery = { __typename?: 'Query', waitlistPagination?: { __typename?: 'WaitlistPagination', count?: number | null, items?: Array<{ __typename?: 'Waitlist', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null, status: EnumWaitlistStatus, inspectionLevel?: EnumWaitlistInspectionLevel | null, headCount?: number | null, linkedJob?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus } | null, producer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export const ChatMessageFragmentFragmentDoc = gql`
    fragment ChatMessageFragment on ChatMessage {
  _id
  chatRoom {
    _id
    vendor {
      _id
      shop_name
      tenant {
        name
        picture_url
      }
    }
  }
  content
  imageUrl
  isNotification
  animal
  animalSpecies
  notificationPrompt {
    _id
    kind
    status
    canAnswer
    jobId
    expiresAt
  }
  sender {
    _id
    first_name
    last_name
    company
    role
    picture_url
  }
  readAt
  createdAt
  updatedAt
}
    `;
export const ChatRoomFragmentFragmentDoc = gql`
    fragment ChatRoomFragment on ChatRoom {
  _id
  vendor {
    _id
    shop_name
    tenant {
      name
      picture_url
    }
  }
  producer {
    _id
    first_name
    last_name
    company
    picture_url
  }
  participants {
    _id
    first_name
    last_name
    company
    role
    picture_url
  }
  createdAt
  createdBy {
    _id
  }
  updatedAt
  twilioConversationSid
  unreadMessagesCount
  markedUnread
  lastMessage {
    content
    sender {
      _id
    }
  }
}
    `;
export const CutsheetAssignmentRuleSetFragmentFragmentDoc = gql`
    fragment CutsheetAssignmentRuleSetFragment on CutsheetAssignmentRuleSet {
  _id
  vendor
  capabilityId
  defaultQuestionnaireId
  rules {
    sortOrder
    label
    inspectionLevel
    splitType
    splitIndex
    producer
    buyer
    questionnaireId
  }
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityFragment on CutsheetCapability {
  _id
  vendor
  species
  name
  description
  printSettings {
    baseFontSize
    primalColumns
    specsLayoutPosition
    checkboxStyle
    showAllSpecOptions
    showPrimalGroup
    alwaysShowPrimalNotes
    hideUnselectedCuts
    highlightCutsheetNotes
    highlightSectionNotes
    orientation
    hiddenGroupIds
    hiddenItemIds
    hiddenSpecificationIds
    showCustomContent
    customContentTitle
    customContent
  }
  legacyInspectionLevelMap {
    inspectionLevel
    questionnaireId
    cutMappings {
      oldCutId
      newOptionId
    }
    trimMappings {
      oldTrimName
      newOptionId
    }
    extraMappings {
      oldExtraName
      newSpecificationId
      newOptionValue
    }
    specMappings {
      oldSpecName
      newSpecificationId
    }
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityOptionFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityOptionFragment on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  optionType
  title
  description
  imageUrl
  printedText
  groupId
  isDefault
  minQty
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  partnerCodes {
    adapter
    code
    rules {
      conditions {
        specificationId
        value
      }
      code
    }
  }
  sortOrder
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityCutFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityCutFragment on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  groupId
  title
  description
  imageUrl
  printedText
  sortOrder
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  partnerCodes {
    adapter
    code
    rules {
      conditions {
        specificationId
        value
      }
      code
    }
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetDescriptionLibraryFragmentFragmentDoc = gql`
    fragment CutsheetDescriptionLibraryFragment on CutsheetDescriptionLibrary {
  _id
  name
  description
  tags
  notes
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityExtraFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityExtraFragment on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  title
  description
  imageUrl
  printedText
  sortOrder
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  partnerCodes {
    adapter
    code
    rules {
      conditions {
        specificationId
        value
      }
      code
    }
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityGroupFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityGroupFragment on CutsheetCapabilityGroup {
  _id
  vendor
  capabilityId
  title
  sortOrder
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetImageLibraryFragmentFragmentDoc = gql`
    fragment CutsheetImageLibraryFragment on CutsheetImageLibrary {
  _id
  name
  imageUrl
  tags
  notes
  createdAt
  updatedAt
}
    `;
export const CutsheetQuestionnaireFragmentFragmentDoc = gql`
    fragment CutsheetQuestionnaireFragment on CutsheetQuestionnaire {
  _id
  vendor
  capabilityId
  name
  description
  questions {
    id
    type
    title
    description
    required
    sortOrder
    specificationId
    availableCutIds
    allowMultiple
    minSelections
    maxSelections
    allowSubSelection
    options {
      id
      label
      description
      imageUrl
      cutIds
    }
    availableTrimIds
    requireExactTotal
    imageUrl
    details
  }
  pricingOverrides
  specOptionPricingOverrides
  pricePerPound
  processingFee {
    priceType
    amount
    basis
  }
  killFee {
    priceType
    amount
    basis
  }
  additionalCharges {
    id
    label
    amount
    priceType
    basis
    description
  }
  defaultSelections {
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
    primalNotes {
      id
      note
    }
    trimNotes {
      id
      note
    }
  }
  useCustomPrintSettings
  printSettings {
    baseFontSize
    primalColumns
    specsLayoutPosition
    checkboxStyle
    showAllSpecOptions
    showPrimalGroup
    alwaysShowPrimalNotes
    hideUnselectedCuts
    highlightCutsheetNotes
    highlightSectionNotes
    orientation
    hiddenGroupIds
    hiddenItemIds
    hiddenSpecificationIds
    showCustomContent
    customContentTitle
    customContent
  }
  status
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilitySpecificationFragmentFragmentDoc = gql`
    fragment CutsheetCapabilitySpecificationFragment on CutsheetCapabilitySpecification {
  _id
  vendor
  capabilityId
  title
  description
  inputType
  options
  unit
  defaultValue
  required
  printedText
  assignedToIds
  pricingAdjustments
  sortOrder
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityTrimFragmentV2FragmentDoc = gql`
    fragment CutsheetCapabilityTrimFragmentV2 on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  title
  description
  imageUrl
  printedText
  isDefault
  minQty
  sortOrder
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  partnerCodes {
    adapter
    code
    rules {
      conditions {
        specificationId
        value
      }
      code
    }
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const DocumentFragmentFragmentDoc = gql`
    fragment DocumentFragment on Document {
  _id
  category
  source
  generator
  url
  filename
  mimeType
  fileSize
  hash
  currentVersion
  links {
    entityType
    entityId
  }
  versions {
    version
    filename
    mimeType
    fileSize
    isGenerated
    note
    createdAt
  }
  uploadedBy {
    _id
    first_name
    last_name
  }
  createdAt
  updatedAt
}
    `;
export const LandingPageFragmentFragmentDoc = gql`
    fragment LandingPageFragment on LandingPageSettings {
  _id
  vendorId
  name
  slug
  species
  about
  buyerBio
  bannerUrl
  boxImageUrl
  buyerChips
  premierProducers {
    producerId
    badge
  }
  showCommunityListings
  storefrontProducers
  tagline
  logoUrl
  showAddress
  showOnMap
  showInDirectory
  showAbout
  showContact
  showPricing
  showGallery
  showDocuments
  showFaq
  address {
    address_1
    address_2
    city
    state
    postcode
    country
    type
  }
  location {
    coordinates
  }
  pricingRows {
    _id
    label
    price
    unit
    notes
  }
  contact {
    email
    phone
    website
    facebook
    instagram
    twitter
    youtube
  }
  galleryImages
  documents {
    _id
    name
    description
    fileUrl
  }
  faq {
    _id
    question
    answer
  }
}
    `;
export const NoteFragmentFragmentDoc = gql`
    fragment NoteFragment on Note {
  _id
  note
  type
  animalHead
  attachments {
    url
    filename
    mimeType
  }
  createdBy {
    first_name
    last_name
  }
  createdAt
  updatedAt
}
    `;
export const NotificationSettingFragmentFragmentDoc = gql`
    fragment NotificationSettingFragment on NotificationSetting {
  _id
  name
  enabled
  trigger
  timings {
    days
    relation
    enabled
  }
  requestConfirmation
  confirmationMessage
  defaultConfirmationMessage
  sendEmail
  sendSMS
  sendInApp
  preferredChannel
  ctaButtonText
  ctaButtonUrl
  emailMessage {
    _id
    content
    type
  }
  smsMessage {
    _id
    content
    type
  }
}
    `;
export const PrimalCutBlockerFragmentFragmentDoc = gql`
    fragment PrimalCutBlockerFragment on PrimalCutBlocker {
  _id
  vendor
  animalSpecies
  inspectionLevel
  name
  primalCutId
  type
  blockedBy {
    name
    primalCutId
    _id
  }
}
    `;
export const CapabilitySpecificationFragmentDoc = gql`
    fragment CapabilitySpecification on ProcessorCapabilitySpecification {
  _id
  capability {
    _id
    animalSpecies
    inspectionLevel
  }
  specifications {
    _id
    name
    description
    imageUrl
    options {
      _id
      name
      isVisible
      isDefault
      description
    }
    measurementUnit
    isVisible
    isRequired
  }
}
    `;
export const ProcessorCapabilityFragmentFragmentDoc = gql`
    fragment ProcessorCapabilityFragment on ProcessorCapability {
  _id
  vendor
  animalSpecies
  inspectionLevel
  canSelectMoreThanOneTrim
  trimSelection
  primalCuts
  cuts {
    primal {
      name
      description
      group {
        animalSpecies
        inspectionLevel
        name
        order
        isDefault
        isDeleted
        processorSettings
        _id
      }
      isDeleted
      order
      _id
    }
    isDeleted
    name
    description
    cutType {
      name
      _id
    }
    order
    _id
  }
  extras {
    name
    pricePerPound
    minLbs
    isActive
    _id
    type
    fee
    description
  }
  trim {
    name
    pricePerPound
    minLbs
    isActive
    _id
    description
  }
  activeSpecification {
    ...CapabilitySpecification
  }
  primalGroups {
    _id
    name
    order
    primals {
      _id
      name
      description
      imageUrl
      order
    }
  }
  wizardWelcomeTitle
  wizardWelcomeContent
  extrasDescription
  trimDescription
  extrasImageUrl
  trimImageUrl
}
    ${CapabilitySpecificationFragmentDoc}`;
export const PrimalCutFragmentFragmentDoc = gql`
    fragment PrimalCutFragment on PrimalCut {
  primal {
    group {
      animalType
      name
      order
      isDeleted
      _id
    }
    name
    order
    isDeleted
    _id
  }
  name
  cutType {
    name
    _id
  }
  order
  _id
}
    `;
export const ExtrasFragmentFragmentDoc = gql`
    fragment ExtrasFragment on CutsheetExtras {
  _id
  isActive
  minLbs
  name
  pricePerPound
  quantity
  type
  fee
}
    `;
export const TrimFragmentFragmentDoc = gql`
    fragment TrimFragment on CutsheetTrim {
  _id
  isActive
  minLbs
  name
  pricePerPound
  quantity
  rank
  trimSelection
}
    `;
export const CutsheetFragmentFragmentDoc = gql`
    fragment CutsheetFragment on Cutsheet {
  vendor {
    _id
    shop_name
  }
  user {
    _id
    first_name
    last_name
    company
  }
  type
  animalSpecies
  inspectionLevels
  primalCuts {
    ...PrimalCutFragment
  }
  name
  pricePerPound
  steakThickness
  steaksPerPack
  groundMeatSize
  roastSize
  isDeleted
  _id
  splitTypes
  activeSpecification {
    _id
    ...CapabilitySpecification
  }
  selectedSpecifications
  extras {
    ...ExtrasFragment
  }
  trim {
    ...TrimFragment
  }
  notes
  convertedToQuestionnaireResponse
}
    ${PrimalCutFragmentFragmentDoc}
${CapabilitySpecificationFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;
export const ContactUserFragmentDoc = gql`
    fragment ContactUser on User {
  _id
  email
  first_name
  last_name
  phone
  enabled
  role
  company
}
    `;
export const SplitFragmentDoc = gql`
    fragment Split on Split {
  _id
  sendNotifications
  cutsheet {
    ...CutsheetFragment
  }
  questionnaire {
    _id
  }
  questionnaireResponse {
    _id
    name
    type
    pricePerPound
    createdAt
  }
  splitPart
  kind
  notes
  locked
  status
  depositOverrideState
  holdExpiresAt
  buyer {
    ...ContactUser
  }
  pickupLocation {
    _id
    name
    description
    address {
      address_1
      address_2
      city
      state
      postcode
    }
  }
  cutsheetSource
  cutsheetChanges {
    _id
    source
    timestamp
    cutsheet {
      _id
      name
    }
    questionnaireResponse {
      _id
      name
    }
    previousCutsheet {
      _id
      name
    }
    previousQuestionnaireResponse {
      _id
      name
    }
    enteredBy {
      _id
      first_name
      last_name
    }
  }
}
    ${CutsheetFragmentFragmentDoc}
${ContactUserFragmentDoc}`;
export const AnimalHeadFragmentDoc = gql`
    fragment AnimalHead on ProcessorSchedulingAnimalHeads {
  _id
  publicId
  producerIdentifier
  hasMissingSplits
  hasMissingContacts
  hasMissingCutsheets
  sendNotifications
  status
  statusChanges {
    date
    previousStatus
    newStatus
    changedByName
  }
  tracking
  splitType
  questionnaire
  isHangingWeightPerSide
  hangingWeightSideA
  hangingWeightSideB
  hangingWeight
  thirdPartyFee
  liveWeight
  grade
  yield
  killDate
  killDateStr
  cutDate
  cutDateStr
  hangTimeDays
  splits {
    ...Split
    settlementStatus {
      billable
      progress
      ready
      collected
      settled
      invoiced
      invoiceId
      invoiceNumber
      invoiceStatus
      settlementMethod
      payerLabel
      payerParty
      producerSettled
    }
  }
  isOverThirtyMonths
  isKillAndChill
  sex
  inspectionLevel
  butcherSlotPrice
  invoice {
    additionalCost {
      cost
      reason
    }
    additionalCharges {
      description
      amount
    }
    extras {
      description
      quantity
      unitPrice
    }
    trims {
      description
      quantity
      unitPrice
    }
    finishedWeights {
      type
      totalWeight
      categories {
        name
        weight
      }
    }
  }
}
    ${SplitFragmentDoc}`;
export const InvoiceFragmentLineItemFragmentDoc = gql`
    fragment InvoiceFragmentLineItem on InvoiceLineItem {
  _id
  external_id
  description
  quantity
  amount
}
    `;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on Invoice {
  vendor {
    shop_name
    _id
  }
  user {
    first_name
    last_name
    email
    phone
    _id
  }
  external_id
  description
  billing_month
  billing_year
  date_created
  amount_due
  amount_paid
  amount_refunded
  amount_discounted
  line_items {
    ...InvoiceFragmentLineItem
  }
  status_changes {
    date
    previous_status
    new_status
  }
  external_links {
    stripe
    quickbooks
  }
  links {
    entityType
    parentEntityId
    subEntityId
    entity
    description
  }
  due_date
  number
  status
  status_changes {
    date
    previous_status
    new_status
  }
  _id
  type
}
    ${InvoiceFragmentLineItemFragmentDoc}`;
export const ProcessorSchedulingFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingFragment on ProcessorScheduling {
  _id
  jobId
  tags {
    _id
    name
    icon
    sortOrder
  }
  status
  statusLastUpdated
  createdAt
  recurringSeries
  statusChanges {
    _id
    date
    newStatus
    previousStatus
    changedByName
  }
  source
  isDeleted
  sendNotifications
  dropoffDate
  dropoffDateStr
  animalSpecies
  headCount
  refundDeadlineDays
  hasCutsheetNeededNotification
  hasCutsheetReminderNotification
  hasMissingSplits
  hasMissingContacts
  hasMissingCutsheets
  blockIndex
  blockTitle
  expectedArrivalTime
  customerConfirmation {
    status
    respondedAt
    via
    respondedByName
  }
  customerConfirmationHistory {
    status
    respondedAt
    via
    respondedByName
  }
  pickupLocation {
    _id
    name
    description
    address {
      address_1
      address_2
      city
      state
      postcode
    }
  }
  additionalPickupDetails
  deposit {
    amount
    method
    status
    checkoutSession {
      status
      payment_status
    }
  }
  requestedBy {
    _id
    first_name
    last_name
    phone
    email
    role
    company
    relationships {
      vendorId
      producerId
      type
    }
  }
  vendor {
    _id
    shop_name
    address {
      email
      phone
    }
  }
  animalHeads {
    ...AnimalHead
  }
  processorSettings {
    _id
  }
  invoice {
    invoice_status
    additionalCost {
      cost
      reason
    }
  }
  linkedInvoices {
    ...InvoiceFragment
  }
}
    ${AnimalHeadFragmentDoc}
${InvoiceFragmentFragmentDoc}`;
export const ProcessorSchedulingCalendarFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingCalendarFragment on ProcessorScheduling {
  _id
  jobId
  tags {
    _id
    name
    icon
    sortOrder
  }
  status
  statusLastUpdated
  isDeleted
  sendNotifications
  recurringSeries
  dropoffDate
  dropoffDateStr
  animalSpecies
  headCount
  refundDeadlineDays
  hasMissingSplits
  hasMissingContacts
  hasMissingCutsheets
  blockIndex
  blockTitle
  expectedArrivalTime
  customerConfirmation {
    status
    respondedAt
  }
  deposit {
    amount
    method
    status
    checkoutSession {
      status
      payment_status
    }
  }
  requestedBy {
    _id
    first_name
    last_name
    phone
    email
    role
    company
  }
  vendor {
    _id
    shop_name
    address {
      email
      phone
    }
  }
  animalHeads {
    _id
    publicId
    producerIdentifier
    tracking
    hasMissingSplits
    hasMissingContacts
    hasMissingCutsheets
    splitType
    isHangingWeightPerSide
    hangingWeightSideA
    hangingWeightSideB
    hangingWeight
    liveWeight
    grade
    yield
    killDate
    killDateStr
    cutDate
    cutDateStr
    hangTimeDays
    isOverThirtyMonths
    isKillAndChill
    sex
    inspectionLevel
    butcherSlotPrice
    splits {
      _id
      splitPart
      kind
      isDeleted
      buyer {
        _id
        first_name
        last_name
        company
      }
      locked
      questionnaire {
        _id
      }
      cutsheet {
        _id
        name
      }
      questionnaireResponse {
        _id
        name
      }
    }
  }
}
    `;
export const ProcessorSchedulingSlimFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingSlimFragment on ProcessorScheduling {
  _id
  vendor {
    _id
  }
  dropoffDate
  status
  animalSpecies
  headCount
  blockIndex
  blockTitle
  expectedArrivalTime
  animalHeads {
    _id
    inspectionLevel
    status
  }
}
    `;
export const DailyCapacityFragmentFragmentDoc = gql`
    fragment DailyCapacityFragment on DailyCapacityCapacitiesByType {
  type
  capacities {
    ... on SpeciesComplexAnimalCapacitySchema {
      species
      value
    }
    ... on SpeciesInspectionComplexAnimalCapacitySchema {
      species
      inspectionLevel
      value
    }
    ... on WeightedAnimalComplexAnimalCapacitySchema {
      value
    }
  }
}
    `;
export const DailyCapacityBlockFragmentFragmentDoc = gql`
    fragment DailyCapacityBlockFragment on DailyCapacity {
  title
  capacitiesByType {
    ...DailyCapacityFragment
  }
}
    ${DailyCapacityFragmentFragmentDoc}`;
export const ProcessorSettingsCustomCapacityFragmentFragmentDoc = gql`
    fragment ProcessorSettingsCustomCapacityFragment on ProcessorSettingsCustomCapacity {
  _id
  isDeleted
  date
  dailyCapacities {
    ...DailyCapacityBlockFragment
  }
  note
  dateStr
}
    ${DailyCapacityBlockFragmentFragmentDoc}`;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  first_name
  last_name
  company
  address_1
  address_2
  city
  state
  postcode
  country
  email
  phone
  type
  _id
}
    `;
export const TenantFragmentFragmentDoc = gql`
    fragment TenantFragment on Tenant {
  name
  date_created
  enabled
  domain
  vendors {
    date_created
    external_id
    prefers_dropoff
    shop_name
    shop_slug
    show_in_directory
    tagline
    address {
      ...AddressFragment
    }
    _id
  }
  _id
}
    ${AddressFragmentFragmentDoc}`;
export const ParentProductFragmentDoc = gql`
    fragment ParentProduct on ParentProduct {
  _id
  vendor
  external_id
  slug
  name
  permalink
  price
  weight
  description
  short_description
  stock_status
  stock_quantity
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  external_id
  slug
  name
  permalink
  price
  weight
  enabled
  description
  short_description
  stock_status
  stock_quantity
  _id
  integration {
    name
  }
  parent {
    ...ParentProduct
  }
  children {
    ...ParentProduct
  }
}
    ${ParentProductFragmentDoc}`;
export const VendorFragmentFragmentDoc = gql`
    fragment VendorFragment on Vendor {
  external_id
  date_created
  shop_name
  shop_slug
  pickup_days
  enabled
  free_shipping_amount
  prefers_dropoff
  show_in_directory
  tagline
  _id
  tenant {
    ...TenantFragment
  }
  address {
    ...AddressFragment
  }
  products {
    ...ProductFragment
  }
  integrations {
    _id
    name
    type
  }
  modules {
    _id
    moduleType
    name
    label
    href
    order
    active
    settings
  }
  zone
  stripe_config
  twilioPhoneConfig {
    phoneNumberSid
    phoneNumber
    phoneNumberType
    phoneNumberStatus
    hostedNumberOrderSid
    friendlyName
  }
}
    ${TenantFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;
export const ProcessorSettingsFragmentFragmentDoc = gql`
    fragment ProcessorSettingsFragment on ProcessorSettings {
  _id
  animalSettings {
    _id
    isEnabled
    species
    inspectionLevels
    splitTypes
    weightedAnimalUnit
    minSchedulingDays
    maxSchedulingDays
    showOutsideWindowDates
    requestDropoffConfirmation
    schedulingDeposit
    customCutsheetPricing {
      price
      inspectionLevel
    }
    butcherSlotPricing {
      price
      inspectionLevel
    }
    rebooking {
      isEnabled
      intervalDays
      dueSoonWindowDays
    }
  }
  capacityConfigurationType
  capacitySettings {
    isEnabled
    dayOfWeek
    dailyCapacities {
      ...DailyCapacityBlockFragment
    }
  }
  carcassSettings {
    species
    inspectionLevel
    year
    currentNumber
    lastTakenNumber
  }
  schedulingDeposit
  refundDeadlineDays
  slug
  vendor {
    ...VendorFragment
  }
  faq
  validationErrors {
    type
    value
    property
    messages
    group
  }
  about
  autoSchedulingSettings {
    species
    isEnabled
    cutDateDays
    harvestDateDays
  }
  killAndChillSettings {
    species
    isEnabled
    pricePerHead
  }
  hangTimeSettings {
    species
    isEnabled
    options {
      durationDays
      isDefault
      upcharge
      availableAtBooking
    }
  }
  isWaitlistFunctionalityDisabled
  outsideWindowNote
  isProcessorNotificationsEnabled
  acceptsInPersonDeposits
  processorNotificationEmailAddresses
  sendWeeklySummaryEmail
  animals
  invoicing {
    trackYields
    showYieldOnInvoice
    defaultSplitRule
  }
  documentSettings {
    cutsheet {
      format
    }
    carcassTag {
      title
      fields {
        fieldKey
        fieldSource
        label
        enabled
        displayOrder
      }
    }
    killSheet {
      fields {
        fieldKey
        fieldSource
        label
        enabled
        displayOrder
      }
    }
    calendarTooltip {
      fields {
        fieldKey
        fieldSource
        label
        enabled
        displayOrder
      }
    }
    cutsheetHeader {
      media
      fields {
        fieldKey
        fieldSource
        label
        enabled
        displayOrder
        column
      }
    }
  }
  timeTrackingConfig {
    timePerNotification
    timePerCutsheet
    timePerBooking
    baseDigitalSavings
    hourlyRate
  }
}
    ${DailyCapacityBlockFragmentFragmentDoc}
${VendorFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  first_name
  last_name
  email
  phone
  company
  slug
  picture_url
  banner_url
  box_image_url
  bio
  role
  enabled
  auth_method
  can_receive_sms
  can_receive_email_updates
  address {
    _id
    address_1
    address_2
    city
    state
    postcode
    country
  }
  relationships {
    vendorId
    producerId
    type
  }
  active_vendor {
    date_created
    external_id
    prefers_dropoff
    shop_name
    shop_slug
    tagline
    address {
      ...AddressFragment
    }
    integrations {
      name
      type
      isSyncing
      lastSynced
      _id
    }
    zone
    stripe_config
    twilioPhoneConfig {
      phoneNumberSid
      phoneNumber
      phoneNumberType
      phoneNumberStatus
      hostedNumberOrderSid
      friendlyName
    }
    processorSettings {
      ...ProcessorSettingsFragment
    }
    modules {
      moduleType
      name
      label
      href
      order
      active
      settings
      _id
    }
    tenant {
      _id
      picture_url
    }
    _id
  }
  tenant {
    ...TenantFragment
  }
  settings {
    calendar {
      dateConfiguration
      calendarView
      showAllEvents
    }
  }
  _id
}
    ${AddressFragmentFragmentDoc}
${ProcessorSettingsFragmentFragmentDoc}
${TenantFragmentFragmentDoc}`;
export const WaitlistFragmentFragmentDoc = gql`
    fragment WaitlistFragment on Waitlist {
  _id
  vendor
  createdAt
  updatedAt
  sendWaitlistEmail
  sendWaitlistSMS
  animal
  startDate
  endDate
  status
  inspectionLevel
  headCount
  linkedJob {
    _id
    jobId
    status
  }
  producer {
    _id
    first_name
    last_name
    email
    phone
    company
  }
}
    `;
export const AdminUserUpdateDocument = gql`
    mutation AdminUserUpdate($userId: MongoID!, $firstName: String, $lastName: String, $email: String, $phone: String, $company: String, $role: EnumUserRole, $address: AdminUserAddressInput, $relationships: [AdminUserRelationshipInput]) {
  adminUserUpdate(
    userId: $userId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    role: $role
    address: $address
    relationships: $relationships
  ) {
    _id
    first_name
    last_name
    email
    phone
    company
    role
    enabled
    tenant {
      _id
      name
    }
    active_vendor {
      _id
      shop_name
    }
    address {
      _id
      address_1
      address_2
      city
      state
      postcode
    }
    relationships {
      vendorId
      producerId
      type
    }
  }
}
    `;
export type AdminUserUpdateMutationFn = Apollo.MutationFunction<AdminUserUpdateMutation, AdminUserUpdateMutationVariables>;

/**
 * __useAdminUserUpdateMutation__
 *
 * To run a mutation, you first call `useAdminUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserUpdateMutation, { data, loading, error }] = useAdminUserUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      role: // value for 'role'
 *      address: // value for 'address'
 *      relationships: // value for 'relationships'
 *   },
 * });
 */
export function useAdminUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserUpdateMutation, AdminUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserUpdateMutation, AdminUserUpdateMutationVariables>(AdminUserUpdateDocument, options);
      }
export type AdminUserUpdateMutationHookResult = ReturnType<typeof useAdminUserUpdateMutation>;
export type AdminUserUpdateMutationResult = Apollo.MutationResult<AdminUserUpdateMutation>;
export type AdminUserUpdateMutationOptions = Apollo.BaseMutationOptions<AdminUserUpdateMutation, AdminUserUpdateMutationVariables>;
export const IntegrationCreateOneDocument = gql`
    mutation IntegrationCreateOne($record: CreateOneIntegrationInput!) {
  integrationCreateOne(record: $record) {
    recordId
    record {
      name
      type
      endpoint
      _id
    }
    error {
      message
    }
  }
}
    `;
export type IntegrationCreateOneMutationFn = Apollo.MutationFunction<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>;

/**
 * __useIntegrationCreateOneMutation__
 *
 * To run a mutation, you first call `useIntegrationCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationCreateOneMutation, { data, loading, error }] = useIntegrationCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useIntegrationCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>(IntegrationCreateOneDocument, options);
      }
export type IntegrationCreateOneMutationHookResult = ReturnType<typeof useIntegrationCreateOneMutation>;
export type IntegrationCreateOneMutationResult = Apollo.MutationResult<IntegrationCreateOneMutation>;
export type IntegrationCreateOneMutationOptions = Apollo.BaseMutationOptions<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>;
export const IntegrationUpdateConfigDocument = gql`
    mutation IntegrationUpdateConfig($integrationId: MongoID!, $config: JSON!) {
  integrationUpdateById(_id: $integrationId, record: {config: $config}) {
    recordId
  }
}
    `;
export type IntegrationUpdateConfigMutationFn = Apollo.MutationFunction<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>;

/**
 * __useIntegrationUpdateConfigMutation__
 *
 * To run a mutation, you first call `useIntegrationUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationUpdateConfigMutation, { data, loading, error }] = useIntegrationUpdateConfigMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useIntegrationUpdateConfigMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>(IntegrationUpdateConfigDocument, options);
      }
export type IntegrationUpdateConfigMutationHookResult = ReturnType<typeof useIntegrationUpdateConfigMutation>;
export type IntegrationUpdateConfigMutationResult = Apollo.MutationResult<IntegrationUpdateConfigMutation>;
export type IntegrationUpdateConfigMutationOptions = Apollo.BaseMutationOptions<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>;
export const LandingPageRemoveByIdDocument = gql`
    mutation LandingPageRemoveById($_id: MongoID!) {
  landingPageRemoveById(_id: $_id) {
    recordId
  }
}
    `;
export type LandingPageRemoveByIdMutationFn = Apollo.MutationFunction<LandingPageRemoveByIdMutation, LandingPageRemoveByIdMutationVariables>;

/**
 * __useLandingPageRemoveByIdMutation__
 *
 * To run a mutation, you first call `useLandingPageRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLandingPageRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [landingPageRemoveByIdMutation, { data, loading, error }] = useLandingPageRemoveByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLandingPageRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<LandingPageRemoveByIdMutation, LandingPageRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LandingPageRemoveByIdMutation, LandingPageRemoveByIdMutationVariables>(LandingPageRemoveByIdDocument, options);
      }
export type LandingPageRemoveByIdMutationHookResult = ReturnType<typeof useLandingPageRemoveByIdMutation>;
export type LandingPageRemoveByIdMutationResult = Apollo.MutationResult<LandingPageRemoveByIdMutation>;
export type LandingPageRemoveByIdMutationOptions = Apollo.BaseMutationOptions<LandingPageRemoveByIdMutation, LandingPageRemoveByIdMutationVariables>;
export const MarketplaceLeadExportCsvDocument = gql`
    mutation MarketplaceLeadExportCsv($search: String, $species: String, $quantity: String, $timeline: String, $startDate: String, $endDate: String) {
  marketplaceLeadExportCsv(
    search: $search
    species: $species
    quantity: $quantity
    timeline: $timeline
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
  }
}
    `;
export type MarketplaceLeadExportCsvMutationFn = Apollo.MutationFunction<MarketplaceLeadExportCsvMutation, MarketplaceLeadExportCsvMutationVariables>;

/**
 * __useMarketplaceLeadExportCsvMutation__
 *
 * To run a mutation, you first call `useMarketplaceLeadExportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceLeadExportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceLeadExportCsvMutation, { data, loading, error }] = useMarketplaceLeadExportCsvMutation({
 *   variables: {
 *      search: // value for 'search'
 *      species: // value for 'species'
 *      quantity: // value for 'quantity'
 *      timeline: // value for 'timeline'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useMarketplaceLeadExportCsvMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceLeadExportCsvMutation, MarketplaceLeadExportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceLeadExportCsvMutation, MarketplaceLeadExportCsvMutationVariables>(MarketplaceLeadExportCsvDocument, options);
      }
export type MarketplaceLeadExportCsvMutationHookResult = ReturnType<typeof useMarketplaceLeadExportCsvMutation>;
export type MarketplaceLeadExportCsvMutationResult = Apollo.MutationResult<MarketplaceLeadExportCsvMutation>;
export type MarketplaceLeadExportCsvMutationOptions = Apollo.BaseMutationOptions<MarketplaceLeadExportCsvMutation, MarketplaceLeadExportCsvMutationVariables>;
export const ProcessorSettingsUpdateByIdDocument = gql`
    mutation ProcessorSettingsUpdateById($id: MongoID!, $record: UpdateByIdProcessorSettingsInput!) {
  processorSettingsUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type ProcessorSettingsUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>;

/**
 * __useProcessorSettingsUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsUpdateByIdMutation, { data, loading, error }] = useProcessorSettingsUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSettingsUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>(ProcessorSettingsUpdateByIdDocument, options);
      }
export type ProcessorSettingsUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSettingsUpdateByIdMutation>;
export type ProcessorSettingsUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSettingsUpdateByIdMutation>;
export type ProcessorSettingsUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>;
export const TenantCreateDocument = gql`
    mutation TenantCreate($newTenant: CreateOneTenantInput!) {
  tenantCreate(newTenant: $newTenant) {
    external_id
    name
    date_created
    domain
    enabled
    _id
  }
}
    `;
export type TenantCreateMutationFn = Apollo.MutationFunction<TenantCreateMutation, TenantCreateMutationVariables>;

/**
 * __useTenantCreateMutation__
 *
 * To run a mutation, you first call `useTenantCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantCreateMutation, { data, loading, error }] = useTenantCreateMutation({
 *   variables: {
 *      newTenant: // value for 'newTenant'
 *   },
 * });
 */
export function useTenantCreateMutation(baseOptions?: Apollo.MutationHookOptions<TenantCreateMutation, TenantCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantCreateMutation, TenantCreateMutationVariables>(TenantCreateDocument, options);
      }
export type TenantCreateMutationHookResult = ReturnType<typeof useTenantCreateMutation>;
export type TenantCreateMutationResult = Apollo.MutationResult<TenantCreateMutation>;
export type TenantCreateMutationOptions = Apollo.BaseMutationOptions<TenantCreateMutation, TenantCreateMutationVariables>;
export const TenantEnabledEditDocument = gql`
    mutation TenantEnabledEdit($tenantId: MongoID!, $enabled: Boolean!) {
  tenantEnabledEdit(tenantId: $tenantId, enabled: $enabled) {
    _id
    enabled
  }
}
    `;
export type TenantEnabledEditMutationFn = Apollo.MutationFunction<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>;

/**
 * __useTenantEnabledEditMutation__
 *
 * To run a mutation, you first call `useTenantEnabledEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantEnabledEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantEnabledEditMutation, { data, loading, error }] = useTenantEnabledEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useTenantEnabledEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>(TenantEnabledEditDocument, options);
      }
export type TenantEnabledEditMutationHookResult = ReturnType<typeof useTenantEnabledEditMutation>;
export type TenantEnabledEditMutationResult = Apollo.MutationResult<TenantEnabledEditMutation>;
export type TenantEnabledEditMutationOptions = Apollo.BaseMutationOptions<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>;
export const TenantPictureUrlEditDocument = gql`
    mutation TenantPictureUrlEdit($tenantId: MongoID!, $pictureImage: Upload, $pictureImageToRemove: Boolean) {
  tenantPictureUrlEdit(
    tenantId: $tenantId
    pictureImage: $pictureImage
    pictureImageToRemove: $pictureImageToRemove
  ) {
    external_id
    name
    enabled
    _id
    picture_url
  }
}
    `;
export type TenantPictureUrlEditMutationFn = Apollo.MutationFunction<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>;

/**
 * __useTenantPictureUrlEditMutation__
 *
 * To run a mutation, you first call `useTenantPictureUrlEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantPictureUrlEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantPictureUrlEditMutation, { data, loading, error }] = useTenantPictureUrlEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      pictureImage: // value for 'pictureImage'
 *      pictureImageToRemove: // value for 'pictureImageToRemove'
 *   },
 * });
 */
export function useTenantPictureUrlEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>(TenantPictureUrlEditDocument, options);
      }
export type TenantPictureUrlEditMutationHookResult = ReturnType<typeof useTenantPictureUrlEditMutation>;
export type TenantPictureUrlEditMutationResult = Apollo.MutationResult<TenantPictureUrlEditMutation>;
export type TenantPictureUrlEditMutationOptions = Apollo.BaseMutationOptions<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>;
export const TenantSubscriptionEditDocument = gql`
    mutation TenantSubscriptionEdit($tenantId: MongoID!, $subscription: String!) {
  tenantSubscriptionEdit(tenantId: $tenantId, subscription: $subscription) {
    external_id
    external_ids
    name
    email
    date_created
    picture_url
    primary_color
    domain
    enabled
    _id
  }
}
    `;
export type TenantSubscriptionEditMutationFn = Apollo.MutationFunction<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>;

/**
 * __useTenantSubscriptionEditMutation__
 *
 * To run a mutation, you first call `useTenantSubscriptionEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantSubscriptionEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantSubscriptionEditMutation, { data, loading, error }] = useTenantSubscriptionEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useTenantSubscriptionEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>(TenantSubscriptionEditDocument, options);
      }
export type TenantSubscriptionEditMutationHookResult = ReturnType<typeof useTenantSubscriptionEditMutation>;
export type TenantSubscriptionEditMutationResult = Apollo.MutationResult<TenantSubscriptionEditMutation>;
export type TenantSubscriptionEditMutationOptions = Apollo.BaseMutationOptions<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>;
export const UserActivateDocument = gql`
    mutation UserActivate($userId: MongoID!) {
  userActivate(userId: $userId) {
    external_id
    enabled
    first_name
    last_name
    email
    picture_url
    role
    last_login
    _id
  }
}
    `;
export type UserActivateMutationFn = Apollo.MutationFunction<UserActivateMutation, UserActivateMutationVariables>;

/**
 * __useUserActivateMutation__
 *
 * To run a mutation, you first call `useUserActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userActivateMutation, { data, loading, error }] = useUserActivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserActivateMutation(baseOptions?: Apollo.MutationHookOptions<UserActivateMutation, UserActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserActivateMutation, UserActivateMutationVariables>(UserActivateDocument, options);
      }
export type UserActivateMutationHookResult = ReturnType<typeof useUserActivateMutation>;
export type UserActivateMutationResult = Apollo.MutationResult<UserActivateMutation>;
export type UserActivateMutationOptions = Apollo.BaseMutationOptions<UserActivateMutation, UserActivateMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($newUser: CreateOneUserInput!) {
  userCreate(newUser: $newUser) {
    first_name
    last_name
    email
    picture_url
    role
    access_token
    refresh_token
    access_token
    refresh_token
    last_login
    _id
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserDeactivateDocument = gql`
    mutation UserDeactivate($userId: MongoID!) {
  userDeactivate(userId: $userId) {
    external_id
    enabled
    first_name
    last_name
    email
    picture_url
    role
    last_login
    _id
  }
}
    `;
export type UserDeactivateMutationFn = Apollo.MutationFunction<UserDeactivateMutation, UserDeactivateMutationVariables>;

/**
 * __useUserDeactivateMutation__
 *
 * To run a mutation, you first call `useUserDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeactivateMutation, { data, loading, error }] = useUserDeactivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<UserDeactivateMutation, UserDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeactivateMutation, UserDeactivateMutationVariables>(UserDeactivateDocument, options);
      }
export type UserDeactivateMutationHookResult = ReturnType<typeof useUserDeactivateMutation>;
export type UserDeactivateMutationResult = Apollo.MutationResult<UserDeactivateMutation>;
export type UserDeactivateMutationOptions = Apollo.BaseMutationOptions<UserDeactivateMutation, UserDeactivateMutationVariables>;
export const UserNotificationSummarySendDocument = gql`
    mutation UserNotificationSummarySend($userId: MongoID!, $vendorId: MongoID) {
  userNotificationSummarySend(userId: $userId, vendorId: $vendorId) {
    queued
    totalUnread
  }
}
    `;
export type UserNotificationSummarySendMutationFn = Apollo.MutationFunction<UserNotificationSummarySendMutation, UserNotificationSummarySendMutationVariables>;

/**
 * __useUserNotificationSummarySendMutation__
 *
 * To run a mutation, you first call `useUserNotificationSummarySendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationSummarySendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userNotificationSummarySendMutation, { data, loading, error }] = useUserNotificationSummarySendMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useUserNotificationSummarySendMutation(baseOptions?: Apollo.MutationHookOptions<UserNotificationSummarySendMutation, UserNotificationSummarySendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserNotificationSummarySendMutation, UserNotificationSummarySendMutationVariables>(UserNotificationSummarySendDocument, options);
      }
export type UserNotificationSummarySendMutationHookResult = ReturnType<typeof useUserNotificationSummarySendMutation>;
export type UserNotificationSummarySendMutationResult = Apollo.MutationResult<UserNotificationSummarySendMutation>;
export type UserNotificationSummarySendMutationOptions = Apollo.BaseMutationOptions<UserNotificationSummarySendMutation, UserNotificationSummarySendMutationVariables>;
export const VendorCreateDocument = gql`
    mutation VendorCreate($newVendor: CreateOneVendorInput!) {
  vendorCreate(newVendor: $newVendor) {
    external_id
    date_created
    shop_name
    shop_slug
    tagline
    enabled
    annualHangingWeightThroughput
    _id
  }
}
    `;
export type VendorCreateMutationFn = Apollo.MutationFunction<VendorCreateMutation, VendorCreateMutationVariables>;

/**
 * __useVendorCreateMutation__
 *
 * To run a mutation, you first call `useVendorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCreateMutation, { data, loading, error }] = useVendorCreateMutation({
 *   variables: {
 *      newVendor: // value for 'newVendor'
 *   },
 * });
 */
export function useVendorCreateMutation(baseOptions?: Apollo.MutationHookOptions<VendorCreateMutation, VendorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorCreateMutation, VendorCreateMutationVariables>(VendorCreateDocument, options);
      }
export type VendorCreateMutationHookResult = ReturnType<typeof useVendorCreateMutation>;
export type VendorCreateMutationResult = Apollo.MutationResult<VendorCreateMutation>;
export type VendorCreateMutationOptions = Apollo.BaseMutationOptions<VendorCreateMutation, VendorCreateMutationVariables>;
export const VendorModuleUpsertDocument = gql`
    mutation VendorModuleUpsert($vendorId: MongoID!, $moduleType: String!, $name: String!, $label: String!, $href: String!, $order: Int, $active: Boolean!, $settings: JSON) {
  vendorModuleUpsert(
    vendorId: $vendorId
    moduleType: $moduleType
    name: $name
    label: $label
    href: $href
    order: $order
    active: $active
    settings: $settings
  ) {
    _id
    moduleType
    name
    label
    href
    order
    active
    settings
  }
}
    `;
export type VendorModuleUpsertMutationFn = Apollo.MutationFunction<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>;

/**
 * __useVendorModuleUpsertMutation__
 *
 * To run a mutation, you first call `useVendorModuleUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorModuleUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorModuleUpsertMutation, { data, loading, error }] = useVendorModuleUpsertMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      moduleType: // value for 'moduleType'
 *      name: // value for 'name'
 *      label: // value for 'label'
 *      href: // value for 'href'
 *      order: // value for 'order'
 *      active: // value for 'active'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useVendorModuleUpsertMutation(baseOptions?: Apollo.MutationHookOptions<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>(VendorModuleUpsertDocument, options);
      }
export type VendorModuleUpsertMutationHookResult = ReturnType<typeof useVendorModuleUpsertMutation>;
export type VendorModuleUpsertMutationResult = Apollo.MutationResult<VendorModuleUpsertMutation>;
export type VendorModuleUpsertMutationOptions = Apollo.BaseMutationOptions<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>;
export const VendorUpdateByIdDocument = gql`
    mutation VendorUpdateById($record: UpdateByIdVendorInput!, $_id: MongoID!) {
  vendorUpdateById(record: $record, _id: $_id) {
    record {
      ...VendorFragment
    }
  }
}
    ${VendorFragmentFragmentDoc}`;
export type VendorUpdateByIdMutationFn = Apollo.MutationFunction<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>;

/**
 * __useVendorUpdateByIdMutation__
 *
 * To run a mutation, you first call `useVendorUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorUpdateByIdMutation, { data, loading, error }] = useVendorUpdateByIdMutation({
 *   variables: {
 *      record: // value for 'record'
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useVendorUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>(VendorUpdateByIdDocument, options);
      }
export type VendorUpdateByIdMutationHookResult = ReturnType<typeof useVendorUpdateByIdMutation>;
export type VendorUpdateByIdMutationResult = Apollo.MutationResult<VendorUpdateByIdMutation>;
export type VendorUpdateByIdMutationOptions = Apollo.BaseMutationOptions<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>;
export const ApplyCutsheetCatalogChangesDocument = gql`
    mutation ApplyCutsheetCatalogChanges($capabilityId: MongoID!, $changes: [CutsheetProposedChangeInput!]!) {
  applyCutsheetCatalogChanges(capabilityId: $capabilityId, changes: $changes) {
    catalogChanged
    actions {
      kind
      label
      itemType
      itemId
    }
  }
}
    `;
export type ApplyCutsheetCatalogChangesMutationFn = Apollo.MutationFunction<ApplyCutsheetCatalogChangesMutation, ApplyCutsheetCatalogChangesMutationVariables>;

/**
 * __useApplyCutsheetCatalogChangesMutation__
 *
 * To run a mutation, you first call `useApplyCutsheetCatalogChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCutsheetCatalogChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCutsheetCatalogChangesMutation, { data, loading, error }] = useApplyCutsheetCatalogChangesMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useApplyCutsheetCatalogChangesMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCutsheetCatalogChangesMutation, ApplyCutsheetCatalogChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCutsheetCatalogChangesMutation, ApplyCutsheetCatalogChangesMutationVariables>(ApplyCutsheetCatalogChangesDocument, options);
      }
export type ApplyCutsheetCatalogChangesMutationHookResult = ReturnType<typeof useApplyCutsheetCatalogChangesMutation>;
export type ApplyCutsheetCatalogChangesMutationResult = Apollo.MutationResult<ApplyCutsheetCatalogChangesMutation>;
export type ApplyCutsheetCatalogChangesMutationOptions = Apollo.BaseMutationOptions<ApplyCutsheetCatalogChangesMutation, ApplyCutsheetCatalogChangesMutationVariables>;
export const ApplyCutsheetQuestionnaireChangesDocument = gql`
    mutation ApplyCutsheetQuestionnaireChanges($capabilityId: MongoID!, $questions: JSON!, $changes: [CutsheetProposedChangeInput!]!) {
  applyCutsheetQuestionnaireChanges(
    capabilityId: $capabilityId
    questions: $questions
    changes: $changes
  ) {
    changed
    actions {
      kind
      label
      itemType
      itemId
    }
    questions
  }
}
    `;
export type ApplyCutsheetQuestionnaireChangesMutationFn = Apollo.MutationFunction<ApplyCutsheetQuestionnaireChangesMutation, ApplyCutsheetQuestionnaireChangesMutationVariables>;

/**
 * __useApplyCutsheetQuestionnaireChangesMutation__
 *
 * To run a mutation, you first call `useApplyCutsheetQuestionnaireChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCutsheetQuestionnaireChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCutsheetQuestionnaireChangesMutation, { data, loading, error }] = useApplyCutsheetQuestionnaireChangesMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      questions: // value for 'questions'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useApplyCutsheetQuestionnaireChangesMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCutsheetQuestionnaireChangesMutation, ApplyCutsheetQuestionnaireChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCutsheetQuestionnaireChangesMutation, ApplyCutsheetQuestionnaireChangesMutationVariables>(ApplyCutsheetQuestionnaireChangesDocument, options);
      }
export type ApplyCutsheetQuestionnaireChangesMutationHookResult = ReturnType<typeof useApplyCutsheetQuestionnaireChangesMutation>;
export type ApplyCutsheetQuestionnaireChangesMutationResult = Apollo.MutationResult<ApplyCutsheetQuestionnaireChangesMutation>;
export type ApplyCutsheetQuestionnaireChangesMutationOptions = Apollo.BaseMutationOptions<ApplyCutsheetQuestionnaireChangesMutation, ApplyCutsheetQuestionnaireChangesMutationVariables>;
export const AuthCheckUserDocument = gql`
    mutation AuthCheckUser($identifier: String!, $redirectPath: String, $clientOrigin: String) {
  authCheckUser(
    identifier: $identifier
    redirectPath: $redirectPath
    clientOrigin: $clientOrigin
  ) {
    exists
    authMethod
    requiresPasswordReset
    redirectUrl
    otpSent
    session
    message
    resetCodeSent
    resetDestination
  }
}
    `;
export type AuthCheckUserMutationFn = Apollo.MutationFunction<AuthCheckUserMutation, AuthCheckUserMutationVariables>;

/**
 * __useAuthCheckUserMutation__
 *
 * To run a mutation, you first call `useAuthCheckUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthCheckUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authCheckUserMutation, { data, loading, error }] = useAuthCheckUserMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      redirectPath: // value for 'redirectPath'
 *      clientOrigin: // value for 'clientOrigin'
 *   },
 * });
 */
export function useAuthCheckUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthCheckUserMutation, AuthCheckUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthCheckUserMutation, AuthCheckUserMutationVariables>(AuthCheckUserDocument, options);
      }
export type AuthCheckUserMutationHookResult = ReturnType<typeof useAuthCheckUserMutation>;
export type AuthCheckUserMutationResult = Apollo.MutationResult<AuthCheckUserMutation>;
export type AuthCheckUserMutationOptions = Apollo.BaseMutationOptions<AuthCheckUserMutation, AuthCheckUserMutationVariables>;
export const AuthLoginOAuthDocument = gql`
    mutation AuthLoginOAuth($code: String!, $redirectUri: String!) {
  authLoginOAuth(code: $code, redirectUri: $redirectUri) {
    accessToken
    idToken
    refreshToken
    expiresIn
  }
}
    `;
export type AuthLoginOAuthMutationFn = Apollo.MutationFunction<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>;

/**
 * __useAuthLoginOAuthMutation__
 *
 * To run a mutation, you first call `useAuthLoginOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginOAuthMutation, { data, loading, error }] = useAuthLoginOAuthMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useAuthLoginOAuthMutation(baseOptions?: Apollo.MutationHookOptions<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>(AuthLoginOAuthDocument, options);
      }
export type AuthLoginOAuthMutationHookResult = ReturnType<typeof useAuthLoginOAuthMutation>;
export type AuthLoginOAuthMutationResult = Apollo.MutationResult<AuthLoginOAuthMutation>;
export type AuthLoginOAuthMutationOptions = Apollo.BaseMutationOptions<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>;
export const AuthLoginPasswordDocument = gql`
    mutation AuthLoginPassword($identifier: String!, $password: String!) {
  authLoginPassword(identifier: $identifier, password: $password) {
    accessToken
    idToken
    refreshToken
    expiresIn
  }
}
    `;
export type AuthLoginPasswordMutationFn = Apollo.MutationFunction<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>;

/**
 * __useAuthLoginPasswordMutation__
 *
 * To run a mutation, you first call `useAuthLoginPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginPasswordMutation, { data, loading, error }] = useAuthLoginPasswordMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthLoginPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>(AuthLoginPasswordDocument, options);
      }
export type AuthLoginPasswordMutationHookResult = ReturnType<typeof useAuthLoginPasswordMutation>;
export type AuthLoginPasswordMutationResult = Apollo.MutationResult<AuthLoginPasswordMutation>;
export type AuthLoginPasswordMutationOptions = Apollo.BaseMutationOptions<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>;
export const AuthRefreshTokenDocument = gql`
    mutation AuthRefreshToken($refreshToken: String!) {
  authRefreshToken(refreshToken: $refreshToken) {
    accessToken
    idToken
    expiresIn
  }
}
    `;
export type AuthRefreshTokenMutationFn = Apollo.MutationFunction<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>;

/**
 * __useAuthRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAuthRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRefreshTokenMutation, { data, loading, error }] = useAuthRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAuthRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>(AuthRefreshTokenDocument, options);
      }
export type AuthRefreshTokenMutationHookResult = ReturnType<typeof useAuthRefreshTokenMutation>;
export type AuthRefreshTokenMutationResult = Apollo.MutationResult<AuthRefreshTokenMutation>;
export type AuthRefreshTokenMutationOptions = Apollo.BaseMutationOptions<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>;
export const AuthRegisterAndSignInDocument = gql`
    mutation AuthRegisterAndSignIn($firstName: String!, $lastName: String, $email: String, $phone: String, $acceptTos: Boolean!, $canReceiveEmailUpdates: Boolean) {
  authRegisterAndSignIn(
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    acceptTos: $acceptTos
    canReceiveEmailUpdates: $canReceiveEmailUpdates
  ) {
    status
    accessToken
    idToken
    refreshToken
    session
    userId
    message
  }
}
    `;
export type AuthRegisterAndSignInMutationFn = Apollo.MutationFunction<AuthRegisterAndSignInMutation, AuthRegisterAndSignInMutationVariables>;

/**
 * __useAuthRegisterAndSignInMutation__
 *
 * To run a mutation, you first call `useAuthRegisterAndSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRegisterAndSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRegisterAndSignInMutation, { data, loading, error }] = useAuthRegisterAndSignInMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      acceptTos: // value for 'acceptTos'
 *      canReceiveEmailUpdates: // value for 'canReceiveEmailUpdates'
 *   },
 * });
 */
export function useAuthRegisterAndSignInMutation(baseOptions?: Apollo.MutationHookOptions<AuthRegisterAndSignInMutation, AuthRegisterAndSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRegisterAndSignInMutation, AuthRegisterAndSignInMutationVariables>(AuthRegisterAndSignInDocument, options);
      }
export type AuthRegisterAndSignInMutationHookResult = ReturnType<typeof useAuthRegisterAndSignInMutation>;
export type AuthRegisterAndSignInMutationResult = Apollo.MutationResult<AuthRegisterAndSignInMutation>;
export type AuthRegisterAndSignInMutationOptions = Apollo.BaseMutationOptions<AuthRegisterAndSignInMutation, AuthRegisterAndSignInMutationVariables>;
export const AuthRegisterDocument = gql`
    mutation AuthRegister($firstName: String!, $lastName: String, $email: String, $phone: String, $company: String, $userType: String, $acceptTos: Boolean, $acceptPrivacyPolicy: Boolean, $canReceiveEmailUpdates: Boolean) {
  authRegister(
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    userType: $userType
    acceptTos: $acceptTos
    acceptPrivacyPolicy: $acceptPrivacyPolicy
    canReceiveEmailUpdates: $canReceiveEmailUpdates
  ) {
    success
    userId
    email
    phone
    message
  }
}
    `;
export type AuthRegisterMutationFn = Apollo.MutationFunction<AuthRegisterMutation, AuthRegisterMutationVariables>;

/**
 * __useAuthRegisterMutation__
 *
 * To run a mutation, you first call `useAuthRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRegisterMutation, { data, loading, error }] = useAuthRegisterMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      userType: // value for 'userType'
 *      acceptTos: // value for 'acceptTos'
 *      acceptPrivacyPolicy: // value for 'acceptPrivacyPolicy'
 *      canReceiveEmailUpdates: // value for 'canReceiveEmailUpdates'
 *   },
 * });
 */
export function useAuthRegisterMutation(baseOptions?: Apollo.MutationHookOptions<AuthRegisterMutation, AuthRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRegisterMutation, AuthRegisterMutationVariables>(AuthRegisterDocument, options);
      }
export type AuthRegisterMutationHookResult = ReturnType<typeof useAuthRegisterMutation>;
export type AuthRegisterMutationResult = Apollo.MutationResult<AuthRegisterMutation>;
export type AuthRegisterMutationOptions = Apollo.BaseMutationOptions<AuthRegisterMutation, AuthRegisterMutationVariables>;
export const AuthSendOtpDocument = gql`
    mutation AuthSendOTP($identifier: String!) {
  authSendOTP(identifier: $identifier) {
    success
    message
    session
  }
}
    `;
export type AuthSendOtpMutationFn = Apollo.MutationFunction<AuthSendOtpMutation, AuthSendOtpMutationVariables>;

/**
 * __useAuthSendOtpMutation__
 *
 * To run a mutation, you first call `useAuthSendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSendOtpMutation, { data, loading, error }] = useAuthSendOtpMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useAuthSendOtpMutation(baseOptions?: Apollo.MutationHookOptions<AuthSendOtpMutation, AuthSendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSendOtpMutation, AuthSendOtpMutationVariables>(AuthSendOtpDocument, options);
      }
export type AuthSendOtpMutationHookResult = ReturnType<typeof useAuthSendOtpMutation>;
export type AuthSendOtpMutationResult = Apollo.MutationResult<AuthSendOtpMutation>;
export type AuthSendOtpMutationOptions = Apollo.BaseMutationOptions<AuthSendOtpMutation, AuthSendOtpMutationVariables>;
export const AuthVerifyOtpDocument = gql`
    mutation AuthVerifyOTP($identifier: String!, $otp: String!, $session: String) {
  authVerifyOTP(identifier: $identifier, otp: $otp, session: $session) {
    accessToken
    idToken
    refreshToken
    expiresIn
    requiresProfileCompletion
  }
}
    `;
export type AuthVerifyOtpMutationFn = Apollo.MutationFunction<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>;

/**
 * __useAuthVerifyOtpMutation__
 *
 * To run a mutation, you first call `useAuthVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authVerifyOtpMutation, { data, loading, error }] = useAuthVerifyOtpMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      otp: // value for 'otp'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useAuthVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>(AuthVerifyOtpDocument, options);
      }
export type AuthVerifyOtpMutationHookResult = ReturnType<typeof useAuthVerifyOtpMutation>;
export type AuthVerifyOtpMutationResult = Apollo.MutationResult<AuthVerifyOtpMutation>;
export type AuthVerifyOtpMutationOptions = Apollo.BaseMutationOptions<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
  changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
    success
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const BookingDepositPaymentIntentCreateDocument = gql`
    mutation BookingDepositPaymentIntentCreate($vendorId: MongoID!, $headCount: Int!, $species: String!, $requestId: String) {
  bookingDepositPaymentIntentCreate(
    vendorId: $vendorId
    headCount: $headCount
    species: $species
    requestId: $requestId
  ) {
    clientSecret
    connectedAccountId
    paymentIntentId
    amount
  }
}
    `;
export type BookingDepositPaymentIntentCreateMutationFn = Apollo.MutationFunction<BookingDepositPaymentIntentCreateMutation, BookingDepositPaymentIntentCreateMutationVariables>;

/**
 * __useBookingDepositPaymentIntentCreateMutation__
 *
 * To run a mutation, you first call `useBookingDepositPaymentIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingDepositPaymentIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingDepositPaymentIntentCreateMutation, { data, loading, error }] = useBookingDepositPaymentIntentCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      headCount: // value for 'headCount'
 *      species: // value for 'species'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useBookingDepositPaymentIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<BookingDepositPaymentIntentCreateMutation, BookingDepositPaymentIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingDepositPaymentIntentCreateMutation, BookingDepositPaymentIntentCreateMutationVariables>(BookingDepositPaymentIntentCreateDocument, options);
      }
export type BookingDepositPaymentIntentCreateMutationHookResult = ReturnType<typeof useBookingDepositPaymentIntentCreateMutation>;
export type BookingDepositPaymentIntentCreateMutationResult = Apollo.MutationResult<BookingDepositPaymentIntentCreateMutation>;
export type BookingDepositPaymentIntentCreateMutationOptions = Apollo.BaseMutationOptions<BookingDepositPaymentIntentCreateMutation, BookingDepositPaymentIntentCreateMutationVariables>;
export const BuildCutsheetCatalogDocument = gql`
    mutation BuildCutsheetCatalog($file: Upload!, $capabilityId: MongoID!) {
  buildCutsheetCatalog(file: $file, capabilityId: $capabilityId) {
    capabilityId
    catalogName
    animalType
    primalsCount
    cutsCount
    trimCount
    extrasCount
    specificationsCount
  }
}
    `;
export type BuildCutsheetCatalogMutationFn = Apollo.MutationFunction<BuildCutsheetCatalogMutation, BuildCutsheetCatalogMutationVariables>;

/**
 * __useBuildCutsheetCatalogMutation__
 *
 * To run a mutation, you first call `useBuildCutsheetCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildCutsheetCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildCutsheetCatalogMutation, { data, loading, error }] = useBuildCutsheetCatalogMutation({
 *   variables: {
 *      file: // value for 'file'
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useBuildCutsheetCatalogMutation(baseOptions?: Apollo.MutationHookOptions<BuildCutsheetCatalogMutation, BuildCutsheetCatalogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildCutsheetCatalogMutation, BuildCutsheetCatalogMutationVariables>(BuildCutsheetCatalogDocument, options);
      }
export type BuildCutsheetCatalogMutationHookResult = ReturnType<typeof useBuildCutsheetCatalogMutation>;
export type BuildCutsheetCatalogMutationResult = Apollo.MutationResult<BuildCutsheetCatalogMutation>;
export type BuildCutsheetCatalogMutationOptions = Apollo.BaseMutationOptions<BuildCutsheetCatalogMutation, BuildCutsheetCatalogMutationVariables>;
export const BuyerAddAnimalSectionDocument = gql`
    mutation BuyerAddAnimalSection($animalId: MongoID!, $splitPart: String!, $requestId: String, $pickupLocationId: MongoID) {
  buyerAddAnimalSection(
    animalId: $animalId
    splitPart: $splitPart
    requestId: $requestId
    pickupLocationId: $pickupLocationId
  ) {
    _id
    splitPart
    status
  }
}
    `;
export type BuyerAddAnimalSectionMutationFn = Apollo.MutationFunction<BuyerAddAnimalSectionMutation, BuyerAddAnimalSectionMutationVariables>;

/**
 * __useBuyerAddAnimalSectionMutation__
 *
 * To run a mutation, you first call `useBuyerAddAnimalSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerAddAnimalSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerAddAnimalSectionMutation, { data, loading, error }] = useBuyerAddAnimalSectionMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      splitPart: // value for 'splitPart'
 *      requestId: // value for 'requestId'
 *      pickupLocationId: // value for 'pickupLocationId'
 *   },
 * });
 */
export function useBuyerAddAnimalSectionMutation(baseOptions?: Apollo.MutationHookOptions<BuyerAddAnimalSectionMutation, BuyerAddAnimalSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerAddAnimalSectionMutation, BuyerAddAnimalSectionMutationVariables>(BuyerAddAnimalSectionDocument, options);
      }
export type BuyerAddAnimalSectionMutationHookResult = ReturnType<typeof useBuyerAddAnimalSectionMutation>;
export type BuyerAddAnimalSectionMutationResult = Apollo.MutationResult<BuyerAddAnimalSectionMutation>;
export type BuyerAddAnimalSectionMutationOptions = Apollo.BaseMutationOptions<BuyerAddAnimalSectionMutation, BuyerAddAnimalSectionMutationVariables>;
export const BuyerCancelSplitDocument = gql`
    mutation BuyerCancelSplit($splitId: MongoID!) {
  buyerCancelSplit(splitId: $splitId) {
    _id
    status
  }
}
    `;
export type BuyerCancelSplitMutationFn = Apollo.MutationFunction<BuyerCancelSplitMutation, BuyerCancelSplitMutationVariables>;

/**
 * __useBuyerCancelSplitMutation__
 *
 * To run a mutation, you first call `useBuyerCancelSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerCancelSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerCancelSplitMutation, { data, loading, error }] = useBuyerCancelSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useBuyerCancelSplitMutation(baseOptions?: Apollo.MutationHookOptions<BuyerCancelSplitMutation, BuyerCancelSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerCancelSplitMutation, BuyerCancelSplitMutationVariables>(BuyerCancelSplitDocument, options);
      }
export type BuyerCancelSplitMutationHookResult = ReturnType<typeof useBuyerCancelSplitMutation>;
export type BuyerCancelSplitMutationResult = Apollo.MutationResult<BuyerCancelSplitMutation>;
export type BuyerCancelSplitMutationOptions = Apollo.BaseMutationOptions<BuyerCancelSplitMutation, BuyerCancelSplitMutationVariables>;
export const BuyerClaimSplitDocument = gql`
    mutation BuyerClaimSplit($animalId: MongoID!, $splitPart: String!, $requestId: String, $pickupLocationId: MongoID) {
  buyerClaimSplit(
    animalId: $animalId
    splitPart: $splitPart
    requestId: $requestId
    pickupLocationId: $pickupLocationId
  ) {
    _id
    splitPart
    status
  }
}
    `;
export type BuyerClaimSplitMutationFn = Apollo.MutationFunction<BuyerClaimSplitMutation, BuyerClaimSplitMutationVariables>;

/**
 * __useBuyerClaimSplitMutation__
 *
 * To run a mutation, you first call `useBuyerClaimSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerClaimSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerClaimSplitMutation, { data, loading, error }] = useBuyerClaimSplitMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      splitPart: // value for 'splitPart'
 *      requestId: // value for 'requestId'
 *      pickupLocationId: // value for 'pickupLocationId'
 *   },
 * });
 */
export function useBuyerClaimSplitMutation(baseOptions?: Apollo.MutationHookOptions<BuyerClaimSplitMutation, BuyerClaimSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerClaimSplitMutation, BuyerClaimSplitMutationVariables>(BuyerClaimSplitDocument, options);
      }
export type BuyerClaimSplitMutationHookResult = ReturnType<typeof useBuyerClaimSplitMutation>;
export type BuyerClaimSplitMutationResult = Apollo.MutationResult<BuyerClaimSplitMutation>;
export type BuyerClaimSplitMutationOptions = Apollo.BaseMutationOptions<BuyerClaimSplitMutation, BuyerClaimSplitMutationVariables>;
export const BuyerCreateBalanceCheckoutDocument = gql`
    mutation BuyerCreateBalanceCheckout($orderId: MongoID!) {
  buyerCreateBalanceCheckout(orderId: $orderId) {
    clientSecret
    sessionId
    balanceDue
    processorName
  }
}
    `;
export type BuyerCreateBalanceCheckoutMutationFn = Apollo.MutationFunction<BuyerCreateBalanceCheckoutMutation, BuyerCreateBalanceCheckoutMutationVariables>;

/**
 * __useBuyerCreateBalanceCheckoutMutation__
 *
 * To run a mutation, you first call `useBuyerCreateBalanceCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerCreateBalanceCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerCreateBalanceCheckoutMutation, { data, loading, error }] = useBuyerCreateBalanceCheckoutMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useBuyerCreateBalanceCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<BuyerCreateBalanceCheckoutMutation, BuyerCreateBalanceCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerCreateBalanceCheckoutMutation, BuyerCreateBalanceCheckoutMutationVariables>(BuyerCreateBalanceCheckoutDocument, options);
      }
export type BuyerCreateBalanceCheckoutMutationHookResult = ReturnType<typeof useBuyerCreateBalanceCheckoutMutation>;
export type BuyerCreateBalanceCheckoutMutationResult = Apollo.MutationResult<BuyerCreateBalanceCheckoutMutation>;
export type BuyerCreateBalanceCheckoutMutationOptions = Apollo.BaseMutationOptions<BuyerCreateBalanceCheckoutMutation, BuyerCreateBalanceCheckoutMutationVariables>;
export const BuyerCreateCombinedSettlementIntentDocument = gql`
    mutation BuyerCreateCombinedSettlementIntent($orderId: MongoID!) {
  buyerCreateCombinedSettlementIntent(orderId: $orderId) {
    clientSecret
    amountDue
    chargeableParties
    savedPaymentMethods {
      id
      brand
      last4
      expMonth
      expYear
    }
  }
}
    `;
export type BuyerCreateCombinedSettlementIntentMutationFn = Apollo.MutationFunction<BuyerCreateCombinedSettlementIntentMutation, BuyerCreateCombinedSettlementIntentMutationVariables>;

/**
 * __useBuyerCreateCombinedSettlementIntentMutation__
 *
 * To run a mutation, you first call `useBuyerCreateCombinedSettlementIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerCreateCombinedSettlementIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerCreateCombinedSettlementIntentMutation, { data, loading, error }] = useBuyerCreateCombinedSettlementIntentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useBuyerCreateCombinedSettlementIntentMutation(baseOptions?: Apollo.MutationHookOptions<BuyerCreateCombinedSettlementIntentMutation, BuyerCreateCombinedSettlementIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerCreateCombinedSettlementIntentMutation, BuyerCreateCombinedSettlementIntentMutationVariables>(BuyerCreateCombinedSettlementIntentDocument, options);
      }
export type BuyerCreateCombinedSettlementIntentMutationHookResult = ReturnType<typeof useBuyerCreateCombinedSettlementIntentMutation>;
export type BuyerCreateCombinedSettlementIntentMutationResult = Apollo.MutationResult<BuyerCreateCombinedSettlementIntentMutation>;
export type BuyerCreateCombinedSettlementIntentMutationOptions = Apollo.BaseMutationOptions<BuyerCreateCombinedSettlementIntentMutation, BuyerCreateCombinedSettlementIntentMutationVariables>;
export const BuyerCreateDepositCheckoutDocument = gql`
    mutation BuyerCreateDepositCheckout($splitId: MongoID!, $inline: Boolean) {
  buyerCreateDepositCheckout(splitId: $splitId, inline: $inline) {
    clientSecret
    sessionId
    depositAmount
    listingFee
    total
    splitPart
    processorName
    species
    expiresAt
  }
}
    `;
export type BuyerCreateDepositCheckoutMutationFn = Apollo.MutationFunction<BuyerCreateDepositCheckoutMutation, BuyerCreateDepositCheckoutMutationVariables>;

/**
 * __useBuyerCreateDepositCheckoutMutation__
 *
 * To run a mutation, you first call `useBuyerCreateDepositCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerCreateDepositCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerCreateDepositCheckoutMutation, { data, loading, error }] = useBuyerCreateDepositCheckoutMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      inline: // value for 'inline'
 *   },
 * });
 */
export function useBuyerCreateDepositCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<BuyerCreateDepositCheckoutMutation, BuyerCreateDepositCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerCreateDepositCheckoutMutation, BuyerCreateDepositCheckoutMutationVariables>(BuyerCreateDepositCheckoutDocument, options);
      }
export type BuyerCreateDepositCheckoutMutationHookResult = ReturnType<typeof useBuyerCreateDepositCheckoutMutation>;
export type BuyerCreateDepositCheckoutMutationResult = Apollo.MutationResult<BuyerCreateDepositCheckoutMutation>;
export type BuyerCreateDepositCheckoutMutationOptions = Apollo.BaseMutationOptions<BuyerCreateDepositCheckoutMutation, BuyerCreateDepositCheckoutMutationVariables>;
export const BuyerInterestUnsubscribeDocument = gql`
    mutation BuyerInterestUnsubscribe($token: String!) {
  buyerInterestUnsubscribe(token: $token)
}
    `;
export type BuyerInterestUnsubscribeMutationFn = Apollo.MutationFunction<BuyerInterestUnsubscribeMutation, BuyerInterestUnsubscribeMutationVariables>;

/**
 * __useBuyerInterestUnsubscribeMutation__
 *
 * To run a mutation, you first call `useBuyerInterestUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerInterestUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerInterestUnsubscribeMutation, { data, loading, error }] = useBuyerInterestUnsubscribeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBuyerInterestUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<BuyerInterestUnsubscribeMutation, BuyerInterestUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerInterestUnsubscribeMutation, BuyerInterestUnsubscribeMutationVariables>(BuyerInterestUnsubscribeDocument, options);
      }
export type BuyerInterestUnsubscribeMutationHookResult = ReturnType<typeof useBuyerInterestUnsubscribeMutation>;
export type BuyerInterestUnsubscribeMutationResult = Apollo.MutationResult<BuyerInterestUnsubscribeMutation>;
export type BuyerInterestUnsubscribeMutationOptions = Apollo.BaseMutationOptions<BuyerInterestUnsubscribeMutation, BuyerInterestUnsubscribeMutationVariables>;
export const BuyerPayInvoiceDocument = gql`
    mutation BuyerPayInvoice($invoiceId: MongoID!) {
  buyerPayInvoice(invoiceId: $invoiceId) {
    status
    clientSecret
    connectedAccountId
    amountDue
  }
}
    `;
export type BuyerPayInvoiceMutationFn = Apollo.MutationFunction<BuyerPayInvoiceMutation, BuyerPayInvoiceMutationVariables>;

/**
 * __useBuyerPayInvoiceMutation__
 *
 * To run a mutation, you first call `useBuyerPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerPayInvoiceMutation, { data, loading, error }] = useBuyerPayInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useBuyerPayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<BuyerPayInvoiceMutation, BuyerPayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerPayInvoiceMutation, BuyerPayInvoiceMutationVariables>(BuyerPayInvoiceDocument, options);
      }
export type BuyerPayInvoiceMutationHookResult = ReturnType<typeof useBuyerPayInvoiceMutation>;
export type BuyerPayInvoiceMutationResult = Apollo.MutationResult<BuyerPayInvoiceMutation>;
export type BuyerPayInvoiceMutationOptions = Apollo.BaseMutationOptions<BuyerPayInvoiceMutation, BuyerPayInvoiceMutationVariables>;
export const BuyerRegisterInterestDocument = gql`
    mutation BuyerRegisterInterest($vendorId: MongoID!, $species: String!) {
  buyerRegisterInterest(vendorId: $vendorId, species: $species) {
    _id
    vendor {
      _id
      shop_name
    }
    species
    createdAt
  }
}
    `;
export type BuyerRegisterInterestMutationFn = Apollo.MutationFunction<BuyerRegisterInterestMutation, BuyerRegisterInterestMutationVariables>;

/**
 * __useBuyerRegisterInterestMutation__
 *
 * To run a mutation, you first call `useBuyerRegisterInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerRegisterInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerRegisterInterestMutation, { data, loading, error }] = useBuyerRegisterInterestMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useBuyerRegisterInterestMutation(baseOptions?: Apollo.MutationHookOptions<BuyerRegisterInterestMutation, BuyerRegisterInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerRegisterInterestMutation, BuyerRegisterInterestMutationVariables>(BuyerRegisterInterestDocument, options);
      }
export type BuyerRegisterInterestMutationHookResult = ReturnType<typeof useBuyerRegisterInterestMutation>;
export type BuyerRegisterInterestMutationResult = Apollo.MutationResult<BuyerRegisterInterestMutation>;
export type BuyerRegisterInterestMutationOptions = Apollo.BaseMutationOptions<BuyerRegisterInterestMutation, BuyerRegisterInterestMutationVariables>;
export const BuyerRegisterProducerInterestDocument = gql`
    mutation BuyerRegisterProducerInterest($producerId: MongoID!, $species: String!) {
  buyerRegisterProducerInterest(producerId: $producerId, species: $species) {
    _id
    producer {
      _id
    }
    species
    createdAt
  }
}
    `;
export type BuyerRegisterProducerInterestMutationFn = Apollo.MutationFunction<BuyerRegisterProducerInterestMutation, BuyerRegisterProducerInterestMutationVariables>;

/**
 * __useBuyerRegisterProducerInterestMutation__
 *
 * To run a mutation, you first call `useBuyerRegisterProducerInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerRegisterProducerInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerRegisterProducerInterestMutation, { data, loading, error }] = useBuyerRegisterProducerInterestMutation({
 *   variables: {
 *      producerId: // value for 'producerId'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useBuyerRegisterProducerInterestMutation(baseOptions?: Apollo.MutationHookOptions<BuyerRegisterProducerInterestMutation, BuyerRegisterProducerInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerRegisterProducerInterestMutation, BuyerRegisterProducerInterestMutationVariables>(BuyerRegisterProducerInterestDocument, options);
      }
export type BuyerRegisterProducerInterestMutationHookResult = ReturnType<typeof useBuyerRegisterProducerInterestMutation>;
export type BuyerRegisterProducerInterestMutationResult = Apollo.MutationResult<BuyerRegisterProducerInterestMutation>;
export type BuyerRegisterProducerInterestMutationOptions = Apollo.BaseMutationOptions<BuyerRegisterProducerInterestMutation, BuyerRegisterProducerInterestMutationVariables>;
export const BuyerRemoveInterestDocument = gql`
    mutation BuyerRemoveInterest($vendorId: MongoID!, $species: String!) {
  buyerRemoveInterest(vendorId: $vendorId, species: $species) {
    _id
    vendor {
      _id
      shop_name
    }
    species
    createdAt
  }
}
    `;
export type BuyerRemoveInterestMutationFn = Apollo.MutationFunction<BuyerRemoveInterestMutation, BuyerRemoveInterestMutationVariables>;

/**
 * __useBuyerRemoveInterestMutation__
 *
 * To run a mutation, you first call `useBuyerRemoveInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerRemoveInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerRemoveInterestMutation, { data, loading, error }] = useBuyerRemoveInterestMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useBuyerRemoveInterestMutation(baseOptions?: Apollo.MutationHookOptions<BuyerRemoveInterestMutation, BuyerRemoveInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerRemoveInterestMutation, BuyerRemoveInterestMutationVariables>(BuyerRemoveInterestDocument, options);
      }
export type BuyerRemoveInterestMutationHookResult = ReturnType<typeof useBuyerRemoveInterestMutation>;
export type BuyerRemoveInterestMutationResult = Apollo.MutationResult<BuyerRemoveInterestMutation>;
export type BuyerRemoveInterestMutationOptions = Apollo.BaseMutationOptions<BuyerRemoveInterestMutation, BuyerRemoveInterestMutationVariables>;
export const BuyerRemoveProducerInterestDocument = gql`
    mutation BuyerRemoveProducerInterest($producerId: MongoID!, $species: String!) {
  buyerRemoveProducerInterest(producerId: $producerId, species: $species) {
    _id
    producer {
      _id
    }
    species
    createdAt
  }
}
    `;
export type BuyerRemoveProducerInterestMutationFn = Apollo.MutationFunction<BuyerRemoveProducerInterestMutation, BuyerRemoveProducerInterestMutationVariables>;

/**
 * __useBuyerRemoveProducerInterestMutation__
 *
 * To run a mutation, you first call `useBuyerRemoveProducerInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerRemoveProducerInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerRemoveProducerInterestMutation, { data, loading, error }] = useBuyerRemoveProducerInterestMutation({
 *   variables: {
 *      producerId: // value for 'producerId'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useBuyerRemoveProducerInterestMutation(baseOptions?: Apollo.MutationHookOptions<BuyerRemoveProducerInterestMutation, BuyerRemoveProducerInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerRemoveProducerInterestMutation, BuyerRemoveProducerInterestMutationVariables>(BuyerRemoveProducerInterestDocument, options);
      }
export type BuyerRemoveProducerInterestMutationHookResult = ReturnType<typeof useBuyerRemoveProducerInterestMutation>;
export type BuyerRemoveProducerInterestMutationResult = Apollo.MutationResult<BuyerRemoveProducerInterestMutation>;
export type BuyerRemoveProducerInterestMutationOptions = Apollo.BaseMutationOptions<BuyerRemoveProducerInterestMutation, BuyerRemoveProducerInterestMutationVariables>;
export const BuyerSubmitRequestDocument = gql`
    mutation BuyerSubmitRequest($vendorId: MongoID!, $species: String!, $splitType: String!, $desiredPickupDate: String, $note: String) {
  buyerSubmitRequest(
    vendorId: $vendorId
    species: $species
    splitType: $splitType
    desiredPickupDate: $desiredPickupDate
    note: $note
  ) {
    _id
    species
    splitType
    desiredPickupDate
    note
    active
    createdAt
  }
}
    `;
export type BuyerSubmitRequestMutationFn = Apollo.MutationFunction<BuyerSubmitRequestMutation, BuyerSubmitRequestMutationVariables>;

/**
 * __useBuyerSubmitRequestMutation__
 *
 * To run a mutation, you first call `useBuyerSubmitRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerSubmitRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerSubmitRequestMutation, { data, loading, error }] = useBuyerSubmitRequestMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *      splitType: // value for 'splitType'
 *      desiredPickupDate: // value for 'desiredPickupDate'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useBuyerSubmitRequestMutation(baseOptions?: Apollo.MutationHookOptions<BuyerSubmitRequestMutation, BuyerSubmitRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerSubmitRequestMutation, BuyerSubmitRequestMutationVariables>(BuyerSubmitRequestDocument, options);
      }
export type BuyerSubmitRequestMutationHookResult = ReturnType<typeof useBuyerSubmitRequestMutation>;
export type BuyerSubmitRequestMutationResult = Apollo.MutationResult<BuyerSubmitRequestMutation>;
export type BuyerSubmitRequestMutationOptions = Apollo.BaseMutationOptions<BuyerSubmitRequestMutation, BuyerSubmitRequestMutationVariables>;
export const BuyerSyncBalanceCheckoutDocument = gql`
    mutation BuyerSyncBalanceCheckout($sessionId: String!) {
  buyerSyncBalanceCheckout(sessionId: $sessionId) {
    status
    orderStatus
  }
}
    `;
export type BuyerSyncBalanceCheckoutMutationFn = Apollo.MutationFunction<BuyerSyncBalanceCheckoutMutation, BuyerSyncBalanceCheckoutMutationVariables>;

/**
 * __useBuyerSyncBalanceCheckoutMutation__
 *
 * To run a mutation, you first call `useBuyerSyncBalanceCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerSyncBalanceCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerSyncBalanceCheckoutMutation, { data, loading, error }] = useBuyerSyncBalanceCheckoutMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useBuyerSyncBalanceCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<BuyerSyncBalanceCheckoutMutation, BuyerSyncBalanceCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerSyncBalanceCheckoutMutation, BuyerSyncBalanceCheckoutMutationVariables>(BuyerSyncBalanceCheckoutDocument, options);
      }
export type BuyerSyncBalanceCheckoutMutationHookResult = ReturnType<typeof useBuyerSyncBalanceCheckoutMutation>;
export type BuyerSyncBalanceCheckoutMutationResult = Apollo.MutationResult<BuyerSyncBalanceCheckoutMutation>;
export type BuyerSyncBalanceCheckoutMutationOptions = Apollo.BaseMutationOptions<BuyerSyncBalanceCheckoutMutation, BuyerSyncBalanceCheckoutMutationVariables>;
export const BuyerSyncCombinedSettlementDocument = gql`
    mutation BuyerSyncCombinedSettlement($orderId: MongoID!) {
  buyerSyncCombinedSettlement(orderId: $orderId) {
    status
  }
}
    `;
export type BuyerSyncCombinedSettlementMutationFn = Apollo.MutationFunction<BuyerSyncCombinedSettlementMutation, BuyerSyncCombinedSettlementMutationVariables>;

/**
 * __useBuyerSyncCombinedSettlementMutation__
 *
 * To run a mutation, you first call `useBuyerSyncCombinedSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerSyncCombinedSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerSyncCombinedSettlementMutation, { data, loading, error }] = useBuyerSyncCombinedSettlementMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useBuyerSyncCombinedSettlementMutation(baseOptions?: Apollo.MutationHookOptions<BuyerSyncCombinedSettlementMutation, BuyerSyncCombinedSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerSyncCombinedSettlementMutation, BuyerSyncCombinedSettlementMutationVariables>(BuyerSyncCombinedSettlementDocument, options);
      }
export type BuyerSyncCombinedSettlementMutationHookResult = ReturnType<typeof useBuyerSyncCombinedSettlementMutation>;
export type BuyerSyncCombinedSettlementMutationResult = Apollo.MutationResult<BuyerSyncCombinedSettlementMutation>;
export type BuyerSyncCombinedSettlementMutationOptions = Apollo.BaseMutationOptions<BuyerSyncCombinedSettlementMutation, BuyerSyncCombinedSettlementMutationVariables>;
export const BuyerSyncDepositCheckoutDocument = gql`
    mutation BuyerSyncDepositCheckout($sessionId: String!) {
  buyerSyncDepositCheckout(sessionId: $sessionId) {
    status
    splitStatus
    depositStatus
  }
}
    `;
export type BuyerSyncDepositCheckoutMutationFn = Apollo.MutationFunction<BuyerSyncDepositCheckoutMutation, BuyerSyncDepositCheckoutMutationVariables>;

/**
 * __useBuyerSyncDepositCheckoutMutation__
 *
 * To run a mutation, you first call `useBuyerSyncDepositCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerSyncDepositCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerSyncDepositCheckoutMutation, { data, loading, error }] = useBuyerSyncDepositCheckoutMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useBuyerSyncDepositCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<BuyerSyncDepositCheckoutMutation, BuyerSyncDepositCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyerSyncDepositCheckoutMutation, BuyerSyncDepositCheckoutMutationVariables>(BuyerSyncDepositCheckoutDocument, options);
      }
export type BuyerSyncDepositCheckoutMutationHookResult = ReturnType<typeof useBuyerSyncDepositCheckoutMutation>;
export type BuyerSyncDepositCheckoutMutationResult = Apollo.MutationResult<BuyerSyncDepositCheckoutMutation>;
export type BuyerSyncDepositCheckoutMutationOptions = Apollo.BaseMutationOptions<BuyerSyncDepositCheckoutMutation, BuyerSyncDepositCheckoutMutationVariables>;
export const CalendarEventCreateOneDocument = gql`
    mutation CalendarEventCreateOne($record: CreateOneCalendarEventInput!) {
  calendarEventCreateOne(record: $record) {
    record {
      _id
      vendor
      eventType
      title
      date
      description
    }
  }
}
    `;
export type CalendarEventCreateOneMutationFn = Apollo.MutationFunction<CalendarEventCreateOneMutation, CalendarEventCreateOneMutationVariables>;

/**
 * __useCalendarEventCreateOneMutation__
 *
 * To run a mutation, you first call `useCalendarEventCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventCreateOneMutation, { data, loading, error }] = useCalendarEventCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCalendarEventCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventCreateOneMutation, CalendarEventCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventCreateOneMutation, CalendarEventCreateOneMutationVariables>(CalendarEventCreateOneDocument, options);
      }
export type CalendarEventCreateOneMutationHookResult = ReturnType<typeof useCalendarEventCreateOneMutation>;
export type CalendarEventCreateOneMutationResult = Apollo.MutationResult<CalendarEventCreateOneMutation>;
export type CalendarEventCreateOneMutationOptions = Apollo.BaseMutationOptions<CalendarEventCreateOneMutation, CalendarEventCreateOneMutationVariables>;
export const CalendarEventRemoveByIdDocument = gql`
    mutation CalendarEventRemoveById($id: MongoID!) {
  calendarEventRemoveById(_id: $id) {
    recordId
  }
}
    `;
export type CalendarEventRemoveByIdMutationFn = Apollo.MutationFunction<CalendarEventRemoveByIdMutation, CalendarEventRemoveByIdMutationVariables>;

/**
 * __useCalendarEventRemoveByIdMutation__
 *
 * To run a mutation, you first call `useCalendarEventRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventRemoveByIdMutation, { data, loading, error }] = useCalendarEventRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventRemoveByIdMutation, CalendarEventRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventRemoveByIdMutation, CalendarEventRemoveByIdMutationVariables>(CalendarEventRemoveByIdDocument, options);
      }
export type CalendarEventRemoveByIdMutationHookResult = ReturnType<typeof useCalendarEventRemoveByIdMutation>;
export type CalendarEventRemoveByIdMutationResult = Apollo.MutationResult<CalendarEventRemoveByIdMutation>;
export type CalendarEventRemoveByIdMutationOptions = Apollo.BaseMutationOptions<CalendarEventRemoveByIdMutation, CalendarEventRemoveByIdMutationVariables>;
export const CalendarEventTypeCreateOneDocument = gql`
    mutation CalendarEventTypeCreateOne($record: CreateOneCalendarEventTypeInput!) {
  calendarEventTypeCreateOne(record: $record) {
    record {
      _id
      vendor
      title
      color
      isEnabled
      sortOrder
    }
  }
}
    `;
export type CalendarEventTypeCreateOneMutationFn = Apollo.MutationFunction<CalendarEventTypeCreateOneMutation, CalendarEventTypeCreateOneMutationVariables>;

/**
 * __useCalendarEventTypeCreateOneMutation__
 *
 * To run a mutation, you first call `useCalendarEventTypeCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventTypeCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventTypeCreateOneMutation, { data, loading, error }] = useCalendarEventTypeCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCalendarEventTypeCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventTypeCreateOneMutation, CalendarEventTypeCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventTypeCreateOneMutation, CalendarEventTypeCreateOneMutationVariables>(CalendarEventTypeCreateOneDocument, options);
      }
export type CalendarEventTypeCreateOneMutationHookResult = ReturnType<typeof useCalendarEventTypeCreateOneMutation>;
export type CalendarEventTypeCreateOneMutationResult = Apollo.MutationResult<CalendarEventTypeCreateOneMutation>;
export type CalendarEventTypeCreateOneMutationOptions = Apollo.BaseMutationOptions<CalendarEventTypeCreateOneMutation, CalendarEventTypeCreateOneMutationVariables>;
export const CalendarEventTypeRemoveByIdDocument = gql`
    mutation CalendarEventTypeRemoveById($id: MongoID!) {
  calendarEventTypeRemoveById(_id: $id) {
    recordId
  }
}
    `;
export type CalendarEventTypeRemoveByIdMutationFn = Apollo.MutationFunction<CalendarEventTypeRemoveByIdMutation, CalendarEventTypeRemoveByIdMutationVariables>;

/**
 * __useCalendarEventTypeRemoveByIdMutation__
 *
 * To run a mutation, you first call `useCalendarEventTypeRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventTypeRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventTypeRemoveByIdMutation, { data, loading, error }] = useCalendarEventTypeRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventTypeRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventTypeRemoveByIdMutation, CalendarEventTypeRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventTypeRemoveByIdMutation, CalendarEventTypeRemoveByIdMutationVariables>(CalendarEventTypeRemoveByIdDocument, options);
      }
export type CalendarEventTypeRemoveByIdMutationHookResult = ReturnType<typeof useCalendarEventTypeRemoveByIdMutation>;
export type CalendarEventTypeRemoveByIdMutationResult = Apollo.MutationResult<CalendarEventTypeRemoveByIdMutation>;
export type CalendarEventTypeRemoveByIdMutationOptions = Apollo.BaseMutationOptions<CalendarEventTypeRemoveByIdMutation, CalendarEventTypeRemoveByIdMutationVariables>;
export const CalendarEventTypeUpdateByIdDocument = gql`
    mutation CalendarEventTypeUpdateById($id: MongoID!, $record: UpdateByIdCalendarEventTypeInput!) {
  calendarEventTypeUpdateById(_id: $id, record: $record) {
    record {
      _id
      vendor
      title
      color
      isEnabled
      sortOrder
    }
  }
}
    `;
export type CalendarEventTypeUpdateByIdMutationFn = Apollo.MutationFunction<CalendarEventTypeUpdateByIdMutation, CalendarEventTypeUpdateByIdMutationVariables>;

/**
 * __useCalendarEventTypeUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCalendarEventTypeUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventTypeUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventTypeUpdateByIdMutation, { data, loading, error }] = useCalendarEventTypeUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCalendarEventTypeUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventTypeUpdateByIdMutation, CalendarEventTypeUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventTypeUpdateByIdMutation, CalendarEventTypeUpdateByIdMutationVariables>(CalendarEventTypeUpdateByIdDocument, options);
      }
export type CalendarEventTypeUpdateByIdMutationHookResult = ReturnType<typeof useCalendarEventTypeUpdateByIdMutation>;
export type CalendarEventTypeUpdateByIdMutationResult = Apollo.MutationResult<CalendarEventTypeUpdateByIdMutation>;
export type CalendarEventTypeUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CalendarEventTypeUpdateByIdMutation, CalendarEventTypeUpdateByIdMutationVariables>;
export const CalendarEventUpdateByIdDocument = gql`
    mutation CalendarEventUpdateById($id: MongoID!, $record: UpdateByIdCalendarEventInput!) {
  calendarEventUpdateById(_id: $id, record: $record) {
    record {
      _id
      vendor
      eventType
      title
      date
      description
    }
  }
}
    `;
export type CalendarEventUpdateByIdMutationFn = Apollo.MutationFunction<CalendarEventUpdateByIdMutation, CalendarEventUpdateByIdMutationVariables>;

/**
 * __useCalendarEventUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCalendarEventUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventUpdateByIdMutation, { data, loading, error }] = useCalendarEventUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCalendarEventUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventUpdateByIdMutation, CalendarEventUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventUpdateByIdMutation, CalendarEventUpdateByIdMutationVariables>(CalendarEventUpdateByIdDocument, options);
      }
export type CalendarEventUpdateByIdMutationHookResult = ReturnType<typeof useCalendarEventUpdateByIdMutation>;
export type CalendarEventUpdateByIdMutationResult = Apollo.MutationResult<CalendarEventUpdateByIdMutation>;
export type CalendarEventUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CalendarEventUpdateByIdMutation, CalendarEventUpdateByIdMutationVariables>;
export const CarcassTagPreviewDocument = gql`
    mutation CarcassTagPreview($vendorId: MongoID!) {
  carcassTagPreview(vendorId: $vendorId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type CarcassTagPreviewMutationFn = Apollo.MutationFunction<CarcassTagPreviewMutation, CarcassTagPreviewMutationVariables>;

/**
 * __useCarcassTagPreviewMutation__
 *
 * To run a mutation, you first call `useCarcassTagPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarcassTagPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carcassTagPreviewMutation, { data, loading, error }] = useCarcassTagPreviewMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCarcassTagPreviewMutation(baseOptions?: Apollo.MutationHookOptions<CarcassTagPreviewMutation, CarcassTagPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarcassTagPreviewMutation, CarcassTagPreviewMutationVariables>(CarcassTagPreviewDocument, options);
      }
export type CarcassTagPreviewMutationHookResult = ReturnType<typeof useCarcassTagPreviewMutation>;
export type CarcassTagPreviewMutationResult = Apollo.MutationResult<CarcassTagPreviewMutation>;
export type CarcassTagPreviewMutationOptions = Apollo.BaseMutationOptions<CarcassTagPreviewMutation, CarcassTagPreviewMutationVariables>;
export const ChatRoomCreateOneDocument = gql`
    mutation ChatRoomCreateOne($record: CreateOneChatRoomInput!) {
  chatRoomCreateOne(record: $record) {
    recordId
    record {
      ...ChatRoomFragment
    }
  }
}
    ${ChatRoomFragmentFragmentDoc}`;
export type ChatRoomCreateOneMutationFn = Apollo.MutationFunction<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>;

/**
 * __useChatRoomCreateOneMutation__
 *
 * To run a mutation, you first call `useChatRoomCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatRoomCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatRoomCreateOneMutation, { data, loading, error }] = useChatRoomCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useChatRoomCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>(ChatRoomCreateOneDocument, options);
      }
export type ChatRoomCreateOneMutationHookResult = ReturnType<typeof useChatRoomCreateOneMutation>;
export type ChatRoomCreateOneMutationResult = Apollo.MutationResult<ChatRoomCreateOneMutation>;
export type ChatRoomCreateOneMutationOptions = Apollo.BaseMutationOptions<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>;
export const CreateProcessorSchedulingDocument = gql`
    mutation CreateProcessorScheduling($newSchedule: CreateProcessorSchedulingInput!) {
  processorSchedulingCreate(newSchedule: $newSchedule) {
    scheduling {
      ...ProcessorSchedulingFragment
    }
    bookingFollowUp {
      date
      dayCapacity
      daySpotsRemaining
      nextOpenDate
    }
    messages
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;
export type CreateProcessorSchedulingMutationFn = Apollo.MutationFunction<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>;

/**
 * __useCreateProcessorSchedulingMutation__
 *
 * To run a mutation, you first call `useCreateProcessorSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessorSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessorSchedulingMutation, { data, loading, error }] = useCreateProcessorSchedulingMutation({
 *   variables: {
 *      newSchedule: // value for 'newSchedule'
 *   },
 * });
 */
export function useCreateProcessorSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>(CreateProcessorSchedulingDocument, options);
      }
export type CreateProcessorSchedulingMutationHookResult = ReturnType<typeof useCreateProcessorSchedulingMutation>;
export type CreateProcessorSchedulingMutationResult = Apollo.MutationResult<CreateProcessorSchedulingMutation>;
export type CreateProcessorSchedulingMutationOptions = Apollo.BaseMutationOptions<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>;
export const CsvImportCancelJobDocument = gql`
    mutation CsvImportCancelJob($jobId: String!, $stage: String!) {
  csvImportCancelJob(jobId: $jobId, stage: $stage) {
    jobId
    status
    cancelledAt
    cancelledAtStage
    message
  }
}
    `;
export type CsvImportCancelJobMutationFn = Apollo.MutationFunction<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>;

/**
 * __useCsvImportCancelJobMutation__
 *
 * To run a mutation, you first call `useCsvImportCancelJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportCancelJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportCancelJobMutation, { data, loading, error }] = useCsvImportCancelJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useCsvImportCancelJobMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>(CsvImportCancelJobDocument, options);
      }
export type CsvImportCancelJobMutationHookResult = ReturnType<typeof useCsvImportCancelJobMutation>;
export type CsvImportCancelJobMutationResult = Apollo.MutationResult<CsvImportCancelJobMutation>;
export type CsvImportCancelJobMutationOptions = Apollo.BaseMutationOptions<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>;
export const CsvImportDeleteRecordDocument = gql`
    mutation csvImportDeleteRecord($jobId: String!, $rowNumber: Int!) {
  csvImportDeleteRecord(jobId: $jobId, rowNumber: $rowNumber) {
    jobId
    deletedRows
    validRows
  }
}
    `;
export type CsvImportDeleteRecordMutationFn = Apollo.MutationFunction<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>;

/**
 * __useCsvImportDeleteRecordMutation__
 *
 * To run a mutation, you first call `useCsvImportDeleteRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportDeleteRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportDeleteRecordMutation, { data, loading, error }] = useCsvImportDeleteRecordMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      rowNumber: // value for 'rowNumber'
 *   },
 * });
 */
export function useCsvImportDeleteRecordMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>(CsvImportDeleteRecordDocument, options);
      }
export type CsvImportDeleteRecordMutationHookResult = ReturnType<typeof useCsvImportDeleteRecordMutation>;
export type CsvImportDeleteRecordMutationResult = Apollo.MutationResult<CsvImportDeleteRecordMutation>;
export type CsvImportDeleteRecordMutationOptions = Apollo.BaseMutationOptions<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>;
export const CsvImportExecuteDocument = gql`
    mutation CsvImportExecute($jobId: String!) {
  csvImportExecute(jobId: $jobId) {
    jobId
    status
    message
  }
}
    `;
export type CsvImportExecuteMutationFn = Apollo.MutationFunction<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>;

/**
 * __useCsvImportExecuteMutation__
 *
 * To run a mutation, you first call `useCsvImportExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportExecuteMutation, { data, loading, error }] = useCsvImportExecuteMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCsvImportExecuteMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>(CsvImportExecuteDocument, options);
      }
export type CsvImportExecuteMutationHookResult = ReturnType<typeof useCsvImportExecuteMutation>;
export type CsvImportExecuteMutationResult = Apollo.MutationResult<CsvImportExecuteMutation>;
export type CsvImportExecuteMutationOptions = Apollo.BaseMutationOptions<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>;
export const CsvImportRevalidateDocument = gql`
    mutation CsvImportRevalidate($jobId: String!, $data: JSON!) {
  csvImportRevalidate(jobId: $jobId, data: $data) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      errorMessages
    }
  }
}
    `;
export type CsvImportRevalidateMutationFn = Apollo.MutationFunction<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>;

/**
 * __useCsvImportRevalidateMutation__
 *
 * To run a mutation, you first call `useCsvImportRevalidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportRevalidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportRevalidateMutation, { data, loading, error }] = useCsvImportRevalidateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCsvImportRevalidateMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>(CsvImportRevalidateDocument, options);
      }
export type CsvImportRevalidateMutationHookResult = ReturnType<typeof useCsvImportRevalidateMutation>;
export type CsvImportRevalidateMutationResult = Apollo.MutationResult<CsvImportRevalidateMutation>;
export type CsvImportRevalidateMutationOptions = Apollo.BaseMutationOptions<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>;
export const CsvImportSaveColumnMappingDocument = gql`
    mutation CsvImportSaveColumnMapping($jobId: String!, $columnMapping: JSON!) {
  csvImportSaveColumnMapping(jobId: $jobId, columnMapping: $columnMapping) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      errorMessages
      warningMessages
    }
    s3Keys
    parsedData
    columns
  }
}
    `;
export type CsvImportSaveColumnMappingMutationFn = Apollo.MutationFunction<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>;

/**
 * __useCsvImportSaveColumnMappingMutation__
 *
 * To run a mutation, you first call `useCsvImportSaveColumnMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportSaveColumnMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportSaveColumnMappingMutation, { data, loading, error }] = useCsvImportSaveColumnMappingMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      columnMapping: // value for 'columnMapping'
 *   },
 * });
 */
export function useCsvImportSaveColumnMappingMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>(CsvImportSaveColumnMappingDocument, options);
      }
export type CsvImportSaveColumnMappingMutationHookResult = ReturnType<typeof useCsvImportSaveColumnMappingMutation>;
export type CsvImportSaveColumnMappingMutationResult = Apollo.MutationResult<CsvImportSaveColumnMappingMutation>;
export type CsvImportSaveColumnMappingMutationOptions = Apollo.BaseMutationOptions<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>;
export const CsvImportUpdateRowsDocument = gql`
    mutation csvImportUpdateRows($jobId: String!, $updatedRows: JSON!) {
  csvImportUpdateRows(jobId: $jobId, updatedRows: $updatedRows) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      errorMessages
      warningMessages
    }
  }
}
    `;
export type CsvImportUpdateRowsMutationFn = Apollo.MutationFunction<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>;

/**
 * __useCsvImportUpdateRowsMutation__
 *
 * To run a mutation, you first call `useCsvImportUpdateRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportUpdateRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportUpdateRowsMutation, { data, loading, error }] = useCsvImportUpdateRowsMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      updatedRows: // value for 'updatedRows'
 *   },
 * });
 */
export function useCsvImportUpdateRowsMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>(CsvImportUpdateRowsDocument, options);
      }
export type CsvImportUpdateRowsMutationHookResult = ReturnType<typeof useCsvImportUpdateRowsMutation>;
export type CsvImportUpdateRowsMutationResult = Apollo.MutationResult<CsvImportUpdateRowsMutation>;
export type CsvImportUpdateRowsMutationOptions = Apollo.BaseMutationOptions<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>;
export const CsvImportForceCancelDocument = gql`
    mutation CsvImportForceCancel($jobId: String!) {
  csvImportForceCancel(jobId: $jobId) {
    jobId
    status
    cancelledAt
    message
    warning
  }
}
    `;
export type CsvImportForceCancelMutationFn = Apollo.MutationFunction<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>;

/**
 * __useCsvImportForceCancelMutation__
 *
 * To run a mutation, you first call `useCsvImportForceCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportForceCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportForceCancelMutation, { data, loading, error }] = useCsvImportForceCancelMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCsvImportForceCancelMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>(CsvImportForceCancelDocument, options);
      }
export type CsvImportForceCancelMutationHookResult = ReturnType<typeof useCsvImportForceCancelMutation>;
export type CsvImportForceCancelMutationResult = Apollo.MutationResult<CsvImportForceCancelMutation>;
export type CsvImportForceCancelMutationOptions = Apollo.BaseMutationOptions<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>;
export const CsvImportUploadDocument = gql`
    mutation CsvImportUpload($file: Upload!, $type: String!, $vendorId: MongoID!, $tenantId: MongoID!) {
  csvImportUpload(
    file: $file
    type: $type
    vendorId: $vendorId
    tenantId: $tenantId
  ) {
    jobId
    totalRows
    validRows
    invalidRows
    validFilePath
    invalidFilePath
    validationErrors {
      row
      errorMessages
    }
    availableColumns {
      fieldName
      aliases
      required
      description
      validationRules
    }
    detectedColumns
    suggestedMapping
  }
}
    `;
export type CsvImportUploadMutationFn = Apollo.MutationFunction<CsvImportUploadMutation, CsvImportUploadMutationVariables>;

/**
 * __useCsvImportUploadMutation__
 *
 * To run a mutation, you first call `useCsvImportUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportUploadMutation, { data, loading, error }] = useCsvImportUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      type: // value for 'type'
 *      vendorId: // value for 'vendorId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCsvImportUploadMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportUploadMutation, CsvImportUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportUploadMutation, CsvImportUploadMutationVariables>(CsvImportUploadDocument, options);
      }
export type CsvImportUploadMutationHookResult = ReturnType<typeof useCsvImportUploadMutation>;
export type CsvImportUploadMutationResult = Apollo.MutationResult<CsvImportUploadMutation>;
export type CsvImportUploadMutationOptions = Apollo.BaseMutationOptions<CsvImportUploadMutation, CsvImportUploadMutationVariables>;
export const CustomFieldDefinitionCreateOneDocument = gql`
    mutation CustomFieldDefinitionCreateOne($record: CreateOneCustomFieldDefinitionInput!) {
  customFieldDefinitionCreateOne(record: $record) {
    record {
      _id
      vendor
      modelType
      label
      fieldType
      fieldSource
      fieldKey
      enabled
      options
      sortOrder
      required
      speciesFilter
      captureAt
      hint
    }
  }
}
    `;
export type CustomFieldDefinitionCreateOneMutationFn = Apollo.MutationFunction<CustomFieldDefinitionCreateOneMutation, CustomFieldDefinitionCreateOneMutationVariables>;

/**
 * __useCustomFieldDefinitionCreateOneMutation__
 *
 * To run a mutation, you first call `useCustomFieldDefinitionCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldDefinitionCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldDefinitionCreateOneMutation, { data, loading, error }] = useCustomFieldDefinitionCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCustomFieldDefinitionCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldDefinitionCreateOneMutation, CustomFieldDefinitionCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldDefinitionCreateOneMutation, CustomFieldDefinitionCreateOneMutationVariables>(CustomFieldDefinitionCreateOneDocument, options);
      }
export type CustomFieldDefinitionCreateOneMutationHookResult = ReturnType<typeof useCustomFieldDefinitionCreateOneMutation>;
export type CustomFieldDefinitionCreateOneMutationResult = Apollo.MutationResult<CustomFieldDefinitionCreateOneMutation>;
export type CustomFieldDefinitionCreateOneMutationOptions = Apollo.BaseMutationOptions<CustomFieldDefinitionCreateOneMutation, CustomFieldDefinitionCreateOneMutationVariables>;
export const CustomFieldDefinitionSoftDeleteDocument = gql`
    mutation CustomFieldDefinitionSoftDelete($id: MongoID!) {
  customFieldDefinitionSoftDelete(definitionId: $id) {
    _id
  }
}
    `;
export type CustomFieldDefinitionSoftDeleteMutationFn = Apollo.MutationFunction<CustomFieldDefinitionSoftDeleteMutation, CustomFieldDefinitionSoftDeleteMutationVariables>;

/**
 * __useCustomFieldDefinitionSoftDeleteMutation__
 *
 * To run a mutation, you first call `useCustomFieldDefinitionSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldDefinitionSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldDefinitionSoftDeleteMutation, { data, loading, error }] = useCustomFieldDefinitionSoftDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomFieldDefinitionSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldDefinitionSoftDeleteMutation, CustomFieldDefinitionSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldDefinitionSoftDeleteMutation, CustomFieldDefinitionSoftDeleteMutationVariables>(CustomFieldDefinitionSoftDeleteDocument, options);
      }
export type CustomFieldDefinitionSoftDeleteMutationHookResult = ReturnType<typeof useCustomFieldDefinitionSoftDeleteMutation>;
export type CustomFieldDefinitionSoftDeleteMutationResult = Apollo.MutationResult<CustomFieldDefinitionSoftDeleteMutation>;
export type CustomFieldDefinitionSoftDeleteMutationOptions = Apollo.BaseMutationOptions<CustomFieldDefinitionSoftDeleteMutation, CustomFieldDefinitionSoftDeleteMutationVariables>;
export const CustomFieldDefinitionUpdateByIdDocument = gql`
    mutation CustomFieldDefinitionUpdateById($id: MongoID!, $record: UpdateByIdCustomFieldDefinitionInput!) {
  customFieldDefinitionUpdateById(_id: $id, record: $record) {
    record {
      _id
      vendor
      modelType
      label
      fieldType
      fieldSource
      fieldKey
      enabled
      options
      sortOrder
      required
      speciesFilter
      captureAt
      hint
    }
  }
}
    `;
export type CustomFieldDefinitionUpdateByIdMutationFn = Apollo.MutationFunction<CustomFieldDefinitionUpdateByIdMutation, CustomFieldDefinitionUpdateByIdMutationVariables>;

/**
 * __useCustomFieldDefinitionUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCustomFieldDefinitionUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldDefinitionUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldDefinitionUpdateByIdMutation, { data, loading, error }] = useCustomFieldDefinitionUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCustomFieldDefinitionUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldDefinitionUpdateByIdMutation, CustomFieldDefinitionUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldDefinitionUpdateByIdMutation, CustomFieldDefinitionUpdateByIdMutationVariables>(CustomFieldDefinitionUpdateByIdDocument, options);
      }
export type CustomFieldDefinitionUpdateByIdMutationHookResult = ReturnType<typeof useCustomFieldDefinitionUpdateByIdMutation>;
export type CustomFieldDefinitionUpdateByIdMutationResult = Apollo.MutationResult<CustomFieldDefinitionUpdateByIdMutation>;
export type CustomFieldDefinitionUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CustomFieldDefinitionUpdateByIdMutation, CustomFieldDefinitionUpdateByIdMutationVariables>;
export const CustomFieldValueBulkSaveDocument = gql`
    mutation CustomFieldValueBulkSave($inputs: [CustomFieldValueBulkInput!]!) {
  customFieldValueBulkSave(inputs: $inputs) {
    savedCount
    errors {
      index
      message
    }
  }
}
    `;
export type CustomFieldValueBulkSaveMutationFn = Apollo.MutationFunction<CustomFieldValueBulkSaveMutation, CustomFieldValueBulkSaveMutationVariables>;

/**
 * __useCustomFieldValueBulkSaveMutation__
 *
 * To run a mutation, you first call `useCustomFieldValueBulkSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldValueBulkSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldValueBulkSaveMutation, { data, loading, error }] = useCustomFieldValueBulkSaveMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCustomFieldValueBulkSaveMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldValueBulkSaveMutation, CustomFieldValueBulkSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldValueBulkSaveMutation, CustomFieldValueBulkSaveMutationVariables>(CustomFieldValueBulkSaveDocument, options);
      }
export type CustomFieldValueBulkSaveMutationHookResult = ReturnType<typeof useCustomFieldValueBulkSaveMutation>;
export type CustomFieldValueBulkSaveMutationResult = Apollo.MutationResult<CustomFieldValueBulkSaveMutation>;
export type CustomFieldValueBulkSaveMutationOptions = Apollo.BaseMutationOptions<CustomFieldValueBulkSaveMutation, CustomFieldValueBulkSaveMutationVariables>;
export const CustomFieldValueClearDocument = gql`
    mutation CustomFieldValueClear($inputs: [CustomFieldValueClearInput!]!) {
  customFieldValueClear(inputs: $inputs) {
    deletedCount
  }
}
    `;
export type CustomFieldValueClearMutationFn = Apollo.MutationFunction<CustomFieldValueClearMutation, CustomFieldValueClearMutationVariables>;

/**
 * __useCustomFieldValueClearMutation__
 *
 * To run a mutation, you first call `useCustomFieldValueClearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldValueClearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldValueClearMutation, { data, loading, error }] = useCustomFieldValueClearMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCustomFieldValueClearMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldValueClearMutation, CustomFieldValueClearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldValueClearMutation, CustomFieldValueClearMutationVariables>(CustomFieldValueClearDocument, options);
      }
export type CustomFieldValueClearMutationHookResult = ReturnType<typeof useCustomFieldValueClearMutation>;
export type CustomFieldValueClearMutationResult = Apollo.MutationResult<CustomFieldValueClearMutation>;
export type CustomFieldValueClearMutationOptions = Apollo.BaseMutationOptions<CustomFieldValueClearMutation, CustomFieldValueClearMutationVariables>;
export const CustomerDeleteDocument = gql`
    mutation CustomerDelete($userId: MongoID!, $vendorId: MongoID!) {
  customerDelete(userId: $userId, vendorId: $vendorId) {
    operationId
    loserSoftDeleted
  }
}
    `;
export type CustomerDeleteMutationFn = Apollo.MutationFunction<CustomerDeleteMutation, CustomerDeleteMutationVariables>;

/**
 * __useCustomerDeleteMutation__
 *
 * To run a mutation, you first call `useCustomerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerDeleteMutation, { data, loading, error }] = useCustomerDeleteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCustomerDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CustomerDeleteMutation, CustomerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerDeleteMutation, CustomerDeleteMutationVariables>(CustomerDeleteDocument, options);
      }
export type CustomerDeleteMutationHookResult = ReturnType<typeof useCustomerDeleteMutation>;
export type CustomerDeleteMutationResult = Apollo.MutationResult<CustomerDeleteMutation>;
export type CustomerDeleteMutationOptions = Apollo.BaseMutationOptions<CustomerDeleteMutation, CustomerDeleteMutationVariables>;
export const CustomerMergeDocument = gql`
    mutation CustomerMerge($winnerId: MongoID!, $loserIds: [MongoID!]!, $vendorId: MongoID!, $fieldSelections: [CustomerMergeFieldSelectionInput!]) {
  customerMerge(
    winnerId: $winnerId
    loserIds: $loserIds
    vendorId: $vendorId
    fieldSelections: $fieldSelections
  ) {
    operationIds
    affectedRecordCount
  }
}
    `;
export type CustomerMergeMutationFn = Apollo.MutationFunction<CustomerMergeMutation, CustomerMergeMutationVariables>;

/**
 * __useCustomerMergeMutation__
 *
 * To run a mutation, you first call `useCustomerMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerMergeMutation, { data, loading, error }] = useCustomerMergeMutation({
 *   variables: {
 *      winnerId: // value for 'winnerId'
 *      loserIds: // value for 'loserIds'
 *      vendorId: // value for 'vendorId'
 *      fieldSelections: // value for 'fieldSelections'
 *   },
 * });
 */
export function useCustomerMergeMutation(baseOptions?: Apollo.MutationHookOptions<CustomerMergeMutation, CustomerMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerMergeMutation, CustomerMergeMutationVariables>(CustomerMergeDocument, options);
      }
export type CustomerMergeMutationHookResult = ReturnType<typeof useCustomerMergeMutation>;
export type CustomerMergeMutationResult = Apollo.MutationResult<CustomerMergeMutation>;
export type CustomerMergeMutationOptions = Apollo.BaseMutationOptions<CustomerMergeMutation, CustomerMergeMutationVariables>;
export const CustomerNotificationPreferenceUpdateDocument = gql`
    mutation CustomerNotificationPreferenceUpdate($userId: MongoID!, $category: String!, $email: Boolean, $sms: Boolean) {
  customerNotificationPreferenceUpdate(
    userId: $userId
    category: $category
    email: $email
    sms: $sms
  ) {
    category
    label
    description
    email
    sms
  }
}
    `;
export type CustomerNotificationPreferenceUpdateMutationFn = Apollo.MutationFunction<CustomerNotificationPreferenceUpdateMutation, CustomerNotificationPreferenceUpdateMutationVariables>;

/**
 * __useCustomerNotificationPreferenceUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerNotificationPreferenceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerNotificationPreferenceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerNotificationPreferenceUpdateMutation, { data, loading, error }] = useCustomerNotificationPreferenceUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      category: // value for 'category'
 *      email: // value for 'email'
 *      sms: // value for 'sms'
 *   },
 * });
 */
export function useCustomerNotificationPreferenceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CustomerNotificationPreferenceUpdateMutation, CustomerNotificationPreferenceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerNotificationPreferenceUpdateMutation, CustomerNotificationPreferenceUpdateMutationVariables>(CustomerNotificationPreferenceUpdateDocument, options);
      }
export type CustomerNotificationPreferenceUpdateMutationHookResult = ReturnType<typeof useCustomerNotificationPreferenceUpdateMutation>;
export type CustomerNotificationPreferenceUpdateMutationResult = Apollo.MutationResult<CustomerNotificationPreferenceUpdateMutation>;
export type CustomerNotificationPreferenceUpdateMutationOptions = Apollo.BaseMutationOptions<CustomerNotificationPreferenceUpdateMutation, CustomerNotificationPreferenceUpdateMutationVariables>;
export const CutsheetAssignmentRuleSetDeleteDocument = gql`
    mutation CutsheetAssignmentRuleSetDelete($capabilityId: MongoID!) {
  cutsheetAssignmentRuleSetDelete(capabilityId: $capabilityId)
}
    `;
export type CutsheetAssignmentRuleSetDeleteMutationFn = Apollo.MutationFunction<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>;

/**
 * __useCutsheetAssignmentRuleSetDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetAssignmentRuleSetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetAssignmentRuleSetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetAssignmentRuleSetDeleteMutation, { data, loading, error }] = useCutsheetAssignmentRuleSetDeleteMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useCutsheetAssignmentRuleSetDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>(CutsheetAssignmentRuleSetDeleteDocument, options);
      }
export type CutsheetAssignmentRuleSetDeleteMutationHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetDeleteMutation>;
export type CutsheetAssignmentRuleSetDeleteMutationResult = Apollo.MutationResult<CutsheetAssignmentRuleSetDeleteMutation>;
export type CutsheetAssignmentRuleSetDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>;
export const CutsheetAssignmentRuleSetUpsertDocument = gql`
    mutation CutsheetAssignmentRuleSetUpsert($capabilityId: MongoID!, $rules: [CutsheetAssignmentRuleInput!], $defaultQuestionnaireId: MongoID) {
  cutsheetAssignmentRuleSetUpsert(
    capabilityId: $capabilityId
    rules: $rules
    defaultQuestionnaireId: $defaultQuestionnaireId
  ) {
    ...CutsheetAssignmentRuleSetFragment
  }
}
    ${CutsheetAssignmentRuleSetFragmentFragmentDoc}`;
export type CutsheetAssignmentRuleSetUpsertMutationFn = Apollo.MutationFunction<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>;

/**
 * __useCutsheetAssignmentRuleSetUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetAssignmentRuleSetUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetAssignmentRuleSetUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetAssignmentRuleSetUpsertMutation, { data, loading, error }] = useCutsheetAssignmentRuleSetUpsertMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      rules: // value for 'rules'
 *      defaultQuestionnaireId: // value for 'defaultQuestionnaireId'
 *   },
 * });
 */
export function useCutsheetAssignmentRuleSetUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>(CutsheetAssignmentRuleSetUpsertDocument, options);
      }
export type CutsheetAssignmentRuleSetUpsertMutationHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetUpsertMutation>;
export type CutsheetAssignmentRuleSetUpsertMutationResult = Apollo.MutationResult<CutsheetAssignmentRuleSetUpsertMutation>;
export type CutsheetAssignmentRuleSetUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>;
export const CutsheetCapabilityDeleteDocument = gql`
    mutation CutsheetCapabilityDelete($id: MongoID!) {
  CutsheetCapabilityDelete(id: $id)
}
    `;
export type CutsheetCapabilityDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityDeleteMutation, { data, loading, error }] = useCutsheetCapabilityDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>(CutsheetCapabilityDeleteDocument, options);
      }
export type CutsheetCapabilityDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityDeleteMutation>;
export type CutsheetCapabilityDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityDeleteMutation>;
export type CutsheetCapabilityDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>;
export const CutsheetCapabilityUpsertDocument = gql`
    mutation CutsheetCapabilityUpsert($id: MongoID, $vendorId: MongoID!, $species: String!, $name: String!, $description: String, $isActive: Boolean) {
  CutsheetCapabilityUpsert(
    id: $id
    vendorId: $vendorId
    species: $species
    name: $name
    description: $description
    isActive: $isActive
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityUpsertMutation, { data, loading, error }] = useCutsheetCapabilityUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>(CutsheetCapabilityUpsertDocument, options);
      }
export type CutsheetCapabilityUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityUpsertMutation>;
export type CutsheetCapabilityUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityUpsertMutation>;
export type CutsheetCapabilityUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>;
export const CutsheetCapabilityDuplicateDocument = gql`
    mutation CutsheetCapabilityDuplicate($sourceCapabilityId: MongoID!, $targetCapabilityId: MongoID!, $includeQuestionnaires: Boolean!, $includeAssignmentRules: Boolean!, $allowCrossVendor: Boolean) {
  CutsheetCapabilityDuplicate(
    sourceCapabilityId: $sourceCapabilityId
    targetCapabilityId: $targetCapabilityId
    includeQuestionnaires: $includeQuestionnaires
    includeAssignmentRules: $includeAssignmentRules
    allowCrossVendor: $allowCrossVendor
  ) {
    capability {
      ...CutsheetCapabilityFragment
    }
    summary {
      groupsCopied
      optionsCopied
      specificationsCopied
      questionnairesCopied
      assignmentRulesCopied
    }
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityDuplicateMutationFn = Apollo.MutationFunction<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>;

/**
 * __useCutsheetCapabilityDuplicateMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityDuplicateMutation, { data, loading, error }] = useCutsheetCapabilityDuplicateMutation({
 *   variables: {
 *      sourceCapabilityId: // value for 'sourceCapabilityId'
 *      targetCapabilityId: // value for 'targetCapabilityId'
 *      includeQuestionnaires: // value for 'includeQuestionnaires'
 *      includeAssignmentRules: // value for 'includeAssignmentRules'
 *      allowCrossVendor: // value for 'allowCrossVendor'
 *   },
 * });
 */
export function useCutsheetCapabilityDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>(CutsheetCapabilityDuplicateDocument, options);
      }
export type CutsheetCapabilityDuplicateMutationHookResult = ReturnType<typeof useCutsheetCapabilityDuplicateMutation>;
export type CutsheetCapabilityDuplicateMutationResult = Apollo.MutationResult<CutsheetCapabilityDuplicateMutation>;
export type CutsheetCapabilityDuplicateMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>;
export const CutsheetCapabilityGenerateBlankCutsheetDocument = gql`
    mutation CutsheetCapabilityGenerateBlankCutsheet($cutsheetCapabilityId: MongoID!) {
  cutsheetCapabilityGenerateBlankCutsheet(
    cutsheetCapabilityId: $cutsheetCapabilityId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type CutsheetCapabilityGenerateBlankCutsheetMutationFn = Apollo.MutationFunction<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>;

/**
 * __useCutsheetCapabilityGenerateBlankCutsheetMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGenerateBlankCutsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGenerateBlankCutsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGenerateBlankCutsheetMutation, { data, loading, error }] = useCutsheetCapabilityGenerateBlankCutsheetMutation({
 *   variables: {
 *      cutsheetCapabilityId: // value for 'cutsheetCapabilityId'
 *   },
 * });
 */
export function useCutsheetCapabilityGenerateBlankCutsheetMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>(CutsheetCapabilityGenerateBlankCutsheetDocument, options);
      }
export type CutsheetCapabilityGenerateBlankCutsheetMutationHookResult = ReturnType<typeof useCutsheetCapabilityGenerateBlankCutsheetMutation>;
export type CutsheetCapabilityGenerateBlankCutsheetMutationResult = Apollo.MutationResult<CutsheetCapabilityGenerateBlankCutsheetMutation>;
export type CutsheetCapabilityGenerateBlankCutsheetMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>;
export const CutsheetCapabilityMigrateLegacyDocument = gql`
    mutation CutsheetCapabilityMigrateLegacy($capabilityId: MongoID!, $enabledOnly: Boolean, $deactivateUnusedCuts: Boolean, $inspectionLevel: String) {
  CutsheetCapabilityMigrateLegacy(
    capabilityId: $capabilityId
    enabledOnly: $enabledOnly
    deactivateUnusedCuts: $deactivateUnusedCuts
    inspectionLevel: $inspectionLevel
  ) {
    capability {
      ...CutsheetCapabilityFragment
    }
    summary {
      inspectionLevelsMigrated
      groupsCreated
      groupsReused
      cutsCreated
      cutsReused
      trimsCreated
      trimsReused
      specificationsCreated
      specificationsReused
      questionnairesCreated
      questionnairesReused
      assignmentRulesAdded
    }
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityMigrateLegacyMutationFn = Apollo.MutationFunction<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>;

/**
 * __useCutsheetCapabilityMigrateLegacyMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityMigrateLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityMigrateLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityMigrateLegacyMutation, { data, loading, error }] = useCutsheetCapabilityMigrateLegacyMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      enabledOnly: // value for 'enabledOnly'
 *      deactivateUnusedCuts: // value for 'deactivateUnusedCuts'
 *      inspectionLevel: // value for 'inspectionLevel'
 *   },
 * });
 */
export function useCutsheetCapabilityMigrateLegacyMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>(CutsheetCapabilityMigrateLegacyDocument, options);
      }
export type CutsheetCapabilityMigrateLegacyMutationHookResult = ReturnType<typeof useCutsheetCapabilityMigrateLegacyMutation>;
export type CutsheetCapabilityMigrateLegacyMutationResult = Apollo.MutationResult<CutsheetCapabilityMigrateLegacyMutation>;
export type CutsheetCapabilityMigrateLegacyMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>;
export const CutsheetCapabilityOptionDeleteDocument = gql`
    mutation CutsheetCapabilityOptionDelete($id: MongoID!) {
  cutsheetCapabilityOptionDelete(id: $id)
}
    `;
export type CutsheetCapabilityOptionDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityOptionDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityOptionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityOptionDeleteMutation, { data, loading, error }] = useCutsheetCapabilityOptionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>(CutsheetCapabilityOptionDeleteDocument, options);
      }
export type CutsheetCapabilityOptionDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityOptionDeleteMutation>;
export type CutsheetCapabilityOptionDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityOptionDeleteMutation>;
export type CutsheetCapabilityOptionDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>;
export const CutsheetCapabilityOptionUpsertDocument = gql`
    mutation CutsheetCapabilityOptionUpsert($id: MongoID, $capabilityId: MongoID!, $optionType: String!, $title: String!, $description: String, $imageUrl: String, $specifications: [CutsheetCapabilityOptionSpecificationInput!], $pricing: CutsheetCapabilityOptionPricingInput, $isActive: Boolean, $groupId: MongoID, $isDefault: Boolean, $minQty: Float, $hasCharge: Boolean, $printedText: String) {
  cutsheetCapabilityOptionUpsert(
    id: $id
    capabilityId: $capabilityId
    optionType: $optionType
    title: $title
    description: $description
    imageUrl: $imageUrl
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    groupId: $groupId
    isDefault: $isDefault
    minQty: $minQty
    hasCharge: $hasCharge
    printedText: $printedText
  ) {
    ...CutsheetCapabilityOptionFragment
  }
}
    ${CutsheetCapabilityOptionFragmentFragmentDoc}`;
export type CutsheetCapabilityOptionUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityOptionUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityOptionUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityOptionUpsertMutation, { data, loading, error }] = useCutsheetCapabilityOptionUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      capabilityId: // value for 'capabilityId'
 *      optionType: // value for 'optionType'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      groupId: // value for 'groupId'
 *      isDefault: // value for 'isDefault'
 *      minQty: // value for 'minQty'
 *      hasCharge: // value for 'hasCharge'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>(CutsheetCapabilityOptionUpsertDocument, options);
      }
export type CutsheetCapabilityOptionUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityOptionUpsertMutation>;
export type CutsheetCapabilityOptionUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityOptionUpsertMutation>;
export type CutsheetCapabilityOptionUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>;
export const CutsheetCapabilityPrintSettingsUpdateDocument = gql`
    mutation CutsheetCapabilityPrintSettingsUpdate($id: MongoID!, $baseFontSize: Float!, $primalColumns: Float!, $specsLayoutPosition: String!, $checkboxStyle: String!, $showAllSpecOptions: Boolean, $showPrimalGroup: Boolean!, $alwaysShowPrimalNotes: Boolean!, $hideUnselectedCuts: Boolean!, $highlightCutsheetNotes: Boolean, $highlightSectionNotes: Boolean, $orientation: String!, $hiddenGroupIds: [String!]!, $hiddenItemIds: [String!]!, $hiddenSpecificationIds: [String!]!, $showCustomContent: Boolean, $customContentTitle: String, $customContent: String) {
  CutsheetCapabilityPrintSettingsUpdate(
    id: $id
    baseFontSize: $baseFontSize
    primalColumns: $primalColumns
    specsLayoutPosition: $specsLayoutPosition
    checkboxStyle: $checkboxStyle
    showAllSpecOptions: $showAllSpecOptions
    showPrimalGroup: $showPrimalGroup
    alwaysShowPrimalNotes: $alwaysShowPrimalNotes
    hideUnselectedCuts: $hideUnselectedCuts
    highlightCutsheetNotes: $highlightCutsheetNotes
    highlightSectionNotes: $highlightSectionNotes
    orientation: $orientation
    hiddenGroupIds: $hiddenGroupIds
    hiddenItemIds: $hiddenItemIds
    hiddenSpecificationIds: $hiddenSpecificationIds
    showCustomContent: $showCustomContent
    customContentTitle: $customContentTitle
    customContent: $customContent
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityPrintSettingsUpdateMutationFn = Apollo.MutationFunction<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>;

/**
 * __useCutsheetCapabilityPrintSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityPrintSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityPrintSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityPrintSettingsUpdateMutation, { data, loading, error }] = useCutsheetCapabilityPrintSettingsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      baseFontSize: // value for 'baseFontSize'
 *      primalColumns: // value for 'primalColumns'
 *      specsLayoutPosition: // value for 'specsLayoutPosition'
 *      checkboxStyle: // value for 'checkboxStyle'
 *      showAllSpecOptions: // value for 'showAllSpecOptions'
 *      showPrimalGroup: // value for 'showPrimalGroup'
 *      alwaysShowPrimalNotes: // value for 'alwaysShowPrimalNotes'
 *      hideUnselectedCuts: // value for 'hideUnselectedCuts'
 *      highlightCutsheetNotes: // value for 'highlightCutsheetNotes'
 *      highlightSectionNotes: // value for 'highlightSectionNotes'
 *      orientation: // value for 'orientation'
 *      hiddenGroupIds: // value for 'hiddenGroupIds'
 *      hiddenItemIds: // value for 'hiddenItemIds'
 *      hiddenSpecificationIds: // value for 'hiddenSpecificationIds'
 *      showCustomContent: // value for 'showCustomContent'
 *      customContentTitle: // value for 'customContentTitle'
 *      customContent: // value for 'customContent'
 *   },
 * });
 */
export function useCutsheetCapabilityPrintSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>(CutsheetCapabilityPrintSettingsUpdateDocument, options);
      }
export type CutsheetCapabilityPrintSettingsUpdateMutationHookResult = ReturnType<typeof useCutsheetCapabilityPrintSettingsUpdateMutation>;
export type CutsheetCapabilityPrintSettingsUpdateMutationResult = Apollo.MutationResult<CutsheetCapabilityPrintSettingsUpdateMutation>;
export type CutsheetCapabilityPrintSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>;
export const CutsheetCapabilitySetLegacyMapDocument = gql`
    mutation CutsheetCapabilitySetLegacyMap($id: MongoID!, $legacyInspectionLevelMap: [CutsheetLegacyInspectionLevelEntryInput!]!) {
  CutsheetCapabilitySetLegacyMap(
    id: $id
    legacyInspectionLevelMap: $legacyInspectionLevelMap
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilitySetLegacyMapMutationFn = Apollo.MutationFunction<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>;

/**
 * __useCutsheetCapabilitySetLegacyMapMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySetLegacyMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySetLegacyMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySetLegacyMapMutation, { data, loading, error }] = useCutsheetCapabilitySetLegacyMapMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legacyInspectionLevelMap: // value for 'legacyInspectionLevelMap'
 *   },
 * });
 */
export function useCutsheetCapabilitySetLegacyMapMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>(CutsheetCapabilitySetLegacyMapDocument, options);
      }
export type CutsheetCapabilitySetLegacyMapMutationHookResult = ReturnType<typeof useCutsheetCapabilitySetLegacyMapMutation>;
export type CutsheetCapabilitySetLegacyMapMutationResult = Apollo.MutationResult<CutsheetCapabilitySetLegacyMapMutation>;
export type CutsheetCapabilitySetLegacyMapMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>;
export const CutsheetCatalogChatDocument = gql`
    mutation CutsheetCatalogChat($capabilityId: MongoID!, $messages: [CutsheetCatalogChatMessageInput!]!, $autoApprove: Boolean) {
  cutsheetCatalogChat(
    capabilityId: $capabilityId
    messages: $messages
    autoApprove: $autoApprove
  ) {
    message
    catalogChanged
    actions {
      kind
      label
      itemType
      itemId
    }
    proposedChanges {
      id
      tool
      args
      kind
      itemType
      label
    }
  }
}
    `;
export type CutsheetCatalogChatMutationFn = Apollo.MutationFunction<CutsheetCatalogChatMutation, CutsheetCatalogChatMutationVariables>;

/**
 * __useCutsheetCatalogChatMutation__
 *
 * To run a mutation, you first call `useCutsheetCatalogChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCatalogChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCatalogChatMutation, { data, loading, error }] = useCutsheetCatalogChatMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      messages: // value for 'messages'
 *      autoApprove: // value for 'autoApprove'
 *   },
 * });
 */
export function useCutsheetCatalogChatMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCatalogChatMutation, CutsheetCatalogChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCatalogChatMutation, CutsheetCatalogChatMutationVariables>(CutsheetCatalogChatDocument, options);
      }
export type CutsheetCatalogChatMutationHookResult = ReturnType<typeof useCutsheetCatalogChatMutation>;
export type CutsheetCatalogChatMutationResult = Apollo.MutationResult<CutsheetCatalogChatMutation>;
export type CutsheetCatalogChatMutationOptions = Apollo.BaseMutationOptions<CutsheetCatalogChatMutation, CutsheetCatalogChatMutationVariables>;
export const CutsheetCreateOneDocument = gql`
    mutation CutsheetCreateOne($record: CreateOneCutsheetInput!) {
  cutsheetCreateOne(record: $record) {
    recordId
    record {
      ...CutsheetFragment
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;
export type CutsheetCreateOneMutationFn = Apollo.MutationFunction<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>;

/**
 * __useCutsheetCreateOneMutation__
 *
 * To run a mutation, you first call `useCutsheetCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCreateOneMutation, { data, loading, error }] = useCutsheetCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>(CutsheetCreateOneDocument, options);
      }
export type CutsheetCreateOneMutationHookResult = ReturnType<typeof useCutsheetCreateOneMutation>;
export type CutsheetCreateOneMutationResult = Apollo.MutationResult<CutsheetCreateOneMutation>;
export type CutsheetCreateOneMutationOptions = Apollo.BaseMutationOptions<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>;
export const CutsheetCapabilityCutDeleteDocument = gql`
    mutation CutsheetCapabilityCutDelete($id: MongoID!) {
  cutsheetCutDelete(id: $id)
}
    `;
export type CutsheetCapabilityCutDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityCutDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityCutDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityCutDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityCutDeleteMutation, { data, loading, error }] = useCutsheetCapabilityCutDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityCutDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>(CutsheetCapabilityCutDeleteDocument, options);
      }
export type CutsheetCapabilityCutDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityCutDeleteMutation>;
export type CutsheetCapabilityCutDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityCutDeleteMutation>;
export type CutsheetCapabilityCutDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>;
export const CutsheetCapabilityCutUpsertDocument = gql`
    mutation CutsheetCapabilityCutUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $groupId: MongoID, $title: String!, $description: String, $imageUrl: String, $specifications: [CutsheetCutSpecificationInput!], $pricing: CutsheetCutPricingInput, $isActive: Boolean, $printedText: String, $partnerCodes: [CutsheetCapabilityOptionPartnerCodeInput]) {
  cutsheetCutUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    groupId: $groupId
    title: $title
    description: $description
    imageUrl: $imageUrl
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    printedText: $printedText
    partnerCodes: $partnerCodes
  ) {
    ...CutsheetCapabilityCutFragment
  }
}
    ${CutsheetCapabilityCutFragmentFragmentDoc}`;
export type CutsheetCapabilityCutUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityCutUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityCutUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityCutUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityCutUpsertMutation, { data, loading, error }] = useCutsheetCapabilityCutUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      groupId: // value for 'groupId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *      partnerCodes: // value for 'partnerCodes'
 *   },
 * });
 */
export function useCutsheetCapabilityCutUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>(CutsheetCapabilityCutUpsertDocument, options);
      }
export type CutsheetCapabilityCutUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityCutUpsertMutation>;
export type CutsheetCapabilityCutUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityCutUpsertMutation>;
export type CutsheetCapabilityCutUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>;
export const CutsheetDescriptionLibraryCreateOneDocument = gql`
    mutation CutsheetDescriptionLibraryCreateOne($record: CreateOneCutsheetDescriptionLibraryInput!) {
  cutsheetDescriptionLibraryCreateOne(record: $record) {
    recordId
    record {
      ...CutsheetDescriptionLibraryFragment
    }
  }
}
    ${CutsheetDescriptionLibraryFragmentFragmentDoc}`;
export type CutsheetDescriptionLibraryCreateOneMutationFn = Apollo.MutationFunction<CutsheetDescriptionLibraryCreateOneMutation, CutsheetDescriptionLibraryCreateOneMutationVariables>;

/**
 * __useCutsheetDescriptionLibraryCreateOneMutation__
 *
 * To run a mutation, you first call `useCutsheetDescriptionLibraryCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibraryCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetDescriptionLibraryCreateOneMutation, { data, loading, error }] = useCutsheetDescriptionLibraryCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetDescriptionLibraryCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetDescriptionLibraryCreateOneMutation, CutsheetDescriptionLibraryCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetDescriptionLibraryCreateOneMutation, CutsheetDescriptionLibraryCreateOneMutationVariables>(CutsheetDescriptionLibraryCreateOneDocument, options);
      }
export type CutsheetDescriptionLibraryCreateOneMutationHookResult = ReturnType<typeof useCutsheetDescriptionLibraryCreateOneMutation>;
export type CutsheetDescriptionLibraryCreateOneMutationResult = Apollo.MutationResult<CutsheetDescriptionLibraryCreateOneMutation>;
export type CutsheetDescriptionLibraryCreateOneMutationOptions = Apollo.BaseMutationOptions<CutsheetDescriptionLibraryCreateOneMutation, CutsheetDescriptionLibraryCreateOneMutationVariables>;
export const CutsheetDescriptionLibraryRemoveByIdDocument = gql`
    mutation CutsheetDescriptionLibraryRemoveById($_id: MongoID!) {
  cutsheetDescriptionLibraryRemoveById(_id: $_id) {
    recordId
  }
}
    `;
export type CutsheetDescriptionLibraryRemoveByIdMutationFn = Apollo.MutationFunction<CutsheetDescriptionLibraryRemoveByIdMutation, CutsheetDescriptionLibraryRemoveByIdMutationVariables>;

/**
 * __useCutsheetDescriptionLibraryRemoveByIdMutation__
 *
 * To run a mutation, you first call `useCutsheetDescriptionLibraryRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibraryRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetDescriptionLibraryRemoveByIdMutation, { data, loading, error }] = useCutsheetDescriptionLibraryRemoveByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useCutsheetDescriptionLibraryRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetDescriptionLibraryRemoveByIdMutation, CutsheetDescriptionLibraryRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetDescriptionLibraryRemoveByIdMutation, CutsheetDescriptionLibraryRemoveByIdMutationVariables>(CutsheetDescriptionLibraryRemoveByIdDocument, options);
      }
export type CutsheetDescriptionLibraryRemoveByIdMutationHookResult = ReturnType<typeof useCutsheetDescriptionLibraryRemoveByIdMutation>;
export type CutsheetDescriptionLibraryRemoveByIdMutationResult = Apollo.MutationResult<CutsheetDescriptionLibraryRemoveByIdMutation>;
export type CutsheetDescriptionLibraryRemoveByIdMutationOptions = Apollo.BaseMutationOptions<CutsheetDescriptionLibraryRemoveByIdMutation, CutsheetDescriptionLibraryRemoveByIdMutationVariables>;
export const CutsheetDescriptionLibraryUpdateByIdDocument = gql`
    mutation CutsheetDescriptionLibraryUpdateById($_id: MongoID!, $record: UpdateByIdCutsheetDescriptionLibraryInput!) {
  cutsheetDescriptionLibraryUpdateById(_id: $_id, record: $record) {
    recordId
    record {
      ...CutsheetDescriptionLibraryFragment
    }
  }
}
    ${CutsheetDescriptionLibraryFragmentFragmentDoc}`;
export type CutsheetDescriptionLibraryUpdateByIdMutationFn = Apollo.MutationFunction<CutsheetDescriptionLibraryUpdateByIdMutation, CutsheetDescriptionLibraryUpdateByIdMutationVariables>;

/**
 * __useCutsheetDescriptionLibraryUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCutsheetDescriptionLibraryUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibraryUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetDescriptionLibraryUpdateByIdMutation, { data, loading, error }] = useCutsheetDescriptionLibraryUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetDescriptionLibraryUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetDescriptionLibraryUpdateByIdMutation, CutsheetDescriptionLibraryUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetDescriptionLibraryUpdateByIdMutation, CutsheetDescriptionLibraryUpdateByIdMutationVariables>(CutsheetDescriptionLibraryUpdateByIdDocument, options);
      }
export type CutsheetDescriptionLibraryUpdateByIdMutationHookResult = ReturnType<typeof useCutsheetDescriptionLibraryUpdateByIdMutation>;
export type CutsheetDescriptionLibraryUpdateByIdMutationResult = Apollo.MutationResult<CutsheetDescriptionLibraryUpdateByIdMutation>;
export type CutsheetDescriptionLibraryUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CutsheetDescriptionLibraryUpdateByIdMutation, CutsheetDescriptionLibraryUpdateByIdMutationVariables>;
export const CutsheetCapabilityExtraDeleteDocument = gql`
    mutation CutsheetCapabilityExtraDelete($id: MongoID!) {
  cutsheetExtraDelete(id: $id)
}
    `;
export type CutsheetCapabilityExtraDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityExtraDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityExtraDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityExtraDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityExtraDeleteMutation, { data, loading, error }] = useCutsheetCapabilityExtraDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityExtraDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>(CutsheetCapabilityExtraDeleteDocument, options);
      }
export type CutsheetCapabilityExtraDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityExtraDeleteMutation>;
export type CutsheetCapabilityExtraDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityExtraDeleteMutation>;
export type CutsheetCapabilityExtraDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>;
export const CutsheetCapabilityExtraUpsertDocument = gql`
    mutation CutsheetCapabilityExtraUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $description: String, $imageUrl: String, $hasCharge: Boolean, $specifications: [CutsheetExtraSpecificationInput!], $pricing: CutsheetExtraPricingInput, $isActive: Boolean, $printedText: String, $partnerCodes: [CutsheetCapabilityOptionPartnerCodeInput]) {
  cutsheetExtraUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    description: $description
    imageUrl: $imageUrl
    hasCharge: $hasCharge
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    printedText: $printedText
    partnerCodes: $partnerCodes
  ) {
    ...CutsheetCapabilityExtraFragment
  }
}
    ${CutsheetCapabilityExtraFragmentFragmentDoc}`;
export type CutsheetCapabilityExtraUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityExtraUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityExtraUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityExtraUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityExtraUpsertMutation, { data, loading, error }] = useCutsheetCapabilityExtraUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      hasCharge: // value for 'hasCharge'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *      partnerCodes: // value for 'partnerCodes'
 *   },
 * });
 */
export function useCutsheetCapabilityExtraUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>(CutsheetCapabilityExtraUpsertDocument, options);
      }
export type CutsheetCapabilityExtraUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityExtraUpsertMutation>;
export type CutsheetCapabilityExtraUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityExtraUpsertMutation>;
export type CutsheetCapabilityExtraUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>;
export const CutsheetCapabilityGroupDeleteDocument = gql`
    mutation CutsheetCapabilityGroupDelete($id: MongoID!) {
  cutsheetGroupDelete(id: $id)
}
    `;
export type CutsheetCapabilityGroupDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityGroupDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGroupDeleteMutation, { data, loading, error }] = useCutsheetCapabilityGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>(CutsheetCapabilityGroupDeleteDocument, options);
      }
export type CutsheetCapabilityGroupDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityGroupDeleteMutation>;
export type CutsheetCapabilityGroupDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityGroupDeleteMutation>;
export type CutsheetCapabilityGroupDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>;
export const CutsheetCapabilityGroupReorderDocument = gql`
    mutation CutsheetCapabilityGroupReorder($ids: [MongoID!]!) {
  cutsheetGroupReorder(ids: $ids)
}
    `;
export type CutsheetCapabilityGroupReorderMutationFn = Apollo.MutationFunction<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>;

/**
 * __useCutsheetCapabilityGroupReorderMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGroupReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGroupReorderMutation, { data, loading, error }] = useCutsheetCapabilityGroupReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupReorderMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>(CutsheetCapabilityGroupReorderDocument, options);
      }
export type CutsheetCapabilityGroupReorderMutationHookResult = ReturnType<typeof useCutsheetCapabilityGroupReorderMutation>;
export type CutsheetCapabilityGroupReorderMutationResult = Apollo.MutationResult<CutsheetCapabilityGroupReorderMutation>;
export type CutsheetCapabilityGroupReorderMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>;
export const CutsheetCapabilityGroupUpsertDocument = gql`
    mutation CutsheetCapabilityGroupUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $sortOrder: Float, $isActive: Boolean) {
  cutsheetGroupUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    sortOrder: $sortOrder
    isActive: $isActive
  ) {
    ...CutsheetCapabilityGroupFragment
  }
}
    ${CutsheetCapabilityGroupFragmentFragmentDoc}`;
export type CutsheetCapabilityGroupUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityGroupUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGroupUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGroupUpsertMutation, { data, loading, error }] = useCutsheetCapabilityGroupUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      sortOrder: // value for 'sortOrder'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>(CutsheetCapabilityGroupUpsertDocument, options);
      }
export type CutsheetCapabilityGroupUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityGroupUpsertMutation>;
export type CutsheetCapabilityGroupUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityGroupUpsertMutation>;
export type CutsheetCapabilityGroupUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>;
export const CutsheetHeaderPreviewDocument = gql`
    mutation CutsheetHeaderPreview($vendorId: MongoID!) {
  cutsheetHeaderPreview(vendorId: $vendorId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type CutsheetHeaderPreviewMutationFn = Apollo.MutationFunction<CutsheetHeaderPreviewMutation, CutsheetHeaderPreviewMutationVariables>;

/**
 * __useCutsheetHeaderPreviewMutation__
 *
 * To run a mutation, you first call `useCutsheetHeaderPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetHeaderPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetHeaderPreviewMutation, { data, loading, error }] = useCutsheetHeaderPreviewMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCutsheetHeaderPreviewMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetHeaderPreviewMutation, CutsheetHeaderPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetHeaderPreviewMutation, CutsheetHeaderPreviewMutationVariables>(CutsheetHeaderPreviewDocument, options);
      }
export type CutsheetHeaderPreviewMutationHookResult = ReturnType<typeof useCutsheetHeaderPreviewMutation>;
export type CutsheetHeaderPreviewMutationResult = Apollo.MutationResult<CutsheetHeaderPreviewMutation>;
export type CutsheetHeaderPreviewMutationOptions = Apollo.BaseMutationOptions<CutsheetHeaderPreviewMutation, CutsheetHeaderPreviewMutationVariables>;
export const CutsheetImageLibraryCreateOneDocument = gql`
    mutation CutsheetImageLibraryCreateOne($record: CreateOneCutsheetImageLibraryInput!) {
  cutsheetImageLibraryCreateOne(record: $record) {
    recordId
    record {
      ...CutsheetImageLibraryFragment
    }
  }
}
    ${CutsheetImageLibraryFragmentFragmentDoc}`;
export type CutsheetImageLibraryCreateOneMutationFn = Apollo.MutationFunction<CutsheetImageLibraryCreateOneMutation, CutsheetImageLibraryCreateOneMutationVariables>;

/**
 * __useCutsheetImageLibraryCreateOneMutation__
 *
 * To run a mutation, you first call `useCutsheetImageLibraryCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibraryCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetImageLibraryCreateOneMutation, { data, loading, error }] = useCutsheetImageLibraryCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetImageLibraryCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetImageLibraryCreateOneMutation, CutsheetImageLibraryCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetImageLibraryCreateOneMutation, CutsheetImageLibraryCreateOneMutationVariables>(CutsheetImageLibraryCreateOneDocument, options);
      }
export type CutsheetImageLibraryCreateOneMutationHookResult = ReturnType<typeof useCutsheetImageLibraryCreateOneMutation>;
export type CutsheetImageLibraryCreateOneMutationResult = Apollo.MutationResult<CutsheetImageLibraryCreateOneMutation>;
export type CutsheetImageLibraryCreateOneMutationOptions = Apollo.BaseMutationOptions<CutsheetImageLibraryCreateOneMutation, CutsheetImageLibraryCreateOneMutationVariables>;
export const CutsheetImageLibraryRemoveByIdDocument = gql`
    mutation CutsheetImageLibraryRemoveById($_id: MongoID!) {
  cutsheetImageLibraryRemoveById(_id: $_id) {
    recordId
  }
}
    `;
export type CutsheetImageLibraryRemoveByIdMutationFn = Apollo.MutationFunction<CutsheetImageLibraryRemoveByIdMutation, CutsheetImageLibraryRemoveByIdMutationVariables>;

/**
 * __useCutsheetImageLibraryRemoveByIdMutation__
 *
 * To run a mutation, you first call `useCutsheetImageLibraryRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibraryRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetImageLibraryRemoveByIdMutation, { data, loading, error }] = useCutsheetImageLibraryRemoveByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useCutsheetImageLibraryRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetImageLibraryRemoveByIdMutation, CutsheetImageLibraryRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetImageLibraryRemoveByIdMutation, CutsheetImageLibraryRemoveByIdMutationVariables>(CutsheetImageLibraryRemoveByIdDocument, options);
      }
export type CutsheetImageLibraryRemoveByIdMutationHookResult = ReturnType<typeof useCutsheetImageLibraryRemoveByIdMutation>;
export type CutsheetImageLibraryRemoveByIdMutationResult = Apollo.MutationResult<CutsheetImageLibraryRemoveByIdMutation>;
export type CutsheetImageLibraryRemoveByIdMutationOptions = Apollo.BaseMutationOptions<CutsheetImageLibraryRemoveByIdMutation, CutsheetImageLibraryRemoveByIdMutationVariables>;
export const CutsheetImageLibraryUpdateByIdDocument = gql`
    mutation CutsheetImageLibraryUpdateById($_id: MongoID!, $record: UpdateByIdCutsheetImageLibraryInput!) {
  cutsheetImageLibraryUpdateById(_id: $_id, record: $record) {
    recordId
    record {
      ...CutsheetImageLibraryFragment
    }
  }
}
    ${CutsheetImageLibraryFragmentFragmentDoc}`;
export type CutsheetImageLibraryUpdateByIdMutationFn = Apollo.MutationFunction<CutsheetImageLibraryUpdateByIdMutation, CutsheetImageLibraryUpdateByIdMutationVariables>;

/**
 * __useCutsheetImageLibraryUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCutsheetImageLibraryUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibraryUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetImageLibraryUpdateByIdMutation, { data, loading, error }] = useCutsheetImageLibraryUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetImageLibraryUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetImageLibraryUpdateByIdMutation, CutsheetImageLibraryUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetImageLibraryUpdateByIdMutation, CutsheetImageLibraryUpdateByIdMutationVariables>(CutsheetImageLibraryUpdateByIdDocument, options);
      }
export type CutsheetImageLibraryUpdateByIdMutationHookResult = ReturnType<typeof useCutsheetImageLibraryUpdateByIdMutation>;
export type CutsheetImageLibraryUpdateByIdMutationResult = Apollo.MutationResult<CutsheetImageLibraryUpdateByIdMutation>;
export type CutsheetImageLibraryUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CutsheetImageLibraryUpdateByIdMutation, CutsheetImageLibraryUpdateByIdMutationVariables>;
export const CutsheetMarkConvertedDocument = gql`
    mutation CutsheetMarkConverted($cutsheetId: MongoID!, $responseId: MongoID!) {
  cutsheetMarkConverted(cutsheetId: $cutsheetId, responseId: $responseId) {
    _id
    convertedToQuestionnaireResponse
  }
}
    `;
export type CutsheetMarkConvertedMutationFn = Apollo.MutationFunction<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>;

/**
 * __useCutsheetMarkConvertedMutation__
 *
 * To run a mutation, you first call `useCutsheetMarkConvertedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetMarkConvertedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetMarkConvertedMutation, { data, loading, error }] = useCutsheetMarkConvertedMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useCutsheetMarkConvertedMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>(CutsheetMarkConvertedDocument, options);
      }
export type CutsheetMarkConvertedMutationHookResult = ReturnType<typeof useCutsheetMarkConvertedMutation>;
export type CutsheetMarkConvertedMutationResult = Apollo.MutationResult<CutsheetMarkConvertedMutation>;
export type CutsheetMarkConvertedMutationOptions = Apollo.BaseMutationOptions<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>;
export const CutsheetCapabilityOptionReorderDocument = gql`
    mutation CutsheetCapabilityOptionReorder($ids: [MongoID!]!) {
  cutsheetOptionReorder(ids: $ids)
}
    `;
export type CutsheetCapabilityOptionReorderMutationFn = Apollo.MutationFunction<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>;

/**
 * __useCutsheetCapabilityOptionReorderMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityOptionReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityOptionReorderMutation, { data, loading, error }] = useCutsheetCapabilityOptionReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionReorderMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>(CutsheetCapabilityOptionReorderDocument, options);
      }
export type CutsheetCapabilityOptionReorderMutationHookResult = ReturnType<typeof useCutsheetCapabilityOptionReorderMutation>;
export type CutsheetCapabilityOptionReorderMutationResult = Apollo.MutationResult<CutsheetCapabilityOptionReorderMutation>;
export type CutsheetCapabilityOptionReorderMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>;
export const CutsheetQuestionnaireChatDocument = gql`
    mutation CutsheetQuestionnaireChat($capabilityId: MongoID!, $questions: JSON!, $messages: [CutsheetCatalogChatMessageInput!]!, $autoApprove: Boolean) {
  cutsheetQuestionnaireChat(
    capabilityId: $capabilityId
    questions: $questions
    messages: $messages
    autoApprove: $autoApprove
  ) {
    message
    changed
    actions {
      kind
      label
      itemType
      itemId
    }
    questions
    proposedChanges {
      id
      tool
      args
      kind
      itemType
      label
    }
  }
}
    `;
export type CutsheetQuestionnaireChatMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireChatMutation, CutsheetQuestionnaireChatMutationVariables>;

/**
 * __useCutsheetQuestionnaireChatMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireChatMutation, { data, loading, error }] = useCutsheetQuestionnaireChatMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      questions: // value for 'questions'
 *      messages: // value for 'messages'
 *      autoApprove: // value for 'autoApprove'
 *   },
 * });
 */
export function useCutsheetQuestionnaireChatMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireChatMutation, CutsheetQuestionnaireChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireChatMutation, CutsheetQuestionnaireChatMutationVariables>(CutsheetQuestionnaireChatDocument, options);
      }
export type CutsheetQuestionnaireChatMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireChatMutation>;
export type CutsheetQuestionnaireChatMutationResult = Apollo.MutationResult<CutsheetQuestionnaireChatMutation>;
export type CutsheetQuestionnaireChatMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireChatMutation, CutsheetQuestionnaireChatMutationVariables>;
export const CutsheetQuestionnaireDeleteDocument = gql`
    mutation CutsheetQuestionnaireDelete($id: MongoID!) {
  cutsheetQuestionnaireDelete(id: $id)
}
    `;
export type CutsheetQuestionnaireDeleteMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>;

/**
 * __useCutsheetQuestionnaireDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireDeleteMutation, { data, loading, error }] = useCutsheetQuestionnaireDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>(CutsheetQuestionnaireDeleteDocument, options);
      }
export type CutsheetQuestionnaireDeleteMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireDeleteMutation>;
export type CutsheetQuestionnaireDeleteMutationResult = Apollo.MutationResult<CutsheetQuestionnaireDeleteMutation>;
export type CutsheetQuestionnaireDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>;
export const CutsheetQuestionnaireResponseAttachSourceDocument = gql`
    mutation CutsheetQuestionnaireResponseAttachSource($id: MongoID!, $pages: [CutsheetResponseSourcePageInput!]!, $annotations: [CutsheetResponseSourceAnnotationInput!]) {
  cutsheetQuestionnaireResponseAttachSource(
    id: $id
    pages: $pages
    annotations: $annotations
  ) {
    _id
  }
}
    `;
export type CutsheetQuestionnaireResponseAttachSourceMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseAttachSourceMutation, CutsheetQuestionnaireResponseAttachSourceMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseAttachSourceMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseAttachSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseAttachSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseAttachSourceMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseAttachSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pages: // value for 'pages'
 *      annotations: // value for 'annotations'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseAttachSourceMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseAttachSourceMutation, CutsheetQuestionnaireResponseAttachSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseAttachSourceMutation, CutsheetQuestionnaireResponseAttachSourceMutationVariables>(CutsheetQuestionnaireResponseAttachSourceDocument, options);
      }
export type CutsheetQuestionnaireResponseAttachSourceMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseAttachSourceMutation>;
export type CutsheetQuestionnaireResponseAttachSourceMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseAttachSourceMutation>;
export type CutsheetQuestionnaireResponseAttachSourceMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseAttachSourceMutation, CutsheetQuestionnaireResponseAttachSourceMutationVariables>;
export const CutsheetQuestionnaireResponseGeneratePdfDocument = gql`
    mutation CutsheetQuestionnaireResponseGeneratePdf($id: MongoID!) {
  cutsheetQuestionnaireResponseGeneratePdf(id: $id) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type CutsheetQuestionnaireResponseGeneratePdfMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseGeneratePdfMutation, CutsheetQuestionnaireResponseGeneratePdfMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseGeneratePdfMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseGeneratePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseGeneratePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseGeneratePdfMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseGeneratePdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseGeneratePdfMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseGeneratePdfMutation, CutsheetQuestionnaireResponseGeneratePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseGeneratePdfMutation, CutsheetQuestionnaireResponseGeneratePdfMutationVariables>(CutsheetQuestionnaireResponseGeneratePdfDocument, options);
      }
export type CutsheetQuestionnaireResponseGeneratePdfMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseGeneratePdfMutation>;
export type CutsheetQuestionnaireResponseGeneratePdfMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseGeneratePdfMutation>;
export type CutsheetQuestionnaireResponseGeneratePdfMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseGeneratePdfMutation, CutsheetQuestionnaireResponseGeneratePdfMutationVariables>;
export const CutsheetQuestionnaireResponseReassignDocument = gql`
    mutation CutsheetQuestionnaireResponseReassign($id: MongoID!, $userId: MongoID, $type: String) {
  cutsheetQuestionnaireResponseReassign(id: $id, userId: $userId, type: $type) {
    _id
    type
    user
  }
}
    `;
export type CutsheetQuestionnaireResponseReassignMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseReassignMutation, CutsheetQuestionnaireResponseReassignMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseReassignMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseReassignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseReassignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseReassignMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseReassignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseReassignMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseReassignMutation, CutsheetQuestionnaireResponseReassignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseReassignMutation, CutsheetQuestionnaireResponseReassignMutationVariables>(CutsheetQuestionnaireResponseReassignDocument, options);
      }
export type CutsheetQuestionnaireResponseReassignMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseReassignMutation>;
export type CutsheetQuestionnaireResponseReassignMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseReassignMutation>;
export type CutsheetQuestionnaireResponseReassignMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseReassignMutation, CutsheetQuestionnaireResponseReassignMutationVariables>;
export const CutsheetQuestionnaireResponseRestoreDocument = gql`
    mutation CutsheetQuestionnaireResponseRestore($id: MongoID!) {
  cutsheetQuestionnaireResponseRestore(id: $id)
}
    `;
export type CutsheetQuestionnaireResponseRestoreMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseRestoreMutation, CutsheetQuestionnaireResponseRestoreMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseRestoreMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseRestoreMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseRestoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseRestoreMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseRestoreMutation, CutsheetQuestionnaireResponseRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseRestoreMutation, CutsheetQuestionnaireResponseRestoreMutationVariables>(CutsheetQuestionnaireResponseRestoreDocument, options);
      }
export type CutsheetQuestionnaireResponseRestoreMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseRestoreMutation>;
export type CutsheetQuestionnaireResponseRestoreMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseRestoreMutation>;
export type CutsheetQuestionnaireResponseRestoreMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseRestoreMutation, CutsheetQuestionnaireResponseRestoreMutationVariables>;
export const CutsheetQuestionnaireResponseSoftDeleteDocument = gql`
    mutation CutsheetQuestionnaireResponseSoftDelete($id: MongoID!) {
  cutsheetQuestionnaireResponseSoftDelete(id: $id)
}
    `;
export type CutsheetQuestionnaireResponseSoftDeleteMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseSoftDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseSoftDeleteMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseSoftDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>(CutsheetQuestionnaireResponseSoftDeleteDocument, options);
      }
export type CutsheetQuestionnaireResponseSoftDeleteMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseSoftDeleteMutation>;
export type CutsheetQuestionnaireResponseSoftDeleteMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseSoftDeleteMutation>;
export type CutsheetQuestionnaireResponseSoftDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>;
export const CutsheetQuestionnaireResponseUpsertDocument = gql`
    mutation CutsheetQuestionnaireResponseUpsert($id: MongoID, $questionnaireId: MongoID!, $name: String!, $pricePerPound: Float, $type: String, $userId: MongoID, $selectedCuts: [CutsheetResponseCutOptionInput], $trimSelections: CutsheetResponseTrimResponseInput, $specifications: [CutsheetResponseSpecificationSelectionInput], $notes: String, $primalNotes: [CutsheetResponseNoteEntryInput], $trimSectionNotes: String, $timeToComplete: Int) {
  cutsheetQuestionnaireResponseUpsert(
    id: $id
    questionnaireId: $questionnaireId
    name: $name
    pricePerPound: $pricePerPound
    type: $type
    userId: $userId
    selectedCuts: $selectedCuts
    trimSelections: $trimSelections
    specifications: $specifications
    notes: $notes
    primalNotes: $primalNotes
    trimSectionNotes: $trimSectionNotes
    timeToComplete: $timeToComplete
  ) {
    _id
    name
    questionnaire
    capabilitySet
    type
    pricePerPound
    notes
    createdAt
    updatedAt
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
    primalNotes {
      id
      note
    }
    trimSectionNotes
  }
}
    `;
export type CutsheetQuestionnaireResponseUpsertMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseUpsertMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionnaireId: // value for 'questionnaireId'
 *      name: // value for 'name'
 *      pricePerPound: // value for 'pricePerPound'
 *      type: // value for 'type'
 *      userId: // value for 'userId'
 *      selectedCuts: // value for 'selectedCuts'
 *      trimSelections: // value for 'trimSelections'
 *      specifications: // value for 'specifications'
 *      notes: // value for 'notes'
 *      primalNotes: // value for 'primalNotes'
 *      trimSectionNotes: // value for 'trimSectionNotes'
 *      timeToComplete: // value for 'timeToComplete'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>(CutsheetQuestionnaireResponseUpsertDocument, options);
      }
export type CutsheetQuestionnaireResponseUpsertMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseUpsertMutation>;
export type CutsheetQuestionnaireResponseUpsertMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseUpsertMutation>;
export type CutsheetQuestionnaireResponseUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>;
export const CutsheetQuestionnaireRestoreDocument = gql`
    mutation CutsheetQuestionnaireRestore($id: MongoID!, $status: String!) {
  cutsheetQuestionnaireRestore(id: $id, status: $status)
}
    `;
export type CutsheetQuestionnaireRestoreMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireRestoreMutation, CutsheetQuestionnaireRestoreMutationVariables>;

/**
 * __useCutsheetQuestionnaireRestoreMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireRestoreMutation, { data, loading, error }] = useCutsheetQuestionnaireRestoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCutsheetQuestionnaireRestoreMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireRestoreMutation, CutsheetQuestionnaireRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireRestoreMutation, CutsheetQuestionnaireRestoreMutationVariables>(CutsheetQuestionnaireRestoreDocument, options);
      }
export type CutsheetQuestionnaireRestoreMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireRestoreMutation>;
export type CutsheetQuestionnaireRestoreMutationResult = Apollo.MutationResult<CutsheetQuestionnaireRestoreMutation>;
export type CutsheetQuestionnaireRestoreMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireRestoreMutation, CutsheetQuestionnaireRestoreMutationVariables>;
export const CutsheetQuestionnaireUpsertDocument = gql`
    mutation CutsheetQuestionnaireUpsert($id: MongoID, $capabilityId: MongoID!, $name: String!, $description: String, $questions: [CutsheetQuestionInput!], $pricingOverrides: [CutsheetPricingOverrideEntryInput], $specOptionPricingOverrides: [CutsheetSpecOptionPricingEntryInput], $processingFee: CutsheetQuestionnaireFeeInput, $killFee: CutsheetQuestionnaireFeeInput, $additionalCharges: [CutsheetQuestionnaireAdditionalChargeInput], $defaultSelections: CutsheetQuestionnaireDefaultSelectionsInput, $useCustomPrintSettings: Boolean, $printSettings: CutsheetQuestionnairePrintSettingsOverrideInput, $status: String) {
  cutsheetQuestionnaireUpsert(
    id: $id
    capabilityId: $capabilityId
    name: $name
    description: $description
    questions: $questions
    pricingOverrides: $pricingOverrides
    specOptionPricingOverrides: $specOptionPricingOverrides
    processingFee: $processingFee
    killFee: $killFee
    additionalCharges: $additionalCharges
    defaultSelections: $defaultSelections
    useCustomPrintSettings: $useCustomPrintSettings
    printSettings: $printSettings
    status: $status
  ) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;
export type CutsheetQuestionnaireUpsertMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>;

/**
 * __useCutsheetQuestionnaireUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireUpsertMutation, { data, loading, error }] = useCutsheetQuestionnaireUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      capabilityId: // value for 'capabilityId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      questions: // value for 'questions'
 *      pricingOverrides: // value for 'pricingOverrides'
 *      specOptionPricingOverrides: // value for 'specOptionPricingOverrides'
 *      processingFee: // value for 'processingFee'
 *      killFee: // value for 'killFee'
 *      additionalCharges: // value for 'additionalCharges'
 *      defaultSelections: // value for 'defaultSelections'
 *      useCustomPrintSettings: // value for 'useCustomPrintSettings'
 *      printSettings: // value for 'printSettings'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCutsheetQuestionnaireUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>(CutsheetQuestionnaireUpsertDocument, options);
      }
export type CutsheetQuestionnaireUpsertMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireUpsertMutation>;
export type CutsheetQuestionnaireUpsertMutationResult = Apollo.MutationResult<CutsheetQuestionnaireUpsertMutation>;
export type CutsheetQuestionnaireUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>;
export const CutsheetRestoreDocument = gql`
    mutation CutsheetRestore($cutsheetId: MongoID!) {
  cutsheetRestore(cutsheetId: $cutsheetId) {
    _id
  }
}
    `;
export type CutsheetRestoreMutationFn = Apollo.MutationFunction<CutsheetRestoreMutation, CutsheetRestoreMutationVariables>;

/**
 * __useCutsheetRestoreMutation__
 *
 * To run a mutation, you first call `useCutsheetRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetRestoreMutation, { data, loading, error }] = useCutsheetRestoreMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *   },
 * });
 */
export function useCutsheetRestoreMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetRestoreMutation, CutsheetRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetRestoreMutation, CutsheetRestoreMutationVariables>(CutsheetRestoreDocument, options);
      }
export type CutsheetRestoreMutationHookResult = ReturnType<typeof useCutsheetRestoreMutation>;
export type CutsheetRestoreMutationResult = Apollo.MutationResult<CutsheetRestoreMutation>;
export type CutsheetRestoreMutationOptions = Apollo.BaseMutationOptions<CutsheetRestoreMutation, CutsheetRestoreMutationVariables>;
export const CutsheetSoftDeleteDocument = gql`
    mutation cutsheetSoftDelete($cutsheetId: MongoID!) {
  cutsheetSoftDelete(cutsheetId: $cutsheetId) {
    _id
  }
}
    `;
export type CutsheetSoftDeleteMutationFn = Apollo.MutationFunction<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>;

/**
 * __useCutsheetSoftDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetSoftDeleteMutation, { data, loading, error }] = useCutsheetSoftDeleteMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *   },
 * });
 */
export function useCutsheetSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>(CutsheetSoftDeleteDocument, options);
      }
export type CutsheetSoftDeleteMutationHookResult = ReturnType<typeof useCutsheetSoftDeleteMutation>;
export type CutsheetSoftDeleteMutationResult = Apollo.MutationResult<CutsheetSoftDeleteMutation>;
export type CutsheetSoftDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>;
export const CutsheetCapabilitySpecificationDeleteDocument = gql`
    mutation CutsheetCapabilitySpecificationDelete($id: MongoID!) {
  cutsheetSpecificationDelete(id: $id)
}
    `;
export type CutsheetCapabilitySpecificationDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>;

/**
 * __useCutsheetCapabilitySpecificationDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySpecificationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySpecificationDeleteMutation, { data, loading, error }] = useCutsheetCapabilitySpecificationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>(CutsheetCapabilitySpecificationDeleteDocument, options);
      }
export type CutsheetCapabilitySpecificationDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationDeleteMutation>;
export type CutsheetCapabilitySpecificationDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilitySpecificationDeleteMutation>;
export type CutsheetCapabilitySpecificationDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>;
export const CutsheetCapabilitySpecificationReorderDocument = gql`
    mutation CutsheetCapabilitySpecificationReorder($ids: [MongoID!]!) {
  cutsheetSpecificationReorder(ids: $ids)
}
    `;
export type CutsheetCapabilitySpecificationReorderMutationFn = Apollo.MutationFunction<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>;

/**
 * __useCutsheetCapabilitySpecificationReorderMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySpecificationReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySpecificationReorderMutation, { data, loading, error }] = useCutsheetCapabilitySpecificationReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationReorderMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>(CutsheetCapabilitySpecificationReorderDocument, options);
      }
export type CutsheetCapabilitySpecificationReorderMutationHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationReorderMutation>;
export type CutsheetCapabilitySpecificationReorderMutationResult = Apollo.MutationResult<CutsheetCapabilitySpecificationReorderMutation>;
export type CutsheetCapabilitySpecificationReorderMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>;
export const CutsheetCapabilitySpecificationUpsertDocument = gql`
    mutation CutsheetCapabilitySpecificationUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $description: String, $imageUrl: String, $inputType: String!, $options: JSON, $unit: String, $defaultValue: String, $required: Boolean, $assignedToIds: [MongoID!], $pricingAdjustments: JSON, $isActive: Boolean, $printedText: String) {
  cutsheetSpecificationUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    description: $description
    imageUrl: $imageUrl
    inputType: $inputType
    options: $options
    unit: $unit
    defaultValue: $defaultValue
    required: $required
    assignedToIds: $assignedToIds
    pricingAdjustments: $pricingAdjustments
    isActive: $isActive
    printedText: $printedText
  ) {
    ...CutsheetCapabilitySpecificationFragment
  }
}
    ${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;
export type CutsheetCapabilitySpecificationUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>;

/**
 * __useCutsheetCapabilitySpecificationUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySpecificationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySpecificationUpsertMutation, { data, loading, error }] = useCutsheetCapabilitySpecificationUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      inputType: // value for 'inputType'
 *      options: // value for 'options'
 *      unit: // value for 'unit'
 *      defaultValue: // value for 'defaultValue'
 *      required: // value for 'required'
 *      assignedToIds: // value for 'assignedToIds'
 *      pricingAdjustments: // value for 'pricingAdjustments'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>(CutsheetCapabilitySpecificationUpsertDocument, options);
      }
export type CutsheetCapabilitySpecificationUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationUpsertMutation>;
export type CutsheetCapabilitySpecificationUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilitySpecificationUpsertMutation>;
export type CutsheetCapabilitySpecificationUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>;
export const CutsheetCapabilityTrimDeleteDocument = gql`
    mutation CutsheetCapabilityTrimDelete($id: MongoID!) {
  cutsheetTrimDelete(id: $id)
}
    `;
export type CutsheetCapabilityTrimDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityTrimDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityTrimDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityTrimDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityTrimDeleteMutation, { data, loading, error }] = useCutsheetCapabilityTrimDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityTrimDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>(CutsheetCapabilityTrimDeleteDocument, options);
      }
export type CutsheetCapabilityTrimDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityTrimDeleteMutation>;
export type CutsheetCapabilityTrimDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityTrimDeleteMutation>;
export type CutsheetCapabilityTrimDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>;
export const CutsheetCapabilityTrimUpsertDocument = gql`
    mutation CutsheetCapabilityTrimUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $description: String, $imageUrl: String, $isDefault: Boolean, $minQty: Float, $specifications: [CutsheetTrimSpecificationInput!], $pricing: CutsheetTrimPricingInput, $isActive: Boolean, $printedText: String, $partnerCodes: [CutsheetCapabilityOptionPartnerCodeInput]) {
  cutsheetTrimUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    description: $description
    imageUrl: $imageUrl
    isDefault: $isDefault
    minQty: $minQty
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    printedText: $printedText
    partnerCodes: $partnerCodes
  ) {
    ...CutsheetCapabilityTrimFragmentV2
  }
}
    ${CutsheetCapabilityTrimFragmentV2FragmentDoc}`;
export type CutsheetCapabilityTrimUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityTrimUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityTrimUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityTrimUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityTrimUpsertMutation, { data, loading, error }] = useCutsheetCapabilityTrimUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      isDefault: // value for 'isDefault'
 *      minQty: // value for 'minQty'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *      partnerCodes: // value for 'partnerCodes'
 *   },
 * });
 */
export function useCutsheetCapabilityTrimUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>(CutsheetCapabilityTrimUpsertDocument, options);
      }
export type CutsheetCapabilityTrimUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityTrimUpsertMutation>;
export type CutsheetCapabilityTrimUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityTrimUpsertMutation>;
export type CutsheetCapabilityTrimUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>;
export const CutsheetUpsertDocument = gql`
    mutation CutsheetUpsert($parentCutsheet: MongoID, $cutsheetId: MongoID, $type: EnumCutsheetType, $animalSpecies: EnumCutsheetAnimalSpecies, $inspectionLevels: [EnumCutsheetInspectionLevels], $primalCuts: [MongoID!], $splitTypes: [String!], $name: String!, $pricePerPound: Float, $activeSpecification: MongoID, $selectedSpecifications: JSON, $extras: [CutsheetExtrasTypeInput!], $trim: [CutsheetTrimTypeInput!], $userId: MongoID) {
  cutsheetUpsert(
    parentCutsheet: $parentCutsheet
    cutsheetId: $cutsheetId
    type: $type
    animalSpecies: $animalSpecies
    inspectionLevels: $inspectionLevels
    primalCuts: $primalCuts
    splitTypes: $splitTypes
    name: $name
    pricePerPound: $pricePerPound
    activeSpecification: $activeSpecification
    selectedSpecifications: $selectedSpecifications
    extras: $extras
    trim: $trim
    userId: $userId
  ) {
    ...CutsheetFragment
  }
}
    ${CutsheetFragmentFragmentDoc}`;
export type CutsheetUpsertMutationFn = Apollo.MutationFunction<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>;

/**
 * __useCutsheetUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetUpsertMutation, { data, loading, error }] = useCutsheetUpsertMutation({
 *   variables: {
 *      parentCutsheet: // value for 'parentCutsheet'
 *      cutsheetId: // value for 'cutsheetId'
 *      type: // value for 'type'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevels: // value for 'inspectionLevels'
 *      primalCuts: // value for 'primalCuts'
 *      splitTypes: // value for 'splitTypes'
 *      name: // value for 'name'
 *      pricePerPound: // value for 'pricePerPound'
 *      activeSpecification: // value for 'activeSpecification'
 *      selectedSpecifications: // value for 'selectedSpecifications'
 *      extras: // value for 'extras'
 *      trim: // value for 'trim'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCutsheetUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>(CutsheetUpsertDocument, options);
      }
export type CutsheetUpsertMutationHookResult = ReturnType<typeof useCutsheetUpsertMutation>;
export type CutsheetUpsertMutationResult = Apollo.MutationResult<CutsheetUpsertMutation>;
export type CutsheetUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>;
export const DataImportCancelJobDocument = gql`
    mutation DataImportCancelJob($jobId: String!, $stage: String!) {
  dataImportCancelJob(jobId: $jobId, stage: $stage) {
    jobId
    status
    cancelledAt
    cancelledAtStage
    message
  }
}
    `;
export type DataImportCancelJobMutationFn = Apollo.MutationFunction<DataImportCancelJobMutation, DataImportCancelJobMutationVariables>;

/**
 * __useDataImportCancelJobMutation__
 *
 * To run a mutation, you first call `useDataImportCancelJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportCancelJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportCancelJobMutation, { data, loading, error }] = useDataImportCancelJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useDataImportCancelJobMutation(baseOptions?: Apollo.MutationHookOptions<DataImportCancelJobMutation, DataImportCancelJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportCancelJobMutation, DataImportCancelJobMutationVariables>(DataImportCancelJobDocument, options);
      }
export type DataImportCancelJobMutationHookResult = ReturnType<typeof useDataImportCancelJobMutation>;
export type DataImportCancelJobMutationResult = Apollo.MutationResult<DataImportCancelJobMutation>;
export type DataImportCancelJobMutationOptions = Apollo.BaseMutationOptions<DataImportCancelJobMutation, DataImportCancelJobMutationVariables>;
export const DataImportClearMatchDecisionDocument = gql`
    mutation DataImportClearMatchDecision($jobId: String!, $rowNumber: Int!, $side: String!) {
  dataImportClearMatchDecision(jobId: $jobId, rowNumber: $rowNumber, side: $side) {
    jobId
    rowNumber
    side
    clearedRowCount
  }
}
    `;
export type DataImportClearMatchDecisionMutationFn = Apollo.MutationFunction<DataImportClearMatchDecisionMutation, DataImportClearMatchDecisionMutationVariables>;

/**
 * __useDataImportClearMatchDecisionMutation__
 *
 * To run a mutation, you first call `useDataImportClearMatchDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportClearMatchDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportClearMatchDecisionMutation, { data, loading, error }] = useDataImportClearMatchDecisionMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      rowNumber: // value for 'rowNumber'
 *      side: // value for 'side'
 *   },
 * });
 */
export function useDataImportClearMatchDecisionMutation(baseOptions?: Apollo.MutationHookOptions<DataImportClearMatchDecisionMutation, DataImportClearMatchDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportClearMatchDecisionMutation, DataImportClearMatchDecisionMutationVariables>(DataImportClearMatchDecisionDocument, options);
      }
export type DataImportClearMatchDecisionMutationHookResult = ReturnType<typeof useDataImportClearMatchDecisionMutation>;
export type DataImportClearMatchDecisionMutationResult = Apollo.MutationResult<DataImportClearMatchDecisionMutation>;
export type DataImportClearMatchDecisionMutationOptions = Apollo.BaseMutationOptions<DataImportClearMatchDecisionMutation, DataImportClearMatchDecisionMutationVariables>;
export const DataImportDeleteRecordDocument = gql`
    mutation dataImportDeleteRecord($jobId: String!, $rowNumber: Int!) {
  dataImportDeleteRecord(jobId: $jobId, rowNumber: $rowNumber) {
    jobId
    deletedRows
    validRows
  }
}
    `;
export type DataImportDeleteRecordMutationFn = Apollo.MutationFunction<DataImportDeleteRecordMutation, DataImportDeleteRecordMutationVariables>;

/**
 * __useDataImportDeleteRecordMutation__
 *
 * To run a mutation, you first call `useDataImportDeleteRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportDeleteRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportDeleteRecordMutation, { data, loading, error }] = useDataImportDeleteRecordMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      rowNumber: // value for 'rowNumber'
 *   },
 * });
 */
export function useDataImportDeleteRecordMutation(baseOptions?: Apollo.MutationHookOptions<DataImportDeleteRecordMutation, DataImportDeleteRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportDeleteRecordMutation, DataImportDeleteRecordMutationVariables>(DataImportDeleteRecordDocument, options);
      }
export type DataImportDeleteRecordMutationHookResult = ReturnType<typeof useDataImportDeleteRecordMutation>;
export type DataImportDeleteRecordMutationResult = Apollo.MutationResult<DataImportDeleteRecordMutation>;
export type DataImportDeleteRecordMutationOptions = Apollo.BaseMutationOptions<DataImportDeleteRecordMutation, DataImportDeleteRecordMutationVariables>;
export const DataImportEnableAnimalSpeciesDocument = gql`
    mutation DataImportEnableAnimalSpecies($jobId: String!, $species: String!, $addInspectionLevel: String) {
  dataImportEnableAnimalSpecies(
    jobId: $jobId
    species: $species
    addInspectionLevel: $addInspectionLevel
  ) {
    jobId
    species
    malformedJobCount
  }
}
    `;
export type DataImportEnableAnimalSpeciesMutationFn = Apollo.MutationFunction<DataImportEnableAnimalSpeciesMutation, DataImportEnableAnimalSpeciesMutationVariables>;

/**
 * __useDataImportEnableAnimalSpeciesMutation__
 *
 * To run a mutation, you first call `useDataImportEnableAnimalSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportEnableAnimalSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportEnableAnimalSpeciesMutation, { data, loading, error }] = useDataImportEnableAnimalSpeciesMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      species: // value for 'species'
 *      addInspectionLevel: // value for 'addInspectionLevel'
 *   },
 * });
 */
export function useDataImportEnableAnimalSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<DataImportEnableAnimalSpeciesMutation, DataImportEnableAnimalSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportEnableAnimalSpeciesMutation, DataImportEnableAnimalSpeciesMutationVariables>(DataImportEnableAnimalSpeciesDocument, options);
      }
export type DataImportEnableAnimalSpeciesMutationHookResult = ReturnType<typeof useDataImportEnableAnimalSpeciesMutation>;
export type DataImportEnableAnimalSpeciesMutationResult = Apollo.MutationResult<DataImportEnableAnimalSpeciesMutation>;
export type DataImportEnableAnimalSpeciesMutationOptions = Apollo.BaseMutationOptions<DataImportEnableAnimalSpeciesMutation, DataImportEnableAnimalSpeciesMutationVariables>;
export const DataImportExecuteDocument = gql`
    mutation DataImportExecute($jobId: String!, $excludedRowNumbers: [Int!], $skippedWarningRowNumbers: [Int!]) {
  dataImportExecute(
    jobId: $jobId
    excludedRowNumbers: $excludedRowNumbers
    skippedWarningRowNumbers: $skippedWarningRowNumbers
  ) {
    jobId
    status
    message
  }
}
    `;
export type DataImportExecuteMutationFn = Apollo.MutationFunction<DataImportExecuteMutation, DataImportExecuteMutationVariables>;

/**
 * __useDataImportExecuteMutation__
 *
 * To run a mutation, you first call `useDataImportExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportExecuteMutation, { data, loading, error }] = useDataImportExecuteMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      excludedRowNumbers: // value for 'excludedRowNumbers'
 *      skippedWarningRowNumbers: // value for 'skippedWarningRowNumbers'
 *   },
 * });
 */
export function useDataImportExecuteMutation(baseOptions?: Apollo.MutationHookOptions<DataImportExecuteMutation, DataImportExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportExecuteMutation, DataImportExecuteMutationVariables>(DataImportExecuteDocument, options);
      }
export type DataImportExecuteMutationHookResult = ReturnType<typeof useDataImportExecuteMutation>;
export type DataImportExecuteMutationResult = Apollo.MutationResult<DataImportExecuteMutation>;
export type DataImportExecuteMutationOptions = Apollo.BaseMutationOptions<DataImportExecuteMutation, DataImportExecuteMutationVariables>;
export const DataImportFinalizeHygieneDocument = gql`
    mutation DataImportFinalizeHygiene($jobId: String!) {
  dataImportFinalizeHygiene(jobId: $jobId) {
    jobId
    status
    matchedSideCount
    skippedSideCount
  }
}
    `;
export type DataImportFinalizeHygieneMutationFn = Apollo.MutationFunction<DataImportFinalizeHygieneMutation, DataImportFinalizeHygieneMutationVariables>;

/**
 * __useDataImportFinalizeHygieneMutation__
 *
 * To run a mutation, you first call `useDataImportFinalizeHygieneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportFinalizeHygieneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportFinalizeHygieneMutation, { data, loading, error }] = useDataImportFinalizeHygieneMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportFinalizeHygieneMutation(baseOptions?: Apollo.MutationHookOptions<DataImportFinalizeHygieneMutation, DataImportFinalizeHygieneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportFinalizeHygieneMutation, DataImportFinalizeHygieneMutationVariables>(DataImportFinalizeHygieneDocument, options);
      }
export type DataImportFinalizeHygieneMutationHookResult = ReturnType<typeof useDataImportFinalizeHygieneMutation>;
export type DataImportFinalizeHygieneMutationResult = Apollo.MutationResult<DataImportFinalizeHygieneMutation>;
export type DataImportFinalizeHygieneMutationOptions = Apollo.BaseMutationOptions<DataImportFinalizeHygieneMutation, DataImportFinalizeHygieneMutationVariables>;
export const DataImportResolveJobDuplicateDocument = gql`
    mutation DataImportResolveJobDuplicate($jobId: String!, $rowNumber: Int!, $action: String!) {
  dataImportResolveJobDuplicate(
    jobId: $jobId
    rowNumber: $rowNumber
    action: $action
  ) {
    jobId
    rowNumber
    action
  }
}
    `;
export type DataImportResolveJobDuplicateMutationFn = Apollo.MutationFunction<DataImportResolveJobDuplicateMutation, DataImportResolveJobDuplicateMutationVariables>;

/**
 * __useDataImportResolveJobDuplicateMutation__
 *
 * To run a mutation, you first call `useDataImportResolveJobDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportResolveJobDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportResolveJobDuplicateMutation, { data, loading, error }] = useDataImportResolveJobDuplicateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      rowNumber: // value for 'rowNumber'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useDataImportResolveJobDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<DataImportResolveJobDuplicateMutation, DataImportResolveJobDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportResolveJobDuplicateMutation, DataImportResolveJobDuplicateMutationVariables>(DataImportResolveJobDuplicateDocument, options);
      }
export type DataImportResolveJobDuplicateMutationHookResult = ReturnType<typeof useDataImportResolveJobDuplicateMutation>;
export type DataImportResolveJobDuplicateMutationResult = Apollo.MutationResult<DataImportResolveJobDuplicateMutation>;
export type DataImportResolveJobDuplicateMutationOptions = Apollo.BaseMutationOptions<DataImportResolveJobDuplicateMutation, DataImportResolveJobDuplicateMutationVariables>;
export const DataImportRevalidateDocument = gql`
    mutation DataImportRevalidate($jobId: String!, $data: JSON!) {
  dataImportRevalidate(jobId: $jobId, data: $data) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      side
      errorMessages
      warningMessages
      excludedMessages
    }
  }
}
    `;
export type DataImportRevalidateMutationFn = Apollo.MutationFunction<DataImportRevalidateMutation, DataImportRevalidateMutationVariables>;

/**
 * __useDataImportRevalidateMutation__
 *
 * To run a mutation, you first call `useDataImportRevalidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportRevalidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportRevalidateMutation, { data, loading, error }] = useDataImportRevalidateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDataImportRevalidateMutation(baseOptions?: Apollo.MutationHookOptions<DataImportRevalidateMutation, DataImportRevalidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportRevalidateMutation, DataImportRevalidateMutationVariables>(DataImportRevalidateDocument, options);
      }
export type DataImportRevalidateMutationHookResult = ReturnType<typeof useDataImportRevalidateMutation>;
export type DataImportRevalidateMutationResult = Apollo.MutationResult<DataImportRevalidateMutation>;
export type DataImportRevalidateMutationOptions = Apollo.BaseMutationOptions<DataImportRevalidateMutation, DataImportRevalidateMutationVariables>;
export const DataImportRevertToHygieneDocument = gql`
    mutation DataImportRevertToHygiene($jobId: String!) {
  dataImportRevertToHygiene(jobId: $jobId) {
    jobId
    status
    snapshottedRows
  }
}
    `;
export type DataImportRevertToHygieneMutationFn = Apollo.MutationFunction<DataImportRevertToHygieneMutation, DataImportRevertToHygieneMutationVariables>;

/**
 * __useDataImportRevertToHygieneMutation__
 *
 * To run a mutation, you first call `useDataImportRevertToHygieneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportRevertToHygieneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportRevertToHygieneMutation, { data, loading, error }] = useDataImportRevertToHygieneMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportRevertToHygieneMutation(baseOptions?: Apollo.MutationHookOptions<DataImportRevertToHygieneMutation, DataImportRevertToHygieneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportRevertToHygieneMutation, DataImportRevertToHygieneMutationVariables>(DataImportRevertToHygieneDocument, options);
      }
export type DataImportRevertToHygieneMutationHookResult = ReturnType<typeof useDataImportRevertToHygieneMutation>;
export type DataImportRevertToHygieneMutationResult = Apollo.MutationResult<DataImportRevertToHygieneMutation>;
export type DataImportRevertToHygieneMutationOptions = Apollo.BaseMutationOptions<DataImportRevertToHygieneMutation, DataImportRevertToHygieneMutationVariables>;
export const DataImportRunHygieneDocument = gql`
    mutation DataImportRunHygiene($jobId: String!) {
  dataImportRunHygiene(jobId: $jobId) {
    jobId
    status
    clusterCount
    flagCount
    malformedClusterCount
    needsReviewClusterCount
  }
}
    `;
export type DataImportRunHygieneMutationFn = Apollo.MutationFunction<DataImportRunHygieneMutation, DataImportRunHygieneMutationVariables>;

/**
 * __useDataImportRunHygieneMutation__
 *
 * To run a mutation, you first call `useDataImportRunHygieneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportRunHygieneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportRunHygieneMutation, { data, loading, error }] = useDataImportRunHygieneMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportRunHygieneMutation(baseOptions?: Apollo.MutationHookOptions<DataImportRunHygieneMutation, DataImportRunHygieneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportRunHygieneMutation, DataImportRunHygieneMutationVariables>(DataImportRunHygieneDocument, options);
      }
export type DataImportRunHygieneMutationHookResult = ReturnType<typeof useDataImportRunHygieneMutation>;
export type DataImportRunHygieneMutationResult = Apollo.MutationResult<DataImportRunHygieneMutation>;
export type DataImportRunHygieneMutationOptions = Apollo.BaseMutationOptions<DataImportRunHygieneMutation, DataImportRunHygieneMutationVariables>;
export const DataImportSaveColumnMappingDocument = gql`
    mutation DataImportSaveColumnMapping($jobId: String!, $columnMapping: JSON!) {
  dataImportSaveColumnMapping(jobId: $jobId, columnMapping: $columnMapping) {
    jobId
    status
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      side
      errorMessages
      warningMessages
      excludedMessages
    }
    s3Keys
    parsedData
    columns
    hygiene
  }
}
    `;
export type DataImportSaveColumnMappingMutationFn = Apollo.MutationFunction<DataImportSaveColumnMappingMutation, DataImportSaveColumnMappingMutationVariables>;

/**
 * __useDataImportSaveColumnMappingMutation__
 *
 * To run a mutation, you first call `useDataImportSaveColumnMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportSaveColumnMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportSaveColumnMappingMutation, { data, loading, error }] = useDataImportSaveColumnMappingMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      columnMapping: // value for 'columnMapping'
 *   },
 * });
 */
export function useDataImportSaveColumnMappingMutation(baseOptions?: Apollo.MutationHookOptions<DataImportSaveColumnMappingMutation, DataImportSaveColumnMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportSaveColumnMappingMutation, DataImportSaveColumnMappingMutationVariables>(DataImportSaveColumnMappingDocument, options);
      }
export type DataImportSaveColumnMappingMutationHookResult = ReturnType<typeof useDataImportSaveColumnMappingMutation>;
export type DataImportSaveColumnMappingMutationResult = Apollo.MutationResult<DataImportSaveColumnMappingMutation>;
export type DataImportSaveColumnMappingMutationOptions = Apollo.BaseMutationOptions<DataImportSaveColumnMappingMutation, DataImportSaveColumnMappingMutationVariables>;
export const DataImportSaveHygieneActionDocument = gql`
    mutation DataImportSaveHygieneAction($jobId: String!, $kind: String!, $clusterId: String, $patch: JSON, $flagId: String, $reason: String, $resolution: String, $clusterIds: [String!], $splitRows: [Int!], $rowIndex: Int, $side: String, $fromClusterId: String, $toClusterId: String, $canonicalOverride: JSON, $sourceClusterId: String, $canonicalA: JSON, $canonicalB: JSON, $producerClusterId: String, $buyerClusterId: String, $rowIndices: [Int!], $jobAssignedTo: String, $jobPatch: JSON, $producer: JSON, $inspectionLevel: String) {
  dataImportSaveHygieneAction(
    jobId: $jobId
    kind: $kind
    clusterId: $clusterId
    patch: $patch
    flagId: $flagId
    reason: $reason
    resolution: $resolution
    clusterIds: $clusterIds
    splitRows: $splitRows
    rowIndex: $rowIndex
    side: $side
    fromClusterId: $fromClusterId
    toClusterId: $toClusterId
    canonicalOverride: $canonicalOverride
    sourceClusterId: $sourceClusterId
    canonicalA: $canonicalA
    canonicalB: $canonicalB
    producerClusterId: $producerClusterId
    buyerClusterId: $buyerClusterId
    rowIndices: $rowIndices
    jobAssignedTo: $jobAssignedTo
    jobPatch: $jobPatch
    producer: $producer
    inspectionLevel: $inspectionLevel
  ) {
    jobId
    status
    actionCount
    openFlagCount
    needsReviewClusterCount
    rowsChanged
    rowsUnchanged
    rowsAlreadySet
    rowsIncompatible
  }
}
    `;
export type DataImportSaveHygieneActionMutationFn = Apollo.MutationFunction<DataImportSaveHygieneActionMutation, DataImportSaveHygieneActionMutationVariables>;

/**
 * __useDataImportSaveHygieneActionMutation__
 *
 * To run a mutation, you first call `useDataImportSaveHygieneActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportSaveHygieneActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportSaveHygieneActionMutation, { data, loading, error }] = useDataImportSaveHygieneActionMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      kind: // value for 'kind'
 *      clusterId: // value for 'clusterId'
 *      patch: // value for 'patch'
 *      flagId: // value for 'flagId'
 *      reason: // value for 'reason'
 *      resolution: // value for 'resolution'
 *      clusterIds: // value for 'clusterIds'
 *      splitRows: // value for 'splitRows'
 *      rowIndex: // value for 'rowIndex'
 *      side: // value for 'side'
 *      fromClusterId: // value for 'fromClusterId'
 *      toClusterId: // value for 'toClusterId'
 *      canonicalOverride: // value for 'canonicalOverride'
 *      sourceClusterId: // value for 'sourceClusterId'
 *      canonicalA: // value for 'canonicalA'
 *      canonicalB: // value for 'canonicalB'
 *      producerClusterId: // value for 'producerClusterId'
 *      buyerClusterId: // value for 'buyerClusterId'
 *      rowIndices: // value for 'rowIndices'
 *      jobAssignedTo: // value for 'jobAssignedTo'
 *      jobPatch: // value for 'jobPatch'
 *      producer: // value for 'producer'
 *      inspectionLevel: // value for 'inspectionLevel'
 *   },
 * });
 */
export function useDataImportSaveHygieneActionMutation(baseOptions?: Apollo.MutationHookOptions<DataImportSaveHygieneActionMutation, DataImportSaveHygieneActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportSaveHygieneActionMutation, DataImportSaveHygieneActionMutationVariables>(DataImportSaveHygieneActionDocument, options);
      }
export type DataImportSaveHygieneActionMutationHookResult = ReturnType<typeof useDataImportSaveHygieneActionMutation>;
export type DataImportSaveHygieneActionMutationResult = Apollo.MutationResult<DataImportSaveHygieneActionMutation>;
export type DataImportSaveHygieneActionMutationOptions = Apollo.BaseMutationOptions<DataImportSaveHygieneActionMutation, DataImportSaveHygieneActionMutationVariables>;
export const DataImportSaveMatchDecisionDocument = gql`
    mutation DataImportSaveMatchDecision($jobId: String!, $rowNumber: Int!, $side: String!, $action: String!, $targetUserId: String, $fieldsToApply: [String!]) {
  dataImportSaveMatchDecision(
    jobId: $jobId
    rowNumber: $rowNumber
    side: $side
    action: $action
    targetUserId: $targetUserId
    fieldsToApply: $fieldsToApply
  ) {
    jobId
    rowNumber
    side
    action
    targetUserId
    fieldsToApply
  }
}
    `;
export type DataImportSaveMatchDecisionMutationFn = Apollo.MutationFunction<DataImportSaveMatchDecisionMutation, DataImportSaveMatchDecisionMutationVariables>;

/**
 * __useDataImportSaveMatchDecisionMutation__
 *
 * To run a mutation, you first call `useDataImportSaveMatchDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportSaveMatchDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportSaveMatchDecisionMutation, { data, loading, error }] = useDataImportSaveMatchDecisionMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      rowNumber: // value for 'rowNumber'
 *      side: // value for 'side'
 *      action: // value for 'action'
 *      targetUserId: // value for 'targetUserId'
 *      fieldsToApply: // value for 'fieldsToApply'
 *   },
 * });
 */
export function useDataImportSaveMatchDecisionMutation(baseOptions?: Apollo.MutationHookOptions<DataImportSaveMatchDecisionMutation, DataImportSaveMatchDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportSaveMatchDecisionMutation, DataImportSaveMatchDecisionMutationVariables>(DataImportSaveMatchDecisionDocument, options);
      }
export type DataImportSaveMatchDecisionMutationHookResult = ReturnType<typeof useDataImportSaveMatchDecisionMutation>;
export type DataImportSaveMatchDecisionMutationResult = Apollo.MutationResult<DataImportSaveMatchDecisionMutation>;
export type DataImportSaveMatchDecisionMutationOptions = Apollo.BaseMutationOptions<DataImportSaveMatchDecisionMutation, DataImportSaveMatchDecisionMutationVariables>;
export const DataImportUpdateRowsDocument = gql`
    mutation dataImportUpdateRows($jobId: String!, $updatedRows: JSON!) {
  dataImportUpdateRows(jobId: $jobId, updatedRows: $updatedRows) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      side
      errorMessages
      warningMessages
      excludedMessages
    }
    parsedData
  }
}
    `;
export type DataImportUpdateRowsMutationFn = Apollo.MutationFunction<DataImportUpdateRowsMutation, DataImportUpdateRowsMutationVariables>;

/**
 * __useDataImportUpdateRowsMutation__
 *
 * To run a mutation, you first call `useDataImportUpdateRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportUpdateRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportUpdateRowsMutation, { data, loading, error }] = useDataImportUpdateRowsMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      updatedRows: // value for 'updatedRows'
 *   },
 * });
 */
export function useDataImportUpdateRowsMutation(baseOptions?: Apollo.MutationHookOptions<DataImportUpdateRowsMutation, DataImportUpdateRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportUpdateRowsMutation, DataImportUpdateRowsMutationVariables>(DataImportUpdateRowsDocument, options);
      }
export type DataImportUpdateRowsMutationHookResult = ReturnType<typeof useDataImportUpdateRowsMutation>;
export type DataImportUpdateRowsMutationResult = Apollo.MutationResult<DataImportUpdateRowsMutation>;
export type DataImportUpdateRowsMutationOptions = Apollo.BaseMutationOptions<DataImportUpdateRowsMutation, DataImportUpdateRowsMutationVariables>;
export const DataImportForceCancelDocument = gql`
    mutation DataImportForceCancel($jobId: String!) {
  dataImportForceCancel(jobId: $jobId) {
    jobId
    status
    cancelledAt
    message
    warning
  }
}
    `;
export type DataImportForceCancelMutationFn = Apollo.MutationFunction<DataImportForceCancelMutation, DataImportForceCancelMutationVariables>;

/**
 * __useDataImportForceCancelMutation__
 *
 * To run a mutation, you first call `useDataImportForceCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportForceCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportForceCancelMutation, { data, loading, error }] = useDataImportForceCancelMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportForceCancelMutation(baseOptions?: Apollo.MutationHookOptions<DataImportForceCancelMutation, DataImportForceCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportForceCancelMutation, DataImportForceCancelMutationVariables>(DataImportForceCancelDocument, options);
      }
export type DataImportForceCancelMutationHookResult = ReturnType<typeof useDataImportForceCancelMutation>;
export type DataImportForceCancelMutationResult = Apollo.MutationResult<DataImportForceCancelMutation>;
export type DataImportForceCancelMutationOptions = Apollo.BaseMutationOptions<DataImportForceCancelMutation, DataImportForceCancelMutationVariables>;
export const DataImportUploadDocument = gql`
    mutation DataImportUpload($file: Upload!, $type: String, $vendorId: MongoID!, $tenantId: MongoID!) {
  dataImportUpload(
    file: $file
    type: $type
    vendorId: $vendorId
    tenantId: $tenantId
  ) {
    jobId
    detectedType
    totalRows
    validRows
    invalidRows
    validFilePath
    invalidFilePath
    validationErrors {
      row
      side
      errorMessages
      warningMessages
      excludedMessages
    }
    availableColumns {
      fieldName
      role
      baseField
      aliases
      required
      description
      validationRules
    }
    detectedColumns
    suggestedMapping
  }
}
    `;
export type DataImportUploadMutationFn = Apollo.MutationFunction<DataImportUploadMutation, DataImportUploadMutationVariables>;

/**
 * __useDataImportUploadMutation__
 *
 * To run a mutation, you first call `useDataImportUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportUploadMutation, { data, loading, error }] = useDataImportUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      type: // value for 'type'
 *      vendorId: // value for 'vendorId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useDataImportUploadMutation(baseOptions?: Apollo.MutationHookOptions<DataImportUploadMutation, DataImportUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportUploadMutation, DataImportUploadMutationVariables>(DataImportUploadDocument, options);
      }
export type DataImportUploadMutationHookResult = ReturnType<typeof useDataImportUploadMutation>;
export type DataImportUploadMutationResult = Apollo.MutationResult<DataImportUploadMutation>;
export type DataImportUploadMutationOptions = Apollo.BaseMutationOptions<DataImportUploadMutation, DataImportUploadMutationVariables>;
export const DepositPaymentIntentCreateDocument = gql`
    mutation DepositPaymentIntentCreate($jobId: MongoID!) {
  depositPaymentIntentCreate(jobId: $jobId) {
    clientSecret
    connectedAccountId
  }
}
    `;
export type DepositPaymentIntentCreateMutationFn = Apollo.MutationFunction<DepositPaymentIntentCreateMutation, DepositPaymentIntentCreateMutationVariables>;

/**
 * __useDepositPaymentIntentCreateMutation__
 *
 * To run a mutation, you first call `useDepositPaymentIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepositPaymentIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [depositPaymentIntentCreateMutation, { data, loading, error }] = useDepositPaymentIntentCreateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDepositPaymentIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<DepositPaymentIntentCreateMutation, DepositPaymentIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepositPaymentIntentCreateMutation, DepositPaymentIntentCreateMutationVariables>(DepositPaymentIntentCreateDocument, options);
      }
export type DepositPaymentIntentCreateMutationHookResult = ReturnType<typeof useDepositPaymentIntentCreateMutation>;
export type DepositPaymentIntentCreateMutationResult = Apollo.MutationResult<DepositPaymentIntentCreateMutation>;
export type DepositPaymentIntentCreateMutationOptions = Apollo.BaseMutationOptions<DepositPaymentIntentCreateMutation, DepositPaymentIntentCreateMutationVariables>;
export const DepositPaymentIntentSettleDocument = gql`
    mutation DepositPaymentIntentSettle($jobId: MongoID!) {
  depositPaymentIntentSettle(jobId: $jobId) {
    _id
    status
    deposit {
      amount
      method
      status
    }
  }
}
    `;
export type DepositPaymentIntentSettleMutationFn = Apollo.MutationFunction<DepositPaymentIntentSettleMutation, DepositPaymentIntentSettleMutationVariables>;

/**
 * __useDepositPaymentIntentSettleMutation__
 *
 * To run a mutation, you first call `useDepositPaymentIntentSettleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepositPaymentIntentSettleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [depositPaymentIntentSettleMutation, { data, loading, error }] = useDepositPaymentIntentSettleMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDepositPaymentIntentSettleMutation(baseOptions?: Apollo.MutationHookOptions<DepositPaymentIntentSettleMutation, DepositPaymentIntentSettleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepositPaymentIntentSettleMutation, DepositPaymentIntentSettleMutationVariables>(DepositPaymentIntentSettleDocument, options);
      }
export type DepositPaymentIntentSettleMutationHookResult = ReturnType<typeof useDepositPaymentIntentSettleMutation>;
export type DepositPaymentIntentSettleMutationResult = Apollo.MutationResult<DepositPaymentIntentSettleMutation>;
export type DepositPaymentIntentSettleMutationOptions = Apollo.BaseMutationOptions<DepositPaymentIntentSettleMutation, DepositPaymentIntentSettleMutationVariables>;
export const DepositSetupIntentCreateDocument = gql`
    mutation DepositSetupIntentCreate($vendorId: MongoID!, $userId: MongoID!) {
  depositSetupIntentCreate(vendorId: $vendorId, userId: $userId) {
    clientSecret
    customerId
  }
}
    `;
export type DepositSetupIntentCreateMutationFn = Apollo.MutationFunction<DepositSetupIntentCreateMutation, DepositSetupIntentCreateMutationVariables>;

/**
 * __useDepositSetupIntentCreateMutation__
 *
 * To run a mutation, you first call `useDepositSetupIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepositSetupIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [depositSetupIntentCreateMutation, { data, loading, error }] = useDepositSetupIntentCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDepositSetupIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<DepositSetupIntentCreateMutation, DepositSetupIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepositSetupIntentCreateMutation, DepositSetupIntentCreateMutationVariables>(DepositSetupIntentCreateDocument, options);
      }
export type DepositSetupIntentCreateMutationHookResult = ReturnType<typeof useDepositSetupIntentCreateMutation>;
export type DepositSetupIntentCreateMutationResult = Apollo.MutationResult<DepositSetupIntentCreateMutation>;
export type DepositSetupIntentCreateMutationOptions = Apollo.BaseMutationOptions<DepositSetupIntentCreateMutation, DepositSetupIntentCreateMutationVariables>;
export const DocumentAddVersionDocument = gql`
    mutation DocumentAddVersion($documentId: MongoID!, $key: String!, $filename: String!, $mimeType: String!, $fileSize: Float!, $hash: String, $note: String) {
  documentAddVersion(
    documentId: $documentId
    key: $key
    filename: $filename
    mimeType: $mimeType
    fileSize: $fileSize
    hash: $hash
    note: $note
  ) {
    ...DocumentFragment
  }
}
    ${DocumentFragmentFragmentDoc}`;
export type DocumentAddVersionMutationFn = Apollo.MutationFunction<DocumentAddVersionMutation, DocumentAddVersionMutationVariables>;

/**
 * __useDocumentAddVersionMutation__
 *
 * To run a mutation, you first call `useDocumentAddVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentAddVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentAddVersionMutation, { data, loading, error }] = useDocumentAddVersionMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      key: // value for 'key'
 *      filename: // value for 'filename'
 *      mimeType: // value for 'mimeType'
 *      fileSize: // value for 'fileSize'
 *      hash: // value for 'hash'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDocumentAddVersionMutation(baseOptions?: Apollo.MutationHookOptions<DocumentAddVersionMutation, DocumentAddVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentAddVersionMutation, DocumentAddVersionMutationVariables>(DocumentAddVersionDocument, options);
      }
export type DocumentAddVersionMutationHookResult = ReturnType<typeof useDocumentAddVersionMutation>;
export type DocumentAddVersionMutationResult = Apollo.MutationResult<DocumentAddVersionMutation>;
export type DocumentAddVersionMutationOptions = Apollo.BaseMutationOptions<DocumentAddVersionMutation, DocumentAddVersionMutationVariables>;
export const DocumentCategoryUpsertDocument = gql`
    mutation DocumentCategoryUpsert($name: String!) {
  documentCategoryUpsert(name: $name) {
    _id
    name
    vendor
  }
}
    `;
export type DocumentCategoryUpsertMutationFn = Apollo.MutationFunction<DocumentCategoryUpsertMutation, DocumentCategoryUpsertMutationVariables>;

/**
 * __useDocumentCategoryUpsertMutation__
 *
 * To run a mutation, you first call `useDocumentCategoryUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentCategoryUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentCategoryUpsertMutation, { data, loading, error }] = useDocumentCategoryUpsertMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDocumentCategoryUpsertMutation(baseOptions?: Apollo.MutationHookOptions<DocumentCategoryUpsertMutation, DocumentCategoryUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentCategoryUpsertMutation, DocumentCategoryUpsertMutationVariables>(DocumentCategoryUpsertDocument, options);
      }
export type DocumentCategoryUpsertMutationHookResult = ReturnType<typeof useDocumentCategoryUpsertMutation>;
export type DocumentCategoryUpsertMutationResult = Apollo.MutationResult<DocumentCategoryUpsertMutation>;
export type DocumentCategoryUpsertMutationOptions = Apollo.BaseMutationOptions<DocumentCategoryUpsertMutation, DocumentCategoryUpsertMutationVariables>;
export const DocumentCreateDocument = gql`
    mutation DocumentCreate($links: [DocumentLinkInput!], $key: String!, $filename: String!, $mimeType: String!, $fileSize: Float!, $hash: String, $category: String!) {
  documentCreate(
    links: $links
    key: $key
    filename: $filename
    mimeType: $mimeType
    fileSize: $fileSize
    hash: $hash
    category: $category
  ) {
    ...DocumentFragment
  }
}
    ${DocumentFragmentFragmentDoc}`;
export type DocumentCreateMutationFn = Apollo.MutationFunction<DocumentCreateMutation, DocumentCreateMutationVariables>;

/**
 * __useDocumentCreateMutation__
 *
 * To run a mutation, you first call `useDocumentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentCreateMutation, { data, loading, error }] = useDocumentCreateMutation({
 *   variables: {
 *      links: // value for 'links'
 *      key: // value for 'key'
 *      filename: // value for 'filename'
 *      mimeType: // value for 'mimeType'
 *      fileSize: // value for 'fileSize'
 *      hash: // value for 'hash'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useDocumentCreateMutation(baseOptions?: Apollo.MutationHookOptions<DocumentCreateMutation, DocumentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentCreateMutation, DocumentCreateMutationVariables>(DocumentCreateDocument, options);
      }
export type DocumentCreateMutationHookResult = ReturnType<typeof useDocumentCreateMutation>;
export type DocumentCreateMutationResult = Apollo.MutationResult<DocumentCreateMutation>;
export type DocumentCreateMutationOptions = Apollo.BaseMutationOptions<DocumentCreateMutation, DocumentCreateMutationVariables>;
export const DocumentCreateFromChatAttachmentDocument = gql`
    mutation DocumentCreateFromChatAttachment($chatMessageId: MongoID!, $links: [DocumentLinkInput!], $category: String!) {
  documentCreateFromChatAttachment(
    chatMessageId: $chatMessageId
    links: $links
    category: $category
  ) {
    _id
    filename
    category
  }
}
    `;
export type DocumentCreateFromChatAttachmentMutationFn = Apollo.MutationFunction<DocumentCreateFromChatAttachmentMutation, DocumentCreateFromChatAttachmentMutationVariables>;

/**
 * __useDocumentCreateFromChatAttachmentMutation__
 *
 * To run a mutation, you first call `useDocumentCreateFromChatAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentCreateFromChatAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentCreateFromChatAttachmentMutation, { data, loading, error }] = useDocumentCreateFromChatAttachmentMutation({
 *   variables: {
 *      chatMessageId: // value for 'chatMessageId'
 *      links: // value for 'links'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useDocumentCreateFromChatAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DocumentCreateFromChatAttachmentMutation, DocumentCreateFromChatAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentCreateFromChatAttachmentMutation, DocumentCreateFromChatAttachmentMutationVariables>(DocumentCreateFromChatAttachmentDocument, options);
      }
export type DocumentCreateFromChatAttachmentMutationHookResult = ReturnType<typeof useDocumentCreateFromChatAttachmentMutation>;
export type DocumentCreateFromChatAttachmentMutationResult = Apollo.MutationResult<DocumentCreateFromChatAttachmentMutation>;
export type DocumentCreateFromChatAttachmentMutationOptions = Apollo.BaseMutationOptions<DocumentCreateFromChatAttachmentMutation, DocumentCreateFromChatAttachmentMutationVariables>;
export const DocumentDeleteDocument = gql`
    mutation DocumentDelete($documentId: MongoID!) {
  documentDelete(documentId: $documentId) {
    _id
  }
}
    `;
export type DocumentDeleteMutationFn = Apollo.MutationFunction<DocumentDeleteMutation, DocumentDeleteMutationVariables>;

/**
 * __useDocumentDeleteMutation__
 *
 * To run a mutation, you first call `useDocumentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentDeleteMutation, { data, loading, error }] = useDocumentDeleteMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DocumentDeleteMutation, DocumentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentDeleteMutation, DocumentDeleteMutationVariables>(DocumentDeleteDocument, options);
      }
export type DocumentDeleteMutationHookResult = ReturnType<typeof useDocumentDeleteMutation>;
export type DocumentDeleteMutationResult = Apollo.MutationResult<DocumentDeleteMutation>;
export type DocumentDeleteMutationOptions = Apollo.BaseMutationOptions<DocumentDeleteMutation, DocumentDeleteMutationVariables>;
export const DocumentRestoreVersionDocument = gql`
    mutation DocumentRestoreVersion($documentId: MongoID!, $version: Int!) {
  documentRestoreVersion(documentId: $documentId, version: $version) {
    ...DocumentFragment
  }
}
    ${DocumentFragmentFragmentDoc}`;
export type DocumentRestoreVersionMutationFn = Apollo.MutationFunction<DocumentRestoreVersionMutation, DocumentRestoreVersionMutationVariables>;

/**
 * __useDocumentRestoreVersionMutation__
 *
 * To run a mutation, you first call `useDocumentRestoreVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentRestoreVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentRestoreVersionMutation, { data, loading, error }] = useDocumentRestoreVersionMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDocumentRestoreVersionMutation(baseOptions?: Apollo.MutationHookOptions<DocumentRestoreVersionMutation, DocumentRestoreVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentRestoreVersionMutation, DocumentRestoreVersionMutationVariables>(DocumentRestoreVersionDocument, options);
      }
export type DocumentRestoreVersionMutationHookResult = ReturnType<typeof useDocumentRestoreVersionMutation>;
export type DocumentRestoreVersionMutationResult = Apollo.MutationResult<DocumentRestoreVersionMutation>;
export type DocumentRestoreVersionMutationOptions = Apollo.BaseMutationOptions<DocumentRestoreVersionMutation, DocumentRestoreVersionMutationVariables>;
export const DocumentSetLinksDocument = gql`
    mutation DocumentSetLinks($documentId: MongoID!, $links: [DocumentLinkInput!]!) {
  documentSetLinks(documentId: $documentId, links: $links) {
    _id
    links {
      entityType
      entityId
    }
  }
}
    `;
export type DocumentSetLinksMutationFn = Apollo.MutationFunction<DocumentSetLinksMutation, DocumentSetLinksMutationVariables>;

/**
 * __useDocumentSetLinksMutation__
 *
 * To run a mutation, you first call `useDocumentSetLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentSetLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentSetLinksMutation, { data, loading, error }] = useDocumentSetLinksMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useDocumentSetLinksMutation(baseOptions?: Apollo.MutationHookOptions<DocumentSetLinksMutation, DocumentSetLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentSetLinksMutation, DocumentSetLinksMutationVariables>(DocumentSetLinksDocument, options);
      }
export type DocumentSetLinksMutationHookResult = ReturnType<typeof useDocumentSetLinksMutation>;
export type DocumentSetLinksMutationResult = Apollo.MutationResult<DocumentSetLinksMutation>;
export type DocumentSetLinksMutationOptions = Apollo.BaseMutationOptions<DocumentSetLinksMutation, DocumentSetLinksMutationVariables>;
export const ExportPresetCreateOneDocument = gql`
    mutation ExportPresetCreateOne($record: CreateOneExportPresetInput!) {
  exportPresetCreateOne(record: $record) {
    recordId
  }
}
    `;
export type ExportPresetCreateOneMutationFn = Apollo.MutationFunction<ExportPresetCreateOneMutation, ExportPresetCreateOneMutationVariables>;

/**
 * __useExportPresetCreateOneMutation__
 *
 * To run a mutation, you first call `useExportPresetCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPresetCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPresetCreateOneMutation, { data, loading, error }] = useExportPresetCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useExportPresetCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ExportPresetCreateOneMutation, ExportPresetCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPresetCreateOneMutation, ExportPresetCreateOneMutationVariables>(ExportPresetCreateOneDocument, options);
      }
export type ExportPresetCreateOneMutationHookResult = ReturnType<typeof useExportPresetCreateOneMutation>;
export type ExportPresetCreateOneMutationResult = Apollo.MutationResult<ExportPresetCreateOneMutation>;
export type ExportPresetCreateOneMutationOptions = Apollo.BaseMutationOptions<ExportPresetCreateOneMutation, ExportPresetCreateOneMutationVariables>;
export const ExportPresetUpdateByIdDocument = gql`
    mutation ExportPresetUpdateById($id: MongoID!, $record: UpdateByIdExportPresetInput!) {
  exportPresetUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type ExportPresetUpdateByIdMutationFn = Apollo.MutationFunction<ExportPresetUpdateByIdMutation, ExportPresetUpdateByIdMutationVariables>;

/**
 * __useExportPresetUpdateByIdMutation__
 *
 * To run a mutation, you first call `useExportPresetUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPresetUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPresetUpdateByIdMutation, { data, loading, error }] = useExportPresetUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useExportPresetUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ExportPresetUpdateByIdMutation, ExportPresetUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPresetUpdateByIdMutation, ExportPresetUpdateByIdMutationVariables>(ExportPresetUpdateByIdDocument, options);
      }
export type ExportPresetUpdateByIdMutationHookResult = ReturnType<typeof useExportPresetUpdateByIdMutation>;
export type ExportPresetUpdateByIdMutationResult = Apollo.MutationResult<ExportPresetUpdateByIdMutation>;
export type ExportPresetUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ExportPresetUpdateByIdMutation, ExportPresetUpdateByIdMutationVariables>;
export const ExportPresetDeleteByIdDocument = gql`
    mutation ExportPresetDeleteById($id: MongoID!) {
  exportPresetUpdateById(_id: $id, record: {isDeleted: true}) {
    recordId
  }
}
    `;
export type ExportPresetDeleteByIdMutationFn = Apollo.MutationFunction<ExportPresetDeleteByIdMutation, ExportPresetDeleteByIdMutationVariables>;

/**
 * __useExportPresetDeleteByIdMutation__
 *
 * To run a mutation, you first call `useExportPresetDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPresetDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPresetDeleteByIdMutation, { data, loading, error }] = useExportPresetDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportPresetDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<ExportPresetDeleteByIdMutation, ExportPresetDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPresetDeleteByIdMutation, ExportPresetDeleteByIdMutationVariables>(ExportPresetDeleteByIdDocument, options);
      }
export type ExportPresetDeleteByIdMutationHookResult = ReturnType<typeof useExportPresetDeleteByIdMutation>;
export type ExportPresetDeleteByIdMutationResult = Apollo.MutationResult<ExportPresetDeleteByIdMutation>;
export type ExportPresetDeleteByIdMutationOptions = Apollo.BaseMutationOptions<ExportPresetDeleteByIdMutation, ExportPresetDeleteByIdMutationVariables>;
export const ExportSettingCreateOneDocument = gql`
    mutation ExportSettingCreateOne($record: CreateOneExportSettingInput!) {
  exportSettingCreateOne(record: $record) {
    recordId
  }
}
    `;
export type ExportSettingCreateOneMutationFn = Apollo.MutationFunction<ExportSettingCreateOneMutation, ExportSettingCreateOneMutationVariables>;

/**
 * __useExportSettingCreateOneMutation__
 *
 * To run a mutation, you first call `useExportSettingCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSettingCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSettingCreateOneMutation, { data, loading, error }] = useExportSettingCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useExportSettingCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ExportSettingCreateOneMutation, ExportSettingCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSettingCreateOneMutation, ExportSettingCreateOneMutationVariables>(ExportSettingCreateOneDocument, options);
      }
export type ExportSettingCreateOneMutationHookResult = ReturnType<typeof useExportSettingCreateOneMutation>;
export type ExportSettingCreateOneMutationResult = Apollo.MutationResult<ExportSettingCreateOneMutation>;
export type ExportSettingCreateOneMutationOptions = Apollo.BaseMutationOptions<ExportSettingCreateOneMutation, ExportSettingCreateOneMutationVariables>;
export const ExportSettingUpdateByIdDocument = gql`
    mutation ExportSettingUpdateById($id: MongoID!, $record: UpdateByIdExportSettingInput!) {
  exportSettingUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type ExportSettingUpdateByIdMutationFn = Apollo.MutationFunction<ExportSettingUpdateByIdMutation, ExportSettingUpdateByIdMutationVariables>;

/**
 * __useExportSettingUpdateByIdMutation__
 *
 * To run a mutation, you first call `useExportSettingUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSettingUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSettingUpdateByIdMutation, { data, loading, error }] = useExportSettingUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useExportSettingUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ExportSettingUpdateByIdMutation, ExportSettingUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSettingUpdateByIdMutation, ExportSettingUpdateByIdMutationVariables>(ExportSettingUpdateByIdDocument, options);
      }
export type ExportSettingUpdateByIdMutationHookResult = ReturnType<typeof useExportSettingUpdateByIdMutation>;
export type ExportSettingUpdateByIdMutationResult = Apollo.MutationResult<ExportSettingUpdateByIdMutation>;
export type ExportSettingUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ExportSettingUpdateByIdMutation, ExportSettingUpdateByIdMutationVariables>;
export const GameJobAddAnimalsDocument = gql`
    mutation GameJobAddAnimals($input: GameJobAddAnimalsInput!) {
  gameJobAddAnimals(input: $input) {
    scheduling {
      _id
      headCount
    }
    addedCount
    sharedCutSheet
    cutSheetOutcome
    replayed
    messages
  }
}
    `;
export type GameJobAddAnimalsMutationFn = Apollo.MutationFunction<GameJobAddAnimalsMutation, GameJobAddAnimalsMutationVariables>;

/**
 * __useGameJobAddAnimalsMutation__
 *
 * To run a mutation, you first call `useGameJobAddAnimalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameJobAddAnimalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameJobAddAnimalsMutation, { data, loading, error }] = useGameJobAddAnimalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameJobAddAnimalsMutation(baseOptions?: Apollo.MutationHookOptions<GameJobAddAnimalsMutation, GameJobAddAnimalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameJobAddAnimalsMutation, GameJobAddAnimalsMutationVariables>(GameJobAddAnimalsDocument, options);
      }
export type GameJobAddAnimalsMutationHookResult = ReturnType<typeof useGameJobAddAnimalsMutation>;
export type GameJobAddAnimalsMutationResult = Apollo.MutationResult<GameJobAddAnimalsMutation>;
export type GameJobAddAnimalsMutationOptions = Apollo.BaseMutationOptions<GameJobAddAnimalsMutation, GameJobAddAnimalsMutationVariables>;
export const GameJobCreateDocument = gql`
    mutation GameJobCreate($input: GameJobCreateInput!) {
  gameJobCreate(input: $input) {
    scheduling {
      _id
      jobId
      status
      dropoffDateStr
      animalSpecies
      headCount
    }
    hunterExisted
    replayed
    messages
  }
}
    `;
export type GameJobCreateMutationFn = Apollo.MutationFunction<GameJobCreateMutation, GameJobCreateMutationVariables>;

/**
 * __useGameJobCreateMutation__
 *
 * To run a mutation, you first call `useGameJobCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameJobCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameJobCreateMutation, { data, loading, error }] = useGameJobCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameJobCreateMutation(baseOptions?: Apollo.MutationHookOptions<GameJobCreateMutation, GameJobCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameJobCreateMutation, GameJobCreateMutationVariables>(GameJobCreateDocument, options);
      }
export type GameJobCreateMutationHookResult = ReturnType<typeof useGameJobCreateMutation>;
export type GameJobCreateMutationResult = Apollo.MutationResult<GameJobCreateMutation>;
export type GameJobCreateMutationOptions = Apollo.BaseMutationOptions<GameJobCreateMutation, GameJobCreateMutationVariables>;
export const GameKioskAddressSetupDocument = gql`
    mutation GameKioskAddressSetup($input: GameKioskAddressSetupInput!) {
  gameKioskAddressSetup(input: $input) {
    kioskToken
    kioskUrl
    kioskShortUrl
    created
  }
}
    `;
export type GameKioskAddressSetupMutationFn = Apollo.MutationFunction<GameKioskAddressSetupMutation, GameKioskAddressSetupMutationVariables>;

/**
 * __useGameKioskAddressSetupMutation__
 *
 * To run a mutation, you first call `useGameKioskAddressSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameKioskAddressSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameKioskAddressSetupMutation, { data, loading, error }] = useGameKioskAddressSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameKioskAddressSetupMutation(baseOptions?: Apollo.MutationHookOptions<GameKioskAddressSetupMutation, GameKioskAddressSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameKioskAddressSetupMutation, GameKioskAddressSetupMutationVariables>(GameKioskAddressSetupDocument, options);
      }
export type GameKioskAddressSetupMutationHookResult = ReturnType<typeof useGameKioskAddressSetupMutation>;
export type GameKioskAddressSetupMutationResult = Apollo.MutationResult<GameKioskAddressSetupMutation>;
export type GameKioskAddressSetupMutationOptions = Apollo.BaseMutationOptions<GameKioskAddressSetupMutation, GameKioskAddressSetupMutationVariables>;
export const GameKioskDropoffCreateDocument = gql`
    mutation GameKioskDropoffCreate($input: GameKioskDropoffInput!) {
  gameKioskDropoffCreate(input: $input) {
    jobId
    animalCount
    processorName
    replayed
  }
}
    `;
export type GameKioskDropoffCreateMutationFn = Apollo.MutationFunction<GameKioskDropoffCreateMutation, GameKioskDropoffCreateMutationVariables>;

/**
 * __useGameKioskDropoffCreateMutation__
 *
 * To run a mutation, you first call `useGameKioskDropoffCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameKioskDropoffCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameKioskDropoffCreateMutation, { data, loading, error }] = useGameKioskDropoffCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameKioskDropoffCreateMutation(baseOptions?: Apollo.MutationHookOptions<GameKioskDropoffCreateMutation, GameKioskDropoffCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameKioskDropoffCreateMutation, GameKioskDropoffCreateMutationVariables>(GameKioskDropoffCreateDocument, options);
      }
export type GameKioskDropoffCreateMutationHookResult = ReturnType<typeof useGameKioskDropoffCreateMutation>;
export type GameKioskDropoffCreateMutationResult = Apollo.MutationResult<GameKioskDropoffCreateMutation>;
export type GameKioskDropoffCreateMutationOptions = Apollo.BaseMutationOptions<GameKioskDropoffCreateMutation, GameKioskDropoffCreateMutationVariables>;
export const GameKioskSignGenerateDocument = gql`
    mutation GameKioskSignGenerate($vendor: MongoID!) {
  gameKioskSignGenerate(vendor: $vendor) {
    file
    filename
    fileUrl
    errors
  }
}
    `;
export type GameKioskSignGenerateMutationFn = Apollo.MutationFunction<GameKioskSignGenerateMutation, GameKioskSignGenerateMutationVariables>;

/**
 * __useGameKioskSignGenerateMutation__
 *
 * To run a mutation, you first call `useGameKioskSignGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameKioskSignGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameKioskSignGenerateMutation, { data, loading, error }] = useGameKioskSignGenerateMutation({
 *   variables: {
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useGameKioskSignGenerateMutation(baseOptions?: Apollo.MutationHookOptions<GameKioskSignGenerateMutation, GameKioskSignGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameKioskSignGenerateMutation, GameKioskSignGenerateMutationVariables>(GameKioskSignGenerateDocument, options);
      }
export type GameKioskSignGenerateMutationHookResult = ReturnType<typeof useGameKioskSignGenerateMutation>;
export type GameKioskSignGenerateMutationResult = Apollo.MutationResult<GameKioskSignGenerateMutation>;
export type GameKioskSignGenerateMutationOptions = Apollo.BaseMutationOptions<GameKioskSignGenerateMutation, GameKioskSignGenerateMutationVariables>;
export const GenerateCutsheetQuestionnaireDocument = gql`
    mutation GenerateCutsheetQuestionnaire($capabilityId: MongoID!) {
  generateCutsheetQuestionnaire(capabilityId: $capabilityId) {
    questionnaireId
    name
    questionCount
  }
}
    `;
export type GenerateCutsheetQuestionnaireMutationFn = Apollo.MutationFunction<GenerateCutsheetQuestionnaireMutation, GenerateCutsheetQuestionnaireMutationVariables>;

/**
 * __useGenerateCutsheetQuestionnaireMutation__
 *
 * To run a mutation, you first call `useGenerateCutsheetQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCutsheetQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCutsheetQuestionnaireMutation, { data, loading, error }] = useGenerateCutsheetQuestionnaireMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useGenerateCutsheetQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCutsheetQuestionnaireMutation, GenerateCutsheetQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCutsheetQuestionnaireMutation, GenerateCutsheetQuestionnaireMutationVariables>(GenerateCutsheetQuestionnaireDocument, options);
      }
export type GenerateCutsheetQuestionnaireMutationHookResult = ReturnType<typeof useGenerateCutsheetQuestionnaireMutation>;
export type GenerateCutsheetQuestionnaireMutationResult = Apollo.MutationResult<GenerateCutsheetQuestionnaireMutation>;
export type GenerateCutsheetQuestionnaireMutationOptions = Apollo.BaseMutationOptions<GenerateCutsheetQuestionnaireMutation, GenerateCutsheetQuestionnaireMutationVariables>;
export const GenerateUploadUrlDocument = gql`
    mutation GenerateUploadUrl($key: String!, $contentType: String, $expiresIn: Int, $isPrivate: Boolean) {
  generateUploadUrl(
    key: $key
    contentType: $contentType
    expiresIn: $expiresIn
    isPrivate: $isPrivate
  ) {
    uploadUrl
    cdnUrl
  }
}
    `;
export type GenerateUploadUrlMutationFn = Apollo.MutationFunction<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;

/**
 * __useGenerateUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlMutation, { data, loading, error }] = useGenerateUploadUrlMutation({
 *   variables: {
 *      key: // value for 'key'
 *      contentType: // value for 'contentType'
 *      expiresIn: // value for 'expiresIn'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useGenerateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>(GenerateUploadUrlDocument, options);
      }
export type GenerateUploadUrlMutationHookResult = ReturnType<typeof useGenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationResult = Apollo.MutationResult<GenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;
export const InAppNotificationsMarkSeenDocument = gql`
    mutation InAppNotificationsMarkSeen($ids: [ID!]) {
  inAppNotificationsMarkSeen(ids: $ids)
}
    `;
export type InAppNotificationsMarkSeenMutationFn = Apollo.MutationFunction<InAppNotificationsMarkSeenMutation, InAppNotificationsMarkSeenMutationVariables>;

/**
 * __useInAppNotificationsMarkSeenMutation__
 *
 * To run a mutation, you first call `useInAppNotificationsMarkSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInAppNotificationsMarkSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inAppNotificationsMarkSeenMutation, { data, loading, error }] = useInAppNotificationsMarkSeenMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInAppNotificationsMarkSeenMutation(baseOptions?: Apollo.MutationHookOptions<InAppNotificationsMarkSeenMutation, InAppNotificationsMarkSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InAppNotificationsMarkSeenMutation, InAppNotificationsMarkSeenMutationVariables>(InAppNotificationsMarkSeenDocument, options);
      }
export type InAppNotificationsMarkSeenMutationHookResult = ReturnType<typeof useInAppNotificationsMarkSeenMutation>;
export type InAppNotificationsMarkSeenMutationResult = Apollo.MutationResult<InAppNotificationsMarkSeenMutation>;
export type InAppNotificationsMarkSeenMutationOptions = Apollo.BaseMutationOptions<InAppNotificationsMarkSeenMutation, InAppNotificationsMarkSeenMutationVariables>;
export const IntegrationDeliveryRetryDocument = gql`
    mutation IntegrationDeliveryRetry($deliveryId: MongoID, $integrationId: MongoID) {
  integrationDeliveryRetry(deliveryId: $deliveryId, integrationId: $integrationId) {
    requeued
    reason
  }
}
    `;
export type IntegrationDeliveryRetryMutationFn = Apollo.MutationFunction<IntegrationDeliveryRetryMutation, IntegrationDeliveryRetryMutationVariables>;

/**
 * __useIntegrationDeliveryRetryMutation__
 *
 * To run a mutation, you first call `useIntegrationDeliveryRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDeliveryRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationDeliveryRetryMutation, { data, loading, error }] = useIntegrationDeliveryRetryMutation({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationDeliveryRetryMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationDeliveryRetryMutation, IntegrationDeliveryRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationDeliveryRetryMutation, IntegrationDeliveryRetryMutationVariables>(IntegrationDeliveryRetryDocument, options);
      }
export type IntegrationDeliveryRetryMutationHookResult = ReturnType<typeof useIntegrationDeliveryRetryMutation>;
export type IntegrationDeliveryRetryMutationResult = Apollo.MutationResult<IntegrationDeliveryRetryMutation>;
export type IntegrationDeliveryRetryMutationOptions = Apollo.BaseMutationOptions<IntegrationDeliveryRetryMutation, IntegrationDeliveryRetryMutationVariables>;
export const IntegrationInboundRecordResolveDocument = gql`
    mutation IntegrationInboundRecordResolve($recordId: MongoID!, $action: String!) {
  integrationInboundRecordResolve(recordId: $recordId, action: $action) {
    _id
    status
    error
    match {
      animal
      matchedOn
      matchedValue
    }
  }
}
    `;
export type IntegrationInboundRecordResolveMutationFn = Apollo.MutationFunction<IntegrationInboundRecordResolveMutation, IntegrationInboundRecordResolveMutationVariables>;

/**
 * __useIntegrationInboundRecordResolveMutation__
 *
 * To run a mutation, you first call `useIntegrationInboundRecordResolveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationInboundRecordResolveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationInboundRecordResolveMutation, { data, loading, error }] = useIntegrationInboundRecordResolveMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useIntegrationInboundRecordResolveMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationInboundRecordResolveMutation, IntegrationInboundRecordResolveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationInboundRecordResolveMutation, IntegrationInboundRecordResolveMutationVariables>(IntegrationInboundRecordResolveDocument, options);
      }
export type IntegrationInboundRecordResolveMutationHookResult = ReturnType<typeof useIntegrationInboundRecordResolveMutation>;
export type IntegrationInboundRecordResolveMutationResult = Apollo.MutationResult<IntegrationInboundRecordResolveMutation>;
export type IntegrationInboundRecordResolveMutationOptions = Apollo.BaseMutationOptions<IntegrationInboundRecordResolveMutation, IntegrationInboundRecordResolveMutationVariables>;
export const IntegrationInitDocument = gql`
    mutation IntegrationInit($integrationName: EnumIntegrationName!, $shop: String) {
  integrationInit(integrationName: $integrationName, shop: $shop) {
    name
    type
    endpoint
    _id
  }
}
    `;
export type IntegrationInitMutationFn = Apollo.MutationFunction<IntegrationInitMutation, IntegrationInitMutationVariables>;

/**
 * __useIntegrationInitMutation__
 *
 * To run a mutation, you first call `useIntegrationInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationInitMutation, { data, loading, error }] = useIntegrationInitMutation({
 *   variables: {
 *      integrationName: // value for 'integrationName'
 *      shop: // value for 'shop'
 *   },
 * });
 */
export function useIntegrationInitMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationInitMutation, IntegrationInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationInitMutation, IntegrationInitMutationVariables>(IntegrationInitDocument, options);
      }
export type IntegrationInitMutationHookResult = ReturnType<typeof useIntegrationInitMutation>;
export type IntegrationInitMutationResult = Apollo.MutationResult<IntegrationInitMutation>;
export type IntegrationInitMutationOptions = Apollo.BaseMutationOptions<IntegrationInitMutation, IntegrationInitMutationVariables>;
export const IntegrationPollNowDocument = gql`
    mutation IntegrationPollNow($adapter: String!) {
  integrationPollNow(adapter: $adapter) {
    ok
    received
    matched
    applied
    unmatched
    duplicates
    reason
  }
}
    `;
export type IntegrationPollNowMutationFn = Apollo.MutationFunction<IntegrationPollNowMutation, IntegrationPollNowMutationVariables>;

/**
 * __useIntegrationPollNowMutation__
 *
 * To run a mutation, you first call `useIntegrationPollNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationPollNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationPollNowMutation, { data, loading, error }] = useIntegrationPollNowMutation({
 *   variables: {
 *      adapter: // value for 'adapter'
 *   },
 * });
 */
export function useIntegrationPollNowMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationPollNowMutation, IntegrationPollNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationPollNowMutation, IntegrationPollNowMutationVariables>(IntegrationPollNowDocument, options);
      }
export type IntegrationPollNowMutationHookResult = ReturnType<typeof useIntegrationPollNowMutation>;
export type IntegrationPollNowMutationResult = Apollo.MutationResult<IntegrationPollNowMutation>;
export type IntegrationPollNowMutationOptions = Apollo.BaseMutationOptions<IntegrationPollNowMutation, IntegrationPollNowMutationVariables>;
export const InvoiceCreateForSchedulingJobDocument = gql`
    mutation InvoiceCreateForSchedulingJob($input: CreateInvoiceForSchedulingJobInput!) {
  invoiceCreateForSchedulingJob(input: $input) {
    _id
    number
    status
    amount_due
    amount_discounted
    due_date
    type
    user {
      _id
      first_name
      last_name
      email
    }
  }
}
    `;
export type InvoiceCreateForSchedulingJobMutationFn = Apollo.MutationFunction<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>;

/**
 * __useInvoiceCreateForSchedulingJobMutation__
 *
 * To run a mutation, you first call `useInvoiceCreateForSchedulingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreateForSchedulingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCreateForSchedulingJobMutation, { data, loading, error }] = useInvoiceCreateForSchedulingJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceCreateForSchedulingJobMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>(InvoiceCreateForSchedulingJobDocument, options);
      }
export type InvoiceCreateForSchedulingJobMutationHookResult = ReturnType<typeof useInvoiceCreateForSchedulingJobMutation>;
export type InvoiceCreateForSchedulingJobMutationResult = Apollo.MutationResult<InvoiceCreateForSchedulingJobMutation>;
export type InvoiceCreateForSchedulingJobMutationOptions = Apollo.BaseMutationOptions<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>;
export const InvoiceFinalizeAndSendDocument = gql`
    mutation InvoiceFinalizeAndSend($input: VoidInvoiceInput) {
  invoiceFinalizeAndSend(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceFinalizeAndSendMutationFn = Apollo.MutationFunction<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>;

/**
 * __useInvoiceFinalizeAndSendMutation__
 *
 * To run a mutation, you first call `useInvoiceFinalizeAndSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceFinalizeAndSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceFinalizeAndSendMutation, { data, loading, error }] = useInvoiceFinalizeAndSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceFinalizeAndSendMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>(InvoiceFinalizeAndSendDocument, options);
      }
export type InvoiceFinalizeAndSendMutationHookResult = ReturnType<typeof useInvoiceFinalizeAndSendMutation>;
export type InvoiceFinalizeAndSendMutationResult = Apollo.MutationResult<InvoiceFinalizeAndSendMutation>;
export type InvoiceFinalizeAndSendMutationOptions = Apollo.BaseMutationOptions<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>;
export const GenerateInvoicePdfDocument = gql`
    mutation generateInvoicePdf($invoiceId: MongoID!) {
  generateInvoicePdf(invoiceId: $invoiceId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type GenerateInvoicePdfMutationFn = Apollo.MutationFunction<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;

/**
 * __useGenerateInvoicePdfMutation__
 *
 * To run a mutation, you first call `useGenerateInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoicePdfMutation, { data, loading, error }] = useGenerateInvoicePdfMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGenerateInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>(GenerateInvoicePdfDocument, options);
      }
export type GenerateInvoicePdfMutationHookResult = ReturnType<typeof useGenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationResult = Apollo.MutationResult<GenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationOptions = Apollo.BaseMutationOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;
export const InvoiceMarkAsPaidDocument = gql`
    mutation InvoiceMarkAsPaid($input: MarkAsPaidInput) {
  invoiceMarkAsPaid(input: $input) {
    ...InvoiceFragment
    followUp {
      jobId
      jobSettled
      customerOpenInvoiceCount
      customerOutstandingBalance
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceMarkAsPaidMutationFn = Apollo.MutationFunction<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>;

/**
 * __useInvoiceMarkAsPaidMutation__
 *
 * To run a mutation, you first call `useInvoiceMarkAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceMarkAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceMarkAsPaidMutation, { data, loading, error }] = useInvoiceMarkAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceMarkAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>(InvoiceMarkAsPaidDocument, options);
      }
export type InvoiceMarkAsPaidMutationHookResult = ReturnType<typeof useInvoiceMarkAsPaidMutation>;
export type InvoiceMarkAsPaidMutationResult = Apollo.MutationResult<InvoiceMarkAsPaidMutation>;
export type InvoiceMarkAsPaidMutationOptions = Apollo.BaseMutationOptions<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>;
export const InvoiceRefundDocument = gql`
    mutation InvoiceRefund($input: RefundInvoiceInput) {
  invoiceRefund(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceRefundMutationFn = Apollo.MutationFunction<InvoiceRefundMutation, InvoiceRefundMutationVariables>;

/**
 * __useInvoiceRefundMutation__
 *
 * To run a mutation, you first call `useInvoiceRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRefundMutation, { data, loading, error }] = useInvoiceRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceRefundMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceRefundMutation, InvoiceRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceRefundMutation, InvoiceRefundMutationVariables>(InvoiceRefundDocument, options);
      }
export type InvoiceRefundMutationHookResult = ReturnType<typeof useInvoiceRefundMutation>;
export type InvoiceRefundMutationResult = Apollo.MutationResult<InvoiceRefundMutation>;
export type InvoiceRefundMutationOptions = Apollo.BaseMutationOptions<InvoiceRefundMutation, InvoiceRefundMutationVariables>;
export const InvoiceUpdateDocument = gql`
    mutation InvoiceUpdate($input: UpdateInvoiceInput) {
  invoiceUpdate(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceUpdateMutationFn = Apollo.MutationFunction<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;

/**
 * __useInvoiceUpdateMutation__
 *
 * To run a mutation, you first call `useInvoiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceUpdateMutation, { data, loading, error }] = useInvoiceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>(InvoiceUpdateDocument, options);
      }
export type InvoiceUpdateMutationHookResult = ReturnType<typeof useInvoiceUpdateMutation>;
export type InvoiceUpdateMutationResult = Apollo.MutationResult<InvoiceUpdateMutation>;
export type InvoiceUpdateMutationOptions = Apollo.BaseMutationOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;
export const InvoiceVoidDocument = gql`
    mutation InvoiceVoid($input: VoidInvoiceInput) {
  invoiceVoid(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceVoidMutationFn = Apollo.MutationFunction<InvoiceVoidMutation, InvoiceVoidMutationVariables>;

/**
 * __useInvoiceVoidMutation__
 *
 * To run a mutation, you first call `useInvoiceVoidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceVoidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceVoidMutation, { data, loading, error }] = useInvoiceVoidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceVoidMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceVoidMutation, InvoiceVoidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceVoidMutation, InvoiceVoidMutationVariables>(InvoiceVoidDocument, options);
      }
export type InvoiceVoidMutationHookResult = ReturnType<typeof useInvoiceVoidMutation>;
export type InvoiceVoidMutationResult = Apollo.MutationResult<InvoiceVoidMutation>;
export type InvoiceVoidMutationOptions = Apollo.BaseMutationOptions<InvoiceVoidMutation, InvoiceVoidMutationVariables>;
export const JobIntegrationPushDocument = gql`
    mutation JobIntegrationPush($jobId: MongoID!, $adapter: String, $integrationId: MongoID) {
  jobIntegrationPush(
    jobId: $jobId
    adapter: $adapter
    integrationId: $integrationId
  ) {
    queued
    integrations
    reason
  }
}
    `;
export type JobIntegrationPushMutationFn = Apollo.MutationFunction<JobIntegrationPushMutation, JobIntegrationPushMutationVariables>;

/**
 * __useJobIntegrationPushMutation__
 *
 * To run a mutation, you first call `useJobIntegrationPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobIntegrationPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobIntegrationPushMutation, { data, loading, error }] = useJobIntegrationPushMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      adapter: // value for 'adapter'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useJobIntegrationPushMutation(baseOptions?: Apollo.MutationHookOptions<JobIntegrationPushMutation, JobIntegrationPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobIntegrationPushMutation, JobIntegrationPushMutationVariables>(JobIntegrationPushDocument, options);
      }
export type JobIntegrationPushMutationHookResult = ReturnType<typeof useJobIntegrationPushMutation>;
export type JobIntegrationPushMutationResult = Apollo.MutationResult<JobIntegrationPushMutation>;
export type JobIntegrationPushMutationOptions = Apollo.BaseMutationOptions<JobIntegrationPushMutation, JobIntegrationPushMutationVariables>;
export const JobTagCreateOneDocument = gql`
    mutation JobTagCreateOne($record: CreateOneJobTagInput!) {
  jobTagCreateOne(record: $record) {
    record {
      _id
      vendor
      name
      icon
      species
      isEnabled
      sortOrder
    }
  }
}
    `;
export type JobTagCreateOneMutationFn = Apollo.MutationFunction<JobTagCreateOneMutation, JobTagCreateOneMutationVariables>;

/**
 * __useJobTagCreateOneMutation__
 *
 * To run a mutation, you first call `useJobTagCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobTagCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobTagCreateOneMutation, { data, loading, error }] = useJobTagCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useJobTagCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<JobTagCreateOneMutation, JobTagCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobTagCreateOneMutation, JobTagCreateOneMutationVariables>(JobTagCreateOneDocument, options);
      }
export type JobTagCreateOneMutationHookResult = ReturnType<typeof useJobTagCreateOneMutation>;
export type JobTagCreateOneMutationResult = Apollo.MutationResult<JobTagCreateOneMutation>;
export type JobTagCreateOneMutationOptions = Apollo.BaseMutationOptions<JobTagCreateOneMutation, JobTagCreateOneMutationVariables>;
export const JobTagRemoveByIdDocument = gql`
    mutation JobTagRemoveById($id: MongoID!) {
  jobTagRemoveById(_id: $id) {
    recordId
  }
}
    `;
export type JobTagRemoveByIdMutationFn = Apollo.MutationFunction<JobTagRemoveByIdMutation, JobTagRemoveByIdMutationVariables>;

/**
 * __useJobTagRemoveByIdMutation__
 *
 * To run a mutation, you first call `useJobTagRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobTagRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobTagRemoveByIdMutation, { data, loading, error }] = useJobTagRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobTagRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<JobTagRemoveByIdMutation, JobTagRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobTagRemoveByIdMutation, JobTagRemoveByIdMutationVariables>(JobTagRemoveByIdDocument, options);
      }
export type JobTagRemoveByIdMutationHookResult = ReturnType<typeof useJobTagRemoveByIdMutation>;
export type JobTagRemoveByIdMutationResult = Apollo.MutationResult<JobTagRemoveByIdMutation>;
export type JobTagRemoveByIdMutationOptions = Apollo.BaseMutationOptions<JobTagRemoveByIdMutation, JobTagRemoveByIdMutationVariables>;
export const JobTagUpdateByIdDocument = gql`
    mutation JobTagUpdateById($id: MongoID!, $record: UpdateByIdJobTagInput!) {
  jobTagUpdateById(_id: $id, record: $record) {
    record {
      _id
      vendor
      name
      icon
      species
      isEnabled
      sortOrder
    }
  }
}
    `;
export type JobTagUpdateByIdMutationFn = Apollo.MutationFunction<JobTagUpdateByIdMutation, JobTagUpdateByIdMutationVariables>;

/**
 * __useJobTagUpdateByIdMutation__
 *
 * To run a mutation, you first call `useJobTagUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobTagUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobTagUpdateByIdMutation, { data, loading, error }] = useJobTagUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useJobTagUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<JobTagUpdateByIdMutation, JobTagUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobTagUpdateByIdMutation, JobTagUpdateByIdMutationVariables>(JobTagUpdateByIdDocument, options);
      }
export type JobTagUpdateByIdMutationHookResult = ReturnType<typeof useJobTagUpdateByIdMutation>;
export type JobTagUpdateByIdMutationResult = Apollo.MutationResult<JobTagUpdateByIdMutation>;
export type JobTagUpdateByIdMutationOptions = Apollo.BaseMutationOptions<JobTagUpdateByIdMutation, JobTagUpdateByIdMutationVariables>;
export const KillSheetPreviewDocument = gql`
    mutation KillSheetPreview($vendorId: MongoID!) {
  killSheetPreview(vendorId: $vendorId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type KillSheetPreviewMutationFn = Apollo.MutationFunction<KillSheetPreviewMutation, KillSheetPreviewMutationVariables>;

/**
 * __useKillSheetPreviewMutation__
 *
 * To run a mutation, you first call `useKillSheetPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKillSheetPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [killSheetPreviewMutation, { data, loading, error }] = useKillSheetPreviewMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useKillSheetPreviewMutation(baseOptions?: Apollo.MutationHookOptions<KillSheetPreviewMutation, KillSheetPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KillSheetPreviewMutation, KillSheetPreviewMutationVariables>(KillSheetPreviewDocument, options);
      }
export type KillSheetPreviewMutationHookResult = ReturnType<typeof useKillSheetPreviewMutation>;
export type KillSheetPreviewMutationResult = Apollo.MutationResult<KillSheetPreviewMutation>;
export type KillSheetPreviewMutationOptions = Apollo.BaseMutationOptions<KillSheetPreviewMutation, KillSheetPreviewMutationVariables>;
export const LandingPageUpsertDocument = gql`
    mutation LandingPageUpsert($input: LandingPageUpsertInput!) {
  landingPageUpsert(input: $input) {
    ...LandingPageFragment
  }
}
    ${LandingPageFragmentFragmentDoc}`;
export type LandingPageUpsertMutationFn = Apollo.MutationFunction<LandingPageUpsertMutation, LandingPageUpsertMutationVariables>;

/**
 * __useLandingPageUpsertMutation__
 *
 * To run a mutation, you first call `useLandingPageUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLandingPageUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [landingPageUpsertMutation, { data, loading, error }] = useLandingPageUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLandingPageUpsertMutation(baseOptions?: Apollo.MutationHookOptions<LandingPageUpsertMutation, LandingPageUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LandingPageUpsertMutation, LandingPageUpsertMutationVariables>(LandingPageUpsertDocument, options);
      }
export type LandingPageUpsertMutationHookResult = ReturnType<typeof useLandingPageUpsertMutation>;
export type LandingPageUpsertMutationResult = Apollo.MutationResult<LandingPageUpsertMutation>;
export type LandingPageUpsertMutationOptions = Apollo.BaseMutationOptions<LandingPageUpsertMutation, LandingPageUpsertMutationVariables>;
export const MarkChatRoomAsReadDocument = gql`
    mutation MarkChatRoomAsRead($chatRoomId: MongoID!, $markMessagesRead: Boolean) {
  markChatRoomAsRead(chatRoomId: $chatRoomId, markMessagesRead: $markMessagesRead) {
    _id
    unreadMessagesCount
    markedUnread
  }
}
    `;
export type MarkChatRoomAsReadMutationFn = Apollo.MutationFunction<MarkChatRoomAsReadMutation, MarkChatRoomAsReadMutationVariables>;

/**
 * __useMarkChatRoomAsReadMutation__
 *
 * To run a mutation, you first call `useMarkChatRoomAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatRoomAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatRoomAsReadMutation, { data, loading, error }] = useMarkChatRoomAsReadMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      markMessagesRead: // value for 'markMessagesRead'
 *   },
 * });
 */
export function useMarkChatRoomAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkChatRoomAsReadMutation, MarkChatRoomAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChatRoomAsReadMutation, MarkChatRoomAsReadMutationVariables>(MarkChatRoomAsReadDocument, options);
      }
export type MarkChatRoomAsReadMutationHookResult = ReturnType<typeof useMarkChatRoomAsReadMutation>;
export type MarkChatRoomAsReadMutationResult = Apollo.MutationResult<MarkChatRoomAsReadMutation>;
export type MarkChatRoomAsReadMutationOptions = Apollo.BaseMutationOptions<MarkChatRoomAsReadMutation, MarkChatRoomAsReadMutationVariables>;
export const MarkChatRoomAsUnreadDocument = gql`
    mutation MarkChatRoomAsUnread($chatRoomId: MongoID!) {
  markChatRoomAsUnread(chatRoomId: $chatRoomId) {
    _id
    unreadMessagesCount
    markedUnread
  }
}
    `;
export type MarkChatRoomAsUnreadMutationFn = Apollo.MutationFunction<MarkChatRoomAsUnreadMutation, MarkChatRoomAsUnreadMutationVariables>;

/**
 * __useMarkChatRoomAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkChatRoomAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatRoomAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatRoomAsUnreadMutation, { data, loading, error }] = useMarkChatRoomAsUnreadMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *   },
 * });
 */
export function useMarkChatRoomAsUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkChatRoomAsUnreadMutation, MarkChatRoomAsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChatRoomAsUnreadMutation, MarkChatRoomAsUnreadMutationVariables>(MarkChatRoomAsUnreadDocument, options);
      }
export type MarkChatRoomAsUnreadMutationHookResult = ReturnType<typeof useMarkChatRoomAsUnreadMutation>;
export type MarkChatRoomAsUnreadMutationResult = Apollo.MutationResult<MarkChatRoomAsUnreadMutation>;
export type MarkChatRoomAsUnreadMutationOptions = Apollo.BaseMutationOptions<MarkChatRoomAsUnreadMutation, MarkChatRoomAsUnreadMutationVariables>;
export const MarketplaceLeadSubmitDocument = gql`
    mutation MarketplaceLeadSubmit($species: String!, $quantity: String!, $timeline: String!, $postcode: String!, $name: String!, $email: String!, $phone: String!, $note: String, $source: String) {
  marketplaceLeadSubmit(
    species: $species
    quantity: $quantity
    timeline: $timeline
    postcode: $postcode
    name: $name
    email: $email
    phone: $phone
    note: $note
    source: $source
  )
}
    `;
export type MarketplaceLeadSubmitMutationFn = Apollo.MutationFunction<MarketplaceLeadSubmitMutation, MarketplaceLeadSubmitMutationVariables>;

/**
 * __useMarketplaceLeadSubmitMutation__
 *
 * To run a mutation, you first call `useMarketplaceLeadSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceLeadSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceLeadSubmitMutation, { data, loading, error }] = useMarketplaceLeadSubmitMutation({
 *   variables: {
 *      species: // value for 'species'
 *      quantity: // value for 'quantity'
 *      timeline: // value for 'timeline'
 *      postcode: // value for 'postcode'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      note: // value for 'note'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useMarketplaceLeadSubmitMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceLeadSubmitMutation, MarketplaceLeadSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceLeadSubmitMutation, MarketplaceLeadSubmitMutationVariables>(MarketplaceLeadSubmitDocument, options);
      }
export type MarketplaceLeadSubmitMutationHookResult = ReturnType<typeof useMarketplaceLeadSubmitMutation>;
export type MarketplaceLeadSubmitMutationResult = Apollo.MutationResult<MarketplaceLeadSubmitMutation>;
export type MarketplaceLeadSubmitMutationOptions = Apollo.BaseMutationOptions<MarketplaceLeadSubmitMutation, MarketplaceLeadSubmitMutationVariables>;
export const MyAddOnJobSplitDocument = gql`
    mutation MyAddOnJobSplit($animalId: MongoID!, $splitPart: String!, $buyerId: MongoID!) {
  myAddOnJobSplit(animalId: $animalId, splitPart: $splitPart, buyerId: $buyerId) {
    _id
  }
}
    `;
export type MyAddOnJobSplitMutationFn = Apollo.MutationFunction<MyAddOnJobSplitMutation, MyAddOnJobSplitMutationVariables>;

/**
 * __useMyAddOnJobSplitMutation__
 *
 * To run a mutation, you first call `useMyAddOnJobSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAddOnJobSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAddOnJobSplitMutation, { data, loading, error }] = useMyAddOnJobSplitMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      splitPart: // value for 'splitPart'
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useMyAddOnJobSplitMutation(baseOptions?: Apollo.MutationHookOptions<MyAddOnJobSplitMutation, MyAddOnJobSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAddOnJobSplitMutation, MyAddOnJobSplitMutationVariables>(MyAddOnJobSplitDocument, options);
      }
export type MyAddOnJobSplitMutationHookResult = ReturnType<typeof useMyAddOnJobSplitMutation>;
export type MyAddOnJobSplitMutationResult = Apollo.MutationResult<MyAddOnJobSplitMutation>;
export type MyAddOnJobSplitMutationOptions = Apollo.BaseMutationOptions<MyAddOnJobSplitMutation, MyAddOnJobSplitMutationVariables>;
export const MyAnimalAssignToJobDocument = gql`
    mutation MyAnimalAssignToJob($jobId: MongoID!, $animalIds: [MongoID!]!, $inspectionLevel: EnumProcessorSchedulingAnimalHeadsInspectionLevel, $listing: ProcessorSchedulingListingInput) {
  myAnimalAssignToJob(
    jobId: $jobId
    animalIds: $animalIds
    inspectionLevel: $inspectionLevel
    listing: $listing
  ) {
    jobId
    assignedCount
  }
}
    `;
export type MyAnimalAssignToJobMutationFn = Apollo.MutationFunction<MyAnimalAssignToJobMutation, MyAnimalAssignToJobMutationVariables>;

/**
 * __useMyAnimalAssignToJobMutation__
 *
 * To run a mutation, you first call `useMyAnimalAssignToJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalAssignToJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAnimalAssignToJobMutation, { data, loading, error }] = useMyAnimalAssignToJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      animalIds: // value for 'animalIds'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      listing: // value for 'listing'
 *   },
 * });
 */
export function useMyAnimalAssignToJobMutation(baseOptions?: Apollo.MutationHookOptions<MyAnimalAssignToJobMutation, MyAnimalAssignToJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAnimalAssignToJobMutation, MyAnimalAssignToJobMutationVariables>(MyAnimalAssignToJobDocument, options);
      }
export type MyAnimalAssignToJobMutationHookResult = ReturnType<typeof useMyAnimalAssignToJobMutation>;
export type MyAnimalAssignToJobMutationResult = Apollo.MutationResult<MyAnimalAssignToJobMutation>;
export type MyAnimalAssignToJobMutationOptions = Apollo.BaseMutationOptions<MyAnimalAssignToJobMutation, MyAnimalAssignToJobMutationVariables>;
export const MyAnimalCsvImportUploadDocument = gql`
    mutation MyAnimalCsvImportUpload($file: Upload!) {
  myAnimalCsvImportUpload(file: $file) {
    jobId
    totalRows
    validRows
    invalidRows
    validFilePath
    invalidFilePath
    validationErrors {
      row
      errorMessages
    }
    availableColumns {
      fieldName
      aliases
      required
      description
      validationRules
    }
    detectedColumns
    suggestedMapping
  }
}
    `;
export type MyAnimalCsvImportUploadMutationFn = Apollo.MutationFunction<MyAnimalCsvImportUploadMutation, MyAnimalCsvImportUploadMutationVariables>;

/**
 * __useMyAnimalCsvImportUploadMutation__
 *
 * To run a mutation, you first call `useMyAnimalCsvImportUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalCsvImportUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAnimalCsvImportUploadMutation, { data, loading, error }] = useMyAnimalCsvImportUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useMyAnimalCsvImportUploadMutation(baseOptions?: Apollo.MutationHookOptions<MyAnimalCsvImportUploadMutation, MyAnimalCsvImportUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAnimalCsvImportUploadMutation, MyAnimalCsvImportUploadMutationVariables>(MyAnimalCsvImportUploadDocument, options);
      }
export type MyAnimalCsvImportUploadMutationHookResult = ReturnType<typeof useMyAnimalCsvImportUploadMutation>;
export type MyAnimalCsvImportUploadMutationResult = Apollo.MutationResult<MyAnimalCsvImportUploadMutation>;
export type MyAnimalCsvImportUploadMutationOptions = Apollo.BaseMutationOptions<MyAnimalCsvImportUploadMutation, MyAnimalCsvImportUploadMutationVariables>;
export const MyAnimalDeleteDocument = gql`
    mutation MyAnimalDelete($id: MongoID!) {
  myAnimalDelete(_id: $id) {
    _id
  }
}
    `;
export type MyAnimalDeleteMutationFn = Apollo.MutationFunction<MyAnimalDeleteMutation, MyAnimalDeleteMutationVariables>;

/**
 * __useMyAnimalDeleteMutation__
 *
 * To run a mutation, you first call `useMyAnimalDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAnimalDeleteMutation, { data, loading, error }] = useMyAnimalDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyAnimalDeleteMutation(baseOptions?: Apollo.MutationHookOptions<MyAnimalDeleteMutation, MyAnimalDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAnimalDeleteMutation, MyAnimalDeleteMutationVariables>(MyAnimalDeleteDocument, options);
      }
export type MyAnimalDeleteMutationHookResult = ReturnType<typeof useMyAnimalDeleteMutation>;
export type MyAnimalDeleteMutationResult = Apollo.MutationResult<MyAnimalDeleteMutation>;
export type MyAnimalDeleteMutationOptions = Apollo.BaseMutationOptions<MyAnimalDeleteMutation, MyAnimalDeleteMutationVariables>;
export const MyAnimalQuickAddDocument = gql`
    mutation MyAnimalQuickAdd($animals: [QuickAddAnimalInput!]!) {
  myAnimalQuickAdd(animals: $animals) {
    _id
    species
    tracking
    splitType
    producerIdentifier
  }
}
    `;
export type MyAnimalQuickAddMutationFn = Apollo.MutationFunction<MyAnimalQuickAddMutation, MyAnimalQuickAddMutationVariables>;

/**
 * __useMyAnimalQuickAddMutation__
 *
 * To run a mutation, you first call `useMyAnimalQuickAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalQuickAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAnimalQuickAddMutation, { data, loading, error }] = useMyAnimalQuickAddMutation({
 *   variables: {
 *      animals: // value for 'animals'
 *   },
 * });
 */
export function useMyAnimalQuickAddMutation(baseOptions?: Apollo.MutationHookOptions<MyAnimalQuickAddMutation, MyAnimalQuickAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAnimalQuickAddMutation, MyAnimalQuickAddMutationVariables>(MyAnimalQuickAddDocument, options);
      }
export type MyAnimalQuickAddMutationHookResult = ReturnType<typeof useMyAnimalQuickAddMutation>;
export type MyAnimalQuickAddMutationResult = Apollo.MutationResult<MyAnimalQuickAddMutation>;
export type MyAnimalQuickAddMutationOptions = Apollo.BaseMutationOptions<MyAnimalQuickAddMutation, MyAnimalQuickAddMutationVariables>;
export const MyAnimalSetSplitBuyersDocument = gql`
    mutation MyAnimalSetSplitBuyers($id: MongoID!, $splits: [HerdSplitBuyerInput!]!) {
  myAnimalSetSplitBuyers(_id: $id, splits: $splits) {
    _id
    splits {
      splitPart
      buyer {
        _id
        first_name
        last_name
        company
      }
    }
  }
}
    `;
export type MyAnimalSetSplitBuyersMutationFn = Apollo.MutationFunction<MyAnimalSetSplitBuyersMutation, MyAnimalSetSplitBuyersMutationVariables>;

/**
 * __useMyAnimalSetSplitBuyersMutation__
 *
 * To run a mutation, you first call `useMyAnimalSetSplitBuyersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalSetSplitBuyersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAnimalSetSplitBuyersMutation, { data, loading, error }] = useMyAnimalSetSplitBuyersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      splits: // value for 'splits'
 *   },
 * });
 */
export function useMyAnimalSetSplitBuyersMutation(baseOptions?: Apollo.MutationHookOptions<MyAnimalSetSplitBuyersMutation, MyAnimalSetSplitBuyersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAnimalSetSplitBuyersMutation, MyAnimalSetSplitBuyersMutationVariables>(MyAnimalSetSplitBuyersDocument, options);
      }
export type MyAnimalSetSplitBuyersMutationHookResult = ReturnType<typeof useMyAnimalSetSplitBuyersMutation>;
export type MyAnimalSetSplitBuyersMutationResult = Apollo.MutationResult<MyAnimalSetSplitBuyersMutation>;
export type MyAnimalSetSplitBuyersMutationOptions = Apollo.BaseMutationOptions<MyAnimalSetSplitBuyersMutation, MyAnimalSetSplitBuyersMutationVariables>;
export const MyAnimalUpdateDocument = gql`
    mutation MyAnimalUpdate($id: MongoID!, $species: String, $tracking: String, $splitType: String, $liveWeight: Float, $sex: String, $hangTimeDays: Int, $isOverThirtyMonths: Boolean, $availableToBuyers: Boolean, $allowedSectionSizes: [String], $claimMode: String, $listingRatePerLb: Float, $listingDeposits: MyAnimalListingDepositsInput, $descriptorChips: [String], $producerDescription: String, $sizeTier: String, $liveWeightHigh: Float, $listingTotalPrice: Float) {
  myAnimalUpdate(
    _id: $id
    species: $species
    tracking: $tracking
    splitType: $splitType
    liveWeight: $liveWeight
    sex: $sex
    hangTimeDays: $hangTimeDays
    isOverThirtyMonths: $isOverThirtyMonths
    availableToBuyers: $availableToBuyers
    allowedSectionSizes: $allowedSectionSizes
    claimMode: $claimMode
    listingRatePerLb: $listingRatePerLb
    listingDeposits: $listingDeposits
    descriptorChips: $descriptorChips
    producerDescription: $producerDescription
    sizeTier: $sizeTier
    liveWeightHigh: $liveWeightHigh
    listingTotalPrice: $listingTotalPrice
  ) {
    _id
    species
    tracking
    splitType
    liveWeight
    sex
    hangTimeDays
    isOverThirtyMonths
    availableToBuyers
    allowedSectionSizes
    claimMode
    listingRatePerLb
    listingDeposits {
      whole
      half
      quarter
    }
    descriptorChips
    producerDescription
    sizeTier
    liveWeightHigh
    listingTotalPrice
    remainingCapacity
    isFull
  }
}
    `;
export type MyAnimalUpdateMutationFn = Apollo.MutationFunction<MyAnimalUpdateMutation, MyAnimalUpdateMutationVariables>;

/**
 * __useMyAnimalUpdateMutation__
 *
 * To run a mutation, you first call `useMyAnimalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myAnimalUpdateMutation, { data, loading, error }] = useMyAnimalUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      species: // value for 'species'
 *      tracking: // value for 'tracking'
 *      splitType: // value for 'splitType'
 *      liveWeight: // value for 'liveWeight'
 *      sex: // value for 'sex'
 *      hangTimeDays: // value for 'hangTimeDays'
 *      isOverThirtyMonths: // value for 'isOverThirtyMonths'
 *      availableToBuyers: // value for 'availableToBuyers'
 *      allowedSectionSizes: // value for 'allowedSectionSizes'
 *      claimMode: // value for 'claimMode'
 *      listingRatePerLb: // value for 'listingRatePerLb'
 *      listingDeposits: // value for 'listingDeposits'
 *      descriptorChips: // value for 'descriptorChips'
 *      producerDescription: // value for 'producerDescription'
 *      sizeTier: // value for 'sizeTier'
 *      liveWeightHigh: // value for 'liveWeightHigh'
 *      listingTotalPrice: // value for 'listingTotalPrice'
 *   },
 * });
 */
export function useMyAnimalUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MyAnimalUpdateMutation, MyAnimalUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyAnimalUpdateMutation, MyAnimalUpdateMutationVariables>(MyAnimalUpdateDocument, options);
      }
export type MyAnimalUpdateMutationHookResult = ReturnType<typeof useMyAnimalUpdateMutation>;
export type MyAnimalUpdateMutationResult = Apollo.MutationResult<MyAnimalUpdateMutation>;
export type MyAnimalUpdateMutationOptions = Apollo.BaseMutationOptions<MyAnimalUpdateMutation, MyAnimalUpdateMutationVariables>;
export const MyGenerateSaleInvoiceDocument = gql`
    mutation MyGenerateSaleInvoice($splitId: MongoID!, $saleAmount: Float!, $adjustments: [OrderAdjustmentInput!]) {
  myGenerateSaleInvoice(
    splitId: $splitId
    saleAmount: $saleAmount
    adjustments: $adjustments
  ) {
    _id
    status
    finalAmount
    saleBaseAmount
    adjustments {
      label
      amount
    }
    balanceDue
    invoicedAt
  }
}
    `;
export type MyGenerateSaleInvoiceMutationFn = Apollo.MutationFunction<MyGenerateSaleInvoiceMutation, MyGenerateSaleInvoiceMutationVariables>;

/**
 * __useMyGenerateSaleInvoiceMutation__
 *
 * To run a mutation, you first call `useMyGenerateSaleInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyGenerateSaleInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myGenerateSaleInvoiceMutation, { data, loading, error }] = useMyGenerateSaleInvoiceMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      saleAmount: // value for 'saleAmount'
 *      adjustments: // value for 'adjustments'
 *   },
 * });
 */
export function useMyGenerateSaleInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<MyGenerateSaleInvoiceMutation, MyGenerateSaleInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyGenerateSaleInvoiceMutation, MyGenerateSaleInvoiceMutationVariables>(MyGenerateSaleInvoiceDocument, options);
      }
export type MyGenerateSaleInvoiceMutationHookResult = ReturnType<typeof useMyGenerateSaleInvoiceMutation>;
export type MyGenerateSaleInvoiceMutationResult = Apollo.MutationResult<MyGenerateSaleInvoiceMutation>;
export type MyGenerateSaleInvoiceMutationOptions = Apollo.BaseMutationOptions<MyGenerateSaleInvoiceMutation, MyGenerateSaleInvoiceMutationVariables>;
export const MyMarkOrderSettledOffPlatformDocument = gql`
    mutation MyMarkOrderSettledOffPlatform($splitId: MongoID!) {
  myMarkOrderSettledOffPlatform(splitId: $splitId) {
    _id
    status
    finalAmount
    balanceDue
    invoicedAt
  }
}
    `;
export type MyMarkOrderSettledOffPlatformMutationFn = Apollo.MutationFunction<MyMarkOrderSettledOffPlatformMutation, MyMarkOrderSettledOffPlatformMutationVariables>;

/**
 * __useMyMarkOrderSettledOffPlatformMutation__
 *
 * To run a mutation, you first call `useMyMarkOrderSettledOffPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyMarkOrderSettledOffPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myMarkOrderSettledOffPlatformMutation, { data, loading, error }] = useMyMarkOrderSettledOffPlatformMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useMyMarkOrderSettledOffPlatformMutation(baseOptions?: Apollo.MutationHookOptions<MyMarkOrderSettledOffPlatformMutation, MyMarkOrderSettledOffPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyMarkOrderSettledOffPlatformMutation, MyMarkOrderSettledOffPlatformMutationVariables>(MyMarkOrderSettledOffPlatformDocument, options);
      }
export type MyMarkOrderSettledOffPlatformMutationHookResult = ReturnType<typeof useMyMarkOrderSettledOffPlatformMutation>;
export type MyMarkOrderSettledOffPlatformMutationResult = Apollo.MutationResult<MyMarkOrderSettledOffPlatformMutation>;
export type MyMarkOrderSettledOffPlatformMutationOptions = Apollo.BaseMutationOptions<MyMarkOrderSettledOffPlatformMutation, MyMarkOrderSettledOffPlatformMutationVariables>;
export const MyNudgeSectionBuyerDocument = gql`
    mutation MyNudgeSectionBuyer($splitId: MongoID!) {
  myNudgeSectionBuyer(splitId: $splitId) {
    splitId
    nudgeCase
    nudgedAt
  }
}
    `;
export type MyNudgeSectionBuyerMutationFn = Apollo.MutationFunction<MyNudgeSectionBuyerMutation, MyNudgeSectionBuyerMutationVariables>;

/**
 * __useMyNudgeSectionBuyerMutation__
 *
 * To run a mutation, you first call `useMyNudgeSectionBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyNudgeSectionBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myNudgeSectionBuyerMutation, { data, loading, error }] = useMyNudgeSectionBuyerMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useMyNudgeSectionBuyerMutation(baseOptions?: Apollo.MutationHookOptions<MyNudgeSectionBuyerMutation, MyNudgeSectionBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyNudgeSectionBuyerMutation, MyNudgeSectionBuyerMutationVariables>(MyNudgeSectionBuyerDocument, options);
      }
export type MyNudgeSectionBuyerMutationHookResult = ReturnType<typeof useMyNudgeSectionBuyerMutation>;
export type MyNudgeSectionBuyerMutationResult = Apollo.MutationResult<MyNudgeSectionBuyerMutation>;
export type MyNudgeSectionBuyerMutationOptions = Apollo.BaseMutationOptions<MyNudgeSectionBuyerMutation, MyNudgeSectionBuyerMutationVariables>;
export const MyPlaceBuyerOnAnimalDocument = gql`
    mutation MyPlaceBuyerOnAnimal($animalId: MongoID!, $splitPart: String!, $buyerId: MongoID!, $requestId: String, $depositAmount: Float) {
  myPlaceBuyerOnAnimal(
    animalId: $animalId
    splitPart: $splitPart
    buyerId: $buyerId
    requestId: $requestId
    depositAmount: $depositAmount
  ) {
    _id
  }
}
    `;
export type MyPlaceBuyerOnAnimalMutationFn = Apollo.MutationFunction<MyPlaceBuyerOnAnimalMutation, MyPlaceBuyerOnAnimalMutationVariables>;

/**
 * __useMyPlaceBuyerOnAnimalMutation__
 *
 * To run a mutation, you first call `useMyPlaceBuyerOnAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyPlaceBuyerOnAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myPlaceBuyerOnAnimalMutation, { data, loading, error }] = useMyPlaceBuyerOnAnimalMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      splitPart: // value for 'splitPart'
 *      buyerId: // value for 'buyerId'
 *      requestId: // value for 'requestId'
 *      depositAmount: // value for 'depositAmount'
 *   },
 * });
 */
export function useMyPlaceBuyerOnAnimalMutation(baseOptions?: Apollo.MutationHookOptions<MyPlaceBuyerOnAnimalMutation, MyPlaceBuyerOnAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyPlaceBuyerOnAnimalMutation, MyPlaceBuyerOnAnimalMutationVariables>(MyPlaceBuyerOnAnimalDocument, options);
      }
export type MyPlaceBuyerOnAnimalMutationHookResult = ReturnType<typeof useMyPlaceBuyerOnAnimalMutation>;
export type MyPlaceBuyerOnAnimalMutationResult = Apollo.MutationResult<MyPlaceBuyerOnAnimalMutation>;
export type MyPlaceBuyerOnAnimalMutationOptions = Apollo.BaseMutationOptions<MyPlaceBuyerOnAnimalMutation, MyPlaceBuyerOnAnimalMutationVariables>;
export const MyReassignBuyerSplitDocument = gql`
    mutation MyReassignBuyerSplit($splitId: MongoID!, $newBuyerId: MongoID!) {
  myReassignBuyerSplit(splitId: $splitId, newBuyerId: $newBuyerId) {
    _id
    status
    buyer {
      _id
    }
  }
}
    `;
export type MyReassignBuyerSplitMutationFn = Apollo.MutationFunction<MyReassignBuyerSplitMutation, MyReassignBuyerSplitMutationVariables>;

/**
 * __useMyReassignBuyerSplitMutation__
 *
 * To run a mutation, you first call `useMyReassignBuyerSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyReassignBuyerSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myReassignBuyerSplitMutation, { data, loading, error }] = useMyReassignBuyerSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      newBuyerId: // value for 'newBuyerId'
 *   },
 * });
 */
export function useMyReassignBuyerSplitMutation(baseOptions?: Apollo.MutationHookOptions<MyReassignBuyerSplitMutation, MyReassignBuyerSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyReassignBuyerSplitMutation, MyReassignBuyerSplitMutationVariables>(MyReassignBuyerSplitDocument, options);
      }
export type MyReassignBuyerSplitMutationHookResult = ReturnType<typeof useMyReassignBuyerSplitMutation>;
export type MyReassignBuyerSplitMutationResult = Apollo.MutationResult<MyReassignBuyerSplitMutation>;
export type MyReassignBuyerSplitMutationOptions = Apollo.BaseMutationOptions<MyReassignBuyerSplitMutation, MyReassignBuyerSplitMutationVariables>;
export const MyReleaseBuyerSplitDocument = gql`
    mutation MyReleaseBuyerSplit($splitId: MongoID!) {
  myReleaseBuyerSplit(splitId: $splitId) {
    _id
    status
  }
}
    `;
export type MyReleaseBuyerSplitMutationFn = Apollo.MutationFunction<MyReleaseBuyerSplitMutation, MyReleaseBuyerSplitMutationVariables>;

/**
 * __useMyReleaseBuyerSplitMutation__
 *
 * To run a mutation, you first call `useMyReleaseBuyerSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyReleaseBuyerSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myReleaseBuyerSplitMutation, { data, loading, error }] = useMyReleaseBuyerSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useMyReleaseBuyerSplitMutation(baseOptions?: Apollo.MutationHookOptions<MyReleaseBuyerSplitMutation, MyReleaseBuyerSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyReleaseBuyerSplitMutation, MyReleaseBuyerSplitMutationVariables>(MyReleaseBuyerSplitDocument, options);
      }
export type MyReleaseBuyerSplitMutationHookResult = ReturnType<typeof useMyReleaseBuyerSplitMutation>;
export type MyReleaseBuyerSplitMutationResult = Apollo.MutationResult<MyReleaseBuyerSplitMutation>;
export type MyReleaseBuyerSplitMutationOptions = Apollo.BaseMutationOptions<MyReleaseBuyerSplitMutation, MyReleaseBuyerSplitMutationVariables>;
export const MyRemoveBuyerSplitDocument = gql`
    mutation MyRemoveBuyerSplit($splitId: MongoID!) {
  myRemoveBuyerSplit(splitId: $splitId) {
    _id
    status
  }
}
    `;
export type MyRemoveBuyerSplitMutationFn = Apollo.MutationFunction<MyRemoveBuyerSplitMutation, MyRemoveBuyerSplitMutationVariables>;

/**
 * __useMyRemoveBuyerSplitMutation__
 *
 * To run a mutation, you first call `useMyRemoveBuyerSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyRemoveBuyerSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myRemoveBuyerSplitMutation, { data, loading, error }] = useMyRemoveBuyerSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useMyRemoveBuyerSplitMutation(baseOptions?: Apollo.MutationHookOptions<MyRemoveBuyerSplitMutation, MyRemoveBuyerSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyRemoveBuyerSplitMutation, MyRemoveBuyerSplitMutationVariables>(MyRemoveBuyerSplitDocument, options);
      }
export type MyRemoveBuyerSplitMutationHookResult = ReturnType<typeof useMyRemoveBuyerSplitMutation>;
export type MyRemoveBuyerSplitMutationResult = Apollo.MutationResult<MyRemoveBuyerSplitMutation>;
export type MyRemoveBuyerSplitMutationOptions = Apollo.BaseMutationOptions<MyRemoveBuyerSplitMutation, MyRemoveBuyerSplitMutationVariables>;
export const MyReviseSaleInvoiceDocument = gql`
    mutation MyReviseSaleInvoice($splitId: MongoID!, $saleAmount: Float!, $adjustments: [OrderAdjustmentInput!], $reason: String) {
  myReviseSaleInvoice(
    splitId: $splitId
    saleAmount: $saleAmount
    adjustments: $adjustments
    reason: $reason
  ) {
    _id
    status
    finalAmount
    saleBaseAmount
    adjustments {
      label
      amount
    }
    balanceDue
    invoicedAt
  }
}
    `;
export type MyReviseSaleInvoiceMutationFn = Apollo.MutationFunction<MyReviseSaleInvoiceMutation, MyReviseSaleInvoiceMutationVariables>;

/**
 * __useMyReviseSaleInvoiceMutation__
 *
 * To run a mutation, you first call `useMyReviseSaleInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyReviseSaleInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myReviseSaleInvoiceMutation, { data, loading, error }] = useMyReviseSaleInvoiceMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      saleAmount: // value for 'saleAmount'
 *      adjustments: // value for 'adjustments'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useMyReviseSaleInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<MyReviseSaleInvoiceMutation, MyReviseSaleInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyReviseSaleInvoiceMutation, MyReviseSaleInvoiceMutationVariables>(MyReviseSaleInvoiceDocument, options);
      }
export type MyReviseSaleInvoiceMutationHookResult = ReturnType<typeof useMyReviseSaleInvoiceMutation>;
export type MyReviseSaleInvoiceMutationResult = Apollo.MutationResult<MyReviseSaleInvoiceMutation>;
export type MyReviseSaleInvoiceMutationOptions = Apollo.BaseMutationOptions<MyReviseSaleInvoiceMutation, MyReviseSaleInvoiceMutationVariables>;
export const MyStartBuyerChatDocument = gql`
    mutation MyStartBuyerChat($buyerId: MongoID!) {
  myStartBuyerChat(buyerId: $buyerId) {
    _id
  }
}
    `;
export type MyStartBuyerChatMutationFn = Apollo.MutationFunction<MyStartBuyerChatMutation, MyStartBuyerChatMutationVariables>;

/**
 * __useMyStartBuyerChatMutation__
 *
 * To run a mutation, you first call `useMyStartBuyerChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyStartBuyerChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myStartBuyerChatMutation, { data, loading, error }] = useMyStartBuyerChatMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useMyStartBuyerChatMutation(baseOptions?: Apollo.MutationHookOptions<MyStartBuyerChatMutation, MyStartBuyerChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyStartBuyerChatMutation, MyStartBuyerChatMutationVariables>(MyStartBuyerChatDocument, options);
      }
export type MyStartBuyerChatMutationHookResult = ReturnType<typeof useMyStartBuyerChatMutation>;
export type MyStartBuyerChatMutationResult = Apollo.MutationResult<MyStartBuyerChatMutation>;
export type MyStartBuyerChatMutationOptions = Apollo.BaseMutationOptions<MyStartBuyerChatMutation, MyStartBuyerChatMutationVariables>;
export const MyStartProducerChatDocument = gql`
    mutation MyStartProducerChat($producerId: MongoID!, $animalId: MongoID) {
  myStartProducerChat(producerId: $producerId, animalId: $animalId) {
    _id
  }
}
    `;
export type MyStartProducerChatMutationFn = Apollo.MutationFunction<MyStartProducerChatMutation, MyStartProducerChatMutationVariables>;

/**
 * __useMyStartProducerChatMutation__
 *
 * To run a mutation, you first call `useMyStartProducerChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyStartProducerChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myStartProducerChatMutation, { data, loading, error }] = useMyStartProducerChatMutation({
 *   variables: {
 *      producerId: // value for 'producerId'
 *      animalId: // value for 'animalId'
 *   },
 * });
 */
export function useMyStartProducerChatMutation(baseOptions?: Apollo.MutationHookOptions<MyStartProducerChatMutation, MyStartProducerChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyStartProducerChatMutation, MyStartProducerChatMutationVariables>(MyStartProducerChatDocument, options);
      }
export type MyStartProducerChatMutationHookResult = ReturnType<typeof useMyStartProducerChatMutation>;
export type MyStartProducerChatMutationResult = Apollo.MutationResult<MyStartProducerChatMutation>;
export type MyStartProducerChatMutationOptions = Apollo.BaseMutationOptions<MyStartProducerChatMutation, MyStartProducerChatMutationVariables>;
export const MyVoidSaleInvoiceDocument = gql`
    mutation MyVoidSaleInvoice($splitId: MongoID!, $reason: String) {
  myVoidSaleInvoice(splitId: $splitId, reason: $reason) {
    _id
    status
    finalAmount
    balanceDue
    invoicedAt
  }
}
    `;
export type MyVoidSaleInvoiceMutationFn = Apollo.MutationFunction<MyVoidSaleInvoiceMutation, MyVoidSaleInvoiceMutationVariables>;

/**
 * __useMyVoidSaleInvoiceMutation__
 *
 * To run a mutation, you first call `useMyVoidSaleInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyVoidSaleInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myVoidSaleInvoiceMutation, { data, loading, error }] = useMyVoidSaleInvoiceMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useMyVoidSaleInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<MyVoidSaleInvoiceMutation, MyVoidSaleInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyVoidSaleInvoiceMutation, MyVoidSaleInvoiceMutationVariables>(MyVoidSaleInvoiceDocument, options);
      }
export type MyVoidSaleInvoiceMutationHookResult = ReturnType<typeof useMyVoidSaleInvoiceMutation>;
export type MyVoidSaleInvoiceMutationResult = Apollo.MutationResult<MyVoidSaleInvoiceMutation>;
export type MyVoidSaleInvoiceMutationOptions = Apollo.BaseMutationOptions<MyVoidSaleInvoiceMutation, MyVoidSaleInvoiceMutationVariables>;
export const NoteDeleteDocument = gql`
    mutation NoteDelete($noteId: MongoID!) {
  noteDelete(noteId: $noteId) {
    _id
  }
}
    `;
export type NoteDeleteMutationFn = Apollo.MutationFunction<NoteDeleteMutation, NoteDeleteMutationVariables>;

/**
 * __useNoteDeleteMutation__
 *
 * To run a mutation, you first call `useNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteDeleteMutation, { data, loading, error }] = useNoteDeleteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useNoteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<NoteDeleteMutation, NoteDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteDeleteMutation, NoteDeleteMutationVariables>(NoteDeleteDocument, options);
      }
export type NoteDeleteMutationHookResult = ReturnType<typeof useNoteDeleteMutation>;
export type NoteDeleteMutationResult = Apollo.MutationResult<NoteDeleteMutation>;
export type NoteDeleteMutationOptions = Apollo.BaseMutationOptions<NoteDeleteMutation, NoteDeleteMutationVariables>;
export const NoteUpsertDocument = gql`
    mutation NoteUpsert($noteId: MongoID, $note: String!, $processorScheduling: MongoID, $animalHead: MongoID, $type: EnumNoteType, $attachments: [Upload], $removeAttachmentUrls: [String], $user: MongoID) {
  noteUpsert(
    noteId: $noteId
    note: $note
    processorScheduling: $processorScheduling
    animalHead: $animalHead
    type: $type
    attachments: $attachments
    removeAttachmentUrls: $removeAttachmentUrls
    user: $user
  ) {
    _id
  }
}
    `;
export type NoteUpsertMutationFn = Apollo.MutationFunction<NoteUpsertMutation, NoteUpsertMutationVariables>;

/**
 * __useNoteUpsertMutation__
 *
 * To run a mutation, you first call `useNoteUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteUpsertMutation, { data, loading, error }] = useNoteUpsertMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      note: // value for 'note'
 *      processorScheduling: // value for 'processorScheduling'
 *      animalHead: // value for 'animalHead'
 *      type: // value for 'type'
 *      attachments: // value for 'attachments'
 *      removeAttachmentUrls: // value for 'removeAttachmentUrls'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useNoteUpsertMutation(baseOptions?: Apollo.MutationHookOptions<NoteUpsertMutation, NoteUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteUpsertMutation, NoteUpsertMutationVariables>(NoteUpsertDocument, options);
      }
export type NoteUpsertMutationHookResult = ReturnType<typeof useNoteUpsertMutation>;
export type NoteUpsertMutationResult = Apollo.MutationResult<NoteUpsertMutation>;
export type NoteUpsertMutationOptions = Apollo.BaseMutationOptions<NoteUpsertMutation, NoteUpsertMutationVariables>;
export const NotificationPreferenceUpdateDocument = gql`
    mutation NotificationPreferenceUpdate($category: String!, $email: Boolean, $sms: Boolean) {
  notificationPreferenceUpdate(category: $category, email: $email, sms: $sms) {
    category
    label
    description
    email
    sms
  }
}
    `;
export type NotificationPreferenceUpdateMutationFn = Apollo.MutationFunction<NotificationPreferenceUpdateMutation, NotificationPreferenceUpdateMutationVariables>;

/**
 * __useNotificationPreferenceUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationPreferenceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferenceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationPreferenceUpdateMutation, { data, loading, error }] = useNotificationPreferenceUpdateMutation({
 *   variables: {
 *      category: // value for 'category'
 *      email: // value for 'email'
 *      sms: // value for 'sms'
 *   },
 * });
 */
export function useNotificationPreferenceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NotificationPreferenceUpdateMutation, NotificationPreferenceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationPreferenceUpdateMutation, NotificationPreferenceUpdateMutationVariables>(NotificationPreferenceUpdateDocument, options);
      }
export type NotificationPreferenceUpdateMutationHookResult = ReturnType<typeof useNotificationPreferenceUpdateMutation>;
export type NotificationPreferenceUpdateMutationResult = Apollo.MutationResult<NotificationPreferenceUpdateMutation>;
export type NotificationPreferenceUpdateMutationOptions = Apollo.BaseMutationOptions<NotificationPreferenceUpdateMutation, NotificationPreferenceUpdateMutationVariables>;
export const NotificationPromptAnswerDocument = gql`
    mutation NotificationPromptAnswer($promptId: ID!, $answer: String!, $via: String) {
  notificationPromptAnswer(promptId: $promptId, answer: $answer, via: $via) {
    _id
    kind
    status
    canAnswer
    jobId
    expiresAt
  }
}
    `;
export type NotificationPromptAnswerMutationFn = Apollo.MutationFunction<NotificationPromptAnswerMutation, NotificationPromptAnswerMutationVariables>;

/**
 * __useNotificationPromptAnswerMutation__
 *
 * To run a mutation, you first call `useNotificationPromptAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationPromptAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationPromptAnswerMutation, { data, loading, error }] = useNotificationPromptAnswerMutation({
 *   variables: {
 *      promptId: // value for 'promptId'
 *      answer: // value for 'answer'
 *      via: // value for 'via'
 *   },
 * });
 */
export function useNotificationPromptAnswerMutation(baseOptions?: Apollo.MutationHookOptions<NotificationPromptAnswerMutation, NotificationPromptAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationPromptAnswerMutation, NotificationPromptAnswerMutationVariables>(NotificationPromptAnswerDocument, options);
      }
export type NotificationPromptAnswerMutationHookResult = ReturnType<typeof useNotificationPromptAnswerMutation>;
export type NotificationPromptAnswerMutationResult = Apollo.MutationResult<NotificationPromptAnswerMutation>;
export type NotificationPromptAnswerMutationOptions = Apollo.BaseMutationOptions<NotificationPromptAnswerMutation, NotificationPromptAnswerMutationVariables>;
export const NotificationPromptAnswerByTokenDocument = gql`
    mutation NotificationPromptAnswerByToken($token: String!, $answer: String!) {
  notificationPromptAnswerByToken(token: $token, answer: $answer) {
    kind
    status
    expiredReason
    vendorName
    animalSpecies
    dropoffDate
    jobId
  }
}
    `;
export type NotificationPromptAnswerByTokenMutationFn = Apollo.MutationFunction<NotificationPromptAnswerByTokenMutation, NotificationPromptAnswerByTokenMutationVariables>;

/**
 * __useNotificationPromptAnswerByTokenMutation__
 *
 * To run a mutation, you first call `useNotificationPromptAnswerByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationPromptAnswerByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationPromptAnswerByTokenMutation, { data, loading, error }] = useNotificationPromptAnswerByTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useNotificationPromptAnswerByTokenMutation(baseOptions?: Apollo.MutationHookOptions<NotificationPromptAnswerByTokenMutation, NotificationPromptAnswerByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationPromptAnswerByTokenMutation, NotificationPromptAnswerByTokenMutationVariables>(NotificationPromptAnswerByTokenDocument, options);
      }
export type NotificationPromptAnswerByTokenMutationHookResult = ReturnType<typeof useNotificationPromptAnswerByTokenMutation>;
export type NotificationPromptAnswerByTokenMutationResult = Apollo.MutationResult<NotificationPromptAnswerByTokenMutation>;
export type NotificationPromptAnswerByTokenMutationOptions = Apollo.BaseMutationOptions<NotificationPromptAnswerByTokenMutation, NotificationPromptAnswerByTokenMutationVariables>;
export const NotificationSettingsUpdateDocument = gql`
    mutation NotificationSettingsUpdate($notificationSettingId: MongoID!, $settings: NotificationSettingsInput!) {
  notificationSettingsUpdate(
    notificationSettingId: $notificationSettingId
    settings: $settings
  ) {
    ...NotificationSettingFragment
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;
export type NotificationSettingsUpdateMutationFn = Apollo.MutationFunction<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>;

/**
 * __useNotificationSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationSettingsUpdateMutation, { data, loading, error }] = useNotificationSettingsUpdateMutation({
 *   variables: {
 *      notificationSettingId: // value for 'notificationSettingId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useNotificationSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>(NotificationSettingsUpdateDocument, options);
      }
export type NotificationSettingsUpdateMutationHookResult = ReturnType<typeof useNotificationSettingsUpdateMutation>;
export type NotificationSettingsUpdateMutationResult = Apollo.MutationResult<NotificationSettingsUpdateMutation>;
export type NotificationSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>;
export const ParseCutsheetDocument = gql`
    mutation ParseCutsheet($file: Upload!, $capabilityId: MongoID!) {
  parseCutsheet(file: $file, capabilityId: $capabilityId) {
    catalog {
      name
      description
      animalType
      primals {
        title
        description
      }
      cuts {
        title
        description
        primalName
        pricePerPound
        priceFee
        priceFeePerPound
        minLbs
      }
      specifications {
        title
        description
        cutName
        options
      }
      trim {
        title
        description
        pricePerPound
        priceFee
        minLbs
      }
      extras {
        title
        description
        pricePerPound
        priceFee
        minLbs
      }
    }
    questionnaire {
      name
      description
      animalType
      questions {
        id
        type
        title
        description
        required
        sortOrder
        details
        imageUrl
        availableCutIds
        allowMultiple
        specificationId
        availableTrimIds
        requireExactTotal
      }
    }
  }
}
    `;
export type ParseCutsheetMutationFn = Apollo.MutationFunction<ParseCutsheetMutation, ParseCutsheetMutationVariables>;

/**
 * __useParseCutsheetMutation__
 *
 * To run a mutation, you first call `useParseCutsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseCutsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseCutsheetMutation, { data, loading, error }] = useParseCutsheetMutation({
 *   variables: {
 *      file: // value for 'file'
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useParseCutsheetMutation(baseOptions?: Apollo.MutationHookOptions<ParseCutsheetMutation, ParseCutsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseCutsheetMutation, ParseCutsheetMutationVariables>(ParseCutsheetDocument, options);
      }
export type ParseCutsheetMutationHookResult = ReturnType<typeof useParseCutsheetMutation>;
export type ParseCutsheetMutationResult = Apollo.MutationResult<ParseCutsheetMutation>;
export type ParseCutsheetMutationOptions = Apollo.BaseMutationOptions<ParseCutsheetMutation, ParseCutsheetMutationVariables>;
export const ParseFilledCutsheetDocument = gql`
    mutation ParseFilledCutsheet($file: Upload, $documentId: MongoID, $questionnaireId: MongoID!) {
  parseFilledCutsheet(
    file: $file
    documentId: $documentId
    questionnaireId: $questionnaireId
  ) {
    defaultSelections {
      name
      selectedCuts {
        optionId
        specifications {
          specification
          type
          value
        }
      }
      trimSelections {
        type
        trim {
          optionId
          rank
          quantity
          percentage
          specifications {
            specification
            type
            value
          }
        }
      }
      extraSelections {
        extras {
          optionId
          quantity
        }
      }
      specifications {
        specification
        type
        value
      }
      primalNotes {
        id
        note
      }
      trimSectionNotes
      notes
    }
    customerDetails {
      name
      company
      phone
      email
    }
    pages {
      page
      key
      url
      width
      height
    }
    report {
      documentSummary
      suggestedName
      items {
        category
        rawText
        matchedTitle
        matchedId
        confidence
        status
        questionId
        detail
        anchorKind
        anchorId
        regions {
          page
          x
          y
          width
          height
        }
      }
      counts {
        matched
        lowConfidence
        unmatched
      }
    }
  }
}
    `;
export type ParseFilledCutsheetMutationFn = Apollo.MutationFunction<ParseFilledCutsheetMutation, ParseFilledCutsheetMutationVariables>;

/**
 * __useParseFilledCutsheetMutation__
 *
 * To run a mutation, you first call `useParseFilledCutsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseFilledCutsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseFilledCutsheetMutation, { data, loading, error }] = useParseFilledCutsheetMutation({
 *   variables: {
 *      file: // value for 'file'
 *      documentId: // value for 'documentId'
 *      questionnaireId: // value for 'questionnaireId'
 *   },
 * });
 */
export function useParseFilledCutsheetMutation(baseOptions?: Apollo.MutationHookOptions<ParseFilledCutsheetMutation, ParseFilledCutsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseFilledCutsheetMutation, ParseFilledCutsheetMutationVariables>(ParseFilledCutsheetDocument, options);
      }
export type ParseFilledCutsheetMutationHookResult = ReturnType<typeof useParseFilledCutsheetMutation>;
export type ParseFilledCutsheetMutationResult = Apollo.MutationResult<ParseFilledCutsheetMutation>;
export type ParseFilledCutsheetMutationOptions = Apollo.BaseMutationOptions<ParseFilledCutsheetMutation, ParseFilledCutsheetMutationVariables>;
export const PartnerIntegrationDeleteDocument = gql`
    mutation PartnerIntegrationDelete($integrationId: MongoID!) {
  partnerIntegrationDelete(integrationId: $integrationId) {
    ok
    reason
  }
}
    `;
export type PartnerIntegrationDeleteMutationFn = Apollo.MutationFunction<PartnerIntegrationDeleteMutation, PartnerIntegrationDeleteMutationVariables>;

/**
 * __usePartnerIntegrationDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationDeleteMutation, { data, loading, error }] = usePartnerIntegrationDeleteMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function usePartnerIntegrationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PartnerIntegrationDeleteMutation, PartnerIntegrationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerIntegrationDeleteMutation, PartnerIntegrationDeleteMutationVariables>(PartnerIntegrationDeleteDocument, options);
      }
export type PartnerIntegrationDeleteMutationHookResult = ReturnType<typeof usePartnerIntegrationDeleteMutation>;
export type PartnerIntegrationDeleteMutationResult = Apollo.MutationResult<PartnerIntegrationDeleteMutation>;
export type PartnerIntegrationDeleteMutationOptions = Apollo.BaseMutationOptions<PartnerIntegrationDeleteMutation, PartnerIntegrationDeleteMutationVariables>;
export const PartnerIntegrationIssueTokenDocument = gql`
    mutation PartnerIntegrationIssueToken($adapter: String!, $integrationId: MongoID) {
  partnerIntegrationIssueToken(adapter: $adapter, integrationId: $integrationId) {
    token
    hint
    inboundUrl
  }
}
    `;
export type PartnerIntegrationIssueTokenMutationFn = Apollo.MutationFunction<PartnerIntegrationIssueTokenMutation, PartnerIntegrationIssueTokenMutationVariables>;

/**
 * __usePartnerIntegrationIssueTokenMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationIssueTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationIssueTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationIssueTokenMutation, { data, loading, error }] = usePartnerIntegrationIssueTokenMutation({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function usePartnerIntegrationIssueTokenMutation(baseOptions?: Apollo.MutationHookOptions<PartnerIntegrationIssueTokenMutation, PartnerIntegrationIssueTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerIntegrationIssueTokenMutation, PartnerIntegrationIssueTokenMutationVariables>(PartnerIntegrationIssueTokenDocument, options);
      }
export type PartnerIntegrationIssueTokenMutationHookResult = ReturnType<typeof usePartnerIntegrationIssueTokenMutation>;
export type PartnerIntegrationIssueTokenMutationResult = Apollo.MutationResult<PartnerIntegrationIssueTokenMutation>;
export type PartnerIntegrationIssueTokenMutationOptions = Apollo.BaseMutationOptions<PartnerIntegrationIssueTokenMutation, PartnerIntegrationIssueTokenMutationVariables>;
export const PartnerIntegrationUpsertDocument = gql`
    mutation PartnerIntegrationUpsert($adapter: String!, $integrationId: MongoID, $label: String, $enabled: Boolean, $endpoint: String, $apiKey: String, $apiSecret: String, $subscribedEvents: [String!], $autoPush: Boolean, $autoPoll: Boolean, $inboundEnabled: Boolean, $weightMode: String, $config: JSON) {
  partnerIntegrationUpsert(
    adapter: $adapter
    integrationId: $integrationId
    label: $label
    enabled: $enabled
    endpoint: $endpoint
    apiKey: $apiKey
    apiSecret: $apiSecret
    subscribedEvents: $subscribedEvents
    autoPush: $autoPush
    autoPoll: $autoPoll
    inboundEnabled: $inboundEnabled
    weightMode: $weightMode
    config: $config
  ) {
    _id
    adapter
    label
    enabled
    subscribedEvents
    autoPush
    autoPoll
    inbound {
      enabled
      tokenHint
      weightMode
    }
  }
}
    `;
export type PartnerIntegrationUpsertMutationFn = Apollo.MutationFunction<PartnerIntegrationUpsertMutation, PartnerIntegrationUpsertMutationVariables>;

/**
 * __usePartnerIntegrationUpsertMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationUpsertMutation, { data, loading, error }] = usePartnerIntegrationUpsertMutation({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      integrationId: // value for 'integrationId'
 *      label: // value for 'label'
 *      enabled: // value for 'enabled'
 *      endpoint: // value for 'endpoint'
 *      apiKey: // value for 'apiKey'
 *      apiSecret: // value for 'apiSecret'
 *      subscribedEvents: // value for 'subscribedEvents'
 *      autoPush: // value for 'autoPush'
 *      autoPoll: // value for 'autoPoll'
 *      inboundEnabled: // value for 'inboundEnabled'
 *      weightMode: // value for 'weightMode'
 *      config: // value for 'config'
 *   },
 * });
 */
export function usePartnerIntegrationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PartnerIntegrationUpsertMutation, PartnerIntegrationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartnerIntegrationUpsertMutation, PartnerIntegrationUpsertMutationVariables>(PartnerIntegrationUpsertDocument, options);
      }
export type PartnerIntegrationUpsertMutationHookResult = ReturnType<typeof usePartnerIntegrationUpsertMutation>;
export type PartnerIntegrationUpsertMutationResult = Apollo.MutationResult<PartnerIntegrationUpsertMutation>;
export type PartnerIntegrationUpsertMutationOptions = Apollo.BaseMutationOptions<PartnerIntegrationUpsertMutation, PartnerIntegrationUpsertMutationVariables>;
export const SearchAvailablePhoneNumbersDocument = gql`
    query SearchAvailablePhoneNumbers($input: SearchAvailablePhoneNumbersInput!) {
  searchAvailablePhoneNumbers(input: $input) {
    phoneNumber
    friendlyName
    locality
    region
    capabilities {
      voice
      sms
      mms
    }
  }
}
    `;

/**
 * __useSearchAvailablePhoneNumbersQuery__
 *
 * To run a query within a React component, call `useSearchAvailablePhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAvailablePhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAvailablePhoneNumbersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchAvailablePhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>(SearchAvailablePhoneNumbersDocument, options);
      }
export function useSearchAvailablePhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>(SearchAvailablePhoneNumbersDocument, options);
        }
export type SearchAvailablePhoneNumbersQueryHookResult = ReturnType<typeof useSearchAvailablePhoneNumbersQuery>;
export type SearchAvailablePhoneNumbersLazyQueryHookResult = ReturnType<typeof useSearchAvailablePhoneNumbersLazyQuery>;
export type SearchAvailablePhoneNumbersQueryResult = Apollo.QueryResult<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>;
export const ProvisionPhoneNumberDocument = gql`
    mutation ProvisionPhoneNumber($input: ProvisionPhoneNumberInput!) {
  provisionPhoneNumber(input: $input) {
    success
    error
    phoneNumber
    phoneNumberSid
  }
}
    `;
export type ProvisionPhoneNumberMutationFn = Apollo.MutationFunction<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>;

/**
 * __useProvisionPhoneNumberMutation__
 *
 * To run a mutation, you first call `useProvisionPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionPhoneNumberMutation, { data, loading, error }] = useProvisionPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>(ProvisionPhoneNumberDocument, options);
      }
export type ProvisionPhoneNumberMutationHookResult = ReturnType<typeof useProvisionPhoneNumberMutation>;
export type ProvisionPhoneNumberMutationResult = Apollo.MutationResult<ProvisionPhoneNumberMutation>;
export type ProvisionPhoneNumberMutationOptions = Apollo.BaseMutationOptions<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>;
export const ReleasePhoneNumberDocument = gql`
    mutation ReleasePhoneNumber($input: ReleasePhoneNumberInput!) {
  releasePhoneNumber(input: $input) {
    success
    error
  }
}
    `;
export type ReleasePhoneNumberMutationFn = Apollo.MutationFunction<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>;

/**
 * __useReleasePhoneNumberMutation__
 *
 * To run a mutation, you first call `useReleasePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePhoneNumberMutation, { data, loading, error }] = useReleasePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleasePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>(ReleasePhoneNumberDocument, options);
      }
export type ReleasePhoneNumberMutationHookResult = ReturnType<typeof useReleasePhoneNumberMutation>;
export type ReleasePhoneNumberMutationResult = Apollo.MutationResult<ReleasePhoneNumberMutation>;
export type ReleasePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>;
export const SubmitHostedLandlineOrderDocument = gql`
    mutation SubmitHostedLandlineOrder($input: SubmitHostedLandlineOrderInput!) {
  submitHostedLandlineOrder(input: $input) {
    success
    error
    hostedNumberOrderSid
    status
  }
}
    `;
export type SubmitHostedLandlineOrderMutationFn = Apollo.MutationFunction<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>;

/**
 * __useSubmitHostedLandlineOrderMutation__
 *
 * To run a mutation, you first call `useSubmitHostedLandlineOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitHostedLandlineOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitHostedLandlineOrderMutation, { data, loading, error }] = useSubmitHostedLandlineOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitHostedLandlineOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>(SubmitHostedLandlineOrderDocument, options);
      }
export type SubmitHostedLandlineOrderMutationHookResult = ReturnType<typeof useSubmitHostedLandlineOrderMutation>;
export type SubmitHostedLandlineOrderMutationResult = Apollo.MutationResult<SubmitHostedLandlineOrderMutation>;
export type SubmitHostedLandlineOrderMutationOptions = Apollo.BaseMutationOptions<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>;
export const RefreshHostedNumberStatusDocument = gql`
    mutation RefreshHostedNumberStatus($input: RefreshHostedNumberStatusInput!) {
  refreshHostedNumberStatus(input: $input) {
    success
    error
    status
    phoneNumberSid
    isProvisioned
  }
}
    `;
export type RefreshHostedNumberStatusMutationFn = Apollo.MutationFunction<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>;

/**
 * __useRefreshHostedNumberStatusMutation__
 *
 * To run a mutation, you first call `useRefreshHostedNumberStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshHostedNumberStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshHostedNumberStatusMutation, { data, loading, error }] = useRefreshHostedNumberStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshHostedNumberStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>(RefreshHostedNumberStatusDocument, options);
      }
export type RefreshHostedNumberStatusMutationHookResult = ReturnType<typeof useRefreshHostedNumberStatusMutation>;
export type RefreshHostedNumberStatusMutationResult = Apollo.MutationResult<RefreshHostedNumberStatusMutation>;
export type RefreshHostedNumberStatusMutationOptions = Apollo.BaseMutationOptions<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>;
export const UpdatePhoneNumberSmsWebhookDocument = gql`
    mutation UpdatePhoneNumberSmsWebhook($input: UpdatePhoneNumberSmsWebhookInput!) {
  updatePhoneNumberSmsWebhook(input: $input) {
    success
    error
    phoneNumber
  }
}
    `;
export type UpdatePhoneNumberSmsWebhookMutationFn = Apollo.MutationFunction<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>;

/**
 * __useUpdatePhoneNumberSmsWebhookMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberSmsWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberSmsWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberSmsWebhookMutation, { data, loading, error }] = useUpdatePhoneNumberSmsWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhoneNumberSmsWebhookMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>(UpdatePhoneNumberSmsWebhookDocument, options);
      }
export type UpdatePhoneNumberSmsWebhookMutationHookResult = ReturnType<typeof useUpdatePhoneNumberSmsWebhookMutation>;
export type UpdatePhoneNumberSmsWebhookMutationResult = Apollo.MutationResult<UpdatePhoneNumberSmsWebhookMutation>;
export type UpdatePhoneNumberSmsWebhookMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>;
export const AddPhoneToMessagingServiceDocument = gql`
    mutation AddPhoneToMessagingService($input: AddPhoneToMessagingServiceInput!) {
  addPhoneToMessagingService(input: $input) {
    success
    error
  }
}
    `;
export type AddPhoneToMessagingServiceMutationFn = Apollo.MutationFunction<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>;

/**
 * __useAddPhoneToMessagingServiceMutation__
 *
 * To run a mutation, you first call `useAddPhoneToMessagingServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhoneToMessagingServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhoneToMessagingServiceMutation, { data, loading, error }] = useAddPhoneToMessagingServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPhoneToMessagingServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>(AddPhoneToMessagingServiceDocument, options);
      }
export type AddPhoneToMessagingServiceMutationHookResult = ReturnType<typeof useAddPhoneToMessagingServiceMutation>;
export type AddPhoneToMessagingServiceMutationResult = Apollo.MutationResult<AddPhoneToMessagingServiceMutation>;
export type AddPhoneToMessagingServiceMutationOptions = Apollo.BaseMutationOptions<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>;
export const PickupLocationUpsertDocument = gql`
    mutation PickupLocationUpsert($input: PickupLocationUpsertInput!) {
  pickupLocationUpsert(input: $input) {
    _id
    name
    description
    active
    isDefault
    sortOrder
    address {
      address_1
      address_2
      city
      state
      postcode
      country
    }
    location {
      coordinates
    }
  }
}
    `;
export type PickupLocationUpsertMutationFn = Apollo.MutationFunction<PickupLocationUpsertMutation, PickupLocationUpsertMutationVariables>;

/**
 * __usePickupLocationUpsertMutation__
 *
 * To run a mutation, you first call `usePickupLocationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePickupLocationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pickupLocationUpsertMutation, { data, loading, error }] = usePickupLocationUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePickupLocationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PickupLocationUpsertMutation, PickupLocationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PickupLocationUpsertMutation, PickupLocationUpsertMutationVariables>(PickupLocationUpsertDocument, options);
      }
export type PickupLocationUpsertMutationHookResult = ReturnType<typeof usePickupLocationUpsertMutation>;
export type PickupLocationUpsertMutationResult = Apollo.MutationResult<PickupLocationUpsertMutation>;
export type PickupLocationUpsertMutationOptions = Apollo.BaseMutationOptions<PickupLocationUpsertMutation, PickupLocationUpsertMutationVariables>;
export const PrimalCreateOneDocument = gql`
    mutation PrimalCreateOne($record: CreateOnePrimalInput!) {
  primalCreateOne(record: $record) {
    recordId
  }
}
    `;
export type PrimalCreateOneMutationFn = Apollo.MutationFunction<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>;

/**
 * __usePrimalCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCreateOneMutation, { data, loading, error }] = usePrimalCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>(PrimalCreateOneDocument, options);
      }
export type PrimalCreateOneMutationHookResult = ReturnType<typeof usePrimalCreateOneMutation>;
export type PrimalCreateOneMutationResult = Apollo.MutationResult<PrimalCreateOneMutation>;
export type PrimalCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>;
export const PrimalCutBlockerUpsertDocument = gql`
    mutation PrimalCutBlockerUpsert($animalSpecies: String!, $inspectionLevel: String!, $name: String!, $primalCutId: MongoID!, $blockedBy: [BlockedByInput!]!) {
  primalCutBlockerUpsert(
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    name: $name
    primalCutId: $primalCutId
    blockedBy: $blockedBy
  ) {
    ...PrimalCutBlockerFragment
  }
}
    ${PrimalCutBlockerFragmentFragmentDoc}`;
export type PrimalCutBlockerUpsertMutationFn = Apollo.MutationFunction<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>;

/**
 * __usePrimalCutBlockerUpsertMutation__
 *
 * To run a mutation, you first call `usePrimalCutBlockerUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutBlockerUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutBlockerUpsertMutation, { data, loading, error }] = usePrimalCutBlockerUpsertMutation({
 *   variables: {
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      name: // value for 'name'
 *      primalCutId: // value for 'primalCutId'
 *      blockedBy: // value for 'blockedBy'
 *   },
 * });
 */
export function usePrimalCutBlockerUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>(PrimalCutBlockerUpsertDocument, options);
      }
export type PrimalCutBlockerUpsertMutationHookResult = ReturnType<typeof usePrimalCutBlockerUpsertMutation>;
export type PrimalCutBlockerUpsertMutationResult = Apollo.MutationResult<PrimalCutBlockerUpsertMutation>;
export type PrimalCutBlockerUpsertMutationOptions = Apollo.BaseMutationOptions<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>;
export const PrimalCutCreateOneDocument = gql`
    mutation PrimalCutCreateOne($record: CreateOnePrimalCutInput!) {
  primalCutCreateOne(record: $record) {
    recordId
    record {
      ...PrimalCutFragment
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}`;
export type PrimalCutCreateOneMutationFn = Apollo.MutationFunction<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>;

/**
 * __usePrimalCutCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCutCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutCreateOneMutation, { data, loading, error }] = usePrimalCutCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>(PrimalCutCreateOneDocument, options);
      }
export type PrimalCutCreateOneMutationHookResult = ReturnType<typeof usePrimalCutCreateOneMutation>;
export type PrimalCutCreateOneMutationResult = Apollo.MutationResult<PrimalCutCreateOneMutation>;
export type PrimalCutCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>;
export const PrimalCutSoftDeleteDocument = gql`
    mutation PrimalCutSoftDelete($primalCutId: MongoID!) {
  primalCutSoftDelete(primalCutId: $primalCutId) {
    _id
    primal {
      _id
      group {
        _id
      }
    }
  }
}
    `;
export type PrimalCutSoftDeleteMutationFn = Apollo.MutationFunction<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>;

/**
 * __usePrimalCutSoftDeleteMutation__
 *
 * To run a mutation, you first call `usePrimalCutSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutSoftDeleteMutation, { data, loading, error }] = usePrimalCutSoftDeleteMutation({
 *   variables: {
 *      primalCutId: // value for 'primalCutId'
 *   },
 * });
 */
export function usePrimalCutSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>(PrimalCutSoftDeleteDocument, options);
      }
export type PrimalCutSoftDeleteMutationHookResult = ReturnType<typeof usePrimalCutSoftDeleteMutation>;
export type PrimalCutSoftDeleteMutationResult = Apollo.MutationResult<PrimalCutSoftDeleteMutation>;
export type PrimalCutSoftDeleteMutationOptions = Apollo.BaseMutationOptions<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>;
export const PrimalCutTypeCreateOneDocument = gql`
    mutation PrimalCutTypeCreateOne($record: CreateOnePrimalCutTypeInput!) {
  primalCutTypeCreateOne(record: $record) {
    recordId
  }
}
    `;
export type PrimalCutTypeCreateOneMutationFn = Apollo.MutationFunction<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>;

/**
 * __usePrimalCutTypeCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCutTypeCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutTypeCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutTypeCreateOneMutation, { data, loading, error }] = usePrimalCutTypeCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutTypeCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>(PrimalCutTypeCreateOneDocument, options);
      }
export type PrimalCutTypeCreateOneMutationHookResult = ReturnType<typeof usePrimalCutTypeCreateOneMutation>;
export type PrimalCutTypeCreateOneMutationResult = Apollo.MutationResult<PrimalCutTypeCreateOneMutation>;
export type PrimalCutTypeCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>;
export const PrimalCutUpdateByIdDocument = gql`
    mutation PrimalCutUpdateById($_id: MongoID!, $record: UpdateByIdPrimalCutInput!) {
  primalCutUpdateById(_id: $_id, record: $record) {
    recordId
    record {
      ...PrimalCutFragment
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}`;
export type PrimalCutUpdateByIdMutationFn = Apollo.MutationFunction<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>;

/**
 * __usePrimalCutUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePrimalCutUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutUpdateByIdMutation, { data, loading, error }] = usePrimalCutUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>(PrimalCutUpdateByIdDocument, options);
      }
export type PrimalCutUpdateByIdMutationHookResult = ReturnType<typeof usePrimalCutUpdateByIdMutation>;
export type PrimalCutUpdateByIdMutationResult = Apollo.MutationResult<PrimalCutUpdateByIdMutation>;
export type PrimalCutUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>;
export const PrimalGroupRestoreByIdDocument = gql`
    mutation PrimalGroupRestoreById($id: MongoID!) {
  primalGroupUpdateById(_id: $id, record: {isDeleted: false, deletedAt: null}) {
    record {
      _id
      isDeleted
    }
  }
}
    `;
export type PrimalGroupRestoreByIdMutationFn = Apollo.MutationFunction<PrimalGroupRestoreByIdMutation, PrimalGroupRestoreByIdMutationVariables>;

/**
 * __usePrimalGroupRestoreByIdMutation__
 *
 * To run a mutation, you first call `usePrimalGroupRestoreByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupRestoreByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalGroupRestoreByIdMutation, { data, loading, error }] = usePrimalGroupRestoreByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalGroupRestoreByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalGroupRestoreByIdMutation, PrimalGroupRestoreByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalGroupRestoreByIdMutation, PrimalGroupRestoreByIdMutationVariables>(PrimalGroupRestoreByIdDocument, options);
      }
export type PrimalGroupRestoreByIdMutationHookResult = ReturnType<typeof usePrimalGroupRestoreByIdMutation>;
export type PrimalGroupRestoreByIdMutationResult = Apollo.MutationResult<PrimalGroupRestoreByIdMutation>;
export type PrimalGroupRestoreByIdMutationOptions = Apollo.BaseMutationOptions<PrimalGroupRestoreByIdMutation, PrimalGroupRestoreByIdMutationVariables>;
export const PrimalGroupSoftDeleteByIdDocument = gql`
    mutation PrimalGroupSoftDeleteById($id: MongoID!) {
  primalGroupUpdateById(_id: $id, record: {isDeleted: true}) {
    record {
      _id
      isDeleted
      deletedAt
    }
  }
}
    `;
export type PrimalGroupSoftDeleteByIdMutationFn = Apollo.MutationFunction<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>;

/**
 * __usePrimalGroupSoftDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePrimalGroupSoftDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupSoftDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalGroupSoftDeleteByIdMutation, { data, loading, error }] = usePrimalGroupSoftDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalGroupSoftDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>(PrimalGroupSoftDeleteByIdDocument, options);
      }
export type PrimalGroupSoftDeleteByIdMutationHookResult = ReturnType<typeof usePrimalGroupSoftDeleteByIdMutation>;
export type PrimalGroupSoftDeleteByIdMutationResult = Apollo.MutationResult<PrimalGroupSoftDeleteByIdMutation>;
export type PrimalGroupSoftDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>;
export const PrimalRestoreByIdDocument = gql`
    mutation PrimalRestoreById($id: MongoID!) {
  primalUpdateById(_id: $id, record: {isDeleted: false, deletedAt: null}) {
    record {
      _id
      isDeleted
    }
  }
}
    `;
export type PrimalRestoreByIdMutationFn = Apollo.MutationFunction<PrimalRestoreByIdMutation, PrimalRestoreByIdMutationVariables>;

/**
 * __usePrimalRestoreByIdMutation__
 *
 * To run a mutation, you first call `usePrimalRestoreByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalRestoreByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalRestoreByIdMutation, { data, loading, error }] = usePrimalRestoreByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalRestoreByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalRestoreByIdMutation, PrimalRestoreByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalRestoreByIdMutation, PrimalRestoreByIdMutationVariables>(PrimalRestoreByIdDocument, options);
      }
export type PrimalRestoreByIdMutationHookResult = ReturnType<typeof usePrimalRestoreByIdMutation>;
export type PrimalRestoreByIdMutationResult = Apollo.MutationResult<PrimalRestoreByIdMutation>;
export type PrimalRestoreByIdMutationOptions = Apollo.BaseMutationOptions<PrimalRestoreByIdMutation, PrimalRestoreByIdMutationVariables>;
export const PrimalSoftDeleteByIdDocument = gql`
    mutation PrimalSoftDeleteById($id: MongoID!) {
  primalUpdateById(_id: $id, record: {isDeleted: true}) {
    record {
      _id
      isDeleted
      deletedAt
    }
  }
}
    `;
export type PrimalSoftDeleteByIdMutationFn = Apollo.MutationFunction<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>;

/**
 * __usePrimalSoftDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePrimalSoftDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalSoftDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalSoftDeleteByIdMutation, { data, loading, error }] = usePrimalSoftDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalSoftDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>(PrimalSoftDeleteByIdDocument, options);
      }
export type PrimalSoftDeleteByIdMutationHookResult = ReturnType<typeof usePrimalSoftDeleteByIdMutation>;
export type PrimalSoftDeleteByIdMutationResult = Apollo.MutationResult<PrimalSoftDeleteByIdMutation>;
export type PrimalSoftDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>;
export const PrimalUpdateByIdDocument = gql`
    mutation PrimalUpdateById($_id: MongoID!, $record: UpdateByIdPrimalInput!) {
  primalUpdateById(_id: $_id, record: $record) {
    recordId
  }
}
    `;
export type PrimalUpdateByIdMutationFn = Apollo.MutationFunction<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>;

/**
 * __usePrimalUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePrimalUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalUpdateByIdMutation, { data, loading, error }] = usePrimalUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>(PrimalUpdateByIdDocument, options);
      }
export type PrimalUpdateByIdMutationHookResult = ReturnType<typeof usePrimalUpdateByIdMutation>;
export type PrimalUpdateByIdMutationResult = Apollo.MutationResult<PrimalUpdateByIdMutation>;
export type PrimalUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>;
export const ProcessingJobForceUpdateStatusDocument = gql`
    mutation ProcessingJobForceUpdateStatus($processorSchedulingId: MongoID!, $processorSchedulingStatus: String!) {
  processingJobForceUpdateStatus(
    processorSchedulingId: $processorSchedulingId
    processorSchedulingStatus: $processorSchedulingStatus
  ) {
    recordId
    record {
      _id
      status
      statusLastUpdated
    }
    previousStatus
    newStatus
  }
}
    `;
export type ProcessingJobForceUpdateStatusMutationFn = Apollo.MutationFunction<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>;

/**
 * __useProcessingJobForceUpdateStatusMutation__
 *
 * To run a mutation, you first call `useProcessingJobForceUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessingJobForceUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processingJobForceUpdateStatusMutation, { data, loading, error }] = useProcessingJobForceUpdateStatusMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      processorSchedulingStatus: // value for 'processorSchedulingStatus'
 *   },
 * });
 */
export function useProcessingJobForceUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>(ProcessingJobForceUpdateStatusDocument, options);
      }
export type ProcessingJobForceUpdateStatusMutationHookResult = ReturnType<typeof useProcessingJobForceUpdateStatusMutation>;
export type ProcessingJobForceUpdateStatusMutationResult = Apollo.MutationResult<ProcessingJobForceUpdateStatusMutation>;
export type ProcessingJobForceUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>;
export const ProcessorCapabilityUpsertDocument = gql`
    mutation ProcessorCapabilityUpsert($animalSpecies: EnumProcessorCapabilityAnimalSpecies!, $inspectionLevel: EnumProcessorCapabilityInspectionLevel!, $primalCuts: [MongoID!]!, $canSelectMoreThanOneTrim: Boolean!, $trimSelection: EnumProcessorCapabilityTrimSelection!, $extras: [ProcessorCapabilityExtrasModelInput!], $trim: [ProcessorCapabilityTrimModelInput!], $specifications: [ProcessorCapabilitySpecificationSpecificationsInput!], $primalGroups: [ProcessorCapabilityPrimalGroupInput!], $newCutBlockers: JSON, $wizardWelcomeTitle: String, $wizardWelcomeContent: String, $extrasDescription: String, $trimDescription: String, $extrasImage: Upload, $extrasImageToRemove: Boolean, $trimImage: Upload, $trimImageToRemove: Boolean) {
  processorCapabilityUpsert(
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    primalCuts: $primalCuts
    extras: $extras
    trim: $trim
    canSelectMoreThanOneTrim: $canSelectMoreThanOneTrim
    trimSelection: $trimSelection
    specifications: $specifications
    primalGroups: $primalGroups
    newCutBlockers: $newCutBlockers
    wizardWelcomeTitle: $wizardWelcomeTitle
    wizardWelcomeContent: $wizardWelcomeContent
    extrasDescription: $extrasDescription
    trimDescription: $trimDescription
    extrasImage: $extrasImage
    extrasImageToRemove: $extrasImageToRemove
    trimImage: $trimImage
    trimImageToRemove: $trimImageToRemove
  ) {
    ...ProcessorCapabilityFragment
  }
}
    ${ProcessorCapabilityFragmentFragmentDoc}`;
export type ProcessorCapabilityUpsertMutationFn = Apollo.MutationFunction<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>;

/**
 * __useProcessorCapabilityUpsertMutation__
 *
 * To run a mutation, you first call `useProcessorCapabilityUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorCapabilityUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorCapabilityUpsertMutation, { data, loading, error }] = useProcessorCapabilityUpsertMutation({
 *   variables: {
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      primalCuts: // value for 'primalCuts'
 *      canSelectMoreThanOneTrim: // value for 'canSelectMoreThanOneTrim'
 *      trimSelection: // value for 'trimSelection'
 *      extras: // value for 'extras'
 *      trim: // value for 'trim'
 *      specifications: // value for 'specifications'
 *      primalGroups: // value for 'primalGroups'
 *      newCutBlockers: // value for 'newCutBlockers'
 *      wizardWelcomeTitle: // value for 'wizardWelcomeTitle'
 *      wizardWelcomeContent: // value for 'wizardWelcomeContent'
 *      extrasDescription: // value for 'extrasDescription'
 *      trimDescription: // value for 'trimDescription'
 *      extrasImage: // value for 'extrasImage'
 *      extrasImageToRemove: // value for 'extrasImageToRemove'
 *      trimImage: // value for 'trimImage'
 *      trimImageToRemove: // value for 'trimImageToRemove'
 *   },
 * });
 */
export function useProcessorCapabilityUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>(ProcessorCapabilityUpsertDocument, options);
      }
export type ProcessorCapabilityUpsertMutationHookResult = ReturnType<typeof useProcessorCapabilityUpsertMutation>;
export type ProcessorCapabilityUpsertMutationResult = Apollo.MutationResult<ProcessorCapabilityUpsertMutation>;
export type ProcessorCapabilityUpsertMutationOptions = Apollo.BaseMutationOptions<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>;
export const ProcessorDepositPaymentIntentCreateDocument = gql`
    mutation ProcessorDepositPaymentIntentCreate($jobId: MongoID!) {
  processorDepositPaymentIntentCreate(jobId: $jobId) {
    clientSecret
    connectedAccountId
  }
}
    `;
export type ProcessorDepositPaymentIntentCreateMutationFn = Apollo.MutationFunction<ProcessorDepositPaymentIntentCreateMutation, ProcessorDepositPaymentIntentCreateMutationVariables>;

/**
 * __useProcessorDepositPaymentIntentCreateMutation__
 *
 * To run a mutation, you first call `useProcessorDepositPaymentIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorDepositPaymentIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorDepositPaymentIntentCreateMutation, { data, loading, error }] = useProcessorDepositPaymentIntentCreateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useProcessorDepositPaymentIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorDepositPaymentIntentCreateMutation, ProcessorDepositPaymentIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorDepositPaymentIntentCreateMutation, ProcessorDepositPaymentIntentCreateMutationVariables>(ProcessorDepositPaymentIntentCreateDocument, options);
      }
export type ProcessorDepositPaymentIntentCreateMutationHookResult = ReturnType<typeof useProcessorDepositPaymentIntentCreateMutation>;
export type ProcessorDepositPaymentIntentCreateMutationResult = Apollo.MutationResult<ProcessorDepositPaymentIntentCreateMutation>;
export type ProcessorDepositPaymentIntentCreateMutationOptions = Apollo.BaseMutationOptions<ProcessorDepositPaymentIntentCreateMutation, ProcessorDepositPaymentIntentCreateMutationVariables>;
export const ProcessorExportCsvDocument = gql`
    mutation ProcessorExportCsv($vendorId: MongoID!, $type: ProcessorExportTypeEnum!, $startDate: String!, $endDate: String!, $animalSpecies: String, $inspectionLevel: String, $anchorDate: String, $columns: [ExportColumnInput], $sort: [ExportSortInput], $filters: [ExportFilterInput], $filterMode: String) {
  processorExportCsv(
    vendorId: $vendorId
    type: $type
    startDate: $startDate
    endDate: $endDate
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    anchorDate: $anchorDate
    columns: $columns
    sort: $sort
    filters: $filters
    filterMode: $filterMode
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorExportCsvMutationFn = Apollo.MutationFunction<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>;

/**
 * __useProcessorExportCsvMutation__
 *
 * To run a mutation, you first call `useProcessorExportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorExportCsvMutation, { data, loading, error }] = useProcessorExportCsvMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      type: // value for 'type'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      anchorDate: // value for 'anchorDate'
 *      columns: // value for 'columns'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      filterMode: // value for 'filterMode'
 *   },
 * });
 */
export function useProcessorExportCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>(ProcessorExportCsvDocument, options);
      }
export type ProcessorExportCsvMutationHookResult = ReturnType<typeof useProcessorExportCsvMutation>;
export type ProcessorExportCsvMutationResult = Apollo.MutationResult<ProcessorExportCsvMutation>;
export type ProcessorExportCsvMutationOptions = Apollo.BaseMutationOptions<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>;
export const ProcessorExportCsvByVendorIdDocument = gql`
    mutation ProcessorExportCsvByVendorId($vendorId: MongoID!, $startDate: String!, $endDate: String!) {
  processorExportCsvByVendorId(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorExportCsvByVendorIdMutationFn = Apollo.MutationFunction<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>;

/**
 * __useProcessorExportCsvByVendorIdMutation__
 *
 * To run a mutation, you first call `useProcessorExportCsvByVendorIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportCsvByVendorIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorExportCsvByVendorIdMutation, { data, loading, error }] = useProcessorExportCsvByVendorIdMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorExportCsvByVendorIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>(ProcessorExportCsvByVendorIdDocument, options);
      }
export type ProcessorExportCsvByVendorIdMutationHookResult = ReturnType<typeof useProcessorExportCsvByVendorIdMutation>;
export type ProcessorExportCsvByVendorIdMutationResult = Apollo.MutationResult<ProcessorExportCsvByVendorIdMutation>;
export type ProcessorExportCsvByVendorIdMutationOptions = Apollo.BaseMutationOptions<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>;
export const ProcessorSchedulingAnimalHeadBulkUpdateDocument = gql`
    mutation ProcessorSchedulingAnimalHeadBulkUpdate($processorSchedulingId: MongoID!, $updatedAnimalHeads: [AnimalHeadUpdatesInput]) {
  processorSchedulingAnimalHeadBulkUpdate(
    processorSchedulingId: $processorSchedulingId
    updatedAnimalHeads: $updatedAnimalHeads
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadBulkUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadBulkUpdateMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadBulkUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      updatedAnimalHeads: // value for 'updatedAnimalHeads'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadBulkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>(ProcessorSchedulingAnimalHeadBulkUpdateDocument, options);
      }
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadBulkUpdateMutation>;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadBulkUpdateMutation>;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>;
export const ProcessorSchedulingAnimalHeadDeleteDocument = gql`
    mutation ProcessorSchedulingAnimalHeadDelete($processorSchedulingId: MongoID!, $animalHeadId: MongoID!) {
  processorSchedulingAnimalHeadDelete(
    processorSchedulingId: $processorSchedulingId
    animalHeadId: $animalHeadId
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingAnimalHeadDeleteMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadDeleteMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadDeleteMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadDeleteMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadId: // value for 'animalHeadId'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>(ProcessorSchedulingAnimalHeadDeleteDocument, options);
      }
export type ProcessorSchedulingAnimalHeadDeleteMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadDeleteMutation>;
export type ProcessorSchedulingAnimalHeadDeleteMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadDeleteMutation>;
export type ProcessorSchedulingAnimalHeadDeleteMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>;
export const ProcessorSchedulingAnimalHeadPartialUpdateByIdDocument = gql`
    mutation ProcessorSchedulingAnimalHeadPartialUpdateById($processorSchedulingId: MongoID!, $animalHeadId: MongoID!, $record: ProcessorSchedulingPartialUpdateAnimalHeadInput!, $suppressNotifications: Boolean) {
  processorSchedulingAnimalHeadPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    animalHeadId: $animalHeadId
    record: $record
    suppressNotifications: $suppressNotifications
  ) {
    recordId
    record {
      _id
      animalHeads {
        _id
        tracking
        isHangingWeightPerSide
        hangingWeight
        hangingWeightSideA
        hangingWeightSideB
        thirdPartyFee
        liveWeight
        killDate
      }
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadPartialUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadId: // value for 'animalHeadId'
 *      record: // value for 'record'
 *      suppressNotifications: // value for 'suppressNotifications'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>(ProcessorSchedulingAnimalHeadPartialUpdateByIdDocument, options);
      }
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation>;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation>;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>;
export const ProcessorSchedulingBulkActionDocument = gql`
    mutation ProcessorSchedulingBulkAction($jobs: [ProcessorSchedulingBulkActionJobInput!]!) {
  processorSchedulingBulkAction(jobs: $jobs) {
    results {
      processorSchedulingId
      warnings
      error
      record {
        _id
        status
        statusLastUpdated
        killedDate
        animalHeads {
          _id
          producerIdentifier
          tracking
          inspectionLevel
          isHangingWeightPerSide
          hangingWeight
          hangingWeightSideA
          hangingWeightSideB
          liveWeight
          killDate
          cutDate
        }
      }
    }
  }
}
    `;
export type ProcessorSchedulingBulkActionMutationFn = Apollo.MutationFunction<ProcessorSchedulingBulkActionMutation, ProcessorSchedulingBulkActionMutationVariables>;

/**
 * __useProcessorSchedulingBulkActionMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingBulkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingBulkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingBulkActionMutation, { data, loading, error }] = useProcessorSchedulingBulkActionMutation({
 *   variables: {
 *      jobs: // value for 'jobs'
 *   },
 * });
 */
export function useProcessorSchedulingBulkActionMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingBulkActionMutation, ProcessorSchedulingBulkActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingBulkActionMutation, ProcessorSchedulingBulkActionMutationVariables>(ProcessorSchedulingBulkActionDocument, options);
      }
export type ProcessorSchedulingBulkActionMutationHookResult = ReturnType<typeof useProcessorSchedulingBulkActionMutation>;
export type ProcessorSchedulingBulkActionMutationResult = Apollo.MutationResult<ProcessorSchedulingBulkActionMutation>;
export type ProcessorSchedulingBulkActionMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingBulkActionMutation, ProcessorSchedulingBulkActionMutationVariables>;
export const ProcessorSchedulingBuyerCutsheetReminderDocument = gql`
    mutation ProcessorSchedulingBuyerCutsheetReminder($schedulingId: MongoID!, $contactUserId: MongoID!) {
  processorSchedulingBuyerCutsheetReminder(
    schedulingId: $schedulingId
    contactUserId: $contactUserId
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingBuyerCutsheetReminderMutationFn = Apollo.MutationFunction<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>;

/**
 * __useProcessorSchedulingBuyerCutsheetReminderMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingBuyerCutsheetReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingBuyerCutsheetReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingBuyerCutsheetReminderMutation, { data, loading, error }] = useProcessorSchedulingBuyerCutsheetReminderMutation({
 *   variables: {
 *      schedulingId: // value for 'schedulingId'
 *      contactUserId: // value for 'contactUserId'
 *   },
 * });
 */
export function useProcessorSchedulingBuyerCutsheetReminderMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>(ProcessorSchedulingBuyerCutsheetReminderDocument, options);
      }
export type ProcessorSchedulingBuyerCutsheetReminderMutationHookResult = ReturnType<typeof useProcessorSchedulingBuyerCutsheetReminderMutation>;
export type ProcessorSchedulingBuyerCutsheetReminderMutationResult = Apollo.MutationResult<ProcessorSchedulingBuyerCutsheetReminderMutation>;
export type ProcessorSchedulingBuyerCutsheetReminderMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>;
export const ProcessorSchedulingCutsheetReminderDocument = gql`
    mutation processorSchedulingCutsheetReminder($schedulingId: MongoID!) {
  processorSchedulingCutsheetReminder(schedulingId: $schedulingId) {
    ...ProcessorSchedulingFragment
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;
export type ProcessorSchedulingCutsheetReminderMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetReminderMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetReminderMutation, { data, loading, error }] = useProcessorSchedulingCutsheetReminderMutation({
 *   variables: {
 *      schedulingId: // value for 'schedulingId'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetReminderMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>(ProcessorSchedulingCutsheetReminderDocument, options);
      }
export type ProcessorSchedulingCutsheetReminderMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetReminderMutation>;
export type ProcessorSchedulingCutsheetReminderMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetReminderMutation>;
export type ProcessorSchedulingCutsheetReminderMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>;
export const ProcessorSchedulingCutsheetsPartialUpdateDocument = gql`
    mutation ProcessorSchedulingCutsheetsPartialUpdate($processorSchedulingId: MongoID!, $record: [CutsheetPartialUpdateInput]!) {
  processorSchedulingUpdateCutsheets(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
  }
}
    `;
export type ProcessorSchedulingCutsheetsPartialUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetsPartialUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetsPartialUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetsPartialUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetsPartialUpdateMutation, { data, loading, error }] = useProcessorSchedulingCutsheetsPartialUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetsPartialUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>(ProcessorSchedulingCutsheetsPartialUpdateDocument, options);
      }
export type ProcessorSchedulingCutsheetsPartialUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetsPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetsPartialUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetsPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetsPartialUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>;
export const ProcessorSchedulingDepositChargeCardDocument = gql`
    mutation ProcessorSchedulingDepositChargeCard($jobId: MongoID!, $paymentMethodId: String!) {
  processorSchedulingDepositChargeCard(
    jobId: $jobId
    paymentMethodId: $paymentMethodId
  ) {
    _id
    status
    deposit {
      amount
      method
      status
    }
  }
}
    `;
export type ProcessorSchedulingDepositChargeCardMutationFn = Apollo.MutationFunction<ProcessorSchedulingDepositChargeCardMutation, ProcessorSchedulingDepositChargeCardMutationVariables>;

/**
 * __useProcessorSchedulingDepositChargeCardMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDepositChargeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDepositChargeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDepositChargeCardMutation, { data, loading, error }] = useProcessorSchedulingDepositChargeCardMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useProcessorSchedulingDepositChargeCardMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDepositChargeCardMutation, ProcessorSchedulingDepositChargeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDepositChargeCardMutation, ProcessorSchedulingDepositChargeCardMutationVariables>(ProcessorSchedulingDepositChargeCardDocument, options);
      }
export type ProcessorSchedulingDepositChargeCardMutationHookResult = ReturnType<typeof useProcessorSchedulingDepositChargeCardMutation>;
export type ProcessorSchedulingDepositChargeCardMutationResult = Apollo.MutationResult<ProcessorSchedulingDepositChargeCardMutation>;
export type ProcessorSchedulingDepositChargeCardMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDepositChargeCardMutation, ProcessorSchedulingDepositChargeCardMutationVariables>;
export const ProcessorSchedulingDepositCheckStripeDocument = gql`
    mutation ProcessorSchedulingDepositCheckStripe($jobId: MongoID!) {
  processorSchedulingDepositCheckStripe(jobId: $jobId) {
    found
    message
    scheduling {
      _id
      status
      deposit {
        amount
        method
        status
      }
    }
  }
}
    `;
export type ProcessorSchedulingDepositCheckStripeMutationFn = Apollo.MutationFunction<ProcessorSchedulingDepositCheckStripeMutation, ProcessorSchedulingDepositCheckStripeMutationVariables>;

/**
 * __useProcessorSchedulingDepositCheckStripeMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDepositCheckStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDepositCheckStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDepositCheckStripeMutation, { data, loading, error }] = useProcessorSchedulingDepositCheckStripeMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useProcessorSchedulingDepositCheckStripeMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDepositCheckStripeMutation, ProcessorSchedulingDepositCheckStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDepositCheckStripeMutation, ProcessorSchedulingDepositCheckStripeMutationVariables>(ProcessorSchedulingDepositCheckStripeDocument, options);
      }
export type ProcessorSchedulingDepositCheckStripeMutationHookResult = ReturnType<typeof useProcessorSchedulingDepositCheckStripeMutation>;
export type ProcessorSchedulingDepositCheckStripeMutationResult = Apollo.MutationResult<ProcessorSchedulingDepositCheckStripeMutation>;
export type ProcessorSchedulingDepositCheckStripeMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDepositCheckStripeMutation, ProcessorSchedulingDepositCheckStripeMutationVariables>;
export const ProcessorSchedulingDepositMarkPaidDocument = gql`
    mutation ProcessorSchedulingDepositMarkPaid($jobId: MongoID!, $method: DepositManualMethod!) {
  processorSchedulingDepositMarkPaid(jobId: $jobId, method: $method) {
    _id
    status
    deposit {
      amount
      method
      status
    }
  }
}
    `;
export type ProcessorSchedulingDepositMarkPaidMutationFn = Apollo.MutationFunction<ProcessorSchedulingDepositMarkPaidMutation, ProcessorSchedulingDepositMarkPaidMutationVariables>;

/**
 * __useProcessorSchedulingDepositMarkPaidMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDepositMarkPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDepositMarkPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDepositMarkPaidMutation, { data, loading, error }] = useProcessorSchedulingDepositMarkPaidMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useProcessorSchedulingDepositMarkPaidMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDepositMarkPaidMutation, ProcessorSchedulingDepositMarkPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDepositMarkPaidMutation, ProcessorSchedulingDepositMarkPaidMutationVariables>(ProcessorSchedulingDepositMarkPaidDocument, options);
      }
export type ProcessorSchedulingDepositMarkPaidMutationHookResult = ReturnType<typeof useProcessorSchedulingDepositMarkPaidMutation>;
export type ProcessorSchedulingDepositMarkPaidMutationResult = Apollo.MutationResult<ProcessorSchedulingDepositMarkPaidMutation>;
export type ProcessorSchedulingDepositMarkPaidMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDepositMarkPaidMutation, ProcessorSchedulingDepositMarkPaidMutationVariables>;
export const ProcessorSchedulingDragAndDropUpdateDocument = gql`
    mutation processorSchedulingDragAndDropUpdate($processorSchedulingId: MongoID!, $eventType: String!, $eventDate: String!, $animalHeadIds: [MongoID]) {
  processorSchedulingDragAndDropUpdate(
    processorSchedulingId: $processorSchedulingId
    eventType: $eventType
    eventDate: $eventDate
    animalHeadIds: $animalHeadIds
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingDragAndDropUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>;

/**
 * __useProcessorSchedulingDragAndDropUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDragAndDropUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDragAndDropUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDragAndDropUpdateMutation, { data, loading, error }] = useProcessorSchedulingDragAndDropUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      eventType: // value for 'eventType'
 *      eventDate: // value for 'eventDate'
 *      animalHeadIds: // value for 'animalHeadIds'
 *   },
 * });
 */
export function useProcessorSchedulingDragAndDropUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>(ProcessorSchedulingDragAndDropUpdateDocument, options);
      }
export type ProcessorSchedulingDragAndDropUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingDragAndDropUpdateMutation>;
export type ProcessorSchedulingDragAndDropUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingDragAndDropUpdateMutation>;
export type ProcessorSchedulingDragAndDropUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>;
export const ProcessorSchedulingDropoffConfirmationSetDocument = gql`
    mutation ProcessorSchedulingDropoffConfirmationSet($jobId: MongoID!, $status: String) {
  processorSchedulingDropoffConfirmationSet(jobId: $jobId, status: $status) {
    _id
    customerConfirmation {
      status
      respondedAt
      via
      respondedByName
    }
    customerConfirmationHistory {
      status
      respondedAt
      via
      respondedByName
    }
  }
}
    `;
export type ProcessorSchedulingDropoffConfirmationSetMutationFn = Apollo.MutationFunction<ProcessorSchedulingDropoffConfirmationSetMutation, ProcessorSchedulingDropoffConfirmationSetMutationVariables>;

/**
 * __useProcessorSchedulingDropoffConfirmationSetMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDropoffConfirmationSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDropoffConfirmationSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDropoffConfirmationSetMutation, { data, loading, error }] = useProcessorSchedulingDropoffConfirmationSetMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useProcessorSchedulingDropoffConfirmationSetMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDropoffConfirmationSetMutation, ProcessorSchedulingDropoffConfirmationSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDropoffConfirmationSetMutation, ProcessorSchedulingDropoffConfirmationSetMutationVariables>(ProcessorSchedulingDropoffConfirmationSetDocument, options);
      }
export type ProcessorSchedulingDropoffConfirmationSetMutationHookResult = ReturnType<typeof useProcessorSchedulingDropoffConfirmationSetMutation>;
export type ProcessorSchedulingDropoffConfirmationSetMutationResult = Apollo.MutationResult<ProcessorSchedulingDropoffConfirmationSetMutation>;
export type ProcessorSchedulingDropoffConfirmationSetMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDropoffConfirmationSetMutation, ProcessorSchedulingDropoffConfirmationSetMutationVariables>;
export const ProcessorSchedulingGenerateBillingStatementDocument = gql`
    mutation ProcessorSchedulingGenerateBillingStatement($processorSchedulingId: MongoID!) {
  processorSchedulingGenerateBillingStatement(
    processorSchedulingId: $processorSchedulingId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateBillingStatementMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>;

/**
 * __useProcessorSchedulingGenerateBillingStatementMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateBillingStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateBillingStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateBillingStatementMutation, { data, loading, error }] = useProcessorSchedulingGenerateBillingStatementMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateBillingStatementMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>(ProcessorSchedulingGenerateBillingStatementDocument, options);
      }
export type ProcessorSchedulingGenerateBillingStatementMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateBillingStatementMutation>;
export type ProcessorSchedulingGenerateBillingStatementMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateBillingStatementMutation>;
export type ProcessorSchedulingGenerateBillingStatementMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>;
export const ProcessorSchedulingGenerateBulkCarcassTagsDocument = gql`
    mutation ProcessorSchedulingGenerateBulkCarcassTags($processorSchedulingIds: [MongoID!]!, $killDate: String) {
  processorSchedulingGenerateBulkCarcassTags(
    processorSchedulingIds: $processorSchedulingIds
    killDate: $killDate
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateBulkCarcassTagsMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateBulkCarcassTagsMutation, ProcessorSchedulingGenerateBulkCarcassTagsMutationVariables>;

/**
 * __useProcessorSchedulingGenerateBulkCarcassTagsMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateBulkCarcassTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateBulkCarcassTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateBulkCarcassTagsMutation, { data, loading, error }] = useProcessorSchedulingGenerateBulkCarcassTagsMutation({
 *   variables: {
 *      processorSchedulingIds: // value for 'processorSchedulingIds'
 *      killDate: // value for 'killDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateBulkCarcassTagsMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateBulkCarcassTagsMutation, ProcessorSchedulingGenerateBulkCarcassTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateBulkCarcassTagsMutation, ProcessorSchedulingGenerateBulkCarcassTagsMutationVariables>(ProcessorSchedulingGenerateBulkCarcassTagsDocument, options);
      }
export type ProcessorSchedulingGenerateBulkCarcassTagsMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateBulkCarcassTagsMutation>;
export type ProcessorSchedulingGenerateBulkCarcassTagsMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateBulkCarcassTagsMutation>;
export type ProcessorSchedulingGenerateBulkCarcassTagsMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateBulkCarcassTagsMutation, ProcessorSchedulingGenerateBulkCarcassTagsMutationVariables>;
export const ProcessorSchedulingGenerateBulkCutsheetRequestsDocument = gql`
    mutation ProcessorSchedulingGenerateBulkCutsheetRequests($requests: [BulkCutsheetRequestInput!]!) {
  processorSchedulingGenerateBulkCutsheetRequests(requests: $requests) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateBulkCutsheetRequestsMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateBulkCutsheetRequestsMutation, ProcessorSchedulingGenerateBulkCutsheetRequestsMutationVariables>;

/**
 * __useProcessorSchedulingGenerateBulkCutsheetRequestsMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateBulkCutsheetRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateBulkCutsheetRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateBulkCutsheetRequestsMutation, { data, loading, error }] = useProcessorSchedulingGenerateBulkCutsheetRequestsMutation({
 *   variables: {
 *      requests: // value for 'requests'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateBulkCutsheetRequestsMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateBulkCutsheetRequestsMutation, ProcessorSchedulingGenerateBulkCutsheetRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateBulkCutsheetRequestsMutation, ProcessorSchedulingGenerateBulkCutsheetRequestsMutationVariables>(ProcessorSchedulingGenerateBulkCutsheetRequestsDocument, options);
      }
export type ProcessorSchedulingGenerateBulkCutsheetRequestsMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateBulkCutsheetRequestsMutation>;
export type ProcessorSchedulingGenerateBulkCutsheetRequestsMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateBulkCutsheetRequestsMutation>;
export type ProcessorSchedulingGenerateBulkCutsheetRequestsMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateBulkCutsheetRequestsMutation, ProcessorSchedulingGenerateBulkCutsheetRequestsMutationVariables>;
export const ProcessorSchedulingGenerateCarcassTagsDocument = gql`
    mutation ProcessorSchedulingGenerateCarcassTags($processorSchedulingId: MongoID!, $animalHeadIds: [MongoID]) {
  processorSchedulingGenerateCarcassTags(
    processorSchedulingId: $processorSchedulingId
    animalHeadIds: $animalHeadIds
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateCarcassTagsMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCarcassTagsMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCarcassTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCarcassTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCarcassTagsMutation, { data, loading, error }] = useProcessorSchedulingGenerateCarcassTagsMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadIds: // value for 'animalHeadIds'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCarcassTagsMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>(ProcessorSchedulingGenerateCarcassTagsDocument, options);
      }
export type ProcessorSchedulingGenerateCarcassTagsMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCarcassTagsMutation>;
export type ProcessorSchedulingGenerateCarcassTagsMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCarcassTagsMutation>;
export type ProcessorSchedulingGenerateCarcassTagsMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>;
export const ProcessorSchedulingGenerateCsvByVendorIdDocument = gql`
    mutation ProcessorSchedulingGenerateCsvByVendorId($vendorId: MongoID, $startDate: String!, $endDate: String!) {
  processorSchedulingGenerateCsvByVendorId(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCsvByVendorIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCsvByVendorIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCsvByVendorIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCsvByVendorIdMutation, { data, loading, error }] = useProcessorSchedulingGenerateCsvByVendorIdMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCsvByVendorIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>(ProcessorSchedulingGenerateCsvByVendorIdDocument, options);
      }
export type ProcessorSchedulingGenerateCsvByVendorIdMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCsvByVendorIdMutation>;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCsvByVendorIdMutation>;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>;
export const ProcessorSchedulingGenerateCutsheetRequestDocument = gql`
    mutation ProcessorSchedulingGenerateCutsheetRequest($processorSchedulingId: MongoID!, $cutsheetRequestId: MongoID!) {
  processorSchedulingGenerateCutsheetRequest(
    processorSchedulingId: $processorSchedulingId
    cutsheetRequestId: $cutsheetRequestId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateCutsheetRequestMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCutsheetRequestMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCutsheetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCutsheetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCutsheetRequestMutation, { data, loading, error }] = useProcessorSchedulingGenerateCutsheetRequestMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      cutsheetRequestId: // value for 'cutsheetRequestId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCutsheetRequestMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>(ProcessorSchedulingGenerateCutsheetRequestDocument, options);
      }
export type ProcessorSchedulingGenerateCutsheetRequestMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCutsheetRequestMutation>;
export type ProcessorSchedulingGenerateCutsheetRequestMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCutsheetRequestMutation>;
export type ProcessorSchedulingGenerateCutsheetRequestMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>;
export const ProcessorSchedulingGenerateHangingWeightCsvDocument = gql`
    mutation ProcessorSchedulingGenerateHangingWeightCsv($vendorId: MongoID, $startDate: String!, $endDate: String!) {
  processorSchedulingGenerateHangingWeightCsv(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>;

/**
 * __useProcessorSchedulingGenerateHangingWeightCsvMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateHangingWeightCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateHangingWeightCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateHangingWeightCsvMutation, { data, loading, error }] = useProcessorSchedulingGenerateHangingWeightCsvMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateHangingWeightCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>(ProcessorSchedulingGenerateHangingWeightCsvDocument, options);
      }
export type ProcessorSchedulingGenerateHangingWeightCsvMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateHangingWeightCsvMutation>;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateHangingWeightCsvMutation>;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>;
export const ProcessorSchedulingGenerateKillSheetDocument = gql`
    mutation ProcessorSchedulingGenerateKillSheet($date: Date!) {
  processorSchedulingGenerateKillSheet(date: $date) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateKillSheetMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>;

/**
 * __useProcessorSchedulingGenerateKillSheetMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateKillSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateKillSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateKillSheetMutation, { data, loading, error }] = useProcessorSchedulingGenerateKillSheetMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateKillSheetMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>(ProcessorSchedulingGenerateKillSheetDocument, options);
      }
export type ProcessorSchedulingGenerateKillSheetMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateKillSheetMutation>;
export type ProcessorSchedulingGenerateKillSheetMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateKillSheetMutation>;
export type ProcessorSchedulingGenerateKillSheetMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>;
export const ProcessorSchedulingGeneratePackingSlipDocument = gql`
    mutation ProcessorSchedulingGeneratePackingSlip($processorSchedulingId: MongoID!, $cutsheetInformationId: MongoID) {
  processorSchedulingGeneratePackingSlip(
    processorSchedulingId: $processorSchedulingId
    cutsheetInformationId: $cutsheetInformationId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGeneratePackingSlipMutationFn = Apollo.MutationFunction<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>;

/**
 * __useProcessorSchedulingGeneratePackingSlipMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGeneratePackingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGeneratePackingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGeneratePackingSlipMutation, { data, loading, error }] = useProcessorSchedulingGeneratePackingSlipMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      cutsheetInformationId: // value for 'cutsheetInformationId'
 *   },
 * });
 */
export function useProcessorSchedulingGeneratePackingSlipMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>(ProcessorSchedulingGeneratePackingSlipDocument, options);
      }
export type ProcessorSchedulingGeneratePackingSlipMutationHookResult = ReturnType<typeof useProcessorSchedulingGeneratePackingSlipMutation>;
export type ProcessorSchedulingGeneratePackingSlipMutationResult = Apollo.MutationResult<ProcessorSchedulingGeneratePackingSlipMutation>;
export type ProcessorSchedulingGeneratePackingSlipMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>;
export const ProcessorSchedulingNotificationSendDocument = gql`
    mutation ProcessorSchedulingNotificationSend($type: NotificationTypeInput, $notificationRequest: NotificationRequestInput) {
  processorSchedulingNotificationSend(type: $type, request: $notificationRequest) {
    _id
  }
}
    `;
export type ProcessorSchedulingNotificationSendMutationFn = Apollo.MutationFunction<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>;

/**
 * __useProcessorSchedulingNotificationSendMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingNotificationSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingNotificationSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingNotificationSendMutation, { data, loading, error }] = useProcessorSchedulingNotificationSendMutation({
 *   variables: {
 *      type: // value for 'type'
 *      notificationRequest: // value for 'notificationRequest'
 *   },
 * });
 */
export function useProcessorSchedulingNotificationSendMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>(ProcessorSchedulingNotificationSendDocument, options);
      }
export type ProcessorSchedulingNotificationSendMutationHookResult = ReturnType<typeof useProcessorSchedulingNotificationSendMutation>;
export type ProcessorSchedulingNotificationSendMutationResult = Apollo.MutationResult<ProcessorSchedulingNotificationSendMutation>;
export type ProcessorSchedulingNotificationSendMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>;
export const ProcessorSchedulingPartialUpdateByIdDocument = gql`
    mutation ProcessorSchedulingPartialUpdateById($processorSchedulingId: MongoID!, $record: ProcessorSchedulingPartialUpdateInput!, $suppressNotifications: Boolean) {
  processorSchedulingPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: $record
    suppressNotifications: $suppressNotifications
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingPartialUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingPartialUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingPartialUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingPartialUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingPartialUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingPartialUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *      suppressNotifications: // value for 'suppressNotifications'
 *   },
 * });
 */
export function useProcessorSchedulingPartialUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>(ProcessorSchedulingPartialUpdateByIdDocument, options);
      }
export type ProcessorSchedulingPartialUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingPartialUpdateByIdMutation>;
export type ProcessorSchedulingPartialUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingPartialUpdateByIdMutation>;
export type ProcessorSchedulingPartialUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>;
export const ProcessorSchedulingCutsheetInformationPartialUpdateDocument = gql`
    mutation ProcessorSchedulingCutsheetInformationPartialUpdate($processorSchedulingId: MongoID!, $record: [CutsheetPartialUpdateInput]!) {
  processorSchedulingUpdateCutsheets(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
    record {
      _id
    }
  }
}
    `;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetInformationPartialUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetInformationPartialUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetInformationPartialUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetInformationPartialUpdateMutation, { data, loading, error }] = useProcessorSchedulingCutsheetInformationPartialUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetInformationPartialUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>(ProcessorSchedulingCutsheetInformationPartialUpdateDocument, options);
      }
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetInformationPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetInformationPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>;
export const ProcessorSchedulingResendDepositNotificationDocument = gql`
    mutation ProcessorSchedulingResendDepositNotification($jobId: MongoID!) {
  processorSchedulingResendDepositNotification(jobId: $jobId) {
    _id
    deposit {
      method
      status
    }
  }
}
    `;
export type ProcessorSchedulingResendDepositNotificationMutationFn = Apollo.MutationFunction<ProcessorSchedulingResendDepositNotificationMutation, ProcessorSchedulingResendDepositNotificationMutationVariables>;

/**
 * __useProcessorSchedulingResendDepositNotificationMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingResendDepositNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingResendDepositNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingResendDepositNotificationMutation, { data, loading, error }] = useProcessorSchedulingResendDepositNotificationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useProcessorSchedulingResendDepositNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingResendDepositNotificationMutation, ProcessorSchedulingResendDepositNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingResendDepositNotificationMutation, ProcessorSchedulingResendDepositNotificationMutationVariables>(ProcessorSchedulingResendDepositNotificationDocument, options);
      }
export type ProcessorSchedulingResendDepositNotificationMutationHookResult = ReturnType<typeof useProcessorSchedulingResendDepositNotificationMutation>;
export type ProcessorSchedulingResendDepositNotificationMutationResult = Apollo.MutationResult<ProcessorSchedulingResendDepositNotificationMutation>;
export type ProcessorSchedulingResendDepositNotificationMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingResendDepositNotificationMutation, ProcessorSchedulingResendDepositNotificationMutationVariables>;
export const ProcessorSchedulingSendManualNotificationDocument = gql`
    mutation ProcessorSchedulingSendManualNotification($jobId: MongoID!, $notificationSettingId: MongoID!, $recipients: [ManualNotificationRecipientInput!]!) {
  processorSchedulingSendManualNotification(
    jobId: $jobId
    notificationSettingId: $notificationSettingId
    recipients: $recipients
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingSendManualNotificationMutationFn = Apollo.MutationFunction<ProcessorSchedulingSendManualNotificationMutation, ProcessorSchedulingSendManualNotificationMutationVariables>;

/**
 * __useProcessorSchedulingSendManualNotificationMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingSendManualNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingSendManualNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingSendManualNotificationMutation, { data, loading, error }] = useProcessorSchedulingSendManualNotificationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      notificationSettingId: // value for 'notificationSettingId'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useProcessorSchedulingSendManualNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingSendManualNotificationMutation, ProcessorSchedulingSendManualNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingSendManualNotificationMutation, ProcessorSchedulingSendManualNotificationMutationVariables>(ProcessorSchedulingSendManualNotificationDocument, options);
      }
export type ProcessorSchedulingSendManualNotificationMutationHookResult = ReturnType<typeof useProcessorSchedulingSendManualNotificationMutation>;
export type ProcessorSchedulingSendManualNotificationMutationResult = Apollo.MutationResult<ProcessorSchedulingSendManualNotificationMutation>;
export type ProcessorSchedulingSendManualNotificationMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingSendManualNotificationMutation, ProcessorSchedulingSendManualNotificationMutationVariables>;
export const ProcessorSchedulingSplitTypeUpdateByIdDocument = gql`
    mutation ProcessorSchedulingSplitTypeUpdateById($processorSchedulingId: MongoID!, $record: ProcessorSchedulingSplitTypeUpdateInput!) {
  processorSchedulingSplitTypeUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
  }
}
    `;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingSplitTypeUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingSplitTypeUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingSplitTypeUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingSplitTypeUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingSplitTypeUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingSplitTypeUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>(ProcessorSchedulingSplitTypeUpdateByIdDocument, options);
      }
export type ProcessorSchedulingSplitTypeUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingSplitTypeUpdateByIdMutation>;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingSplitTypeUpdateByIdMutation>;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>;
export const ProcessorSchedulingTagsUpdateDocument = gql`
    mutation ProcessorSchedulingTagsUpdate($processorSchedulingId: MongoID!, $addTags: [MongoID], $removeTags: [MongoID]) {
  processorSchedulingPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: {addTags: $addTags, removeTags: $removeTags}
  ) {
    recordId
    record {
      _id
      tags {
        _id
        name
        icon
        sortOrder
      }
    }
  }
}
    `;
export type ProcessorSchedulingTagsUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingTagsUpdateMutation, ProcessorSchedulingTagsUpdateMutationVariables>;

/**
 * __useProcessorSchedulingTagsUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingTagsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingTagsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingTagsUpdateMutation, { data, loading, error }] = useProcessorSchedulingTagsUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      addTags: // value for 'addTags'
 *      removeTags: // value for 'removeTags'
 *   },
 * });
 */
export function useProcessorSchedulingTagsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingTagsUpdateMutation, ProcessorSchedulingTagsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingTagsUpdateMutation, ProcessorSchedulingTagsUpdateMutationVariables>(ProcessorSchedulingTagsUpdateDocument, options);
      }
export type ProcessorSchedulingTagsUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingTagsUpdateMutation>;
export type ProcessorSchedulingTagsUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingTagsUpdateMutation>;
export type ProcessorSchedulingTagsUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingTagsUpdateMutation, ProcessorSchedulingTagsUpdateMutationVariables>;
export const ProcessorSchedulingUpdateByIdDocument = gql`
    mutation ProcessorSchedulingUpdateById($id: MongoID!, $record: UpdateByIdProcessorSchedulingInput!) {
  processorSchedulingUpdate(_id: $id, record: $record) {
    recordId
    record {
      _id
      status
      statusLastUpdated
      animalHeads {
        _id
        status
      }
    }
  }
}
    `;
export type ProcessorSchedulingUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>(ProcessorSchedulingUpdateByIdDocument, options);
      }
export type ProcessorSchedulingUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingUpdateByIdMutation>;
export type ProcessorSchedulingUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingUpdateByIdMutation>;
export type ProcessorSchedulingUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>;
export const ProcessorSettingsCreateDocument = gql`
    mutation ProcessorSettingsCreate($newProcessorSettings: CreateProcessorSettingsWithCustomCapacityInput!) {
  processorSettingsCreate(newProcessor: $newProcessorSettings) {
    processorSettings {
      ...ProcessorSettingsFragment
    }
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;
export type ProcessorSettingsCreateMutationFn = Apollo.MutationFunction<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>;

/**
 * __useProcessorSettingsCreateMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsCreateMutation, { data, loading, error }] = useProcessorSettingsCreateMutation({
 *   variables: {
 *      newProcessorSettings: // value for 'newProcessorSettings'
 *   },
 * });
 */
export function useProcessorSettingsCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>(ProcessorSettingsCreateDocument, options);
      }
export type ProcessorSettingsCreateMutationHookResult = ReturnType<typeof useProcessorSettingsCreateMutation>;
export type ProcessorSettingsCreateMutationResult = Apollo.MutationResult<ProcessorSettingsCreateMutation>;
export type ProcessorSettingsCreateMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>;
export const ProcessorSettingsCustomCapacityCreateOneDocument = gql`
    mutation ProcessorSettingsCustomCapacityCreateOne($record: CreateOneProcessorSettingsCustomCapacityInput!) {
  processorSettingsCustomCapacityCreateOne(record: $record) {
    recordId
  }
}
    `;
export type ProcessorSettingsCustomCapacityCreateOneMutationFn = Apollo.MutationFunction<ProcessorSettingsCustomCapacityCreateOneMutation, ProcessorSettingsCustomCapacityCreateOneMutationVariables>;

/**
 * __useProcessorSettingsCustomCapacityCreateOneMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsCustomCapacityCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsCustomCapacityCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsCustomCapacityCreateOneMutation, { data, loading, error }] = useProcessorSettingsCustomCapacityCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSettingsCustomCapacityCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsCustomCapacityCreateOneMutation, ProcessorSettingsCustomCapacityCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsCustomCapacityCreateOneMutation, ProcessorSettingsCustomCapacityCreateOneMutationVariables>(ProcessorSettingsCustomCapacityCreateOneDocument, options);
      }
export type ProcessorSettingsCustomCapacityCreateOneMutationHookResult = ReturnType<typeof useProcessorSettingsCustomCapacityCreateOneMutation>;
export type ProcessorSettingsCustomCapacityCreateOneMutationResult = Apollo.MutationResult<ProcessorSettingsCustomCapacityCreateOneMutation>;
export type ProcessorSettingsCustomCapacityCreateOneMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsCustomCapacityCreateOneMutation, ProcessorSettingsCustomCapacityCreateOneMutationVariables>;
export const ProcessorSettingsCustomCapacityUpdateByIdDocument = gql`
    mutation ProcessorSettingsCustomCapacityUpdateById($_id: MongoID!, $record: UpdateByIdProcessorSettingsCustomCapacityInput!) {
  processorSettingsCustomCapacityUpdateById(_id: $_id, record: $record) {
    recordId
  }
}
    `;
export type ProcessorSettingsCustomCapacityUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSettingsCustomCapacityUpdateByIdMutation, ProcessorSettingsCustomCapacityUpdateByIdMutationVariables>;

/**
 * __useProcessorSettingsCustomCapacityUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsCustomCapacityUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsCustomCapacityUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsCustomCapacityUpdateByIdMutation, { data, loading, error }] = useProcessorSettingsCustomCapacityUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSettingsCustomCapacityUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsCustomCapacityUpdateByIdMutation, ProcessorSettingsCustomCapacityUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsCustomCapacityUpdateByIdMutation, ProcessorSettingsCustomCapacityUpdateByIdMutationVariables>(ProcessorSettingsCustomCapacityUpdateByIdDocument, options);
      }
export type ProcessorSettingsCustomCapacityUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSettingsCustomCapacityUpdateByIdMutation>;
export type ProcessorSettingsCustomCapacityUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSettingsCustomCapacityUpdateByIdMutation>;
export type ProcessorSettingsCustomCapacityUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsCustomCapacityUpdateByIdMutation, ProcessorSettingsCustomCapacityUpdateByIdMutationVariables>;
export const ProcessorSettingsUpdateDocument = gql`
    mutation ProcessorSettingsUpdate($updateProcessorSettings: UpdateProcessorSettingsWithCustomCapacityInput!) {
  processorSettingsUpdate(updateProcessor: $updateProcessorSettings) {
    processorSettings {
      ...ProcessorSettingsFragment
    }
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;
export type ProcessorSettingsUpdateMutationFn = Apollo.MutationFunction<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>;

/**
 * __useProcessorSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsUpdateMutation, { data, loading, error }] = useProcessorSettingsUpdateMutation({
 *   variables: {
 *      updateProcessorSettings: // value for 'updateProcessorSettings'
 *   },
 * });
 */
export function useProcessorSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>(ProcessorSettingsUpdateDocument, options);
      }
export type ProcessorSettingsUpdateMutationHookResult = ReturnType<typeof useProcessorSettingsUpdateMutation>;
export type ProcessorSettingsUpdateMutationResult = Apollo.MutationResult<ProcessorSettingsUpdateMutation>;
export type ProcessorSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>;
export const ProducerSettingsUpdateDocument = gql`
    mutation ProducerSettingsUpdate($splitDeposits: [ProducerSplitDepositInput!]!, $listingPresets: [ProducerListingPresetInput!]) {
  producerSettingsUpdate(
    splitDeposits: $splitDeposits
    listingPresets: $listingPresets
  ) {
    producer
    splitDeposits {
      species
      whole
      half
      quarter
    }
    listingPresets {
      species
      pricingMode
      listingRatePerLb
      listingTotalPrice
      sizeTier
      allowedSectionSizes
      descriptorChips
      description
    }
  }
}
    `;
export type ProducerSettingsUpdateMutationFn = Apollo.MutationFunction<ProducerSettingsUpdateMutation, ProducerSettingsUpdateMutationVariables>;

/**
 * __useProducerSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useProducerSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProducerSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [producerSettingsUpdateMutation, { data, loading, error }] = useProducerSettingsUpdateMutation({
 *   variables: {
 *      splitDeposits: // value for 'splitDeposits'
 *      listingPresets: // value for 'listingPresets'
 *   },
 * });
 */
export function useProducerSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProducerSettingsUpdateMutation, ProducerSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProducerSettingsUpdateMutation, ProducerSettingsUpdateMutationVariables>(ProducerSettingsUpdateDocument, options);
      }
export type ProducerSettingsUpdateMutationHookResult = ReturnType<typeof useProducerSettingsUpdateMutation>;
export type ProducerSettingsUpdateMutationResult = Apollo.MutationResult<ProducerSettingsUpdateMutation>;
export type ProducerSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<ProducerSettingsUpdateMutation, ProducerSettingsUpdateMutationVariables>;
export const RecurringSeriesCancelUpcomingJobsDocument = gql`
    mutation RecurringSeriesCancelUpcomingJobs($seriesId: MongoID!, $cancellationReason: MongoID, $customText: String) {
  recurringSeriesCancelUpcomingJobs(
    seriesId: $seriesId
    cancellationReason: $cancellationReason
    customText: $customText
  ) {
    cancelled
  }
}
    `;
export type RecurringSeriesCancelUpcomingJobsMutationFn = Apollo.MutationFunction<RecurringSeriesCancelUpcomingJobsMutation, RecurringSeriesCancelUpcomingJobsMutationVariables>;

/**
 * __useRecurringSeriesCancelUpcomingJobsMutation__
 *
 * To run a mutation, you first call `useRecurringSeriesCancelUpcomingJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSeriesCancelUpcomingJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSeriesCancelUpcomingJobsMutation, { data, loading, error }] = useRecurringSeriesCancelUpcomingJobsMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      cancellationReason: // value for 'cancellationReason'
 *      customText: // value for 'customText'
 *   },
 * });
 */
export function useRecurringSeriesCancelUpcomingJobsMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSeriesCancelUpcomingJobsMutation, RecurringSeriesCancelUpcomingJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSeriesCancelUpcomingJobsMutation, RecurringSeriesCancelUpcomingJobsMutationVariables>(RecurringSeriesCancelUpcomingJobsDocument, options);
      }
export type RecurringSeriesCancelUpcomingJobsMutationHookResult = ReturnType<typeof useRecurringSeriesCancelUpcomingJobsMutation>;
export type RecurringSeriesCancelUpcomingJobsMutationResult = Apollo.MutationResult<RecurringSeriesCancelUpcomingJobsMutation>;
export type RecurringSeriesCancelUpcomingJobsMutationOptions = Apollo.BaseMutationOptions<RecurringSeriesCancelUpcomingJobsMutation, RecurringSeriesCancelUpcomingJobsMutationVariables>;
export const RecurringSeriesCreateDocument = gql`
    mutation RecurringSeriesCreate($vendorId: MongoID!, $producerId: MongoID, $animalSpecies: String!, $inspectionLevel: String!, $headCount: Int!, $rule: RecurrenceRuleInput!, $targetUpcomingCount: Int) {
  recurringSeriesCreate(
    vendorId: $vendorId
    producerId: $producerId
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    headCount: $headCount
    rule: $rule
    targetUpcomingCount: $targetUpcomingCount
  ) {
    _id
    active
  }
}
    `;
export type RecurringSeriesCreateMutationFn = Apollo.MutationFunction<RecurringSeriesCreateMutation, RecurringSeriesCreateMutationVariables>;

/**
 * __useRecurringSeriesCreateMutation__
 *
 * To run a mutation, you first call `useRecurringSeriesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSeriesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSeriesCreateMutation, { data, loading, error }] = useRecurringSeriesCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      producerId: // value for 'producerId'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      headCount: // value for 'headCount'
 *      rule: // value for 'rule'
 *      targetUpcomingCount: // value for 'targetUpcomingCount'
 *   },
 * });
 */
export function useRecurringSeriesCreateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSeriesCreateMutation, RecurringSeriesCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSeriesCreateMutation, RecurringSeriesCreateMutationVariables>(RecurringSeriesCreateDocument, options);
      }
export type RecurringSeriesCreateMutationHookResult = ReturnType<typeof useRecurringSeriesCreateMutation>;
export type RecurringSeriesCreateMutationResult = Apollo.MutationResult<RecurringSeriesCreateMutation>;
export type RecurringSeriesCreateMutationOptions = Apollo.BaseMutationOptions<RecurringSeriesCreateMutation, RecurringSeriesCreateMutationVariables>;
export const RecurringSeriesCreateFromJobDocument = gql`
    mutation RecurringSeriesCreateFromJob($processorSchedulingId: MongoID!, $rule: RecurrenceRuleInput!, $targetUpcomingCount: Int) {
  recurringSeriesCreateFromJob(
    processorSchedulingId: $processorSchedulingId
    rule: $rule
    targetUpcomingCount: $targetUpcomingCount
  ) {
    _id
    active
  }
}
    `;
export type RecurringSeriesCreateFromJobMutationFn = Apollo.MutationFunction<RecurringSeriesCreateFromJobMutation, RecurringSeriesCreateFromJobMutationVariables>;

/**
 * __useRecurringSeriesCreateFromJobMutation__
 *
 * To run a mutation, you first call `useRecurringSeriesCreateFromJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSeriesCreateFromJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSeriesCreateFromJobMutation, { data, loading, error }] = useRecurringSeriesCreateFromJobMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      rule: // value for 'rule'
 *      targetUpcomingCount: // value for 'targetUpcomingCount'
 *   },
 * });
 */
export function useRecurringSeriesCreateFromJobMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSeriesCreateFromJobMutation, RecurringSeriesCreateFromJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSeriesCreateFromJobMutation, RecurringSeriesCreateFromJobMutationVariables>(RecurringSeriesCreateFromJobDocument, options);
      }
export type RecurringSeriesCreateFromJobMutationHookResult = ReturnType<typeof useRecurringSeriesCreateFromJobMutation>;
export type RecurringSeriesCreateFromJobMutationResult = Apollo.MutationResult<RecurringSeriesCreateFromJobMutation>;
export type RecurringSeriesCreateFromJobMutationOptions = Apollo.BaseMutationOptions<RecurringSeriesCreateFromJobMutation, RecurringSeriesCreateFromJobMutationVariables>;
export const RecurringSeriesSetActiveDocument = gql`
    mutation RecurringSeriesSetActive($seriesId: MongoID!, $active: Boolean!) {
  recurringSeriesSetActive(seriesId: $seriesId, active: $active) {
    _id
    active
  }
}
    `;
export type RecurringSeriesSetActiveMutationFn = Apollo.MutationFunction<RecurringSeriesSetActiveMutation, RecurringSeriesSetActiveMutationVariables>;

/**
 * __useRecurringSeriesSetActiveMutation__
 *
 * To run a mutation, you first call `useRecurringSeriesSetActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSeriesSetActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSeriesSetActiveMutation, { data, loading, error }] = useRecurringSeriesSetActiveMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useRecurringSeriesSetActiveMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSeriesSetActiveMutation, RecurringSeriesSetActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSeriesSetActiveMutation, RecurringSeriesSetActiveMutationVariables>(RecurringSeriesSetActiveDocument, options);
      }
export type RecurringSeriesSetActiveMutationHookResult = ReturnType<typeof useRecurringSeriesSetActiveMutation>;
export type RecurringSeriesSetActiveMutationResult = Apollo.MutationResult<RecurringSeriesSetActiveMutation>;
export type RecurringSeriesSetActiveMutationOptions = Apollo.BaseMutationOptions<RecurringSeriesSetActiveMutation, RecurringSeriesSetActiveMutationVariables>;
export const RecurringSeriesUpdateRuleDocument = gql`
    mutation RecurringSeriesUpdateRule($seriesId: MongoID!, $rule: RecurrenceRuleInput!, $targetUpcomingCount: Int) {
  recurringSeriesUpdateRule(
    seriesId: $seriesId
    rule: $rule
    targetUpcomingCount: $targetUpcomingCount
  ) {
    _id
    active
    nextOccurrence
    targetUpcomingCount
    rule {
      freq
      interval
      anchor
      byDay {
        ordinal
        day
      }
      byMonthDay
      until
      count
    }
  }
}
    `;
export type RecurringSeriesUpdateRuleMutationFn = Apollo.MutationFunction<RecurringSeriesUpdateRuleMutation, RecurringSeriesUpdateRuleMutationVariables>;

/**
 * __useRecurringSeriesUpdateRuleMutation__
 *
 * To run a mutation, you first call `useRecurringSeriesUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSeriesUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSeriesUpdateRuleMutation, { data, loading, error }] = useRecurringSeriesUpdateRuleMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      rule: // value for 'rule'
 *      targetUpcomingCount: // value for 'targetUpcomingCount'
 *   },
 * });
 */
export function useRecurringSeriesUpdateRuleMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSeriesUpdateRuleMutation, RecurringSeriesUpdateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSeriesUpdateRuleMutation, RecurringSeriesUpdateRuleMutationVariables>(RecurringSeriesUpdateRuleDocument, options);
      }
export type RecurringSeriesUpdateRuleMutationHookResult = ReturnType<typeof useRecurringSeriesUpdateRuleMutation>;
export type RecurringSeriesUpdateRuleMutationResult = Apollo.MutationResult<RecurringSeriesUpdateRuleMutation>;
export type RecurringSeriesUpdateRuleMutationOptions = Apollo.BaseMutationOptions<RecurringSeriesUpdateRuleMutation, RecurringSeriesUpdateRuleMutationVariables>;
export const CreateFinancialReportingConfigDocument = gql`
    mutation CreateFinancialReportingConfig($record: CreateOneFinancialReportingConfigInput!) {
  financialReportingConfigCreateOne(record: $record) {
    record {
      _id
      vendor
      createdAt
      updatedAt
    }
    error {
      message
    }
  }
}
    `;
export type CreateFinancialReportingConfigMutationFn = Apollo.MutationFunction<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>;

/**
 * __useCreateFinancialReportingConfigMutation__
 *
 * To run a mutation, you first call `useCreateFinancialReportingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinancialReportingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinancialReportingConfigMutation, { data, loading, error }] = useCreateFinancialReportingConfigMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreateFinancialReportingConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>(CreateFinancialReportingConfigDocument, options);
      }
export type CreateFinancialReportingConfigMutationHookResult = ReturnType<typeof useCreateFinancialReportingConfigMutation>;
export type CreateFinancialReportingConfigMutationResult = Apollo.MutationResult<CreateFinancialReportingConfigMutation>;
export type CreateFinancialReportingConfigMutationOptions = Apollo.BaseMutationOptions<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>;
export const UpdateProcessorWorkflowCapacityDocument = gql`
    mutation UpdateProcessorWorkflowCapacity($capacity: JSON!) {
  processorWorkflowCapacityUpdate(capacity: $capacity)
}
    `;
export type UpdateProcessorWorkflowCapacityMutationFn = Apollo.MutationFunction<UpdateProcessorWorkflowCapacityMutation, UpdateProcessorWorkflowCapacityMutationVariables>;

/**
 * __useUpdateProcessorWorkflowCapacityMutation__
 *
 * To run a mutation, you first call `useUpdateProcessorWorkflowCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessorWorkflowCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessorWorkflowCapacityMutation, { data, loading, error }] = useUpdateProcessorWorkflowCapacityMutation({
 *   variables: {
 *      capacity: // value for 'capacity'
 *   },
 * });
 */
export function useUpdateProcessorWorkflowCapacityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessorWorkflowCapacityMutation, UpdateProcessorWorkflowCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessorWorkflowCapacityMutation, UpdateProcessorWorkflowCapacityMutationVariables>(UpdateProcessorWorkflowCapacityDocument, options);
      }
export type UpdateProcessorWorkflowCapacityMutationHookResult = ReturnType<typeof useUpdateProcessorWorkflowCapacityMutation>;
export type UpdateProcessorWorkflowCapacityMutationResult = Apollo.MutationResult<UpdateProcessorWorkflowCapacityMutation>;
export type UpdateProcessorWorkflowCapacityMutationOptions = Apollo.BaseMutationOptions<UpdateProcessorWorkflowCapacityMutation, UpdateProcessorWorkflowCapacityMutationVariables>;
export const UpdateFinancialReportingConfigDocument = gql`
    mutation UpdateFinancialReportingConfig($filter: FilterUpdateOneFinancialReportingConfigInput!, $record: UpdateOneFinancialReportingConfigInput!) {
  financialReportingConfigUpdateOne(filter: $filter, record: $record) {
    record {
      _id
      vendor
      updatedAt
    }
    error {
      message
    }
  }
}
    `;
export type UpdateFinancialReportingConfigMutationFn = Apollo.MutationFunction<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>;

/**
 * __useUpdateFinancialReportingConfigMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialReportingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialReportingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialReportingConfigMutation, { data, loading, error }] = useUpdateFinancialReportingConfigMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUpdateFinancialReportingConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>(UpdateFinancialReportingConfigDocument, options);
      }
export type UpdateFinancialReportingConfigMutationHookResult = ReturnType<typeof useUpdateFinancialReportingConfigMutation>;
export type UpdateFinancialReportingConfigMutationResult = Apollo.MutationResult<UpdateFinancialReportingConfigMutation>;
export type UpdateFinancialReportingConfigMutationOptions = Apollo.BaseMutationOptions<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($chatRoomId: MongoID!, $message: String!, $customerId: MongoID, $attachment: Upload, $documentId: MongoID) {
  sendMessage(
    chatRoomId: $chatRoomId
    message: $message
    customerId: $customerId
    attachment: $attachment
    documentId: $documentId
  ) {
    ...ChatMessageFragment
  }
}
    ${ChatMessageFragmentFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      message: // value for 'message'
 *      customerId: // value for 'customerId'
 *      attachment: // value for 'attachment'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const SendTestNotificationDocument = gql`
    mutation SendTestNotification($notificationSettingId: MongoID!, $email: String, $phone: String, $emailContent: String, $smsContent: String) {
  sendTestNotification(
    notificationSettingId: $notificationSettingId
    email: $email
    phone: $phone
    emailContent: $emailContent
    smsContent: $smsContent
  ) {
    emailSent
    smsSent
    errors
  }
}
    `;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      notificationSettingId: // value for 'notificationSettingId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      emailContent: // value for 'emailContent'
 *      smsContent: // value for 'smsContent'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = Apollo.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const SplitSendNotificationsUpdateDocument = gql`
    mutation SplitSendNotificationsUpdate($splitId: MongoID!, $sendNotifications: Boolean!) {
  splitSendNotificationsUpdate(
    splitId: $splitId
    sendNotifications: $sendNotifications
  ) {
    _id
    sendNotifications
  }
}
    `;
export type SplitSendNotificationsUpdateMutationFn = Apollo.MutationFunction<SplitSendNotificationsUpdateMutation, SplitSendNotificationsUpdateMutationVariables>;

/**
 * __useSplitSendNotificationsUpdateMutation__
 *
 * To run a mutation, you first call `useSplitSendNotificationsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitSendNotificationsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitSendNotificationsUpdateMutation, { data, loading, error }] = useSplitSendNotificationsUpdateMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      sendNotifications: // value for 'sendNotifications'
 *   },
 * });
 */
export function useSplitSendNotificationsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SplitSendNotificationsUpdateMutation, SplitSendNotificationsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitSendNotificationsUpdateMutation, SplitSendNotificationsUpdateMutationVariables>(SplitSendNotificationsUpdateDocument, options);
      }
export type SplitSendNotificationsUpdateMutationHookResult = ReturnType<typeof useSplitSendNotificationsUpdateMutation>;
export type SplitSendNotificationsUpdateMutationResult = Apollo.MutationResult<SplitSendNotificationsUpdateMutation>;
export type SplitSendNotificationsUpdateMutationOptions = Apollo.BaseMutationOptions<SplitSendNotificationsUpdateMutation, SplitSendNotificationsUpdateMutationVariables>;
export const ProducerStripeAccountCreateDocument = gql`
    mutation ProducerStripeAccountCreate {
  producerStripeAccountCreate {
    id
    status
  }
}
    `;
export type ProducerStripeAccountCreateMutationFn = Apollo.MutationFunction<ProducerStripeAccountCreateMutation, ProducerStripeAccountCreateMutationVariables>;

/**
 * __useProducerStripeAccountCreateMutation__
 *
 * To run a mutation, you first call `useProducerStripeAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProducerStripeAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [producerStripeAccountCreateMutation, { data, loading, error }] = useProducerStripeAccountCreateMutation({
 *   variables: {
 *   },
 * });
 */
export function useProducerStripeAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProducerStripeAccountCreateMutation, ProducerStripeAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProducerStripeAccountCreateMutation, ProducerStripeAccountCreateMutationVariables>(ProducerStripeAccountCreateDocument, options);
      }
export type ProducerStripeAccountCreateMutationHookResult = ReturnType<typeof useProducerStripeAccountCreateMutation>;
export type ProducerStripeAccountCreateMutationResult = Apollo.MutationResult<ProducerStripeAccountCreateMutation>;
export type ProducerStripeAccountCreateMutationOptions = Apollo.BaseMutationOptions<ProducerStripeAccountCreateMutation, ProducerStripeAccountCreateMutationVariables>;
export const ProducerStripeSessionCreateDocument = gql`
    mutation ProducerStripeSessionCreate {
  producerStripeSessionCreate {
    clientSecret
  }
}
    `;
export type ProducerStripeSessionCreateMutationFn = Apollo.MutationFunction<ProducerStripeSessionCreateMutation, ProducerStripeSessionCreateMutationVariables>;

/**
 * __useProducerStripeSessionCreateMutation__
 *
 * To run a mutation, you first call `useProducerStripeSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProducerStripeSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [producerStripeSessionCreateMutation, { data, loading, error }] = useProducerStripeSessionCreateMutation({
 *   variables: {
 *   },
 * });
 */
export function useProducerStripeSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProducerStripeSessionCreateMutation, ProducerStripeSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProducerStripeSessionCreateMutation, ProducerStripeSessionCreateMutationVariables>(ProducerStripeSessionCreateDocument, options);
      }
export type ProducerStripeSessionCreateMutationHookResult = ReturnType<typeof useProducerStripeSessionCreateMutation>;
export type ProducerStripeSessionCreateMutationResult = Apollo.MutationResult<ProducerStripeSessionCreateMutation>;
export type ProducerStripeSessionCreateMutationOptions = Apollo.BaseMutationOptions<ProducerStripeSessionCreateMutation, ProducerStripeSessionCreateMutationVariables>;
export const StripeAccountCreateDocument = gql`
    mutation StripeAccountCreate($vendorId: MongoID) {
  stripeAccountCreate(vendorId: $vendorId) {
    _id
    stripe_config
  }
}
    `;
export type StripeAccountCreateMutationFn = Apollo.MutationFunction<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>;

/**
 * __useStripeAccountCreateMutation__
 *
 * To run a mutation, you first call `useStripeAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeAccountCreateMutation, { data, loading, error }] = useStripeAccountCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useStripeAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>(StripeAccountCreateDocument, options);
      }
export type StripeAccountCreateMutationHookResult = ReturnType<typeof useStripeAccountCreateMutation>;
export type StripeAccountCreateMutationResult = Apollo.MutationResult<StripeAccountCreateMutation>;
export type StripeAccountCreateMutationOptions = Apollo.BaseMutationOptions<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>;
export const StripeSessionCreateDocument = gql`
    mutation StripeSessionCreate($vendorId: MongoID) {
  stripeSessionCreate(vendorId: $vendorId) {
    _id
    stripe_config
  }
}
    `;
export type StripeSessionCreateMutationFn = Apollo.MutationFunction<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>;

/**
 * __useStripeSessionCreateMutation__
 *
 * To run a mutation, you first call `useStripeSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSessionCreateMutation, { data, loading, error }] = useStripeSessionCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useStripeSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>(StripeSessionCreateDocument, options);
      }
export type StripeSessionCreateMutationHookResult = ReturnType<typeof useStripeSessionCreateMutation>;
export type StripeSessionCreateMutationResult = Apollo.MutationResult<StripeSessionCreateMutation>;
export type StripeSessionCreateMutationOptions = Apollo.BaseMutationOptions<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>;
export const UpdateAuthMethodDocument = gql`
    mutation UpdateAuthMethod($targetAuthMethod: String!, $newPassword: String) {
  updateAuthMethod(targetAuthMethod: $targetAuthMethod, newPassword: $newPassword) {
    success
    message
    authMethod
  }
}
    `;
export type UpdateAuthMethodMutationFn = Apollo.MutationFunction<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>;

/**
 * __useUpdateAuthMethodMutation__
 *
 * To run a mutation, you first call `useUpdateAuthMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthMethodMutation, { data, loading, error }] = useUpdateAuthMethodMutation({
 *   variables: {
 *      targetAuthMethod: // value for 'targetAuthMethod'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdateAuthMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>(UpdateAuthMethodDocument, options);
      }
export type UpdateAuthMethodMutationHookResult = ReturnType<typeof useUpdateAuthMethodMutation>;
export type UpdateAuthMethodMutationResult = Apollo.MutationResult<UpdateAuthMethodMutation>;
export type UpdateAuthMethodMutationOptions = Apollo.BaseMutationOptions<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($firstName: String, $lastName: String, $email: String, $phone: String, $company: String, $address: AddressInputForProfile, $acceptTos: Boolean, $acceptPrivacyPolicy: Boolean, $canReceiveEmailUpdates: Boolean, $canReceiveSms: Boolean, $bio: String, $bannerUrl: String, $boxImageUrl: String, $buyerChips: [String!], $buyerBio: String, $pictureUrl: String, $city: String, $state: String) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    address: $address
    acceptTos: $acceptTos
    acceptPrivacyPolicy: $acceptPrivacyPolicy
    canReceiveEmailUpdates: $canReceiveEmailUpdates
    canReceiveSms: $canReceiveSms
    bio: $bio
    bannerUrl: $bannerUrl
    boxImageUrl: $boxImageUrl
    buyerChips: $buyerChips
    buyerBio: $buyerBio
    pictureUrl: $pictureUrl
    city: $city
    state: $state
  ) {
    _id
    first_name
    last_name
    email
    phone
    company
    picture_url
    tos_accepted_at
    privacy_policy_accepted_at
    can_receive_email_updates
    can_receive_sms
    address {
      _id
      address_1
      address_2
      city
      state
      postcode
      country
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      address: // value for 'address'
 *      acceptTos: // value for 'acceptTos'
 *      acceptPrivacyPolicy: // value for 'acceptPrivacyPolicy'
 *      canReceiveEmailUpdates: // value for 'canReceiveEmailUpdates'
 *      canReceiveSms: // value for 'canReceiveSms'
 *      bio: // value for 'bio'
 *      bannerUrl: // value for 'bannerUrl'
 *      boxImageUrl: // value for 'boxImageUrl'
 *      buyerChips: // value for 'buyerChips'
 *      buyerBio: // value for 'buyerBio'
 *      pictureUrl: // value for 'pictureUrl'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UserBasicUpsertDocument = gql`
    mutation UserBasicUpsert($userId: MongoID, $firstName: String!, $lastName: String, $email: String, $phone: String, $company: String, $address: AddressInputForUser, $relationships: [RelationshipsInputForUser]) {
  userBasicUpsert(
    userId: $userId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    address: $address
    relationships: $relationships
  ) {
    user {
      _id
      first_name
      last_name
      email
      phone
      company
      role
      enabled
      address {
        _id
        address_1
        address_2
        city
        state
        postcode
      }
      relationships {
        vendorId
        producerId
        type
      }
    }
    message
  }
}
    `;
export type UserBasicUpsertMutationFn = Apollo.MutationFunction<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>;

/**
 * __useUserBasicUpsertMutation__
 *
 * To run a mutation, you first call `useUserBasicUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBasicUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBasicUpsertMutation, { data, loading, error }] = useUserBasicUpsertMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      address: // value for 'address'
 *      relationships: // value for 'relationships'
 *   },
 * });
 */
export function useUserBasicUpsertMutation(baseOptions?: Apollo.MutationHookOptions<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>(UserBasicUpsertDocument, options);
      }
export type UserBasicUpsertMutationHookResult = ReturnType<typeof useUserBasicUpsertMutation>;
export type UserBasicUpsertMutationResult = Apollo.MutationResult<UserBasicUpsertMutation>;
export type UserBasicUpsertMutationOptions = Apollo.BaseMutationOptions<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>;
export const UserHangTimePreferenceUpdateDocument = gql`
    mutation UserHangTimePreferenceUpdate($userId: MongoID!, $vendorId: MongoID!, $species: String!, $preferredDays: Int) {
  userHangTimePreferenceUpdate(
    userId: $userId
    vendorId: $vendorId
    species: $species
    preferredDays: $preferredDays
  ) {
    success
  }
}
    `;
export type UserHangTimePreferenceUpdateMutationFn = Apollo.MutationFunction<UserHangTimePreferenceUpdateMutation, UserHangTimePreferenceUpdateMutationVariables>;

/**
 * __useUserHangTimePreferenceUpdateMutation__
 *
 * To run a mutation, you first call `useUserHangTimePreferenceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserHangTimePreferenceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userHangTimePreferenceUpdateMutation, { data, loading, error }] = useUserHangTimePreferenceUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *      preferredDays: // value for 'preferredDays'
 *   },
 * });
 */
export function useUserHangTimePreferenceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserHangTimePreferenceUpdateMutation, UserHangTimePreferenceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserHangTimePreferenceUpdateMutation, UserHangTimePreferenceUpdateMutationVariables>(UserHangTimePreferenceUpdateDocument, options);
      }
export type UserHangTimePreferenceUpdateMutationHookResult = ReturnType<typeof useUserHangTimePreferenceUpdateMutation>;
export type UserHangTimePreferenceUpdateMutationResult = Apollo.MutationResult<UserHangTimePreferenceUpdateMutation>;
export type UserHangTimePreferenceUpdateMutationOptions = Apollo.BaseMutationOptions<UserHangTimePreferenceUpdateMutation, UserHangTimePreferenceUpdateMutationVariables>;
export const UserRebookingOverrideUpdateDocument = gql`
    mutation UserRebookingOverrideUpdate($userId: MongoID!, $vendorId: MongoID!, $intervalDays: Int) {
  userRebookingOverrideUpdate(
    userId: $userId
    vendorId: $vendorId
    intervalDays: $intervalDays
  ) {
    latestDropoffDate
    autoIntervalDays
    overrideIntervalDays
    effectiveIntervalDays
    dueSoonWindowDays
    expectedNextBookingDate
    rebookingStatus
    rebookingIntervalSource
  }
}
    `;
export type UserRebookingOverrideUpdateMutationFn = Apollo.MutationFunction<UserRebookingOverrideUpdateMutation, UserRebookingOverrideUpdateMutationVariables>;

/**
 * __useUserRebookingOverrideUpdateMutation__
 *
 * To run a mutation, you first call `useUserRebookingOverrideUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRebookingOverrideUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRebookingOverrideUpdateMutation, { data, loading, error }] = useUserRebookingOverrideUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      intervalDays: // value for 'intervalDays'
 *   },
 * });
 */
export function useUserRebookingOverrideUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserRebookingOverrideUpdateMutation, UserRebookingOverrideUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRebookingOverrideUpdateMutation, UserRebookingOverrideUpdateMutationVariables>(UserRebookingOverrideUpdateDocument, options);
      }
export type UserRebookingOverrideUpdateMutationHookResult = ReturnType<typeof useUserRebookingOverrideUpdateMutation>;
export type UserRebookingOverrideUpdateMutationResult = Apollo.MutationResult<UserRebookingOverrideUpdateMutation>;
export type UserRebookingOverrideUpdateMutationOptions = Apollo.BaseMutationOptions<UserRebookingOverrideUpdateMutation, UserRebookingOverrideUpdateMutationVariables>;
export const UserSettingsUpdateDocument = gql`
    mutation UserSettingsUpdate($userId: MongoID!, $settings: UserSettingsInput!) {
  userSettingsUpdate(userId: $userId, settings: $settings) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UserSettingsUpdateMutationFn = Apollo.MutationFunction<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>;

/**
 * __useUserSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useUserSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSettingsUpdateMutation, { data, loading, error }] = useUserSettingsUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUserSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>(UserSettingsUpdateDocument, options);
      }
export type UserSettingsUpdateMutationHookResult = ReturnType<typeof useUserSettingsUpdateMutation>;
export type UserSettingsUpdateMutationResult = Apollo.MutationResult<UserSettingsUpdateMutation>;
export type UserSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>;
export const UserUpdateActiveVendorDocument = gql`
    mutation UserUpdateActiveVendor($userId: MongoID!, $active_vendor: MongoID!) {
  userUpdateById(_id: $userId, record: {active_vendor: $active_vendor}) {
    recordId
  }
}
    `;
export type UserUpdateActiveVendorMutationFn = Apollo.MutationFunction<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>;

/**
 * __useUserUpdateActiveVendorMutation__
 *
 * To run a mutation, you first call `useUserUpdateActiveVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateActiveVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateActiveVendorMutation, { data, loading, error }] = useUserUpdateActiveVendorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      active_vendor: // value for 'active_vendor'
 *   },
 * });
 */
export function useUserUpdateActiveVendorMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>(UserUpdateActiveVendorDocument, options);
      }
export type UserUpdateActiveVendorMutationHookResult = ReturnType<typeof useUserUpdateActiveVendorMutation>;
export type UserUpdateActiveVendorMutationResult = Apollo.MutationResult<UserUpdateActiveVendorMutation>;
export type UserUpdateActiveVendorMutationOptions = Apollo.BaseMutationOptions<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>;
export const UserUpdateRoleDocument = gql`
    mutation UserUpdateRole($userId: MongoID!, $role: EnumUserRole!) {
  userUpdateById(_id: $userId, record: {role: $role}) {
    record {
      _id
      role
      first_name
      last_name
      email
    }
  }
}
    `;
export type UserUpdateRoleMutationFn = Apollo.MutationFunction<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>;

/**
 * __useUserUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUserUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateRoleMutation, { data, loading, error }] = useUserUpdateRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>(UserUpdateRoleDocument, options);
      }
export type UserUpdateRoleMutationHookResult = ReturnType<typeof useUserUpdateRoleMutation>;
export type UserUpdateRoleMutationResult = Apollo.MutationResult<UserUpdateRoleMutation>;
export type UserUpdateRoleMutationOptions = Apollo.BaseMutationOptions<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>;
export const VendorAddOnJobSplitDocument = gql`
    mutation VendorAddOnJobSplit($animalId: MongoID!, $splitPart: String!, $buyerId: MongoID!) {
  vendorAddOnJobSplit(
    animalId: $animalId
    splitPart: $splitPart
    buyerId: $buyerId
  ) {
    _id
  }
}
    `;
export type VendorAddOnJobSplitMutationFn = Apollo.MutationFunction<VendorAddOnJobSplitMutation, VendorAddOnJobSplitMutationVariables>;

/**
 * __useVendorAddOnJobSplitMutation__
 *
 * To run a mutation, you first call `useVendorAddOnJobSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorAddOnJobSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorAddOnJobSplitMutation, { data, loading, error }] = useVendorAddOnJobSplitMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      splitPart: // value for 'splitPart'
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useVendorAddOnJobSplitMutation(baseOptions?: Apollo.MutationHookOptions<VendorAddOnJobSplitMutation, VendorAddOnJobSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorAddOnJobSplitMutation, VendorAddOnJobSplitMutationVariables>(VendorAddOnJobSplitDocument, options);
      }
export type VendorAddOnJobSplitMutationHookResult = ReturnType<typeof useVendorAddOnJobSplitMutation>;
export type VendorAddOnJobSplitMutationResult = Apollo.MutationResult<VendorAddOnJobSplitMutation>;
export type VendorAddOnJobSplitMutationOptions = Apollo.BaseMutationOptions<VendorAddOnJobSplitMutation, VendorAddOnJobSplitMutationVariables>;
export const VendorAnimalStatusUpdateDocument = gql`
    mutation VendorAnimalStatusUpdate($animalIds: [MongoID!]!, $status: String!) {
  vendorAnimalStatusUpdate(animalIds: $animalIds, status: $status) {
    jobId
    updatedCount
    skippedCount
    skippedLabels
    jobStatus
  }
}
    `;
export type VendorAnimalStatusUpdateMutationFn = Apollo.MutationFunction<VendorAnimalStatusUpdateMutation, VendorAnimalStatusUpdateMutationVariables>;

/**
 * __useVendorAnimalStatusUpdateMutation__
 *
 * To run a mutation, you first call `useVendorAnimalStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorAnimalStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorAnimalStatusUpdateMutation, { data, loading, error }] = useVendorAnimalStatusUpdateMutation({
 *   variables: {
 *      animalIds: // value for 'animalIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useVendorAnimalStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VendorAnimalStatusUpdateMutation, VendorAnimalStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorAnimalStatusUpdateMutation, VendorAnimalStatusUpdateMutationVariables>(VendorAnimalStatusUpdateDocument, options);
      }
export type VendorAnimalStatusUpdateMutationHookResult = ReturnType<typeof useVendorAnimalStatusUpdateMutation>;
export type VendorAnimalStatusUpdateMutationResult = Apollo.MutationResult<VendorAnimalStatusUpdateMutation>;
export type VendorAnimalStatusUpdateMutationOptions = Apollo.BaseMutationOptions<VendorAnimalStatusUpdateMutation, VendorAnimalStatusUpdateMutationVariables>;
export const VendorCopySettingsDocument = gql`
    mutation VendorCopySettings($sourceVendorId: MongoID!, $targetVendorId: MongoID!, $buckets: [String!]!, $species: [String!]) {
  vendorCopySettings(
    sourceVendorId: $sourceVendorId
    targetVendorId: $targetVendorId
    buckets: $buckets
    species: $species
  )
}
    `;
export type VendorCopySettingsMutationFn = Apollo.MutationFunction<VendorCopySettingsMutation, VendorCopySettingsMutationVariables>;

/**
 * __useVendorCopySettingsMutation__
 *
 * To run a mutation, you first call `useVendorCopySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCopySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCopySettingsMutation, { data, loading, error }] = useVendorCopySettingsMutation({
 *   variables: {
 *      sourceVendorId: // value for 'sourceVendorId'
 *      targetVendorId: // value for 'targetVendorId'
 *      buckets: // value for 'buckets'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useVendorCopySettingsMutation(baseOptions?: Apollo.MutationHookOptions<VendorCopySettingsMutation, VendorCopySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorCopySettingsMutation, VendorCopySettingsMutationVariables>(VendorCopySettingsDocument, options);
      }
export type VendorCopySettingsMutationHookResult = ReturnType<typeof useVendorCopySettingsMutation>;
export type VendorCopySettingsMutationResult = Apollo.MutationResult<VendorCopySettingsMutation>;
export type VendorCopySettingsMutationOptions = Apollo.BaseMutationOptions<VendorCopySettingsMutation, VendorCopySettingsMutationVariables>;
export const VendorCreateInHouseProducerDocument = gql`
    mutation VendorCreateInHouseProducer($name: String!, $photo: String!, $street: String!, $street2: String, $city: String!, $state: String!, $postcode: String!) {
  vendorCreateInHouseProducer(
    name: $name
    photo: $photo
    street: $street
    street2: $street2
    city: $city
    state: $state
    postcode: $postcode
  ) {
    id
    slug
    company
  }
}
    `;
export type VendorCreateInHouseProducerMutationFn = Apollo.MutationFunction<VendorCreateInHouseProducerMutation, VendorCreateInHouseProducerMutationVariables>;

/**
 * __useVendorCreateInHouseProducerMutation__
 *
 * To run a mutation, you first call `useVendorCreateInHouseProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCreateInHouseProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCreateInHouseProducerMutation, { data, loading, error }] = useVendorCreateInHouseProducerMutation({
 *   variables: {
 *      name: // value for 'name'
 *      photo: // value for 'photo'
 *      street: // value for 'street'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useVendorCreateInHouseProducerMutation(baseOptions?: Apollo.MutationHookOptions<VendorCreateInHouseProducerMutation, VendorCreateInHouseProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorCreateInHouseProducerMutation, VendorCreateInHouseProducerMutationVariables>(VendorCreateInHouseProducerDocument, options);
      }
export type VendorCreateInHouseProducerMutationHookResult = ReturnType<typeof useVendorCreateInHouseProducerMutation>;
export type VendorCreateInHouseProducerMutationResult = Apollo.MutationResult<VendorCreateInHouseProducerMutation>;
export type VendorCreateInHouseProducerMutationOptions = Apollo.BaseMutationOptions<VendorCreateInHouseProducerMutation, VendorCreateInHouseProducerMutationVariables>;
export const VendorCustomerNotificationDefaultsUpdateDocument = gql`
    mutation VendorCustomerNotificationDefaultsUpdate($vendorId: MongoID!, $job: Boolean!, $animal: Boolean!, $split: Boolean!) {
  vendorCustomerNotificationDefaultsUpdate(
    vendorId: $vendorId
    job: $job
    animal: $animal
    split: $split
  ) {
    job
    animal
    split
  }
}
    `;
export type VendorCustomerNotificationDefaultsUpdateMutationFn = Apollo.MutationFunction<VendorCustomerNotificationDefaultsUpdateMutation, VendorCustomerNotificationDefaultsUpdateMutationVariables>;

/**
 * __useVendorCustomerNotificationDefaultsUpdateMutation__
 *
 * To run a mutation, you first call `useVendorCustomerNotificationDefaultsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomerNotificationDefaultsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCustomerNotificationDefaultsUpdateMutation, { data, loading, error }] = useVendorCustomerNotificationDefaultsUpdateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      job: // value for 'job'
 *      animal: // value for 'animal'
 *      split: // value for 'split'
 *   },
 * });
 */
export function useVendorCustomerNotificationDefaultsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VendorCustomerNotificationDefaultsUpdateMutation, VendorCustomerNotificationDefaultsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorCustomerNotificationDefaultsUpdateMutation, VendorCustomerNotificationDefaultsUpdateMutationVariables>(VendorCustomerNotificationDefaultsUpdateDocument, options);
      }
export type VendorCustomerNotificationDefaultsUpdateMutationHookResult = ReturnType<typeof useVendorCustomerNotificationDefaultsUpdateMutation>;
export type VendorCustomerNotificationDefaultsUpdateMutationResult = Apollo.MutationResult<VendorCustomerNotificationDefaultsUpdateMutation>;
export type VendorCustomerNotificationDefaultsUpdateMutationOptions = Apollo.BaseMutationOptions<VendorCustomerNotificationDefaultsUpdateMutation, VendorCustomerNotificationDefaultsUpdateMutationVariables>;
export const VendorDeclineRequestDocument = gql`
    mutation VendorDeclineRequest($requestId: MongoID!) {
  vendorDeclineRequest(requestId: $requestId) {
    _id
    active
    declinedAt
  }
}
    `;
export type VendorDeclineRequestMutationFn = Apollo.MutationFunction<VendorDeclineRequestMutation, VendorDeclineRequestMutationVariables>;

/**
 * __useVendorDeclineRequestMutation__
 *
 * To run a mutation, you first call `useVendorDeclineRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorDeclineRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorDeclineRequestMutation, { data, loading, error }] = useVendorDeclineRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useVendorDeclineRequestMutation(baseOptions?: Apollo.MutationHookOptions<VendorDeclineRequestMutation, VendorDeclineRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorDeclineRequestMutation, VendorDeclineRequestMutationVariables>(VendorDeclineRequestDocument, options);
      }
export type VendorDeclineRequestMutationHookResult = ReturnType<typeof useVendorDeclineRequestMutation>;
export type VendorDeclineRequestMutationResult = Apollo.MutationResult<VendorDeclineRequestMutation>;
export type VendorDeclineRequestMutationOptions = Apollo.BaseMutationOptions<VendorDeclineRequestMutation, VendorDeclineRequestMutationVariables>;
export const VendorHerdAnimalDeleteDocument = gql`
    mutation VendorHerdAnimalDelete($id: MongoID!) {
  vendorHerdAnimalDelete(_id: $id) {
    _id
  }
}
    `;
export type VendorHerdAnimalDeleteMutationFn = Apollo.MutationFunction<VendorHerdAnimalDeleteMutation, VendorHerdAnimalDeleteMutationVariables>;

/**
 * __useVendorHerdAnimalDeleteMutation__
 *
 * To run a mutation, you first call `useVendorHerdAnimalDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorHerdAnimalDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorHerdAnimalDeleteMutation, { data, loading, error }] = useVendorHerdAnimalDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorHerdAnimalDeleteMutation(baseOptions?: Apollo.MutationHookOptions<VendorHerdAnimalDeleteMutation, VendorHerdAnimalDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorHerdAnimalDeleteMutation, VendorHerdAnimalDeleteMutationVariables>(VendorHerdAnimalDeleteDocument, options);
      }
export type VendorHerdAnimalDeleteMutationHookResult = ReturnType<typeof useVendorHerdAnimalDeleteMutation>;
export type VendorHerdAnimalDeleteMutationResult = Apollo.MutationResult<VendorHerdAnimalDeleteMutation>;
export type VendorHerdAnimalDeleteMutationOptions = Apollo.BaseMutationOptions<VendorHerdAnimalDeleteMutation, VendorHerdAnimalDeleteMutationVariables>;
export const VendorHerdAnimalUpdateDocument = gql`
    mutation VendorHerdAnimalUpdate($id: MongoID!, $species: String, $tracking: String, $splitType: String, $liveWeight: Float, $sex: String, $hangTimeDays: Int, $isOverThirtyMonths: Boolean, $availableToBuyers: Boolean, $allowedSectionSizes: [String], $claimMode: String, $sizeTier: String, $liveWeightHigh: Float, $listingRatePerLb: Float, $listingTotalPrice: Float, $listingDeposits: MyAnimalListingDepositsInput, $descriptorChips: [String], $producerDescription: String) {
  vendorHerdAnimalUpdate(
    _id: $id
    species: $species
    tracking: $tracking
    splitType: $splitType
    liveWeight: $liveWeight
    sex: $sex
    hangTimeDays: $hangTimeDays
    isOverThirtyMonths: $isOverThirtyMonths
    availableToBuyers: $availableToBuyers
    allowedSectionSizes: $allowedSectionSizes
    claimMode: $claimMode
    sizeTier: $sizeTier
    liveWeightHigh: $liveWeightHigh
    listingRatePerLb: $listingRatePerLb
    listingTotalPrice: $listingTotalPrice
    listingDeposits: $listingDeposits
    descriptorChips: $descriptorChips
    producerDescription: $producerDescription
  ) {
    _id
    species
    tracking
    splitType
    liveWeight
    sex
    hangTimeDays
    isOverThirtyMonths
    availableToBuyers
    allowedSectionSizes
    claimMode
    sizeTier
    liveWeightHigh
    listingRatePerLb
    listingTotalPrice
    listingDeposits {
      whole
      half
      quarter
    }
    descriptorChips
    producerDescription
    remainingCapacity
    isFull
  }
}
    `;
export type VendorHerdAnimalUpdateMutationFn = Apollo.MutationFunction<VendorHerdAnimalUpdateMutation, VendorHerdAnimalUpdateMutationVariables>;

/**
 * __useVendorHerdAnimalUpdateMutation__
 *
 * To run a mutation, you first call `useVendorHerdAnimalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorHerdAnimalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorHerdAnimalUpdateMutation, { data, loading, error }] = useVendorHerdAnimalUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      species: // value for 'species'
 *      tracking: // value for 'tracking'
 *      splitType: // value for 'splitType'
 *      liveWeight: // value for 'liveWeight'
 *      sex: // value for 'sex'
 *      hangTimeDays: // value for 'hangTimeDays'
 *      isOverThirtyMonths: // value for 'isOverThirtyMonths'
 *      availableToBuyers: // value for 'availableToBuyers'
 *      allowedSectionSizes: // value for 'allowedSectionSizes'
 *      claimMode: // value for 'claimMode'
 *      sizeTier: // value for 'sizeTier'
 *      liveWeightHigh: // value for 'liveWeightHigh'
 *      listingRatePerLb: // value for 'listingRatePerLb'
 *      listingTotalPrice: // value for 'listingTotalPrice'
 *      listingDeposits: // value for 'listingDeposits'
 *      descriptorChips: // value for 'descriptorChips'
 *      producerDescription: // value for 'producerDescription'
 *   },
 * });
 */
export function useVendorHerdAnimalUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VendorHerdAnimalUpdateMutation, VendorHerdAnimalUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorHerdAnimalUpdateMutation, VendorHerdAnimalUpdateMutationVariables>(VendorHerdAnimalUpdateDocument, options);
      }
export type VendorHerdAnimalUpdateMutationHookResult = ReturnType<typeof useVendorHerdAnimalUpdateMutation>;
export type VendorHerdAnimalUpdateMutationResult = Apollo.MutationResult<VendorHerdAnimalUpdateMutation>;
export type VendorHerdAnimalUpdateMutationOptions = Apollo.BaseMutationOptions<VendorHerdAnimalUpdateMutation, VendorHerdAnimalUpdateMutationVariables>;
export const VendorHerdAssignAnimalsToJobDocument = gql`
    mutation VendorHerdAssignAnimalsToJob($jobId: MongoID!, $animalIds: [MongoID!]!, $inspectionLevel: EnumProcessorSchedulingAnimalHeadsInspectionLevel) {
  vendorHerdAssignAnimalsToJob(
    jobId: $jobId
    animalIds: $animalIds
    inspectionLevel: $inspectionLevel
  ) {
    jobId
    assignedCount
  }
}
    `;
export type VendorHerdAssignAnimalsToJobMutationFn = Apollo.MutationFunction<VendorHerdAssignAnimalsToJobMutation, VendorHerdAssignAnimalsToJobMutationVariables>;

/**
 * __useVendorHerdAssignAnimalsToJobMutation__
 *
 * To run a mutation, you first call `useVendorHerdAssignAnimalsToJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorHerdAssignAnimalsToJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorHerdAssignAnimalsToJobMutation, { data, loading, error }] = useVendorHerdAssignAnimalsToJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      animalIds: // value for 'animalIds'
 *      inspectionLevel: // value for 'inspectionLevel'
 *   },
 * });
 */
export function useVendorHerdAssignAnimalsToJobMutation(baseOptions?: Apollo.MutationHookOptions<VendorHerdAssignAnimalsToJobMutation, VendorHerdAssignAnimalsToJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorHerdAssignAnimalsToJobMutation, VendorHerdAssignAnimalsToJobMutationVariables>(VendorHerdAssignAnimalsToJobDocument, options);
      }
export type VendorHerdAssignAnimalsToJobMutationHookResult = ReturnType<typeof useVendorHerdAssignAnimalsToJobMutation>;
export type VendorHerdAssignAnimalsToJobMutationResult = Apollo.MutationResult<VendorHerdAssignAnimalsToJobMutation>;
export type VendorHerdAssignAnimalsToJobMutationOptions = Apollo.BaseMutationOptions<VendorHerdAssignAnimalsToJobMutation, VendorHerdAssignAnimalsToJobMutationVariables>;
export const VendorHerdQuickAddDocument = gql`
    mutation VendorHerdQuickAdd($producer: HerdIntakeProducerInput!, $animals: [QuickAddAnimalInput!]!) {
  vendorHerdQuickAdd(producer: $producer, animals: $animals) {
    _id
    species
    tracking
    splitType
    producerIdentifier
    status
    jobId
  }
}
    `;
export type VendorHerdQuickAddMutationFn = Apollo.MutationFunction<VendorHerdQuickAddMutation, VendorHerdQuickAddMutationVariables>;

/**
 * __useVendorHerdQuickAddMutation__
 *
 * To run a mutation, you first call `useVendorHerdQuickAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorHerdQuickAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorHerdQuickAddMutation, { data, loading, error }] = useVendorHerdQuickAddMutation({
 *   variables: {
 *      producer: // value for 'producer'
 *      animals: // value for 'animals'
 *   },
 * });
 */
export function useVendorHerdQuickAddMutation(baseOptions?: Apollo.MutationHookOptions<VendorHerdQuickAddMutation, VendorHerdQuickAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorHerdQuickAddMutation, VendorHerdQuickAddMutationVariables>(VendorHerdQuickAddDocument, options);
      }
export type VendorHerdQuickAddMutationHookResult = ReturnType<typeof useVendorHerdQuickAddMutation>;
export type VendorHerdQuickAddMutationResult = Apollo.MutationResult<VendorHerdQuickAddMutation>;
export type VendorHerdQuickAddMutationOptions = Apollo.BaseMutationOptions<VendorHerdQuickAddMutation, VendorHerdQuickAddMutationVariables>;
export const VendorHerdAnimalSetSplitBuyersDocument = gql`
    mutation VendorHerdAnimalSetSplitBuyers($id: MongoID!, $splits: [HerdSplitBuyerInput!]!) {
  vendorHerdAnimalSetSplitBuyers(_id: $id, splits: $splits) {
    _id
    splits {
      splitPart
      buyer {
        _id
      }
    }
  }
}
    `;
export type VendorHerdAnimalSetSplitBuyersMutationFn = Apollo.MutationFunction<VendorHerdAnimalSetSplitBuyersMutation, VendorHerdAnimalSetSplitBuyersMutationVariables>;

/**
 * __useVendorHerdAnimalSetSplitBuyersMutation__
 *
 * To run a mutation, you first call `useVendorHerdAnimalSetSplitBuyersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorHerdAnimalSetSplitBuyersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorHerdAnimalSetSplitBuyersMutation, { data, loading, error }] = useVendorHerdAnimalSetSplitBuyersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      splits: // value for 'splits'
 *   },
 * });
 */
export function useVendorHerdAnimalSetSplitBuyersMutation(baseOptions?: Apollo.MutationHookOptions<VendorHerdAnimalSetSplitBuyersMutation, VendorHerdAnimalSetSplitBuyersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorHerdAnimalSetSplitBuyersMutation, VendorHerdAnimalSetSplitBuyersMutationVariables>(VendorHerdAnimalSetSplitBuyersDocument, options);
      }
export type VendorHerdAnimalSetSplitBuyersMutationHookResult = ReturnType<typeof useVendorHerdAnimalSetSplitBuyersMutation>;
export type VendorHerdAnimalSetSplitBuyersMutationResult = Apollo.MutationResult<VendorHerdAnimalSetSplitBuyersMutation>;
export type VendorHerdAnimalSetSplitBuyersMutationOptions = Apollo.BaseMutationOptions<VendorHerdAnimalSetSplitBuyersMutation, VendorHerdAnimalSetSplitBuyersMutationVariables>;
export const VendorInHouseProducerSettingsUpdateDocument = gql`
    mutation VendorInHouseProducerSettingsUpdate($splitDeposits: [ProducerSplitDepositInput!]!, $listingPresets: [ProducerListingPresetInput!]) {
  vendorInHouseProducerSettingsUpdate(
    splitDeposits: $splitDeposits
    listingPresets: $listingPresets
  ) {
    producer
    splitDeposits {
      species
      whole
      half
      quarter
    }
    listingPresets {
      species
      pricingMode
      listingRatePerLb
      listingTotalPrice
      sizeTier
      allowedSectionSizes
      descriptorChips
      description
    }
  }
}
    `;
export type VendorInHouseProducerSettingsUpdateMutationFn = Apollo.MutationFunction<VendorInHouseProducerSettingsUpdateMutation, VendorInHouseProducerSettingsUpdateMutationVariables>;

/**
 * __useVendorInHouseProducerSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useVendorInHouseProducerSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorInHouseProducerSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorInHouseProducerSettingsUpdateMutation, { data, loading, error }] = useVendorInHouseProducerSettingsUpdateMutation({
 *   variables: {
 *      splitDeposits: // value for 'splitDeposits'
 *      listingPresets: // value for 'listingPresets'
 *   },
 * });
 */
export function useVendorInHouseProducerSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VendorInHouseProducerSettingsUpdateMutation, VendorInHouseProducerSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorInHouseProducerSettingsUpdateMutation, VendorInHouseProducerSettingsUpdateMutationVariables>(VendorInHouseProducerSettingsUpdateDocument, options);
      }
export type VendorInHouseProducerSettingsUpdateMutationHookResult = ReturnType<typeof useVendorInHouseProducerSettingsUpdateMutation>;
export type VendorInHouseProducerSettingsUpdateMutationResult = Apollo.MutationResult<VendorInHouseProducerSettingsUpdateMutation>;
export type VendorInHouseProducerSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<VendorInHouseProducerSettingsUpdateMutation, VendorInHouseProducerSettingsUpdateMutationVariables>;
export const VendorLinkInHouseProducerDocument = gql`
    mutation VendorLinkInHouseProducer($producerUserId: MongoID!, $confirmStaffAccount: Boolean) {
  vendorLinkInHouseProducer(
    producerUserId: $producerUserId
    confirmStaffAccount: $confirmStaffAccount
  ) {
    id
    slug
    company
    picture_url
  }
}
    `;
export type VendorLinkInHouseProducerMutationFn = Apollo.MutationFunction<VendorLinkInHouseProducerMutation, VendorLinkInHouseProducerMutationVariables>;

/**
 * __useVendorLinkInHouseProducerMutation__
 *
 * To run a mutation, you first call `useVendorLinkInHouseProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorLinkInHouseProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorLinkInHouseProducerMutation, { data, loading, error }] = useVendorLinkInHouseProducerMutation({
 *   variables: {
 *      producerUserId: // value for 'producerUserId'
 *      confirmStaffAccount: // value for 'confirmStaffAccount'
 *   },
 * });
 */
export function useVendorLinkInHouseProducerMutation(baseOptions?: Apollo.MutationHookOptions<VendorLinkInHouseProducerMutation, VendorLinkInHouseProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorLinkInHouseProducerMutation, VendorLinkInHouseProducerMutationVariables>(VendorLinkInHouseProducerDocument, options);
      }
export type VendorLinkInHouseProducerMutationHookResult = ReturnType<typeof useVendorLinkInHouseProducerMutation>;
export type VendorLinkInHouseProducerMutationResult = Apollo.MutationResult<VendorLinkInHouseProducerMutation>;
export type VendorLinkInHouseProducerMutationOptions = Apollo.BaseMutationOptions<VendorLinkInHouseProducerMutation, VendorLinkInHouseProducerMutationVariables>;
export const VendorNudgeSectionBuyerDocument = gql`
    mutation VendorNudgeSectionBuyer($splitId: MongoID!) {
  vendorNudgeSectionBuyer(splitId: $splitId) {
    splitId
    nudgeCase
    nudgedAt
  }
}
    `;
export type VendorNudgeSectionBuyerMutationFn = Apollo.MutationFunction<VendorNudgeSectionBuyerMutation, VendorNudgeSectionBuyerMutationVariables>;

/**
 * __useVendorNudgeSectionBuyerMutation__
 *
 * To run a mutation, you first call `useVendorNudgeSectionBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorNudgeSectionBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorNudgeSectionBuyerMutation, { data, loading, error }] = useVendorNudgeSectionBuyerMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useVendorNudgeSectionBuyerMutation(baseOptions?: Apollo.MutationHookOptions<VendorNudgeSectionBuyerMutation, VendorNudgeSectionBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorNudgeSectionBuyerMutation, VendorNudgeSectionBuyerMutationVariables>(VendorNudgeSectionBuyerDocument, options);
      }
export type VendorNudgeSectionBuyerMutationHookResult = ReturnType<typeof useVendorNudgeSectionBuyerMutation>;
export type VendorNudgeSectionBuyerMutationResult = Apollo.MutationResult<VendorNudgeSectionBuyerMutation>;
export type VendorNudgeSectionBuyerMutationOptions = Apollo.BaseMutationOptions<VendorNudgeSectionBuyerMutation, VendorNudgeSectionBuyerMutationVariables>;
export const VendorPlaceRequestOnAnimalDocument = gql`
    mutation VendorPlaceRequestOnAnimal($requestId: MongoID!, $animalId: MongoID!) {
  vendorPlaceRequestOnAnimal(requestId: $requestId, animalId: $animalId) {
    _id
    active
    fulfilledSplit
    fulfilledAt
  }
}
    `;
export type VendorPlaceRequestOnAnimalMutationFn = Apollo.MutationFunction<VendorPlaceRequestOnAnimalMutation, VendorPlaceRequestOnAnimalMutationVariables>;

/**
 * __useVendorPlaceRequestOnAnimalMutation__
 *
 * To run a mutation, you first call `useVendorPlaceRequestOnAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPlaceRequestOnAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPlaceRequestOnAnimalMutation, { data, loading, error }] = useVendorPlaceRequestOnAnimalMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      animalId: // value for 'animalId'
 *   },
 * });
 */
export function useVendorPlaceRequestOnAnimalMutation(baseOptions?: Apollo.MutationHookOptions<VendorPlaceRequestOnAnimalMutation, VendorPlaceRequestOnAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorPlaceRequestOnAnimalMutation, VendorPlaceRequestOnAnimalMutationVariables>(VendorPlaceRequestOnAnimalDocument, options);
      }
export type VendorPlaceRequestOnAnimalMutationHookResult = ReturnType<typeof useVendorPlaceRequestOnAnimalMutation>;
export type VendorPlaceRequestOnAnimalMutationResult = Apollo.MutationResult<VendorPlaceRequestOnAnimalMutation>;
export type VendorPlaceRequestOnAnimalMutationOptions = Apollo.BaseMutationOptions<VendorPlaceRequestOnAnimalMutation, VendorPlaceRequestOnAnimalMutationVariables>;
export const VendorReassignBuyerSplitDocument = gql`
    mutation VendorReassignBuyerSplit($splitId: MongoID!, $newBuyerId: MongoID!) {
  vendorReassignBuyerSplit(splitId: $splitId, newBuyerId: $newBuyerId) {
    _id
    status
    buyer {
      _id
    }
  }
}
    `;
export type VendorReassignBuyerSplitMutationFn = Apollo.MutationFunction<VendorReassignBuyerSplitMutation, VendorReassignBuyerSplitMutationVariables>;

/**
 * __useVendorReassignBuyerSplitMutation__
 *
 * To run a mutation, you first call `useVendorReassignBuyerSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorReassignBuyerSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorReassignBuyerSplitMutation, { data, loading, error }] = useVendorReassignBuyerSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *      newBuyerId: // value for 'newBuyerId'
 *   },
 * });
 */
export function useVendorReassignBuyerSplitMutation(baseOptions?: Apollo.MutationHookOptions<VendorReassignBuyerSplitMutation, VendorReassignBuyerSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorReassignBuyerSplitMutation, VendorReassignBuyerSplitMutationVariables>(VendorReassignBuyerSplitDocument, options);
      }
export type VendorReassignBuyerSplitMutationHookResult = ReturnType<typeof useVendorReassignBuyerSplitMutation>;
export type VendorReassignBuyerSplitMutationResult = Apollo.MutationResult<VendorReassignBuyerSplitMutation>;
export type VendorReassignBuyerSplitMutationOptions = Apollo.BaseMutationOptions<VendorReassignBuyerSplitMutation, VendorReassignBuyerSplitMutationVariables>;
export const VendorRecordAnimalSettlementDocument = gql`
    mutation VendorRecordAnimalSettlement($animalId: MongoID!, $method: String!) {
  vendorRecordAnimalSettlement(animalId: $animalId, method: $method) {
    animalId
    method
    settledCount
    skippedCount
    errorCount
    results {
      splitId
      splitPart
      outcome
      skipReason
      message
      invoiceId
    }
  }
}
    `;
export type VendorRecordAnimalSettlementMutationFn = Apollo.MutationFunction<VendorRecordAnimalSettlementMutation, VendorRecordAnimalSettlementMutationVariables>;

/**
 * __useVendorRecordAnimalSettlementMutation__
 *
 * To run a mutation, you first call `useVendorRecordAnimalSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorRecordAnimalSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorRecordAnimalSettlementMutation, { data, loading, error }] = useVendorRecordAnimalSettlementMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useVendorRecordAnimalSettlementMutation(baseOptions?: Apollo.MutationHookOptions<VendorRecordAnimalSettlementMutation, VendorRecordAnimalSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorRecordAnimalSettlementMutation, VendorRecordAnimalSettlementMutationVariables>(VendorRecordAnimalSettlementDocument, options);
      }
export type VendorRecordAnimalSettlementMutationHookResult = ReturnType<typeof useVendorRecordAnimalSettlementMutation>;
export type VendorRecordAnimalSettlementMutationResult = Apollo.MutationResult<VendorRecordAnimalSettlementMutation>;
export type VendorRecordAnimalSettlementMutationOptions = Apollo.BaseMutationOptions<VendorRecordAnimalSettlementMutation, VendorRecordAnimalSettlementMutationVariables>;
export const VendorReleaseBuyerSplitDocument = gql`
    mutation VendorReleaseBuyerSplit($splitId: MongoID!) {
  vendorReleaseBuyerSplit(splitId: $splitId) {
    _id
    status
    isDeleted
  }
}
    `;
export type VendorReleaseBuyerSplitMutationFn = Apollo.MutationFunction<VendorReleaseBuyerSplitMutation, VendorReleaseBuyerSplitMutationVariables>;

/**
 * __useVendorReleaseBuyerSplitMutation__
 *
 * To run a mutation, you first call `useVendorReleaseBuyerSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorReleaseBuyerSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorReleaseBuyerSplitMutation, { data, loading, error }] = useVendorReleaseBuyerSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useVendorReleaseBuyerSplitMutation(baseOptions?: Apollo.MutationHookOptions<VendorReleaseBuyerSplitMutation, VendorReleaseBuyerSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorReleaseBuyerSplitMutation, VendorReleaseBuyerSplitMutationVariables>(VendorReleaseBuyerSplitDocument, options);
      }
export type VendorReleaseBuyerSplitMutationHookResult = ReturnType<typeof useVendorReleaseBuyerSplitMutation>;
export type VendorReleaseBuyerSplitMutationResult = Apollo.MutationResult<VendorReleaseBuyerSplitMutation>;
export type VendorReleaseBuyerSplitMutationOptions = Apollo.BaseMutationOptions<VendorReleaseBuyerSplitMutation, VendorReleaseBuyerSplitMutationVariables>;
export const VendorRemoveBuyerSplitDocument = gql`
    mutation VendorRemoveBuyerSplit($splitId: MongoID!) {
  vendorRemoveBuyerSplit(splitId: $splitId) {
    _id
    status
  }
}
    `;
export type VendorRemoveBuyerSplitMutationFn = Apollo.MutationFunction<VendorRemoveBuyerSplitMutation, VendorRemoveBuyerSplitMutationVariables>;

/**
 * __useVendorRemoveBuyerSplitMutation__
 *
 * To run a mutation, you first call `useVendorRemoveBuyerSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorRemoveBuyerSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorRemoveBuyerSplitMutation, { data, loading, error }] = useVendorRemoveBuyerSplitMutation({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useVendorRemoveBuyerSplitMutation(baseOptions?: Apollo.MutationHookOptions<VendorRemoveBuyerSplitMutation, VendorRemoveBuyerSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorRemoveBuyerSplitMutation, VendorRemoveBuyerSplitMutationVariables>(VendorRemoveBuyerSplitDocument, options);
      }
export type VendorRemoveBuyerSplitMutationHookResult = ReturnType<typeof useVendorRemoveBuyerSplitMutation>;
export type VendorRemoveBuyerSplitMutationResult = Apollo.MutationResult<VendorRemoveBuyerSplitMutation>;
export type VendorRemoveBuyerSplitMutationOptions = Apollo.BaseMutationOptions<VendorRemoveBuyerSplitMutation, VendorRemoveBuyerSplitMutationVariables>;
export const VendorSyncInHouseProducerDocument = gql`
    mutation VendorSyncInHouseProducer {
  vendorSyncInHouseProducer {
    changed
    unavailable
  }
}
    `;
export type VendorSyncInHouseProducerMutationFn = Apollo.MutationFunction<VendorSyncInHouseProducerMutation, VendorSyncInHouseProducerMutationVariables>;

/**
 * __useVendorSyncInHouseProducerMutation__
 *
 * To run a mutation, you first call `useVendorSyncInHouseProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorSyncInHouseProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorSyncInHouseProducerMutation, { data, loading, error }] = useVendorSyncInHouseProducerMutation({
 *   variables: {
 *   },
 * });
 */
export function useVendorSyncInHouseProducerMutation(baseOptions?: Apollo.MutationHookOptions<VendorSyncInHouseProducerMutation, VendorSyncInHouseProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorSyncInHouseProducerMutation, VendorSyncInHouseProducerMutationVariables>(VendorSyncInHouseProducerDocument, options);
      }
export type VendorSyncInHouseProducerMutationHookResult = ReturnType<typeof useVendorSyncInHouseProducerMutation>;
export type VendorSyncInHouseProducerMutationResult = Apollo.MutationResult<VendorSyncInHouseProducerMutation>;
export type VendorSyncInHouseProducerMutationOptions = Apollo.BaseMutationOptions<VendorSyncInHouseProducerMutation, VendorSyncInHouseProducerMutationVariables>;
export const VendorTeamMemberInviteDocument = gql`
    mutation VendorTeamMemberInvite($email: String!, $firstName: String!, $lastName: String, $role: EnumUserRole!) {
  vendorTeamMemberInvite(
    email: $email
    firstName: $firstName
    lastName: $lastName
    role: $role
  ) {
    _id
    first_name
    last_name
    email
    role
    enabled
  }
}
    `;
export type VendorTeamMemberInviteMutationFn = Apollo.MutationFunction<VendorTeamMemberInviteMutation, VendorTeamMemberInviteMutationVariables>;

/**
 * __useVendorTeamMemberInviteMutation__
 *
 * To run a mutation, you first call `useVendorTeamMemberInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorTeamMemberInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorTeamMemberInviteMutation, { data, loading, error }] = useVendorTeamMemberInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useVendorTeamMemberInviteMutation(baseOptions?: Apollo.MutationHookOptions<VendorTeamMemberInviteMutation, VendorTeamMemberInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorTeamMemberInviteMutation, VendorTeamMemberInviteMutationVariables>(VendorTeamMemberInviteDocument, options);
      }
export type VendorTeamMemberInviteMutationHookResult = ReturnType<typeof useVendorTeamMemberInviteMutation>;
export type VendorTeamMemberInviteMutationResult = Apollo.MutationResult<VendorTeamMemberInviteMutation>;
export type VendorTeamMemberInviteMutationOptions = Apollo.BaseMutationOptions<VendorTeamMemberInviteMutation, VendorTeamMemberInviteMutationVariables>;
export const VendorTeamMemberRoleUpdateDocument = gql`
    mutation VendorTeamMemberRoleUpdate($userId: MongoID!, $role: EnumUserRole!) {
  vendorTeamMemberRoleUpdate(userId: $userId, role: $role) {
    _id
    role
  }
}
    `;
export type VendorTeamMemberRoleUpdateMutationFn = Apollo.MutationFunction<VendorTeamMemberRoleUpdateMutation, VendorTeamMemberRoleUpdateMutationVariables>;

/**
 * __useVendorTeamMemberRoleUpdateMutation__
 *
 * To run a mutation, you first call `useVendorTeamMemberRoleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorTeamMemberRoleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorTeamMemberRoleUpdateMutation, { data, loading, error }] = useVendorTeamMemberRoleUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useVendorTeamMemberRoleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VendorTeamMemberRoleUpdateMutation, VendorTeamMemberRoleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorTeamMemberRoleUpdateMutation, VendorTeamMemberRoleUpdateMutationVariables>(VendorTeamMemberRoleUpdateDocument, options);
      }
export type VendorTeamMemberRoleUpdateMutationHookResult = ReturnType<typeof useVendorTeamMemberRoleUpdateMutation>;
export type VendorTeamMemberRoleUpdateMutationResult = Apollo.MutationResult<VendorTeamMemberRoleUpdateMutation>;
export type VendorTeamMemberRoleUpdateMutationOptions = Apollo.BaseMutationOptions<VendorTeamMemberRoleUpdateMutation, VendorTeamMemberRoleUpdateMutationVariables>;
export const VendorTeamMemberSetEnabledDocument = gql`
    mutation VendorTeamMemberSetEnabled($userId: MongoID!, $enabled: Boolean!) {
  vendorTeamMemberSetEnabled(userId: $userId, enabled: $enabled) {
    _id
    enabled
  }
}
    `;
export type VendorTeamMemberSetEnabledMutationFn = Apollo.MutationFunction<VendorTeamMemberSetEnabledMutation, VendorTeamMemberSetEnabledMutationVariables>;

/**
 * __useVendorTeamMemberSetEnabledMutation__
 *
 * To run a mutation, you first call `useVendorTeamMemberSetEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorTeamMemberSetEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorTeamMemberSetEnabledMutation, { data, loading, error }] = useVendorTeamMemberSetEnabledMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useVendorTeamMemberSetEnabledMutation(baseOptions?: Apollo.MutationHookOptions<VendorTeamMemberSetEnabledMutation, VendorTeamMemberSetEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorTeamMemberSetEnabledMutation, VendorTeamMemberSetEnabledMutationVariables>(VendorTeamMemberSetEnabledDocument, options);
      }
export type VendorTeamMemberSetEnabledMutationHookResult = ReturnType<typeof useVendorTeamMemberSetEnabledMutation>;
export type VendorTeamMemberSetEnabledMutationResult = Apollo.MutationResult<VendorTeamMemberSetEnabledMutation>;
export type VendorTeamMemberSetEnabledMutationOptions = Apollo.BaseMutationOptions<VendorTeamMemberSetEnabledMutation, VendorTeamMemberSetEnabledMutationVariables>;
export const VendorUndoDeclineDocument = gql`
    mutation VendorUndoDecline($requestId: MongoID!) {
  vendorUndoDecline(requestId: $requestId) {
    _id
    active
    declinedAt
  }
}
    `;
export type VendorUndoDeclineMutationFn = Apollo.MutationFunction<VendorUndoDeclineMutation, VendorUndoDeclineMutationVariables>;

/**
 * __useVendorUndoDeclineMutation__
 *
 * To run a mutation, you first call `useVendorUndoDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorUndoDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorUndoDeclineMutation, { data, loading, error }] = useVendorUndoDeclineMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useVendorUndoDeclineMutation(baseOptions?: Apollo.MutationHookOptions<VendorUndoDeclineMutation, VendorUndoDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorUndoDeclineMutation, VendorUndoDeclineMutationVariables>(VendorUndoDeclineDocument, options);
      }
export type VendorUndoDeclineMutationHookResult = ReturnType<typeof useVendorUndoDeclineMutation>;
export type VendorUndoDeclineMutationResult = Apollo.MutationResult<VendorUndoDeclineMutation>;
export type VendorUndoDeclineMutationOptions = Apollo.BaseMutationOptions<VendorUndoDeclineMutation, VendorUndoDeclineMutationVariables>;
export const VendorUndoPlacementDocument = gql`
    mutation VendorUndoPlacement($requestId: MongoID!) {
  vendorUndoPlacement(requestId: $requestId) {
    _id
    active
    fulfilledSplit
    fulfilledAt
  }
}
    `;
export type VendorUndoPlacementMutationFn = Apollo.MutationFunction<VendorUndoPlacementMutation, VendorUndoPlacementMutationVariables>;

/**
 * __useVendorUndoPlacementMutation__
 *
 * To run a mutation, you first call `useVendorUndoPlacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorUndoPlacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorUndoPlacementMutation, { data, loading, error }] = useVendorUndoPlacementMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useVendorUndoPlacementMutation(baseOptions?: Apollo.MutationHookOptions<VendorUndoPlacementMutation, VendorUndoPlacementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorUndoPlacementMutation, VendorUndoPlacementMutationVariables>(VendorUndoPlacementDocument, options);
      }
export type VendorUndoPlacementMutationHookResult = ReturnType<typeof useVendorUndoPlacementMutation>;
export type VendorUndoPlacementMutationResult = Apollo.MutationResult<VendorUndoPlacementMutation>;
export type VendorUndoPlacementMutationOptions = Apollo.BaseMutationOptions<VendorUndoPlacementMutation, VendorUndoPlacementMutationVariables>;
export const WaitlistAddDocument = gql`
    mutation WaitlistAdd($slug: String, $vendorId: MongoID, $producer: MongoID, $firstName: String, $lastName: String, $email: String, $phone: String, $company: String, $sendWaitlistEmail: Boolean, $sendWaitlistSMS: Boolean, $animal: String!, $headCount: Int, $startDate: String!, $endDate: String!, $inspectionLevel: String) {
  waitlistAdd(
    slug: $slug
    vendorId: $vendorId
    producer: $producer
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    sendWaitlistEmail: $sendWaitlistEmail
    sendWaitlistSMS: $sendWaitlistSMS
    animal: $animal
    headCount: $headCount
    startDate: $startDate
    endDate: $endDate
    inspectionLevel: $inspectionLevel
  ) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistAddMutationFn = Apollo.MutationFunction<WaitlistAddMutation, WaitlistAddMutationVariables>;

/**
 * __useWaitlistAddMutation__
 *
 * To run a mutation, you first call `useWaitlistAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistAddMutation, { data, loading, error }] = useWaitlistAddMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      vendorId: // value for 'vendorId'
 *      producer: // value for 'producer'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      sendWaitlistEmail: // value for 'sendWaitlistEmail'
 *      sendWaitlistSMS: // value for 'sendWaitlistSMS'
 *      animal: // value for 'animal'
 *      headCount: // value for 'headCount'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      inspectionLevel: // value for 'inspectionLevel'
 *   },
 * });
 */
export function useWaitlistAddMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistAddMutation, WaitlistAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistAddMutation, WaitlistAddMutationVariables>(WaitlistAddDocument, options);
      }
export type WaitlistAddMutationHookResult = ReturnType<typeof useWaitlistAddMutation>;
export type WaitlistAddMutationResult = Apollo.MutationResult<WaitlistAddMutation>;
export type WaitlistAddMutationOptions = Apollo.BaseMutationOptions<WaitlistAddMutation, WaitlistAddMutationVariables>;
export const WaitlistDeleteDocument = gql`
    mutation WaitlistDelete($customerId: MongoID!) {
  waitlistDelete(_id: $customerId) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistDeleteMutationFn = Apollo.MutationFunction<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>;

/**
 * __useWaitlistDeleteMutation__
 *
 * To run a mutation, you first call `useWaitlistDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistDeleteMutation, { data, loading, error }] = useWaitlistDeleteMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useWaitlistDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>(WaitlistDeleteDocument, options);
      }
export type WaitlistDeleteMutationHookResult = ReturnType<typeof useWaitlistDeleteMutation>;
export type WaitlistDeleteMutationResult = Apollo.MutationResult<WaitlistDeleteMutation>;
export type WaitlistDeleteMutationOptions = Apollo.BaseMutationOptions<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>;
export const WaitlistUnsubscribeDocument = gql`
    mutation WaitlistUnsubscribe($token: String!) {
  waitlistUnsubscribe(token: $token) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistUnsubscribeMutationFn = Apollo.MutationFunction<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>;

/**
 * __useWaitlistUnsubscribeMutation__
 *
 * To run a mutation, you first call `useWaitlistUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistUnsubscribeMutation, { data, loading, error }] = useWaitlistUnsubscribeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWaitlistUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>(WaitlistUnsubscribeDocument, options);
      }
export type WaitlistUnsubscribeMutationHookResult = ReturnType<typeof useWaitlistUnsubscribeMutation>;
export type WaitlistUnsubscribeMutationResult = Apollo.MutationResult<WaitlistUnsubscribeMutation>;
export type WaitlistUnsubscribeMutationOptions = Apollo.BaseMutationOptions<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>;
export const WaitlistUpdateDocument = gql`
    mutation WaitlistUpdate($_id: MongoID!, $animal: String, $inspectionLevel: String, $headCount: Int, $startDate: String, $endDate: String, $sendWaitlistEmail: Boolean, $sendWaitlistSMS: Boolean) {
  waitlistUpdate(
    _id: $_id
    animal: $animal
    inspectionLevel: $inspectionLevel
    headCount: $headCount
    startDate: $startDate
    endDate: $endDate
    sendWaitlistEmail: $sendWaitlistEmail
    sendWaitlistSMS: $sendWaitlistSMS
  ) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistUpdateMutationFn = Apollo.MutationFunction<WaitlistUpdateMutation, WaitlistUpdateMutationVariables>;

/**
 * __useWaitlistUpdateMutation__
 *
 * To run a mutation, you first call `useWaitlistUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistUpdateMutation, { data, loading, error }] = useWaitlistUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      animal: // value for 'animal'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      headCount: // value for 'headCount'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sendWaitlistEmail: // value for 'sendWaitlistEmail'
 *      sendWaitlistSMS: // value for 'sendWaitlistSMS'
 *   },
 * });
 */
export function useWaitlistUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistUpdateMutation, WaitlistUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistUpdateMutation, WaitlistUpdateMutationVariables>(WaitlistUpdateDocument, options);
      }
export type WaitlistUpdateMutationHookResult = ReturnType<typeof useWaitlistUpdateMutation>;
export type WaitlistUpdateMutationResult = Apollo.MutationResult<WaitlistUpdateMutation>;
export type WaitlistUpdateMutationOptions = Apollo.BaseMutationOptions<WaitlistUpdateMutation, WaitlistUpdateMutationVariables>;
export const ProducerAvailableSplitsDocument = gql`
    query ProducerAvailableSplits($producerSlug: String!) {
  producerAvailableSplits(producerSlug: $producerSlug) {
    _id
    species
    splitType
    allowedSectionSizes
    claimMode
    descriptorChips
    remainingCapacity
    isFull
    distanceMiles
    vendorId
    processorName
    producerName
    city
    state
    slug
    logoUrl
    producerLogoUrl
    createdAt
    myClaimedSplitId
    myClaimedSplitPart
    hasPendingClaim
    myClaimedSplitStatus
    myClaimedSplitDepositStatus
    killDate
    cutDate
    inspectionLevel
    reserveByDate
    datesEstimated
    isPendingAcceptance
    listingRatePerLb
    sections {
      size
      deposit
      available
      estimatedTotalLow
      estimatedTotalHigh
    }
    isInHouse
    producerId
    producerSlug
  }
}
    `;

/**
 * __useProducerAvailableSplitsQuery__
 *
 * To run a query within a React component, call `useProducerAvailableSplitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerAvailableSplitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerAvailableSplitsQuery({
 *   variables: {
 *      producerSlug: // value for 'producerSlug'
 *   },
 * });
 */
export function useProducerAvailableSplitsQuery(baseOptions: Apollo.QueryHookOptions<ProducerAvailableSplitsQuery, ProducerAvailableSplitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerAvailableSplitsQuery, ProducerAvailableSplitsQueryVariables>(ProducerAvailableSplitsDocument, options);
      }
export function useProducerAvailableSplitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerAvailableSplitsQuery, ProducerAvailableSplitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerAvailableSplitsQuery, ProducerAvailableSplitsQueryVariables>(ProducerAvailableSplitsDocument, options);
        }
export type ProducerAvailableSplitsQueryHookResult = ReturnType<typeof useProducerAvailableSplitsQuery>;
export type ProducerAvailableSplitsLazyQueryHookResult = ReturnType<typeof useProducerAvailableSplitsLazyQuery>;
export type ProducerAvailableSplitsQueryResult = Apollo.QueryResult<ProducerAvailableSplitsQuery, ProducerAvailableSplitsQueryVariables>;
export const ProducerBySlugDocument = gql`
    query ProducerBySlug($slug: String!) {
  producerBySlug(slug: $slug) {
    _id
    slug
    displayName
    logoUrl
    bannerUrl
    bio
    buyerChips
    buyerBio
    city
    state
    partnerProcessors {
      slug
      name
    }
  }
}
    `;

/**
 * __useProducerBySlugQuery__
 *
 * To run a query within a React component, call `useProducerBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProducerBySlugQuery(baseOptions: Apollo.QueryHookOptions<ProducerBySlugQuery, ProducerBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerBySlugQuery, ProducerBySlugQueryVariables>(ProducerBySlugDocument, options);
      }
export function useProducerBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerBySlugQuery, ProducerBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerBySlugQuery, ProducerBySlugQueryVariables>(ProducerBySlugDocument, options);
        }
export type ProducerBySlugQueryHookResult = ReturnType<typeof useProducerBySlugQuery>;
export type ProducerBySlugLazyQueryHookResult = ReturnType<typeof useProducerBySlugLazyQuery>;
export type ProducerBySlugQueryResult = Apollo.QueryResult<ProducerBySlugQuery, ProducerBySlugQueryVariables>;
export const ViewProcessingPartnerDocument = gql`
    query ViewProcessingPartner($vendorId: MongoID, $slug: String) {
  processingPartnersOne(vendorId: $vendorId, slug: $slug) {
    _id
    about
    slug
    buyerBio
    bannerUrl
    buyerChips
    premierProducers {
      producerId
      badge
    }
    showCommunityListings
    storefrontProducers
    isEnabled
    enabledAnimals
    animalSettings {
      isEnabled
      species
      inspectionLevels
      splitTypes
      weightedAnimalUnit
      schedulingDeposit
      butcherSlotPricing {
        inspectionLevel
        price
      }
      customCutsheetPricing {
        inspectionLevel
        price
      }
    }
    capacityConfigurationType
    capacitySettings {
      isEnabled
      dayOfWeek
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    pickupLocations {
      _id
      name
      description
      isDefault
      address_1
      address_2
      city
      state
      postcode
      lat
      lng
    }
    vendor {
      _id
      shop_name
      stripe_config
      address {
        ...AddressFragment
      }
      tenant {
        name
        picture_url
        _id
      }
    }
    customCapacities {
      _id
      isDeleted
      date
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    schedulingDeposit
    refundDeadlineDays
    isWaitlistFunctionalityDisabled
    killAndChillSettings {
      species
      isEnabled
      pricePerHead
    }
    hangTimeSettings {
      species
      isEnabled
      options {
        durationDays
        isDefault
        upcharge
        availableAtBooking
      }
    }
  }
}
    ${DailyCapacityBlockFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useViewProcessingPartnerQuery__
 *
 * To run a query within a React component, call `useViewProcessingPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessingPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessingPartnerQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useViewProcessingPartnerQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>(ViewProcessingPartnerDocument, options);
      }
export function useViewProcessingPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>(ViewProcessingPartnerDocument, options);
        }
export type ViewProcessingPartnerQueryHookResult = ReturnType<typeof useViewProcessingPartnerQuery>;
export type ViewProcessingPartnerLazyQueryHookResult = ReturnType<typeof useViewProcessingPartnerLazyQuery>;
export type ViewProcessingPartnerQueryResult = Apollo.QueryResult<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>;
export const ViewProcessorAdminDocument = gql`
    query ViewProcessorAdmin($filter: FilterFindOneProcessorSettingsInput) {
  processorSettingsOne(filter: $filter) {
    ...ProcessorSettingsFragment
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
  processorCapabilityMany {
    ...ProcessorCapabilityFragment
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}`;

/**
 * __useViewProcessorAdminQuery__
 *
 * To run a query within a React component, call `useViewProcessorAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessorAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessorAdminQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useViewProcessorAdminQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>(ViewProcessorAdminDocument, options);
      }
export function useViewProcessorAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>(ViewProcessorAdminDocument, options);
        }
export type ViewProcessorAdminQueryHookResult = ReturnType<typeof useViewProcessorAdminQuery>;
export type ViewProcessorAdminLazyQueryHookResult = ReturnType<typeof useViewProcessorAdminLazyQuery>;
export type ViewProcessorAdminQueryResult = Apollo.QueryResult<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>;
export const ViewProcessorAdminLightDocument = gql`
    query ViewProcessorAdminLight($filter: FilterFindOneProcessorSettingsInput) {
  processorSettingsOne(filter: $filter) {
    ...ProcessorSettingsFragment
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
  processorCapabilityMany {
    _id
    vendor
    animalSpecies
    inspectionLevel
    canSelectMoreThanOneTrim
    trimSelection
    primalCuts
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;

/**
 * __useViewProcessorAdminLightQuery__
 *
 * To run a query within a React component, call `useViewProcessorAdminLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessorAdminLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessorAdminLightQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useViewProcessorAdminLightQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>(ViewProcessorAdminLightDocument, options);
      }
export function useViewProcessorAdminLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>(ViewProcessorAdminLightDocument, options);
        }
export type ViewProcessorAdminLightQueryHookResult = ReturnType<typeof useViewProcessorAdminLightQuery>;
export type ViewProcessorAdminLightLazyQueryHookResult = ReturnType<typeof useViewProcessorAdminLightLazyQuery>;
export type ViewProcessorAdminLightQueryResult = Apollo.QueryResult<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>;
export const ViewSchedulingCreateDocument = gql`
    query ViewSchedulingCreate($userId: MongoID, $vendorId: MongoID!, $animalSpeciesCutsheet: EnumCutsheetAnimalSpecies!, $animalSpeciesProcessorCapability: EnumProcessorCapabilityAnimalSpecies!, $statuses: [EnumProcessorSchedulingStatus!]) {
  cutsheetMany(
    filter: {OR: [{user: $userId}, {vendor: $vendorId}], animalSpecies: $animalSpeciesCutsheet}
  ) {
    ...CutsheetFragment
  }
  processorCapabilityOne(
    filter: {vendor: $vendorId, animalSpecies: $animalSpeciesProcessorCapability}
  ) {
    ...ProcessorCapabilityFragment
  }
  processingPartnersOne(vendorId: $vendorId) {
    _id
    vendor {
      shop_name
      address {
        ...AddressFragment
      }
      tenant {
        name
        picture_url
        _id
      }
      _id
    }
    capacitySettings {
      isEnabled
      dayOfWeek
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    capacityConfigurationType
    customCapacities {
      _id
      isDeleted
      date
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    schedulingDeposit
    refundDeadlineDays
    faq
    animalSettings {
      isEnabled
      species
      inspectionLevels
      splitTypes
      weightedAnimalUnit
      schedulingDeposit
      butcherSlotPricing {
        inspectionLevel
        price
      }
    }
    isWaitlistFunctionalityDisabled
    killAndChillSettings {
      species
      isEnabled
      pricePerHead
    }
    hangTimeSettings {
      species
      isEnabled
      options {
        durationDays
        isDefault
        upcharge
        availableAtBooking
      }
    }
  }
  processorSchedulingMany(
    filter: {vendor: $vendorId, _operators: {status: {in: $statuses}}}
    skip: 0
    limit: 10000
  ) {
    ...ProcessorSchedulingSlimFragment
  }
}
    ${CutsheetFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${DailyCapacityBlockFragmentFragmentDoc}
${ProcessorSchedulingSlimFragmentFragmentDoc}`;

/**
 * __useViewSchedulingCreateQuery__
 *
 * To run a query within a React component, call `useViewSchedulingCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSchedulingCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSchedulingCreateQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      animalSpeciesCutsheet: // value for 'animalSpeciesCutsheet'
 *      animalSpeciesProcessorCapability: // value for 'animalSpeciesProcessorCapability'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useViewSchedulingCreateQuery(baseOptions: Apollo.QueryHookOptions<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>(ViewSchedulingCreateDocument, options);
      }
export function useViewSchedulingCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>(ViewSchedulingCreateDocument, options);
        }
export type ViewSchedulingCreateQueryHookResult = ReturnType<typeof useViewSchedulingCreateQuery>;
export type ViewSchedulingCreateLazyQueryHookResult = ReturnType<typeof useViewSchedulingCreateLazyQuery>;
export type ViewSchedulingCreateQueryResult = Apollo.QueryResult<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>;
export const ViewSchedulingEditDocument = gql`
    query ViewSchedulingEdit($jobId: MongoID!, $userId: MongoID!, $isDeleted: Boolean!) {
  findProcessorSchedulingById(_id: $jobId) {
    _id
    vendor {
      _id
      shop_name
      address {
        email
        phone
      }
    }
    animalHeads {
      _id
      producerIdentifier
      splitType
      inspectionLevel
      butcherSlotPrice
      splits {
        _id
        cutsheet {
          _id
          name
          type
          pricePerPound
        }
        questionnaire {
          _id
        }
        questionnaireResponse {
          _id
          name
          type
          pricePerPound
          createdAt
        }
        splitPart
        notes
        locked
        buyer {
          _id
          email
          first_name
          last_name
          phone
          enabled
        }
      }
      isKillAndChill
    }
    requestedBy {
      _id
      first_name
      last_name
      email
      phone
    }
    isDeleted
    status
    dropoffDate
    dropoffDateStr
    animalSpecies
    headCount
    refundDeadlineDays
    deposit {
      amount
    }
    vendorCutsheets {
      ...CutsheetFragment
    }
    processorSettings {
      _id
      killAndChillSettings {
        isEnabled
        pricePerHead
        species
      }
      animalSettings {
        isEnabled
        inspectionLevels
        species
        schedulingDeposit
        butcherSlotPricing {
          inspectionLevel
          species
          price
        }
        customCutsheetPricing {
          inspectionLevel
          species
          price
        }
      }
      vendor {
        shop_name
        address {
          ...AddressFragment
        }
        tenant {
          name
          picture_url
          _id
        }
        _id
      }
      customCapacities {
        date
        capacity
        isDeleted
        _id
      }
      customCutsheetPricing {
        animal
        price
      }
      schedulingDeposit
      refundDeadlineDays
      faq
    }
    processorCapabilities {
      ...ProcessorCapabilityFragment
    }
  }
  cutsheetMany(filter: {user: $userId, isDeleted: $isDeleted}) {
    ...CutsheetFragment
  }
}
    ${CutsheetFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}`;

/**
 * __useViewSchedulingEditQuery__
 *
 * To run a query within a React component, call `useViewSchedulingEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSchedulingEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSchedulingEditQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      userId: // value for 'userId'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useViewSchedulingEditQuery(baseOptions: Apollo.QueryHookOptions<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>(ViewSchedulingEditDocument, options);
      }
export function useViewSchedulingEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>(ViewSchedulingEditDocument, options);
        }
export type ViewSchedulingEditQueryHookResult = ReturnType<typeof useViewSchedulingEditQuery>;
export type ViewSchedulingEditLazyQueryHookResult = ReturnType<typeof useViewSchedulingEditLazyQuery>;
export type ViewSchedulingEditQueryResult = Apollo.QueryResult<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>;
export const ActiveVendorListDocument = gql`
    query ActiveVendorList {
  activeVendorList {
    _id
    shop_name
    enabled
  }
}
    `;

/**
 * __useActiveVendorListQuery__
 *
 * To run a query within a React component, call `useActiveVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveVendorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveVendorListQuery(baseOptions?: Apollo.QueryHookOptions<ActiveVendorListQuery, ActiveVendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveVendorListQuery, ActiveVendorListQueryVariables>(ActiveVendorListDocument, options);
      }
export function useActiveVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveVendorListQuery, ActiveVendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveVendorListQuery, ActiveVendorListQueryVariables>(ActiveVendorListDocument, options);
        }
export type ActiveVendorListQueryHookResult = ReturnType<typeof useActiveVendorListQuery>;
export type ActiveVendorListLazyQueryHookResult = ReturnType<typeof useActiveVendorListLazyQuery>;
export type ActiveVendorListQueryResult = Apollo.QueryResult<ActiveVendorListQuery, ActiveVendorListQueryVariables>;
export const AdminAccountActivityDocument = gql`
    query AdminAccountActivity($startDate: String!, $endDate: String!, $comparisonType: ComparisonType) {
  adminAccountActivity(
    startDate: $startDate
    endDate: $endDate
    comparisonType: $comparisonType
  )
}
    `;

/**
 * __useAdminAccountActivityQuery__
 *
 * To run a query within a React component, call `useAdminAccountActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAccountActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAccountActivityQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      comparisonType: // value for 'comparisonType'
 *   },
 * });
 */
export function useAdminAccountActivityQuery(baseOptions: Apollo.QueryHookOptions<AdminAccountActivityQuery, AdminAccountActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAccountActivityQuery, AdminAccountActivityQueryVariables>(AdminAccountActivityDocument, options);
      }
export function useAdminAccountActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAccountActivityQuery, AdminAccountActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAccountActivityQuery, AdminAccountActivityQueryVariables>(AdminAccountActivityDocument, options);
        }
export type AdminAccountActivityQueryHookResult = ReturnType<typeof useAdminAccountActivityQuery>;
export type AdminAccountActivityLazyQueryHookResult = ReturnType<typeof useAdminAccountActivityLazyQuery>;
export type AdminAccountActivityQueryResult = Apollo.QueryResult<AdminAccountActivityQuery, AdminAccountActivityQueryVariables>;
export const AdminBusinessStatsDocument = gql`
    query AdminBusinessStats($startDate: String!, $endDate: String!, $comparisonType: ComparisonType, $consistentCohort: Boolean) {
  adminBusinessStats(
    startDate: $startDate
    endDate: $endDate
    comparisonType: $comparisonType
    consistentCohort: $consistentCohort
  )
}
    `;

/**
 * __useAdminBusinessStatsQuery__
 *
 * To run a query within a React component, call `useAdminBusinessStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBusinessStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBusinessStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      comparisonType: // value for 'comparisonType'
 *      consistentCohort: // value for 'consistentCohort'
 *   },
 * });
 */
export function useAdminBusinessStatsQuery(baseOptions: Apollo.QueryHookOptions<AdminBusinessStatsQuery, AdminBusinessStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBusinessStatsQuery, AdminBusinessStatsQueryVariables>(AdminBusinessStatsDocument, options);
      }
export function useAdminBusinessStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBusinessStatsQuery, AdminBusinessStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBusinessStatsQuery, AdminBusinessStatsQueryVariables>(AdminBusinessStatsDocument, options);
        }
export type AdminBusinessStatsQueryHookResult = ReturnType<typeof useAdminBusinessStatsQuery>;
export type AdminBusinessStatsLazyQueryHookResult = ReturnType<typeof useAdminBusinessStatsLazyQuery>;
export type AdminBusinessStatsQueryResult = Apollo.QueryResult<AdminBusinessStatsQuery, AdminBusinessStatsQueryVariables>;
export const AdminUserSearchDocument = gql`
    query AdminUserSearch($search: String!, $limit: Int = 10) {
  adminUserSearch(search: $search, limit: $limit) {
    _id
    first_name
    last_name
    email
    phone
    role
    enabled
    company
    active_vendor {
      _id
      shop_name
    }
    relationships {
      type
      vendor {
        _id
        shop_name
      }
    }
  }
}
    `;

/**
 * __useAdminUserSearchQuery__
 *
 * To run a query within a React component, call `useAdminUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminUserSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminUserSearchQuery, AdminUserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserSearchQuery, AdminUserSearchQueryVariables>(AdminUserSearchDocument, options);
      }
export function useAdminUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserSearchQuery, AdminUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserSearchQuery, AdminUserSearchQueryVariables>(AdminUserSearchDocument, options);
        }
export type AdminUserSearchQueryHookResult = ReturnType<typeof useAdminUserSearchQuery>;
export type AdminUserSearchLazyQueryHookResult = ReturnType<typeof useAdminUserSearchLazyQuery>;
export type AdminUserSearchQueryResult = Apollo.QueryResult<AdminUserSearchQuery, AdminUserSearchQueryVariables>;
export const AdminProducerSearchDocument = gql`
    query AdminProducerSearch($vendorId: MongoID!, $search: String) {
  adminProducerSearch(vendorId: $vendorId, search: $search) {
    _id
    first_name
    last_name
    company
    email
  }
}
    `;

/**
 * __useAdminProducerSearchQuery__
 *
 * To run a query within a React component, call `useAdminProducerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducerSearchQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminProducerSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminProducerSearchQuery, AdminProducerSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducerSearchQuery, AdminProducerSearchQueryVariables>(AdminProducerSearchDocument, options);
      }
export function useAdminProducerSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducerSearchQuery, AdminProducerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducerSearchQuery, AdminProducerSearchQueryVariables>(AdminProducerSearchDocument, options);
        }
export type AdminProducerSearchQueryHookResult = ReturnType<typeof useAdminProducerSearchQuery>;
export type AdminProducerSearchLazyQueryHookResult = ReturnType<typeof useAdminProducerSearchLazyQuery>;
export type AdminProducerSearchQueryResult = Apollo.QueryResult<AdminProducerSearchQuery, AdminProducerSearchQueryVariables>;
export const AdminUsersFilteredDocument = gql`
    query AdminUsersFiltered($search: String, $roles: [EnumUserRole!], $relationshipType: String, $relationshipVendorId: MongoID, $relationshipProducerId: MongoID, $enabled: Boolean, $sort: SortFindManyUserInput!, $page: Int!, $perPage: Int!) {
  getFilteredUsers(
    search: $search
    roles: $roles
    relationshipType: $relationshipType
    relationshipVendorId: $relationshipVendorId
    relationshipProducerId: $relationshipProducerId
    enabled: $enabled
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      _id
      first_name
      last_name
      email
      phone
      company
      role
      enabled
      last_login
      tenant {
        _id
        name
      }
      active_vendor {
        _id
        shop_name
      }
      address {
        _id
        address_1
        address_2
        city
        state
        postcode
      }
      relationships {
        vendorId
        producerId
        type
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminUsersFilteredQuery__
 *
 * To run a query within a React component, call `useAdminUsersFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersFilteredQuery({
 *   variables: {
 *      search: // value for 'search'
 *      roles: // value for 'roles'
 *      relationshipType: // value for 'relationshipType'
 *      relationshipVendorId: // value for 'relationshipVendorId'
 *      relationshipProducerId: // value for 'relationshipProducerId'
 *      enabled: // value for 'enabled'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAdminUsersFilteredQuery(baseOptions: Apollo.QueryHookOptions<AdminUsersFilteredQuery, AdminUsersFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersFilteredQuery, AdminUsersFilteredQueryVariables>(AdminUsersFilteredDocument, options);
      }
export function useAdminUsersFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersFilteredQuery, AdminUsersFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersFilteredQuery, AdminUsersFilteredQueryVariables>(AdminUsersFilteredDocument, options);
        }
export type AdminUsersFilteredQueryHookResult = ReturnType<typeof useAdminUsersFilteredQuery>;
export type AdminUsersFilteredLazyQueryHookResult = ReturnType<typeof useAdminUsersFilteredLazyQuery>;
export type AdminUsersFilteredQueryResult = Apollo.QueryResult<AdminUsersFilteredQuery, AdminUsersFilteredQueryVariables>;
export const LandingPageByIdDocument = gql`
    query LandingPageById($_id: MongoID!) {
  landingPageById(_id: $_id) {
    ...LandingPageFragment
    vendor {
      _id
      shop_name
      shop_slug
    }
  }
}
    ${LandingPageFragmentFragmentDoc}`;

/**
 * __useLandingPageByIdQuery__
 *
 * To run a query within a React component, call `useLandingPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLandingPageByIdQuery(baseOptions: Apollo.QueryHookOptions<LandingPageByIdQuery, LandingPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPageByIdQuery, LandingPageByIdQueryVariables>(LandingPageByIdDocument, options);
      }
export function useLandingPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPageByIdQuery, LandingPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPageByIdQuery, LandingPageByIdQueryVariables>(LandingPageByIdDocument, options);
        }
export type LandingPageByIdQueryHookResult = ReturnType<typeof useLandingPageByIdQuery>;
export type LandingPageByIdLazyQueryHookResult = ReturnType<typeof useLandingPageByIdLazyQuery>;
export type LandingPageByIdQueryResult = Apollo.QueryResult<LandingPageByIdQuery, LandingPageByIdQueryVariables>;
export const LandingPageListDocument = gql`
    query LandingPageList($search: String, $linkStatus: String, $sort: SortFindManyLandingPageSettingsInput, $page: Int!, $perPage: Int!) {
  landingPageList(
    search: $search
    linkStatus: $linkStatus
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      _id
      vendorId
      name
      tagline
      logoUrl
      showInDirectory
      showOnMap
      address {
        city
        state
      }
      vendor {
        _id
        shop_name
      }
      createdAt
      updatedAt
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useLandingPageListQuery__
 *
 * To run a query within a React component, call `useLandingPageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      linkStatus: // value for 'linkStatus'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useLandingPageListQuery(baseOptions: Apollo.QueryHookOptions<LandingPageListQuery, LandingPageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPageListQuery, LandingPageListQueryVariables>(LandingPageListDocument, options);
      }
export function useLandingPageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPageListQuery, LandingPageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPageListQuery, LandingPageListQueryVariables>(LandingPageListDocument, options);
        }
export type LandingPageListQueryHookResult = ReturnType<typeof useLandingPageListQuery>;
export type LandingPageListLazyQueryHookResult = ReturnType<typeof useLandingPageListLazyQuery>;
export type LandingPageListQueryResult = Apollo.QueryResult<LandingPageListQuery, LandingPageListQueryVariables>;
export const MarketplaceLeadSearchDocument = gql`
    query MarketplaceLeadSearch($search: String, $species: String, $quantity: String, $timeline: String, $startDate: String, $endDate: String, $page: Int, $perPage: Int) {
  marketplaceLeadSearch(
    search: $search
    species: $species
    quantity: $quantity
    timeline: $timeline
    startDate: $startDate
    endDate: $endDate
    page: $page
    perPage: $perPage
  ) {
    total
    records {
      _id
      species
      quantity
      timeline
      postcode
      name
      email
      phone
      note
      source
      location {
        coordinates
      }
      createdAt
    }
  }
}
    `;

/**
 * __useMarketplaceLeadSearchQuery__
 *
 * To run a query within a React component, call `useMarketplaceLeadSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceLeadSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceLeadSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      species: // value for 'species'
 *      quantity: // value for 'quantity'
 *      timeline: // value for 'timeline'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMarketplaceLeadSearchQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceLeadSearchQuery, MarketplaceLeadSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceLeadSearchQuery, MarketplaceLeadSearchQueryVariables>(MarketplaceLeadSearchDocument, options);
      }
export function useMarketplaceLeadSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceLeadSearchQuery, MarketplaceLeadSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceLeadSearchQuery, MarketplaceLeadSearchQueryVariables>(MarketplaceLeadSearchDocument, options);
        }
export type MarketplaceLeadSearchQueryHookResult = ReturnType<typeof useMarketplaceLeadSearchQuery>;
export type MarketplaceLeadSearchLazyQueryHookResult = ReturnType<typeof useMarketplaceLeadSearchLazyQuery>;
export type MarketplaceLeadSearchQueryResult = Apollo.QueryResult<MarketplaceLeadSearchQuery, MarketplaceLeadSearchQueryVariables>;
export const TenantByIdDocument = gql`
    query TenantById($tenantId: MongoID!) {
  tenantById(_id: $tenantId) {
    _id
    date_created
    domain
    email
    enabled
    external_id
    external_ids
    name
    picture_url
    primary_color
    users {
      first_name
      last_name
      email
      picture_url
      role
      last_login
      enabled
      _id
    }
    vendors {
      external_id
      date_created
      shop_name
      shop_slug
      shop_url
      tagline
      prefers_dropoff
      pickup_days
      free_shipping_amount
      enabled
      show_in_directory
      is_demo
      address {
        ...AddressFragment
      }
      integrations {
        config
        name
        type
        endpoint
        keyHint
        _id
      }
      processorSettings {
        isEnabled
        commercialStartDate
        _id
      }
      modules {
        moduleType
        name
        label
        href
        order
        active
        settings
        _id
      }
      _id
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useTenantByIdQuery__
 *
 * To run a query within a React component, call `useTenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantByIdQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useTenantByIdQuery(baseOptions: Apollo.QueryHookOptions<TenantByIdQuery, TenantByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantByIdQuery, TenantByIdQueryVariables>(TenantByIdDocument, options);
      }
export function useTenantByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantByIdQuery, TenantByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantByIdQuery, TenantByIdQueryVariables>(TenantByIdDocument, options);
        }
export type TenantByIdQueryHookResult = ReturnType<typeof useTenantByIdQuery>;
export type TenantByIdLazyQueryHookResult = ReturnType<typeof useTenantByIdLazyQuery>;
export type TenantByIdQueryResult = Apollo.QueryResult<TenantByIdQuery, TenantByIdQueryVariables>;
export const TenantFilteredDocument = gql`
    query TenantFiltered($isEnabled: Boolean, $search: String, $sort: SortFindManyTenantInput!, $page: Int!, $perPage: Int!) {
  getFilteredTenants(
    isEnabled: $isEnabled
    search: $search
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      _id
      external_id
      name
      date_created
      domain
      enabled
      users {
        _id
        first_name
        last_name
        role
      }
      vendors {
        _id
        date_created
        shop_name
        shop_slug
        enabled
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useTenantFilteredQuery__
 *
 * To run a query within a React component, call `useTenantFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantFilteredQuery({
 *   variables: {
 *      isEnabled: // value for 'isEnabled'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTenantFilteredQuery(baseOptions: Apollo.QueryHookOptions<TenantFilteredQuery, TenantFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantFilteredQuery, TenantFilteredQueryVariables>(TenantFilteredDocument, options);
      }
export function useTenantFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantFilteredQuery, TenantFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantFilteredQuery, TenantFilteredQueryVariables>(TenantFilteredDocument, options);
        }
export type TenantFilteredQueryHookResult = ReturnType<typeof useTenantFilteredQuery>;
export type TenantFilteredLazyQueryHookResult = ReturnType<typeof useTenantFilteredLazyQuery>;
export type TenantFilteredQueryResult = Apollo.QueryResult<TenantFilteredQuery, TenantFilteredQueryVariables>;
export const TenantPaginationDocument = gql`
    query TenantPagination($sort: SortFindManyTenantInput!, $filter: FilterFindManyTenantInput!, $page: Int!, $perPage: Int!) {
  tenantPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      external_id
      name
      date_created
      domain
      enabled
      _id
      users {
        first_name
        last_name
        role
        _id
      }
      vendors {
        date_created
        shop_name
        shop_slug
        enabled
        _id
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useTenantPaginationQuery__
 *
 * To run a query within a React component, call `useTenantPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTenantPaginationQuery(baseOptions: Apollo.QueryHookOptions<TenantPaginationQuery, TenantPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantPaginationQuery, TenantPaginationQueryVariables>(TenantPaginationDocument, options);
      }
export function useTenantPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantPaginationQuery, TenantPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantPaginationQuery, TenantPaginationQueryVariables>(TenantPaginationDocument, options);
        }
export type TenantPaginationQueryHookResult = ReturnType<typeof useTenantPaginationQuery>;
export type TenantPaginationLazyQueryHookResult = ReturnType<typeof useTenantPaginationLazyQuery>;
export type TenantPaginationQueryResult = Apollo.QueryResult<TenantPaginationQuery, TenantPaginationQueryVariables>;
export const BuyerActiveHoldsDocument = gql`
    query BuyerActiveHolds {
  buyerActiveHolds {
    _id
    splitPart
    holdExpiresAt
    placementHoldAt
    depositAmount
    animal {
      _id
      species
      killDate
      cutDate
      reserveByDate
    }
    vendorId
    processorName
    city
    state
    slug
  }
}
    `;

/**
 * __useBuyerActiveHoldsQuery__
 *
 * To run a query within a React component, call `useBuyerActiveHoldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerActiveHoldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerActiveHoldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuyerActiveHoldsQuery(baseOptions?: Apollo.QueryHookOptions<BuyerActiveHoldsQuery, BuyerActiveHoldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerActiveHoldsQuery, BuyerActiveHoldsQueryVariables>(BuyerActiveHoldsDocument, options);
      }
export function useBuyerActiveHoldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerActiveHoldsQuery, BuyerActiveHoldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerActiveHoldsQuery, BuyerActiveHoldsQueryVariables>(BuyerActiveHoldsDocument, options);
        }
export type BuyerActiveHoldsQueryHookResult = ReturnType<typeof useBuyerActiveHoldsQuery>;
export type BuyerActiveHoldsLazyQueryHookResult = ReturnType<typeof useBuyerActiveHoldsLazyQuery>;
export type BuyerActiveHoldsQueryResult = Apollo.QueryResult<BuyerActiveHoldsQuery, BuyerActiveHoldsQueryVariables>;
export const BuyerAnimalDetailDocument = gql`
    query BuyerAnimalDetail($animalId: MongoID!) {
  buyerAnimalDetail(animalId: $animalId) {
    _id
    species
    processorName
    producerName
    producerSlug
    producerLogoUrl
    producerId
    vendorId
    killDate
    cutDate
    estimatedPickupDate
    reserveByDate
    hangTimeDays
    remainingCapacity
    totalCapacity
    isFull
    descriptorChips
    producerDescription
    city
    state
    slug
    address
    location {
      lat
      lng
    }
    pickupLocations {
      _id
      name
      description
      address_1
      address_2
      city
      state
      postcode
      isDefault
      location {
        lat
        lng
      }
    }
    sections {
      size
      deposit
      available
      estimatedTotalLow
      estimatedTotalHigh
    }
    costBreakdown {
      size
      meatLow
      meatHigh
      processingLow
      processingHigh
      deposit
      sizeTier
      weightRingLow
      weightRingHigh
      dressingYieldLow
      dressingYieldHigh
      hangingWeightLow
      hangingWeightHigh
      takeHomeMeatLow
      takeHomeMeatHigh
    }
    myClaimedSplitId
    myClaimedSplitPart
    myAssignedSplitId
    myPickupLocationId
    hasPendingClaim
    myClaimedSplitStatus
    myClaimedSplitDepositStatus
    isPendingAcceptance
    iOwnThis
    sellable
    isMarketplaceListing
    actualHangingWeight
    thirdPartyFee
    finalAnimalPrice
    listingUnavailable
  }
}
    `;

/**
 * __useBuyerAnimalDetailQuery__
 *
 * To run a query within a React component, call `useBuyerAnimalDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerAnimalDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerAnimalDetailQuery({
 *   variables: {
 *      animalId: // value for 'animalId'
 *   },
 * });
 */
export function useBuyerAnimalDetailQuery(baseOptions: Apollo.QueryHookOptions<BuyerAnimalDetailQuery, BuyerAnimalDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerAnimalDetailQuery, BuyerAnimalDetailQueryVariables>(BuyerAnimalDetailDocument, options);
      }
export function useBuyerAnimalDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerAnimalDetailQuery, BuyerAnimalDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerAnimalDetailQuery, BuyerAnimalDetailQueryVariables>(BuyerAnimalDetailDocument, options);
        }
export type BuyerAnimalDetailQueryHookResult = ReturnType<typeof useBuyerAnimalDetailQuery>;
export type BuyerAnimalDetailLazyQueryHookResult = ReturnType<typeof useBuyerAnimalDetailLazyQuery>;
export type BuyerAnimalDetailQueryResult = Apollo.QueryResult<BuyerAnimalDetailQuery, BuyerAnimalDetailQueryVariables>;
export const BuyerAvailableAnimalsDocument = gql`
    query BuyerAvailableAnimals($lat: Float!, $lng: Float!, $radiusMiles: Int, $anyDistance: Boolean, $species: [String], $sectionSize: [String], $limit: Int, $vendorId: MongoID, $pickupMonth: String) {
  buyerAvailableAnimals(
    lat: $lat
    lng: $lng
    radiusMiles: $radiusMiles
    anyDistance: $anyDistance
    species: $species
    sectionSize: $sectionSize
    limit: $limit
    vendorId: $vendorId
    pickupMonth: $pickupMonth
  ) {
    _id
    species
    splitType
    allowedSectionSizes
    claimMode
    descriptorChips
    remainingCapacity
    isFull
    distanceMiles
    vendorId
    processorName
    producerName
    city
    state
    slug
    pickupLat
    pickupLng
    producerLat
    producerLng
    logoUrl
    producerLogoUrl
    producerBannerUrl
    producerBoxUrl
    producerBio
    processorBoxUrl
    createdAt
    myClaimedSplitId
    myClaimedSplitPart
    hasPendingClaim
    myClaimedSplitStatus
    myClaimedSplitDepositStatus
    killDate
    cutDate
    inspectionLevel
    reserveByDate
    datesEstimated
    isPendingAcceptance
    listingRatePerLb
    sections {
      size
      deposit
      available
      estimatedTotalLow
      estimatedTotalHigh
    }
    isInHouse
    producerId
    producerSlug
  }
}
    `;

/**
 * __useBuyerAvailableAnimalsQuery__
 *
 * To run a query within a React component, call `useBuyerAvailableAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerAvailableAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerAvailableAnimalsQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      radiusMiles: // value for 'radiusMiles'
 *      anyDistance: // value for 'anyDistance'
 *      species: // value for 'species'
 *      sectionSize: // value for 'sectionSize'
 *      limit: // value for 'limit'
 *      vendorId: // value for 'vendorId'
 *      pickupMonth: // value for 'pickupMonth'
 *   },
 * });
 */
export function useBuyerAvailableAnimalsQuery(baseOptions: Apollo.QueryHookOptions<BuyerAvailableAnimalsQuery, BuyerAvailableAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerAvailableAnimalsQuery, BuyerAvailableAnimalsQueryVariables>(BuyerAvailableAnimalsDocument, options);
      }
export function useBuyerAvailableAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerAvailableAnimalsQuery, BuyerAvailableAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerAvailableAnimalsQuery, BuyerAvailableAnimalsQueryVariables>(BuyerAvailableAnimalsDocument, options);
        }
export type BuyerAvailableAnimalsQueryHookResult = ReturnType<typeof useBuyerAvailableAnimalsQuery>;
export type BuyerAvailableAnimalsLazyQueryHookResult = ReturnType<typeof useBuyerAvailableAnimalsLazyQuery>;
export type BuyerAvailableAnimalsQueryResult = Apollo.QueryResult<BuyerAvailableAnimalsQuery, BuyerAvailableAnimalsQueryVariables>;
export const BuyerFindProcessorsDocument = gql`
    query BuyerFindProcessors($lat: Float, $lng: Float, $maxDistanceMiles: Int, $species: [String]) {
  processingPartners(
    lat: $lat
    lng: $lng
    maxDistanceMiles: $maxDistanceMiles
    species: $species
  ) {
    _id
    isEnabled
    enabledAnimals
    slug
    landingPage {
      _id
      name
      slug
      tagline
      logoUrl
      address {
        address_1
        city
        state
        postcode
      }
      contact {
        phone
        website
      }
      location {
        coordinates
      }
    }
    vendor {
      _id
      shop_name
      address {
        city
        state
      }
      tenant {
        name
        picture_url
      }
    }
  }
}
    `;

/**
 * __useBuyerFindProcessorsQuery__
 *
 * To run a query within a React component, call `useBuyerFindProcessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerFindProcessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerFindProcessorsQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      maxDistanceMiles: // value for 'maxDistanceMiles'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useBuyerFindProcessorsQuery(baseOptions?: Apollo.QueryHookOptions<BuyerFindProcessorsQuery, BuyerFindProcessorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerFindProcessorsQuery, BuyerFindProcessorsQueryVariables>(BuyerFindProcessorsDocument, options);
      }
export function useBuyerFindProcessorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerFindProcessorsQuery, BuyerFindProcessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerFindProcessorsQuery, BuyerFindProcessorsQueryVariables>(BuyerFindProcessorsDocument, options);
        }
export type BuyerFindProcessorsQueryHookResult = ReturnType<typeof useBuyerFindProcessorsQuery>;
export type BuyerFindProcessorsLazyQueryHookResult = ReturnType<typeof useBuyerFindProcessorsLazyQuery>;
export type BuyerFindProcessorsQueryResult = Apollo.QueryResult<BuyerFindProcessorsQuery, BuyerFindProcessorsQueryVariables>;
export const BuyerInterestsDocument = gql`
    query BuyerInterests {
  buyerInterests {
    _id
    producer {
      _id
      company
      first_name
      last_name
      slug
    }
    vendor {
      _id
      shop_name
    }
    species
    createdAt
  }
}
    `;

/**
 * __useBuyerInterestsQuery__
 *
 * To run a query within a React component, call `useBuyerInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuyerInterestsQuery(baseOptions?: Apollo.QueryHookOptions<BuyerInterestsQuery, BuyerInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerInterestsQuery, BuyerInterestsQueryVariables>(BuyerInterestsDocument, options);
      }
export function useBuyerInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerInterestsQuery, BuyerInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerInterestsQuery, BuyerInterestsQueryVariables>(BuyerInterestsDocument, options);
        }
export type BuyerInterestsQueryHookResult = ReturnType<typeof useBuyerInterestsQuery>;
export type BuyerInterestsLazyQueryHookResult = ReturnType<typeof useBuyerInterestsLazyQuery>;
export type BuyerInterestsQueryResult = Apollo.QueryResult<BuyerInterestsQuery, BuyerInterestsQueryVariables>;
export const BuyerInvoiceForJobDocument = gql`
    query BuyerInvoiceForJob($jobId: MongoID!) {
  buyerInvoiceForJob(jobId: $jobId) {
    _id
    number
    status
    amount_due
    amount_paid
    amount_refunded
    date_created
    settlement_recorded_at
    external_links {
      hostedInvoiceUrl
    }
    line_items {
      _id
      description
      quantity
      amount
    }
  }
}
    `;

/**
 * __useBuyerInvoiceForJobQuery__
 *
 * To run a query within a React component, call `useBuyerInvoiceForJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerInvoiceForJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerInvoiceForJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBuyerInvoiceForJobQuery(baseOptions: Apollo.QueryHookOptions<BuyerInvoiceForJobQuery, BuyerInvoiceForJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerInvoiceForJobQuery, BuyerInvoiceForJobQueryVariables>(BuyerInvoiceForJobDocument, options);
      }
export function useBuyerInvoiceForJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerInvoiceForJobQuery, BuyerInvoiceForJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerInvoiceForJobQuery, BuyerInvoiceForJobQueryVariables>(BuyerInvoiceForJobDocument, options);
        }
export type BuyerInvoiceForJobQueryHookResult = ReturnType<typeof useBuyerInvoiceForJobQuery>;
export type BuyerInvoiceForJobLazyQueryHookResult = ReturnType<typeof useBuyerInvoiceForJobLazyQuery>;
export type BuyerInvoiceForJobQueryResult = Apollo.QueryResult<BuyerInvoiceForJobQuery, BuyerInvoiceForJobQueryVariables>;
export const BuyerJobCutsheetByIdDocument = gql`
    query BuyerJobCutsheetById($jobId: MongoID!) {
  processorSchedulingById(_id: $jobId) {
    _id
    animalHeads {
      _id
      splits {
        _id
        cutsheet {
          _id
          name
          type
          pricePerPound
          primalCuts {
            ...PrimalCutFragment
          }
          selectedSpecifications
          extras {
            ...ExtrasFragment
          }
          trim {
            ...TrimFragment
          }
          notes
        }
        buyer {
          _id
        }
      }
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useBuyerJobCutsheetByIdQuery__
 *
 * To run a query within a React component, call `useBuyerJobCutsheetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerJobCutsheetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerJobCutsheetByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBuyerJobCutsheetByIdQuery(baseOptions: Apollo.QueryHookOptions<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>(BuyerJobCutsheetByIdDocument, options);
      }
export function useBuyerJobCutsheetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>(BuyerJobCutsheetByIdDocument, options);
        }
export type BuyerJobCutsheetByIdQueryHookResult = ReturnType<typeof useBuyerJobCutsheetByIdQuery>;
export type BuyerJobCutsheetByIdLazyQueryHookResult = ReturnType<typeof useBuyerJobCutsheetByIdLazyQuery>;
export type BuyerJobCutsheetByIdQueryResult = Apollo.QueryResult<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>;
export const BuyerOrdersDocument = gql`
    query BuyerOrders {
  buyerOrders {
    _id
    status
    splitId
    animalId
    jobId
    vendorId
    processorName
    producerName
    producerSlug
    producerLogoUrl
    depositRecipientParty
    isProducerListed
    species
    splitPart
    depositAmount
    listingFee
    total
    depositPaidAt
    createdAt
    finalAmount
    saleBaseAmount
    adjustments {
      label
      amount
    }
    balanceDue
    combinedSettlement {
      active
      ready
      amountDue
      paid
      blockedReason
      producerAmount
      producerStatus
      processorAmount
      processorStatus
    }
    refundedAmount
    refundedAt
    isRefunded
    paymentMethod
    invoicedAt
    invoicePaidAt
    balancePaidAt
    processingStatus
    isComplete
    events {
      type
      at
      amount
      byRole
      reason
    }
  }
}
    `;

/**
 * __useBuyerOrdersQuery__
 *
 * To run a query within a React component, call `useBuyerOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuyerOrdersQuery(baseOptions?: Apollo.QueryHookOptions<BuyerOrdersQuery, BuyerOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerOrdersQuery, BuyerOrdersQueryVariables>(BuyerOrdersDocument, options);
      }
export function useBuyerOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerOrdersQuery, BuyerOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerOrdersQuery, BuyerOrdersQueryVariables>(BuyerOrdersDocument, options);
        }
export type BuyerOrdersQueryHookResult = ReturnType<typeof useBuyerOrdersQuery>;
export type BuyerOrdersLazyQueryHookResult = ReturnType<typeof useBuyerOrdersLazyQuery>;
export type BuyerOrdersQueryResult = Apollo.QueryResult<BuyerOrdersQuery, BuyerOrdersQueryVariables>;
export const BuyerOrdersPaginationDocument = gql`
    query BuyerOrdersPagination($sort: SortFindManyProcessorSchedulingInput!, $filter: FilterFindManyProcessorSchedulingInput!, $page: Int!, $perPage: Int!) {
  buyerOrdersPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      animalSpecies
      dropoffDate
      additionalPickupDetails
      headCount
      status
      statusLastUpdated
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      vendor {
        _id
        shop_name
        address {
          address_1
          address_2
          city
          state
          postcode
          phone
        }
        pickup_days
        prefers_dropoff
      }
      animalHeads {
        _id
        publicId
        status
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        grade
        yield
        splits {
          ...Split
          yield {
            _id
            label
            weightLbs
            itemCount
            packageCount
            packageIdentifier
          }
        }
        isKillAndChill
      }
    }
  }
}
    ${SplitFragmentDoc}`;

/**
 * __useBuyerOrdersPaginationQuery__
 *
 * To run a query within a React component, call `useBuyerOrdersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerOrdersPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerOrdersPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useBuyerOrdersPaginationQuery(baseOptions: Apollo.QueryHookOptions<BuyerOrdersPaginationQuery, BuyerOrdersPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerOrdersPaginationQuery, BuyerOrdersPaginationQueryVariables>(BuyerOrdersPaginationDocument, options);
      }
export function useBuyerOrdersPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerOrdersPaginationQuery, BuyerOrdersPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerOrdersPaginationQuery, BuyerOrdersPaginationQueryVariables>(BuyerOrdersPaginationDocument, options);
        }
export type BuyerOrdersPaginationQueryHookResult = ReturnType<typeof useBuyerOrdersPaginationQuery>;
export type BuyerOrdersPaginationLazyQueryHookResult = ReturnType<typeof useBuyerOrdersPaginationLazyQuery>;
export type BuyerOrdersPaginationQueryResult = Apollo.QueryResult<BuyerOrdersPaginationQuery, BuyerOrdersPaginationQueryVariables>;
export const BuyerSplitForCutsheetDocument = gql`
    query BuyerSplitForCutsheet($splitId: MongoID!) {
  buyerSplitForCutsheet(splitId: $splitId) {
    _id
    jobId
    animalId
    animalSpecies
    inspectionLevel
    splitPart
    producerId
    vendorId
    questionnaireId
    hasCutsheet
    cutsheetMode
    cutsheetRequired
    holdExpiresAt
    placementHoldAt
    depositStatus
  }
}
    `;

/**
 * __useBuyerSplitForCutsheetQuery__
 *
 * To run a query within a React component, call `useBuyerSplitForCutsheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerSplitForCutsheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerSplitForCutsheetQuery({
 *   variables: {
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useBuyerSplitForCutsheetQuery(baseOptions: Apollo.QueryHookOptions<BuyerSplitForCutsheetQuery, BuyerSplitForCutsheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerSplitForCutsheetQuery, BuyerSplitForCutsheetQueryVariables>(BuyerSplitForCutsheetDocument, options);
      }
export function useBuyerSplitForCutsheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerSplitForCutsheetQuery, BuyerSplitForCutsheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerSplitForCutsheetQuery, BuyerSplitForCutsheetQueryVariables>(BuyerSplitForCutsheetDocument, options);
        }
export type BuyerSplitForCutsheetQueryHookResult = ReturnType<typeof useBuyerSplitForCutsheetQuery>;
export type BuyerSplitForCutsheetLazyQueryHookResult = ReturnType<typeof useBuyerSplitForCutsheetLazyQuery>;
export type BuyerSplitForCutsheetQueryResult = Apollo.QueryResult<BuyerSplitForCutsheetQuery, BuyerSplitForCutsheetQueryVariables>;
export const BuyerTransactionsDocument = gql`
    query BuyerTransactions {
  buyerTransactions {
    _id
    splitPart
    status
    depositStatus
    depositAmount
    listingFee
    depositPaidAt
    refund {
      id
      amount
      at
    }
    createdAt
    holdExpiresAt
    cancelledAt
    releasedWithoutRefundAt
    isDeleted
    jobId
    jobPublicId
    orderStatus
    purchaseAmount
    purchasePaidAt
    purchasePaidOnline
    depositPaidOnline
    animal {
      _id
      species
      tracking
      publicId
      producerIdentifier
      killDate
      cutDate
    }
    vendor {
      _id
      shop_name
      pickup_days
      address {
        address_1
        address_2
        city
        state
        postcode
        phone
      }
    }
  }
}
    `;

/**
 * __useBuyerTransactionsQuery__
 *
 * To run a query within a React component, call `useBuyerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuyerTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<BuyerTransactionsQuery, BuyerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerTransactionsQuery, BuyerTransactionsQueryVariables>(BuyerTransactionsDocument, options);
      }
export function useBuyerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerTransactionsQuery, BuyerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerTransactionsQuery, BuyerTransactionsQueryVariables>(BuyerTransactionsDocument, options);
        }
export type BuyerTransactionsQueryHookResult = ReturnType<typeof useBuyerTransactionsQuery>;
export type BuyerTransactionsLazyQueryHookResult = ReturnType<typeof useBuyerTransactionsLazyQuery>;
export type BuyerTransactionsQueryResult = Apollo.QueryResult<BuyerTransactionsQuery, BuyerTransactionsQueryVariables>;
export const CalculateProcessorCapacityAllSpeciesDocument = gql`
    query CalculateProcessorCapacityAllSpecies($vendorId: String!, $startDate: String!, $endDate: String!, $dateFormat: String, $groupFormat: String) {
  calculateProcessorCapacityAllSpecies(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
    dateFormat: $dateFormat
    groupFormat: $groupFormat
  ) {
    spotGroups
    totalSpots
    hasAvailableSpots
    bySpecies
  }
}
    `;

/**
 * __useCalculateProcessorCapacityAllSpeciesQuery__
 *
 * To run a query within a React component, call `useCalculateProcessorCapacityAllSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateProcessorCapacityAllSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateProcessorCapacityAllSpeciesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      dateFormat: // value for 'dateFormat'
 *      groupFormat: // value for 'groupFormat'
 *   },
 * });
 */
export function useCalculateProcessorCapacityAllSpeciesQuery(baseOptions: Apollo.QueryHookOptions<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>(CalculateProcessorCapacityAllSpeciesDocument, options);
      }
export function useCalculateProcessorCapacityAllSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>(CalculateProcessorCapacityAllSpeciesDocument, options);
        }
export type CalculateProcessorCapacityAllSpeciesQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityAllSpeciesQuery>;
export type CalculateProcessorCapacityAllSpeciesLazyQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityAllSpeciesLazyQuery>;
export type CalculateProcessorCapacityAllSpeciesQueryResult = Apollo.QueryResult<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>;
export const CalculateProcessorCapacityDocument = gql`
    query CalculateProcessorCapacity($vendorId: String!, $selectedAnimalSpecies: String!, $startDate: String!, $endDate: String!, $dateFormat: String, $groupFormat: String) {
  calculateProcessorCapacity(
    vendorId: $vendorId
    selectedAnimalSpecies: $selectedAnimalSpecies
    startDate: $startDate
    endDate: $endDate
    dateFormat: $dateFormat
    groupFormat: $groupFormat
  ) {
    spotGroups
    totalSpots
    hasAvailableSpots
  }
}
    `;

/**
 * __useCalculateProcessorCapacityQuery__
 *
 * To run a query within a React component, call `useCalculateProcessorCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateProcessorCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateProcessorCapacityQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      selectedAnimalSpecies: // value for 'selectedAnimalSpecies'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      dateFormat: // value for 'dateFormat'
 *      groupFormat: // value for 'groupFormat'
 *   },
 * });
 */
export function useCalculateProcessorCapacityQuery(baseOptions: Apollo.QueryHookOptions<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>(CalculateProcessorCapacityDocument, options);
      }
export function useCalculateProcessorCapacityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>(CalculateProcessorCapacityDocument, options);
        }
export type CalculateProcessorCapacityQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityQuery>;
export type CalculateProcessorCapacityLazyQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityLazyQuery>;
export type CalculateProcessorCapacityQueryResult = Apollo.QueryResult<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>;
export const CalendarEventTypeManyDocument = gql`
    query CalendarEventTypeMany($filter: FilterFindManyCalendarEventTypeInput, $sort: SortFindManyCalendarEventTypeInput) {
  calendarEventTypeMany(filter: $filter, sort: $sort, limit: 500) {
    _id
    vendor
    title
    color
    isEnabled
    sortOrder
  }
}
    `;

/**
 * __useCalendarEventTypeManyQuery__
 *
 * To run a query within a React component, call `useCalendarEventTypeManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventTypeManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventTypeManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCalendarEventTypeManyQuery(baseOptions?: Apollo.QueryHookOptions<CalendarEventTypeManyQuery, CalendarEventTypeManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventTypeManyQuery, CalendarEventTypeManyQueryVariables>(CalendarEventTypeManyDocument, options);
      }
export function useCalendarEventTypeManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventTypeManyQuery, CalendarEventTypeManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventTypeManyQuery, CalendarEventTypeManyQueryVariables>(CalendarEventTypeManyDocument, options);
        }
export type CalendarEventTypeManyQueryHookResult = ReturnType<typeof useCalendarEventTypeManyQuery>;
export type CalendarEventTypeManyLazyQueryHookResult = ReturnType<typeof useCalendarEventTypeManyLazyQuery>;
export type CalendarEventTypeManyQueryResult = Apollo.QueryResult<CalendarEventTypeManyQuery, CalendarEventTypeManyQueryVariables>;
export const CalendarEventManyDocument = gql`
    query CalendarEventMany($filter: FilterFindManyCalendarEventInput) {
  calendarEventMany(filter: $filter, limit: 1000) {
    _id
    vendor
    eventType
    title
    date
    description
  }
}
    `;

/**
 * __useCalendarEventManyQuery__
 *
 * To run a query within a React component, call `useCalendarEventManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCalendarEventManyQuery(baseOptions?: Apollo.QueryHookOptions<CalendarEventManyQuery, CalendarEventManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventManyQuery, CalendarEventManyQueryVariables>(CalendarEventManyDocument, options);
      }
export function useCalendarEventManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventManyQuery, CalendarEventManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventManyQuery, CalendarEventManyQueryVariables>(CalendarEventManyDocument, options);
        }
export type CalendarEventManyQueryHookResult = ReturnType<typeof useCalendarEventManyQuery>;
export type CalendarEventManyLazyQueryHookResult = ReturnType<typeof useCalendarEventManyLazyQuery>;
export type CalendarEventManyQueryResult = Apollo.QueryResult<CalendarEventManyQuery, CalendarEventManyQueryVariables>;
export const CancellationReasonManyDocument = gql`
    query cancellationReasonMany($filter: FilterFindManyCancellationReasonInput, $sort: SortFindManyCancellationReasonInput) {
  cancellationReasonMany(filter: $filter, sort: $sort) {
    reason
    index
    isEnabled
    _id
  }
}
    `;

/**
 * __useCancellationReasonManyQuery__
 *
 * To run a query within a React component, call `useCancellationReasonManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationReasonManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCancellationReasonManyQuery(baseOptions?: Apollo.QueryHookOptions<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>(CancellationReasonManyDocument, options);
      }
export function useCancellationReasonManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>(CancellationReasonManyDocument, options);
        }
export type CancellationReasonManyQueryHookResult = ReturnType<typeof useCancellationReasonManyQuery>;
export type CancellationReasonManyLazyQueryHookResult = ReturnType<typeof useCancellationReasonManyLazyQuery>;
export type CancellationReasonManyQueryResult = Apollo.QueryResult<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>;
export const CsvImportJobStatusDocument = gql`
    query CsvImportJobStatus($jobId: String!) {
  csvImportJobStatus(jobId: $jobId) {
    jobId
    type
    status
    totalRows
    validRows
    invalidRows
    processedCount
    successCount
    failureCount
    failures {
      row
      error
    }
    s3Keys
    deletedRows
    validationErrors {
      row
      errorMessages
      warningMessages
    }
    createdAt
    completedAt
  }
}
    `;

/**
 * __useCsvImportJobStatusQuery__
 *
 * To run a query within a React component, call `useCsvImportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvImportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvImportJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCsvImportJobStatusQuery(baseOptions: Apollo.QueryHookOptions<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>(CsvImportJobStatusDocument, options);
      }
export function useCsvImportJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>(CsvImportJobStatusDocument, options);
        }
export type CsvImportJobStatusQueryHookResult = ReturnType<typeof useCsvImportJobStatusQuery>;
export type CsvImportJobStatusLazyQueryHookResult = ReturnType<typeof useCsvImportJobStatusLazyQuery>;
export type CsvImportJobStatusQueryResult = Apollo.QueryResult<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>;
export const CsvImportJobsDocument = gql`
    query CsvImportJobs($tenantId: String!, $vendorId: String, $type: String, $limit: Int, $skip: Int) {
  csvImportJobs(
    tenantId: $tenantId
    vendorId: $vendorId
    type: $type
    limit: $limit
    skip: $skip
  ) {
    jobs {
      jobId
      type
      status
      totalRows
      validRows
      invalidRows
      processedCount
      successCount
      failureCount
      s3Keys
      createdAt
      completedAt
      cancelledAt
    }
    total
    hasMore
  }
}
    `;

/**
 * __useCsvImportJobsQuery__
 *
 * To run a query within a React component, call `useCsvImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvImportJobsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      vendorId: // value for 'vendorId'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCsvImportJobsQuery(baseOptions: Apollo.QueryHookOptions<CsvImportJobsQuery, CsvImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvImportJobsQuery, CsvImportJobsQueryVariables>(CsvImportJobsDocument, options);
      }
export function useCsvImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvImportJobsQuery, CsvImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvImportJobsQuery, CsvImportJobsQueryVariables>(CsvImportJobsDocument, options);
        }
export type CsvImportJobsQueryHookResult = ReturnType<typeof useCsvImportJobsQuery>;
export type CsvImportJobsLazyQueryHookResult = ReturnType<typeof useCsvImportJobsLazyQuery>;
export type CsvImportJobsQueryResult = Apollo.QueryResult<CsvImportJobsQuery, CsvImportJobsQueryVariables>;
export const CustomFieldDefinitionManyDocument = gql`
    query CustomFieldDefinitionMany($filter: FilterFindManyCustomFieldDefinitionInput, $sort: SortFindManyCustomFieldDefinitionInput) {
  customFieldDefinitionMany(filter: $filter, sort: $sort) {
    _id
    vendor
    modelType
    label
    fieldType
    fieldSource
    fieldKey
    enabled
    options
    sortOrder
    required
    speciesFilter
    captureAt
    hint
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCustomFieldDefinitionManyQuery__
 *
 * To run a query within a React component, call `useCustomFieldDefinitionManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldDefinitionManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldDefinitionManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCustomFieldDefinitionManyQuery(baseOptions?: Apollo.QueryHookOptions<CustomFieldDefinitionManyQuery, CustomFieldDefinitionManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldDefinitionManyQuery, CustomFieldDefinitionManyQueryVariables>(CustomFieldDefinitionManyDocument, options);
      }
export function useCustomFieldDefinitionManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldDefinitionManyQuery, CustomFieldDefinitionManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldDefinitionManyQuery, CustomFieldDefinitionManyQueryVariables>(CustomFieldDefinitionManyDocument, options);
        }
export type CustomFieldDefinitionManyQueryHookResult = ReturnType<typeof useCustomFieldDefinitionManyQuery>;
export type CustomFieldDefinitionManyLazyQueryHookResult = ReturnType<typeof useCustomFieldDefinitionManyLazyQuery>;
export type CustomFieldDefinitionManyQueryResult = Apollo.QueryResult<CustomFieldDefinitionManyQuery, CustomFieldDefinitionManyQueryVariables>;
export const CustomFieldValueManyDocument = gql`
    query CustomFieldValueMany($filter: FilterFindManyCustomFieldValueInput, $limit: Int) {
  customFieldValueMany(filter: $filter, limit: $limit) {
    _id
    definition
    recordId
    recordType
    value_text
    value_number
    value_boolean
    value_json
  }
}
    `;

/**
 * __useCustomFieldValueManyQuery__
 *
 * To run a query within a React component, call `useCustomFieldValueManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldValueManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldValueManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomFieldValueManyQuery(baseOptions?: Apollo.QueryHookOptions<CustomFieldValueManyQuery, CustomFieldValueManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldValueManyQuery, CustomFieldValueManyQueryVariables>(CustomFieldValueManyDocument, options);
      }
export function useCustomFieldValueManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldValueManyQuery, CustomFieldValueManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldValueManyQuery, CustomFieldValueManyQueryVariables>(CustomFieldValueManyDocument, options);
        }
export type CustomFieldValueManyQueryHookResult = ReturnType<typeof useCustomFieldValueManyQuery>;
export type CustomFieldValueManyLazyQueryHookResult = ReturnType<typeof useCustomFieldValueManyLazyQuery>;
export type CustomFieldValueManyQueryResult = Apollo.QueryResult<CustomFieldValueManyQuery, CustomFieldValueManyQueryVariables>;
export const CustomerDeletePreviewDocument = gql`
    query CustomerDeletePreview($userId: MongoID!, $vendorId: MongoID!) {
  customerDeletePreview(userId: $userId, vendorId: $vendorId) {
    associatedRecordCount
    canDelete
    blockedReason
    multiVendor
  }
}
    `;

/**
 * __useCustomerDeletePreviewQuery__
 *
 * To run a query within a React component, call `useCustomerDeletePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeletePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerDeletePreviewQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCustomerDeletePreviewQuery(baseOptions: Apollo.QueryHookOptions<CustomerDeletePreviewQuery, CustomerDeletePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerDeletePreviewQuery, CustomerDeletePreviewQueryVariables>(CustomerDeletePreviewDocument, options);
      }
export function useCustomerDeletePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerDeletePreviewQuery, CustomerDeletePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerDeletePreviewQuery, CustomerDeletePreviewQueryVariables>(CustomerDeletePreviewDocument, options);
        }
export type CustomerDeletePreviewQueryHookResult = ReturnType<typeof useCustomerDeletePreviewQuery>;
export type CustomerDeletePreviewLazyQueryHookResult = ReturnType<typeof useCustomerDeletePreviewLazyQuery>;
export type CustomerDeletePreviewQueryResult = Apollo.QueryResult<CustomerDeletePreviewQuery, CustomerDeletePreviewQueryVariables>;
export const CustomerMergeCandidatesDocument = gql`
    query CustomerMergeCandidates($ids: [MongoID!]!, $vendorId: MongoID) {
  customerMergeCandidates(ids: $ids, vendorId: $vendorId) {
    _id
    first_name
    last_name
    company
    email
    phone
    address
    hasLogin
    retireBlockedReason
  }
}
    `;

/**
 * __useCustomerMergeCandidatesQuery__
 *
 * To run a query within a React component, call `useCustomerMergeCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerMergeCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerMergeCandidatesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCustomerMergeCandidatesQuery(baseOptions: Apollo.QueryHookOptions<CustomerMergeCandidatesQuery, CustomerMergeCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerMergeCandidatesQuery, CustomerMergeCandidatesQueryVariables>(CustomerMergeCandidatesDocument, options);
      }
export function useCustomerMergeCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerMergeCandidatesQuery, CustomerMergeCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerMergeCandidatesQuery, CustomerMergeCandidatesQueryVariables>(CustomerMergeCandidatesDocument, options);
        }
export type CustomerMergeCandidatesQueryHookResult = ReturnType<typeof useCustomerMergeCandidatesQuery>;
export type CustomerMergeCandidatesLazyQueryHookResult = ReturnType<typeof useCustomerMergeCandidatesLazyQuery>;
export type CustomerMergeCandidatesQueryResult = Apollo.QueryResult<CustomerMergeCandidatesQuery, CustomerMergeCandidatesQueryVariables>;
export const CustomerMergePreviewDocument = gql`
    query CustomerMergePreview($winnerId: MongoID!, $loserIds: [MongoID!]!, $vendorId: MongoID!) {
  customerMergePreview(
    winnerId: $winnerId
    loserIds: $loserIds
    vendorId: $vendorId
  ) {
    affectedRecordCount
    exceedsCap
    cap
    crossType
    touchesQuickbooks
  }
}
    `;

/**
 * __useCustomerMergePreviewQuery__
 *
 * To run a query within a React component, call `useCustomerMergePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerMergePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerMergePreviewQuery({
 *   variables: {
 *      winnerId: // value for 'winnerId'
 *      loserIds: // value for 'loserIds'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCustomerMergePreviewQuery(baseOptions: Apollo.QueryHookOptions<CustomerMergePreviewQuery, CustomerMergePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerMergePreviewQuery, CustomerMergePreviewQueryVariables>(CustomerMergePreviewDocument, options);
      }
export function useCustomerMergePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerMergePreviewQuery, CustomerMergePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerMergePreviewQuery, CustomerMergePreviewQueryVariables>(CustomerMergePreviewDocument, options);
        }
export type CustomerMergePreviewQueryHookResult = ReturnType<typeof useCustomerMergePreviewQuery>;
export type CustomerMergePreviewLazyQueryHookResult = ReturnType<typeof useCustomerMergePreviewLazyQuery>;
export type CustomerMergePreviewQueryResult = Apollo.QueryResult<CustomerMergePreviewQuery, CustomerMergePreviewQueryVariables>;
export const CustomerNotificationPreferencesDocument = gql`
    query CustomerNotificationPreferences($userId: MongoID!) {
  customerNotificationPreferences(userId: $userId) {
    category
    label
    description
    email
    sms
  }
}
    `;

/**
 * __useCustomerNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useCustomerNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerNotificationPreferencesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomerNotificationPreferencesQuery(baseOptions: Apollo.QueryHookOptions<CustomerNotificationPreferencesQuery, CustomerNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerNotificationPreferencesQuery, CustomerNotificationPreferencesQueryVariables>(CustomerNotificationPreferencesDocument, options);
      }
export function useCustomerNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerNotificationPreferencesQuery, CustomerNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerNotificationPreferencesQuery, CustomerNotificationPreferencesQueryVariables>(CustomerNotificationPreferencesDocument, options);
        }
export type CustomerNotificationPreferencesQueryHookResult = ReturnType<typeof useCustomerNotificationPreferencesQuery>;
export type CustomerNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useCustomerNotificationPreferencesLazyQuery>;
export type CustomerNotificationPreferencesQueryResult = Apollo.QueryResult<CustomerNotificationPreferencesQuery, CustomerNotificationPreferencesQueryVariables>;
export const CustomerRebookingDocument = gql`
    query CustomerRebooking($userId: MongoID!, $vendorId: MongoID!) {
  getCustomerRebooking(userId: $userId, vendorId: $vendorId) {
    latestDropoffDate
    autoIntervalDays
    overrideIntervalDays
    effectiveIntervalDays
    dueSoonWindowDays
    expectedNextBookingDate
    rebookingStatus
    rebookingIntervalSource
  }
}
    `;

/**
 * __useCustomerRebookingQuery__
 *
 * To run a query within a React component, call `useCustomerRebookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerRebookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerRebookingQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCustomerRebookingQuery(baseOptions: Apollo.QueryHookOptions<CustomerRebookingQuery, CustomerRebookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerRebookingQuery, CustomerRebookingQueryVariables>(CustomerRebookingDocument, options);
      }
export function useCustomerRebookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerRebookingQuery, CustomerRebookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerRebookingQuery, CustomerRebookingQueryVariables>(CustomerRebookingDocument, options);
        }
export type CustomerRebookingQueryHookResult = ReturnType<typeof useCustomerRebookingQuery>;
export type CustomerRebookingLazyQueryHookResult = ReturnType<typeof useCustomerRebookingLazyQuery>;
export type CustomerRebookingQueryResult = Apollo.QueryResult<CustomerRebookingQuery, CustomerRebookingQueryVariables>;
export const CustomerSavedCardsDocument = gql`
    query CustomerSavedCards($vendorId: MongoID!, $userId: MongoID!) {
  customerSavedCards(vendorId: $vendorId, userId: $userId) {
    id
    brand
    last4
    expMonth
    expYear
  }
}
    `;

/**
 * __useCustomerSavedCardsQuery__
 *
 * To run a query within a React component, call `useCustomerSavedCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSavedCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSavedCardsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomerSavedCardsQuery(baseOptions: Apollo.QueryHookOptions<CustomerSavedCardsQuery, CustomerSavedCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSavedCardsQuery, CustomerSavedCardsQueryVariables>(CustomerSavedCardsDocument, options);
      }
export function useCustomerSavedCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSavedCardsQuery, CustomerSavedCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSavedCardsQuery, CustomerSavedCardsQueryVariables>(CustomerSavedCardsDocument, options);
        }
export type CustomerSavedCardsQueryHookResult = ReturnType<typeof useCustomerSavedCardsQuery>;
export type CustomerSavedCardsLazyQueryHookResult = ReturnType<typeof useCustomerSavedCardsLazyQuery>;
export type CustomerSavedCardsQueryResult = Apollo.QueryResult<CustomerSavedCardsQuery, CustomerSavedCardsQueryVariables>;
export const CutsheetQuestionnaireResponseSearchDocument = gql`
    query CutsheetQuestionnaireResponseSearch($vendorId: MongoID, $userId: MongoID, $questionnaireId: MongoID, $capabilitySetId: MongoID, $type: [EnumCutsheetQuestionnaireResponseType], $includeDeleted: Boolean, $query: String, $sort: SortFindManyCutsheetQuestionnaireResponseInput!, $page: Int!, $perPage: Int!) {
  cutsheetQuestionnaireResponseSearch(
    vendorId: $vendorId
    userId: $userId
    questionnaireId: $questionnaireId
    capabilitySetId: $capabilitySetId
    type: $type
    includeDeleted: $includeDeleted
    query: $query
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    items {
      _id
      name
      notes
      type
      createdAt
      questionnaire
      questionnaireName
      user
      userFullName
    }
    count
    pageInfo {
      currentPage
      perPage
      itemCount
      pageCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponseSearchQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponseSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponseSearchQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      userId: // value for 'userId'
 *      questionnaireId: // value for 'questionnaireId'
 *      capabilitySetId: // value for 'capabilitySetId'
 *      type: // value for 'type'
 *      includeDeleted: // value for 'includeDeleted'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseSearchQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>(CutsheetQuestionnaireResponseSearchDocument, options);
      }
export function useCutsheetQuestionnaireResponseSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>(CutsheetQuestionnaireResponseSearchDocument, options);
        }
export type CutsheetQuestionnaireResponseSearchQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseSearchQuery>;
export type CutsheetQuestionnaireResponseSearchLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseSearchLazyQuery>;
export type CutsheetQuestionnaireResponseSearchQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>;
export const CutsheetAssignmentRuleSetByCapabilityIdDocument = gql`
    query CutsheetAssignmentRuleSetByCapabilityId($capabilityId: MongoID!) {
  cutsheetAssignmentRuleSetByCapabilityId(capabilityId: $capabilityId) {
    ...CutsheetAssignmentRuleSetFragment
  }
}
    ${CutsheetAssignmentRuleSetFragmentFragmentDoc}`;

/**
 * __useCutsheetAssignmentRuleSetByCapabilityIdQuery__
 *
 * To run a query within a React component, call `useCutsheetAssignmentRuleSetByCapabilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetAssignmentRuleSetByCapabilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetAssignmentRuleSetByCapabilityIdQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useCutsheetAssignmentRuleSetByCapabilityIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>(CutsheetAssignmentRuleSetByCapabilityIdDocument, options);
      }
export function useCutsheetAssignmentRuleSetByCapabilityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>(CutsheetAssignmentRuleSetByCapabilityIdDocument, options);
        }
export type CutsheetAssignmentRuleSetByCapabilityIdQueryHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetByCapabilityIdQuery>;
export type CutsheetAssignmentRuleSetByCapabilityIdLazyQueryHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetByCapabilityIdLazyQuery>;
export type CutsheetAssignmentRuleSetByCapabilityIdQueryResult = Apollo.QueryResult<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>;
export const CutsheetCapabilityByIdDocument = gql`
    query CutsheetCapabilityById($id: MongoID!) {
  CutsheetCapabilityById(_id: $id) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityByIdQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityByIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>(CutsheetCapabilityByIdDocument, options);
      }
export function useCutsheetCapabilityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>(CutsheetCapabilityByIdDocument, options);
        }
export type CutsheetCapabilityByIdQueryHookResult = ReturnType<typeof useCutsheetCapabilityByIdQuery>;
export type CutsheetCapabilityByIdLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityByIdLazyQuery>;
export type CutsheetCapabilityByIdQueryResult = Apollo.QueryResult<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>;
export const CutsheetCapabilityManyDocument = gql`
    query CutsheetCapabilityMany($vendorId: MongoID!, $species: String, $isActive: Boolean) {
  CutsheetCapabilityByVendorAndAnimal(
    vendorId: $vendorId
    species: $species
    isActive: $isActive
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityManyQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>(CutsheetCapabilityManyDocument, options);
      }
export function useCutsheetCapabilityManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>(CutsheetCapabilityManyDocument, options);
        }
export type CutsheetCapabilityManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityManyQuery>;
export type CutsheetCapabilityManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityManyLazyQuery>;
export type CutsheetCapabilityManyQueryResult = Apollo.QueryResult<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>;
export const CutsheetCapabilityOptionsByIdsDocument = gql`
    query CutsheetCapabilityOptionsByIds($ids: [MongoID!]!) {
  cutsheetCapabilityOptionByIds(_ids: $ids) {
    ...CutsheetCapabilityOptionFragment
  }
}
    ${CutsheetCapabilityOptionFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityOptionsByIdsQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityOptionsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityOptionsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionsByIdsQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>(CutsheetCapabilityOptionsByIdsDocument, options);
      }
export function useCutsheetCapabilityOptionsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>(CutsheetCapabilityOptionsByIdsDocument, options);
        }
export type CutsheetCapabilityOptionsByIdsQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsByIdsQuery>;
export type CutsheetCapabilityOptionsByIdsLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsByIdsLazyQuery>;
export type CutsheetCapabilityOptionsByIdsQueryResult = Apollo.QueryResult<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>;
export const CutsheetCapabilityOptionsManyDocument = gql`
    query CutsheetCapabilityOptionsMany($capabilityId: MongoID!, $isActive: Boolean, $optionType: String) {
  cutsheetCapabilityOptionsByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
    optionType: $optionType
  ) {
    ...CutsheetCapabilityOptionFragment
  }
}
    ${CutsheetCapabilityOptionFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityOptionsManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityOptionsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityOptionsManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *      optionType: // value for 'optionType'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionsManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>(CutsheetCapabilityOptionsManyDocument, options);
      }
export function useCutsheetCapabilityOptionsManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>(CutsheetCapabilityOptionsManyDocument, options);
        }
export type CutsheetCapabilityOptionsManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsManyQuery>;
export type CutsheetCapabilityOptionsManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsManyLazyQuery>;
export type CutsheetCapabilityOptionsManyQueryResult = Apollo.QueryResult<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>;
export const CutsheetCapabilityCutManyDocument = gql`
    query CutsheetCapabilityCutMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetCutsByVendorAndAnimal(capabilityId: $capabilityId, isActive: $isActive) {
    ...CutsheetCapabilityCutFragment
  }
}
    ${CutsheetCapabilityCutFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityCutManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityCutManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityCutManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityCutManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityCutManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>(CutsheetCapabilityCutManyDocument, options);
      }
export function useCutsheetCapabilityCutManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>(CutsheetCapabilityCutManyDocument, options);
        }
export type CutsheetCapabilityCutManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityCutManyQuery>;
export type CutsheetCapabilityCutManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityCutManyLazyQuery>;
export type CutsheetCapabilityCutManyQueryResult = Apollo.QueryResult<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>;
export const CutsheetCapabilityExtraManyDocument = gql`
    query CutsheetCapabilityExtraMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetExtrasByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
  ) {
    ...CutsheetCapabilityExtraFragment
  }
}
    ${CutsheetCapabilityExtraFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityExtraManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityExtraManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityExtraManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityExtraManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityExtraManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>(CutsheetCapabilityExtraManyDocument, options);
      }
export function useCutsheetCapabilityExtraManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>(CutsheetCapabilityExtraManyDocument, options);
        }
export type CutsheetCapabilityExtraManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityExtraManyQuery>;
export type CutsheetCapabilityExtraManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityExtraManyLazyQuery>;
export type CutsheetCapabilityExtraManyQueryResult = Apollo.QueryResult<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>;
export const CutsheetCapabilityGroupManyDocument = gql`
    query CutsheetCapabilityGroupMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetGroupsByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
  ) {
    ...CutsheetCapabilityGroupFragment
  }
}
    ${CutsheetCapabilityGroupFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityGroupManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityGroupManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>(CutsheetCapabilityGroupManyDocument, options);
      }
export function useCutsheetCapabilityGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>(CutsheetCapabilityGroupManyDocument, options);
        }
export type CutsheetCapabilityGroupManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityGroupManyQuery>;
export type CutsheetCapabilityGroupManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityGroupManyLazyQuery>;
export type CutsheetCapabilityGroupManyQueryResult = Apollo.QueryResult<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>;
export const CutsheetLegacyCapabilityDataDocument = gql`
    query CutsheetLegacyCapabilityData($capabilityId: MongoID!) {
  CutsheetLegacyCapabilityData(capabilityId: $capabilityId) {
    inspectionLevel
    cuts {
      _id
      name
      primalName
    }
    trims {
      name
    }
    extras {
      name
    }
    specifications {
      name
    }
  }
}
    `;

/**
 * __useCutsheetLegacyCapabilityDataQuery__
 *
 * To run a query within a React component, call `useCutsheetLegacyCapabilityDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetLegacyCapabilityDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetLegacyCapabilityDataQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useCutsheetLegacyCapabilityDataQuery(baseOptions: Apollo.QueryHookOptions<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>(CutsheetLegacyCapabilityDataDocument, options);
      }
export function useCutsheetLegacyCapabilityDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>(CutsheetLegacyCapabilityDataDocument, options);
        }
export type CutsheetLegacyCapabilityDataQueryHookResult = ReturnType<typeof useCutsheetLegacyCapabilityDataQuery>;
export type CutsheetLegacyCapabilityDataLazyQueryHookResult = ReturnType<typeof useCutsheetLegacyCapabilityDataLazyQuery>;
export type CutsheetLegacyCapabilityDataQueryResult = Apollo.QueryResult<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>;
export const CutsheetQuestionnaireByIdDocument = gql`
    query CutsheetQuestionnaireById($id: MongoID!) {
  cutsheetQuestionnaireById(_id: $id) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;

/**
 * __useCutsheetQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>(CutsheetQuestionnaireByIdDocument, options);
      }
export function useCutsheetQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>(CutsheetQuestionnaireByIdDocument, options);
        }
export type CutsheetQuestionnaireByIdQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireByIdQuery>;
export type CutsheetQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireByIdLazyQuery>;
export type CutsheetQuestionnaireByIdQueryResult = Apollo.QueryResult<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>;
export const CutsheetQuestionnaireManyDocument = gql`
    query CutsheetQuestionnaireMany($capabilityId: MongoID!, $status: String, $includeArchived: Boolean) {
  cutsheetQuestionnairesByVendorAndAnimal(
    capabilityId: $capabilityId
    status: $status
    includeArchived: $includeArchived
  ) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;

/**
 * __useCutsheetQuestionnaireManyQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      status: // value for 'status'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useCutsheetQuestionnaireManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>(CutsheetQuestionnaireManyDocument, options);
      }
export function useCutsheetQuestionnaireManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>(CutsheetQuestionnaireManyDocument, options);
        }
export type CutsheetQuestionnaireManyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireManyQuery>;
export type CutsheetQuestionnaireManyLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireManyLazyQuery>;
export type CutsheetQuestionnaireManyQueryResult = Apollo.QueryResult<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>;
export const CutsheetQuestionnaireResponseByIdDocument = gql`
    query CutsheetQuestionnaireResponseById($_id: MongoID!) {
  cutsheetQuestionnaireResponseById(_id: $_id) {
    _id
    name
    notes
    type
    user
    questionnaire
    capabilitySet
    createdAt
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
    primalNotes {
      id
      note
    }
    trimSectionNotes
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponseByIdQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponseByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseByIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>(CutsheetQuestionnaireResponseByIdDocument, options);
      }
export function useCutsheetQuestionnaireResponseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>(CutsheetQuestionnaireResponseByIdDocument, options);
        }
export type CutsheetQuestionnaireResponseByIdQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseByIdQuery>;
export type CutsheetQuestionnaireResponseByIdLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseByIdLazyQuery>;
export type CutsheetQuestionnaireResponseByIdQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>;
export const CutsheetQuestionnaireResponsesByUserDocument = gql`
    query CutsheetQuestionnaireResponsesByUser($userId: MongoID!, $questionnaireId: MongoID) {
  cutsheetQuestionnaireResponsesByUser(
    userId: $userId
    questionnaireId: $questionnaireId
  ) {
    _id
    name
    questionnaire
    capabilitySet
    type
    pricePerPound
    notes
    createdAt
    updatedAt
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponsesByUserQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponsesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponsesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponsesByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      questionnaireId: // value for 'questionnaireId'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponsesByUserQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>(CutsheetQuestionnaireResponsesByUserDocument, options);
      }
export function useCutsheetQuestionnaireResponsesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>(CutsheetQuestionnaireResponsesByUserDocument, options);
        }
export type CutsheetQuestionnaireResponsesByUserQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByUserQuery>;
export type CutsheetQuestionnaireResponsesByUserLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByUserLazyQuery>;
export type CutsheetQuestionnaireResponsesByUserQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>;
export const CutsheetQuestionnaireResponsesByVendorDocument = gql`
    query CutsheetQuestionnaireResponsesByVendor($vendorId: MongoID!) {
  cutsheetQuestionnaireResponsesByVendor(vendorId: $vendorId) {
    _id
    name
    type
    pricePerPound
    notes
    createdAt
    updatedAt
    selectedCuts {
      optionId
    }
    trimSelections {
      type
      trim {
        optionId
      }
    }
    questionnaire
    user
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponsesByVendorQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponsesByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponsesByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponsesByVendorQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponsesByVendorQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>(CutsheetQuestionnaireResponsesByVendorDocument, options);
      }
export function useCutsheetQuestionnaireResponsesByVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>(CutsheetQuestionnaireResponsesByVendorDocument, options);
        }
export type CutsheetQuestionnaireResponsesByVendorQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByVendorQuery>;
export type CutsheetQuestionnaireResponsesByVendorLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByVendorLazyQuery>;
export type CutsheetQuestionnaireResponsesByVendorQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>;
export const CutsheetQuestionnairesByIdsDocument = gql`
    query CutsheetQuestionnairesByIds($ids: [MongoID!]!) {
  cutsheetQuestionnaireByIds(_ids: $ids) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;

/**
 * __useCutsheetQuestionnairesByIdsQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnairesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnairesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnairesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetQuestionnairesByIdsQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>(CutsheetQuestionnairesByIdsDocument, options);
      }
export function useCutsheetQuestionnairesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>(CutsheetQuestionnairesByIdsDocument, options);
        }
export type CutsheetQuestionnairesByIdsQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByIdsQuery>;
export type CutsheetQuestionnairesByIdsLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByIdsLazyQuery>;
export type CutsheetQuestionnairesByIdsQueryResult = Apollo.QueryResult<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>;
export const CutsheetQuestionnairesByVendorDocument = gql`
    query CutsheetQuestionnairesByVendor($vendorId: MongoID!) {
  cutsheetQuestionnairesByVendor(vendorId: $vendorId) {
    _id
    name
    status
    capabilityId
  }
}
    `;

/**
 * __useCutsheetQuestionnairesByVendorQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnairesByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnairesByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnairesByVendorQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCutsheetQuestionnairesByVendorQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>(CutsheetQuestionnairesByVendorDocument, options);
      }
export function useCutsheetQuestionnairesByVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>(CutsheetQuestionnairesByVendorDocument, options);
        }
export type CutsheetQuestionnairesByVendorQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByVendorQuery>;
export type CutsheetQuestionnairesByVendorLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByVendorLazyQuery>;
export type CutsheetQuestionnairesByVendorQueryResult = Apollo.QueryResult<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>;
export const CutsheetCapabilitySpecificationManyDocument = gql`
    query CutsheetCapabilitySpecificationMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetSpecificationsByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
  ) {
    ...CutsheetCapabilitySpecificationFragment
  }
}
    ${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilitySpecificationManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilitySpecificationManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilitySpecificationManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>(CutsheetCapabilitySpecificationManyDocument, options);
      }
export function useCutsheetCapabilitySpecificationManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>(CutsheetCapabilitySpecificationManyDocument, options);
        }
export type CutsheetCapabilitySpecificationManyQueryHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationManyQuery>;
export type CutsheetCapabilitySpecificationManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationManyLazyQuery>;
export type CutsheetCapabilitySpecificationManyQueryResult = Apollo.QueryResult<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>;
export const CutsheetCapabilityTrimManyDocument = gql`
    query CutsheetCapabilityTrimMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetTrimByVendorAndAnimal(capabilityId: $capabilityId, isActive: $isActive) {
    ...CutsheetCapabilityTrimFragmentV2
  }
}
    ${CutsheetCapabilityTrimFragmentV2FragmentDoc}`;

/**
 * __useCutsheetCapabilityTrimManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityTrimManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityTrimManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityTrimManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityTrimManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>(CutsheetCapabilityTrimManyDocument, options);
      }
export function useCutsheetCapabilityTrimManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>(CutsheetCapabilityTrimManyDocument, options);
        }
export type CutsheetCapabilityTrimManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityTrimManyQuery>;
export type CutsheetCapabilityTrimManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityTrimManyLazyQuery>;
export type CutsheetCapabilityTrimManyQueryResult = Apollo.QueryResult<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>;
export const CutsheetDescriptionLibraryNamesDocument = gql`
    query CutsheetDescriptionLibraryNames($limit: Int) {
  cutsheetDescriptionLibrarySearch(limit: $limit) {
    _id
    name
  }
}
    `;

/**
 * __useCutsheetDescriptionLibraryNamesQuery__
 *
 * To run a query within a React component, call `useCutsheetDescriptionLibraryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibraryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetDescriptionLibraryNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCutsheetDescriptionLibraryNamesQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetDescriptionLibraryNamesQuery, CutsheetDescriptionLibraryNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetDescriptionLibraryNamesQuery, CutsheetDescriptionLibraryNamesQueryVariables>(CutsheetDescriptionLibraryNamesDocument, options);
      }
export function useCutsheetDescriptionLibraryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetDescriptionLibraryNamesQuery, CutsheetDescriptionLibraryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetDescriptionLibraryNamesQuery, CutsheetDescriptionLibraryNamesQueryVariables>(CutsheetDescriptionLibraryNamesDocument, options);
        }
export type CutsheetDescriptionLibraryNamesQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibraryNamesQuery>;
export type CutsheetDescriptionLibraryNamesLazyQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibraryNamesLazyQuery>;
export type CutsheetDescriptionLibraryNamesQueryResult = Apollo.QueryResult<CutsheetDescriptionLibraryNamesQuery, CutsheetDescriptionLibraryNamesQueryVariables>;
export const CutsheetImageLibraryNamesDocument = gql`
    query CutsheetImageLibraryNames($limit: Int) {
  cutsheetImageLibrarySearch(limit: $limit) {
    _id
    name
  }
}
    `;

/**
 * __useCutsheetImageLibraryNamesQuery__
 *
 * To run a query within a React component, call `useCutsheetImageLibraryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibraryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetImageLibraryNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCutsheetImageLibraryNamesQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetImageLibraryNamesQuery, CutsheetImageLibraryNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetImageLibraryNamesQuery, CutsheetImageLibraryNamesQueryVariables>(CutsheetImageLibraryNamesDocument, options);
      }
export function useCutsheetImageLibraryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetImageLibraryNamesQuery, CutsheetImageLibraryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetImageLibraryNamesQuery, CutsheetImageLibraryNamesQueryVariables>(CutsheetImageLibraryNamesDocument, options);
        }
export type CutsheetImageLibraryNamesQueryHookResult = ReturnType<typeof useCutsheetImageLibraryNamesQuery>;
export type CutsheetImageLibraryNamesLazyQueryHookResult = ReturnType<typeof useCutsheetImageLibraryNamesLazyQuery>;
export type CutsheetImageLibraryNamesQueryResult = Apollo.QueryResult<CutsheetImageLibraryNamesQuery, CutsheetImageLibraryNamesQueryVariables>;
export const CutsheetSearchDocument = gql`
    query CutsheetSearch($vendorId: MongoID, $buyerId: MongoID, $userId: MongoID, $type: [EnumCutsheetType], $includeDeleted: Boolean, $species: EnumCutsheetAnimalSpecies, $inspectionLevel: EnumCutsheetInspectionLevels, $splitType: String, $query: String, $sort: SortFindManyCutsheetInput!, $page: Int!, $perPage: Int!) {
  cutsheetSearch(
    vendorId: $vendorId
    buyerId: $buyerId
    userId: $userId
    type: $type
    includeDeleted: $includeDeleted
    species: $species
    inspectionLevel: $inspectionLevel
    splitType: $splitType
    query: $query
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    items {
      ...CutsheetFragment
      lastUsedDate
    }
    count
    pageInfo {
      currentPage
      perPage
      itemCount
      pageCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;

/**
 * __useCutsheetSearchQuery__
 *
 * To run a query within a React component, call `useCutsheetSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetSearchQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      includeDeleted: // value for 'includeDeleted'
 *      species: // value for 'species'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      splitType: // value for 'splitType'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetSearchQuery(baseOptions: Apollo.QueryHookOptions<CutsheetSearchQuery, CutsheetSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetSearchQuery, CutsheetSearchQueryVariables>(CutsheetSearchDocument, options);
      }
export function useCutsheetSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetSearchQuery, CutsheetSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetSearchQuery, CutsheetSearchQueryVariables>(CutsheetSearchDocument, options);
        }
export type CutsheetSearchQueryHookResult = ReturnType<typeof useCutsheetSearchQuery>;
export type CutsheetSearchLazyQueryHookResult = ReturnType<typeof useCutsheetSearchLazyQuery>;
export type CutsheetSearchQueryResult = Apollo.QueryResult<CutsheetSearchQuery, CutsheetSearchQueryVariables>;
export const CutsheetDescriptionLibraryManyDocument = gql`
    query CutsheetDescriptionLibraryMany($filter: FilterFindManyCutsheetDescriptionLibraryInput, $sort: SortFindManyCutsheetDescriptionLibraryInput, $limit: Int) {
  cutsheetDescriptionLibraryMany(filter: $filter, sort: $sort, limit: $limit) {
    ...CutsheetDescriptionLibraryFragment
  }
}
    ${CutsheetDescriptionLibraryFragmentFragmentDoc}`;

/**
 * __useCutsheetDescriptionLibraryManyQuery__
 *
 * To run a query within a React component, call `useCutsheetDescriptionLibraryManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibraryManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetDescriptionLibraryManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCutsheetDescriptionLibraryManyQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetDescriptionLibraryManyQuery, CutsheetDescriptionLibraryManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetDescriptionLibraryManyQuery, CutsheetDescriptionLibraryManyQueryVariables>(CutsheetDescriptionLibraryManyDocument, options);
      }
export function useCutsheetDescriptionLibraryManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetDescriptionLibraryManyQuery, CutsheetDescriptionLibraryManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetDescriptionLibraryManyQuery, CutsheetDescriptionLibraryManyQueryVariables>(CutsheetDescriptionLibraryManyDocument, options);
        }
export type CutsheetDescriptionLibraryManyQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibraryManyQuery>;
export type CutsheetDescriptionLibraryManyLazyQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibraryManyLazyQuery>;
export type CutsheetDescriptionLibraryManyQueryResult = Apollo.QueryResult<CutsheetDescriptionLibraryManyQuery, CutsheetDescriptionLibraryManyQueryVariables>;
export const CutsheetDescriptionLibrarySearchDocument = gql`
    query CutsheetDescriptionLibrarySearch($q: String, $tags: [String!], $limit: Int) {
  cutsheetDescriptionLibrarySearch(q: $q, tags: $tags, limit: $limit) {
    ...CutsheetDescriptionLibraryFragment
  }
}
    ${CutsheetDescriptionLibraryFragmentFragmentDoc}`;

/**
 * __useCutsheetDescriptionLibrarySearchQuery__
 *
 * To run a query within a React component, call `useCutsheetDescriptionLibrarySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibrarySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetDescriptionLibrarySearchQuery({
 *   variables: {
 *      q: // value for 'q'
 *      tags: // value for 'tags'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCutsheetDescriptionLibrarySearchQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetDescriptionLibrarySearchQuery, CutsheetDescriptionLibrarySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetDescriptionLibrarySearchQuery, CutsheetDescriptionLibrarySearchQueryVariables>(CutsheetDescriptionLibrarySearchDocument, options);
      }
export function useCutsheetDescriptionLibrarySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetDescriptionLibrarySearchQuery, CutsheetDescriptionLibrarySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetDescriptionLibrarySearchQuery, CutsheetDescriptionLibrarySearchQueryVariables>(CutsheetDescriptionLibrarySearchDocument, options);
        }
export type CutsheetDescriptionLibrarySearchQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibrarySearchQuery>;
export type CutsheetDescriptionLibrarySearchLazyQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibrarySearchLazyQuery>;
export type CutsheetDescriptionLibrarySearchQueryResult = Apollo.QueryResult<CutsheetDescriptionLibrarySearchQuery, CutsheetDescriptionLibrarySearchQueryVariables>;
export const CutsheetDescriptionLibraryTagsDocument = gql`
    query CutsheetDescriptionLibraryTags {
  cutsheetDescriptionLibraryTags
}
    `;

/**
 * __useCutsheetDescriptionLibraryTagsQuery__
 *
 * To run a query within a React component, call `useCutsheetDescriptionLibraryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetDescriptionLibraryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetDescriptionLibraryTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCutsheetDescriptionLibraryTagsQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetDescriptionLibraryTagsQuery, CutsheetDescriptionLibraryTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetDescriptionLibraryTagsQuery, CutsheetDescriptionLibraryTagsQueryVariables>(CutsheetDescriptionLibraryTagsDocument, options);
      }
export function useCutsheetDescriptionLibraryTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetDescriptionLibraryTagsQuery, CutsheetDescriptionLibraryTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetDescriptionLibraryTagsQuery, CutsheetDescriptionLibraryTagsQueryVariables>(CutsheetDescriptionLibraryTagsDocument, options);
        }
export type CutsheetDescriptionLibraryTagsQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibraryTagsQuery>;
export type CutsheetDescriptionLibraryTagsLazyQueryHookResult = ReturnType<typeof useCutsheetDescriptionLibraryTagsLazyQuery>;
export type CutsheetDescriptionLibraryTagsQueryResult = Apollo.QueryResult<CutsheetDescriptionLibraryTagsQuery, CutsheetDescriptionLibraryTagsQueryVariables>;
export const CutsheetImageLibraryManyDocument = gql`
    query CutsheetImageLibraryMany($filter: FilterFindManyCutsheetImageLibraryInput, $sort: SortFindManyCutsheetImageLibraryInput, $limit: Int) {
  cutsheetImageLibraryMany(filter: $filter, sort: $sort, limit: $limit) {
    ...CutsheetImageLibraryFragment
  }
}
    ${CutsheetImageLibraryFragmentFragmentDoc}`;

/**
 * __useCutsheetImageLibraryManyQuery__
 *
 * To run a query within a React component, call `useCutsheetImageLibraryManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibraryManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetImageLibraryManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCutsheetImageLibraryManyQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetImageLibraryManyQuery, CutsheetImageLibraryManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetImageLibraryManyQuery, CutsheetImageLibraryManyQueryVariables>(CutsheetImageLibraryManyDocument, options);
      }
export function useCutsheetImageLibraryManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetImageLibraryManyQuery, CutsheetImageLibraryManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetImageLibraryManyQuery, CutsheetImageLibraryManyQueryVariables>(CutsheetImageLibraryManyDocument, options);
        }
export type CutsheetImageLibraryManyQueryHookResult = ReturnType<typeof useCutsheetImageLibraryManyQuery>;
export type CutsheetImageLibraryManyLazyQueryHookResult = ReturnType<typeof useCutsheetImageLibraryManyLazyQuery>;
export type CutsheetImageLibraryManyQueryResult = Apollo.QueryResult<CutsheetImageLibraryManyQuery, CutsheetImageLibraryManyQueryVariables>;
export const CutsheetImageLibrarySearchDocument = gql`
    query CutsheetImageLibrarySearch($q: String, $tags: [String!], $limit: Int) {
  cutsheetImageLibrarySearch(q: $q, tags: $tags, limit: $limit) {
    ...CutsheetImageLibraryFragment
  }
}
    ${CutsheetImageLibraryFragmentFragmentDoc}`;

/**
 * __useCutsheetImageLibrarySearchQuery__
 *
 * To run a query within a React component, call `useCutsheetImageLibrarySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibrarySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetImageLibrarySearchQuery({
 *   variables: {
 *      q: // value for 'q'
 *      tags: // value for 'tags'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCutsheetImageLibrarySearchQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetImageLibrarySearchQuery, CutsheetImageLibrarySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetImageLibrarySearchQuery, CutsheetImageLibrarySearchQueryVariables>(CutsheetImageLibrarySearchDocument, options);
      }
export function useCutsheetImageLibrarySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetImageLibrarySearchQuery, CutsheetImageLibrarySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetImageLibrarySearchQuery, CutsheetImageLibrarySearchQueryVariables>(CutsheetImageLibrarySearchDocument, options);
        }
export type CutsheetImageLibrarySearchQueryHookResult = ReturnType<typeof useCutsheetImageLibrarySearchQuery>;
export type CutsheetImageLibrarySearchLazyQueryHookResult = ReturnType<typeof useCutsheetImageLibrarySearchLazyQuery>;
export type CutsheetImageLibrarySearchQueryResult = Apollo.QueryResult<CutsheetImageLibrarySearchQuery, CutsheetImageLibrarySearchQueryVariables>;
export const CutsheetImageLibraryTagsDocument = gql`
    query CutsheetImageLibraryTags {
  cutsheetImageLibraryTags
}
    `;

/**
 * __useCutsheetImageLibraryTagsQuery__
 *
 * To run a query within a React component, call `useCutsheetImageLibraryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetImageLibraryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetImageLibraryTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCutsheetImageLibraryTagsQuery(baseOptions?: Apollo.QueryHookOptions<CutsheetImageLibraryTagsQuery, CutsheetImageLibraryTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetImageLibraryTagsQuery, CutsheetImageLibraryTagsQueryVariables>(CutsheetImageLibraryTagsDocument, options);
      }
export function useCutsheetImageLibraryTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetImageLibraryTagsQuery, CutsheetImageLibraryTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetImageLibraryTagsQuery, CutsheetImageLibraryTagsQueryVariables>(CutsheetImageLibraryTagsDocument, options);
        }
export type CutsheetImageLibraryTagsQueryHookResult = ReturnType<typeof useCutsheetImageLibraryTagsQuery>;
export type CutsheetImageLibraryTagsLazyQueryHookResult = ReturnType<typeof useCutsheetImageLibraryTagsLazyQuery>;
export type CutsheetImageLibraryTagsQueryResult = Apollo.QueryResult<CutsheetImageLibraryTagsQuery, CutsheetImageLibraryTagsQueryVariables>;
export const CutsheetPaginationDocument = gql`
    query CutsheetPagination($sort: SortFindManyCutsheetInput!, $filter: FilterFindManyCutsheetInput!, $page: Int!, $perPage: Int!) {
  cutsheetPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...CutsheetFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;

/**
 * __useCutsheetPaginationQuery__
 *
 * To run a query within a React component, call `useCutsheetPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetPaginationQuery(baseOptions: Apollo.QueryHookOptions<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>(CutsheetPaginationDocument, options);
      }
export function useCutsheetPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>(CutsheetPaginationDocument, options);
        }
export type CutsheetPaginationQueryHookResult = ReturnType<typeof useCutsheetPaginationQuery>;
export type CutsheetPaginationLazyQueryHookResult = ReturnType<typeof useCutsheetPaginationLazyQuery>;
export type CutsheetPaginationQueryResult = Apollo.QueryResult<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>;
export const CutsheetSpecificationByIdsDocument = gql`
    query CutsheetSpecificationByIds($ids: [MongoID!]!) {
  cutsheetSpecificationByIds(_ids: $ids) {
    ...CutsheetCapabilitySpecificationFragment
  }
}
    ${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;

/**
 * __useCutsheetSpecificationByIdsQuery__
 *
 * To run a query within a React component, call `useCutsheetSpecificationByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSpecificationByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetSpecificationByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetSpecificationByIdsQuery(baseOptions: Apollo.QueryHookOptions<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>(CutsheetSpecificationByIdsDocument, options);
      }
export function useCutsheetSpecificationByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>(CutsheetSpecificationByIdsDocument, options);
        }
export type CutsheetSpecificationByIdsQueryHookResult = ReturnType<typeof useCutsheetSpecificationByIdsQuery>;
export type CutsheetSpecificationByIdsLazyQueryHookResult = ReturnType<typeof useCutsheetSpecificationByIdsLazyQuery>;
export type CutsheetSpecificationByIdsQueryResult = Apollo.QueryResult<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>;
export const DataImportJobStageDocument = gql`
    query DataImportJobStage($jobId: String!) {
  dataImportJobStatus(jobId: $jobId) {
    jobId
    status
  }
}
    `;

/**
 * __useDataImportJobStageQuery__
 *
 * To run a query within a React component, call `useDataImportJobStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportJobStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportJobStageQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportJobStageQuery(baseOptions: Apollo.QueryHookOptions<DataImportJobStageQuery, DataImportJobStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportJobStageQuery, DataImportJobStageQueryVariables>(DataImportJobStageDocument, options);
      }
export function useDataImportJobStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportJobStageQuery, DataImportJobStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportJobStageQuery, DataImportJobStageQueryVariables>(DataImportJobStageDocument, options);
        }
export type DataImportJobStageQueryHookResult = ReturnType<typeof useDataImportJobStageQuery>;
export type DataImportJobStageLazyQueryHookResult = ReturnType<typeof useDataImportJobStageLazyQuery>;
export type DataImportJobStageQueryResult = Apollo.QueryResult<DataImportJobStageQuery, DataImportJobStageQueryVariables>;
export const DataImportAnimalSettingsDocument = gql`
    query DataImportAnimalSettings($jobId: String!) {
  dataImportAnimalSettings(jobId: $jobId) {
    vendorId
    animalSettings {
      species
      isEnabled
      splitTypes
      inspectionLevels
    }
  }
}
    `;

/**
 * __useDataImportAnimalSettingsQuery__
 *
 * To run a query within a React component, call `useDataImportAnimalSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportAnimalSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportAnimalSettingsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportAnimalSettingsQuery(baseOptions: Apollo.QueryHookOptions<DataImportAnimalSettingsQuery, DataImportAnimalSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportAnimalSettingsQuery, DataImportAnimalSettingsQueryVariables>(DataImportAnimalSettingsDocument, options);
      }
export function useDataImportAnimalSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportAnimalSettingsQuery, DataImportAnimalSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportAnimalSettingsQuery, DataImportAnimalSettingsQueryVariables>(DataImportAnimalSettingsDocument, options);
        }
export type DataImportAnimalSettingsQueryHookResult = ReturnType<typeof useDataImportAnimalSettingsQuery>;
export type DataImportAnimalSettingsLazyQueryHookResult = ReturnType<typeof useDataImportAnimalSettingsLazyQuery>;
export type DataImportAnimalSettingsQueryResult = Apollo.QueryResult<DataImportAnimalSettingsQuery, DataImportAnimalSettingsQueryVariables>;
export const DataImportJobStatusDocument = gql`
    query DataImportJobStatus($jobId: String!) {
  dataImportJobStatus(jobId: $jobId) {
    jobId
    type
    status
    totalRows
    validRows
    invalidRows
    excludedRows
    processedCount
    successCount
    notImportedCount
    importedIdentityCount
    notImportedIdentityCount
    jobCount
    jobImportedCount
    jobNotImportedCount
    notImported {
      row
      error
    }
    s3Keys
    deletedRows
    validationErrors {
      row
      side
      errorMessages
      warningMessages
      excludedMessages
    }
    createdAt
    completedAt
  }
}
    `;

/**
 * __useDataImportJobStatusQuery__
 *
 * To run a query within a React component, call `useDataImportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportJobStatusQuery(baseOptions: Apollo.QueryHookOptions<DataImportJobStatusQuery, DataImportJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportJobStatusQuery, DataImportJobStatusQueryVariables>(DataImportJobStatusDocument, options);
      }
export function useDataImportJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportJobStatusQuery, DataImportJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportJobStatusQuery, DataImportJobStatusQueryVariables>(DataImportJobStatusDocument, options);
        }
export type DataImportJobStatusQueryHookResult = ReturnType<typeof useDataImportJobStatusQuery>;
export type DataImportJobStatusLazyQueryHookResult = ReturnType<typeof useDataImportJobStatusLazyQuery>;
export type DataImportJobStatusQueryResult = Apollo.QueryResult<DataImportJobStatusQuery, DataImportJobStatusQueryVariables>;
export const DataImportJobsDocument = gql`
    query DataImportJobs($tenantId: String!, $vendorId: String, $limit: Int, $skip: Int) {
  dataImportJobs(
    tenantId: $tenantId
    vendorId: $vendorId
    limit: $limit
    skip: $skip
  ) {
    jobs {
      jobId
      type
      status
      totalRows
      validRows
      invalidRows
      customerCount
      distinctIdentityCount
      importedIdentityCount
      notImportedIdentityCount
      processedCount
      successCount
      notImportedCount
      s3Keys
      createdAt
      completedAt
      cancelledAt
    }
    total
    hasMore
  }
}
    `;

/**
 * __useDataImportJobsQuery__
 *
 * To run a query within a React component, call `useDataImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportJobsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      vendorId: // value for 'vendorId'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useDataImportJobsQuery(baseOptions: Apollo.QueryHookOptions<DataImportJobsQuery, DataImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportJobsQuery, DataImportJobsQueryVariables>(DataImportJobsDocument, options);
      }
export function useDataImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportJobsQuery, DataImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportJobsQuery, DataImportJobsQueryVariables>(DataImportJobsDocument, options);
        }
export type DataImportJobsQueryHookResult = ReturnType<typeof useDataImportJobsQuery>;
export type DataImportJobsLazyQueryHookResult = ReturnType<typeof useDataImportJobsLazyQuery>;
export type DataImportJobsQueryResult = Apollo.QueryResult<DataImportJobsQuery, DataImportJobsQueryVariables>;
export const DataImportSessionDocument = gql`
    query DataImportSession($jobId: String!) {
  dataImportSession(jobId: $jobId) {
    jobId
    type
    stage
    vendorId
    totalRows
    validRows
    invalidRows
    customerCount
    detectedColumns
    suggestedMapping
    availableColumns {
      fieldName
      role
      baseField
      aliases
      required
      description
      validationRules
    }
    columns
    data
    validationErrors {
      row
      side
      errorMessages
      warningMessages
      excludedMessages
    }
    hygiene
  }
}
    `;

/**
 * __useDataImportSessionQuery__
 *
 * To run a query within a React component, call `useDataImportSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportSessionQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataImportSessionQuery(baseOptions: Apollo.QueryHookOptions<DataImportSessionQuery, DataImportSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportSessionQuery, DataImportSessionQueryVariables>(DataImportSessionDocument, options);
      }
export function useDataImportSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportSessionQuery, DataImportSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportSessionQuery, DataImportSessionQueryVariables>(DataImportSessionDocument, options);
        }
export type DataImportSessionQueryHookResult = ReturnType<typeof useDataImportSessionQuery>;
export type DataImportSessionLazyQueryHookResult = ReturnType<typeof useDataImportSessionLazyQuery>;
export type DataImportSessionQueryResult = Apollo.QueryResult<DataImportSessionQuery, DataImportSessionQueryVariables>;
export const DocumentAssignableEntitiesDocument = gql`
    query DocumentAssignableEntities($search: String, $limit: Int) {
  documentAssignableEntities(search: $search, limit: $limit) {
    type
    id
    label
    sublabel
  }
}
    `;

/**
 * __useDocumentAssignableEntitiesQuery__
 *
 * To run a query within a React component, call `useDocumentAssignableEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentAssignableEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentAssignableEntitiesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDocumentAssignableEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<DocumentAssignableEntitiesQuery, DocumentAssignableEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentAssignableEntitiesQuery, DocumentAssignableEntitiesQueryVariables>(DocumentAssignableEntitiesDocument, options);
      }
export function useDocumentAssignableEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentAssignableEntitiesQuery, DocumentAssignableEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentAssignableEntitiesQuery, DocumentAssignableEntitiesQueryVariables>(DocumentAssignableEntitiesDocument, options);
        }
export type DocumentAssignableEntitiesQueryHookResult = ReturnType<typeof useDocumentAssignableEntitiesQuery>;
export type DocumentAssignableEntitiesLazyQueryHookResult = ReturnType<typeof useDocumentAssignableEntitiesLazyQuery>;
export type DocumentAssignableEntitiesQueryResult = Apollo.QueryResult<DocumentAssignableEntitiesQuery, DocumentAssignableEntitiesQueryVariables>;
export const DocumentCategoriesForVendorDocument = gql`
    query DocumentCategoriesForVendor {
  documentCategoriesForVendor {
    _id
    name
    vendor
  }
}
    `;

/**
 * __useDocumentCategoriesForVendorQuery__
 *
 * To run a query within a React component, call `useDocumentCategoriesForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentCategoriesForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentCategoriesForVendorQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentCategoriesForVendorQuery(baseOptions?: Apollo.QueryHookOptions<DocumentCategoriesForVendorQuery, DocumentCategoriesForVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentCategoriesForVendorQuery, DocumentCategoriesForVendorQueryVariables>(DocumentCategoriesForVendorDocument, options);
      }
export function useDocumentCategoriesForVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentCategoriesForVendorQuery, DocumentCategoriesForVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentCategoriesForVendorQuery, DocumentCategoriesForVendorQueryVariables>(DocumentCategoriesForVendorDocument, options);
        }
export type DocumentCategoriesForVendorQueryHookResult = ReturnType<typeof useDocumentCategoriesForVendorQuery>;
export type DocumentCategoriesForVendorLazyQueryHookResult = ReturnType<typeof useDocumentCategoriesForVendorLazyQuery>;
export type DocumentCategoriesForVendorQueryResult = Apollo.QueryResult<DocumentCategoriesForVendorQuery, DocumentCategoriesForVendorQueryVariables>;
export const DocumentFolderDocument = gql`
    query DocumentFolder($facetOrder: [String!]!, $path: [String!], $search: String, $scopeEntityType: String, $scopeEntityId: MongoID, $includeGenerated: Boolean, $sort: EnumDocumentSearchSort, $page: Int!, $perPage: Int!) {
  documentFolder(
    facetOrder: $facetOrder
    path: $path
    search: $search
    scopeEntityType: $scopeEntityType
    scopeEntityId: $scopeEntityId
    includeGenerated: $includeGenerated
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    facet
    folders {
      facet
      value
      label
      sublabel
    }
    files {
      count
      items {
        ...DocumentFragment
        linkSummaries {
          entityType
          entityId
          label
          sublabel
        }
      }
      pageInfo {
        currentPage
        perPage
        pageCount
        itemCount
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${DocumentFragmentFragmentDoc}`;

/**
 * __useDocumentFolderQuery__
 *
 * To run a query within a React component, call `useDocumentFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentFolderQuery({
 *   variables: {
 *      facetOrder: // value for 'facetOrder'
 *      path: // value for 'path'
 *      search: // value for 'search'
 *      scopeEntityType: // value for 'scopeEntityType'
 *      scopeEntityId: // value for 'scopeEntityId'
 *      includeGenerated: // value for 'includeGenerated'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useDocumentFolderQuery(baseOptions: Apollo.QueryHookOptions<DocumentFolderQuery, DocumentFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentFolderQuery, DocumentFolderQueryVariables>(DocumentFolderDocument, options);
      }
export function useDocumentFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentFolderQuery, DocumentFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentFolderQuery, DocumentFolderQueryVariables>(DocumentFolderDocument, options);
        }
export type DocumentFolderQueryHookResult = ReturnType<typeof useDocumentFolderQuery>;
export type DocumentFolderLazyQueryHookResult = ReturnType<typeof useDocumentFolderLazyQuery>;
export type DocumentFolderQueryResult = Apollo.QueryResult<DocumentFolderQuery, DocumentFolderQueryVariables>;
export const DocumentSearchDocument = gql`
    query DocumentSearch($search: String, $categories: [String], $assignment: String, $includeGenerated: Boolean, $sort: EnumDocumentSearchSort, $page: Int!, $perPage: Int!) {
  documentSearch(
    search: $search
    categories: $categories
    assignment: $assignment
    includeGenerated: $includeGenerated
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...DocumentFragment
      linkSummaries {
        entityType
        entityId
        label
        sublabel
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${DocumentFragmentFragmentDoc}`;

/**
 * __useDocumentSearchQuery__
 *
 * To run a query within a React component, call `useDocumentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      categories: // value for 'categories'
 *      assignment: // value for 'assignment'
 *      includeGenerated: // value for 'includeGenerated'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useDocumentSearchQuery(baseOptions: Apollo.QueryHookOptions<DocumentSearchQuery, DocumentSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSearchQuery, DocumentSearchQueryVariables>(DocumentSearchDocument, options);
      }
export function useDocumentSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSearchQuery, DocumentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSearchQuery, DocumentSearchQueryVariables>(DocumentSearchDocument, options);
        }
export type DocumentSearchQueryHookResult = ReturnType<typeof useDocumentSearchQuery>;
export type DocumentSearchLazyQueryHookResult = ReturnType<typeof useDocumentSearchLazyQuery>;
export type DocumentSearchQueryResult = Apollo.QueryResult<DocumentSearchQuery, DocumentSearchQueryVariables>;
export const DocumentVersionUrlDocument = gql`
    query DocumentVersionUrl($documentId: MongoID!, $version: Int!) {
  documentVersionUrl(documentId: $documentId, version: $version)
}
    `;

/**
 * __useDocumentVersionUrlQuery__
 *
 * To run a query within a React component, call `useDocumentVersionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentVersionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentVersionUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDocumentVersionUrlQuery(baseOptions: Apollo.QueryHookOptions<DocumentVersionUrlQuery, DocumentVersionUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentVersionUrlQuery, DocumentVersionUrlQueryVariables>(DocumentVersionUrlDocument, options);
      }
export function useDocumentVersionUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentVersionUrlQuery, DocumentVersionUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentVersionUrlQuery, DocumentVersionUrlQueryVariables>(DocumentVersionUrlDocument, options);
        }
export type DocumentVersionUrlQueryHookResult = ReturnType<typeof useDocumentVersionUrlQuery>;
export type DocumentVersionUrlLazyQueryHookResult = ReturnType<typeof useDocumentVersionUrlLazyQuery>;
export type DocumentVersionUrlQueryResult = Apollo.QueryResult<DocumentVersionUrlQuery, DocumentVersionUrlQueryVariables>;
export const DocumentsForEntityDocument = gql`
    query DocumentsForEntity($entityType: EnumDocumentEntityType!, $entityId: MongoID!, $search: String, $includeGenerated: Boolean, $page: Int!, $perPage: Int!) {
  documentsForEntity(
    entityType: $entityType
    entityId: $entityId
    search: $search
    includeGenerated: $includeGenerated
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...DocumentFragment
      linkSummaries {
        entityType
        entityId
        label
        sublabel
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${DocumentFragmentFragmentDoc}`;

/**
 * __useDocumentsForEntityQuery__
 *
 * To run a query within a React component, call `useDocumentsForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsForEntityQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *      search: // value for 'search'
 *      includeGenerated: // value for 'includeGenerated'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useDocumentsForEntityQuery(baseOptions: Apollo.QueryHookOptions<DocumentsForEntityQuery, DocumentsForEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsForEntityQuery, DocumentsForEntityQueryVariables>(DocumentsForEntityDocument, options);
      }
export function useDocumentsForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsForEntityQuery, DocumentsForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsForEntityQuery, DocumentsForEntityQueryVariables>(DocumentsForEntityDocument, options);
        }
export type DocumentsForEntityQueryHookResult = ReturnType<typeof useDocumentsForEntityQuery>;
export type DocumentsForEntityLazyQueryHookResult = ReturnType<typeof useDocumentsForEntityLazyQuery>;
export type DocumentsForEntityQueryResult = Apollo.QueryResult<DocumentsForEntityQuery, DocumentsForEntityQueryVariables>;
export const ExportDeliveryDownloadUrlDocument = gql`
    query ExportDeliveryDownloadUrl($presetId: MongoID!, $token: String!) {
  exportDeliveryDownloadUrl(presetId: $presetId, token: $token)
}
    `;

/**
 * __useExportDeliveryDownloadUrlQuery__
 *
 * To run a query within a React component, call `useExportDeliveryDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDeliveryDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDeliveryDownloadUrlQuery({
 *   variables: {
 *      presetId: // value for 'presetId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useExportDeliveryDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<ExportDeliveryDownloadUrlQuery, ExportDeliveryDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDeliveryDownloadUrlQuery, ExportDeliveryDownloadUrlQueryVariables>(ExportDeliveryDownloadUrlDocument, options);
      }
export function useExportDeliveryDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDeliveryDownloadUrlQuery, ExportDeliveryDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDeliveryDownloadUrlQuery, ExportDeliveryDownloadUrlQueryVariables>(ExportDeliveryDownloadUrlDocument, options);
        }
export type ExportDeliveryDownloadUrlQueryHookResult = ReturnType<typeof useExportDeliveryDownloadUrlQuery>;
export type ExportDeliveryDownloadUrlLazyQueryHookResult = ReturnType<typeof useExportDeliveryDownloadUrlLazyQuery>;
export type ExportDeliveryDownloadUrlQueryResult = Apollo.QueryResult<ExportDeliveryDownloadUrlQuery, ExportDeliveryDownloadUrlQueryVariables>;
export const ExportPresetManyDocument = gql`
    query ExportPresetMany($filter: FilterFindManyExportPresetInput) {
  exportPresetMany(filter: $filter, sort: _ID_DESC) {
    _id
    name
    type
    anchorDate
    datePreset
    customStart
    customEnd
    animalSpecies
    inspectionLevel
    columns {
      key
      label
    }
    sort {
      key
      direction
    }
    filters {
      key
      operator
      value
    }
    filterMode
    schedule {
      enabled
      frequency
      dayOfWeek
      dayOfMonth
      hourUtc
      recipients
      lastRunAt
      nextRunAt
      lastRunStatus
      lastRunError
      lastRunRowCount
    }
  }
}
    `;

/**
 * __useExportPresetManyQuery__
 *
 * To run a query within a React component, call `useExportPresetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPresetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPresetManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportPresetManyQuery(baseOptions?: Apollo.QueryHookOptions<ExportPresetManyQuery, ExportPresetManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPresetManyQuery, ExportPresetManyQueryVariables>(ExportPresetManyDocument, options);
      }
export function useExportPresetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPresetManyQuery, ExportPresetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPresetManyQuery, ExportPresetManyQueryVariables>(ExportPresetManyDocument, options);
        }
export type ExportPresetManyQueryHookResult = ReturnType<typeof useExportPresetManyQuery>;
export type ExportPresetManyLazyQueryHookResult = ReturnType<typeof useExportPresetManyLazyQuery>;
export type ExportPresetManyQueryResult = Apollo.QueryResult<ExportPresetManyQuery, ExportPresetManyQueryVariables>;
export const ExportSettingOneDocument = gql`
    query ExportSettingOne($filter: FilterFindOneExportSettingInput) {
  exportSettingOne(filter: $filter) {
    _id
    quickbooksDesktop {
      arAccount
      incomeAccount
      depositAccount
      discountAccount
      adjustmentAccount
      defaultItem
    }
  }
}
    `;

/**
 * __useExportSettingOneQuery__
 *
 * To run a query within a React component, call `useExportSettingOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSettingOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSettingOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportSettingOneQuery(baseOptions?: Apollo.QueryHookOptions<ExportSettingOneQuery, ExportSettingOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSettingOneQuery, ExportSettingOneQueryVariables>(ExportSettingOneDocument, options);
      }
export function useExportSettingOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSettingOneQuery, ExportSettingOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSettingOneQuery, ExportSettingOneQueryVariables>(ExportSettingOneDocument, options);
        }
export type ExportSettingOneQueryHookResult = ReturnType<typeof useExportSettingOneQuery>;
export type ExportSettingOneLazyQueryHookResult = ReturnType<typeof useExportSettingOneLazyQuery>;
export type ExportSettingOneQueryResult = Apollo.QueryResult<ExportSettingOneQuery, ExportSettingOneQueryVariables>;
export const GameKioskAddressDocument = gql`
    query GameKioskAddress($vendor: MongoID!) {
  gameKioskAddress(vendor: $vendor) {
    kioskToken
    kioskUrl
    kioskShortUrl
  }
}
    `;

/**
 * __useGameKioskAddressQuery__
 *
 * To run a query within a React component, call `useGameKioskAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameKioskAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameKioskAddressQuery({
 *   variables: {
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useGameKioskAddressQuery(baseOptions: Apollo.QueryHookOptions<GameKioskAddressQuery, GameKioskAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameKioskAddressQuery, GameKioskAddressQueryVariables>(GameKioskAddressDocument, options);
      }
export function useGameKioskAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameKioskAddressQuery, GameKioskAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameKioskAddressQuery, GameKioskAddressQueryVariables>(GameKioskAddressDocument, options);
        }
export type GameKioskAddressQueryHookResult = ReturnType<typeof useGameKioskAddressQuery>;
export type GameKioskAddressLazyQueryHookResult = ReturnType<typeof useGameKioskAddressLazyQuery>;
export type GameKioskAddressQueryResult = Apollo.QueryResult<GameKioskAddressQuery, GameKioskAddressQueryVariables>;
export const GameKioskByTokenDocument = gql`
    query GameKioskByToken($token: String!) {
  gameKioskByToken(token: $token) {
    processorName
    processorSettings
    vendor
    species {
      species
      label
      inspectionLevels
      schedulingDeposit
      cutsheets {
        id
        name
        description
      }
    }
  }
}
    `;

/**
 * __useGameKioskByTokenQuery__
 *
 * To run a query within a React component, call `useGameKioskByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameKioskByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameKioskByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGameKioskByTokenQuery(baseOptions: Apollo.QueryHookOptions<GameKioskByTokenQuery, GameKioskByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameKioskByTokenQuery, GameKioskByTokenQueryVariables>(GameKioskByTokenDocument, options);
      }
export function useGameKioskByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameKioskByTokenQuery, GameKioskByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameKioskByTokenQuery, GameKioskByTokenQueryVariables>(GameKioskByTokenDocument, options);
        }
export type GameKioskByTokenQueryHookResult = ReturnType<typeof useGameKioskByTokenQuery>;
export type GameKioskByTokenLazyQueryHookResult = ReturnType<typeof useGameKioskByTokenLazyQuery>;
export type GameKioskByTokenQueryResult = Apollo.QueryResult<GameKioskByTokenQuery, GameKioskByTokenQueryVariables>;
export const GameKioskCutsheetDocument = gql`
    query GameKioskCutsheet($token: String!, $questionnaireId: MongoID!) {
  gameKioskCutsheet(token: $token, questionnaireId: $questionnaireId) {
    questionnaire {
      ...CutsheetQuestionnaireFragment
    }
    catalog {
      primals {
        ...CutsheetCapabilityGroupFragment
      }
      cuts {
        ...CutsheetCapabilityCutFragment
      }
      trim {
        ...CutsheetCapabilityTrimFragmentV2
      }
      extras {
        ...CutsheetCapabilityExtraFragment
      }
      specifications {
        ...CutsheetCapabilitySpecificationFragment
      }
    }
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}
${CutsheetCapabilityGroupFragmentFragmentDoc}
${CutsheetCapabilityCutFragmentFragmentDoc}
${CutsheetCapabilityTrimFragmentV2FragmentDoc}
${CutsheetCapabilityExtraFragmentFragmentDoc}
${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;

/**
 * __useGameKioskCutsheetQuery__
 *
 * To run a query within a React component, call `useGameKioskCutsheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameKioskCutsheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameKioskCutsheetQuery({
 *   variables: {
 *      token: // value for 'token'
 *      questionnaireId: // value for 'questionnaireId'
 *   },
 * });
 */
export function useGameKioskCutsheetQuery(baseOptions: Apollo.QueryHookOptions<GameKioskCutsheetQuery, GameKioskCutsheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameKioskCutsheetQuery, GameKioskCutsheetQueryVariables>(GameKioskCutsheetDocument, options);
      }
export function useGameKioskCutsheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameKioskCutsheetQuery, GameKioskCutsheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameKioskCutsheetQuery, GameKioskCutsheetQueryVariables>(GameKioskCutsheetDocument, options);
        }
export type GameKioskCutsheetQueryHookResult = ReturnType<typeof useGameKioskCutsheetQuery>;
export type GameKioskCutsheetLazyQueryHookResult = ReturnType<typeof useGameKioskCutsheetLazyQuery>;
export type GameKioskCutsheetQueryResult = Apollo.QueryResult<GameKioskCutsheetQuery, GameKioskCutsheetQueryVariables>;
export const GameKioskHunterCheckDocument = gql`
    query GameKioskHunterCheck($token: String!, $phone: String, $email: String) {
  gameKioskHunterCheck(token: $token, phone: $phone, email: $email)
}
    `;

/**
 * __useGameKioskHunterCheckQuery__
 *
 * To run a query within a React component, call `useGameKioskHunterCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameKioskHunterCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameKioskHunterCheckQuery({
 *   variables: {
 *      token: // value for 'token'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGameKioskHunterCheckQuery(baseOptions: Apollo.QueryHookOptions<GameKioskHunterCheckQuery, GameKioskHunterCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameKioskHunterCheckQuery, GameKioskHunterCheckQueryVariables>(GameKioskHunterCheckDocument, options);
      }
export function useGameKioskHunterCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameKioskHunterCheckQuery, GameKioskHunterCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameKioskHunterCheckQuery, GameKioskHunterCheckQueryVariables>(GameKioskHunterCheckDocument, options);
        }
export type GameKioskHunterCheckQueryHookResult = ReturnType<typeof useGameKioskHunterCheckQuery>;
export type GameKioskHunterCheckLazyQueryHookResult = ReturnType<typeof useGameKioskHunterCheckLazyQuery>;
export type GameKioskHunterCheckQueryResult = Apollo.QueryResult<GameKioskHunterCheckQuery, GameKioskHunterCheckQueryVariables>;
export const GeocodeLocationDocument = gql`
    query GeocodeLocation($query: String!) {
  geocodeLocation(query: $query) {
    lat
    lng
  }
}
    `;

/**
 * __useGeocodeLocationQuery__
 *
 * To run a query within a React component, call `useGeocodeLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeocodeLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeocodeLocationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGeocodeLocationQuery(baseOptions: Apollo.QueryHookOptions<GeocodeLocationQuery, GeocodeLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeocodeLocationQuery, GeocodeLocationQueryVariables>(GeocodeLocationDocument, options);
      }
export function useGeocodeLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeocodeLocationQuery, GeocodeLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeocodeLocationQuery, GeocodeLocationQueryVariables>(GeocodeLocationDocument, options);
        }
export type GeocodeLocationQueryHookResult = ReturnType<typeof useGeocodeLocationQuery>;
export type GeocodeLocationLazyQueryHookResult = ReturnType<typeof useGeocodeLocationLazyQuery>;
export type GeocodeLocationQueryResult = Apollo.QueryResult<GeocodeLocationQuery, GeocodeLocationQueryVariables>;
export const GetPublicHolidaysDocument = gql`
    query GetPublicHolidays($year: Int, $start: String, $end: String, $country: String, $lang: String) {
  getPublicHolidays(
    year: $year
    start: $start
    end: $end
    country: $country
    lang: $lang
  ) {
    holidays {
      name
      date
      type
      country
      lang
    }
    meta {
      country
      lang
      start
      end
      count
    }
  }
}
    `;

/**
 * __useGetPublicHolidaysQuery__
 *
 * To run a query within a React component, call `useGetPublicHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicHolidaysQuery({
 *   variables: {
 *      year: // value for 'year'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      country: // value for 'country'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetPublicHolidaysQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>(GetPublicHolidaysDocument, options);
      }
export function useGetPublicHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>(GetPublicHolidaysDocument, options);
        }
export type GetPublicHolidaysQueryHookResult = ReturnType<typeof useGetPublicHolidaysQuery>;
export type GetPublicHolidaysLazyQueryHookResult = ReturnType<typeof useGetPublicHolidaysLazyQuery>;
export type GetPublicHolidaysQueryResult = Apollo.QueryResult<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>;
export const GetAuditLogsDocument = gql`
    query GetAuditLogs($documentType: String, $documentId: MongoID, $targets: [AuditLogTargetInput], $page: Int, $perPage: Int) {
  getAuditLogs(
    documentType: $documentType
    documentId: $documentId
    targets: $targets
    page: $page
    perPage: $perPage
  ) {
    total
    logs {
      _id
      documentId
      documentType
      actorId
      actor {
        first_name
        last_name
        picture_url
      }
      createdAt
      updatedAt
      changes {
        path
        from
        to
      }
    }
  }
}
    `;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      documentId: // value for 'documentId'
 *      targets: // value for 'targets'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
      }
export function useGetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
export type GetAuditLogsQueryHookResult = ReturnType<typeof useGetAuditLogsQuery>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<typeof useGetAuditLogsLazyQuery>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetCustomerSummaryDetailsDocument = gql`
    query GetCustomerSummaryDetails($customerId: MongoID!, $vendorId: MongoID!) {
  getCustomerSummaryDetails(customerId: $customerId, vendorId: $vendorId) {
    jobSummary {
      inProgressCount
      needsApprovalCount
      completedCount
      cancelledCount
      firstJobDate
      lastJobDate
    }
    linkedProducer {
      _id
      first_name
      last_name
      email
      company
      phone
    }
    customerCount
  }
}
    `;

/**
 * __useGetCustomerSummaryDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerSummaryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSummaryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSummaryDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetCustomerSummaryDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>(GetCustomerSummaryDetailsDocument, options);
      }
export function useGetCustomerSummaryDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>(GetCustomerSummaryDetailsDocument, options);
        }
export type GetCustomerSummaryDetailsQueryHookResult = ReturnType<typeof useGetCustomerSummaryDetailsQuery>;
export type GetCustomerSummaryDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerSummaryDetailsLazyQuery>;
export type GetCustomerSummaryDetailsQueryResult = Apollo.QueryResult<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>;
export const GetRecurringSeriesListDocument = gql`
    query GetRecurringSeriesList($vendorId: MongoID!) {
  getRecurringSeriesList(vendorId: $vendorId) {
    _id
    active
    producerName
    nextOccurrence
    upcomingJobCount
    targetUpcomingCount
    rule {
      freq
      interval
      anchor
      timezone
      byDay {
        ordinal
        day
      }
      byMonthDay
      until
      count
    }
    jobTemplate {
      animalSpecies
      headCount
    }
  }
}
    `;

/**
 * __useGetRecurringSeriesListQuery__
 *
 * To run a query within a React component, call `useGetRecurringSeriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringSeriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringSeriesListQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetRecurringSeriesListQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringSeriesListQuery, GetRecurringSeriesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringSeriesListQuery, GetRecurringSeriesListQueryVariables>(GetRecurringSeriesListDocument, options);
      }
export function useGetRecurringSeriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringSeriesListQuery, GetRecurringSeriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringSeriesListQuery, GetRecurringSeriesListQueryVariables>(GetRecurringSeriesListDocument, options);
        }
export type GetRecurringSeriesListQueryHookResult = ReturnType<typeof useGetRecurringSeriesListQuery>;
export type GetRecurringSeriesListLazyQueryHookResult = ReturnType<typeof useGetRecurringSeriesListLazyQuery>;
export type GetRecurringSeriesListQueryResult = Apollo.QueryResult<GetRecurringSeriesListQuery, GetRecurringSeriesListQueryVariables>;
export const HerdAssignableJobsDocument = gql`
    query HerdAssignableJobs($producerId: MongoID, $species: String, $dropoffDateFrom: Date, $limit: Int) {
  vendorHerdAssignableJobs(
    producerId: $producerId
    species: $species
    dropoffDateFrom: $dropoffDateFrom
    limit: $limit
  ) {
    _id
    jobId
    animalSpecies
    dropoffDate
    headCount
    status
    requestedBy {
      _id
      first_name
      last_name
      company
    }
  }
}
    `;

/**
 * __useHerdAssignableJobsQuery__
 *
 * To run a query within a React component, call `useHerdAssignableJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHerdAssignableJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHerdAssignableJobsQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *      species: // value for 'species'
 *      dropoffDateFrom: // value for 'dropoffDateFrom'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHerdAssignableJobsQuery(baseOptions?: Apollo.QueryHookOptions<HerdAssignableJobsQuery, HerdAssignableJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HerdAssignableJobsQuery, HerdAssignableJobsQueryVariables>(HerdAssignableJobsDocument, options);
      }
export function useHerdAssignableJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HerdAssignableJobsQuery, HerdAssignableJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HerdAssignableJobsQuery, HerdAssignableJobsQueryVariables>(HerdAssignableJobsDocument, options);
        }
export type HerdAssignableJobsQueryHookResult = ReturnType<typeof useHerdAssignableJobsQuery>;
export type HerdAssignableJobsLazyQueryHookResult = ReturnType<typeof useHerdAssignableJobsLazyQuery>;
export type HerdAssignableJobsQueryResult = Apollo.QueryResult<HerdAssignableJobsQuery, HerdAssignableJobsQueryVariables>;
export const IntegrationAdaptersDocument = gql`
    query IntegrationAdapters($all: Boolean) {
  integrationAdapters(all: $all) {
    key
    label
    subscribes
    supportsInbound
    supportsPolling
    allowsMultiple
    configurableEvents
    supportsProducts
    configFields {
      key
      label
      type
      required
      help
      keyLabel
      valueLabel
      keys
      overrideToggleKey
      advanced
    }
    credentialFields {
      key
      label
      help
      placeholder
      required
      advanced
    }
  }
}
    `;

/**
 * __useIntegrationAdaptersQuery__
 *
 * To run a query within a React component, call `useIntegrationAdaptersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationAdaptersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationAdaptersQuery({
 *   variables: {
 *      all: // value for 'all'
 *   },
 * });
 */
export function useIntegrationAdaptersQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationAdaptersQuery, IntegrationAdaptersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationAdaptersQuery, IntegrationAdaptersQueryVariables>(IntegrationAdaptersDocument, options);
      }
export function useIntegrationAdaptersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationAdaptersQuery, IntegrationAdaptersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationAdaptersQuery, IntegrationAdaptersQueryVariables>(IntegrationAdaptersDocument, options);
        }
export type IntegrationAdaptersQueryHookResult = ReturnType<typeof useIntegrationAdaptersQuery>;
export type IntegrationAdaptersLazyQueryHookResult = ReturnType<typeof useIntegrationAdaptersLazyQuery>;
export type IntegrationAdaptersQueryResult = Apollo.QueryResult<IntegrationAdaptersQuery, IntegrationAdaptersQueryVariables>;
export const IntegrationDeliveriesDocument = gql`
    query IntegrationDeliveries($filter: FilterFindManyIntegrationDeliveryInput) {
  integrationDeliveryMany(filter: $filter, sort: _ID_DESC, limit: 50) {
    _id
    eventId
    type
    adapter
    integration
    subjectType
    subjectId
    status
    attempts
    lastError
    occurredAt
    deliveredAt
    createdAt
    cause {
      model
      changedPaths
    }
  }
}
    `;

/**
 * __useIntegrationDeliveriesQuery__
 *
 * To run a query within a React component, call `useIntegrationDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationDeliveriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationDeliveriesQuery, IntegrationDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationDeliveriesQuery, IntegrationDeliveriesQueryVariables>(IntegrationDeliveriesDocument, options);
      }
export function useIntegrationDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationDeliveriesQuery, IntegrationDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationDeliveriesQuery, IntegrationDeliveriesQueryVariables>(IntegrationDeliveriesDocument, options);
        }
export type IntegrationDeliveriesQueryHookResult = ReturnType<typeof useIntegrationDeliveriesQuery>;
export type IntegrationDeliveriesLazyQueryHookResult = ReturnType<typeof useIntegrationDeliveriesLazyQuery>;
export type IntegrationDeliveriesQueryResult = Apollo.QueryResult<IntegrationDeliveriesQuery, IntegrationDeliveriesQueryVariables>;
export const IntegrationDeliveriesBySubjectDocument = gql`
    query IntegrationDeliveriesBySubject($subjectId: MongoID!, $limit: Int) {
  integrationDeliveryMany(
    filter: {subjectType: job, subjectId: $subjectId}
    sort: _ID_DESC
    limit: $limit
  ) {
    _id
    eventId
    type
    adapter
    subjectType
    subjectId
    status
    attempts
    lastError
    occurredAt
    deliveredAt
    createdAt
    cause {
      model
      changedPaths
    }
  }
}
    `;

/**
 * __useIntegrationDeliveriesBySubjectQuery__
 *
 * To run a query within a React component, call `useIntegrationDeliveriesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDeliveriesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationDeliveriesBySubjectQuery({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIntegrationDeliveriesBySubjectQuery(baseOptions: Apollo.QueryHookOptions<IntegrationDeliveriesBySubjectQuery, IntegrationDeliveriesBySubjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationDeliveriesBySubjectQuery, IntegrationDeliveriesBySubjectQueryVariables>(IntegrationDeliveriesBySubjectDocument, options);
      }
export function useIntegrationDeliveriesBySubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationDeliveriesBySubjectQuery, IntegrationDeliveriesBySubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationDeliveriesBySubjectQuery, IntegrationDeliveriesBySubjectQueryVariables>(IntegrationDeliveriesBySubjectDocument, options);
        }
export type IntegrationDeliveriesBySubjectQueryHookResult = ReturnType<typeof useIntegrationDeliveriesBySubjectQuery>;
export type IntegrationDeliveriesBySubjectLazyQueryHookResult = ReturnType<typeof useIntegrationDeliveriesBySubjectLazyQuery>;
export type IntegrationDeliveriesBySubjectQueryResult = Apollo.QueryResult<IntegrationDeliveriesBySubjectQuery, IntegrationDeliveriesBySubjectQueryVariables>;
export const IntegrationDeliveryAttemptsDocument = gql`
    query IntegrationDeliveryAttempts($deliveryId: MongoID!) {
  integrationDeliveryAttemptMany(
    filter: {delivery: $deliveryId}
    sort: _ID_DESC
    limit: 20
  ) {
    _id
    attempt
    at
    outcome
    statusCode
    error
    durationMs
    exchanges {
      method
      url
      requestHeaders
      requestBody
      status
      responseBody
      error
      durationMs
      truncated
    }
  }
}
    `;

/**
 * __useIntegrationDeliveryAttemptsQuery__
 *
 * To run a query within a React component, call `useIntegrationDeliveryAttemptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDeliveryAttemptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationDeliveryAttemptsQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useIntegrationDeliveryAttemptsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationDeliveryAttemptsQuery, IntegrationDeliveryAttemptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationDeliveryAttemptsQuery, IntegrationDeliveryAttemptsQueryVariables>(IntegrationDeliveryAttemptsDocument, options);
      }
export function useIntegrationDeliveryAttemptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationDeliveryAttemptsQuery, IntegrationDeliveryAttemptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationDeliveryAttemptsQuery, IntegrationDeliveryAttemptsQueryVariables>(IntegrationDeliveryAttemptsDocument, options);
        }
export type IntegrationDeliveryAttemptsQueryHookResult = ReturnType<typeof useIntegrationDeliveryAttemptsQuery>;
export type IntegrationDeliveryAttemptsLazyQueryHookResult = ReturnType<typeof useIntegrationDeliveryAttemptsLazyQuery>;
export type IntegrationDeliveryAttemptsQueryResult = Apollo.QueryResult<IntegrationDeliveryAttemptsQuery, IntegrationDeliveryAttemptsQueryVariables>;
export const IntegrationInboundRecordsDocument = gql`
    query IntegrationInboundRecords($filter: FilterFindManyIntegrationInboundRecordInput) {
  integrationInboundRecordMany(filter: $filter, sort: _ID_DESC, limit: 50) {
    _id
    adapter
    kind
    weightLbs
    liveWeightLbs
    grade
    rawPayload
    yieldLines {
      label
      partnerLabel
      partnerSku
      weightLbs
      packageCount
    }
    status
    error
    externalRef
    receivedAt
    identifiers
    match {
      job
      animal
      split
      matchedOn
      matchedValue
    }
  }
}
    `;

/**
 * __useIntegrationInboundRecordsQuery__
 *
 * To run a query within a React component, call `useIntegrationInboundRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationInboundRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationInboundRecordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationInboundRecordsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationInboundRecordsQuery, IntegrationInboundRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationInboundRecordsQuery, IntegrationInboundRecordsQueryVariables>(IntegrationInboundRecordsDocument, options);
      }
export function useIntegrationInboundRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationInboundRecordsQuery, IntegrationInboundRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationInboundRecordsQuery, IntegrationInboundRecordsQueryVariables>(IntegrationInboundRecordsDocument, options);
        }
export type IntegrationInboundRecordsQueryHookResult = ReturnType<typeof useIntegrationInboundRecordsQuery>;
export type IntegrationInboundRecordsLazyQueryHookResult = ReturnType<typeof useIntegrationInboundRecordsLazyQuery>;
export type IntegrationInboundRecordsQueryResult = Apollo.QueryResult<IntegrationInboundRecordsQuery, IntegrationInboundRecordsQueryVariables>;
export const IntegrationOneDocument = gql`
    query IntegrationOne($filter: FilterFindOneIntegrationInput) {
  integrationOne(filter: $filter) {
    _id
    name
    config
  }
}
    `;

/**
 * __useIntegrationOneQuery__
 *
 * To run a query within a React component, call `useIntegrationOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationOneQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationOneQuery, IntegrationOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationOneQuery, IntegrationOneQueryVariables>(IntegrationOneDocument, options);
      }
export function useIntegrationOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationOneQuery, IntegrationOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationOneQuery, IntegrationOneQueryVariables>(IntegrationOneDocument, options);
        }
export type IntegrationOneQueryHookResult = ReturnType<typeof useIntegrationOneQuery>;
export type IntegrationOneLazyQueryHookResult = ReturnType<typeof useIntegrationOneLazyQuery>;
export type IntegrationOneQueryResult = Apollo.QueryResult<IntegrationOneQuery, IntegrationOneQueryVariables>;
export const IntegrationPartnerProductsDocument = gql`
    query IntegrationPartnerProducts($adapter: String!) {
  integrationPartnerProducts(adapter: $adapter) {
    supported
    error
    products {
      code
      name
      updatedAt
    }
  }
}
    `;

/**
 * __useIntegrationPartnerProductsQuery__
 *
 * To run a query within a React component, call `useIntegrationPartnerProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationPartnerProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationPartnerProductsQuery({
 *   variables: {
 *      adapter: // value for 'adapter'
 *   },
 * });
 */
export function useIntegrationPartnerProductsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationPartnerProductsQuery, IntegrationPartnerProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationPartnerProductsQuery, IntegrationPartnerProductsQueryVariables>(IntegrationPartnerProductsDocument, options);
      }
export function useIntegrationPartnerProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationPartnerProductsQuery, IntegrationPartnerProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationPartnerProductsQuery, IntegrationPartnerProductsQueryVariables>(IntegrationPartnerProductsDocument, options);
        }
export type IntegrationPartnerProductsQueryHookResult = ReturnType<typeof useIntegrationPartnerProductsQuery>;
export type IntegrationPartnerProductsLazyQueryHookResult = ReturnType<typeof useIntegrationPartnerProductsLazyQuery>;
export type IntegrationPartnerProductsQueryResult = Apollo.QueryResult<IntegrationPartnerProductsQuery, IntegrationPartnerProductsQueryVariables>;
export const InvoiceByIdDocument = gql`
    query invoiceById($id: MongoID!) {
  invoiceById(_id: $id) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

/**
 * __useInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<InvoiceByIdQuery, InvoiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceByIdQuery, InvoiceByIdQueryVariables>(InvoiceByIdDocument, options);
      }
export function useInvoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceByIdQuery, InvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceByIdQuery, InvoiceByIdQueryVariables>(InvoiceByIdDocument, options);
        }
export type InvoiceByIdQueryHookResult = ReturnType<typeof useInvoiceByIdQuery>;
export type InvoiceByIdLazyQueryHookResult = ReturnType<typeof useInvoiceByIdLazyQuery>;
export type InvoiceByIdQueryResult = Apollo.QueryResult<InvoiceByIdQuery, InvoiceByIdQueryVariables>;
export const SearchInvoicesDocument = gql`
    query SearchInvoices($type: String!, $sort: SortFindManyInvoiceInput!, $page: Int!, $perPage: Int!, $search: String, $status: [String!]) {
  searchInvoices(
    type: $type
    sort: $sort
    page: $page
    perPage: $perPage
    search: $search
    status: $status
  ) {
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    count
    items {
      ...InvoiceFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;

/**
 * __useSearchInvoicesQuery__
 *
 * To run a query within a React component, call `useSearchInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInvoicesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSearchInvoicesQuery(baseOptions: Apollo.QueryHookOptions<SearchInvoicesQuery, SearchInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInvoicesQuery, SearchInvoicesQueryVariables>(SearchInvoicesDocument, options);
      }
export function useSearchInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInvoicesQuery, SearchInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInvoicesQuery, SearchInvoicesQueryVariables>(SearchInvoicesDocument, options);
        }
export type SearchInvoicesQueryHookResult = ReturnType<typeof useSearchInvoicesQuery>;
export type SearchInvoicesLazyQueryHookResult = ReturnType<typeof useSearchInvoicesLazyQuery>;
export type SearchInvoicesQueryResult = Apollo.QueryResult<SearchInvoicesQuery, SearchInvoicesQueryVariables>;
export const JobRequesterDocument = gql`
    query JobRequester($id: MongoID!) {
  processorSchedulingById(_id: $id) {
    _id
    requestedBy {
      _id
    }
  }
}
    `;

/**
 * __useJobRequesterQuery__
 *
 * To run a query within a React component, call `useJobRequesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRequesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRequesterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobRequesterQuery(baseOptions: Apollo.QueryHookOptions<JobRequesterQuery, JobRequesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRequesterQuery, JobRequesterQueryVariables>(JobRequesterDocument, options);
      }
export function useJobRequesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRequesterQuery, JobRequesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRequesterQuery, JobRequesterQueryVariables>(JobRequesterDocument, options);
        }
export type JobRequesterQueryHookResult = ReturnType<typeof useJobRequesterQuery>;
export type JobRequesterLazyQueryHookResult = ReturnType<typeof useJobRequesterLazyQuery>;
export type JobRequesterQueryResult = Apollo.QueryResult<JobRequesterQuery, JobRequesterQueryVariables>;
export const JobManualNotificationOptionsDocument = gql`
    query JobManualNotificationOptions($jobId: MongoID!) {
  jobManualNotificationOptions(jobId: $jobId) {
    notificationSettingId
    eventType
    name
    trigger
    sendEmail
    sendSMS
    recipients {
      userId
      name
      email
      phone
      role
      defaultSelected
      reason
    }
  }
}
    `;

/**
 * __useJobManualNotificationOptionsQuery__
 *
 * To run a query within a React component, call `useJobManualNotificationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobManualNotificationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobManualNotificationOptionsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobManualNotificationOptionsQuery(baseOptions: Apollo.QueryHookOptions<JobManualNotificationOptionsQuery, JobManualNotificationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobManualNotificationOptionsQuery, JobManualNotificationOptionsQueryVariables>(JobManualNotificationOptionsDocument, options);
      }
export function useJobManualNotificationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobManualNotificationOptionsQuery, JobManualNotificationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobManualNotificationOptionsQuery, JobManualNotificationOptionsQueryVariables>(JobManualNotificationOptionsDocument, options);
        }
export type JobManualNotificationOptionsQueryHookResult = ReturnType<typeof useJobManualNotificationOptionsQuery>;
export type JobManualNotificationOptionsLazyQueryHookResult = ReturnType<typeof useJobManualNotificationOptionsLazyQuery>;
export type JobManualNotificationOptionsQueryResult = Apollo.QueryResult<JobManualNotificationOptionsQuery, JobManualNotificationOptionsQueryVariables>;
export const JobTagManyDocument = gql`
    query JobTagMany($filter: FilterFindManyJobTagInput, $sort: SortFindManyJobTagInput) {
  jobTagMany(filter: $filter, sort: $sort, limit: 500) {
    _id
    vendor
    name
    icon
    species
    isEnabled
    sortOrder
  }
}
    `;

/**
 * __useJobTagManyQuery__
 *
 * To run a query within a React component, call `useJobTagManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTagManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTagManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useJobTagManyQuery(baseOptions?: Apollo.QueryHookOptions<JobTagManyQuery, JobTagManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTagManyQuery, JobTagManyQueryVariables>(JobTagManyDocument, options);
      }
export function useJobTagManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTagManyQuery, JobTagManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTagManyQuery, JobTagManyQueryVariables>(JobTagManyDocument, options);
        }
export type JobTagManyQueryHookResult = ReturnType<typeof useJobTagManyQuery>;
export type JobTagManyLazyQueryHookResult = ReturnType<typeof useJobTagManyLazyQuery>;
export type JobTagManyQueryResult = Apollo.QueryResult<JobTagManyQuery, JobTagManyQueryVariables>;
export const LandingPageOneDocument = gql`
    query LandingPageOne($vendorId: MongoID!) {
  landingPageOne(vendorId: $vendorId) {
    ...LandingPageFragment
  }
}
    ${LandingPageFragmentFragmentDoc}`;

/**
 * __useLandingPageOneQuery__
 *
 * To run a query within a React component, call `useLandingPageOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageOneQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useLandingPageOneQuery(baseOptions: Apollo.QueryHookOptions<LandingPageOneQuery, LandingPageOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPageOneQuery, LandingPageOneQueryVariables>(LandingPageOneDocument, options);
      }
export function useLandingPageOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPageOneQuery, LandingPageOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPageOneQuery, LandingPageOneQueryVariables>(LandingPageOneDocument, options);
        }
export type LandingPageOneQueryHookResult = ReturnType<typeof useLandingPageOneQuery>;
export type LandingPageOneLazyQueryHookResult = ReturnType<typeof useLandingPageOneLazyQuery>;
export type LandingPageOneQueryResult = Apollo.QueryResult<LandingPageOneQuery, LandingPageOneQueryVariables>;
export const LandingPagePublicByIdDocument = gql`
    query LandingPagePublicById($_id: MongoID!) {
  landingPagePublicById(_id: $_id) {
    ...LandingPageFragment
  }
}
    ${LandingPageFragmentFragmentDoc}`;

/**
 * __useLandingPagePublicByIdQuery__
 *
 * To run a query within a React component, call `useLandingPagePublicByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPagePublicByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPagePublicByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLandingPagePublicByIdQuery(baseOptions: Apollo.QueryHookOptions<LandingPagePublicByIdQuery, LandingPagePublicByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPagePublicByIdQuery, LandingPagePublicByIdQueryVariables>(LandingPagePublicByIdDocument, options);
      }
export function useLandingPagePublicByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPagePublicByIdQuery, LandingPagePublicByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPagePublicByIdQuery, LandingPagePublicByIdQueryVariables>(LandingPagePublicByIdDocument, options);
        }
export type LandingPagePublicByIdQueryHookResult = ReturnType<typeof useLandingPagePublicByIdQuery>;
export type LandingPagePublicByIdLazyQueryHookResult = ReturnType<typeof useLandingPagePublicByIdLazyQuery>;
export type LandingPagePublicByIdQueryResult = Apollo.QueryResult<LandingPagePublicByIdQuery, LandingPagePublicByIdQueryVariables>;
export const LandingPagePublicBySlugDocument = gql`
    query LandingPagePublicBySlug($slug: String!) {
  landingPagePublicBySlug(slug: $slug) {
    ...LandingPageFragment
  }
}
    ${LandingPageFragmentFragmentDoc}`;

/**
 * __useLandingPagePublicBySlugQuery__
 *
 * To run a query within a React component, call `useLandingPagePublicBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPagePublicBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPagePublicBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLandingPagePublicBySlugQuery(baseOptions: Apollo.QueryHookOptions<LandingPagePublicBySlugQuery, LandingPagePublicBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPagePublicBySlugQuery, LandingPagePublicBySlugQueryVariables>(LandingPagePublicBySlugDocument, options);
      }
export function useLandingPagePublicBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPagePublicBySlugQuery, LandingPagePublicBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPagePublicBySlugQuery, LandingPagePublicBySlugQueryVariables>(LandingPagePublicBySlugDocument, options);
        }
export type LandingPagePublicBySlugQueryHookResult = ReturnType<typeof useLandingPagePublicBySlugQuery>;
export type LandingPagePublicBySlugLazyQueryHookResult = ReturnType<typeof useLandingPagePublicBySlugLazyQuery>;
export type LandingPagePublicBySlugQueryResult = Apollo.QueryResult<LandingPagePublicBySlugQuery, LandingPagePublicBySlugQueryVariables>;
export const MessagesByChatRoomDocument = gql`
    query MessagesByChatRoom($chatRoomId: MongoID!, $page: Int!, $perPage: Int!) {
  messagesByChatRoom(chatRoomId: $chatRoomId, page: $page, perPage: $perPage) {
    count
    items {
      ...ChatMessageFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ChatMessageFragmentFragmentDoc}`;

/**
 * __useMessagesByChatRoomQuery__
 *
 * To run a query within a React component, call `useMessagesByChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByChatRoomQuery({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMessagesByChatRoomQuery(baseOptions: Apollo.QueryHookOptions<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>(MessagesByChatRoomDocument, options);
      }
export function useMessagesByChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>(MessagesByChatRoomDocument, options);
        }
export type MessagesByChatRoomQueryHookResult = ReturnType<typeof useMessagesByChatRoomQuery>;
export type MessagesByChatRoomLazyQueryHookResult = ReturnType<typeof useMessagesByChatRoomLazyQuery>;
export type MessagesByChatRoomQueryResult = Apollo.QueryResult<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>;
export const MyInvoiceDocument = gql`
    query MyInvoice($id: MongoID!) {
  myInvoice(id: $id) {
    _id
    number
    description
    status
    type
    date_created
    due_date
    amount_due
    amount_paid
    amount_refunded
    settlement_recorded_at
    external_links {
      hostedInvoiceUrl
    }
    vendor {
      _id
      shop_name
    }
    line_items {
      _id
      description
      quantity
      amount
    }
    discounts {
      _id
      description
      applied_amount
    }
    links {
      entityType
      parentEntityId
    }
  }
}
    `;

/**
 * __useMyInvoiceQuery__
 *
 * To run a query within a React component, call `useMyInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyInvoiceQuery(baseOptions: Apollo.QueryHookOptions<MyInvoiceQuery, MyInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInvoiceQuery, MyInvoiceQueryVariables>(MyInvoiceDocument, options);
      }
export function useMyInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInvoiceQuery, MyInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInvoiceQuery, MyInvoiceQueryVariables>(MyInvoiceDocument, options);
        }
export type MyInvoiceQueryHookResult = ReturnType<typeof useMyInvoiceQuery>;
export type MyInvoiceLazyQueryHookResult = ReturnType<typeof useMyInvoiceLazyQuery>;
export type MyInvoiceQueryResult = Apollo.QueryResult<MyInvoiceQuery, MyInvoiceQueryVariables>;
export const MyAnimalsDocument = gql`
    query MyAnimals($scope: String, $search: String, $species: String, $upcoming: Boolean, $cutWithinDays: Int, $status: String, $saleProgress: String, $sort: String, $page: Int, $perPage: Int) {
  myAnimals(
    scope: $scope
    search: $search
    species: $species
    upcoming: $upcoming
    cutWithinDays: $cutWithinDays
    status: $status
    saleProgress: $saleProgress
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      _id
      species
      tracking
      publicId
      splitType
      producerIdentifier
      status
      job
      jobId
      liveWeight
      liveWeightHigh
      sex
      hangTimeDays
      isOverThirtyMonths
      descriptorChips
      producerDescription
      availableToBuyers
      allowedSectionSizes
      claimMode
      listedBy
      sizeTier
      listingRatePerLb
      listingTotalPrice
      listingDeposits {
        whole
        half
        quarter
      }
      killDate
      cutDate
      hangingWeight
      isHangingWeightPerSide
      hangingWeightSideA
      hangingWeightSideB
      remainingCapacity
      isFull
      vendorRef {
        _id
        shop_name
      }
      splits {
        _id
        splitPart
        kind
        status
        depositAmount
        depositOverrideState
        holdExpiresAt
        placementHoldAt
        lastNudgedAt
        lastNudgeKind
        locked
        buyer {
          _id
          first_name
          last_name
          company
        }
        questionnaireResponse {
          _id
        }
        cutsheet {
          _id
        }
        order {
          _id
          status
          finalAmount
          saleBaseAmount
          adjustments {
            label
            amount
          }
          balanceDue
          invoicedAt
          balancePaidAt
          depositRecipientParty
          settledOffPlatform
          listingFee
        }
      }
      createdAt
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useMyAnimalsQuery__
 *
 * To run a query within a React component, call `useMyAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAnimalsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      search: // value for 'search'
 *      species: // value for 'species'
 *      upcoming: // value for 'upcoming'
 *      cutWithinDays: // value for 'cutWithinDays'
 *      status: // value for 'status'
 *      saleProgress: // value for 'saleProgress'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyAnimalsQuery(baseOptions?: Apollo.QueryHookOptions<MyAnimalsQuery, MyAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAnimalsQuery, MyAnimalsQueryVariables>(MyAnimalsDocument, options);
      }
export function useMyAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAnimalsQuery, MyAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAnimalsQuery, MyAnimalsQueryVariables>(MyAnimalsDocument, options);
        }
export type MyAnimalsQueryHookResult = ReturnType<typeof useMyAnimalsQuery>;
export type MyAnimalsLazyQueryHookResult = ReturnType<typeof useMyAnimalsLazyQuery>;
export type MyAnimalsQueryResult = Apollo.QueryResult<MyAnimalsQuery, MyAnimalsQueryVariables>;
export const MyAnimalsStatsDocument = gql`
    query MyAnimalsStats {
  myAnimalsStats {
    total
    listed
    reserved
  }
}
    `;

/**
 * __useMyAnimalsStatsQuery__
 *
 * To run a query within a React component, call `useMyAnimalsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAnimalsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAnimalsStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAnimalsStatsQuery(baseOptions?: Apollo.QueryHookOptions<MyAnimalsStatsQuery, MyAnimalsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAnimalsStatsQuery, MyAnimalsStatsQueryVariables>(MyAnimalsStatsDocument, options);
      }
export function useMyAnimalsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAnimalsStatsQuery, MyAnimalsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAnimalsStatsQuery, MyAnimalsStatsQueryVariables>(MyAnimalsStatsDocument, options);
        }
export type MyAnimalsStatsQueryHookResult = ReturnType<typeof useMyAnimalsStatsQuery>;
export type MyAnimalsStatsLazyQueryHookResult = ReturnType<typeof useMyAnimalsStatsLazyQuery>;
export type MyAnimalsStatsQueryResult = Apollo.QueryResult<MyAnimalsStatsQuery, MyAnimalsStatsQueryVariables>;
export const MyChatRoomDocument = gql`
    query MyChatRoom($chatRoomId: MongoID!) {
  myChatRoom(chatRoomId: $chatRoomId) {
    ...ChatRoomFragment
  }
}
    ${ChatRoomFragmentFragmentDoc}`;

/**
 * __useMyChatRoomQuery__
 *
 * To run a query within a React component, call `useMyChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChatRoomQuery({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *   },
 * });
 */
export function useMyChatRoomQuery(baseOptions: Apollo.QueryHookOptions<MyChatRoomQuery, MyChatRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyChatRoomQuery, MyChatRoomQueryVariables>(MyChatRoomDocument, options);
      }
export function useMyChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyChatRoomQuery, MyChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyChatRoomQuery, MyChatRoomQueryVariables>(MyChatRoomDocument, options);
        }
export type MyChatRoomQueryHookResult = ReturnType<typeof useMyChatRoomQuery>;
export type MyChatRoomLazyQueryHookResult = ReturnType<typeof useMyChatRoomLazyQuery>;
export type MyChatRoomQueryResult = Apollo.QueryResult<MyChatRoomQuery, MyChatRoomQueryVariables>;
export const MyChatRoomUpdatesDocument = gql`
    query MyChatRoomUpdates($customerId: MongoID, $since: Date!) {
  myChatRoomUpdates(customerId: $customerId, since: $since) {
    ...ChatRoomFragment
  }
}
    ${ChatRoomFragmentFragmentDoc}`;

/**
 * __useMyChatRoomUpdatesQuery__
 *
 * To run a query within a React component, call `useMyChatRoomUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChatRoomUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChatRoomUpdatesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useMyChatRoomUpdatesQuery(baseOptions: Apollo.QueryHookOptions<MyChatRoomUpdatesQuery, MyChatRoomUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyChatRoomUpdatesQuery, MyChatRoomUpdatesQueryVariables>(MyChatRoomUpdatesDocument, options);
      }
export function useMyChatRoomUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyChatRoomUpdatesQuery, MyChatRoomUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyChatRoomUpdatesQuery, MyChatRoomUpdatesQueryVariables>(MyChatRoomUpdatesDocument, options);
        }
export type MyChatRoomUpdatesQueryHookResult = ReturnType<typeof useMyChatRoomUpdatesQuery>;
export type MyChatRoomUpdatesLazyQueryHookResult = ReturnType<typeof useMyChatRoomUpdatesLazyQuery>;
export type MyChatRoomUpdatesQueryResult = Apollo.QueryResult<MyChatRoomUpdatesQuery, MyChatRoomUpdatesQueryVariables>;
export const MyChatRoomsDocument = gql`
    query MyChatRooms($customerId: MongoID, $page: Int!, $perPage: Int!, $search: String) {
  myChatRooms(
    customerId: $customerId
    page: $page
    perPage: $perPage
    search: $search
  ) {
    count
    items {
      ...ChatRoomFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
  serverTime
}
    ${ChatRoomFragmentFragmentDoc}`;

/**
 * __useMyChatRoomsQuery__
 *
 * To run a query within a React component, call `useMyChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChatRoomsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMyChatRoomsQuery(baseOptions: Apollo.QueryHookOptions<MyChatRoomsQuery, MyChatRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyChatRoomsQuery, MyChatRoomsQueryVariables>(MyChatRoomsDocument, options);
      }
export function useMyChatRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyChatRoomsQuery, MyChatRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyChatRoomsQuery, MyChatRoomsQueryVariables>(MyChatRoomsDocument, options);
        }
export type MyChatRoomsQueryHookResult = ReturnType<typeof useMyChatRoomsQuery>;
export type MyChatRoomsLazyQueryHookResult = ReturnType<typeof useMyChatRoomsLazyQuery>;
export type MyChatRoomsQueryResult = Apollo.QueryResult<MyChatRoomsQuery, MyChatRoomsQueryVariables>;
export const MyInAppNotificationsDocument = gql`
    query MyInAppNotifications($limit: Int) {
  myInAppNotifications(limit: $limit) {
    unseenCount
    items {
      _id
      title
      body
      ctaUrl
      trigger
      type
      jobId
      promptText
      prompt {
        _id
        kind
        status
        canAnswer
        jobId
        expiresAt
      }
      seenAt
      createdAt
    }
  }
}
    `;

/**
 * __useMyInAppNotificationsQuery__
 *
 * To run a query within a React component, call `useMyInAppNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInAppNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInAppNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyInAppNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<MyInAppNotificationsQuery, MyInAppNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInAppNotificationsQuery, MyInAppNotificationsQueryVariables>(MyInAppNotificationsDocument, options);
      }
export function useMyInAppNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInAppNotificationsQuery, MyInAppNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInAppNotificationsQuery, MyInAppNotificationsQueryVariables>(MyInAppNotificationsDocument, options);
        }
export type MyInAppNotificationsQueryHookResult = ReturnType<typeof useMyInAppNotificationsQuery>;
export type MyInAppNotificationsLazyQueryHookResult = ReturnType<typeof useMyInAppNotificationsLazyQuery>;
export type MyInAppNotificationsQueryResult = Apollo.QueryResult<MyInAppNotificationsQuery, MyInAppNotificationsQueryVariables>;
export const MyInvoicesDocument = gql`
    query MyInvoices($openOnly: Boolean, $limit: Int) {
  myInvoices(openOnly: $openOnly, limit: $limit) {
    _id
    number
    description
    status
    type
    date_created
    due_date
    amount_due
    amount_paid
    amount_refunded
    external_links {
      hostedInvoiceUrl
    }
    vendor {
      _id
      shop_name
    }
  }
}
    `;

/**
 * __useMyInvoicesQuery__
 *
 * To run a query within a React component, call `useMyInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInvoicesQuery({
 *   variables: {
 *      openOnly: // value for 'openOnly'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInvoicesQuery, MyInvoicesQueryVariables>(MyInvoicesDocument, options);
      }
export function useMyInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInvoicesQuery, MyInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInvoicesQuery, MyInvoicesQueryVariables>(MyInvoicesDocument, options);
        }
export type MyInvoicesQueryHookResult = ReturnType<typeof useMyInvoicesQuery>;
export type MyInvoicesLazyQueryHookResult = ReturnType<typeof useMyInvoicesLazyQuery>;
export type MyInvoicesQueryResult = Apollo.QueryResult<MyInvoicesQuery, MyInvoicesQueryVariables>;
export const MyNotificationPreferencesDocument = gql`
    query MyNotificationPreferences {
  myNotificationPreferences {
    category
    label
    description
    email
    sms
  }
}
    `;

/**
 * __useMyNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useMyNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>(MyNotificationPreferencesDocument, options);
      }
export function useMyNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>(MyNotificationPreferencesDocument, options);
        }
export type MyNotificationPreferencesQueryHookResult = ReturnType<typeof useMyNotificationPreferencesQuery>;
export type MyNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useMyNotificationPreferencesLazyQuery>;
export type MyNotificationPreferencesQueryResult = Apollo.QueryResult<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>;
export const MyProcessorsDocument = gql`
    query myProcessors($vendorIds: [MongoID!]) {
  processingPartners(vendorIds: $vendorIds) {
    _id
    slug
    enabledAnimals
    isWaitlistFunctionalityDisabled
    vendor {
      _id
      shop_name
    }
  }
}
    `;

/**
 * __useMyProcessorsQuery__
 *
 * To run a query within a React component, call `useMyProcessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProcessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProcessorsQuery({
 *   variables: {
 *      vendorIds: // value for 'vendorIds'
 *   },
 * });
 */
export function useMyProcessorsQuery(baseOptions?: Apollo.QueryHookOptions<MyProcessorsQuery, MyProcessorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProcessorsQuery, MyProcessorsQueryVariables>(MyProcessorsDocument, options);
      }
export function useMyProcessorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProcessorsQuery, MyProcessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProcessorsQuery, MyProcessorsQueryVariables>(MyProcessorsDocument, options);
        }
export type MyProcessorsQueryHookResult = ReturnType<typeof useMyProcessorsQuery>;
export type MyProcessorsLazyQueryHookResult = ReturnType<typeof useMyProcessorsLazyQuery>;
export type MyProcessorsQueryResult = Apollo.QueryResult<MyProcessorsQuery, MyProcessorsQueryVariables>;
export const MyWaitlistDocument = gql`
    query MyWaitlist {
  myWaitlist {
    _id
    vendor
    animal
    startDate
    endDate
    sendWaitlistEmail
    sendWaitlistSMS
    createdAt
    status
    inspectionLevel
    headCount
    linkedJob {
      _id
      jobId
      status
    }
    vendorRef {
      _id
      shop_name
      shop_slug
    }
  }
}
    `;

/**
 * __useMyWaitlistQuery__
 *
 * To run a query within a React component, call `useMyWaitlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWaitlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWaitlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyWaitlistQuery(baseOptions?: Apollo.QueryHookOptions<MyWaitlistQuery, MyWaitlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyWaitlistQuery, MyWaitlistQueryVariables>(MyWaitlistDocument, options);
      }
export function useMyWaitlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWaitlistQuery, MyWaitlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyWaitlistQuery, MyWaitlistQueryVariables>(MyWaitlistDocument, options);
        }
export type MyWaitlistQueryHookResult = ReturnType<typeof useMyWaitlistQuery>;
export type MyWaitlistLazyQueryHookResult = ReturnType<typeof useMyWaitlistLazyQuery>;
export type MyWaitlistQueryResult = Apollo.QueryResult<MyWaitlistQuery, MyWaitlistQueryVariables>;
export const NavBadgeCountsDocument = gql`
    query NavBadgeCounts {
  navBadgeCounts {
    waitlist
    unreadChats
    requestedJobs
  }
}
    `;

/**
 * __useNavBadgeCountsQuery__
 *
 * To run a query within a React component, call `useNavBadgeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavBadgeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavBadgeCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavBadgeCountsQuery(baseOptions?: Apollo.QueryHookOptions<NavBadgeCountsQuery, NavBadgeCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavBadgeCountsQuery, NavBadgeCountsQueryVariables>(NavBadgeCountsDocument, options);
      }
export function useNavBadgeCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavBadgeCountsQuery, NavBadgeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavBadgeCountsQuery, NavBadgeCountsQueryVariables>(NavBadgeCountsDocument, options);
        }
export type NavBadgeCountsQueryHookResult = ReturnType<typeof useNavBadgeCountsQuery>;
export type NavBadgeCountsLazyQueryHookResult = ReturnType<typeof useNavBadgeCountsLazyQuery>;
export type NavBadgeCountsQueryResult = Apollo.QueryResult<NavBadgeCountsQuery, NavBadgeCountsQueryVariables>;
export const NotePaginationDocument = gql`
    query NotePagination($sort: SortFindManyNoteInput!, $filter: FilterFindManyNoteInput!, $page: Int!, $perPage: Int!) {
  notePagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...NoteFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useNotePaginationQuery__
 *
 * To run a query within a React component, call `useNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotePaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotePaginationQuery(baseOptions: Apollo.QueryHookOptions<NotePaginationQuery, NotePaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotePaginationQuery, NotePaginationQueryVariables>(NotePaginationDocument, options);
      }
export function useNotePaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotePaginationQuery, NotePaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotePaginationQuery, NotePaginationQueryVariables>(NotePaginationDocument, options);
        }
export type NotePaginationQueryHookResult = ReturnType<typeof useNotePaginationQuery>;
export type NotePaginationLazyQueryHookResult = ReturnType<typeof useNotePaginationLazyQuery>;
export type NotePaginationQueryResult = Apollo.QueryResult<NotePaginationQuery, NotePaginationQueryVariables>;
export const NotificationAuditSearchDocument = gql`
    query NotificationAuditSearch($vendorId: String, $jobId: String, $userId: String, $eventType: String, $trigger: String, $outcome: String, $source: String, $runId: String, $correlationId: String, $startDate: Date, $endDate: Date, $query: String, $page: Int, $perPage: Int) {
  notificationAuditSearch(
    vendorId: $vendorId
    jobId: $jobId
    userId: $userId
    eventType: $eventType
    trigger: $trigger
    outcome: $outcome
    source: $source
    runId: $runId
    correlationId: $correlationId
    startDate: $startDate
    endDate: $endDate
    query: $query
    page: $page
    perPage: $perPage
  ) {
    total
    page
    perPage
    pageCount
    hasNextPage
    hasPreviousPage
    outcomeCounts {
      outcome
      count
    }
    records {
      id
      timestamp
      runId
      correlationId
      eventType
      trigger
      notificationType
      source
      vendorId
      vendorName
      userId
      recipientName
      jobId
      outcome
      reason
      forced
      attempt
      channels {
        email {
          status
          reason
          sentTo
          provider {
            name
            messageId
            statusCode
            errorMessage
          }
        }
        sms {
          status
          reason
          sentTo
          provider {
            name
            messageId
            statusCode
            errorMessage
          }
        }
        chat {
          status
          reason
          sentTo
        }
        inApp {
          status
          reason
          sentTo
          provider {
            name
            messageId
            statusCode
            errorMessage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationAuditSearchQuery__
 *
 * To run a query within a React component, call `useNotificationAuditSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationAuditSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationAuditSearchQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      jobId: // value for 'jobId'
 *      userId: // value for 'userId'
 *      eventType: // value for 'eventType'
 *      trigger: // value for 'trigger'
 *      outcome: // value for 'outcome'
 *      source: // value for 'source'
 *      runId: // value for 'runId'
 *      correlationId: // value for 'correlationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationAuditSearchQuery(baseOptions?: Apollo.QueryHookOptions<NotificationAuditSearchQuery, NotificationAuditSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationAuditSearchQuery, NotificationAuditSearchQueryVariables>(NotificationAuditSearchDocument, options);
      }
export function useNotificationAuditSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationAuditSearchQuery, NotificationAuditSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationAuditSearchQuery, NotificationAuditSearchQueryVariables>(NotificationAuditSearchDocument, options);
        }
export type NotificationAuditSearchQueryHookResult = ReturnType<typeof useNotificationAuditSearchQuery>;
export type NotificationAuditSearchLazyQueryHookResult = ReturnType<typeof useNotificationAuditSearchLazyQuery>;
export type NotificationAuditSearchQueryResult = Apollo.QueryResult<NotificationAuditSearchQuery, NotificationAuditSearchQueryVariables>;
export const NotificationPromptByTokenDocument = gql`
    query NotificationPromptByToken($token: String!) {
  notificationPromptByToken(token: $token) {
    kind
    status
    expiredReason
    vendorName
    animalSpecies
    dropoffDate
    jobId
  }
}
    `;

/**
 * __useNotificationPromptByTokenQuery__
 *
 * To run a query within a React component, call `useNotificationPromptByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPromptByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPromptByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useNotificationPromptByTokenQuery(baseOptions: Apollo.QueryHookOptions<NotificationPromptByTokenQuery, NotificationPromptByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPromptByTokenQuery, NotificationPromptByTokenQueryVariables>(NotificationPromptByTokenDocument, options);
      }
export function useNotificationPromptByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPromptByTokenQuery, NotificationPromptByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPromptByTokenQuery, NotificationPromptByTokenQueryVariables>(NotificationPromptByTokenDocument, options);
        }
export type NotificationPromptByTokenQueryHookResult = ReturnType<typeof useNotificationPromptByTokenQuery>;
export type NotificationPromptByTokenLazyQueryHookResult = ReturnType<typeof useNotificationPromptByTokenLazyQuery>;
export type NotificationPromptByTokenQueryResult = Apollo.QueryResult<NotificationPromptByTokenQuery, NotificationPromptByTokenQueryVariables>;
export const NotificationSettingsByVendorIdDocument = gql`
    query NotificationSettingsByVendorId($vendorId: MongoID!, $page: Int!, $perPage: Int!) {
  findNotificationSettingsByVendorId(
    vendorId: $vendorId
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...NotificationSettingFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;

/**
 * __useNotificationSettingsByVendorIdQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationSettingsByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>(NotificationSettingsByVendorIdDocument, options);
      }
export function useNotificationSettingsByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>(NotificationSettingsByVendorIdDocument, options);
        }
export type NotificationSettingsByVendorIdQueryHookResult = ReturnType<typeof useNotificationSettingsByVendorIdQuery>;
export type NotificationSettingsByVendorIdLazyQueryHookResult = ReturnType<typeof useNotificationSettingsByVendorIdLazyQuery>;
export type NotificationSettingsByVendorIdQueryResult = Apollo.QueryResult<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>;
export const NotificationSettingsOneDocument = gql`
    query NotificationSettingsOne($filter: FilterFindOneNotificationSettingInput) {
  notificationSettingsOne(filter: $filter) {
    ...NotificationSettingFragment
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;

/**
 * __useNotificationSettingsOneQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationSettingsOneQuery(baseOptions?: Apollo.QueryHookOptions<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>(NotificationSettingsOneDocument, options);
      }
export function useNotificationSettingsOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>(NotificationSettingsOneDocument, options);
        }
export type NotificationSettingsOneQueryHookResult = ReturnType<typeof useNotificationSettingsOneQuery>;
export type NotificationSettingsOneLazyQueryHookResult = ReturnType<typeof useNotificationSettingsOneLazyQuery>;
export type NotificationSettingsOneQueryResult = Apollo.QueryResult<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>;
export const NotificationsByJobIdDocument = gql`
    query NotificationsByJobId($jobId: MongoID!, $page: Int!, $perPage: Int!) {
  findNotificationsByJobId(jobId: $jobId, page: $page, perPage: $perPage) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      notificationType
      type
      sentTo
      sentOn
      user {
        _id
        first_name
        last_name
        company
        email
        phone
      }
      errorMessage {
        message
        code
      }
    }
  }
}
    `;

/**
 * __useNotificationsByJobIdQuery__
 *
 * To run a query within a React component, call `useNotificationsByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationsByJobIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>(NotificationsByJobIdDocument, options);
      }
export function useNotificationsByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>(NotificationsByJobIdDocument, options);
        }
export type NotificationsByJobIdQueryHookResult = ReturnType<typeof useNotificationsByJobIdQuery>;
export type NotificationsByJobIdLazyQueryHookResult = ReturnType<typeof useNotificationsByJobIdLazyQuery>;
export type NotificationsByJobIdQueryResult = Apollo.QueryResult<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>;
export const NotificationsByUserIdDocument = gql`
    query NotificationsByUserId($userId: MongoID!, $vendorId: MongoID, $page: Int!, $perPage: Int!) {
  notificationPagination(
    filter: {vendorId: $vendorId, OR: [{userId: $userId}, {user: $userId}]}
    sort: _ID_DESC
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      notificationType
      type
      sentTo
      sentOn
      user {
        _id
        first_name
        last_name
        company
        email
        phone
      }
      errorMessage {
        message
        code
      }
    }
  }
}
    `;

/**
 * __useNotificationsByUserIdQuery__
 *
 * To run a query within a React component, call `useNotificationsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>(NotificationsByUserIdDocument, options);
      }
export function useNotificationsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>(NotificationsByUserIdDocument, options);
        }
export type NotificationsByUserIdQueryHookResult = ReturnType<typeof useNotificationsByUserIdQuery>;
export type NotificationsByUserIdLazyQueryHookResult = ReturnType<typeof useNotificationsByUserIdLazyQuery>;
export type NotificationsByUserIdQueryResult = Apollo.QueryResult<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>;
export const PartnerIntegrationsDocument = gql`
    query PartnerIntegrations {
  integrationMany(filter: {name: partner}) {
    _id
    adapter
    label
    enabled
    subscribedEvents
    autoPush
    autoPoll
    config
    endpoint
    inboundUrl
    inbound {
      enabled
      tokenHint
      issuedAt
      weightMode
    }
    lastDeliveryAt
    lastErrorAt
    lastError
  }
}
    `;

/**
 * __usePartnerIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<PartnerIntegrationsQuery, PartnerIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerIntegrationsQuery, PartnerIntegrationsQueryVariables>(PartnerIntegrationsDocument, options);
      }
export function usePartnerIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerIntegrationsQuery, PartnerIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerIntegrationsQuery, PartnerIntegrationsQueryVariables>(PartnerIntegrationsDocument, options);
        }
export type PartnerIntegrationsQueryHookResult = ReturnType<typeof usePartnerIntegrationsQuery>;
export type PartnerIntegrationsLazyQueryHookResult = ReturnType<typeof usePartnerIntegrationsLazyQuery>;
export type PartnerIntegrationsQueryResult = Apollo.QueryResult<PartnerIntegrationsQuery, PartnerIntegrationsQueryVariables>;
export const PickupLocationListDocument = gql`
    query PickupLocationList($includeInactive: Boolean) {
  pickupLocationList(includeInactive: $includeInactive) {
    _id
    name
    description
    active
    isDefault
    sortOrder
    address {
      address_1
      address_2
      city
      state
      postcode
      country
    }
  }
}
    `;

/**
 * __usePickupLocationListQuery__
 *
 * To run a query within a React component, call `usePickupLocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickupLocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickupLocationListQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function usePickupLocationListQuery(baseOptions?: Apollo.QueryHookOptions<PickupLocationListQuery, PickupLocationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickupLocationListQuery, PickupLocationListQueryVariables>(PickupLocationListDocument, options);
      }
export function usePickupLocationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickupLocationListQuery, PickupLocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickupLocationListQuery, PickupLocationListQueryVariables>(PickupLocationListDocument, options);
        }
export type PickupLocationListQueryHookResult = ReturnType<typeof usePickupLocationListQuery>;
export type PickupLocationListLazyQueryHookResult = ReturnType<typeof usePickupLocationListLazyQuery>;
export type PickupLocationListQueryResult = Apollo.QueryResult<PickupLocationListQuery, PickupLocationListQueryVariables>;
export const PrimalCutBlockerManyDocument = gql`
    query PrimalCutBlockerMany($filter: FilterFindManyPrimalCutBlockerInput!, $skip: Int, $limit: Int) {
  primalCutBlockerMany(filter: $filter, skip: $skip, limit: $limit) {
    ...PrimalCutBlockerFragment
  }
}
    ${PrimalCutBlockerFragmentFragmentDoc}`;

/**
 * __usePrimalCutBlockerManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutBlockerManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutBlockerManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutBlockerManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePrimalCutBlockerManyQuery(baseOptions: Apollo.QueryHookOptions<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>(PrimalCutBlockerManyDocument, options);
      }
export function usePrimalCutBlockerManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>(PrimalCutBlockerManyDocument, options);
        }
export type PrimalCutBlockerManyQueryHookResult = ReturnType<typeof usePrimalCutBlockerManyQuery>;
export type PrimalCutBlockerManyLazyQueryHookResult = ReturnType<typeof usePrimalCutBlockerManyLazyQuery>;
export type PrimalCutBlockerManyQueryResult = Apollo.QueryResult<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>;
export const PrimalCutManyDocument = gql`
    query PrimalCutMany($filter: FilterFindManyPrimalCutInput) {
  primalCutMany(filter: $filter) {
    name
    cutType {
      name
      _id
    }
    order
    _id
    isDeleted
    primal {
      name
      order
      _id
      group {
        processorSettings
        isDefault
        animalSpecies
        inspectionLevel
        name
        order
        _id
      }
    }
  }
}
    `;

/**
 * __usePrimalCutManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrimalCutManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalCutManyQuery, PrimalCutManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutManyQuery, PrimalCutManyQueryVariables>(PrimalCutManyDocument, options);
      }
export function usePrimalCutManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutManyQuery, PrimalCutManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutManyQuery, PrimalCutManyQueryVariables>(PrimalCutManyDocument, options);
        }
export type PrimalCutManyQueryHookResult = ReturnType<typeof usePrimalCutManyQuery>;
export type PrimalCutManyLazyQueryHookResult = ReturnType<typeof usePrimalCutManyLazyQuery>;
export type PrimalCutManyQueryResult = Apollo.QueryResult<PrimalCutManyQuery, PrimalCutManyQueryVariables>;
export const PrimalCutTypeManyDocument = gql`
    query PrimalCutTypeMany($filter: FilterFindManyPrimalCutTypeInput, $skip: Int, $limit: Int) {
  primalCutTypeMany(filter: $filter, skip: $skip, limit: $limit) {
    _id
    name
    isDeleted
    animalSpecies
    processorSettings
  }
}
    `;

/**
 * __usePrimalCutTypeManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutTypeManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutTypeManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutTypeManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePrimalCutTypeManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>(PrimalCutTypeManyDocument, options);
      }
export function usePrimalCutTypeManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>(PrimalCutTypeManyDocument, options);
        }
export type PrimalCutTypeManyQueryHookResult = ReturnType<typeof usePrimalCutTypeManyQuery>;
export type PrimalCutTypeManyLazyQueryHookResult = ReturnType<typeof usePrimalCutTypeManyLazyQuery>;
export type PrimalCutTypeManyQueryResult = Apollo.QueryResult<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>;
export const PrimalGroupManyDocument = gql`
    query PrimalGroupMany($filter: FilterFindManyPrimalGroupInput, $sort: SortFindManyPrimalGroupInput) {
  primalGroupMany(filter: $filter, sort: $sort) {
    processorSettings
    isDefault
    animalSpecies
    inspectionLevel
    name
    order
    isDeleted
    primals {
      isDeleted
      cuts {
        isDeleted
        name
        description
        cutType {
          name
          _id
        }
        order
        _id
      }
      order
      name
      description
      _id
    }
    _id
  }
}
    `;

/**
 * __usePrimalGroupManyQuery__
 *
 * To run a query within a React component, call `usePrimalGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalGroupManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePrimalGroupManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>(PrimalGroupManyDocument, options);
      }
export function usePrimalGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>(PrimalGroupManyDocument, options);
        }
export type PrimalGroupManyQueryHookResult = ReturnType<typeof usePrimalGroupManyQuery>;
export type PrimalGroupManyLazyQueryHookResult = ReturnType<typeof usePrimalGroupManyLazyQuery>;
export type PrimalGroupManyQueryResult = Apollo.QueryResult<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>;
export const ProcessingPartnersDocument = gql`
    query processingPartners($state: String, $lat: Float, $lng: Float, $maxDistanceMiles: Int, $species: [String], $buyerMarketplaceOnly: Boolean) {
  processingPartners(
    state: $state
    lat: $lat
    lng: $lng
    maxDistanceMiles: $maxDistanceMiles
    species: $species
    buyerMarketplaceOnly: $buyerMarketplaceOnly
  ) {
    _id
    isEnabled
    enabledAnimals
    openSplitCount
    landingPage {
      _id
      name
      slug
      tagline
      logoUrl
      boxImageUrl
      address {
        address_1
        city
        state
        postcode
      }
      contact {
        email
        phone
        website
      }
      location {
        coordinates
      }
    }
    vendor {
      _id
      shop_name
      address {
        city
        state
      }
      tenant {
        name
        picture_url
      }
    }
    slug
  }
}
    `;

/**
 * __useProcessingPartnersQuery__
 *
 * To run a query within a React component, call `useProcessingPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingPartnersQuery({
 *   variables: {
 *      state: // value for 'state'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      maxDistanceMiles: // value for 'maxDistanceMiles'
 *      species: // value for 'species'
 *      buyerMarketplaceOnly: // value for 'buyerMarketplaceOnly'
 *   },
 * });
 */
export function useProcessingPartnersQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>(ProcessingPartnersDocument, options);
      }
export function useProcessingPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>(ProcessingPartnersDocument, options);
        }
export type ProcessingPartnersQueryHookResult = ReturnType<typeof useProcessingPartnersQuery>;
export type ProcessingPartnersLazyQueryHookResult = ReturnType<typeof useProcessingPartnersLazyQuery>;
export type ProcessingPartnersQueryResult = Apollo.QueryResult<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>;
export const ProcessorCustomerByIdDocument = gql`
    query ProcessorCustomerById($id: MongoID!) {
  userById(_id: $id) {
    first_name
    last_name
    email
    phone
    enabled
    company
    _id
    relationships {
      type
      vendorId
      producerId
      source
    }
    address {
      address_1
      address_2
      city
      state
      postcode
      country
    }
    settings {
      hangTimePreferences {
        vendorId
        species
        preferredDays
      }
    }
  }
}
    `;

/**
 * __useProcessorCustomerByIdQuery__
 *
 * To run a query within a React component, call `useProcessorCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorCustomerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessorCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>(ProcessorCustomerByIdDocument, options);
      }
export function useProcessorCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>(ProcessorCustomerByIdDocument, options);
        }
export type ProcessorCustomerByIdQueryHookResult = ReturnType<typeof useProcessorCustomerByIdQuery>;
export type ProcessorCustomerByIdLazyQueryHookResult = ReturnType<typeof useProcessorCustomerByIdLazyQuery>;
export type ProcessorCustomerByIdQueryResult = Apollo.QueryResult<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>;
export const ProcessorCustomersPaginationDocument = gql`
    query processorCustomersPagination($page: Int!, $perPage: Int!, $search: String, $sort: SortFindManyUserInput!, $vendorId: MongoID!, $producerId: MongoID, $relationshipType: String, $status: String, $latestDropoffDateFrom: Date, $latestDropoffDateTo: Date, $rebookingStatuses: [String!], $latestDropoffSort: String) {
  getProcessorCustomers(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    vendorId: $vendorId
    producerId: $producerId
    relationshipType: $relationshipType
    status: $status
    latestDropoffDateFrom: $latestDropoffDateFrom
    latestDropoffDateTo: $latestDropoffDateTo
    rebookingStatuses: $rebookingStatuses
    latestDropoffSort: $latestDropoffSort
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      first_name
      last_name
      email
      phone
      company
      _id
      address {
        address_1
        address_2
        city
        state
        postcode
      }
      relationships {
        vendorId
        producerId
        type
      }
      status
      latestDropoffDate
      rebookingStatus
      rebookingIntervalSource
    }
  }
}
    `;

/**
 * __useProcessorCustomersPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorCustomersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorCustomersPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorCustomersPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *      producerId: // value for 'producerId'
 *      relationshipType: // value for 'relationshipType'
 *      status: // value for 'status'
 *      latestDropoffDateFrom: // value for 'latestDropoffDateFrom'
 *      latestDropoffDateTo: // value for 'latestDropoffDateTo'
 *      rebookingStatuses: // value for 'rebookingStatuses'
 *      latestDropoffSort: // value for 'latestDropoffSort'
 *   },
 * });
 */
export function useProcessorCustomersPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>(ProcessorCustomersPaginationDocument, options);
      }
export function useProcessorCustomersPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>(ProcessorCustomersPaginationDocument, options);
        }
export type ProcessorCustomersPaginationQueryHookResult = ReturnType<typeof useProcessorCustomersPaginationQuery>;
export type ProcessorCustomersPaginationLazyQueryHookResult = ReturnType<typeof useProcessorCustomersPaginationLazyQuery>;
export type ProcessorCustomersPaginationQueryResult = Apollo.QueryResult<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>;
export const ProcessorExportPreviewDocument = gql`
    query ProcessorExportPreview($vendorId: MongoID!, $type: ProcessorExportTypeEnum!, $startDate: String!, $endDate: String!, $animalSpecies: String, $inspectionLevel: String, $anchorDate: String, $columns: [ExportColumnInput], $sort: [ExportSortInput], $filters: [ExportFilterInput], $filterMode: String, $sampleColumns: Boolean, $limit: Int) {
  processorExportPreview(
    vendorId: $vendorId
    type: $type
    startDate: $startDate
    endDate: $endDate
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    anchorDate: $anchorDate
    columns: $columns
    sort: $sort
    filters: $filters
    filterMode: $filterMode
    sampleColumns: $sampleColumns
    limit: $limit
  )
}
    `;

/**
 * __useProcessorExportPreviewQuery__
 *
 * To run a query within a React component, call `useProcessorExportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorExportPreviewQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      type: // value for 'type'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      anchorDate: // value for 'anchorDate'
 *      columns: // value for 'columns'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      filterMode: // value for 'filterMode'
 *      sampleColumns: // value for 'sampleColumns'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProcessorExportPreviewQuery(baseOptions: Apollo.QueryHookOptions<ProcessorExportPreviewQuery, ProcessorExportPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorExportPreviewQuery, ProcessorExportPreviewQueryVariables>(ProcessorExportPreviewDocument, options);
      }
export function useProcessorExportPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorExportPreviewQuery, ProcessorExportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorExportPreviewQuery, ProcessorExportPreviewQueryVariables>(ProcessorExportPreviewDocument, options);
        }
export type ProcessorExportPreviewQueryHookResult = ReturnType<typeof useProcessorExportPreviewQuery>;
export type ProcessorExportPreviewLazyQueryHookResult = ReturnType<typeof useProcessorExportPreviewLazyQuery>;
export type ProcessorExportPreviewQueryResult = Apollo.QueryResult<ProcessorExportPreviewQuery, ProcessorExportPreviewQueryVariables>;
export const ProcessorNotificationPaginationDocument = gql`
    query processorNotificationPagination($sort: SortFindManyProcessorNotificationInput!, $filter: FilterFindManyProcessorNotificationInput!, $page: Int!, $perPage: Int!) {
  processorNotificationPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      vendor
      notificationType
      type
      sentTo
      sentOn
      errorMessage
    }
  }
}
    `;

/**
 * __useProcessorNotificationPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorNotificationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorNotificationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorNotificationPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorNotificationPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>(ProcessorNotificationPaginationDocument, options);
      }
export function useProcessorNotificationPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>(ProcessorNotificationPaginationDocument, options);
        }
export type ProcessorNotificationPaginationQueryHookResult = ReturnType<typeof useProcessorNotificationPaginationQuery>;
export type ProcessorNotificationPaginationLazyQueryHookResult = ReturnType<typeof useProcessorNotificationPaginationLazyQuery>;
export type ProcessorNotificationPaginationQueryResult = Apollo.QueryResult<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>;
export const ProcessorOfferedSplitsDocument = gql`
    query ProcessorOfferedSplits($slug: String!) {
  processorOfferedSplits(slug: $slug) {
    species
    splitTypes
  }
}
    `;

/**
 * __useProcessorOfferedSplitsQuery__
 *
 * To run a query within a React component, call `useProcessorOfferedSplitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorOfferedSplitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorOfferedSplitsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProcessorOfferedSplitsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorOfferedSplitsQuery, ProcessorOfferedSplitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorOfferedSplitsQuery, ProcessorOfferedSplitsQueryVariables>(ProcessorOfferedSplitsDocument, options);
      }
export function useProcessorOfferedSplitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorOfferedSplitsQuery, ProcessorOfferedSplitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorOfferedSplitsQuery, ProcessorOfferedSplitsQueryVariables>(ProcessorOfferedSplitsDocument, options);
        }
export type ProcessorOfferedSplitsQueryHookResult = ReturnType<typeof useProcessorOfferedSplitsQuery>;
export type ProcessorOfferedSplitsLazyQueryHookResult = ReturnType<typeof useProcessorOfferedSplitsLazyQuery>;
export type ProcessorOfferedSplitsQueryResult = Apollo.QueryResult<ProcessorOfferedSplitsQuery, ProcessorOfferedSplitsQueryVariables>;
export const ProcessorSchedulingByIdDocument = gql`
    query ProcessorSchedulingById($id: MongoID!, $includeSplits: Boolean = false) {
  processorSchedulingById(_id: $id) {
    vendor {
      shop_name
      address {
        first_name
        last_name
        address_1
        address_2
        city
        state
        postcode
        email
        phone
        _id
      }
    }
    dropoffDate
    dropoffDateStr
    status
    statusLastUpdated
    animalSpecies
    headCount
    refundDeadlineDays
    requestedBy {
      _id
      first_name
      last_name
      phone
      email
      phone
    }
    deposit {
      amount
      method
      status
      checkoutSession {
        payment_status
      }
    }
    animalHeads {
      _id
      status
      splitType
      producerIdentifier
      inspectionLevel
      isHangingWeightPerSide
      hangingWeightSideA
      hangingWeightSideB
      hangingWeight
      thirdPartyFee
      liveWeight
      grade
      yield
      tracking
      publicId
      hangTimeDays
      splits @include(if: $includeSplits) {
        cutsheet {
          ...CutsheetFragment
        }
        questionnaire {
          _id
        }
        questionnaireResponse {
          _id
          name
          type
          pricePerPound
          createdAt
          capabilitySet
          questionnaire
          selectedCuts {
            optionId
            specifications {
              specification
              type
              value
            }
          }
          trimSelections {
            type
            trim {
              optionId
              quantity
              percentage
              rank
              specifications {
                specification
                type
                value
              }
            }
          }
          extraSelections {
            extras {
              optionId
              quantity
              specifications {
                specification
                type
                value
              }
            }
          }
          specifications {
            specification
            type
            value
          }
        }
        splitPart
        notes
        locked
        yield {
          _id
          capabilityOptionId
          label
          weightLbs
          itemCount
          packageCount
          packageIdentifier
        }
        buyer {
          _id
          email
          first_name
          last_name
          phone
          company
        }
        _id
      }
      isKillAndChill
    }
    linkedInvoices {
      ...InvoiceFragment
    }
    _id
  }
}
    ${CutsheetFragmentFragmentDoc}
${InvoiceFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingByIdQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeSplits: // value for 'includeSplits'
 *   },
 * });
 */
export function useProcessorSchedulingByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>(ProcessorSchedulingByIdDocument, options);
      }
export function useProcessorSchedulingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>(ProcessorSchedulingByIdDocument, options);
        }
export type ProcessorSchedulingByIdQueryHookResult = ReturnType<typeof useProcessorSchedulingByIdQuery>;
export type ProcessorSchedulingByIdLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingByIdLazyQuery>;
export type ProcessorSchedulingByIdQueryResult = Apollo.QueryResult<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>;
export const ProcessorSchedulingCalendarDocument = gql`
    query ProcessorSchedulingCalendar($vendorId: MongoID!, $startDate: Date!, $endDate: Date!, $filter: FilterFindManyProcessorSchedulingInput) {
  getProcessorSchedulingCalendar(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    ...ProcessorSchedulingCalendarFragment
  }
}
    ${ProcessorSchedulingCalendarFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingCalendarQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingCalendarQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProcessorSchedulingCalendarQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>(ProcessorSchedulingCalendarDocument, options);
      }
export function useProcessorSchedulingCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>(ProcessorSchedulingCalendarDocument, options);
        }
export type ProcessorSchedulingCalendarQueryHookResult = ReturnType<typeof useProcessorSchedulingCalendarQuery>;
export type ProcessorSchedulingCalendarLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingCalendarLazyQuery>;
export type ProcessorSchedulingCalendarQueryResult = Apollo.QueryResult<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>;
export const ProcessorSchedulingFilteredDocument = gql`
    query processorSchedulingFiltered($page: Int!, $perPage: Int!, $searchByContact: String, $sort: SortFindManyProcessorSchedulingInput!, $statusFilter: [EnumProcessorSchedulingStatus!], $matchHeadStatus: Boolean, $vendorId: MongoID!, $animalSpecies: [String!], $kind: String, $issues: [String!], $tags: [MongoID!], $confirmation: [String!], $dropoffDateFrom: Date, $dropoffDateTo: Date, $harvestDateFrom: Date, $harvestDateTo: Date, $cutDateFrom: Date, $cutDateTo: Date) {
  getFilteredProcessorScheduling(
    page: $page
    perPage: $perPage
    searchByContact: $searchByContact
    sort: $sort
    statusFilter: $statusFilter
    matchHeadStatus: $matchHeadStatus
    vendorId: $vendorId
    animalSpecies: $animalSpecies
    kind: $kind
    issues: $issues
    tags: $tags
    confirmation: $confirmation
    dropoffDateFrom: $dropoffDateFrom
    dropoffDateTo: $dropoffDateTo
    harvestDateFrom: $harvestDateFrom
    harvestDateTo: $harvestDateTo
    cutDateFrom: $cutDateFrom
    cutDateTo: $cutDateTo
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      matchedHeadStatuses {
        status
        count
      }
      tags {
        _id
        name
        icon
        sortOrder
      }
      customerConfirmation {
        status
        respondedAt
      }
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      vendor {
        _id
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        status
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        splits {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          notes
          locked
          buyer {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingFilteredQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingFilteredQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      searchByContact: // value for 'searchByContact'
 *      sort: // value for 'sort'
 *      statusFilter: // value for 'statusFilter'
 *      matchHeadStatus: // value for 'matchHeadStatus'
 *      vendorId: // value for 'vendorId'
 *      animalSpecies: // value for 'animalSpecies'
 *      kind: // value for 'kind'
 *      issues: // value for 'issues'
 *      tags: // value for 'tags'
 *      confirmation: // value for 'confirmation'
 *      dropoffDateFrom: // value for 'dropoffDateFrom'
 *      dropoffDateTo: // value for 'dropoffDateTo'
 *      harvestDateFrom: // value for 'harvestDateFrom'
 *      harvestDateTo: // value for 'harvestDateTo'
 *      cutDateFrom: // value for 'cutDateFrom'
 *      cutDateTo: // value for 'cutDateTo'
 *   },
 * });
 */
export function useProcessorSchedulingFilteredQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>(ProcessorSchedulingFilteredDocument, options);
      }
export function useProcessorSchedulingFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>(ProcessorSchedulingFilteredDocument, options);
        }
export type ProcessorSchedulingFilteredQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredQuery>;
export type ProcessorSchedulingFilteredLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredLazyQuery>;
export type ProcessorSchedulingFilteredQueryResult = Apollo.QueryResult<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>;
export const ProcessorSchedulingFilteredCountDocument = gql`
    query processorSchedulingFilteredCount($searchByContact: String, $statusFilter: [EnumProcessorSchedulingStatus!], $vendorId: MongoID!) {
  getFilteredProcessorScheduling(
    page: 1
    perPage: 1
    sort: DROPOFFDATE_ASC
    searchByContact: $searchByContact
    statusFilter: $statusFilter
    vendorId: $vendorId
  ) {
    count
  }
}
    `;

/**
 * __useProcessorSchedulingFilteredCountQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingFilteredCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingFilteredCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingFilteredCountQuery({
 *   variables: {
 *      searchByContact: // value for 'searchByContact'
 *      statusFilter: // value for 'statusFilter'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingFilteredCountQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingFilteredCountQuery, ProcessorSchedulingFilteredCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingFilteredCountQuery, ProcessorSchedulingFilteredCountQueryVariables>(ProcessorSchedulingFilteredCountDocument, options);
      }
export function useProcessorSchedulingFilteredCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingFilteredCountQuery, ProcessorSchedulingFilteredCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingFilteredCountQuery, ProcessorSchedulingFilteredCountQueryVariables>(ProcessorSchedulingFilteredCountDocument, options);
        }
export type ProcessorSchedulingFilteredCountQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredCountQuery>;
export type ProcessorSchedulingFilteredCountLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredCountLazyQuery>;
export type ProcessorSchedulingFilteredCountQueryResult = Apollo.QueryResult<ProcessorSchedulingFilteredCountQuery, ProcessorSchedulingFilteredCountQueryVariables>;
export const ProcessorSchedulingIdsForContactDocument = gql`
    query ProcessorSchedulingIdsForContact($contactUserId: MongoID!) {
  processorSchedulingIdsForContact(contactUserId: $contactUserId)
}
    `;

/**
 * __useProcessorSchedulingIdsForContactQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingIdsForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingIdsForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingIdsForContactQuery({
 *   variables: {
 *      contactUserId: // value for 'contactUserId'
 *   },
 * });
 */
export function useProcessorSchedulingIdsForContactQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingIdsForContactQuery, ProcessorSchedulingIdsForContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingIdsForContactQuery, ProcessorSchedulingIdsForContactQueryVariables>(ProcessorSchedulingIdsForContactDocument, options);
      }
export function useProcessorSchedulingIdsForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingIdsForContactQuery, ProcessorSchedulingIdsForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingIdsForContactQuery, ProcessorSchedulingIdsForContactQueryVariables>(ProcessorSchedulingIdsForContactDocument, options);
        }
export type ProcessorSchedulingIdsForContactQueryHookResult = ReturnType<typeof useProcessorSchedulingIdsForContactQuery>;
export type ProcessorSchedulingIdsForContactLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingIdsForContactLazyQuery>;
export type ProcessorSchedulingIdsForContactQueryResult = Apollo.QueryResult<ProcessorSchedulingIdsForContactQuery, ProcessorSchedulingIdsForContactQueryVariables>;
export const ProcessorSchedulingIdsReadyToInvoiceDocument = gql`
    query ProcessorSchedulingIdsReadyToInvoice {
  processorSchedulingIdsReadyToInvoice
}
    `;

/**
 * __useProcessorSchedulingIdsReadyToInvoiceQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingIdsReadyToInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingIdsReadyToInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingIdsReadyToInvoiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessorSchedulingIdsReadyToInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorSchedulingIdsReadyToInvoiceQuery, ProcessorSchedulingIdsReadyToInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingIdsReadyToInvoiceQuery, ProcessorSchedulingIdsReadyToInvoiceQueryVariables>(ProcessorSchedulingIdsReadyToInvoiceDocument, options);
      }
export function useProcessorSchedulingIdsReadyToInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingIdsReadyToInvoiceQuery, ProcessorSchedulingIdsReadyToInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingIdsReadyToInvoiceQuery, ProcessorSchedulingIdsReadyToInvoiceQueryVariables>(ProcessorSchedulingIdsReadyToInvoiceDocument, options);
        }
export type ProcessorSchedulingIdsReadyToInvoiceQueryHookResult = ReturnType<typeof useProcessorSchedulingIdsReadyToInvoiceQuery>;
export type ProcessorSchedulingIdsReadyToInvoiceLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingIdsReadyToInvoiceLazyQuery>;
export type ProcessorSchedulingIdsReadyToInvoiceQueryResult = Apollo.QueryResult<ProcessorSchedulingIdsReadyToInvoiceQuery, ProcessorSchedulingIdsReadyToInvoiceQueryVariables>;
export const ProcessorSchedulingManyDocument = gql`
    query processorSchedulingMany($filter: FilterFindManyProcessorSchedulingInput, $skip: Int, $limit: Int) {
  processorSchedulingMany(filter: $filter, skip: $skip, limit: $limit) {
    ...ProcessorSchedulingSlimFragment
    jobId
    vendor {
      _id
    }
    requestedBy {
      _id
      first_name
      last_name
      company
    }
    dropoffDate
    status
    statusLastUpdated
    animalSpecies
    headCount
    animalHeads {
      _id
      publicId
      inspectionLevel
      tracking
      isHangingWeightPerSide
      hangingWeight
      hangingWeightSideA
      hangingWeightSideB
      liveWeight
      killDate
      cutDate
      hangTimeDays
      producerIdentifier
      splits {
        _id
        splitPart
        cutsheet {
          _id
        }
        questionnaireResponse {
          _id
        }
      }
    }
  }
}
    ${ProcessorSchedulingSlimFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingManyQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProcessorSchedulingManyQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>(ProcessorSchedulingManyDocument, options);
      }
export function useProcessorSchedulingManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>(ProcessorSchedulingManyDocument, options);
        }
export type ProcessorSchedulingManyQueryHookResult = ReturnType<typeof useProcessorSchedulingManyQuery>;
export type ProcessorSchedulingManyLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingManyLazyQuery>;
export type ProcessorSchedulingManyQueryResult = Apollo.QueryResult<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>;
export const ProcessorSchedulingPaginationDocument = gql`
    query ProcessorSchedulingPagination($sort: SortFindManyProcessorSchedulingInput!, $filter: FilterFindManyProcessorSchedulingInput!, $page: Int!, $perPage: Int!) {
  processorSchedulingPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      animalSpecies
      dropoffDate
      recurringSeries
      headCount
      status
      statusLastUpdated
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      vendor {
        _id
        shop_name
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        status
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        splits {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
            extras {
              ...ExtrasFragment
            }
            trim {
              ...TrimFragment
            }
          }
          splitPart
          notes
          locked
          questionnaire {
            _id
          }
          questionnaireResponse {
            _id
            name
            notes
          }
          buyer {
            _id
            email
            first_name
            last_name
            phone
          }
        }
        isKillAndChill
      }
    }
  }
}
    ${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorSchedulingPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>(ProcessorSchedulingPaginationDocument, options);
      }
export function useProcessorSchedulingPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>(ProcessorSchedulingPaginationDocument, options);
        }
export type ProcessorSchedulingPaginationQueryHookResult = ReturnType<typeof useProcessorSchedulingPaginationQuery>;
export type ProcessorSchedulingPaginationLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingPaginationLazyQuery>;
export type ProcessorSchedulingPaginationQueryResult = Apollo.QueryResult<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>;
export const ProcessorSchedulingWithMissingCutsheetsDocument = gql`
    query processorSchedulingWithMissingCutsheets($page: Int!, $perPage: Int!, $sort: SortFindManyProcessorSchedulingInput!, $vendorId: MongoID, $customerId: MongoID) {
  findProcessorSchedulingsWithMissingCutsheets(
    page: $page
    perPage: $perPage
    sort: $sort
    vendorId: $vendorId
    customerId: $customerId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      vendor {
        shop_name
      }
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        splits {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          notes
          locked
          buyer {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingWithMissingCutsheetsQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingWithMissingCutsheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingWithMissingCutsheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingWithMissingCutsheetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useProcessorSchedulingWithMissingCutsheetsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>(ProcessorSchedulingWithMissingCutsheetsDocument, options);
      }
export function useProcessorSchedulingWithMissingCutsheetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>(ProcessorSchedulingWithMissingCutsheetsDocument, options);
        }
export type ProcessorSchedulingWithMissingCutsheetsQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingCutsheetsQuery>;
export type ProcessorSchedulingWithMissingCutsheetsLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingCutsheetsLazyQuery>;
export type ProcessorSchedulingWithMissingCutsheetsQueryResult = Apollo.QueryResult<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>;
export const ProcessorSchedulingWithMissingHangingWeightsDocument = gql`
    query processorSchedulingWithMissingHangingWeights($page: Int!, $perPage: Int!, $sort: SortFindManyProcessorSchedulingInput!, $vendorId: MongoID!) {
  findProcessorSchedulingsWithMissingHangingWeights(
    page: $page
    perPage: $perPage
    sort: $sort
    vendorId: $vendorId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      vendor {
        shop_name
      }
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        splits {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          notes
          locked
          buyer {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingWithMissingHangingWeightsQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingWithMissingHangingWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingWithMissingHangingWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingWithMissingHangingWeightsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingWithMissingHangingWeightsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>(ProcessorSchedulingWithMissingHangingWeightsDocument, options);
      }
export function useProcessorSchedulingWithMissingHangingWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>(ProcessorSchedulingWithMissingHangingWeightsDocument, options);
        }
export type ProcessorSchedulingWithMissingHangingWeightsQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingHangingWeightsQuery>;
export type ProcessorSchedulingWithMissingHangingWeightsLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingHangingWeightsLazyQuery>;
export type ProcessorSchedulingWithMissingHangingWeightsQueryResult = Apollo.QueryResult<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>;
export const ProcessorSchedulingsByUserIdDocument = gql`
    query ProcessorSchedulingsByUserId($userId: MongoID!, $vendorId: MongoID, $page: Int!, $perPage: Int!) {
  processorSchedulingPagination(
    filter: {requestedBy: $userId, vendor: $vendorId}
    sort: _ID_DESC
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      status
      source
      createdAt
      dropoffDate
      vendor {
        _id
        shop_name
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingsByUserIdQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorSchedulingsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>(ProcessorSchedulingsByUserIdDocument, options);
      }
export function useProcessorSchedulingsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>(ProcessorSchedulingsByUserIdDocument, options);
        }
export type ProcessorSchedulingsByUserIdQueryHookResult = ReturnType<typeof useProcessorSchedulingsByUserIdQuery>;
export type ProcessorSchedulingsByUserIdLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingsByUserIdLazyQuery>;
export type ProcessorSchedulingsByUserIdQueryResult = Apollo.QueryResult<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>;
export const ProcessorSplitRequestsDocument = gql`
    query ProcessorSplitRequests {
  processorSplitRequests {
    _id
    buyer
    species
    splitType
    desiredPickupDate
    note
    createdAt
    depositAmount
    buyerContact {
      name
      email
      phone
    }
  }
}
    `;

/**
 * __useProcessorSplitRequestsQuery__
 *
 * To run a query within a React component, call `useProcessorSplitRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSplitRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSplitRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessorSplitRequestsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorSplitRequestsQuery, ProcessorSplitRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSplitRequestsQuery, ProcessorSplitRequestsQueryVariables>(ProcessorSplitRequestsDocument, options);
      }
export function useProcessorSplitRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSplitRequestsQuery, ProcessorSplitRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSplitRequestsQuery, ProcessorSplitRequestsQueryVariables>(ProcessorSplitRequestsDocument, options);
        }
export type ProcessorSplitRequestsQueryHookResult = ReturnType<typeof useProcessorSplitRequestsQuery>;
export type ProcessorSplitRequestsLazyQueryHookResult = ReturnType<typeof useProcessorSplitRequestsLazyQuery>;
export type ProcessorSplitRequestsQueryResult = Apollo.QueryResult<ProcessorSplitRequestsQuery, ProcessorSplitRequestsQueryVariables>;
export const ProducerActionCountsDocument = gql`
    query ProducerActionCounts($buyerOnly: Boolean!) {
  producerActionCounts(buyerOnly: $buyerOnly) {
    depositDue
    dropoffsToConfirm
    missingSplits
    missingBuyers
    missingCutsheets
    openInvoices
    openInvoiceTotal
  }
}
    `;

/**
 * __useProducerActionCountsQuery__
 *
 * To run a query within a React component, call `useProducerActionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerActionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerActionCountsQuery({
 *   variables: {
 *      buyerOnly: // value for 'buyerOnly'
 *   },
 * });
 */
export function useProducerActionCountsQuery(baseOptions: Apollo.QueryHookOptions<ProducerActionCountsQuery, ProducerActionCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerActionCountsQuery, ProducerActionCountsQueryVariables>(ProducerActionCountsDocument, options);
      }
export function useProducerActionCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerActionCountsQuery, ProducerActionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerActionCountsQuery, ProducerActionCountsQueryVariables>(ProducerActionCountsDocument, options);
        }
export type ProducerActionCountsQueryHookResult = ReturnType<typeof useProducerActionCountsQuery>;
export type ProducerActionCountsLazyQueryHookResult = ReturnType<typeof useProducerActionCountsLazyQuery>;
export type ProducerActionCountsQueryResult = Apollo.QueryResult<ProducerActionCountsQuery, ProducerActionCountsQueryVariables>;
export const ProducerBuyerRosterDocument = gql`
    query ProducerBuyerRoster {
  producerBuyerRoster {
    animalId
    species
    tracking
    publicId
    availableToBuyers
    listingRatePerLb
    listingTotalPrice
    isHangingWeightPerSide
    hangingWeightSideA
    hangingWeightSideB
    hangingWeight
    isPendingAcceptance
    isVetoed
    vetoedAt
    buyers {
      splitId
      splitPart
      status
      buyerId
      buyerName
      buyerEmail
      buyerPhone
      holdExpiresAt
      splitDepositAmount
      orderId
      orderStatus
      depositAmount
      amountRefunded
      finalAmount
      balanceDue
      invoicedAt
      depositRecipientParty
      depositOverrideState
    }
  }
}
    `;

/**
 * __useProducerBuyerRosterQuery__
 *
 * To run a query within a React component, call `useProducerBuyerRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerBuyerRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerBuyerRosterQuery({
 *   variables: {
 *   },
 * });
 */
export function useProducerBuyerRosterQuery(baseOptions?: Apollo.QueryHookOptions<ProducerBuyerRosterQuery, ProducerBuyerRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerBuyerRosterQuery, ProducerBuyerRosterQueryVariables>(ProducerBuyerRosterDocument, options);
      }
export function useProducerBuyerRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerBuyerRosterQuery, ProducerBuyerRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerBuyerRosterQuery, ProducerBuyerRosterQueryVariables>(ProducerBuyerRosterDocument, options);
        }
export type ProducerBuyerRosterQueryHookResult = ReturnType<typeof useProducerBuyerRosterQuery>;
export type ProducerBuyerRosterLazyQueryHookResult = ReturnType<typeof useProducerBuyerRosterLazyQuery>;
export type ProducerBuyerRosterQueryResult = Apollo.QueryResult<ProducerBuyerRosterQuery, ProducerBuyerRosterQueryVariables>;
export const ProducerCustomersDocument = gql`
    query ProducerCustomers($page: Int, $perPage: Int, $sort: String, $sortDirection: String, $producerId: MongoID, $search: String, $balanceDueOnly: Boolean) {
  producerCustomers(
    page: $page
    perPage: $perPage
    sort: $sort
    sortDirection: $sortDirection
    producerId: $producerId
    search: $search
    balanceDueOnly: $balanceDueOnly
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      buyerId
      name
      email
      phone
      claimsCount
      relationshipSummary
      lastActivityAt
      balance {
        kind
        amount
      }
      claims {
        splitId
        splitPart
        status
        holdExpiresAt
        orderId
        orderStatus
        depositAmount
        amountRefunded
        finalAmount
        saleBaseAmount
        adjustments {
          label
          amount
        }
        balanceDue
        invoicedAt
        balancePaid
        depositRecipientParty
        listingFee
        depositOverrideState
        vendorId
        hasCutsheet
        cutsheetKeepReason
        jobId
        jobPublicId
        jobStatus
        animalId
        species
        tracking
        publicId
        availableToBuyers
        listingRatePerLb
        listingTotalPrice
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        hangingWeight
        isPendingAcceptance
        isVetoed
        vetoedAt
      }
      lastOrder {
        date
        animalLabel
        amount
        status
        orderId
      }
    }
  }
}
    `;

/**
 * __useProducerCustomersQuery__
 *
 * To run a query within a React component, call `useProducerCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerCustomersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      producerId: // value for 'producerId'
 *      search: // value for 'search'
 *      balanceDueOnly: // value for 'balanceDueOnly'
 *   },
 * });
 */
export function useProducerCustomersQuery(baseOptions?: Apollo.QueryHookOptions<ProducerCustomersQuery, ProducerCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerCustomersQuery, ProducerCustomersQueryVariables>(ProducerCustomersDocument, options);
      }
export function useProducerCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerCustomersQuery, ProducerCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerCustomersQuery, ProducerCustomersQueryVariables>(ProducerCustomersDocument, options);
        }
export type ProducerCustomersQueryHookResult = ReturnType<typeof useProducerCustomersQuery>;
export type ProducerCustomersLazyQueryHookResult = ReturnType<typeof useProducerCustomersLazyQuery>;
export type ProducerCustomersQueryResult = Apollo.QueryResult<ProducerCustomersQuery, ProducerCustomersQueryVariables>;
export const ProducerDropoffsToConfirmDocument = gql`
    query ProducerDropoffsToConfirm {
  producerDropoffsToConfirm {
    _id
    jobId
    animalSpecies
    dropoffDate
    headCount
    status
    vendor {
      _id
      shop_name
    }
    customerConfirmation {
      status
    }
    dropoffConfirmationRequested
  }
}
    `;

/**
 * __useProducerDropoffsToConfirmQuery__
 *
 * To run a query within a React component, call `useProducerDropoffsToConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerDropoffsToConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerDropoffsToConfirmQuery({
 *   variables: {
 *   },
 * });
 */
export function useProducerDropoffsToConfirmQuery(baseOptions?: Apollo.QueryHookOptions<ProducerDropoffsToConfirmQuery, ProducerDropoffsToConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerDropoffsToConfirmQuery, ProducerDropoffsToConfirmQueryVariables>(ProducerDropoffsToConfirmDocument, options);
      }
export function useProducerDropoffsToConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerDropoffsToConfirmQuery, ProducerDropoffsToConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerDropoffsToConfirmQuery, ProducerDropoffsToConfirmQueryVariables>(ProducerDropoffsToConfirmDocument, options);
        }
export type ProducerDropoffsToConfirmQueryHookResult = ReturnType<typeof useProducerDropoffsToConfirmQuery>;
export type ProducerDropoffsToConfirmLazyQueryHookResult = ReturnType<typeof useProducerDropoffsToConfirmLazyQuery>;
export type ProducerDropoffsToConfirmQueryResult = Apollo.QueryResult<ProducerDropoffsToConfirmQuery, ProducerDropoffsToConfirmQueryVariables>;
export const ProducerJobByIdDocument = gql`
    query ProducerJobById($id: MongoID!) {
  processorSchedulingById(_id: $id) {
    _id
    jobId
    status
    sendNotifications
    statusLastUpdated
    dropoffDate
    dropoffDateStr
    animalSpecies
    headCount
    blockTitle
    expectedArrivalTime
    customerConfirmation {
      status
      respondedAt
      via
    }
    dropoffConfirmationRequested
    pickupLocation {
      _id
      name
      description
      address {
        address_1
        address_2
        city
        state
        postcode
      }
    }
    additionalPickupDetails
    deposit {
      amount
      method
      status
    }
    requestedBy {
      _id
      first_name
      last_name
      company
    }
    vendor {
      _id
      shop_name
      address {
        email
        phone
      }
    }
    animalHeads {
      _id
      status
      splitType
      questionnaire
      publicId
      inspectionLevel
      hasMissingSplits
      hasMissingContacts
      hasMissingCutsheets
      sendNotifications
      killDate
      cutDate
      tracking
      hangingWeight
      hangingWeightSideA
      hangingWeightSideB
      isHangingWeightPerSide
      producerIdentifier
      isKillAndChill
      availableToBuyers
      allowedSectionSizes
      descriptorChips
      producerDescription
      listedBy
      sizeTier
      liveWeight
      liveWeightHigh
      listingRatePerLb
      listingTotalPrice
      listingDeposits {
        whole
        half
        quarter
      }
      splits {
        _id
        sendNotifications
        splitPart
        kind
        locked
        status
        depositOverrideState
        holdExpiresAt
        depositAmount
        placementHoldAt
        lastNudgedAt
        lastNudgeKind
        isDeleted
        questionnaire {
          _id
        }
        yield {
          _id
          capabilityOptionId
          label
          weightLbs
          itemCount
          packageCount
          packageIdentifier
        }
        questionnaireResponse {
          _id
          name
          notes
          questionnaire
          type
          pricePerPound
          selectedCuts {
            optionId
            specifications {
              specification
              type
              value
            }
          }
          trimSelections {
            type
            trim {
              optionId
              quantity
              percentage
              rank
              specifications {
                specification
                type
                value
              }
            }
          }
          extraSelections {
            extras {
              optionId
              quantity
              specifications {
                specification
                type
                value
              }
            }
          }
        }
        cutsheet {
          _id
          name
          type
          pricePerPound
          primalCuts {
            ...PrimalCutFragment
          }
          selectedSpecifications
          extras {
            ...ExtrasFragment
          }
          trim {
            ...TrimFragment
          }
          notes
        }
        buyer {
          _id
          first_name
          last_name
          company
          email
          phone
          relationships {
            vendorId
            producerId
            type
          }
        }
        order {
          _id
          status
          finalAmount
          saleBaseAmount
          adjustments {
            label
            amount
          }
          balanceDue
          invoicedAt
          balancePaidAt
          depositRecipientParty
          settledOffPlatform
          listingFee
        }
      }
    }
    hasCutsheetNeededNotification
    hasCutsheetReminderNotification
    notificationHistory {
      _id
      type
      notificationType
      sentTo
      createdAt
      user {
        _id
      }
    }
    processorSettings {
      _id
      animalSettings {
        species
        splitTypes
      }
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useProducerJobByIdQuery__
 *
 * To run a query within a React component, call `useProducerJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerJobByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProducerJobByIdQuery(baseOptions: Apollo.QueryHookOptions<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>(ProducerJobByIdDocument, options);
      }
export function useProducerJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>(ProducerJobByIdDocument, options);
        }
export type ProducerJobByIdQueryHookResult = ReturnType<typeof useProducerJobByIdQuery>;
export type ProducerJobByIdLazyQueryHookResult = ReturnType<typeof useProducerJobByIdLazyQuery>;
export type ProducerJobByIdQueryResult = Apollo.QueryResult<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>;
export const ProducerJobIdsNeedingAttentionDocument = gql`
    query ProducerJobIdsNeedingAttention($category: String!) {
  producerJobIdsNeedingAttention(category: $category)
}
    `;

/**
 * __useProducerJobIdsNeedingAttentionQuery__
 *
 * To run a query within a React component, call `useProducerJobIdsNeedingAttentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerJobIdsNeedingAttentionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerJobIdsNeedingAttentionQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useProducerJobIdsNeedingAttentionQuery(baseOptions: Apollo.QueryHookOptions<ProducerJobIdsNeedingAttentionQuery, ProducerJobIdsNeedingAttentionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerJobIdsNeedingAttentionQuery, ProducerJobIdsNeedingAttentionQueryVariables>(ProducerJobIdsNeedingAttentionDocument, options);
      }
export function useProducerJobIdsNeedingAttentionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerJobIdsNeedingAttentionQuery, ProducerJobIdsNeedingAttentionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerJobIdsNeedingAttentionQuery, ProducerJobIdsNeedingAttentionQueryVariables>(ProducerJobIdsNeedingAttentionDocument, options);
        }
export type ProducerJobIdsNeedingAttentionQueryHookResult = ReturnType<typeof useProducerJobIdsNeedingAttentionQuery>;
export type ProducerJobIdsNeedingAttentionLazyQueryHookResult = ReturnType<typeof useProducerJobIdsNeedingAttentionLazyQuery>;
export type ProducerJobIdsNeedingAttentionQueryResult = Apollo.QueryResult<ProducerJobIdsNeedingAttentionQuery, ProducerJobIdsNeedingAttentionQueryVariables>;
export const ProducerJobsDocument = gql`
    query ProducerJobs($search: String, $status: String, $sort: String, $page: Int, $perPage: Int) {
  producerJobs(
    search: $search
    status: $status
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      deposit {
        amount
      }
      vendor {
        _id
        shop_name
      }
      animalHeads {
        _id
        killDate
        splitType
        splits {
          _id
          cutsheet {
            _id
          }
          questionnaireResponse {
            _id
          }
          buyer {
            _id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProducerJobsQuery__
 *
 * To run a query within a React component, call `useProducerJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerJobsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProducerJobsQuery(baseOptions?: Apollo.QueryHookOptions<ProducerJobsQuery, ProducerJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerJobsQuery, ProducerJobsQueryVariables>(ProducerJobsDocument, options);
      }
export function useProducerJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerJobsQuery, ProducerJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerJobsQuery, ProducerJobsQueryVariables>(ProducerJobsDocument, options);
        }
export type ProducerJobsQueryHookResult = ReturnType<typeof useProducerJobsQuery>;
export type ProducerJobsLazyQueryHookResult = ReturnType<typeof useProducerJobsLazyQuery>;
export type ProducerJobsQueryResult = Apollo.QueryResult<ProducerJobsQuery, ProducerJobsQueryVariables>;
export const ProducerListingEligibilityDocument = gql`
    query ProducerListingEligibility($vendorId: MongoID) {
  producerListingEligibility(vendorId: $vendorId) {
    eligible
    missing
    marketplaceEnabled
  }
}
    `;

/**
 * __useProducerListingEligibilityQuery__
 *
 * To run a query within a React component, call `useProducerListingEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerListingEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerListingEligibilityQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProducerListingEligibilityQuery(baseOptions?: Apollo.QueryHookOptions<ProducerListingEligibilityQuery, ProducerListingEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerListingEligibilityQuery, ProducerListingEligibilityQueryVariables>(ProducerListingEligibilityDocument, options);
      }
export function useProducerListingEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerListingEligibilityQuery, ProducerListingEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerListingEligibilityQuery, ProducerListingEligibilityQueryVariables>(ProducerListingEligibilityDocument, options);
        }
export type ProducerListingEligibilityQueryHookResult = ReturnType<typeof useProducerListingEligibilityQuery>;
export type ProducerListingEligibilityLazyQueryHookResult = ReturnType<typeof useProducerListingEligibilityLazyQuery>;
export type ProducerListingEligibilityQueryResult = Apollo.QueryResult<ProducerListingEligibilityQuery, ProducerListingEligibilityQueryVariables>;
export const ProducerListingEstimateDocument = gql`
    query ProducerListingEstimate($animalId: MongoID!, $sizeTier: String, $liveWeight: Float, $liveWeightHigh: Float, $listingRatePerLb: Float, $listingTotalPrice: Float) {
  producerListingEstimate(
    animalId: $animalId
    sizeTier: $sizeTier
    liveWeight: $liveWeight
    liveWeightHigh: $liveWeightHigh
    listingRatePerLb: $listingRatePerLb
    listingTotalPrice: $listingTotalPrice
  ) {
    sections {
      size
      estimatedTotalLow
      estimatedTotalHigh
      meatLow
      meatHigh
      processingLow
      processingHigh
    }
  }
}
    `;

/**
 * __useProducerListingEstimateQuery__
 *
 * To run a query within a React component, call `useProducerListingEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerListingEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerListingEstimateQuery({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      sizeTier: // value for 'sizeTier'
 *      liveWeight: // value for 'liveWeight'
 *      liveWeightHigh: // value for 'liveWeightHigh'
 *      listingRatePerLb: // value for 'listingRatePerLb'
 *      listingTotalPrice: // value for 'listingTotalPrice'
 *   },
 * });
 */
export function useProducerListingEstimateQuery(baseOptions: Apollo.QueryHookOptions<ProducerListingEstimateQuery, ProducerListingEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerListingEstimateQuery, ProducerListingEstimateQueryVariables>(ProducerListingEstimateDocument, options);
      }
export function useProducerListingEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerListingEstimateQuery, ProducerListingEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerListingEstimateQuery, ProducerListingEstimateQueryVariables>(ProducerListingEstimateDocument, options);
        }
export type ProducerListingEstimateQueryHookResult = ReturnType<typeof useProducerListingEstimateQuery>;
export type ProducerListingEstimateLazyQueryHookResult = ReturnType<typeof useProducerListingEstimateLazyQuery>;
export type ProducerListingEstimateQueryResult = Apollo.QueryResult<ProducerListingEstimateQuery, ProducerListingEstimateQueryVariables>;
export const ProducerOfferedSpeciesDocument = gql`
    query ProducerOfferedSpecies($producerId: MongoID!) {
  producerOfferedSpecies(producerId: $producerId)
}
    `;

/**
 * __useProducerOfferedSpeciesQuery__
 *
 * To run a query within a React component, call `useProducerOfferedSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerOfferedSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerOfferedSpeciesQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useProducerOfferedSpeciesQuery(baseOptions: Apollo.QueryHookOptions<ProducerOfferedSpeciesQuery, ProducerOfferedSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerOfferedSpeciesQuery, ProducerOfferedSpeciesQueryVariables>(ProducerOfferedSpeciesDocument, options);
      }
export function useProducerOfferedSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerOfferedSpeciesQuery, ProducerOfferedSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerOfferedSpeciesQuery, ProducerOfferedSpeciesQueryVariables>(ProducerOfferedSpeciesDocument, options);
        }
export type ProducerOfferedSpeciesQueryHookResult = ReturnType<typeof useProducerOfferedSpeciesQuery>;
export type ProducerOfferedSpeciesLazyQueryHookResult = ReturnType<typeof useProducerOfferedSpeciesLazyQuery>;
export type ProducerOfferedSpeciesQueryResult = Apollo.QueryResult<ProducerOfferedSpeciesQuery, ProducerOfferedSpeciesQueryVariables>;
export const ProducerSettingsDocument = gql`
    query ProducerSettings {
  producerSettings {
    producer
    splitDeposits {
      species
      whole
      half
      quarter
    }
    listingPresets {
      species
      pricingMode
      listingRatePerLb
      listingTotalPrice
      sizeTier
      allowedSectionSizes
      descriptorChips
      description
    }
    bio
    bannerUrl
    boxImageUrl
    buyerChips
    buyerBio
  }
}
    `;

/**
 * __useProducerSettingsQuery__
 *
 * To run a query within a React component, call `useProducerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProducerSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ProducerSettingsQuery, ProducerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerSettingsQuery, ProducerSettingsQueryVariables>(ProducerSettingsDocument, options);
      }
export function useProducerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerSettingsQuery, ProducerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerSettingsQuery, ProducerSettingsQueryVariables>(ProducerSettingsDocument, options);
        }
export type ProducerSettingsQueryHookResult = ReturnType<typeof useProducerSettingsQuery>;
export type ProducerSettingsLazyQueryHookResult = ReturnType<typeof useProducerSettingsLazyQuery>;
export type ProducerSettingsQueryResult = Apollo.QueryResult<ProducerSettingsQuery, ProducerSettingsQueryVariables>;
export const ProducersByVendorIdDocument = gql`
    query ProducersByVendorId($vendorId: MongoID!, $search: String) {
  searchCustomers(
    vendorId: $vendorId
    search: $search
    relationshipType: "producer"
  ) {
    _id
    first_name
    last_name
    email
    company
    phone
  }
}
    `;

/**
 * __useProducersByVendorIdQuery__
 *
 * To run a query within a React component, call `useProducersByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducersByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducersByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProducersByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>(ProducersByVendorIdDocument, options);
      }
export function useProducersByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>(ProducersByVendorIdDocument, options);
        }
export type ProducersByVendorIdQueryHookResult = ReturnType<typeof useProducersByVendorIdQuery>;
export type ProducersByVendorIdLazyQueryHookResult = ReturnType<typeof useProducersByVendorIdLazyQuery>;
export type ProducersByVendorIdQueryResult = Apollo.QueryResult<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>;
export const RecurringSeriesUpcomingJobCountDocument = gql`
    query RecurringSeriesUpcomingJobCount($seriesId: MongoID!) {
  recurringSeriesUpcomingJobCount(seriesId: $seriesId)
}
    `;

/**
 * __useRecurringSeriesUpcomingJobCountQuery__
 *
 * To run a query within a React component, call `useRecurringSeriesUpcomingJobCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringSeriesUpcomingJobCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringSeriesUpcomingJobCountQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useRecurringSeriesUpcomingJobCountQuery(baseOptions: Apollo.QueryHookOptions<RecurringSeriesUpcomingJobCountQuery, RecurringSeriesUpcomingJobCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringSeriesUpcomingJobCountQuery, RecurringSeriesUpcomingJobCountQueryVariables>(RecurringSeriesUpcomingJobCountDocument, options);
      }
export function useRecurringSeriesUpcomingJobCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringSeriesUpcomingJobCountQuery, RecurringSeriesUpcomingJobCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringSeriesUpcomingJobCountQuery, RecurringSeriesUpcomingJobCountQueryVariables>(RecurringSeriesUpcomingJobCountDocument, options);
        }
export type RecurringSeriesUpcomingJobCountQueryHookResult = ReturnType<typeof useRecurringSeriesUpcomingJobCountQuery>;
export type RecurringSeriesUpcomingJobCountLazyQueryHookResult = ReturnType<typeof useRecurringSeriesUpcomingJobCountLazyQuery>;
export type RecurringSeriesUpcomingJobCountQueryResult = Apollo.QueryResult<RecurringSeriesUpcomingJobCountQuery, RecurringSeriesUpcomingJobCountQueryVariables>;
export const RenderNotificationEmailPreviewDocument = gql`
    query RenderNotificationEmailPreview($content: String!, $vendorName: String!, $logoUrl: String, $subject: String!, $trigger: String) {
  renderNotificationEmailPreview(
    content: $content
    vendorName: $vendorName
    logoUrl: $logoUrl
    subject: $subject
    trigger: $trigger
  ) {
    html
  }
}
    `;

/**
 * __useRenderNotificationEmailPreviewQuery__
 *
 * To run a query within a React component, call `useRenderNotificationEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderNotificationEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderNotificationEmailPreviewQuery({
 *   variables: {
 *      content: // value for 'content'
 *      vendorName: // value for 'vendorName'
 *      logoUrl: // value for 'logoUrl'
 *      subject: // value for 'subject'
 *      trigger: // value for 'trigger'
 *   },
 * });
 */
export function useRenderNotificationEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>(RenderNotificationEmailPreviewDocument, options);
      }
export function useRenderNotificationEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>(RenderNotificationEmailPreviewDocument, options);
        }
export type RenderNotificationEmailPreviewQueryHookResult = ReturnType<typeof useRenderNotificationEmailPreviewQuery>;
export type RenderNotificationEmailPreviewLazyQueryHookResult = ReturnType<typeof useRenderNotificationEmailPreviewLazyQuery>;
export type RenderNotificationEmailPreviewQueryResult = Apollo.QueryResult<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>;
export const FinancialMetricsActualsManyDocument = gql`
    query FinancialMetricsActualsMany($filter: FilterFindManyFinancialMetricsActualsInput, $sort: SortFindManyFinancialMetricsActualsInput) {
  financialMetricsActualsMany(filter: $filter, sort: $sort) {
    _id
    vendor
    period
    speciesActuals {
      species
      headCount
      revenue
      hangingWeight
    }
    overhead
    costOfGoodsSold
    totalHangingWeight
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFinancialMetricsActualsManyQuery__
 *
 * To run a query within a React component, call `useFinancialMetricsActualsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialMetricsActualsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialMetricsActualsManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFinancialMetricsActualsManyQuery(baseOptions?: Apollo.QueryHookOptions<FinancialMetricsActualsManyQuery, FinancialMetricsActualsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialMetricsActualsManyQuery, FinancialMetricsActualsManyQueryVariables>(FinancialMetricsActualsManyDocument, options);
      }
export function useFinancialMetricsActualsManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialMetricsActualsManyQuery, FinancialMetricsActualsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialMetricsActualsManyQuery, FinancialMetricsActualsManyQueryVariables>(FinancialMetricsActualsManyDocument, options);
        }
export type FinancialMetricsActualsManyQueryHookResult = ReturnType<typeof useFinancialMetricsActualsManyQuery>;
export type FinancialMetricsActualsManyLazyQueryHookResult = ReturnType<typeof useFinancialMetricsActualsManyLazyQuery>;
export type FinancialMetricsActualsManyQueryResult = Apollo.QueryResult<FinancialMetricsActualsManyQuery, FinancialMetricsActualsManyQueryVariables>;
export const FinancialMetricsActualsUpsertDocument = gql`
    mutation FinancialMetricsActualsUpsert($record: FinancialMetricsActualsUpsertInput!) {
  financialMetricsActualsUpsert(record: $record) {
    _id
    vendor
    period
    speciesActuals {
      species
      headCount
      revenue
      hangingWeight
    }
    overhead
    costOfGoodsSold
    totalHangingWeight
  }
}
    `;
export type FinancialMetricsActualsUpsertMutationFn = Apollo.MutationFunction<FinancialMetricsActualsUpsertMutation, FinancialMetricsActualsUpsertMutationVariables>;

/**
 * __useFinancialMetricsActualsUpsertMutation__
 *
 * To run a mutation, you first call `useFinancialMetricsActualsUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialMetricsActualsUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialMetricsActualsUpsertMutation, { data, loading, error }] = useFinancialMetricsActualsUpsertMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFinancialMetricsActualsUpsertMutation(baseOptions?: Apollo.MutationHookOptions<FinancialMetricsActualsUpsertMutation, FinancialMetricsActualsUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialMetricsActualsUpsertMutation, FinancialMetricsActualsUpsertMutationVariables>(FinancialMetricsActualsUpsertDocument, options);
      }
export type FinancialMetricsActualsUpsertMutationHookResult = ReturnType<typeof useFinancialMetricsActualsUpsertMutation>;
export type FinancialMetricsActualsUpsertMutationResult = Apollo.MutationResult<FinancialMetricsActualsUpsertMutation>;
export type FinancialMetricsActualsUpsertMutationOptions = Apollo.BaseMutationOptions<FinancialMetricsActualsUpsertMutation, FinancialMetricsActualsUpsertMutationVariables>;
export const FinancialMetricsActualsRemoveDocument = gql`
    mutation FinancialMetricsActualsRemove($_id: MongoID!) {
  financialMetricsActualsRemove(_id: $_id) {
    _id
  }
}
    `;
export type FinancialMetricsActualsRemoveMutationFn = Apollo.MutationFunction<FinancialMetricsActualsRemoveMutation, FinancialMetricsActualsRemoveMutationVariables>;

/**
 * __useFinancialMetricsActualsRemoveMutation__
 *
 * To run a mutation, you first call `useFinancialMetricsActualsRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialMetricsActualsRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialMetricsActualsRemoveMutation, { data, loading, error }] = useFinancialMetricsActualsRemoveMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFinancialMetricsActualsRemoveMutation(baseOptions?: Apollo.MutationHookOptions<FinancialMetricsActualsRemoveMutation, FinancialMetricsActualsRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialMetricsActualsRemoveMutation, FinancialMetricsActualsRemoveMutationVariables>(FinancialMetricsActualsRemoveDocument, options);
      }
export type FinancialMetricsActualsRemoveMutationHookResult = ReturnType<typeof useFinancialMetricsActualsRemoveMutation>;
export type FinancialMetricsActualsRemoveMutationResult = Apollo.MutationResult<FinancialMetricsActualsRemoveMutation>;
export type FinancialMetricsActualsRemoveMutationOptions = Apollo.BaseMutationOptions<FinancialMetricsActualsRemoveMutation, FinancialMetricsActualsRemoveMutationVariables>;
export const GetFinancialReportingConfigDocument = gql`
    query GetFinancialReportingConfig($filter: FilterFindOneFinancialReportingConfigInput) {
  financialReportingConfigOne(filter: $filter) {
    _id
    vendor
    animalConfigurations {
      species
      expectedThroughput
      maxCapacity
      processingCost
      revenue
      averageHangingWeight
    }
    overheadCosts {
      name
      amount
      frequency
    }
    timeConfiguration {
      timePerNotification
      timePerCutsheet
      timePerBooking
      baseDigitalSavings
      hourlyRate
    }
    monthlyModifiers {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
    dateAnchor
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFinancialReportingConfigQuery__
 *
 * To run a query within a React component, call `useGetFinancialReportingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialReportingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialReportingConfigQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFinancialReportingConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>(GetFinancialReportingConfigDocument, options);
      }
export function useGetFinancialReportingConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>(GetFinancialReportingConfigDocument, options);
        }
export type GetFinancialReportingConfigQueryHookResult = ReturnType<typeof useGetFinancialReportingConfigQuery>;
export type GetFinancialReportingConfigLazyQueryHookResult = ReturnType<typeof useGetFinancialReportingConfigLazyQuery>;
export type GetFinancialReportingConfigQueryResult = Apollo.QueryResult<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>;
export const FinancialReportingConfigUpsertDocument = gql`
    mutation FinancialReportingConfigUpsert($record: FinancialReportingConfigUpsertInput!) {
  financialReportingConfigUpsert(record: $record) {
    _id
    vendor
    animalConfigurations {
      species
      expectedThroughput
      maxCapacity
      processingCost
      revenue
      averageHangingWeight
    }
    overheadCosts {
      name
      amount
      frequency
    }
    timeConfiguration {
      timePerNotification
      timePerCutsheet
      timePerBooking
      baseDigitalSavings
      hourlyRate
    }
    monthlyModifiers {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
    dateAnchor
    createdAt
    updatedAt
  }
}
    `;
export type FinancialReportingConfigUpsertMutationFn = Apollo.MutationFunction<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>;

/**
 * __useFinancialReportingConfigUpsertMutation__
 *
 * To run a mutation, you first call `useFinancialReportingConfigUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialReportingConfigUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialReportingConfigUpsertMutation, { data, loading, error }] = useFinancialReportingConfigUpsertMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFinancialReportingConfigUpsertMutation(baseOptions?: Apollo.MutationHookOptions<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>(FinancialReportingConfigUpsertDocument, options);
      }
export type FinancialReportingConfigUpsertMutationHookResult = ReturnType<typeof useFinancialReportingConfigUpsertMutation>;
export type FinancialReportingConfigUpsertMutationResult = Apollo.MutationResult<FinancialReportingConfigUpsertMutation>;
export type FinancialReportingConfigUpsertMutationOptions = Apollo.BaseMutationOptions<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>;
export const GetFinancialReportingMetricsDocument = gql`
    query GetFinancialReportingMetrics($startDate: String, $endDate: String, $dateAnchor: String, $comparisonType: ComparisonType) {
  financialReportingMetrics(
    startDate: $startDate
    endDate: $endDate
    dateAnchor: $dateAnchor
    comparisonType: $comparisonType
  )
}
    `;

/**
 * __useGetFinancialReportingMetricsQuery__
 *
 * To run a query within a React component, call `useGetFinancialReportingMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialReportingMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialReportingMetricsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      dateAnchor: // value for 'dateAnchor'
 *      comparisonType: // value for 'comparisonType'
 *   },
 * });
 */
export function useGetFinancialReportingMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>(GetFinancialReportingMetricsDocument, options);
      }
export function useGetFinancialReportingMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>(GetFinancialReportingMetricsDocument, options);
        }
export type GetFinancialReportingMetricsQueryHookResult = ReturnType<typeof useGetFinancialReportingMetricsQuery>;
export type GetFinancialReportingMetricsLazyQueryHookResult = ReturnType<typeof useGetFinancialReportingMetricsLazyQuery>;
export type GetFinancialReportingMetricsQueryResult = Apollo.QueryResult<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>;
export const GetProcessorBenchmarksDocument = gql`
    query GetProcessorBenchmarks($startDate: String, $endDate: String, $comparisonType: ComparisonType) {
  processorBenchmarks(
    startDate: $startDate
    endDate: $endDate
    comparisonType: $comparisonType
  )
}
    `;

/**
 * __useGetProcessorBenchmarksQuery__
 *
 * To run a query within a React component, call `useGetProcessorBenchmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessorBenchmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessorBenchmarksQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      comparisonType: // value for 'comparisonType'
 *   },
 * });
 */
export function useGetProcessorBenchmarksQuery(baseOptions?: Apollo.QueryHookOptions<GetProcessorBenchmarksQuery, GetProcessorBenchmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessorBenchmarksQuery, GetProcessorBenchmarksQueryVariables>(GetProcessorBenchmarksDocument, options);
      }
export function useGetProcessorBenchmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessorBenchmarksQuery, GetProcessorBenchmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessorBenchmarksQuery, GetProcessorBenchmarksQueryVariables>(GetProcessorBenchmarksDocument, options);
        }
export type GetProcessorBenchmarksQueryHookResult = ReturnType<typeof useGetProcessorBenchmarksQuery>;
export type GetProcessorBenchmarksLazyQueryHookResult = ReturnType<typeof useGetProcessorBenchmarksLazyQuery>;
export type GetProcessorBenchmarksQueryResult = Apollo.QueryResult<GetProcessorBenchmarksQuery, GetProcessorBenchmarksQueryVariables>;
export const GetProcessorWorkflowFunnelDocument = gql`
    query GetProcessorWorkflowFunnel($startDate: String, $endDate: String, $anchor: String) {
  processorWorkflowFunnel(
    startDate: $startDate
    endDate: $endDate
    anchor: $anchor
  )
}
    `;

/**
 * __useGetProcessorWorkflowFunnelQuery__
 *
 * To run a query within a React component, call `useGetProcessorWorkflowFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessorWorkflowFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessorWorkflowFunnelQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      anchor: // value for 'anchor'
 *   },
 * });
 */
export function useGetProcessorWorkflowFunnelQuery(baseOptions?: Apollo.QueryHookOptions<GetProcessorWorkflowFunnelQuery, GetProcessorWorkflowFunnelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessorWorkflowFunnelQuery, GetProcessorWorkflowFunnelQueryVariables>(GetProcessorWorkflowFunnelDocument, options);
      }
export function useGetProcessorWorkflowFunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessorWorkflowFunnelQuery, GetProcessorWorkflowFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessorWorkflowFunnelQuery, GetProcessorWorkflowFunnelQueryVariables>(GetProcessorWorkflowFunnelDocument, options);
        }
export type GetProcessorWorkflowFunnelQueryHookResult = ReturnType<typeof useGetProcessorWorkflowFunnelQuery>;
export type GetProcessorWorkflowFunnelLazyQueryHookResult = ReturnType<typeof useGetProcessorWorkflowFunnelLazyQuery>;
export type GetProcessorWorkflowFunnelQueryResult = Apollo.QueryResult<GetProcessorWorkflowFunnelQuery, GetProcessorWorkflowFunnelQueryVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($vendorId: MongoID!, $producerId: MongoID, $relationshipType: String, $relationshipTypes: [String!], $search: String) {
  searchCustomers(
    vendorId: $vendorId
    producerId: $producerId
    relationshipType: $relationshipType
    relationshipTypes: $relationshipTypes
    search: $search
  ) {
    _id
    first_name
    last_name
    email
    company
    phone
  }
}
    `;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      producerId: // value for 'producerId'
 *      relationshipType: // value for 'relationshipType'
 *      relationshipTypes: // value for 'relationshipTypes'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const SearchRecurringSeriesDocument = gql`
    query SearchRecurringSeries($vendorId: MongoID!, $search: String, $sort: String, $page: Int, $perPage: Int) {
  searchRecurringSeries(
    vendorId: $vendorId
    search: $search
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      _id
      active
      producerName
      nextOccurrence
      upcomingJobCount
      targetUpcomingCount
      rule {
        freq
        interval
        anchor
        timezone
        byDay {
          ordinal
          day
        }
        byMonthDay
        until
        count
      }
      jobTemplate {
        animalSpecies
        headCount
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useSearchRecurringSeriesQuery__
 *
 * To run a query within a React component, call `useSearchRecurringSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRecurringSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRecurringSeriesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useSearchRecurringSeriesQuery(baseOptions: Apollo.QueryHookOptions<SearchRecurringSeriesQuery, SearchRecurringSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchRecurringSeriesQuery, SearchRecurringSeriesQueryVariables>(SearchRecurringSeriesDocument, options);
      }
export function useSearchRecurringSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchRecurringSeriesQuery, SearchRecurringSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchRecurringSeriesQuery, SearchRecurringSeriesQueryVariables>(SearchRecurringSeriesDocument, options);
        }
export type SearchRecurringSeriesQueryHookResult = ReturnType<typeof useSearchRecurringSeriesQuery>;
export type SearchRecurringSeriesLazyQueryHookResult = ReturnType<typeof useSearchRecurringSeriesLazyQuery>;
export type SearchRecurringSeriesQueryResult = Apollo.QueryResult<SearchRecurringSeriesQuery, SearchRecurringSeriesQueryVariables>;
export const ServerTimeDocument = gql`
    query ServerTime {
  serverTime
}
    `;

/**
 * __useServerTimeQuery__
 *
 * To run a query within a React component, call `useServerTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerTimeQuery(baseOptions?: Apollo.QueryHookOptions<ServerTimeQuery, ServerTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServerTimeQuery, ServerTimeQueryVariables>(ServerTimeDocument, options);
      }
export function useServerTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServerTimeQuery, ServerTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServerTimeQuery, ServerTimeQueryVariables>(ServerTimeDocument, options);
        }
export type ServerTimeQueryHookResult = ReturnType<typeof useServerTimeQuery>;
export type ServerTimeLazyQueryHookResult = ReturnType<typeof useServerTimeLazyQuery>;
export type ServerTimeQueryResult = Apollo.QueryResult<ServerTimeQuery, ServerTimeQueryVariables>;
export const ShortUrlPreviewDocument = gql`
    query ShortUrlPreview($code: String!) {
  shortUrlPreview(code: $code) {
    code
    url
    destinationUrl
    title
    description
    imageUrl
    siteName
  }
}
    `;

/**
 * __useShortUrlPreviewQuery__
 *
 * To run a query within a React component, call `useShortUrlPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortUrlPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortUrlPreviewQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useShortUrlPreviewQuery(baseOptions: Apollo.QueryHookOptions<ShortUrlPreviewQuery, ShortUrlPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortUrlPreviewQuery, ShortUrlPreviewQueryVariables>(ShortUrlPreviewDocument, options);
      }
export function useShortUrlPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortUrlPreviewQuery, ShortUrlPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortUrlPreviewQuery, ShortUrlPreviewQueryVariables>(ShortUrlPreviewDocument, options);
        }
export type ShortUrlPreviewQueryHookResult = ReturnType<typeof useShortUrlPreviewQuery>;
export type ShortUrlPreviewLazyQueryHookResult = ReturnType<typeof useShortUrlPreviewLazyQuery>;
export type ShortUrlPreviewQueryResult = Apollo.QueryResult<ShortUrlPreviewQuery, ShortUrlPreviewQueryVariables>;
export const SplitCutsheetQuestionnaireDocument = gql`
    query SplitCutsheetQuestionnaire($processorSchedulingId: MongoID!, $splitId: MongoID!) {
  splitCutsheetQuestionnaire(
    processorSchedulingId: $processorSchedulingId
    splitId: $splitId
  ) {
    questionnaireId
    capabilitiesV2Active
    capabilitiesV1Active
  }
}
    `;

/**
 * __useSplitCutsheetQuestionnaireQuery__
 *
 * To run a query within a React component, call `useSplitCutsheetQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useSplitCutsheetQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplitCutsheetQuestionnaireQuery({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useSplitCutsheetQuestionnaireQuery(baseOptions: Apollo.QueryHookOptions<SplitCutsheetQuestionnaireQuery, SplitCutsheetQuestionnaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SplitCutsheetQuestionnaireQuery, SplitCutsheetQuestionnaireQueryVariables>(SplitCutsheetQuestionnaireDocument, options);
      }
export function useSplitCutsheetQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SplitCutsheetQuestionnaireQuery, SplitCutsheetQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SplitCutsheetQuestionnaireQuery, SplitCutsheetQuestionnaireQueryVariables>(SplitCutsheetQuestionnaireDocument, options);
        }
export type SplitCutsheetQuestionnaireQueryHookResult = ReturnType<typeof useSplitCutsheetQuestionnaireQuery>;
export type SplitCutsheetQuestionnaireLazyQueryHookResult = ReturnType<typeof useSplitCutsheetQuestionnaireLazyQuery>;
export type SplitCutsheetQuestionnaireQueryResult = Apollo.QueryResult<SplitCutsheetQuestionnaireQuery, SplitCutsheetQuestionnaireQueryVariables>;
export const StateManyDocument = gql`
    query StateMany {
  stateMany(sort: STATE_ASC) {
    name
    code
    _id
  }
}
    `;

/**
 * __useStateManyQuery__
 *
 * To run a query within a React component, call `useStateManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useStateManyQuery(baseOptions?: Apollo.QueryHookOptions<StateManyQuery, StateManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StateManyQuery, StateManyQueryVariables>(StateManyDocument, options);
      }
export function useStateManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StateManyQuery, StateManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StateManyQuery, StateManyQueryVariables>(StateManyDocument, options);
        }
export type StateManyQueryHookResult = ReturnType<typeof useStateManyQuery>;
export type StateManyLazyQueryHookResult = ReturnType<typeof useStateManyLazyQuery>;
export type StateManyQueryResult = Apollo.QueryResult<StateManyQuery, StateManyQueryVariables>;
export const UserSettingsByUserIdDocument = gql`
    query UserSettingsByUserId($userId: MongoID!) {
  userSettingsByUserId(userId: $userId) {
    settings {
      calendar {
        dateConfiguration
        calendarView
        showAllEvents
      }
    }
  }
}
    `;

/**
 * __useUserSettingsByUserIdQuery__
 *
 * To run a query within a React component, call `useUserSettingsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSettingsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>(UserSettingsByUserIdDocument, options);
      }
export function useUserSettingsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>(UserSettingsByUserIdDocument, options);
        }
export type UserSettingsByUserIdQueryHookResult = ReturnType<typeof useUserSettingsByUserIdQuery>;
export type UserSettingsByUserIdLazyQueryHookResult = ReturnType<typeof useUserSettingsByUserIdLazyQuery>;
export type UserSettingsByUserIdQueryResult = Apollo.QueryResult<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>;
export const UserTenantVendorDocument = gql`
    query UserTenantVendor {
  userTenantVendor {
    ...UserFragment
    intercomWebToken
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserTenantVendorQuery__
 *
 * To run a query within a React component, call `useUserTenantVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTenantVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTenantVendorQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTenantVendorQuery(baseOptions?: Apollo.QueryHookOptions<UserTenantVendorQuery, UserTenantVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTenantVendorQuery, UserTenantVendorQueryVariables>(UserTenantVendorDocument, options);
      }
export function useUserTenantVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTenantVendorQuery, UserTenantVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTenantVendorQuery, UserTenantVendorQueryVariables>(UserTenantVendorDocument, options);
        }
export type UserTenantVendorQueryHookResult = ReturnType<typeof useUserTenantVendorQuery>;
export type UserTenantVendorLazyQueryHookResult = ReturnType<typeof useUserTenantVendorLazyQuery>;
export type UserTenantVendorQueryResult = Apollo.QueryResult<UserTenantVendorQuery, UserTenantVendorQueryVariables>;
export const VendorCustomerJobsDocument = gql`
    query VendorCustomerJobs($customerId: MongoID!, $buyerJobIds: [MongoID!], $search: String, $status: String, $sort: String, $page: Int, $perPage: Int) {
  vendorCustomerJobs(
    customerId: $customerId
    buyerJobIds: $buyerJobIds
    search: $search
    status: $status
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      deposit {
        amount
      }
      vendor {
        _id
        shop_name
      }
      animalHeads {
        _id
        killDate
        splitType
        splits {
          _id
          cutsheet {
            _id
          }
          questionnaireResponse {
            _id
          }
          buyer {
            _id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVendorCustomerJobsQuery__
 *
 * To run a query within a React component, call `useVendorCustomerJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomerJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomerJobsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      buyerJobIds: // value for 'buyerJobIds'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useVendorCustomerJobsQuery(baseOptions: Apollo.QueryHookOptions<VendorCustomerJobsQuery, VendorCustomerJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorCustomerJobsQuery, VendorCustomerJobsQueryVariables>(VendorCustomerJobsDocument, options);
      }
export function useVendorCustomerJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorCustomerJobsQuery, VendorCustomerJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorCustomerJobsQuery, VendorCustomerJobsQueryVariables>(VendorCustomerJobsDocument, options);
        }
export type VendorCustomerJobsQueryHookResult = ReturnType<typeof useVendorCustomerJobsQuery>;
export type VendorCustomerJobsLazyQueryHookResult = ReturnType<typeof useVendorCustomerJobsLazyQuery>;
export type VendorCustomerJobsQueryResult = Apollo.QueryResult<VendorCustomerJobsQuery, VendorCustomerJobsQueryVariables>;
export const VendorCustomerNotificationDefaultsDocument = gql`
    query VendorCustomerNotificationDefaults($vendorId: MongoID!) {
  vendorCustomerNotificationDefaults(vendorId: $vendorId) {
    job
    animal
    split
  }
}
    `;

/**
 * __useVendorCustomerNotificationDefaultsQuery__
 *
 * To run a query within a React component, call `useVendorCustomerNotificationDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomerNotificationDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomerNotificationDefaultsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorCustomerNotificationDefaultsQuery(baseOptions: Apollo.QueryHookOptions<VendorCustomerNotificationDefaultsQuery, VendorCustomerNotificationDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorCustomerNotificationDefaultsQuery, VendorCustomerNotificationDefaultsQueryVariables>(VendorCustomerNotificationDefaultsDocument, options);
      }
export function useVendorCustomerNotificationDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorCustomerNotificationDefaultsQuery, VendorCustomerNotificationDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorCustomerNotificationDefaultsQuery, VendorCustomerNotificationDefaultsQueryVariables>(VendorCustomerNotificationDefaultsDocument, options);
        }
export type VendorCustomerNotificationDefaultsQueryHookResult = ReturnType<typeof useVendorCustomerNotificationDefaultsQuery>;
export type VendorCustomerNotificationDefaultsLazyQueryHookResult = ReturnType<typeof useVendorCustomerNotificationDefaultsLazyQuery>;
export type VendorCustomerNotificationDefaultsQueryResult = Apollo.QueryResult<VendorCustomerNotificationDefaultsQuery, VendorCustomerNotificationDefaultsQueryVariables>;
export const VendorHerdAnimalsDocument = gql`
    query VendorHerdAnimals($scope: String, $search: String, $species: String, $listed: String, $upcoming: Boolean, $cutWithinDays: Int, $status: String, $saleProgress: String, $sort: String, $page: Int, $perPage: Int, $producerId: MongoID, $excludeCompleted: Boolean) {
  vendorHerdAnimals(
    scope: $scope
    search: $search
    species: $species
    listed: $listed
    upcoming: $upcoming
    cutWithinDays: $cutWithinDays
    status: $status
    saleProgress: $saleProgress
    sort: $sort
    page: $page
    perPage: $perPage
    producerId: $producerId
    excludeCompleted: $excludeCompleted
  ) {
    count
    items {
      _id
      species
      tracking
      splitType
      producerIdentifier
      producerRef {
        _id
        first_name
        last_name
        company
      }
      status
      job
      jobId
      splits {
        _id
        splitPart
        kind
        status
        depositAmount
        depositOverrideState
        holdExpiresAt
        placementHoldAt
        lastNudgedAt
        lastNudgeKind
        locked
        buyer {
          _id
          first_name
          last_name
          company
        }
        questionnaireResponse {
          _id
        }
        cutsheet {
          _id
        }
      }
      sex
      hangTimeDays
      isOverThirtyMonths
      availableToBuyers
      allowedSectionSizes
      claimMode
      remainingCapacity
      isFull
      killDate
      cutDate
      liveWeight
      liveWeightHigh
      sizeTier
      listingRatePerLb
      listingTotalPrice
      listingDeposits {
        whole
        half
        quarter
      }
      descriptorChips
      producerDescription
      listingRecipient
      hangingWeight
      grade
      isKillAndChill
      createdAt
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useVendorHerdAnimalsQuery__
 *
 * To run a query within a React component, call `useVendorHerdAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorHerdAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorHerdAnimalsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      search: // value for 'search'
 *      species: // value for 'species'
 *      listed: // value for 'listed'
 *      upcoming: // value for 'upcoming'
 *      cutWithinDays: // value for 'cutWithinDays'
 *      status: // value for 'status'
 *      saleProgress: // value for 'saleProgress'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      producerId: // value for 'producerId'
 *      excludeCompleted: // value for 'excludeCompleted'
 *   },
 * });
 */
export function useVendorHerdAnimalsQuery(baseOptions?: Apollo.QueryHookOptions<VendorHerdAnimalsQuery, VendorHerdAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorHerdAnimalsQuery, VendorHerdAnimalsQueryVariables>(VendorHerdAnimalsDocument, options);
      }
export function useVendorHerdAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorHerdAnimalsQuery, VendorHerdAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorHerdAnimalsQuery, VendorHerdAnimalsQueryVariables>(VendorHerdAnimalsDocument, options);
        }
export type VendorHerdAnimalsQueryHookResult = ReturnType<typeof useVendorHerdAnimalsQuery>;
export type VendorHerdAnimalsLazyQueryHookResult = ReturnType<typeof useVendorHerdAnimalsLazyQuery>;
export type VendorHerdAnimalsQueryResult = Apollo.QueryResult<VendorHerdAnimalsQuery, VendorHerdAnimalsQueryVariables>;
export const VendorInHouseProducerOneDocument = gql`
    query VendorInHouseProducerOne {
  vendorInHouseProducerOne {
    id
    slug
    company
    picture_url
    first_name
    last_name
    email
    city
    state
    stripeAccountId
    canList
    missingRequirements
  }
}
    `;

/**
 * __useVendorInHouseProducerOneQuery__
 *
 * To run a query within a React component, call `useVendorInHouseProducerOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorInHouseProducerOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorInHouseProducerOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorInHouseProducerOneQuery(baseOptions?: Apollo.QueryHookOptions<VendorInHouseProducerOneQuery, VendorInHouseProducerOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorInHouseProducerOneQuery, VendorInHouseProducerOneQueryVariables>(VendorInHouseProducerOneDocument, options);
      }
export function useVendorInHouseProducerOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorInHouseProducerOneQuery, VendorInHouseProducerOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorInHouseProducerOneQuery, VendorInHouseProducerOneQueryVariables>(VendorInHouseProducerOneDocument, options);
        }
export type VendorInHouseProducerOneQueryHookResult = ReturnType<typeof useVendorInHouseProducerOneQuery>;
export type VendorInHouseProducerOneLazyQueryHookResult = ReturnType<typeof useVendorInHouseProducerOneLazyQuery>;
export type VendorInHouseProducerOneQueryResult = Apollo.QueryResult<VendorInHouseProducerOneQuery, VendorInHouseProducerOneQueryVariables>;
export const VendorInHouseProducerSettingsOneDocument = gql`
    query VendorInHouseProducerSettingsOne {
  vendorInHouseProducerSettingsOne {
    producer
    splitDeposits {
      species
      whole
      half
      quarter
    }
    listingPresets {
      species
      pricingMode
      listingRatePerLb
      listingTotalPrice
      sizeTier
      allowedSectionSizes
      descriptorChips
      description
    }
  }
}
    `;

/**
 * __useVendorInHouseProducerSettingsOneQuery__
 *
 * To run a query within a React component, call `useVendorInHouseProducerSettingsOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorInHouseProducerSettingsOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorInHouseProducerSettingsOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorInHouseProducerSettingsOneQuery(baseOptions?: Apollo.QueryHookOptions<VendorInHouseProducerSettingsOneQuery, VendorInHouseProducerSettingsOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorInHouseProducerSettingsOneQuery, VendorInHouseProducerSettingsOneQueryVariables>(VendorInHouseProducerSettingsOneDocument, options);
      }
export function useVendorInHouseProducerSettingsOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorInHouseProducerSettingsOneQuery, VendorInHouseProducerSettingsOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorInHouseProducerSettingsOneQuery, VendorInHouseProducerSettingsOneQueryVariables>(VendorInHouseProducerSettingsOneDocument, options);
        }
export type VendorInHouseProducerSettingsOneQueryHookResult = ReturnType<typeof useVendorInHouseProducerSettingsOneQuery>;
export type VendorInHouseProducerSettingsOneLazyQueryHookResult = ReturnType<typeof useVendorInHouseProducerSettingsOneLazyQuery>;
export type VendorInHouseProducerSettingsOneQueryResult = Apollo.QueryResult<VendorInHouseProducerSettingsOneQuery, VendorInHouseProducerSettingsOneQueryVariables>;
export const VendorLinkableProducersDocument = gql`
    query VendorLinkableProducers {
  vendorLinkableProducers {
    _id
    company
    first_name
    last_name
    email
    picture_url
    isStaffAccount
  }
}
    `;

/**
 * __useVendorLinkableProducersQuery__
 *
 * To run a query within a React component, call `useVendorLinkableProducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorLinkableProducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorLinkableProducersQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorLinkableProducersQuery(baseOptions?: Apollo.QueryHookOptions<VendorLinkableProducersQuery, VendorLinkableProducersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorLinkableProducersQuery, VendorLinkableProducersQueryVariables>(VendorLinkableProducersDocument, options);
      }
export function useVendorLinkableProducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorLinkableProducersQuery, VendorLinkableProducersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorLinkableProducersQuery, VendorLinkableProducersQueryVariables>(VendorLinkableProducersDocument, options);
        }
export type VendorLinkableProducersQueryHookResult = ReturnType<typeof useVendorLinkableProducersQuery>;
export type VendorLinkableProducersLazyQueryHookResult = ReturnType<typeof useVendorLinkableProducersLazyQuery>;
export type VendorLinkableProducersQueryResult = Apollo.QueryResult<VendorLinkableProducersQuery, VendorLinkableProducersQueryVariables>;
export const VendorListDocument = gql`
    query VendorList($startDate: String!, $endDate: String!) {
  vendorList(startDate: $startDate, endDate: $endDate) {
    _id
    shop_name
    tenant {
      name
    }
  }
}
    `;

/**
 * __useVendorListQuery__
 *
 * To run a query within a React component, call `useVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorListQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useVendorListQuery(baseOptions: Apollo.QueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
      }
export function useVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
        }
export type VendorListQueryHookResult = ReturnType<typeof useVendorListQuery>;
export type VendorListLazyQueryHookResult = ReturnType<typeof useVendorListLazyQuery>;
export type VendorListQueryResult = Apollo.QueryResult<VendorListQuery, VendorListQueryVariables>;
export const VendorPickerListDocument = gql`
    query VendorPickerList {
  adminVendorList {
    _id
    shop_name
    tenant {
      name
    }
  }
}
    `;

/**
 * __useVendorPickerListQuery__
 *
 * To run a query within a React component, call `useVendorPickerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPickerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPickerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorPickerListQuery(baseOptions?: Apollo.QueryHookOptions<VendorPickerListQuery, VendorPickerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorPickerListQuery, VendorPickerListQueryVariables>(VendorPickerListDocument, options);
      }
export function useVendorPickerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorPickerListQuery, VendorPickerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorPickerListQuery, VendorPickerListQueryVariables>(VendorPickerListDocument, options);
        }
export type VendorPickerListQueryHookResult = ReturnType<typeof useVendorPickerListQuery>;
export type VendorPickerListLazyQueryHookResult = ReturnType<typeof useVendorPickerListLazyQuery>;
export type VendorPickerListQueryResult = Apollo.QueryResult<VendorPickerListQuery, VendorPickerListQueryVariables>;
export const VendorSpeciesDocument = gql`
    query VendorSpecies($vendorId: MongoID!) {
  adminVendorSpecies(vendorId: $vendorId)
}
    `;

/**
 * __useVendorSpeciesQuery__
 *
 * To run a query within a React component, call `useVendorSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorSpeciesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorSpeciesQuery(baseOptions: Apollo.QueryHookOptions<VendorSpeciesQuery, VendorSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorSpeciesQuery, VendorSpeciesQueryVariables>(VendorSpeciesDocument, options);
      }
export function useVendorSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorSpeciesQuery, VendorSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorSpeciesQuery, VendorSpeciesQueryVariables>(VendorSpeciesDocument, options);
        }
export type VendorSpeciesQueryHookResult = ReturnType<typeof useVendorSpeciesQuery>;
export type VendorSpeciesLazyQueryHookResult = ReturnType<typeof useVendorSpeciesLazyQuery>;
export type VendorSpeciesQueryResult = Apollo.QueryResult<VendorSpeciesQuery, VendorSpeciesQueryVariables>;
export const VendorTeamMembersDocument = gql`
    query VendorTeamMembers {
  vendorTeamMembers {
    _id
    first_name
    last_name
    email
    role
    enabled
    last_login
  }
}
    `;

/**
 * __useVendorTeamMembersQuery__
 *
 * To run a query within a React component, call `useVendorTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<VendorTeamMembersQuery, VendorTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorTeamMembersQuery, VendorTeamMembersQueryVariables>(VendorTeamMembersDocument, options);
      }
export function useVendorTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorTeamMembersQuery, VendorTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorTeamMembersQuery, VendorTeamMembersQueryVariables>(VendorTeamMembersDocument, options);
        }
export type VendorTeamMembersQueryHookResult = ReturnType<typeof useVendorTeamMembersQuery>;
export type VendorTeamMembersLazyQueryHookResult = ReturnType<typeof useVendorTeamMembersLazyQuery>;
export type VendorTeamMembersQueryResult = Apollo.QueryResult<VendorTeamMembersQuery, VendorTeamMembersQueryVariables>;
export const ProcessingJobByIdDocument = gql`
    query ProcessingJobById($jobId: MongoID!, $includeProcessorSettings: Boolean!) {
  findProcessorSchedulingById(_id: $jobId) {
    ...ProcessorSchedulingFragment
    processorSettings @include(if: $includeProcessorSettings) {
      _id
      enabledAnimalSplits
      animalSettings {
        species
        inspectionLevels
        splitTypes
      }
      killAndChillSettings {
        species
        isEnabled
        pricePerHead
      }
    }
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;

/**
 * __useProcessingJobByIdQuery__
 *
 * To run a query within a React component, call `useProcessingJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingJobByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      includeProcessorSettings: // value for 'includeProcessorSettings'
 *   },
 * });
 */
export function useProcessingJobByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>(ProcessingJobByIdDocument, options);
      }
export function useProcessingJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>(ProcessingJobByIdDocument, options);
        }
export type ProcessingJobByIdQueryHookResult = ReturnType<typeof useProcessingJobByIdQuery>;
export type ProcessingJobByIdLazyQueryHookResult = ReturnType<typeof useProcessingJobByIdLazyQuery>;
export type ProcessingJobByIdQueryResult = Apollo.QueryResult<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>;
export const WaitlistByVendorIdDocument = gql`
    query WaitlistByVendorId($vendorId: MongoID!) {
  waitlistByVendorId(vendorId: $vendorId) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;

/**
 * __useWaitlistByVendorIdQuery__
 *
 * To run a query within a React component, call `useWaitlistByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useWaitlistByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>(WaitlistByVendorIdDocument, options);
      }
export function useWaitlistByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>(WaitlistByVendorIdDocument, options);
        }
export type WaitlistByVendorIdQueryHookResult = ReturnType<typeof useWaitlistByVendorIdQuery>;
export type WaitlistByVendorIdLazyQueryHookResult = ReturnType<typeof useWaitlistByVendorIdLazyQuery>;
export type WaitlistByVendorIdQueryResult = Apollo.QueryResult<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>;
export const WaitlistByVendorPaginationDocument = gql`
    query WaitlistByVendorPagination($vendorId: MongoID!, $search: String, $animal: [String!], $inspectionLevel: [String!], $status: [String!], $sort: String, $page: Int!, $perPage: Int!) {
  waitlistByVendorPagination(
    vendorId: $vendorId
    search: $search
    animal: $animal
    inspectionLevel: $inspectionLevel
    status: $status
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    items {
      ...WaitlistFragment
    }
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${WaitlistFragmentFragmentDoc}`;

/**
 * __useWaitlistByVendorPaginationQuery__
 *
 * To run a query within a React component, call `useWaitlistByVendorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistByVendorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistByVendorPaginationQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      search: // value for 'search'
 *      animal: // value for 'animal'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useWaitlistByVendorPaginationQuery(baseOptions: Apollo.QueryHookOptions<WaitlistByVendorPaginationQuery, WaitlistByVendorPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitlistByVendorPaginationQuery, WaitlistByVendorPaginationQueryVariables>(WaitlistByVendorPaginationDocument, options);
      }
export function useWaitlistByVendorPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitlistByVendorPaginationQuery, WaitlistByVendorPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitlistByVendorPaginationQuery, WaitlistByVendorPaginationQueryVariables>(WaitlistByVendorPaginationDocument, options);
        }
export type WaitlistByVendorPaginationQueryHookResult = ReturnType<typeof useWaitlistByVendorPaginationQuery>;
export type WaitlistByVendorPaginationLazyQueryHookResult = ReturnType<typeof useWaitlistByVendorPaginationLazyQuery>;
export type WaitlistByVendorPaginationQueryResult = Apollo.QueryResult<WaitlistByVendorPaginationQuery, WaitlistByVendorPaginationQueryVariables>;
export const WaitlistPaginationDocument = gql`
    query WaitlistPagination($sort: SortFindManyWaitlistInput, $filter: FilterFindManyWaitlistInput, $page: Int!, $perPage: Int!) {
  waitlistPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...WaitlistFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${WaitlistFragmentFragmentDoc}`;

/**
 * __useWaitlistPaginationQuery__
 *
 * To run a query within a React component, call `useWaitlistPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useWaitlistPaginationQuery(baseOptions: Apollo.QueryHookOptions<WaitlistPaginationQuery, WaitlistPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitlistPaginationQuery, WaitlistPaginationQueryVariables>(WaitlistPaginationDocument, options);
      }
export function useWaitlistPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitlistPaginationQuery, WaitlistPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitlistPaginationQuery, WaitlistPaginationQueryVariables>(WaitlistPaginationDocument, options);
        }
export type WaitlistPaginationQueryHookResult = ReturnType<typeof useWaitlistPaginationQuery>;
export type WaitlistPaginationLazyQueryHookResult = ReturnType<typeof useWaitlistPaginationLazyQuery>;
export type WaitlistPaginationQueryResult = Apollo.QueryResult<WaitlistPaginationQuery, WaitlistPaginationQueryVariables>;